///////////////////////second correct code end here //////////////////////////////

// // ============================================================
// // src/components/admin/PatientsTab.js
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import api from "../../utils/api";

// const SERVICES_LIST = [
//   "General Checkup & Cleaning",
//   "Cosmetic Dentistry / Smile Makeover",
//   "Dental Implants",
//   "Orthodontics / Invisalign",
//   "Root Canal Therapy",
//   "Pediatric Dentistry",
//   "Oral Surgery",
//   "Periodontal Treatment",
//   "Teeth Whitening",
//   "Emergency Dental Care",
//   "Follow-Up Visit",
//   "Other",
// ];

// const MONTHS = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];
// const MONTHS_SHORT = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// function fmtDate(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtDateShort(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS_SHORT[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtTime(t) {
//   if (!t) return "";
//   const parts = t.split(":");
//   const hh = parseInt(parts[0]),
//     mm = parts[1];
//   return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
// }

// function totalRevenue(visits = []) {
//   return visits.reduce((sum, v) => {
//     const n = parseFloat((v.amount || "0").toString().replace(/[^0-9.]/g, ""));
//     return sum + (isNaN(n) ? 0 : n);
//   }, 0);
// }

// export default function PatientsTab({ showNotify, doctor }) {
//   const [patients, setPatients] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showNewForm, setShowNewForm] = useState(false);
//   const [newPat, setNewPat] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     age: "",
//     gender: "",
//     blood: "",
//   });
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [rxModal, setRxModal] = useState(null);
//   const [editMode, setEditMode] = useState(false);
//   const [editPat, setEditPat] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     age: "",
//     gender: "",
//     blood: "",
//   });
//   // Custom medicines — fetched from backend, shared across all doctors/devices
//   const [customMeds, setCustomMeds] = useState([]);

//   const today = new Date().toISOString().split("T")[0];
//   const nowTime = new Date().toTimeString().slice(0, 5);
//   const [visitForm, setVisitForm] = useState({
//     date: today,
//     time: nowTime,
//     service: "",
//     amount: "",
//     nextVisitDate: "",
//     notes: "",
//   });

//   const loadPatients = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await api.get("/patients");
//       setPatients(data);
//       setFiltered(data);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     loadPatients();
//   }, [loadPatients]);

//   // Fetch custom medicines from backend on mount — shared across all doctors/devices
//   useEffect(() => {
//     api
//       .get("/custommeds")
//       .then((data) => {
//         if (Array.isArray(data)) setCustomMeds(data);
//       })
//       .catch(() => {});
//   }, []);

//   const filterPatients = (q) => {
//     const term = q.toLowerCase();
//     setFiltered(
//       patients.filter(
//         (p) =>
//           (p.name || "").toLowerCase().includes(term) ||
//           (p.mobile || "").includes(term) ||
//           (p.email || "").toLowerCase().includes(term),
//       ),
//     );
//   };

//   const createPatient = async () => {
//     if (!newPat.name.trim()) {
//       showNotify("Error", "Patient name is required.", true);
//       return;
//     }
//     if (!newPat.mobile.trim()) {
//       showNotify("Error", "Mobile number is required.", true);
//       return;
//     }
//     try {
//       await api.post("/patients", newPat);
//       setNewPat({
//         name: "",
//         mobile: "",
//         email: "",
//         age: "",
//         gender: "",
//         blood: "",
//       });
//       setShowNewForm(false);
//       showNotify(
//         "Patient Profile Created! ✓",
//         "New profile for " + newPat.name + " saved.",
//       );
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const openPatient = async (p) => {
//     try {
//       const full = await api.get("/patients/" + p._id);
//       setSelectedPatient(full);
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//       });
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deletePatient = async () => {
//     if (
//       !window.confirm(
//         "Delete this patient profile and all their records? This cannot be undone.",
//       )
//     )
//       return;
//     try {
//       await api.delete("/patients/" + selectedPatient._id);
//       showNotify("Profile Deleted", "Patient profile removed.");
//       setSelectedPatient(null);
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const saveEditPatient = async () => {
//     if (!editPat.name.trim()) {
//       showNotify("Error", "Patient name is required.", true);
//       return;
//     }
//     if (!editPat.mobile.trim()) {
//       showNotify("Error", "Mobile number is required.", true);
//       return;
//     }
//     try {
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/update",
//         editPat,
//       );
//       setSelectedPatient(updated);
//       setEditMode(false);
//       showNotify("Profile Updated! ✓", "Patient profile saved successfully.");
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const saveVisit = async () => {
//     if (!visitForm.date) {
//       showNotify("Missing Fields", "Please select a visit date.", true);
//       return;
//     }
//     if (!visitForm.service) {
//       showNotify("Missing Fields", "Please select a service.", true);
//       return;
//     }
//     try {
//       const payload = {
//         visitDate: visitForm.date,
//         visitTime: visitForm.time,
//         service: visitForm.service,
//         amount: visitForm.amount,
//         nextVisitDate: visitForm.nextVisitDate,
//         notes: visitForm.notes,
//         doctor: doctor?.name || "",
//         prescription: { medicineRows: [] },
//       };
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/visits",
//         payload,
//       );
//       setSelectedPatient(updated);

//       // ── Auto-create appointment for follow-up date ──────────
//       // If nextVisitDate is set → create an upcoming appointment entry
//       // so it appears in Appointments tab → Upcoming Appointments
//       if (visitForm.nextVisitDate && selectedPatient.mobile) {
//         try {
//           await api.post("/appointments", {
//             name: selectedPatient.name,
//             phone: selectedPatient.mobile,
//             service: visitForm.service,
//             date: visitForm.nextVisitDate,
//             time: "",
//             message: "Follow-up visit from Patient Profile",
//             status: "pending",
//           });
//         } catch (_) {
//           // Silently ignore if appointment creation fails
//         }
//       }

//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//       });

//       // Follow-up WhatsApp if notes contain "follow-up" and nextVisitDate is set
//       const isFollowUp = /follow[\s\-]?up/i.test(visitForm.notes);
//       if (isFollowUp && visitForm.nextVisitDate && selectedPatient.mobile) {
//         let rawMobile = (selectedPatient.mobile || "").replace(
//           /[\s\-\(\)\+]/g,
//           "",
//         );
//         if (!rawMobile.startsWith("91") && rawMobile.length === 10)
//           rawMobile = "91" + rawMobile;
//         const waMsg = `*PearlSmile Dental Hospital* — Follow-Up Reminder\n\nDear ${selectedPatient.name},\nThis is a reminder for your follow-up appointment.\n\n*Service:* ${visitForm.service}\n*Next Visit:* ${fmtDate(visitForm.nextVisitDate)}\n\nPlease call us to confirm your appointment.\n📞 +91 87936 08083`;
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" +
//                 rawMobile +
//                 "?text=" +
//                 encodeURIComponent(waMsg),
//               "_blank",
//             ),
//           500,
//         );
//         showNotify(
//           "Visit Saved + Follow-Up Appointment Created!",
//           "Reminder sent to " +
//             selectedPatient.name +
//             " for " +
//             fmtDate(visitForm.nextVisitDate) +
//             ". Appointment added to Upcoming.",
//         );
//       } else if (visitForm.nextVisitDate) {
//         showNotify(
//           "Visit Saved + Appointment Created! ✓",
//           "Follow-up appointment for " +
//             fmtDate(visitForm.nextVisitDate) +
//             " added to Upcoming Appointments.",
//         );
//       } else {
//         showNotify(
//           "Visit Record Saved! ✓",
//           "Patient visit has been recorded successfully.",
//         );
//       }
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deleteVisit = async (visitId) => {
//     if (!window.confirm("Delete this visit record?")) return;
//     try {
//       const result = await api.delete(
//         "/patients/" + selectedPatient._id + "/visits/" + visitId,
//       );
//       setSelectedPatient(result.patient);
//       showNotify("Visit Deleted", "Visit record removed.");
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const sendPrescription = (visit) => {
//     // Use the doctor who treated the patient (stored in visit.doctor)
//     // not the currently logged-in doctor
//     const treatingDoctor = visit.doctor ? { name: visit.doctor } : doctor;
//     setRxModal({ visit, patient: selectedPatient, doctor: treatingDoctor });
//   };

//   // ── LIST VIEW ─────────────────────────────────────────────────
//   if (!selectedPatient) {
//     return (
//       <div>
//         <div className="admin-section-title">Patient Profiles</div>
//         <div className="admin-section-desc">
//           Create and manage individual patient profiles. Click a profile to view
//           visit history and add new records.
//         </div>

//         <div className="patients-list-view">
//           <input
//             type="text"
//             className="patient-search-bar"
//             placeholder="🔍 Search patients by name or phone..."
//             onChange={(e) => filterPatients(e.target.value)}
//           />

//           {showNewForm && (
//             <div className="new-patient-form">
//               <h4>➕ Create New Patient Profile</h4>
//               <div className="new-patient-grid">
//                 {[
//                   ["name", "text", "Full Name *", "Patient full name"],
//                   ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
//                   ["email", "email", "Email Address", "patient@email.com"],
//                   ["age", "number", "Age", "Age"],
//                 ].map(([k, t, label, ph]) => (
//                   <div key={k}>
//                     <div className="admin-row-label">{label}</div>
//                     <input
//                       type={t}
//                       placeholder={ph}
//                       value={newPat[k]}
//                       onChange={(e) =>
//                         setNewPat((p) => ({ ...p, [k]: e.target.value }))
//                       }
//                     />
//                   </div>
//                 ))}
//                 <div>
//                   <div className="admin-row-label">Gender</div>
//                   <select
//                     value={newPat.gender}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, gender: e.target.value }))
//                     }
//                   >
//                     <option value="">Select Gender</option>
//                     <option>Male</option>
//                     <option>Female</option>
//                     <option>Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <div className="admin-row-label">Blood Group</div>
//                   <input
//                     type="text"
//                     placeholder="e.g. B+"
//                     value={newPat.blood}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, blood: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//               <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                 <button className="add-visit-save-btn" onClick={createPatient}>
//                   💾 Save Patient Profile
//                 </button>
//                 <button
//                   className="btn-back-patients"
//                   onClick={() => setShowNewForm(false)}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           )}

//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: 14,
//               flexWrap: "wrap",
//               gap: 10,
//             }}
//           >
//             <div style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {loading
//                 ? "Loading patients..."
//                 : `${filtered.length} patient profile${filtered.length !== 1 ? "s" : ""}`}
//             </div>
//             <button
//               className="admin-add-btn"
//               onClick={() => setShowNewForm((s) => !s)}
//             >
//               {showNewForm ? "Cancel" : "+ New Patient Profile"}
//             </button>
//           </div>

//           <div className="patient-profiles-grid">
//             {loading ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "20px 0",
//                   gridColumn: "1/-1",
//                 }}
//               >
//                 Loading...
//               </div>
//             ) : filtered.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "24px 0",
//                   gridColumn: "1/-1",
//                   textAlign: "center",
//                 }}
//               >
//                 No patients yet. Click "+ New Patient Profile" to add your first
//                 patient.
//               </div>
//             ) : (
//               filtered.map((p) => (
//                 <div
//                   key={p._id}
//                   className="patient-profile-card"
//                   onClick={() => openPatient(p)}
//                 >
//                   <div className="patient-avatar-icon">🧑‍⚕️</div>
//                   <div className="patient-card-name">{p.name}</div>
//                   <div className="patient-card-id">📞 {p.mobile || "—"}</div>
//                   <div className="patient-card-visits">
//                     📋 {p.visitCount || 0} visit{p.visitCount !== 1 ? "s" : ""}
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ── DETAIL VIEW ───────────────────────────────────────────────
//   const p = selectedPatient;
//   const visits = p.visits || [];
//   const total = totalRevenue(visits);

//   return (
//     <div>
//       <div className="patient-detail-view open">
//         <div className="patient-detail-header">
//           <button
//             className="btn-back-patients"
//             onClick={() => {
//               setSelectedPatient(null);
//               setEditMode(false);
//             }}
//           >
//             ← Back to Patients
//           </button>
//           <div
//             className="patient-avatar-icon"
//             style={{ width: 56, height: 56, fontSize: 26 }}
//           >
//             🧑‍⚕️
//           </div>
//           <div style={{ flex: 1 }}>
//             <h3>{p.name}</h3>
//             <p style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {p.email}
//               {p.email && p.mobile ? " · " : ""}
//               {p.mobile}
//             </p>
//             <div className="patient-info-row">
//               {[
//                 p.age ? "Age: " + p.age : null,
//                 p.gender || null,
//                 p.blood ? "Blood: " + p.blood : null,
//               ]
//                 .filter(Boolean)
//                 .map((t, i) => (
//                   <span key={i} className="patient-info-pill">
//                     {t}
//                   </span>
//                 ))}
//             </div>
//           </div>
//           <div style={{ textAlign: "right", flexShrink: 0 }}>
//             <div
//               style={{
//                 fontSize: 11,
//                 color: "var(--gray-400)",
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//                 marginBottom: 4,
//               }}
//             >
//               Total Revenue
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 26,
//                 fontWeight: 600,
//                 color: "var(--teal)",
//                 lineHeight: 1,
//               }}
//             >
//               Rs. {total.toLocaleString("en-IN")}
//             </div>
//             <div
//               style={{ fontSize: 11, color: "var(--gray-400)", marginTop: 2 }}
//             >
//               {visits.length} visit{visits.length !== 1 ? "s" : ""}
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 8,
//               alignSelf: "flex-start",
//               marginTop: 4,
//             }}
//           >
//             <button className="admin-del-btn" onClick={deletePatient}>
//               🗑️ Delete Profile
//             </button>
//             <button
//               onClick={() => {
//                 setEditMode((e) => !e);
//                 setEditPat({
//                   name: p.name || "",
//                   mobile: p.mobile || "",
//                   email: p.email || "",
//                   age: p.age || "",
//                   gender: p.gender || "",
//                   blood: p.blood || "",
//                 });
//               }}
//               style={{
//                 background: "linear-gradient(135deg,#0d7377,#0a9a9f)",
//                 color: "#fff",
//                 border: "none",
//                 borderRadius: 7,
//                 padding: "7px 14px",
//                 fontSize: 12,
//                 fontWeight: 600,
//                 cursor: "pointer",
//                 fontFamily: "'DM Sans',sans-serif",
//                 whiteSpace: "nowrap",
//               }}
//             >
//               ✏️ Edit Profile
//             </button>
//           </div>
//         </div>

//         {/* Edit Patient Profile Form */}
//         {editMode && (
//           <div className="new-patient-form" style={{ marginBottom: 16 }}>
//             <h4>✏️ Edit Patient Profile</h4>
//             <div className="new-patient-grid">
//               {[
//                 ["name", "text", "Full Name *", "Patient full name"],
//                 ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
//                 ["email", "email", "Email Address", "patient@email.com"],
//                 ["age", "number", "Age", "Age"],
//               ].map(([k, t, label, ph]) => (
//                 <div key={k}>
//                   <div className="admin-row-label">{label}</div>
//                   <input
//                     type={t}
//                     placeholder={ph}
//                     value={editPat[k]}
//                     onChange={(e) =>
//                       setEditPat((ep) => ({ ...ep, [k]: e.target.value }))
//                     }
//                   />
//                 </div>
//               ))}
//               <div>
//                 <div className="admin-row-label">Gender</div>
//                 <select
//                   value={editPat.gender}
//                   onChange={(e) =>
//                     setEditPat((ep) => ({ ...ep, gender: e.target.value }))
//                   }
//                 >
//                   <option value="">Select Gender</option>
//                   <option>Male</option>
//                   <option>Female</option>
//                   <option>Other</option>
//                 </select>
//               </div>
//               <div>
//                 <div className="admin-row-label">Blood Group</div>
//                 <input
//                   type="text"
//                   placeholder="e.g. B+"
//                   value={editPat.blood}
//                   onChange={(e) =>
//                     setEditPat((ep) => ({ ...ep, blood: e.target.value }))
//                   }
//                 />
//               </div>
//             </div>
//             <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//               <button className="add-visit-save-btn" onClick={saveEditPatient}>
//                 💾 Save Changes
//               </button>
//               <button
//                 className="btn-back-patients"
//                 onClick={() => setEditMode(false)}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Add Visit Form — original simple layout */}
//         <div className="add-visit-form">
//           <h4>📋 Add New Visit Record</h4>
//           <div className="add-visit-grid">
//             <div>
//               <div className="admin-row-label">Visit Date *</div>
//               <input
//                 type="date"
//                 value={visitForm.date}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, date: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Visit Time</div>
//               <input
//                 type="time"
//                 value={visitForm.time}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, time: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Service Taken *</div>
//               <select
//                 value={visitForm.service}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, service: e.target.value }))
//                 }
//               >
//                 <option value="">Select Service</option>
//                 {SERVICES_LIST.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <div className="admin-row-label">Amount Charged (Rs.)</div>
//               <input
//                 type="text"
//                 placeholder="e.g. 2500"
//                 value={visitForm.amount}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, amount: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div
//                 className="admin-row-label"
//                 style={{ display: "flex", alignItems: "center", gap: 6 }}
//               >
//                 Next Date to Visit
//                 <span
//                   style={{
//                     fontSize: 10,
//                     color: "var(--teal)",
//                     fontWeight: 400,
//                     background: "rgba(13,115,119,0.08)",
//                     padding: "2px 8px",
//                     borderRadius: 100,
//                     border: "1px solid rgba(13,115,119,0.2)",
//                   }}
//                 >
//                   For follow-up
//                 </span>
//               </div>
//               <input
//                 type="date"
//                 value={visitForm.nextVisitDate}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, nextVisitDate: e.target.value }))
//                 }
//                 style={{ marginTop: 6 }}
//               />
//             </div>
//           </div>
//           <div className="admin-row-label" style={{ marginBottom: 6 }}>
//             Doctor Notes / Diagnosis
//           </div>
//           <MedAutocomplete
//             value={visitForm.notes}
//             onChange={(v) => setVisitForm((f) => ({ ...f, notes: v }))}
//             customMeds={customMeds}
//             apiPost={api.post}
//             onCustomSaved={(saved) => {
//               if (saved && saved._id) {
//                 // Add to local state immediately so suggestion appears right away
//                 setCustomMeds((prev) => {
//                   const exists = prev.some(
//                     (m) =>
//                       m._id === saved._id ||
//                       m.name.toLowerCase() === saved.name.toLowerCase(),
//                   );
//                   if (exists) return prev;
//                   return [saved, ...prev];
//                 });
//               } else {
//                 // Fallback refetch if saved object not returned
//                 api
//                   .get("/custommeds")
//                   .then((data) => {
//                     if (Array.isArray(data)) setCustomMeds(data);
//                   })
//                   .catch(() => {});
//               }
//             }}
//           />
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               flexWrap: "wrap",
//               gap: 10,
//               marginTop: 4,
//             }}
//           >
//             <button className="add-visit-save-btn" onClick={saveVisit}>
//               💾 Save Visit Record
//             </button>
//           </div>
//         </div>

//         {/* Visit History */}
//         <div style={{ marginBottom: 12 }}>
//           <div className="admin-section-title" style={{ marginBottom: 8 }}>
//             Visit History
//           </div>
//           <div className="visit-records-list">
//             {visits.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 13,
//                   padding: "10px 0",
//                 }}
//               >
//                 No visits recorded yet. Add the first visit above.
//               </div>
//             ) : (
//               visits.map((v, i) => {
//                 const dtStr =
//                   (v.visitDate || "") +
//                   (v.visitTime ? " at " + v.visitTime : "");
//                 const isFollowUp = /follow[\s\-]?up/i.test(v.notes || "");
//                 return (
//                   <div key={v._id || i} className="visit-record-card">
//                     <button
//                       className="visit-del-btn"
//                       onClick={() => deleteVisit(v._id)}
//                       title="Delete"
//                     >
//                       ✕
//                     </button>
//                     <div className="visit-record-meta">
//                       <span className="visit-record-service">
//                         {v.service || "Visit"}
//                       </span>
//                       <span className="visit-record-date">📅 {dtStr}</span>
//                       {v.amount && (
//                         <span
//                           className="patient-info-pill"
//                           style={{ fontSize: 11 }}
//                         >
//                           Rs. {v.amount}
//                         </span>
//                       )}
//                       {v.doctor && (
//                         <span
//                           style={{
//                             fontSize: 11,
//                             color: "var(--teal)",
//                             fontWeight: 600,
//                             background: "rgba(13,115,119,0.08)",
//                             padding: "2px 8px",
//                             borderRadius: 100,
//                             border: "1px solid rgba(13,115,119,0.2)",
//                           }}
//                         >
//                           👨‍⚕️ {v.doctor}
//                         </span>
//                       )}
//                     </div>
//                     <div className="visit-record-notes">{v.notes || "—"}</div>
//                     {v.nextVisitDate && (
//                       <div
//                         style={{
//                           marginTop: 8,
//                           display: "inline-flex",
//                           alignItems: "center",
//                           gap: 6,
//                           background: isFollowUp
//                             ? "rgba(201,168,76,0.12)"
//                             : "rgba(13,115,119,0.08)",
//                           border:
//                             "1px solid " +
//                             (isFollowUp
//                               ? "rgba(201,168,76,0.35)"
//                               : "rgba(13,115,119,0.2)"),
//                           borderRadius: 100,
//                           padding: "3px 12px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           color: isFollowUp ? "#8b6914" : "var(--teal)",
//                         }}
//                       >
//                         {isFollowUp ? "Follow-Up: " : "Next Visit: "}
//                         {fmtDateShort(v.nextVisitDate)}
//                         {isFollowUp ? " — WhatsApp sent" : ""}
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 8,
//                         marginTop: 10,
//                       }}
//                     >
//                       <button
//                         onClick={() => sendPrescription(v)}
//                         style={{
//                           background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Send Prescription
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </div>

//       {rxModal && (
//         <PrescriptionModal
//           visit={rxModal.visit}
//           patient={rxModal.patient}
//           doctor={rxModal.doctor}
//           onClose={() => setRxModal(null)}
//           showNotify={showNotify}
//         />
//       )}
//     </div>
//   );
// }

// // ── Medicine Database — 1500+ entries (India: dental + clinical + surgical) ──
// const MEDICINE_DB = [
//   // ── ANTIBIOTICS ──────────────────────────────────────────────
//   { name: "Amoxicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 875mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin 125mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin 250mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 375mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 625mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 1000mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 228.5mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Azithromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Clindamycin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 600mg Injection", cat: "Antibiotic Inj" },
//   { name: "Metronidazole 200mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 400mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Infusion", cat: "Antibiotic Inj" },
//   { name: "Ciprofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 750mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 200mg/100ml Infusion", cat: "Antibiotic Inj" },
//   { name: "Doxycycline 100mg Capsule", cat: "Antibiotic" },
//   { name: "Doxycycline 200mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Tinidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ornidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Secnidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Co-Amoxiclav 375mg Tablet", cat: "Antibiotic" },
//   { name: "Co-Amoxiclav 625mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 750mg Tablet", cat: "Antibiotic" },
//   { name: "Ofloxacin 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ofloxacin 400mg Tablet", cat: "Antibiotic" },
//   { name: "Cephalexin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Cephalexin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Cefixime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 400mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 50mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Cefuroxime 250mg Tablet", cat: "Antibiotic" },
//   { name: "Cefuroxime 500mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ceftriaxone 250mg Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 2g Injection", cat: "Antibiotic Inj" },
//   { name: "Amikacin 250mg Injection", cat: "Antibiotic Inj" },
//   { name: "Amikacin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Gentamicin 40mg Injection", cat: "Antibiotic Inj" },
//   { name: "Gentamicin 80mg Injection", cat: "Antibiotic Inj" },
//   { name: "Vancomycin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Vancomycin 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Meropenem 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Meropenem 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Piperacillin + Tazobactam 4.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Imipenem + Cilastatin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Linezolid 600mg Tablet", cat: "Antibiotic" },
//   { name: "Linezolid 600mg Infusion", cat: "Antibiotic Inj" },
//   { name: "Colistin 1 MU Injection", cat: "Antibiotic Inj" },
//   { name: "Tetracycline 250mg Capsule", cat: "Antibiotic" },
//   { name: "Tetracycline 500mg Capsule", cat: "Antibiotic" },
//   { name: "Chloramphenicol 250mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin + Sulbactam 1.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Nitrofurantoin 50mg Capsule", cat: "Antibiotic" },
//   { name: "Nitrofurantoin 100mg Capsule", cat: "Antibiotic" },
//   { name: "Norfloxacin 400mg Tablet", cat: "Antibiotic" },
//   { name: "Trimethoprim + Sulfamethoxazole 480mg Tablet", cat: "Antibiotic" },
//   { name: "Trimethoprim + Sulfamethoxazole 960mg Tablet", cat: "Antibiotic" },
//   { name: "Cefoperazone + Sulbactam 1.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Cefoperazone + Sulbactam 3g Injection", cat: "Antibiotic Inj" },
//   { name: "Ertapenem 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Tigecycline 50mg Injection", cat: "Antibiotic Inj" },
//   { name: "Fosfomycin 3g Sachet", cat: "Antibiotic" },
//   { name: "Rifampicin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Rifampicin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Isoniazid 100mg Tablet", cat: "Antibiotic" },
//   { name: "Isoniazid 300mg Tablet", cat: "Antibiotic" },
//   { name: "Pyrazinamide 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ethambutol 400mg Tablet", cat: "Antibiotic" },
//   { name: "Streptomycin 1g Injection", cat: "Antibiotic Inj" },
//   // ── PAIN KILLERS / NSAIDS ────────────────────────────────────
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 250mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 150mg/ml Drops", cat: "Painkiller" },
//   { name: "Paracetamol 500mg/100ml Infusion", cat: "Painkiller Inj" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 100mg/5ml Syrup", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Injection", cat: "NSAID Inj" },
//   { name: "Ketorolac 10mg Tablet", cat: "NSAID" },
//   { name: "Ketorolac 30mg Injection", cat: "NSAID Inj" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Piroxicam 10mg Tablet", cat: "NSAID" },
//   { name: "Piroxicam 20mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 120mg Tablet", cat: "NSAID" },
//   { name: "Celecoxib 100mg Capsule", cat: "NSAID" },
//   { name: "Celecoxib 200mg Capsule", cat: "NSAID" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol 100mg SR Tablet", cat: "Opioid Analgesic" },
//   { name: "Tramadol 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Morphine 10mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Morphine 15mg Tablet", cat: "Opioid Analgesic" },
//   { name: "Fentanyl 50mcg/ml Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pentazocine 30mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pethidine 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Buprenorphine 0.3mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Tapentadol 50mg Tablet", cat: "Opioid Analgesic" },
//   { name: "Tapentadol 100mg Tablet", cat: "Opioid Analgesic" },
//   // ── LOCAL ANAESTHETICS — DENTAL ─────────────────────────────
//   { name: "Lignocaine 2% Dental Cartridge (1.8ml)", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine + Adrenaline 2% Dental Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% Heavy Spinal Injection", cat: "Local Anaesthetic" },
//   { name: "Mepivacaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Prilocaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Lignocaine 2% Plain Injection 30ml Vial", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine 2% + Adrenaline Injection Vial",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Lignocaine 10% Topical Spray", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 2% Viscous Gel", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 5% Ointment", cat: "Local Anaesthetic Topical" },
//   { name: "Benzocaine 20% Topical Gel", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lignocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine Jelly 2%", cat: "Local Anaesthetic Topical" },
//   { name: "Ropivacaine 0.2% Injection", cat: "Local Anaesthetic" },
//   { name: "Ropivacaine 0.75% Injection", cat: "Local Anaesthetic" },
//   {
//     name: "Tetracaine (Amethocaine) Eye Drops",
//     cat: "Local Anaesthetic Topical",
//   },
//   // ── GENERAL ANAESTHESIA ─────────────────────────────────────
//   { name: "Propofol 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 500mg Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Thiopentone Sodium 500mg Injection", cat: "General Anaesthesia" },
//   { name: "Midazolam 1mg/ml Injection", cat: "Sedative / Anaesthesia" },
//   { name: "Midazolam 5mg/ml Injection", cat: "Sedative / Anaesthesia" },
//   { name: "Midazolam 7.5mg Tablet", cat: "Sedative" },
//   { name: "Isoflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Sevoflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Desflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Nitrous Oxide Gas", cat: "Inhalation Anaesthetic" },
//   { name: "Oxygen Gas Cylinder", cat: "Medical Gas" },
//   { name: "Succinylcholine 100mg Injection", cat: "Muscle Relaxant" },
//   { name: "Vecuronium 4mg Injection", cat: "Muscle Relaxant" },
//   { name: "Atracurium 25mg Injection", cat: "Muscle Relaxant" },
//   { name: "Rocuronium 50mg Injection", cat: "Muscle Relaxant" },
//   { name: "Neostigmine 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Atropine 0.6mg Injection", cat: "Anticholinergic" },
//   { name: "Glycopyrrolate 0.2mg Injection", cat: "Anticholinergic" },
//   // ── STEROIDS / ANTI-INFLAMMATORY ────────────────────────────
//   { name: "Dexamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Betamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 40mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 16mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 40mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 125mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone 10mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone Acetonide 0.1% Oral Paste", cat: "Steroid Topical" },
//   { name: "Kenacort 0.1% Dental Paste", cat: "Steroid Topical" },
//   { name: "Betamethasone Gel Oral 0.025%", cat: "Steroid Topical" },
//   // ── ANTIFUNGALS ─────────────────────────────────────────────
//   { name: "Fluconazole 50mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 2mg/ml Infusion", cat: "Antifungal Inj" },
//   { name: "Itraconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Voriconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Amphotericin B 50mg Injection", cat: "Antifungal Inj" },
//   { name: "Clotrimazole 1% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin 100000 IU/ml Oral Drops", cat: "Antifungal" },
//   { name: "Nystatin 500000 IU Tablet", cat: "Antifungal" },
//   { name: "Clotrimazole + Betamethasone Cream", cat: "Antifungal Topical" },
//   { name: "Ketoconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Ketoconazole 2% Shampoo", cat: "Antifungal Topical" },
//   { name: "Terbinafine 250mg Tablet", cat: "Antifungal" },
//   // ── ANTIVIRAL ───────────────────────────────────────────────
//   { name: "Acyclovir 200mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 400mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 800mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 5% Cream", cat: "Antiviral Topical" },
//   { name: "Acyclovir 250mg Injection", cat: "Antiviral Inj" },
//   { name: "Valacyclovir 500mg Tablet", cat: "Antiviral" },
//   { name: "Valacyclovir 1000mg Tablet", cat: "Antiviral" },
//   { name: "Famciclovir 250mg Tablet", cat: "Antiviral" },
//   { name: "Oseltamivir 75mg Capsule", cat: "Antiviral" },
//   // ── ANTISEPTICS / MOUTHWASH / ORAL CARE ─────────────────────
//   { name: "Chlorhexidine Gluconate 0.2% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine Gluconate 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 1% Gel (Gum Gel)", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 5% Mouthwash / Gargle", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 10% Solution", cat: "Antiseptic" },
//   { name: "Povidone Iodine 5% Ointment", cat: "Antiseptic Topical" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 1.5% Mouthwash", cat: "Dental Antiseptic" },
//   {
//     name: "Benzydamine Hydrochloride 0.15% Mouthwash",
//     cat: "Dental Analgesic Rinse",
//   },
//   { name: "Hexetidine 0.1% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Sodium Fluoride 0.05% Mouthwash", cat: "Fluoride Rinse" },
//   { name: "Sodium Fluoride Varnish 5%", cat: "Fluoride Varnish" },
//   { name: "Fluoride Gel APF 1.23%", cat: "Fluoride Gel" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "Aloe Vera Gel Oral", cat: "Oral Care" },
//   { name: "Hyaluronic Acid Gel 0.2% Oral", cat: "Oral Care" },
//   { name: "Triclosan Toothpaste", cat: "Dental Brand" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Colgate Total Toothpaste", cat: "Dental Brand" },
//   { name: "Pepsodent Toothpaste", cat: "Dental Brand" },
//   { name: "Emoform Toothpaste", cat: "Dental Brand" },
//   { name: "Thermoseal Toothpaste", cat: "Dental Brand" },
//   { name: "Himalaya HiOra Toothpaste", cat: "Dental Brand" },
//   { name: "Dabur Red Toothpaste", cat: "Dental Brand" },
//   { name: "Meswak Toothpaste", cat: "Dental Brand" },
//   { name: "Oral-B Electric Toothbrush Head", cat: "Dental Accessory" },
//   { name: "Interdental Brush", cat: "Dental Accessory" },
//   { name: "Dental Floss", cat: "Dental Accessory" },
//   { name: "Tongue Cleaner", cat: "Dental Accessory" },
//   { name: "Water Flosser / Oral Irrigator", cat: "Dental Accessory" },
//   // ── DENTAL MATERIALS ────────────────────────────────────────
//   { name: "GIC Cement (Glass Ionomer Cement)", cat: "Dental Material" },
//   { name: "GIC Type II Restorative", cat: "Dental Material" },
//   { name: "RMGIC (Resin Modified GIC)", cat: "Dental Material" },
//   { name: "Composite Resin A1 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A2 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A3 Shade", cat: "Dental Material" },
//   { name: "Composite Resin B1 Shade", cat: "Dental Material" },
//   { name: "Flowable Composite", cat: "Dental Material" },
//   { name: "Bulk Fill Composite", cat: "Dental Material" },
//   { name: "IRM (Intermediate Restorative Material)", cat: "Dental Material" },
//   { name: "Zinc Oxide Eugenol Cement", cat: "Dental Material" },
//   { name: "Zinc Phosphate Cement", cat: "Dental Material" },
//   { name: "Zinc Polycarboxylate Cement", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Dycal (Calcium Hydroxide Base)", cat: "Dental Material" },
//   { name: "Cavity Liner (Varnish)", cat: "Dental Material" },
//   { name: "Etchant 37% Phosphoric Acid Gel", cat: "Dental Material" },
//   { name: "Bonding Agent (5th Gen)", cat: "Dental Material" },
//   { name: "Bonding Agent (7th Gen Self-Etch)", cat: "Dental Material" },
//   { name: "Dental Amalgam Capsule", cat: "Dental Material" },
//   { name: "Impression Material Alginate", cat: "Dental Material" },
//   {
//     name: "Impression Material Polyvinyl Siloxane (PVS)",
//     cat: "Dental Material",
//   },
//   { name: "Impression Material Polyether", cat: "Dental Material" },
//   { name: "Zinc Oxide Impression Paste", cat: "Dental Material" },
//   { name: "Plaster of Paris (Type II)", cat: "Dental Material" },
//   { name: "Dental Stone (Type III)", cat: "Dental Material" },
//   { name: "Dental Stone (Type IV)", cat: "Dental Material" },
//   { name: "Acrylic Resin Heat Cure", cat: "Dental Material" },
//   { name: "Acrylic Resin Cold Cure / Self Cure", cat: "Dental Material" },
//   { name: "Denture Base Resin", cat: "Dental Material" },
//   { name: "Denture Reliner", cat: "Dental Material" },
//   { name: "Denture Adhesive Cream", cat: "Dental Material" },
//   { name: "Dental Wax (Sheet Wax)", cat: "Dental Material" },
//   { name: "Boxing Wax", cat: "Dental Material" },
//   { name: "Inlay Wax", cat: "Dental Material" },
//   { name: "Sticky Wax", cat: "Dental Material" },
//   { name: "Orthodontic Wire NiTi 0.012", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire NiTi 0.014", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire NiTi 0.016", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire SS 0.019x0.025", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Metal)", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Ceramic)", cat: "Dental Ortho" },
//   { name: "Orthodontic Elastic Bands", cat: "Dental Ortho" },
//   { name: "Orthodontic Separator Elastics", cat: "Dental Ortho" },
//   { name: "Orthodontic Molar Band", cat: "Dental Ortho" },
//   { name: "Orthodontic Retainer Wire", cat: "Dental Ortho" },
//   { name: "Invisalign Clear Aligner Tray", cat: "Dental Ortho" },
//   { name: "Dental Implant Fixture (Titanium)", cat: "Dental Implant" },
//   { name: "Dental Implant Abutment", cat: "Dental Implant" },
//   { name: "Healing Cap / Cover Screw", cat: "Dental Implant" },
//   { name: "Bone Graft Material (Synthetic HA)", cat: "Dental Implant" },
//   { name: "Bone Graft Material (Xenograft)", cat: "Dental Implant" },
//   { name: "Collagen Membrane (Resorbable)", cat: "Dental Implant" },
//   { name: "Titanium Mesh", cat: "Dental Implant" },
//   { name: "PRP (Platelet Rich Plasma) Kit", cat: "Dental Surgical" },
//   { name: "PRF (Platelet Rich Fibrin) Kit", cat: "Dental Surgical" },
//   { name: "Hemostatic Agent (Gelatin Sponge)", cat: "Dental Surgical" },
//   { name: "Surgicel (Oxidised Cellulose)", cat: "Haemostatic" },
//   { name: "Alvogyl (Dry Socket Dressing)", cat: "Dental Surgical" },
//   { name: "Whitehead Varnish (Iodoform Paste)", cat: "Dental Surgical" },
//   { name: "Ledermix Paste", cat: "Dental Material" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Sealapex)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Zinc Oxide Eugenol)", cat: "Endodontic" },
//   { name: "Gutta Percha Points (ISO 20-80)", cat: "Endodontic" },
//   { name: "Paper Points (Absorbent Points)", cat: "Endodontic" },
//   { name: "EDTA Liquid 17% (Root Canal)", cat: "Endodontic" },
//   { name: "EDTA Gel 17% (Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 2.5% Solution", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% Solution", cat: "Endodontic" },
//   { name: "Chlorhexidine 2% Irrigant", cat: "Endodontic" },
//   { name: "RC Prep (Root Canal Lubricant)", cat: "Endodontic" },
//   { name: "K-Files (Root Canal Files) ISO 6-80", cat: "Endodontic Instrument" },
//   { name: "H-Files (Hedstrom Files) ISO 15-60", cat: "Endodontic Instrument" },
//   { name: "Rotary NiTi Files (ProTaper)", cat: "Endodontic Instrument" },
//   { name: "Rotary NiTi Files (WaveOne Gold)", cat: "Endodontic Instrument" },
//   { name: "Rubber Dam Sheet", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Clamp", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Frame", cat: "Endodontic Accessory" },
//   { name: "Pulp Capping Agent (Vitrebond)", cat: "Endodontic" },
//   { name: "Formocresol Solution", cat: "Endodontic Paediatric" },
//   { name: "Buckley's Formocresol", cat: "Endodontic Paediatric" },
//   {
//     name: "Zinc Oxide + Iodoform Paste (Kri Paste)",
//     cat: "Endodontic Paediatric",
//   },
//   { name: "Stainless Steel Crown (Paediatric)", cat: "Paediatric Dental" },
//   { name: "Fluoride Varnish Duraphat 22600 ppm", cat: "Fluoride Varnish" },
//   // ── SURGICAL INSTRUMENTS ────────────────────────────────────
//   { name: "Scalpel Handle No. 3", cat: "Surgical Instrument" },
//   { name: "Scalpel Handle No. 4", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 11", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 12", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 15", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 23", cat: "Surgical Instrument" },
//   { name: "Scissors (Metzenbaum)", cat: "Surgical Instrument" },
//   { name: "Scissors (Mayo Straight)", cat: "Surgical Instrument" },
//   { name: "Scissors (Mayo Curved)", cat: "Surgical Instrument" },
//   { name: "Scissors (Iris)", cat: "Surgical Instrument" },
//   { name: "Scissors (Dean)", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Straight)", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Curved)", cat: "Surgical Instrument" },
//   { name: "Mosquito Forceps", cat: "Surgical Instrument" },
//   { name: "Tissue Forceps (Adson)", cat: "Surgical Instrument" },
//   { name: "Tissue Forceps (Rat Tooth)", cat: "Surgical Instrument" },
//   { name: "Allis Tissue Forceps", cat: "Surgical Instrument" },
//   { name: "Babcock Forceps", cat: "Surgical Instrument" },
//   { name: "Needle Holder (Mayo Hegar)", cat: "Surgical Instrument" },
//   { name: "Needle Holder (Mathieu)", cat: "Surgical Instrument" },
//   { name: "Retractor (Langenbeck)", cat: "Surgical Instrument" },
//   { name: "Retractor (Army-Navy)", cat: "Surgical Instrument" },
//   { name: "Retractor (Minnesota)", cat: "Surgical Instrument" },
//   { name: "Cheek Retractor (Plastic)", cat: "Dental Instrument" },
//   { name: "Mouth Gag (Doyen)", cat: "Surgical Instrument" },
//   { name: "Periosteal Elevator (Molt No.9)", cat: "Dental Instrument" },
//   { name: "Periosteal Elevator (Freer)", cat: "Dental Instrument" },
//   { name: "Bone Curette (Lucas)", cat: "Dental Instrument" },
//   { name: "Surgical Curette", cat: "Surgical Instrument" },
//   { name: "Bone File", cat: "Dental Instrument" },
//   { name: "Rongeur Forceps (Bone Cutting)", cat: "Surgical Instrument" },
//   { name: "Surgical Mallet", cat: "Surgical Instrument" },
//   { name: "Osteotome", cat: "Surgical Instrument" },
//   { name: "Chisel (Straight)", cat: "Surgical Instrument" },
//   { name: "Suction Tip (Yankauer)", cat: "Surgical Instrument" },
//   { name: "Suction Tip (Dental Fine Tip)", cat: "Dental Instrument" },
//   { name: "Saliva Ejector Tip", cat: "Dental Instrument" },
//   { name: "High Volume Evacuator (HVE) Tip", cat: "Dental Instrument" },
//   { name: "Air/Water Syringe Tip", cat: "Dental Instrument" },
//   // ── DENTAL EXTRACTION FORCEPS ────────────────────────────────
//   { name: "Extraction Forceps Upper Anterior", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Premolar", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Molar (Left)", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Molar (Right)", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Anterior", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Premolar", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Molar", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Roots (Bayonet)", cat: "Dental Instrument" },
//   { name: "Elevator (Straight No. 301)", cat: "Dental Instrument" },
//   { name: "Elevator (Cryer Right)", cat: "Dental Instrument" },
//   { name: "Elevator (Cryer Left)", cat: "Dental Instrument" },
//   { name: "Elevator (Apexo)", cat: "Dental Instrument" },
//   { name: "Elevator (Warwick James)", cat: "Dental Instrument" },
//   { name: "Elevator (Coupland)", cat: "Dental Instrument" },
//   // ── PERIODONTAL INSTRUMENTS ──────────────────────────────────
//   { name: "Ultrasonic Scaler Tip (Universal)", cat: "Periodontal Instrument" },
//   {
//     name: "Ultrasonic Scaler Tip (Subgingival)",
//     cat: "Periodontal Instrument",
//   },
//   { name: "Sickle Scaler H6/H7", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 1/2", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 5/6", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 7/8", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 11/12", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 13/14", cat: "Periodontal Instrument" },
//   { name: "Columbia Curette 4R/4L", cat: "Periodontal Instrument" },
//   { name: "Periodontal Probe (Williams)", cat: "Periodontal Instrument" },
//   { name: "Periodontal Probe (UNC-15)", cat: "Periodontal Instrument" },
//   { name: "Periodontal Probe (CPITN)", cat: "Periodontal Instrument" },
//   { name: "Suture Scissors (Crown Removing)", cat: "Periodontal Instrument" },
//   { name: "Electrosurgery Tip", cat: "Periodontal Instrument" },
//   // ── NEEDLES AND SYRINGES ─────────────────────────────────────
//   { name: "Dental Needle 27G Short (21mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 27G Long (38mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Short (21mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 25G Long (38mm)", cat: "Dental Needle" },
//   {
//     name: "Aspirating Dental Syringe (Breech Loading)",
//     cat: "Dental Instrument",
//   },
//   { name: "Disposable Syringe 1ml (Insulin)", cat: "Syringe" },
//   { name: "Disposable Syringe 2ml", cat: "Syringe" },
//   { name: "Disposable Syringe 5ml", cat: "Syringe" },
//   { name: "Disposable Syringe 10ml", cat: "Syringe" },
//   { name: "Disposable Syringe 20ml", cat: "Syringe" },
//   { name: "Disposable Syringe 50ml (Piston)", cat: "Syringe" },
//   { name: "Needle 18G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 20G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 21G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 22G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 23G x 1 inch", cat: "Needle" },
//   { name: "Needle 24G x 1 inch", cat: "Needle" },
//   { name: "Needle 25G x 5/8 inch", cat: "Needle" },
//   { name: "Needle 26G x 0.5 inch", cat: "Needle" },
//   { name: "IV Cannula 14G (Orange)", cat: "IV Cannula" },
//   { name: "IV Cannula 16G (Grey)", cat: "IV Cannula" },
//   { name: "IV Cannula 18G (Green)", cat: "IV Cannula" },
//   { name: "IV Cannula 20G (Pink)", cat: "IV Cannula" },
//   { name: "IV Cannula 22G (Blue)", cat: "IV Cannula" },
//   { name: "IV Cannula 24G (Yellow)", cat: "IV Cannula" },
//   { name: "Spinal Needle 25G (Quincke)", cat: "Spinal Needle" },
//   { name: "Spinal Needle 26G (Quincke)", cat: "Spinal Needle" },
//   { name: "Epidural Needle 16G (Tuohy)", cat: "Epidural Needle" },
//   { name: "Epidural Catheter", cat: "Epidural Set" },
//   { name: 'Hypodermic Needle 21G x 1.5"', cat: "Needle" },
//   { name: "Scalp Vein Set 21G (Butterfly)", cat: "IV Accessory" },
//   { name: "Scalp Vein Set 23G (Butterfly)", cat: "IV Accessory" },
//   { name: "Scalp Vein Set 25G (Butterfly)", cat: "IV Accessory" },
//   // ── IV FLUIDS / INFUSIONS ────────────────────────────────────
//   { name: "Normal Saline 0.9% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 1000ml Infusion", cat: "IV Fluid" },
//   { name: "Ringer's Lactate 500ml Infusion", cat: "IV Fluid" },
//   { name: "Ringer's Lactate 1000ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 5% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 5% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 10% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 25% 200ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 50% 50ml Injection", cat: "IV Fluid" },
//   { name: "Dextrose 5% + Normal Saline 500ml", cat: "IV Fluid" },
//   { name: "Dextrose Saline (0.45% NaCl + 5% Dextrose)", cat: "IV Fluid" },
//   { name: "Isolyte S 500ml Infusion", cat: "IV Fluid" },
//   { name: "Isolyte P 500ml Infusion (Paediatric)", cat: "IV Fluid" },
//   { name: "Plasma Expander (Haemaccel) 500ml", cat: "IV Fluid" },
//   { name: "Colloid Solution (Albumin 5%) 500ml", cat: "IV Fluid" },
//   { name: "Albumin 25% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Sodium Bicarbonate 7.5% 25ml Injection", cat: "IV Fluid" },
//   { name: "Potassium Chloride 15% 10ml Ampoule", cat: "IV Electrolyte" },
//   { name: "Calcium Gluconate 10% Injection", cat: "IV Electrolyte" },
//   { name: "Magnesium Sulphate 50% Injection", cat: "IV Electrolyte" },
//   { name: "TPN (Total Parenteral Nutrition) Bag", cat: "IV Nutrition" },
//   { name: "Lipid Emulsion 20% Infusion", cat: "IV Nutrition" },
//   // ── ANTIEMETICS / GI ─────────────────────────────────────────
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 2mg/ml Injection", cat: "Antiemetic Inj" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Injection", cat: "Antiemetic Inj" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Promethazine 25mg Tablet", cat: "Antiemetic / Antihistamine" },
//   { name: "Promethazine 25mg Injection", cat: "Antiemetic Inj" },
//   { name: "Granisetron 1mg Tablet", cat: "Antiemetic" },
//   { name: "Pantoprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Ranitidine 150mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ranitidine 50mg Injection", cat: "Antacid Inj" },
//   { name: "Sucralfate Suspension 1g/10ml", cat: "Antacid" },
//   { name: "Antacid Suspension (Digene)", cat: "Antacid" },
//   { name: "Antacid Tablet (Gelusil)", cat: "Antacid" },
//   { name: "Syp Lactulose 10g/15ml", cat: "Laxative" },
//   { name: "Bisacodyl 5mg Tablet", cat: "Laxative" },
//   { name: "Bisacodyl Suppository 10mg", cat: "Laxative" },
//   { name: "Loperamide 2mg Tablet", cat: "Antidiarrhoeal" },
//   { name: "ORS Sachet (WHO Formula)", cat: "Oral Rehydration" },
//   { name: "Zinc Sulphate 20mg Tablet (Paediatric)", cat: "Micronutrient" },
//   // ── ANTIHISTAMINES / ALLERGY ─────────────────────────────────
//   { name: "Cetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 5mg/5ml Syrup", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 180mg Tablet", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 4mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 10mg Injection", cat: "Antihistamine Inj" },
//   { name: "Diphenhydramine 25mg Capsule", cat: "Antihistamine" },
//   { name: "Diphenhydramine Injection", cat: "Antihistamine Inj" },
//   { name: "Adrenaline (Epinephrine) 1mg/ml Injection", cat: "Emergency Drug" },
//   { name: "Hydrocortisone 100mg Injection (Allergy)", cat: "Emergency Drug" },
//   { name: "Epinephrine Auto-Injector (EpiPen)", cat: "Emergency Drug" },
//   // ── CARDIOVASCULAR ───────────────────────────────────────────
//   { name: "Amlodipine 2.5mg Tablet", cat: "Antihypertensive" },
//   { name: "Amlodipine 5mg Tablet", cat: "Antihypertensive" },
//   { name: "Amlodipine 10mg Tablet", cat: "Antihypertensive" },
//   { name: "Atenolol 25mg Tablet", cat: "Beta Blocker" },
//   { name: "Atenolol 50mg Tablet", cat: "Beta Blocker" },
//   { name: "Atenolol 100mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 25mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 50mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 100mg Tablet", cat: "Beta Blocker" },
//   { name: "Propranolol 10mg Tablet", cat: "Beta Blocker" },
//   { name: "Propranolol 40mg Tablet", cat: "Beta Blocker" },
//   { name: "Losartan 25mg Tablet", cat: "Antihypertensive" },
//   { name: "Losartan 50mg Tablet", cat: "Antihypertensive" },
//   { name: "Telmisartan 40mg Tablet", cat: "Antihypertensive" },
//   { name: "Telmisartan 80mg Tablet", cat: "Antihypertensive" },
//   { name: "Ramipril 2.5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Ramipril 5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Enalapril 5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Enalapril 10mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Furosemide 20mg Tablet", cat: "Diuretic" },
//   { name: "Furosemide 40mg Tablet", cat: "Diuretic" },
//   { name: "Furosemide 20mg Injection", cat: "Diuretic Inj" },
//   { name: "Spironolactone 25mg Tablet", cat: "Diuretic" },
//   { name: "Aspirin 75mg Tablet", cat: "Antiplatelet" },
//   { name: "Aspirin 150mg Tablet", cat: "Antiplatelet" },
//   { name: "Clopidogrel 75mg Tablet", cat: "Antiplatelet" },
//   { name: "Atorvastatin 10mg Tablet", cat: "Statin" },
//   { name: "Atorvastatin 20mg Tablet", cat: "Statin" },
//   { name: "Atorvastatin 40mg Tablet", cat: "Statin" },
//   { name: "Nitroglycerin 0.5mg Sublingual Tablet", cat: "Nitrate" },
//   { name: "Nitroglycerin 5mg/ml Infusion", cat: "Nitrate Inj" },
//   { name: "Digoxin 0.25mg Tablet", cat: "Cardiac Glycoside" },
//   { name: "Amiodarone 200mg Tablet", cat: "Antiarrhythmic" },
//   { name: "Warfarin 1mg Tablet", cat: "Anticoagulant" },
//   { name: "Warfarin 5mg Tablet", cat: "Anticoagulant" },
//   { name: "Heparin 5000 IU Injection", cat: "Anticoagulant Inj" },
//   { name: "Protamine Sulphate 10mg Injection", cat: "Anticoagulant Reversal" },
//   // ── DIABETES DRUGS ───────────────────────────────────────────
//   { name: "Metformin 500mg Tablet", cat: "Antidiabetic" },
//   { name: "Metformin 850mg Tablet", cat: "Antidiabetic" },
//   { name: "Metformin 1000mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 1mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 2mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 4mg Tablet", cat: "Antidiabetic" },
//   { name: "Insulin Regular (Soluble) 100 IU/ml", cat: "Insulin" },
//   { name: "Insulin NPH (Isophane) 100 IU/ml", cat: "Insulin" },
//   { name: "Insulin Glargine 100 IU/ml (Lantus)", cat: "Insulin" },
//   { name: "Insulin Aspart 100 IU/ml (Novorapid)", cat: "Insulin" },
//   { name: "Insulin Lispro 100 IU/ml (Humalog)", cat: "Insulin" },
//   // ── VITAMINS / SUPPLEMENTS ───────────────────────────────────
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin C 1000mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule (Weekly)", cat: "Vitamin" },
//   { name: "Vitamin D3 1000 IU Tablet (Daily)", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 500mcg Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 1000mcg Injection", cat: "Vitamin Inj" },
//   { name: "Vitamin K1 10mg Injection", cat: "Vitamin Inj" },
//   { name: "Folic Acid 5mg Tablet", cat: "Vitamin" },
//   { name: "Iron (Ferrous Sulphate) 200mg Tablet", cat: "Iron Supplement" },
//   { name: "Iron + Folic Acid Tablet", cat: "Iron Supplement" },
//   { name: "Iron Sucrose 100mg Injection", cat: "Iron Supplement Inj" },
//   { name: "Calcium Carbonate 500mg Tablet", cat: "Calcium Supplement" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Zinc Sulphate 50mg Tablet", cat: "Micronutrient" },
//   { name: "Magnesium Hydroxide 300mg Tablet", cat: "Mineral Supplement" },
//   { name: "Multivitamin Tablet (Adult)", cat: "Multivitamin" },
//   { name: "Multivitamin Syrup (Paediatric)", cat: "Multivitamin" },
//   // ── HAEMOSTATICS / BLEEDING ──────────────────────────────────
//   { name: "Tranexamic Acid 500mg Tablet", cat: "Haemostatic" },
//   { name: "Tranexamic Acid 250mg/5ml Injection", cat: "Haemostatic Inj" },
//   { name: "Etamsylate 250mg Tablet", cat: "Haemostatic" },
//   { name: "Etamsylate 125mg/2ml Injection", cat: "Haemostatic Inj" },
//   { name: "Gelatin Sponge (Absorbable Haemostat)", cat: "Haemostatic" },
//   { name: "Bone Wax", cat: "Haemostatic Surgical" },
//   { name: "Thrombin Topical Powder", cat: "Haemostatic" },
//   { name: "Fibrin Glue (Tisseel)", cat: "Haemostatic Surgical" },
//   // ── SUTURE MATERIALS ─────────────────────────────────────────
//   { name: "Vicryl (Polyglactin 910) 3-0 Suture", cat: "Suture" },
//   { name: "Vicryl (Polyglactin 910) 4-0 Suture", cat: "Suture" },
//   { name: "Vicryl Rapid 4-0 Suture", cat: "Suture" },
//   { name: "Chromic Catgut 2-0 Suture", cat: "Suture" },
//   { name: "Chromic Catgut 3-0 Suture", cat: "Suture" },
//   { name: "Plain Catgut 2-0 Suture", cat: "Suture" },
//   { name: "Silk Suture 2-0 Black Braided", cat: "Suture" },
//   { name: "Silk Suture 3-0 Black Braided", cat: "Suture" },
//   { name: "Silk Suture 4-0 Black Braided", cat: "Suture" },
//   { name: "Nylon Suture 3-0 (Ethilon)", cat: "Suture" },
//   { name: "Nylon Suture 4-0 (Ethilon)", cat: "Suture" },
//   { name: "Nylon Suture 5-0 (Ethilon)", cat: "Suture" },
//   { name: "Prolene (Polypropylene) 3-0 Suture", cat: "Suture" },
//   { name: "Prolene (Polypropylene) 4-0 Suture", cat: "Suture" },
//   { name: "PDS II (Polydioxanone) 3-0 Suture", cat: "Suture" },
//   { name: "Monocryl 4-0 Suture (Poliglecaprone)", cat: "Suture" },
//   { name: "Stapler Skin (Proximate Plus)", cat: "Surgical Closure" },
//   { name: "Skin Staple Remover", cat: "Surgical Instrument" },
//   { name: "Steri-Strip (Wound Closure Strip)", cat: "Wound Care" },
//   { name: "Surgical Glue (Dermabond / Histoacryl)", cat: "Wound Care" },
//   // ── DRESSINGS / WOUND CARE ───────────────────────────────────
//   { name: "Gauze Swab 4x4 inch (Sterile)", cat: "Dressing" },
//   { name: "Gauze Swab 10x10 cm (Non-Sterile)", cat: "Dressing" },
//   { name: "ABD Pad (Combine Dressing)", cat: "Dressing" },
//   { name: "Crepe Bandage 4 inch", cat: "Bandage" },
//   { name: "Crepe Bandage 6 inch", cat: "Bandage" },
//   { name: "Adhesive Plaster Roll 1 inch", cat: "Bandage" },
//   { name: "Elastic Adhesive Bandage (EAB)", cat: "Bandage" },
//   { name: "Cohesive Bandage", cat: "Bandage" },
//   { name: "Cotton Roll (Non-Sterile)", cat: "Dental Material" },
//   { name: "Cotton Roll Sterile", cat: "Dressing" },
//   { name: "Absorbable Haemostatic Gauze", cat: "Haemostatic Dressing" },
//   { name: "Vaseline Gauze (Petrolatum Gauze)", cat: "Dressing" },
//   { name: "Jelonet Paraffin Gauze", cat: "Dressing" },
//   { name: "Melolin Non-Adherent Dressing", cat: "Dressing" },
//   { name: "Hydrocolloid Dressing (DuoDERM)", cat: "Dressing" },
//   { name: "Hydrogel Dressing", cat: "Dressing" },
//   { name: "Foam Dressing", cat: "Dressing" },
//   { name: "Alginate Dressing", cat: "Dressing" },
//   { name: "Transparent Film Dressing (Tegaderm)", cat: "Dressing" },
//   { name: "Povidone Iodine Gauze", cat: "Dressing" },
//   { name: "Silver Sulfadiazine 1% Cream", cat: "Burns Dressing" },
//   { name: "Bacitracin Ointment", cat: "Topical Antibiotic" },
//   { name: "Mupirocin 2% Ointment (Bactroban)", cat: "Topical Antibiotic" },
//   { name: "Fusidic Acid 2% Cream", cat: "Topical Antibiotic" },
//   { name: "Framycetin (Soframycin) Cream", cat: "Topical Antibiotic" },
//   // ── GLOVES / PPE / DISPOSABLES ───────────────────────────────
//   { name: "Latex Examination Gloves (S/M/L)", cat: "PPE" },
//   { name: "Nitrile Examination Gloves (S/M/L)", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 6.0", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 6.5", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 7.0", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 7.5", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 8.0", cat: "PPE" },
//   { name: "Surgical Mask (3-ply)", cat: "PPE" },
//   { name: "N95 Respirator Mask (FFP2)", cat: "PPE" },
//   { name: "Face Shield", cat: "PPE" },
//   { name: "Surgical Cap / Head Cover", cat: "PPE" },
//   { name: "Shoe Cover (Surgical Boot Cover)", cat: "PPE" },
//   { name: "Sterile Gown (Surgical)", cat: "PPE" },
//   { name: "Disposable Apron", cat: "PPE" },
//   { name: "Safety Goggles", cat: "PPE" },
//   { name: "Sharps Container 5L", cat: "Waste Disposal" },
//   { name: "Yellow Biohazard Bag", cat: "Waste Disposal" },
//   { name: "Red Biohazard Bag", cat: "Waste Disposal" },
//   { name: "IV Line / Infusion Set", cat: "IV Accessory" },
//   { name: "Burette Set (Paediatric IV Set)", cat: "IV Accessory" },
//   { name: "Blood Transfusion Set", cat: "IV Accessory" },
//   { name: "Nasogastric Tube (Ryle's Tube) 14F", cat: "Medical Device" },
//   { name: "Nasogastric Tube 16F", cat: "Medical Device" },
//   { name: "Foley Catheter 14F (2-Way)", cat: "Medical Device" },
//   { name: "Foley Catheter 16F (2-Way)", cat: "Medical Device" },
//   { name: "Foley Catheter 18F (3-Way)", cat: "Medical Device" },
//   { name: "Urobag (Urine Collection Bag)", cat: "Medical Device" },
//   { name: "Tracheostomy Tube (Cuffed) Size 7", cat: "Medical Device" },
//   { name: "Endotracheal Tube (ETT) 7.0 Cuffed", cat: "Anaesthesia Device" },
//   { name: "Endotracheal Tube (ETT) 7.5 Cuffed", cat: "Anaesthesia Device" },
//   { name: "Laryngoscope Blade (Macintosh Size 3)", cat: "Anaesthesia Device" },
//   { name: "Laryngeal Mask Airway (LMA) Size 3", cat: "Anaesthesia Device" },
//   { name: "Oropharyngeal Airway (Guedel) Size 3", cat: "Anaesthesia Device" },
//   { name: "Bag Valve Mask (BVM Resuscitator)", cat: "Emergency Device" },
//   { name: "Pulse Oximeter Probe", cat: "Monitoring Device" },
//   { name: "BP Cuff (Sphygmomanometer Cuff)", cat: "Monitoring Device" },
//   // ── RESPIRATORY / BRONCHODILATORS ───────────────────────────
//   { name: "Salbutamol 2mg Tablet", cat: "Bronchodilator" },
//   { name: "Salbutamol 4mg Tablet", cat: "Bronchodilator" },
//   { name: "Salbutamol 2.5mg/2.5ml Nebulisation", cat: "Bronchodilator" },
//   { name: "Salbutamol Inhaler 100mcg (MDI)", cat: "Bronchodilator Inhaler" },
//   { name: "Ipratropium 0.5mg Nebulisation", cat: "Bronchodilator" },
//   { name: "Budesonide 0.5mg Nebulisation", cat: "Steroid Inhaler" },
//   { name: "Doxofylline 400mg Tablet", cat: "Bronchodilator" },
//   { name: "Deriphylline Injection", cat: "Bronchodilator Inj" },
//   // ── ANTIEPILEPTICS ───────────────────────────────────────────
//   { name: "Phenytoin 100mg Tablet", cat: "Antiepileptic" },
//   { name: "Phenytoin 50mg/ml Injection", cat: "Antiepileptic Inj" },
//   { name: "Valproate 200mg Tablet", cat: "Antiepileptic" },
//   { name: "Valproate 500mg Tablet", cat: "Antiepileptic" },
//   { name: "Levetiracetam 500mg Tablet", cat: "Antiepileptic" },
//   { name: "Lorazepam 4mg Injection", cat: "Antiepileptic / Sedative Inj" },
//   { name: "Diazepam 10mg Injection", cat: "Antiepileptic / Sedative Inj" },
//   { name: "Clonazepam 0.5mg Tablet", cat: "Antiepileptic" },
//   { name: "Clonazepam 2mg Tablet", cat: "Antiepileptic" },
//   // ── VACCINES ─────────────────────────────────────────────────
//   { name: "Tetanus Toxoid 0.5ml Injection", cat: "Vaccine" },
//   { name: "Tetanus + Diphtheria (Td) Vaccine", cat: "Vaccine" },
//   { name: "Influenza Vaccine (Flu Shot)", cat: "Vaccine" },
//   { name: "Typhoid Vaccine (Vi Polysaccharide)", cat: "Vaccine" },
//   { name: "Rabies Vaccine (Post-Exposure)", cat: "Vaccine" },
//   { name: "Rabies Immunoglobulin (Human)", cat: "Vaccine" },
//   { name: "MMR Vaccine", cat: "Vaccine" },
//   { name: "Varicella (Chickenpox) Vaccine", cat: "Vaccine" },
//   { name: "HPV Vaccine (Gardasil 4/9)", cat: "Vaccine" },
//   { name: "COVID-19 Vaccine (Covishield)", cat: "Vaccine" },
//   { name: "COVID-19 Vaccine (Covaxin)", cat: "Vaccine" },
//   { name: "Anti-Tetanus Serum (ATS)", cat: "Antiserum" },
//   { name: "Anti-Snake Venom (Polyvalent)", cat: "Antiserum" },
//   { name: "Anti-Rabies Serum", cat: "Antiserum" },
//   { name: "Anti-Scorpion Venom Serum", cat: "Antiserum" },
//   // ── INVESTIGATIONS / LAB ─────────────────────────────────────
//   { name: "OPG (Orthopantomogram) X-ray", cat: "Dental Investigation" },
//   { name: "IOPA X-ray (Intraoral Periapical)", cat: "Dental Investigation" },
//   { name: "Bitewing X-ray", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Cone Beam CT)", cat: "Dental Investigation" },
//   { name: "Occlusal X-ray", cat: "Dental Investigation" },
//   { name: "Lateral Cephalogram X-ray", cat: "Dental Investigation" },
//   { name: "Chest X-ray PA View", cat: "Investigation" },
//   { name: "Skull X-ray AP + Lateral", cat: "Investigation" },
//   { name: "X-Ray Mandible PA View", cat: "Investigation" },
//   { name: "X-Ray Waters View (PNS)", cat: "Investigation" },
//   { name: "ECG (Electrocardiogram)", cat: "Investigation" },
//   { name: "CT Scan Head Plain", cat: "Investigation" },
//   { name: "CT Scan Neck with Contrast", cat: "Investigation" },
//   { name: "MRI Face and Jaw", cat: "Investigation" },
//   { name: "Ultrasound Neck / Submandibular", cat: "Investigation" },
//   { name: "Complete Blood Count (CBC)", cat: "Lab Test" },
//   { name: "Differential Count (DC)", cat: "Lab Test" },
//   { name: "Blood Sugar Fasting (BSF)", cat: "Lab Test" },
//   { name: "Blood Sugar Post Prandial (BSPP)", cat: "Lab Test" },
//   { name: "Random Blood Sugar (RBS)", cat: "Lab Test" },
//   { name: "HbA1c Test", cat: "Lab Test" },
//   { name: "Liver Function Test (LFT)", cat: "Lab Test" },
//   { name: "Kidney Function Test (KFT) / RFT", cat: "Lab Test" },
//   { name: "Thyroid Function Test (TFT)", cat: "Lab Test" },
//   { name: "Lipid Profile Test", cat: "Lab Test" },
//   { name: "Urine Routine and Microscopy", cat: "Lab Test" },
//   { name: "Blood Group and Rh Typing", cat: "Lab Test" },
//   { name: "Platelet Count", cat: "Lab Test" },
//   { name: "PT / INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "APTT Test", cat: "Lab Test" },
//   { name: "Bleeding Time (BT)", cat: "Lab Test" },
//   { name: "Clotting Time (CT)", cat: "Lab Test" },
//   { name: "ESR (Erythrocyte Sedimentation Rate)", cat: "Lab Test" },
//   { name: "CRP (C-Reactive Protein)", cat: "Lab Test" },
//   { name: "Serum Calcium Test", cat: "Lab Test" },
//   { name: "Serum Phosphorus Test", cat: "Lab Test" },
//   { name: "Serum Vitamin D (25-OH) Test", cat: "Lab Test" },
//   { name: "Serum Vitamin B12 Test", cat: "Lab Test" },
//   { name: "Serum Iron / TIBC Test", cat: "Lab Test" },
//   { name: "HIV Test (ELISA)", cat: "Lab Test" },
//   { name: "HBsAg Test (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HCV Test (Hepatitis C)", cat: "Lab Test" },
//   { name: "VDRL / RPR Test (Syphilis)", cat: "Lab Test" },
//   { name: "Pus Culture and Sensitivity", cat: "Lab Test" },
//   { name: "Blood Culture and Sensitivity", cat: "Lab Test" },
//   { name: "FNAC (Fine Needle Aspiration Cytology)", cat: "Biopsy" },
//   { name: "Incisional Biopsy", cat: "Biopsy" },
//   { name: "Excisional Biopsy", cat: "Biopsy" },
//   { name: "Exfoliative Cytology (Oral Smear)", cat: "Lab Test" },
//   { name: "Histopathology (HPE)", cat: "Lab Test" },
//   // ── EMERGENCY DRUGS ─────────────────────────────────────────
//   { name: "Adrenaline 1:1000 (1mg/ml) Injection", cat: "Emergency Drug" },
//   { name: "Adrenaline 1:10000 Injection (Cardiac)", cat: "Emergency Drug" },
//   { name: "Atropine 0.6mg Injection", cat: "Emergency Drug" },
//   { name: "Sodium Bicarbonate 8.4% Injection", cat: "Emergency Drug" },
//   { name: "Calcium Gluconate 10% Injection", cat: "Emergency Drug" },
//   { name: "Dextrose 50% Injection (Hypoglycaemia)", cat: "Emergency Drug" },
//   { name: "Naloxone 0.4mg Injection (Opioid Reversal)", cat: "Emergency Drug" },
//   {
//     name: "Flumazenil 0.5mg Injection (Benzo Reversal)",
//     cat: "Emergency Drug",
//   },
//   { name: "Dopamine 200mg Infusion", cat: "Emergency Drug Inj" },
//   {
//     name: "Noradrenaline (Norepinephrine) Infusion",
//     cat: "Emergency Drug Inj",
//   },
//   { name: "Vasopressin 20 IU Injection", cat: "Emergency Drug Inj" },
//   { name: "GTN (Glyceryl Trinitrate) Infusion", cat: "Emergency Drug Inj" },
//   {
//     name: "Lignocaine 100mg IV Injection (Arrhythmia)",
//     cat: "Emergency Drug Inj",
//   },
//   { name: "Adenosine 6mg Injection (SVT)", cat: "Emergency Drug Inj" },
//   { name: "Defibrillator Pads (AED Electrode)", cat: "Emergency Device" },
//   ,
//   // ── CONSUMABLES: COTTON & GAUZE ──────────────────────────────
//   { name: "Cotton Roll (Dental Grade)", cat: "Consumable" },
//   { name: "Cotton Pellet Small", cat: "Consumable" },
//   { name: "Cotton Pellet Medium", cat: "Consumable" },
//   { name: "Cotton Pellet Large", cat: "Consumable" },
//   { name: "Absorbent Cotton Wool 500g Roll", cat: "Consumable" },
//   { name: "Absorbent Cotton Wool 100g", cat: "Consumable" },
//   { name: "Gauze Swab 4x4 inch Sterile", cat: "Consumable" },
//   { name: "Gauze Swab 2x2 inch Sterile", cat: "Consumable" },
//   { name: "Gauze Roll 5cm x 5m", cat: "Consumable" },
//   { name: "Gauze Roll 10cm x 5m", cat: "Consumable" },
//   { name: "Non-Woven Gauze Swab 4x4", cat: "Consumable" },
//   { name: "Paraffin Gauze Dressing", cat: "Dressing" },
//   { name: "Betadine Gauze Dressing", cat: "Dressing" },
//   { name: "Ribbon Gauze 1/2 inch (Dental Packing)", cat: "Dental Consumable" },
//   { name: "Ribbon Gauze 1 inch", cat: "Dental Consumable" },
//   { name: "Dry Foil (Dental)", cat: "Dental Consumable" },

//   // ── SALINE & IV FLUIDS ─────────────────────────────────────────
//   { name: "Normal Saline 0.9% 100ml", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 250ml", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 500ml", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 1000ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 100ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 250ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 500ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 1000ml", cat: "IV Fluid" },
//   { name: "Dextrose 10% 500ml", cat: "IV Fluid" },
//   { name: "Dextrose 25% 100ml", cat: "IV Fluid" },
//   { name: "Dextrose 50% 50ml", cat: "IV Fluid" },
//   { name: "Ringer Lactate 500ml", cat: "IV Fluid" },
//   { name: "Ringer Lactate 1000ml", cat: "IV Fluid" },
//   { name: "DNS (Dextrose Normal Saline) 500ml", cat: "IV Fluid" },
//   { name: "DNS 1000ml", cat: "IV Fluid" },
//   { name: "Haemaccel 500ml Infusion", cat: "IV Fluid" },
//   { name: "Gelofusine 500ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 100ml", cat: "IV Fluid" },
//   { name: "Mannitol 20% 250ml", cat: "IV Fluid" },
//   { name: "Sodium Bicarbonate 7.5% 25ml", cat: "IV Electrolyte" },
//   { name: "Sodium Bicarbonate 8.4% 100ml", cat: "IV Electrolyte" },
//   { name: "Potassium Chloride 15% 10ml Ampoule", cat: "IV Electrolyte" },
//   { name: "Calcium Gluconate 10% 10ml Injection", cat: "IV Electrolyte" },
//   { name: "Magnesium Sulphate 50% 2ml Injection", cat: "IV Electrolyte" },

//   // ── NEEDLES ────────────────────────────────────────────────────
//   { name: "Disposable Syringe 1ml (Insulin Type)", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 2ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 5ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 10ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 20ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 50ml", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 18G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 20G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 22G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 24G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 26G", cat: "Needle/Syringe" },
//   { name: "Dental Needle 27G Short", cat: "Dental Needle" },
//   { name: "Dental Needle 27G Long", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Short", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Ultra Short", cat: "Dental Needle" },
//   { name: "Scalp Vein Set (Butterfly) 21G", cat: "IV Accessory" },
//   { name: "Scalp Vein Set (Butterfly) 23G", cat: "IV Accessory" },
//   { name: "Scalp Vein Set (Butterfly) 25G", cat: "IV Accessory" },
//   { name: "IV Cannula 14G (Orange)", cat: "IV Cannula" },
//   { name: "IV Cannula 16G (Grey)", cat: "IV Cannula" },
//   { name: "IV Cannula 18G (Green)", cat: "IV Cannula" },
//   { name: "IV Cannula 20G (Pink)", cat: "IV Cannula" },
//   { name: "IV Cannula 22G (Blue)", cat: "IV Cannula" },
//   { name: "IV Cannula 24G (Yellow) Paediatric", cat: "IV Cannula" },
//   { name: "Spinal Needle 25G (Quincke)", cat: "Spinal Needle" },
//   { name: "Spinal Needle 26G", cat: "Spinal Needle" },
//   { name: "Spinal Needle 27G", cat: "Spinal Needle" },
//   { name: "Epidural Needle 16G (Tuohy)", cat: "Epidural Needle" },
//   { name: "Epidural Needle 17G (Tuohy)", cat: "Epidural Needle" },

//   // ── INJECTIONS & AMPOULES ──────────────────────────────────────
//   {
//     name: "Lignocaine 2% with Adrenaline 1:80000 Cartridge (Dental)",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Lignocaine 2% with Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Lignocaine 2% Plain Cartridge (Dental)", cat: "Local Anaesthetic" },
//   {
//     name: "Articaine 4% with Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% with Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Mepivacaine 3% Plain Cartridge", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% with Adrenaline", cat: "Local Anaesthetic" },
//   { name: "Prilocaine 4% Plain Cartridge", cat: "Local Anaesthetic" },
//   {
//     name: "Benzocaine 20% Topical Gel (Dental)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Lidocaine 2% Topical Jelly", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lidocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine 2% Jelly 30g", cat: "Local Anaesthetic Topical" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 250mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 40mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 125mg Injection", cat: "Steroid Inj" },
//   { name: "Ketorolac 30mg Injection", cat: "NSAID Inj" },
//   { name: "Diclofenac 75mg Injection", cat: "NSAID Inj" },
//   { name: "Tramadol 50mg Injection", cat: "Painkiller Inj" },
//   { name: "Tramadol 100mg Injection", cat: "Painkiller Inj" },
//   { name: "Morphine 10mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pethidine 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Fentanyl 50mcg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Ondansetron 4mg Injection", cat: "Antiemetic Inj" },
//   { name: "Metoclopramide 10mg Injection", cat: "Antiemetic Inj" },
//   { name: "Promethazine 25mg Injection", cat: "Antiemetic Inj" },
//   { name: "Chlorpheniramine 10mg Injection", cat: "Antihistamine Inj" },
//   { name: "Pheniramine 22.75mg Injection", cat: "Antihistamine Inj" },
//   { name: "Midazolam 1mg/ml Injection", cat: "Sedative" },
//   { name: "Midazolam 5mg/ml Injection", cat: "Sedative" },
//   { name: "Diazepam 5mg Injection", cat: "Sedative" },
//   { name: "Propofol 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 200mg Injection", cat: "General Anaesthesia" },
//   { name: "Atropine 0.6mg Injection", cat: "Anticholinergic" },
//   { name: "Neostigmine 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Succinylcholine 100mg Injection", cat: "Muscle Relaxant" },
//   { name: "Vecuronium 4mg Injection", cat: "Muscle Relaxant" },
//   { name: "Atracurium 25mg Injection", cat: "Muscle Relaxant" },
//   { name: "Furosemide 20mg Injection", cat: "Diuretic Inj" },
//   { name: "Furosemide 40mg Injection", cat: "Diuretic Inj" },
//   { name: "Ranitidine 50mg Injection", cat: "Antacid Inj" },
//   { name: "Pantoprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Omeprazole 40mg Injection", cat: "Antacid Inj" },
//   {
//     name: "Phytomenadione (Vitamin K1) 10mg Injection",
//     cat: "Haemostatic Inj",
//   },
//   { name: "Tranexamic Acid 500mg Injection", cat: "Haemostatic Inj" },
//   { name: "Etamsylate 250mg Injection", cat: "Haemostatic Inj" },
//   { name: "Oxytocin 10 IU Injection", cat: "Haemostatic Inj" },
//   { name: "Dextrose 50% 50ml Push", cat: "Emergency Drug Inj" },
//   { name: "Naloxone 0.4mg Injection", cat: "Reversal Agent" },
//   { name: "Flumazenil 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Calcium Gluconate 1g Injection", cat: "Emergency Drug Inj" },

//   // ── SURGICAL INSTRUMENTS ───────────────────────────────────────
//   { name: "Scalpel Handle No. 3", cat: "Surgical Instrument" },
//   { name: "Scalpel Handle No. 4", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 11", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 12", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 15", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 22", cat: "Surgical Instrument" },
//   { name: "Surgical Scissors Straight (Mayo)", cat: "Surgical Instrument" },
//   { name: "Surgical Scissors Curved (Mayo)", cat: "Surgical Instrument" },
//   { name: "Metzenbaum Scissors", cat: "Surgical Instrument" },
//   { name: "Iris Scissors", cat: "Surgical Instrument" },
//   { name: "Dissecting Forceps (Toothed) Adson", cat: "Surgical Instrument" },
//   { name: "Dissecting Forceps (Non-Toothed)", cat: "Surgical Instrument" },
//   { name: "Haemostat (Mosquito Forceps) Straight", cat: "Surgical Instrument" },
//   { name: "Haemostat (Mosquito Forceps) Curved", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Kocher) Straight", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Kocher) Curved", cat: "Surgical Instrument" },
//   { name: "Needle Holder (Mayo-Hegar)", cat: "Surgical Instrument" },
//   { name: "Retractor (Langenbeck) Small", cat: "Surgical Instrument" },
//   { name: "Retractor (Langenbeck) Large", cat: "Surgical Instrument" },
//   { name: "Self-Retaining Retractor (Weitlaner)", cat: "Surgical Instrument" },
//   { name: "Bone Rongeur Forceps", cat: "Surgical Instrument" },
//   { name: "Curette Small", cat: "Surgical Instrument" },
//   { name: "Curette Large", cat: "Surgical Instrument" },
//   { name: "Periosteal Elevator (Molt No.9)", cat: "Dental Instrument" },
//   { name: "Periosteal Elevator (Freer)", cat: "Dental Instrument" },
//   { name: "Luxator (Periotome)", cat: "Dental Instrument" },
//   { name: "Dental Elevator (Straight)", cat: "Dental Instrument" },
//   { name: "Dental Elevator (Cryer)", cat: "Dental Instrument" },
//   { name: "Dental Elevator (Warwick James)", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Anteriors", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Premolars", cat: "Dental Instrument" },
//   {
//     name: "Extraction Forceps Upper Molars (Cowhorn)",
//     cat: "Dental Instrument",
//   },
//   { name: "Extraction Forceps Lower Anteriors", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Molars", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Wisdom", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Wisdom", cat: "Dental Instrument" },
//   { name: "Bone File (Dental)", cat: "Dental Instrument" },
//   { name: "Bone Chisel (Dental)", cat: "Dental Instrument" },
//   { name: "Mallet (Surgical)", cat: "Dental Instrument" },
//   { name: "Rongeur Forceps (Dental)", cat: "Dental Instrument" },
//   { name: "Tissue Scissors (Dental)", cat: "Dental Instrument" },
//   { name: "Tongue Retractor", cat: "Dental Instrument" },
//   { name: "Cheek Retractor (Minnesota)", cat: "Dental Instrument" },
//   { name: "Austin/Channel Retractor", cat: "Dental Instrument" },
//   { name: "Dental Mirror No. 5", cat: "Dental Instrument" },
//   { name: "Dental Probe (CPI/UNC-15)", cat: "Dental Instrument" },
//   { name: "Dental Tweezers (College Pliers)", cat: "Dental Instrument" },
//   { name: "Dental Excavator Double Ended", cat: "Dental Instrument" },
//   { name: "Spoon Excavator Small", cat: "Dental Instrument" },
//   { name: "Spoon Excavator Medium", cat: "Dental Instrument" },
//   { name: "Amalgam Plugger", cat: "Dental Instrument" },
//   { name: "Composite Placement Instrument", cat: "Dental Instrument" },
//   { name: "Burnisher Ball", cat: "Dental Instrument" },
//   { name: "Burnisher Acorn", cat: "Dental Instrument" },
//   { name: "Sickle Scaler (H6/H7)", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 1/2", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 7/8", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 11/12", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 13/14", cat: "Periodontal Instrument" },
//   { name: "Columbia Curette", cat: "Periodontal Instrument" },
//   { name: "Hoe Scaler", cat: "Periodontal Instrument" },
//   { name: "File Scaler", cat: "Periodontal Instrument" },
//   { name: "Ultrasonic Scaler Tip (Slim)", cat: "Periodontal Instrument" },
//   { name: "Ultrasonic Scaler Tip (Universal)", cat: "Periodontal Instrument" },

//   // ── SUTURES ─────────────────────────────────────────────────────
//   { name: "Vicryl 3-0 (Polyglactin) Absorbable", cat: "Suture" },
//   { name: "Vicryl 4-0 Absorbable", cat: "Suture" },
//   { name: "Vicryl 5-0 Absorbable", cat: "Suture" },
//   { name: "Catgut Plain 2-0", cat: "Suture" },
//   { name: "Catgut Plain 3-0", cat: "Suture" },
//   { name: "Catgut Chromic 2-0", cat: "Suture" },
//   { name: "Catgut Chromic 3-0", cat: "Suture" },
//   { name: "Catgut Chromic 4-0", cat: "Suture" },
//   { name: "Silk 2-0 Non-Absorbable", cat: "Suture" },
//   { name: "Silk 3-0 Non-Absorbable (Dental)", cat: "Suture" },
//   { name: "Silk 4-0 Non-Absorbable", cat: "Suture" },
//   { name: "Prolene 4-0 (Polypropylene)", cat: "Suture" },
//   { name: "Prolene 5-0", cat: "Suture" },
//   { name: "Prolene 6-0", cat: "Suture" },
//   { name: "Nylon 3-0 Monofilament", cat: "Suture" },
//   { name: "Nylon 4-0 Monofilament", cat: "Suture" },
//   { name: "Nylon 5-0 Monofilament", cat: "Suture" },
//   { name: "PDS II 3-0 (Polydioxanone)", cat: "Suture" },
//   { name: "PDS II 4-0", cat: "Suture" },
//   { name: "Monocryl 4-0 (Poliglecaprone)", cat: "Suture" },
//   { name: "Monocryl 5-0", cat: "Suture" },
//   { name: "Ethibond 0 (Polyester)", cat: "Suture" },
//   { name: "Ethibond 2-0", cat: "Suture" },
//   { name: "Stapler (Skin Staples)", cat: "Surgical Closure" },
//   { name: "Steri-Strip Wound Closure 6mm", cat: "Surgical Closure" },
//   { name: "Steri-Strip Wound Closure 12mm", cat: "Surgical Closure" },
//   { name: "Tissue Glue (Dermabond/Histoacryl)", cat: "Surgical Closure" },

//   // ── IV DRIP ACCESSORIES ────────────────────────────────────────
//   { name: "IV Infusion Set (Standard)", cat: "IV Accessory" },
//   { name: "IV Infusion Set (Burette 100ml Paediatric)", cat: "IV Accessory" },
//   { name: "Blood Transfusion Set", cat: "IV Accessory" },
//   { name: "Extension Tubing (IV Line)", cat: "IV Accessory" },
//   { name: "Three-Way Stopcock", cat: "IV Accessory" },
//   { name: "Tegaderm IV Dressing 6x7cm", cat: "IV Accessory" },
//   { name: "Transparent Dressing IV Site", cat: "IV Accessory" },
//   { name: "IV Arm Board (Splint)", cat: "IV Accessory" },
//   { name: "Normal Saline Flush 10ml Pre-filled", cat: "IV Accessory" },
//   { name: "Heparin Flush 10 IU/ml", cat: "IV Accessory" },

//   // ── DRESSINGS & WOUND CARE ─────────────────────────────────────
//   { name: "Adhesive Plaster Roll 1 inch", cat: "Wound Care" },
//   { name: "Adhesive Plaster Roll 2 inch", cat: "Wound Care" },
//   { name: "Band-Aid Fabric 1 inch", cat: "Wound Care" },
//   { name: "Crepe Bandage 4 inch", cat: "Bandage" },
//   { name: "Crepe Bandage 6 inch", cat: "Bandage" },
//   { name: "Crepe Bandage 8 inch", cat: "Bandage" },
//   { name: "Elastic Adhesive Bandage 4 inch", cat: "Bandage" },
//   { name: "Cotton Bandage 4 inch", cat: "Bandage" },
//   { name: "Plaster of Paris (POP) Bandage 4 inch", cat: "Bandage" },
//   { name: "Plaster of Paris Bandage 6 inch", cat: "Bandage" },
//   { name: "Zinc Oxide Adhesive Plaster 1 inch", cat: "Wound Care" },
//   { name: "Wound Dressing Large (10x10)", cat: "Dressing" },
//   { name: "Wound Dressing Medium (7.5x7.5)", cat: "Dressing" },
//   { name: "Hydrocolloid Dressing", cat: "Wound Care" },
//   { name: "Foam Dressing", cat: "Wound Care" },
//   { name: "Silver Sulfadiazine 1% Cream (Burns)", cat: "Burns Dressing" },
//   { name: "Bactigras (Chlorhexidine Tulle)", cat: "Dressing" },

//   // ── ANTISEPTICS & DISINFECTANTS ────────────────────────────────
//   { name: "Povidone Iodine 5% Solution (Betadine)", cat: "Antiseptic" },
//   { name: "Povidone Iodine 10% Solution", cat: "Antiseptic" },
//   { name: "Povidone Iodine Surgical Scrub", cat: "Antiseptic" },
//   { name: "Chlorhexidine Gluconate 2% Solution", cat: "Antiseptic" },
//   { name: "Chlorhexidine Gluconate 4% Surgical Scrub", cat: "Antiseptic" },
//   { name: "Chlorhexidine 0.2% Mouthwash (Dental)", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Antiseptic" },
//   {
//     name: "Hydrogen Peroxide 6% (Dental Irrigation)",
//     cat: "Dental Antiseptic",
//   },
//   { name: "Isopropyl Alcohol 70% (Spirit Swabs)", cat: "Antiseptic" },
//   { name: "Alcohol Swabs (Pre-injection)", cat: "Antiseptic" },
//   { name: "Cetrimide + Chlorhexidine Solution", cat: "Antiseptic" },
//   { name: "Sodium Hypochlorite 2.5% (NaOCl - Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% (NaOCl)", cat: "Endodontic" },
//   { name: "EDTA Solution 17% (Root Canal)", cat: "Endodontic" },
//   { name: "EDTA Gel (RC Prep)", cat: "Endodontic" },
//   { name: "Saline Irrigation Solution 500ml", cat: "IV Fluid" },
//   { name: "Saline Nasal Drops", cat: "Consumable" },
//   { name: "Savlon (Cetrimide + Chlorhexidine)", cat: "Antiseptic" },
//   { name: "Dettol Liquid Antiseptic", cat: "Antiseptic" },

//   // ── DENTAL MATERIALS (EXPANDED) ────────────────────────────────
//   { name: "Zinc Oxide Eugenol (ZOE) Cement Base", cat: "Dental Material" },
//   { name: "Zinc Oxide Eugenol Impression Paste", cat: "Dental Material" },
//   { name: "Zinc Phosphate Cement", cat: "Dental Material" },
//   { name: "Zinc Polycarboxylate Cement", cat: "Dental Material" },
//   { name: "Glass Ionomer Cement Type I (Luting)", cat: "Dental Material" },
//   {
//     name: "Glass Ionomer Cement Type II (Restorative)",
//     cat: "Dental Material",
//   },
//   { name: "Glass Ionomer Cement Type III (Lining)", cat: "Dental Material" },
//   { name: "RMGIC (Resin Modified GIC)", cat: "Dental Material" },
//   { name: "Composite Resin Shade A1", cat: "Dental Material" },
//   { name: "Composite Resin Shade A2", cat: "Dental Material" },
//   { name: "Composite Resin Shade A3", cat: "Dental Material" },
//   { name: "Composite Resin Shade A3.5", cat: "Dental Material" },
//   { name: "Composite Resin Shade B1", cat: "Dental Material" },
//   { name: "Flowable Composite Shade A2", cat: "Dental Material" },
//   { name: "Flowable Composite Shade A3", cat: "Dental Material" },
//   { name: "Bonding Agent (5th Generation)", cat: "Dental Material" },
//   { name: "Bonding Agent (7th Generation Self-Etch)", cat: "Dental Material" },
//   { name: "Acid Etchant 37% Phosphoric Acid Gel", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste (Pulp Capping)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Powder", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Cavity Liner (Dycal)", cat: "Dental Material" },
//   { name: "Temporary Restoration Material (Cavit)", cat: "Dental Material" },
//   { name: "IRM Temporary Cement", cat: "Dental Material" },
//   { name: "Zinc Oxide Temp Fill", cat: "Dental Material" },
//   { name: "Alginate Impression Material (Chromatic)", cat: "Dental Material" },
//   { name: "Irreversible Hydrocolloid (Alginate) 500g", cat: "Dental Material" },
//   {
//     name: "Polyvinyl Siloxane (PVS) Impression Light Body",
//     cat: "Dental Material",
//   },
//   { name: "PVS Impression Heavy Body", cat: "Dental Material" },
//   { name: "Polyether Impression Material", cat: "Dental Material" },
//   { name: "Zinc Oxide Impression Paste (ZO Paste)", cat: "Dental Material" },
//   { name: "Plaster of Paris Dental Grade", cat: "Dental Material" },
//   { name: "Type III Dental Stone", cat: "Dental Material" },
//   { name: "Type IV Dental Stone (Die Stone)", cat: "Dental Material" },
//   { name: "Dental Wax (Modelling Wax)", cat: "Dental Material" },
//   { name: "Baseplate Wax", cat: "Dental Material" },
//   { name: "Sticky Wax", cat: "Dental Material" },
//   { name: "Bite Registration Paste", cat: "Dental Material" },
//   { name: "Separating Liquid (Sodium Alginate)", cat: "Dental Material" },
//   { name: "Denture Base Resin (Heat Cure)", cat: "Dental Material" },
//   { name: "Denture Base Resin (Cold Cure)", cat: "Dental Material" },
//   { name: "Denture Repair Resin", cat: "Dental Material" },
//   { name: "Acrylic Teeth Set (Upper)", cat: "Dental Material" },
//   { name: "Acrylic Teeth Set (Lower)", cat: "Dental Material" },
//   { name: "Porcelain Teeth", cat: "Dental Material" },
//   { name: "Chromium Cobalt Alloy (Partial Denture)", cat: "Dental Material" },
//   { name: "Amalgam Alloy Capsules (Pre-dosed)", cat: "Dental Material" },
//   { name: "Mercury (Dental Grade)", cat: "Dental Material" },
//   { name: "Amalgam Capsule Activator", cat: "Dental Accessory" },
//   { name: "Light Cure Composite Bleaching Gel 35%", cat: "Dental Material" },
//   { name: "Carbamide Peroxide 10% (Home Bleaching)", cat: "Dental Material" },
//   { name: "Carbamide Peroxide 16%", cat: "Dental Material" },
//   { name: "Carbamide Peroxide 22%", cat: "Dental Material" },
//   {
//     name: "Hydrogen Peroxide 35% (In-office Bleaching)",
//     cat: "Dental Material",
//   },
//   { name: "Desensitising Agent (Gluma)", cat: "Dental Material" },
//   { name: "Fluoride Varnish 5% NaF (Duraphat)", cat: "Dental Fluoride" },
//   { name: "Fluoride Gel APF 1.23%", cat: "Fluoride Gel" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "Pit & Fissure Sealant (Light Cure)", cat: "Dental Material" },
//   { name: "Pit & Fissure Sealant (Self-Cure)", cat: "Dental Material" },
//   { name: "Crown & Bridge Temporary Cement", cat: "Dental Material" },
//   { name: "Permanent Crown Cement (Ketac Cem)", cat: "Dental Material" },
//   { name: "Resin Cement (Panavia F)", cat: "Dental Material" },
//   { name: "Post & Core Material", cat: "Dental Material" },
//   { name: "Fibre Post (Glass Fibre)", cat: "Dental Material" },
//   { name: "Gutta Percha Points ISO Size 15", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 20", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 25", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 30", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 35", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 40", cat: "Endodontic" },
//   { name: "Gutta Percha Points Standardised Large", cat: "Endodontic" },
//   { name: "Gutta Percha Points Accessory Fine", cat: "Endodontic" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Apexit Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Zinc Oxide Eugenol)", cat: "Endodontic" },
//   { name: "K-File ISO 15 (Root Canal File)", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 20", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 25", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 30", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 35", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 40", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 45", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 50", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 60", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 80", cat: "Endodontic Instrument" },
//   { name: "H-File (Hedstroem) ISO 20", cat: "Endodontic Instrument" },
//   { name: "H-File ISO 25", cat: "Endodontic Instrument" },
//   { name: "H-File ISO 30", cat: "Endodontic Instrument" },
//   { name: "Reamer ISO 15-40 Set", cat: "Endodontic Instrument" },
//   { name: "ProTaper Next Rotary File Set", cat: "Endodontic Instrument" },
//   {
//     name: "WaveOne Gold Primary (Reciprocating)",
//     cat: "Endodontic Instrument",
//   },
//   { name: "Reciproc Blue R25", cat: "Endodontic Instrument" },
//   { name: "Lentulo Spiral Filler", cat: "Endodontic Instrument" },
//   { name: "Plugger Spreader (Gutta Percha)", cat: "Endodontic Instrument" },
//   { name: "Barbed Broach Assorted", cat: "Endodontic Instrument" },
//   { name: "Paper Points ISO 20", cat: "Endodontic Accessory" },
//   { name: "Paper Points ISO 25", cat: "Endodontic Accessory" },
//   { name: "Paper Points ISO 30", cat: "Endodontic Accessory" },
//   { name: "Paper Points ISO 40", cat: "Endodontic Accessory" },
//   { name: "Paper Points Fine (Accessory)", cat: "Endodontic Accessory" },
//   { name: "Apex Locator Tips", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Sheet (Latex)", cat: "Dental Accessory" },
//   { name: "Rubber Dam Frame (Ostby)", cat: "Dental Accessory" },
//   { name: "Rubber Dam Clamp Kit", cat: "Dental Accessory" },
//   { name: "Rubber Dam Punch", cat: "Dental Accessory" },
//   { name: "Saliva Ejector Tips (Disposable)", cat: "Dental Accessory" },
//   { name: "High Volume Evacuation Tip (HVE)", cat: "Dental Accessory" },
//   { name: "Matrix Band (Tofflemire Universal)", cat: "Dental Accessory" },
//   { name: "Sectional Matrix System (Palodent)", cat: "Dental Accessory" },
//   { name: "Wooden Wedge Assorted", cat: "Dental Accessory" },
//   { name: "Interproximal Plastic Wedge", cat: "Dental Accessory" },
//   { name: "Celluloid Crown Form (Anterior)", cat: "Dental Accessory" },
//   {
//     name: "Stainless Steel Crown (Molar Paediatric)",
//     cat: "Paediatric Dental",
//   },
//   { name: "Stainless Steel Crown Kit", cat: "Paediatric Dental" },
//   { name: "Pulpotomy Agent (Formocresol)", cat: "Paediatric Dental" },
//   { name: "Pulpotomy Agent (Ferric Sulphate 15.5%)", cat: "Paediatric Dental" },
//   { name: "Zinc Oxide Eugenol Paediatric Filling", cat: "Paediatric Dental" },

//   // ── ORTHO MATERIALS ────────────────────────────────────────────
//   { name: "Orthodontic Bands (Molar) Upper", cat: "Dental Ortho" },
//   { name: "Orthodontic Bands (Molar) Lower", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Metal Roth)", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Ceramic)", cat: "Dental Ortho" },
//   { name: "Archwire NiTi Round 0.014", cat: "Dental Ortho" },
//   { name: "Archwire NiTi Round 0.016", cat: "Dental Ortho" },
//   { name: "Archwire NiTi Round 0.018", cat: "Dental Ortho" },
//   { name: "Archwire SS Rectangular 0.019x0.025", cat: "Dental Ortho" },
//   { name: "Archwire SS Rectangular 0.021x0.025", cat: "Dental Ortho" },
//   { name: "Ligature Wire (Stainless Steel)", cat: "Dental Ortho" },
//   { name: "Elastic Ligature Ties Assorted", cat: "Dental Ortho" },
//   { name: "Power Chain Elastic", cat: "Dental Ortho" },
//   { name: "Separating Elastics (Orthodontic)", cat: "Dental Ortho" },
//   { name: "Molar Tube (Buccal Tube)", cat: "Dental Ortho" },
//   { name: "Ortho Bracket Adhesive (Light Cure)", cat: "Dental Ortho" },
//   { name: "Band Cement (Glass Ionomer Ortho)", cat: "Dental Ortho" },
//   { name: "Debonding Pliers", cat: "Dental Ortho" },
//   { name: "Ligature Tying Pliers", cat: "Dental Ortho" },
//   { name: "How Pliers", cat: "Dental Ortho" },
//   { name: "Cinching Pliers", cat: "Dental Ortho" },
//   { name: "Wire Cutters (Distal End Cutter)", cat: "Dental Ortho" },
//   { name: "Invisalign Chewies (Aligner Seater)", cat: "Dental Ortho" },
//   { name: "Retainer (Hawley Plate)", cat: "Dental Ortho" },

//   // ── PPE & INFECTION CONTROL ────────────────────────────────────
//   { name: "Nitrile Gloves Small (Powder-Free)", cat: "PPE" },
//   { name: "Nitrile Gloves Medium (Powder-Free)", cat: "PPE" },
//   { name: "Nitrile Gloves Large (Powder-Free)", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 6.5", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 7", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 7.5", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 8", cat: "PPE" },
//   { name: "Examination Gloves (Vinyl) Medium", cat: "PPE" },
//   { name: "3-Ply Surgical Face Mask", cat: "PPE" },
//   { name: "N95 Respirator (NIOSH Approved)", cat: "PPE" },
//   { name: "Surgical Gown (Non-Woven Sterile)", cat: "PPE" },
//   { name: "Disposable Apron (Polythene)", cat: "PPE" },
//   { name: "Shoe Cover (Disposable)", cat: "PPE" },
//   { name: "Head Cover / Surgical Cap", cat: "PPE" },
//   { name: "Face Shield (Dental)", cat: "PPE" },
//   { name: "Safety Goggles", cat: "PPE" },
//   { name: "Bib (Dental Patient)", cat: "Dental Accessory" },
//   { name: "Bib Clips", cat: "Dental Accessory" },
//   { name: "Autoclave Pouches (Self-Seal)", cat: "PPE" },
//   { name: "Sharps Container 5L", cat: "Waste Disposal" },
//   { name: "Sharps Container 1L", cat: "Waste Disposal" },
//   { name: "Biomedical Waste Bag Yellow", cat: "Waste Disposal" },
//   { name: "Biomedical Waste Bag Red", cat: "Waste Disposal" },

//   // ── COMMON OTC / PRESCRIPTION TABLETS ─────────────────────────
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 250mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 100mg/5ml Syrup", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Diclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Aceclofenac + Paracetamol + Serratiopeptidase", cat: "NSAID Combo" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 120mg Tablet", cat: "NSAID" },
//   { name: "Celecoxib 100mg Capsule", cat: "NSAID" },
//   { name: "Celecoxib 200mg Capsule", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Capsule", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   {
//     name: "Trypsin + Chymotrypsin Tablet (Antiflam)",
//     cat: "Enzyme Combination",
//   },
//   { name: "Serratiopeptidase 10mg Tablet", cat: "Enzyme Combination" },
//   { name: "Serratiopeptidase 20mg Tablet", cat: "Enzyme Combination" },
//   { name: "Deflazacort 6mg Tablet", cat: "Steroid" },
//   { name: "Deflazacort 12mg Tablet", cat: "Steroid" },
//   { name: "Deflazacort 30mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 8mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 16mg Tablet", cat: "Steroid" },
//   { name: "Betamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Pantoprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Omeprazole 10mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 40mg Capsule", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 10mg Tablet", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Ranitidine 150mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ranitidine 300mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 4mg/5ml Syrup", cat: "Antiemetic" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Domperidone 1mg/ml Suspension", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Promethazine 10mg Tablet", cat: "Antiemetic / Antihistamine" },
//   { name: "Cetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 5mg/5ml Syrup", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 180mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 2.5mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 4mg Tablet", cat: "Antihistamine" },
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin C 1000mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B Complex + Zinc Capsule", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule", cat: "Vitamin" },
//   { name: "Vitamin D3 1000 IU Tablet", cat: "Vitamin" },
//   { name: "Vitamin E 400mg Capsule", cat: "Vitamin" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Calcium Carbonate 500mg Tablet", cat: "Calcium Supplement" },
//   { name: "Zinc Sulphate 20mg Tablet", cat: "Mineral Supplement" },
//   { name: "Ferrous Sulphate 200mg Tablet", cat: "Iron Supplement" },
//   { name: "Ferrous Ascorbate + Folic Acid Tablet", cat: "Iron Supplement" },

//   // ── TOPICAL MEDICATIONS ────────────────────────────────────────
//   {
//     name: "Triamcinolone Acetonide 0.1% Oral Paste (Kenacort)",
//     cat: "Steroid Topical",
//   },
//   { name: "Triamcinolone Acetonide 0.025% Cream", cat: "Steroid Topical" },
//   { name: "Betamethasone 0.05% Cream", cat: "Steroid Topical" },
//   { name: "Clotrimazole 1% Cream", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin Oral Suspension", cat: "Antifungal" },
//   { name: "Nystatin 100000 IU Tablet", cat: "Antifungal" },
//   { name: "Fluconazole 50mg Tablet", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Tablet", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Mupirocin 2% Ointment (Bactroban)", cat: "Topical Antibiotic" },
//   { name: "Neomycin + Bacitracin Ointment", cat: "Topical Antibiotic" },
//   { name: "Tetracycline 3% Ointment", cat: "Topical Antibiotic" },
//   { name: "Fusidic Acid 2% Cream", cat: "Topical Antibiotic" },
//   { name: "Lignocaine Viscous 2% Mouthwash", cat: "Local Anaesthetic Topical" },
//   {
//     name: "Magic Mouthwash (Lignocaine + Diphenhydramine + Antacid)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Amlexanox 5% Paste (Aphthous Ulcer)", cat: "Oral Care" },
//   { name: "Benzydamine 0.15% Mouthwash (Tantum Verde)", cat: "Oral Care" },
//   { name: "Glycerine + Thymol Mouthwash", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash (Hexetidine 0.1%)", cat: "Dental Antiseptic" },
//   { name: "Listerine Mouthwash (OTC)", cat: "Oral Care" },
//   { name: "Colgate Peroxyl Mouthwash", cat: "Oral Care" },
//   { name: "Orajel (Benzocaine 10%) Topical", cat: "Local Anaesthetic Topical" },
//   { name: "Ulcerex Gel (Choline Salicylate)", cat: "Oral Care" },
//   { name: "Dologel CT (Clove Oil Gel)", cat: "Oral Care" },
//   { name: "Clove Oil (Eugenol)", cat: "Dental Material" },

//   // ── DENTAL IMPLANT MATERIALS ───────────────────────────────────
//   { name: "Titanium Implant Fixture (3.3mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (3.5mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (4.0mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (4.5mm)", cat: "Dental Implant" },
//   { name: "Implant Cover Screw", cat: "Dental Implant" },
//   { name: "Implant Healing Abutment", cat: "Dental Implant" },
//   { name: "Implant Final Abutment", cat: "Dental Implant" },
//   { name: "Implant Impression Coping", cat: "Dental Implant" },
//   { name: "Bone Graft (Autograft)", cat: "Dental Surgical" },
//   { name: "Bone Graft (Xenograft - Bio-Oss)", cat: "Dental Surgical" },
//   { name: "Collagen Membrane (Bio-Gide)", cat: "Dental Surgical" },
//   { name: "PRF (Platelet Rich Fibrin) Kit", cat: "Dental Surgical" },
//   {
//     name: "Haemostatic Agent (Surgicel - Oxidised Cellulose)",
//     cat: "Haemostatic Surgical",
//   },
//   { name: "Haemostatic Foam (Gelfoam)", cat: "Haemostatic" },
//   { name: "Bone Wax", cat: "Haemostatic Surgical" },
//   { name: "Surgical Suction Tip (Frazier)", cat: "Dental Instrument" },

//   // ── LAB INVESTIGATIONS ─────────────────────────────────────────
//   { name: "CBC (Complete Blood Count)", cat: "Lab Test" },
//   { name: "RBS (Random Blood Sugar)", cat: "Lab Test" },
//   { name: "FBS (Fasting Blood Sugar)", cat: "Lab Test" },
//   { name: "HbA1c (Glycated Haemoglobin)", cat: "Lab Test" },
//   { name: "Blood Group & Rh Typing", cat: "Lab Test" },
//   { name: "BT (Bleeding Time) & CT (Clotting Time)", cat: "Lab Test" },
//   { name: "PT/INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "APTT (Activated Partial Thromboplastin Time)", cat: "Lab Test" },
//   { name: "LFT (Liver Function Test)", cat: "Lab Test" },
//   { name: "KFT (Kidney Function Test)", cat: "Lab Test" },
//   { name: "Serum Creatinine", cat: "Lab Test" },
//   { name: "Urine Routine Examination", cat: "Lab Test" },
//   { name: "HBsAg (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HIV (ELISA)", cat: "Lab Test" },
//   { name: "VDRL (Syphilis Test)", cat: "Lab Test" },
//   { name: "Dental Radiograph (IOPA X-ray)", cat: "Dental Investigation" },
//   { name: "Orthopantomogram (OPG) X-ray", cat: "Dental Investigation" },
//   { name: "Lateral Cephalogram X-ray", cat: "Dental Investigation" },
//   {
//     name: "Occlusal X-ray (Maxillary/Mandibular)",
//     cat: "Dental Investigation",
//   },
//   { name: "Bitewing Radiograph", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Dental 3D)", cat: "Dental Investigation" },

//   // ── COMMON BRAND NAMES (INDIA) ─────────────────────────────────
//   {
//     name: "Augmentin 625mg Tablet (Amoxicillin+Clavulanate)",
//     cat: "Antibiotic",
//   },
//   { name: "Azithral 500mg Tablet (Azithromycin)", cat: "Antibiotic" },
//   { name: "Cifran 500mg Tablet (Ciprofloxacin)", cat: "Antibiotic" },
//   { name: "Flagyl 400mg Tablet (Metronidazole)", cat: "Antibiotic" },
//   { name: "Doxy 100mg Capsule (Doxycycline)", cat: "Antibiotic" },
//   { name: "Calpol 650mg Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Dolo 650 Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Combiflam Tablet (Ibuprofen+Paracetamol)", cat: "NSAID Combo" },
//   { name: "Voveran 50mg Tablet (Diclofenac)", cat: "NSAID" },
//   { name: "Brufen 400mg Tablet (Ibuprofen)", cat: "NSAID" },
//   { name: "Ultracet Tablet (Tramadol+Paracetamol)", cat: "Analgesic Combo" },
//   { name: "Pan 40mg Tablet (Pantoprazole)", cat: "Antacid / PPI" },
//   { name: "Omez 20mg Capsule (Omeprazole)", cat: "Antacid / PPI" },
//   { name: "Ondem 4mg Tablet (Ondansetron)", cat: "Antiemetic" },
//   { name: "Stemetil 5mg Tablet (Prochlorperazine)", cat: "Antiemetic" },
//   { name: "Sinarest Tablet (Paracetamol+Phenylephrine)", cat: "Antihistamine" },
//   { name: "Allegra 120mg Tablet (Fexofenadine)", cat: "Antihistamine" },
//   {
//     name: "Montair-LC Tablet (Montelukast+Levocetirizine)",
//     cat: "Antihistamine",
//   },
//   { name: "Calpol Syrup (Paracetamol 120mg)", cat: "Painkiller" },
//   {
//     name: "Pyrimon Syrup (Mefenamic+Paracetamol Paediatric)",
//     cat: "Painkiller",
//   },
//   { name: "Perinorm 10mg Tablet (Metoclopramide)", cat: "Antiemetic" },
//   { name: "Rantac 150mg Tablet (Ranitidine)", cat: "Antacid / H2 Blocker" },
//   { name: "Kenacort Oral Paste (Triamcinolone)", cat: "Steroid Topical" },
//   { name: "Kenalog Injection 40mg (Triamcinolone)", cat: "Steroid Inj" },
//   { name: "Depo-Medrol 40mg Injection", cat: "Steroid Inj" },
//   { name: "Betnesol 0.5mg Tablet (Betamethasone)", cat: "Steroid" },
//   { name: "Wysolone 5mg Tablet (Prednisolone)", cat: "Steroid" },
//   { name: "Defcort 6mg Tablet (Deflazacort)", cat: "Steroid" },
//   { name: "Dexona 0.5mg Tablet (Dexamethasone)", cat: "Steroid" },
//   { name: "Mox 500mg Capsule (Amoxicillin)", cat: "Antibiotic" },
//   { name: "Sporanox 100mg Capsule (Itraconazole)", cat: "Antifungal" },
//   { name: "Zovirax 400mg Tablet (Acyclovir)", cat: "Antiviral" },
//   { name: "Valcivir 500mg Tablet (Valacyclovir)", cat: "Antiviral" },
//   { name: "Neosporin Powder (Neomycin+Bacitracin)", cat: "Topical Antibiotic" },
//   { name: "Betadine Ointment 5%", cat: "Antiseptic Topical" },
//   { name: "Borax Glycerine (Oral Ulcer)", cat: "Oral Care" },
//   { name: "Tantum Verde Mouthwash (Benzydamine)", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Recaldent (CPP-ACP Paste)", cat: "Dental Fluoride" },
//   { name: "Tooth Mousse Plus (GC)", cat: "Dental Fluoride" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Sensodyne Repair & Protect", cat: "Dental Brand" },
//   { name: "Colgate Sensitive Pro-Relief", cat: "Dental Brand" },
//   { name: "Pepsodent Germicheck", cat: "Dental Brand" },
//   { name: "Oral-B Toothbrush Indicator", cat: "Dental Brand" },
//   { name: "GUM Soft-Picks Interdental", cat: "Dental Brand" },
//   { name: "Floss (Oral-B Satin)", cat: "Dental Brand" },
//   { name: "Water Flosser", cat: "Dental Brand" },
//   { name: "Tongue Cleaner (Metal)", cat: "Dental Brand" },
//   { name: "Mouth Guard (Bruxism)", cat: "Dental Brand" },
// ];

// // ── Save a custom medicine — receives apiPost function from component
// // apiPost is api.post from api.js — same URL, same token, guaranteed correct
// function saveCustomMed(name, apiPost) {
//   if (!name || name.trim().length < 3) return Promise.resolve(null);
//   // Must contain at least one letter
//   if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
//   // Skip if already in built-in DB
//   const nameLow = name.trim().toLowerCase();
//   const already = MEDICINE_DB.some((m) => m.name.toLowerCase() === nameLow);
//   if (already) return Promise.resolve(null);
//   // Use api.post — same function used everywhere in this app
//   return apiPost("/custommeds", { name: name.trim(), cat: "Custom" })
//     .then((saved) => saved || null)
//     .catch(() => null);
// }

// // ── Google-style multi-word search — uses combined DB + custom meds from state
// // customMeds is passed in from component state (fetched from backend)
// function googleSearch(query, customMeds = []) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   if (!words.length) return [];

//   // Filter out any malformed entries (no name field)
//   const safeMeds = Array.isArray(customMeds)
//     ? customMeds.filter(
//         (m) => m && typeof m.name === "string" && m.name.trim().length > 0,
//       )
//     : [];

//   const combined = [
//     ...MEDICINE_DB,
//     ...safeMeds.map((m) => ({ ...m, _custom: true })),
//   ];

//   const scored = combined
//     .map((m) => {
//       // Guard against undefined name (safety check)
//       if (!m || typeof m.name !== "string") return { m, score: 0 };
//       const nameLow = m.name.toLowerCase();
//       const catLow = (m.cat || "").toLowerCase();
//       let score = 0;
//       for (const w of words) {
//         if (nameLow.startsWith(w)) score += 5;
//         else if (nameLow.includes(w)) score += 3;
//         else if (catLow.includes(w)) score += 1;
//       }
//       // Boost custom medicines so doctor's own entries appear first
//       if (m._custom) score += 2;
//       return { m, score };
//     })
//     .filter((x) => x.score > 0)
//     .sort((a, b) => b.score - a.score)
//     .map((x) => x.m);

//   return scored.slice(0, 12);
// }

// function highlightWords(text, query) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   let result = text;
//   words.forEach((w) => {
//     const re = new RegExp(
//       "(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
//       "gi",
//     );
//     result = result.replace(re, "<b>$1</b>");
//   });
//   return result;
// }

// // ── MedAutocomplete — Google-style medicine search ───────────
// function MedAutocomplete({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const taRef = React.useRef(null);
//   const wrapperRef = React.useRef(null);
//   const [suggestions, setSuggestions] = React.useState([]);
//   const [activeIdx, setActiveIdx] = React.useState(-1);
//   const [currentQuery, setCurrentQuery] = React.useState("");
//   const queryStartRef = React.useRef(0);
//   const queryEndRef = React.useRef(0);

//   const hideSuggestions = () => {
//     setSuggestions([]);
//     setActiveIdx(-1);
//     setCurrentQuery("");
//   };

//   // Single onChange handler — no onInput conflict
//   const handleChange = (e) => {
//     const ta = e.target;
//     const val = ta.value;
//     const cursor = ta.selectionStart;
//     onChange(val);

//     // Find start of current line/word being typed
//     let lineStart = cursor - 1;
//     while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
//     lineStart++;

//     const query = val.substring(lineStart, cursor);
//     queryStartRef.current = lineStart;
//     queryEndRef.current = cursor;

//     if (query.trim().length < 2) {
//       hideSuggestions();
//       return;
//     }
//     const matches = googleSearch(query, customMeds);
//     if (!matches.length) {
//       hideSuggestions();
//       return;
//     }
//     setCurrentQuery(query);
//     setSuggestions(matches);
//     setActiveIdx(-1);
//   };

//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       suggestions[activeIdx]
//     ) {
//       e.preventDefault();
//       selectMed(suggestions[activeIdx].name);
//     } else if (e.key === "Escape") {
//       hideSuggestions();
//     }
//   };

//   const selectMed = (name) => {
//     const ta = taRef.current;
//     const val = ta.value;
//     const before = val.substring(0, queryStartRef.current);
//     const after = val.substring(queryEndRef.current);
//     const newVal = before + name + after;
//     onChange(newVal);
//     hideSuggestions();
//     // Save to backend using api.post — correct URL guaranteed
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     // Restore cursor position after React re-render
//     setTimeout(() => {
//       if (taRef.current) {
//         const nc = queryStartRef.current + name.length;
//         taRef.current.setSelectionRange(nc, nc);
//         taRef.current.focus();
//         queryEndRef.current = nc;
//       }
//     }, 0);
//   };

//   // On blur — save full meaningful lines typed by doctor as custom medicines
//   const handleBlur = () => {
//     if (!taRef.current) return;
//     const val = taRef.current.value;
//     // Save lines that look like medicine names (>=3 chars, has a letter, not pure numbers)
//     val.split("\n").forEach((line) => {
//       const trimmed = line.trim();
//       if (
//         trimmed.length >= 3 &&
//         /[a-zA-Z]/.test(trimmed) &&
//         !/^[0-9\s]+$/.test(trimmed)
//       ) {
//         saveCustomMed(trimmed, apiPost).then((saved) => {
//           if (saved && onCustomSaved) onCustomSaved(saved);
//         });
//       }
//     });
//   };

//   // Click-outside handler using wrapperRef (not fixed id)
//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
//         hideSuggestions();
//       }
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   return (
//     <>
//       <style>{`
//         .med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}
//         .med-suggestion-item:last-child{border-bottom:none;}
//         .med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}
//         .med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}
//         .med-sug-name{font-weight:500;flex:1;color:#1a1614;}
//         .med-sug-name b{color:#0d7377;font-weight:700;}
//         .med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}
//       `}</style>
//       <div style={{ position: "relative" }} ref={wrapperRef}>
//         <textarea
//           ref={taRef}
//           value={value}
//           onChange={handleChange}
//           onKeyDown={handleKeyDown}
//           onBlur={handleBlur}
//           autoComplete="off"
//           placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
//         />
//         {suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderTop: "none",
//               borderRadius: "0 0 12px 12px",
//               boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
//               zIndex: 99999,
//               maxHeight: 280,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {suggestions.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 className={
//                   "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
//                 }
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   selectMed(m.name);
//                 }}
//               >
//                 <span className="med-sug-icon">💊</span>
//                 <span
//                   className="med-sug-name"
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, currentQuery),
//                   }}
//                 />
//                 <span className="med-sug-cat">{m.cat}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── Prescription Modal — exact original PDF design ────────────
// function PrescriptionModal({ visit, patient, doctor, onClose, showNotify }) {
//   const [pdfUrl, setPdfUrl] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [pdfBlob, setPdfBlob] = useState(null);
//   const [rxMobile, setRxMobile] = useState("");
//   const [fileName, setFileName] = useState("");
//   const [canNativeShare, setCanNativeShare] = useState(false);

//   useEffect(() => {
//     generatePDF();
//   }, []);

//   // Close on Escape
//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     document.addEventListener("keydown", handler);
//     return () => document.removeEventListener("keydown", handler);
//   }, [onClose]);

//   const fmtDateLocal = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr + "T00:00:00");
//     return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
//   };

//   const fmtTimeLocal = (t) => {
//     if (!t) return "";
//     const parts = t.split(":");
//     const hh = parseInt(parts[0]),
//       mm = parts[1];
//     return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
//   };

//   const generatePDF = () => {
//     if (window.jspdf) {
//       buildPDF();
//       return;
//     }
//     const existing = document.getElementById("jspdf-cdn");
//     if (existing) {
//       existing.addEventListener("load", buildPDF);
//       return;
//     }
//     const script = document.createElement("script");
//     script.id = "jspdf-cdn";
//     script.src =
//       "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
//     script.crossOrigin = "anonymous";
//     script.onload = buildPDF;
//     script.onerror = () => setLoading(false);
//     document.head.appendChild(script);
//   };

//   const buildPDF = () => {
//     const { jsPDF } = window.jspdf;
//     const pdf = new jsPDF({
//       unit: "mm",
//       format: "a4",
//       orientation: "portrait",
//     });
//     const W = 210,
//       H = 297;

//     const sf = (c) => pdf.setFillColor(c[0], c[1], c[2]);
//     const sd = (c) => pdf.setDrawColor(c[0], c[1], c[2]);
//     const st = (c) => pdf.setTextColor(c[0], c[1], c[2]);

//     const NAVY = [8, 25, 65],
//       BLUE = [20, 80, 160],
//       BLUE2 = [40, 110, 190];
//     const LBLUE = [210, 228, 248],
//       LBLUE2 = [232, 242, 252],
//       MIDBLUE = [160, 195, 235];
//     const TEAL = [0, 130, 130],
//       TEAL2 = [210, 240, 240];
//     const WHITE = [255, 255, 255],
//       LGRAY = [245, 247, 251],
//       LGRAY2 = [250, 251, 254],
//       LGRAY3 = [240, 243, 248];
//     const GRAY = [115, 118, 130],
//       GRAY2 = [75, 80, 95];
//     const GOLD = [170, 130, 40],
//       GOLD2 = [250, 245, 225];

//     const today = new Date();
//     const todayFmt =
//       today.getDate() +
//       " " +
//       MONTHS[today.getMonth()] +
//       " " +
//       today.getFullYear();
//     const rxNum =
//       "PS-" +
//       today.getFullYear() +
//       ("0" + (today.getMonth() + 1)).slice(-2) +
//       ("0" + today.getDate()).slice(-2) +
//       "-" +
//       Math.floor(1000 + Math.random() * 8999);

//     const visitDate = visit.visitDate || "";
//     const visitTime = visit.visitTime || "";
//     const notes = visit.notes || "";
//     const nextDate = visit.nextVisitDate || "";
//     const service = visit.service || "";
//     const doc = { name: doctor?.name || "Doctor", qual: "", reg: "" };

//     const visitDateFmt = fmtDateLocal(visitDate);
//     const visitTimeFmt = fmtTimeLocal(visitTime);
//     const nextDateFmt = fmtDateLocal(nextDate);

//     // ── Outer border ─────────────────────────────────────────────
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.8);
//     pdf.rect(3.5, 3.5, W - 7, H - 7, "S");
//     sd(LBLUE);
//     pdf.setLineWidth(0.3);
//     pdf.rect(5.5, 5.5, W - 11, H - 11, "S");

//     // ── Header ───────────────────────────────────────────────────
//     sf(NAVY);
//     pdf.rect(3.5, 3.5, W - 7, 46, "F");
//     sf(BLUE);
//     pdf.rect(3.5, 43, W - 7, 10, "F");
//     sf(LBLUE);
//     pdf.rect(3.5, 53, W - 7, 6, "F");

//     st(WHITE);
//     pdf.setFontSize(18);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(doc.name, 14, 19);
//     st(LBLUE);
//     pdf.setFontSize(8);
//     pdf.setFont("helvetica", "normal");
//     pdf.text((doc.qual || "").toUpperCase(), 14, 26);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(14, 28.5, W - 40, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(7);
//     pdf.text("Reg. No.:  " + (doc.reg || "—"), 14, 33.5);
//     pdf.text("Specialisation:  Dental & Oral Health Care", 14, 38.5);

//     st(WHITE);
//     pdf.setFontSize(15);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PEARLSMILE", W - 10, 19, { align: "right" });
//     st(LBLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("DENTAL HOSPITAL", W - 10, 25.5, { align: "right" });
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(W - 72, 28.5, W - 10, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(6.8);
//     pdf.text("12, Dental Plaza, MG Road, Pune - 411001", W - 10, 33.5, {
//       align: "right",
//     });
//     pdf.text("+91 87936 08083  |  care@pearlsmiledental.in", W - 10, 38.5, {
//       align: "right",
//     });

//     st(WHITE);
//     pdf.setFontSize(9);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("DIGITAL PRESCRIPTION", W / 2, 50, { align: "center" });
//     st(LBLUE2);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 10, 50);
//     pdf.text("Date: " + todayFmt, W - 10, 50, { align: "right" });

//     st(BLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PATIENT INFORMATION", W / 2, 57, { align: "center" });

//     // ── Patient info table ────────────────────────────────────────
//     const infoTop = 61;
//     sf(LGRAY3);
//     pdf.rect(10, infoTop, W - 20, 44, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, infoTop, W - 20, 44, "S");
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.2);
//     pdf.line(W / 2, infoTop, W / 2, infoTop + 44);
//     let rdy = infoTop + 11;
//     for (let ri = 0; ri < 3; ri++) {
//       pdf.line(10, rdy, W - 10, rdy);
//       rdy += 11;
//     }

//     const drawCell = (label, value, x, y, maxW) => {
//       st(GRAY2);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.8);
//       pdf.text(label, x + 3, y + 4);
//       st(NAVY);
//       pdf.setFont("helvetica", "normal");
//       pdf.setFontSize(8.5);
//       const val = pdf.splitTextToSize(String(value || "—"), maxW || 75);
//       pdf.text(val[0], x + 3, y + 9.5);
//     };
//     const cHalf = W / 2;
//     drawCell("PATIENT NAME", patient.name || "—", 10, infoTop, cHalf - 16);
//     drawCell("MOBILE", patient.mobile || "—", cHalf, infoTop, cHalf - 16);
//     drawCell("EMAIL", patient.email || "—", 10, infoTop + 11, cHalf - 16);
//     drawCell(
//       "BLOOD GROUP",
//       patient.blood || "—",
//       cHalf,
//       infoTop + 11,
//       cHalf - 16,
//     );
//     drawCell(
//       "AGE / GENDER",
//       (patient.age || "—") + (patient.gender ? "  |  " + patient.gender : ""),
//       10,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell(
//       "VISIT DATE",
//       visitDateFmt + (visitTimeFmt ? " (" + visitTimeFmt + ")" : ""),
//       cHalf,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell("SERVICE/TREATMENT", service || "—", 10, infoTop + 33, cHalf - 16);
//     drawCell(
//       "NEXT VISIT DATE",
//       nextDateFmt || "—",
//       cHalf,
//       infoTop + 33,
//       cHalf - 16,
//     );

//     // ── Clinical Notes ────────────────────────────────────────────
//     const diagTop = infoTop + 50;
//     sf(BLUE);
//     pdf.rect(10, diagTop, W - 20, 8, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(8.5);
//     pdf.text(
//       "Rx   CLINICAL NOTES / DIAGNOSIS & PRESCRIPTION",
//       14,
//       diagTop + 5.5,
//     );
//     st(GOLD);
//     pdf.setFontSize(10);
//     pdf.text("Rx", W - 16, diagTop + 5.5, { align: "right" });

//     const notesBoxH = 56;
//     sf(LGRAY2);
//     pdf.rect(10, diagTop + 8, W - 20, notesBoxH, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, diagTop + 8, W - 20, notesBoxH, "S");
//     sd([215, 225, 240]);
//     pdf.setLineWidth(0.15);
//     for (let rl = 0; rl < 7; rl++)
//       pdf.line(14, diagTop + 16 + rl * 7, W - 14, diagTop + 16 + rl * 7);
//     st(NAVY);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(9.5);
//     const noteLines = pdf.splitTextToSize(
//       notes || "No diagnosis or notes recorded for this visit.",
//       W - 30,
//     );
//     pdf.text(noteLines, 14, diagTop + 15);

//     // ── Next appointment box ──────────────────────────────────────
//     let afterY = diagTop + notesBoxH + 10;
//     if (nextDateFmt) {
//       sf(TEAL2);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "F");
//       sd(TEAL);
//       pdf.setLineWidth(0.4);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "S");
//       sf(TEAL);
//       pdf.roundedRect(10, afterY, 10, 13, 2, 2, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.5);
//       pdf.text("NEXT", 11.2, afterY + 5.5);
//       pdf.text("VISIT", 11.0, afterY + 10);
//       st(TEAL);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(9);
//       pdf.text("Next Appointment:", 24, afterY + 6.5);
//       st(NAVY);
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "bold");
//       pdf.text(nextDateFmt, 72, afterY + 6.5);
//       st(GRAY);
//       pdf.setFontSize(7);
//       pdf.setFont("helvetica", "italic");
//       pdf.text(
//         "Please arrive 10 minutes early and bring this prescription.",
//         24,
//         afterY + 11,
//       );
//       afterY += 19;
//     }

//     // ── General advice box ────────────────────────────────────────
//     const advY = afterY + 4;
//     sf(GOLD2);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "F");
//     sd(GOLD);
//     pdf.setLineWidth(0.35);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "S");
//     sf(GOLD);
//     pdf.roundedRect(10, advY, 10, 20, 2, 2, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(6.2);
//     pdf.text("GEN.", 11.2, advY + 8);
//     pdf.text("ADV.", 11.2, advY + 13.5);
//     st(GOLD);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("General Advice:", 24, advY + 6.5);
//     st(GRAY2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(
//       "1.  Follow all prescribed medicines on time and complete the full course.",
//       24,
//       advY + 11.5,
//     );
//     pdf.text(
//       "2.  Maintain good oral hygiene. Brush gently twice daily.",
//       24,
//       advY + 15.5,
//     );
//     pdf.text(
//       "3.  Avoid very hot, cold, or hard foods until fully healed.",
//       24,
//       advY + 19.2,
//     );

//     // ── Watermark ─────────────────────────────────────────────────
//     pdf.saveGraphicsState();
//     pdf.setGState(new pdf.GState({ opacity: 0.035 }));
//     st(NAVY);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(44);
//     pdf.text("PEARLSMILE", W / 2, H / 2 - 5, { align: "center", angle: 35 });
//     pdf.restoreGraphicsState();

//     // ── Doctor seal ───────────────────────────────────────────────
//     const sigY = Math.max(advY + 28, H - 55);
//     const INK = [28, 52, 140],
//       INK2 = [45, 75, 170];
//     const cx = W - 46,
//       cy = sigY + 13,
//       R = 18;

//     sd(INK);
//     pdf.setLineWidth(1.2);
//     pdf.circle(cx, cy, R, "S");
//     pdf.setLineWidth(0.4);
//     pdf.circle(cx, cy, R - 2.5, "S");

//     const drawStar = (sx, sy, sr) => {
//       const pts = [];
//       for (let si = 0; si < 5; si++) {
//         const ao = (si * 4 * Math.PI) / 5 - Math.PI / 2,
//           ai = ao + (2 * Math.PI) / 5;
//         pts.push({ x: sx + sr * Math.cos(ao), y: sy + sr * Math.sin(ao) });
//         pts.push({
//           x: sx + sr * 0.4 * Math.cos(ai),
//           y: sy + sr * 0.4 * Math.sin(ai),
//         });
//       }
//       pdf.setLineWidth(0.3);
//       sd(INK);
//       sf(INK);
//       pdf.lines(
//         pts.slice(1).map((pt, i) => [pt.x - pts[i].x, pt.y - pts[i].y]),
//         pts[0].x,
//         pts[0].y,
//         [1, 1],
//         "FD",
//         true,
//       );
//     };
//     drawStar(cx - R + 3.5, cy + 1, 2.2);
//     drawStar(cx + R - 3.5, cy + 1, 2.2);

//     const docShort = (doc.name || "Doctor").toUpperCase();
//     sd(INK);
//     st(INK);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(5.8);
//     const topSpan = Math.min(docShort.length * 0.19, 1.3);
//     const topStart = -Math.PI / 2 - topSpan / 2;
//     for (let ti = 0; ti < docShort.length; ti++) {
//       const ta = topStart + (ti / Math.max(docShort.length - 1, 1)) * topSpan;
//       const tx = cx + (R - 1.5) * Math.cos(ta),
//         ty = cy + (R - 1.5) * Math.sin(ta);
//       const trot = ((ta + Math.PI / 2) * 180) / Math.PI;
//       pdf.text(docShort[ti], tx, ty, { align: "center", angle: -trot });
//     }

//     pdf.setFontSize(5.5);
//     const botStr = "PEARLSMILE DENTAL";
//     const botSpan = Math.min(botStr.length * 0.175, 1.4);
//     const botStart = Math.PI / 2 - botSpan / 2;
//     for (let bi = 0; bi < botStr.length; bi++) {
//       const ba = botStart + (bi / Math.max(botStr.length - 1, 1)) * botSpan;
//       const bx = cx + (R - 1.5) * Math.cos(ba),
//         by = cy + (R - 1.5) * Math.sin(ba);
//       const brot = ((ba - Math.PI / 2) * 180) / Math.PI;
//       pdf.text(botStr[bi], bx, by, { align: "center", angle: -brot });
//     }

//     sd(INK);
//     pdf.setLineWidth(0.8);
//     pdf.line(cx, cy - 8, cx, cy + 7);
//     pdf.setLineWidth(0.5);
//     pdf.line(cx, cy - 7.5, cx - 4, cy - 9.5);
//     pdf.line(cx - 4, cy - 9.5, cx - 6, cy - 8);
//     pdf.line(cx - 6, cy - 8, cx - 3, cy - 6.5);
//     pdf.line(cx, cy - 7.5, cx + 4, cy - 9.5);
//     pdf.line(cx + 4, cy - 9.5, cx + 6, cy - 8);
//     pdf.line(cx + 6, cy - 8, cx + 3, cy - 6.5);
//     sf(INK);
//     pdf.circle(cx, cy - 8.2, 1, "F");

//     pdf.setLineWidth(0.6);
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//         [0, -2],
//       ],
//       cx - 3,
//       cy + 5,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [-2, -2],
//         [-2, -2],
//         [0, -2],
//       ],
//       cx + 3,
//       cy + 1,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//       ],
//       cx - 3,
//       cy - 3,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [-2, -2],
//         [-2, -2],
//         [0, -2],
//       ],
//       cx + 3,
//       cy + 5,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//         [0, -2],
//       ],
//       cx - 3,
//       cy + 1,
//       [1, 1],
//       "S",
//     );

//     st(INK);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(4.5);
//     pdf.text("Reg. " + (doc.reg || "—"), cx, cy + R - 5.5, { align: "center" });
//     st(INK2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(6.5);
//     pdf.text("Authorised Signatory", cx, cy + R + 4, { align: "center" });

//     st(GRAY);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 14, sigY + 30);
//     pdf.text("Date: " + todayFmt, W - 14, sigY + 30, { align: "right" });

//     // ── Footer ────────────────────────────────────────────────────
//     sf(NAVY);
//     pdf.rect(3.5, H - 21, W - 7, 17.5, "F");
//     sf(BLUE);
//     pdf.rect(3.5, H - 7, W - 7, 3.5, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(7.5);
//     pdf.text("PearlSmile Dental Hospital", 10, H - 14.5);
//     st(LBLUE);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text("+91 87936 08083", 10, H - 9.5);
//     pdf.text("care@pearlsmiledental.in", W / 2, H - 9.5, { align: "center" });
//     pdf.text("12, Dental Plaza, MG Road, Pune - 411001", W - 10, H - 9.5, {
//       align: "right",
//     });
//     st(LBLUE2);
//     pdf.setFontSize(6);
//     pdf.setFont("helvetica", "italic");
//     pdf.text(
//       "This is a computer-generated prescription from PearlSmile Dental Hospital. Valid only with authorised doctor details.",
//       W / 2,
//       H - 5.5,
//       { align: "center" },
//     );

//     // ── Output ────────────────────────────────────────────────────
//     const blob = pdf.output("blob");
//     const url = URL.createObjectURL(blob);
//     const name =
//       "Prescription_" +
//       (patient.name || "Patient").replace(/\s+/g, "_") +
//       "_" +
//       visitDate +
//       ".pdf";

//     let rawMob = (patient.mobile || "").replace(/[\s\-\(\)\+]/g, "");
//     if (!rawMob.startsWith("91") && rawMob.length === 10)
//       rawMob = "91" + rawMob;

//     setPdfBlob(blob);
//     setPdfUrl(url);
//     setRxMobile(rawMob);
//     setFileName(name);
//     // Show native share button only if Web Share API supports files — exactly like original HTML
//     const testFile = new File([blob], name, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [testFile] })
//     ) {
//       setCanNativeShare(true);
//     }
//     setLoading(false);
//   };

//   const downloadPDF = () => {
//     const link = document.createElement("a");
//     link.href = pdfUrl;
//     link.download = fileName;
//     link.click();
//   };

//   const openFullPreview = () => {
//     if (pdfUrl) window.open(pdfUrl, "_blank");
//   };

//   const shareViaWhatsApp = () => {
//     if (rxMobile) window.open("https://wa.me/" + rxMobile, "_blank");
//     showNotify(
//       "WhatsApp Opened!",
//       "Attach the PDF from the preview and send to patient.",
//     );
//   };

//   const nativeShare = async () => {
//     if (!pdfBlob) return;
//     const file = new File([pdfBlob], fileName, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [file] })
//     ) {
//       navigator
//         .share({
//           title: "Digital Prescription — PearlSmile Dental Hospital",
//           text: "",
//           files: [file],
//         })
//         .then(() => {
//           showNotify("Shared!", "Prescription shared successfully.");
//           // After sharing, open WhatsApp to patient's number directly
//           if (rxMobile) {
//             setTimeout(
//               () => window.open("https://wa.me/" + rxMobile, "_blank"),
//               800,
//             );
//           }
//           onClose();
//         })
//         .catch((err) => {
//           if (err.name !== "AbortError")
//             showNotify("Share Failed", err.message, true);
//         });
//     } else {
//       showNotify(
//         "Not Supported",
//         "Native share not supported on this device/browser.",
//         true,
//       );
//     }
//   };

//   return (
//     <div
//       className="rx-share-overlay open"
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           width: "100%",
//           maxWidth: 540,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//           maxHeight: "92vh",
//         }}
//       >
//         {/* Header */}
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "18px 22px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <span style={{ fontSize: 22 }}>📄</span>
//             <div>
//               <div
//                 style={{
//                   color: "#fff",
//                   fontWeight: 600,
//                   fontSize: 15,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Digital Prescription Ready
//               </div>
//               <div
//                 style={{
//                   color: "rgba(255,255,255,0.55)",
//                   fontSize: 12,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 {patient.name} · {visit.visitDate}
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 17,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             ✕
//           </button>
//         </div>

//         {/* PDF Preview */}
//         <div
//           style={{
//             flex: 1,
//             overflow: "hidden",
//             background: "#f0eeeb",
//             minHeight: 340,
//             position: "relative",
//           }}
//         >
//           {loading && (
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: "#f0eeeb",
//                 gap: 10,
//               }}
//             >
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   border: "3px solid #0d7377",
//                   borderTopColor: "transparent",
//                   borderRadius: "50%",
//                   animation: "spin 0.8s linear infinite",
//                 }}
//               />
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "#5a5550",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Generating PDF…
//               </div>
//             </div>
//           )}
//           {pdfUrl && (
//             <iframe
//               title="prescription"
//               src={pdfUrl}
//               style={{ width: "100%", height: 420, border: "none" }}
//             />
//           )}
//         </div>

//         {/* Action buttons — exactly like original HTML */}
//         <div
//           style={{
//             padding: "16px 20px",
//             display: "flex",
//             flexDirection: "column",
//             gap: 10,
//             background: "#fff",
//           }}
//         >
//           <div style={{ display: "flex", gap: 8 }}>
//             <button
//               onClick={openFullPreview}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//             >
//               🔍 Open Full PDF
//             </button>
//             {canNativeShare && (
//               <button
//                 onClick={nativeShare}
//                 onMouseOver={(e) =>
//                   (e.currentTarget.style.background = "#e5e0d8")
//                 }
//                 onMouseOut={(e) =>
//                   (e.currentTarget.style.background = "#f0eeeb")
//                 }
//                 style={{
//                   flex: 1,
//                   background: "#f0eeeb",
//                   color: "#0a1628",
//                   border: "1.5px solid #ddd9d3",
//                   borderRadius: 10,
//                   padding: 10,
//                   fontSize: 13,
//                   fontWeight: 500,
//                   cursor: "pointer",
//                   fontFamily: "DM Sans,sans-serif",
//                   transition: "background 0.2s",
//                 }}
//               >
//                 📤 Share (Device)
//               </button>
//             )}
//           </div>
//           <p
//             style={{
//               fontSize: 11,
//               color: "#9a9590",
//               textAlign: "center",
//               margin: 0,
//               fontFamily: "DM Sans,sans-serif",
//               lineHeight: 1.5,
//             }}
//           >
//             On mobile: tap "Share (Device)" to send directly via WhatsApp.
//             <br />
//             On desktop: use "Open Full PDF" to view, then share manually.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

/////////////////////////////// correct code is here 5/ 4/ 2026  9:31/////////////////
// // ============================================================
// // src/components/admin/PatientsTab.js
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import api from "../../utils/api";

// const SERVICES_LIST = [
//   "General Checkup & Cleaning",
//   "Cosmetic Dentistry / Smile Makeover",
//   "Dental Implants",
//   "Orthodontics / Invisalign",
//   "Root Canal Therapy",
//   "Pediatric Dentistry",
//   "Oral Surgery",
//   "Periodontal Treatment",
//   "Teeth Whitening",
//   "Emergency Dental Care",
//   "Follow-Up Visit",
//   "Other",
// ];

// const MONTHS = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];
// const MONTHS_SHORT = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// function fmtDate(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtDateShort(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS_SHORT[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtTime(t) {
//   if (!t) return "";
//   const parts = t.split(":");
//   const hh = parseInt(parts[0]),
//     mm = parts[1];
//   return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
// }

// function totalRevenue(visits = []) {
//   return visits.reduce((sum, v) => {
//     const n = parseFloat((v.amount || "0").toString().replace(/[^0-9.]/g, ""));
//     return sum + (isNaN(n) ? 0 : n);
//   }, 0);
// }

// export default function PatientsTab({ showNotify, doctor }) {
//   const [patients, setPatients] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showNewForm, setShowNewForm] = useState(false);
//   const [newPat, setNewPat] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     age: "",
//     gender: "",
//     blood: "",
//   });
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [rxModal, setRxModal] = useState(null);
//   // Custom medicines — fetched from backend, shared across all doctors/devices
//   const [customMeds, setCustomMeds] = useState([]);

//   const today = new Date().toISOString().split("T")[0];
//   const nowTime = new Date().toTimeString().slice(0, 5);
//   const [visitForm, setVisitForm] = useState({
//     date: today,
//     time: nowTime,
//     service: "",
//     amount: "",
//     nextVisitDate: "",
//     notes: "",
//   });

//   const loadPatients = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await api.get("/patients");
//       setPatients(data);
//       setFiltered(data);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     loadPatients();
//   }, [loadPatients]);

//   // Fetch custom medicines from backend on mount — shared across all doctors/devices
//   useEffect(() => {
//     api
//       .get("/custommeds")
//       .then((data) => {
//         if (Array.isArray(data)) setCustomMeds(data);
//       })
//       .catch(() => {});
//   }, []);

//   const filterPatients = (q) => {
//     const term = q.toLowerCase();
//     setFiltered(
//       patients.filter(
//         (p) =>
//           (p.name || "").toLowerCase().includes(term) ||
//           (p.mobile || "").includes(term) ||
//           (p.email || "").toLowerCase().includes(term),
//       ),
//     );
//   };

//   const createPatient = async () => {
//     if (!newPat.name.trim()) {
//       showNotify("Error", "Patient name is required.", true);
//       return;
//     }
//     if (!newPat.mobile.trim()) {
//       showNotify("Error", "Mobile number is required.", true);
//       return;
//     }
//     try {
//       await api.post("/patients", newPat);
//       setNewPat({
//         name: "",
//         mobile: "",
//         email: "",
//         age: "",
//         gender: "",
//         blood: "",
//       });
//       setShowNewForm(false);
//       showNotify(
//         "Patient Profile Created! ✓",
//         "New profile for " + newPat.name + " saved.",
//       );
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const openPatient = async (p) => {
//     try {
//       const full = await api.get("/patients/" + p._id);
//       setSelectedPatient(full);
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//       });
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deletePatient = async () => {
//     if (
//       !window.confirm(
//         "Delete this patient profile and all their records? This cannot be undone.",
//       )
//     )
//       return;
//     try {
//       await api.delete("/patients/" + selectedPatient._id);
//       showNotify("Profile Deleted", "Patient profile removed.");
//       setSelectedPatient(null);
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const saveVisit = async () => {
//     if (!visitForm.date) {
//       showNotify("Missing Fields", "Please select a visit date.", true);
//       return;
//     }
//     if (!visitForm.service) {
//       showNotify("Missing Fields", "Please select a service.", true);
//       return;
//     }
//     try {
//       const payload = {
//         visitDate: visitForm.date,
//         visitTime: visitForm.time,
//         service: visitForm.service,
//         amount: visitForm.amount,
//         nextVisitDate: visitForm.nextVisitDate,
//         notes: visitForm.notes,
//         doctor: doctor?.name || "",
//         prescription: { medicineRows: [] },
//       };
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/visits",
//         payload,
//       );
//       setSelectedPatient(updated);

//       // ── Auto-create appointment for follow-up date ──────────
//       // If nextVisitDate is set → create an upcoming appointment entry
//       // so it appears in Appointments tab → Upcoming Appointments
//       if (visitForm.nextVisitDate && selectedPatient.mobile) {
//         try {
//           await api.post("/appointments", {
//             name: selectedPatient.name,
//             phone: selectedPatient.mobile,
//             service: visitForm.service,
//             date: visitForm.nextVisitDate,
//             time: "",
//             message: "Follow-up visit from Patient Profile",
//             status: "pending",
//           });
//         } catch (_) {
//           // Silently ignore if appointment creation fails
//         }
//       }

//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//       });

//       // Follow-up WhatsApp if notes contain "follow-up" and nextVisitDate is set
//       const isFollowUp = /follow[\s\-]?up/i.test(visitForm.notes);
//       if (isFollowUp && visitForm.nextVisitDate && selectedPatient.mobile) {
//         let rawMobile = (selectedPatient.mobile || "").replace(
//           /[\s\-\(\)\+]/g,
//           "",
//         );
//         if (!rawMobile.startsWith("91") && rawMobile.length === 10)
//           rawMobile = "91" + rawMobile;
//         const waMsg = `*PearlSmile Dental Hospital* — Follow-Up Reminder\n\nDear ${selectedPatient.name},\nThis is a reminder for your follow-up appointment.\n\n*Service:* ${visitForm.service}\n*Next Visit:* ${fmtDate(visitForm.nextVisitDate)}\n\nPlease call us to confirm your appointment.\n📞 +91 87936 08083`;
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" +
//                 rawMobile +
//                 "?text=" +
//                 encodeURIComponent(waMsg),
//               "_blank",
//             ),
//           500,
//         );
//         showNotify(
//           "Visit Saved + Follow-Up Appointment Created!",
//           "Reminder sent to " +
//             selectedPatient.name +
//             " for " +
//             fmtDate(visitForm.nextVisitDate) +
//             ". Appointment added to Upcoming.",
//         );
//       } else if (visitForm.nextVisitDate) {
//         showNotify(
//           "Visit Saved + Appointment Created! ✓",
//           "Follow-up appointment for " +
//             fmtDate(visitForm.nextVisitDate) +
//             " added to Upcoming Appointments.",
//         );
//       } else {
//         showNotify(
//           "Visit Record Saved! ✓",
//           "Patient visit has been recorded successfully.",
//         );
//       }
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deleteVisit = async (visitId) => {
//     if (!window.confirm("Delete this visit record?")) return;
//     try {
//       const result = await api.delete(
//         "/patients/" + selectedPatient._id + "/visits/" + visitId,
//       );
//       setSelectedPatient(result.patient);
//       showNotify("Visit Deleted", "Visit record removed.");
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const sendPrescription = (visit) => {
//     // Use the doctor who treated the patient (stored in visit.doctor)
//     // not the currently logged-in doctor
//     const treatingDoctor = visit.doctor ? { name: visit.doctor } : doctor;
//     setRxModal({ visit, patient: selectedPatient, doctor: treatingDoctor });
//   };

//   // ── LIST VIEW ─────────────────────────────────────────────────
//   if (!selectedPatient) {
//     return (
//       <div>
//         <div className="admin-section-title">Patient Profiles</div>
//         <div className="admin-section-desc">
//           Create and manage individual patient profiles. Click a profile to view
//           visit history and add new records.
//         </div>

//         <div className="patients-list-view">
//           <input
//             type="text"
//             className="patient-search-bar"
//             placeholder="🔍 Search patients by name or phone..."
//             onChange={(e) => filterPatients(e.target.value)}
//           />

//           {showNewForm && (
//             <div className="new-patient-form">
//               <h4>➕ Create New Patient Profile</h4>
//               <div className="new-patient-grid">
//                 {[
//                   ["name", "text", "Full Name *", "Patient full name"],
//                   ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
//                   ["email", "email", "Email Address", "patient@email.com"],
//                   ["age", "number", "Age", "Age"],
//                 ].map(([k, t, label, ph]) => (
//                   <div key={k}>
//                     <div className="admin-row-label">{label}</div>
//                     <input
//                       type={t}
//                       placeholder={ph}
//                       value={newPat[k]}
//                       onChange={(e) =>
//                         setNewPat((p) => ({ ...p, [k]: e.target.value }))
//                       }
//                     />
//                   </div>
//                 ))}
//                 <div>
//                   <div className="admin-row-label">Gender</div>
//                   <select
//                     value={newPat.gender}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, gender: e.target.value }))
//                     }
//                   >
//                     <option value="">Select Gender</option>
//                     <option>Male</option>
//                     <option>Female</option>
//                     <option>Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <div className="admin-row-label">Blood Group</div>
//                   <input
//                     type="text"
//                     placeholder="e.g. B+"
//                     value={newPat.blood}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, blood: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//               <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                 <button className="add-visit-save-btn" onClick={createPatient}>
//                   💾 Save Patient Profile
//                 </button>
//                 <button
//                   className="btn-back-patients"
//                   onClick={() => setShowNewForm(false)}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           )}

//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: 14,
//               flexWrap: "wrap",
//               gap: 10,
//             }}
//           >
//             <div style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {loading
//                 ? "Loading patients..."
//                 : `${filtered.length} patient profile${filtered.length !== 1 ? "s" : ""}`}
//             </div>
//             <button
//               className="admin-add-btn"
//               onClick={() => setShowNewForm((s) => !s)}
//             >
//               {showNewForm ? "Cancel" : "+ New Patient Profile"}
//             </button>
//           </div>

//           <div className="patient-profiles-grid">
//             {loading ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "20px 0",
//                   gridColumn: "1/-1",
//                 }}
//               >
//                 Loading...
//               </div>
//             ) : filtered.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "24px 0",
//                   gridColumn: "1/-1",
//                   textAlign: "center",
//                 }}
//               >
//                 No patients yet. Click "+ New Patient Profile" to add your first
//                 patient.
//               </div>
//             ) : (
//               filtered.map((p) => (
//                 <div
//                   key={p._id}
//                   className="patient-profile-card"
//                   onClick={() => openPatient(p)}
//                 >
//                   <div className="patient-avatar-icon">🧑‍⚕️</div>
//                   <div className="patient-card-name">{p.name}</div>
//                   <div className="patient-card-id">📞 {p.mobile || "—"}</div>
//                   <div className="patient-card-visits">
//                     📋 {p.visitCount || 0} visit{p.visitCount !== 1 ? "s" : ""}
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ── DETAIL VIEW ───────────────────────────────────────────────
//   const p = selectedPatient;
//   const visits = p.visits || [];
//   const total = totalRevenue(visits);

//   return (
//     <div>
//       <div className="patient-detail-view open">
//         <div className="patient-detail-header">
//           <button
//             className="btn-back-patients"
//             onClick={() => {
//               setSelectedPatient(null);
//             }}
//           >
//             ← Back to Patients
//           </button>
//           <div
//             className="patient-avatar-icon"
//             style={{ width: 56, height: 56, fontSize: 26 }}
//           >
//             🧑‍⚕️
//           </div>
//           <div style={{ flex: 1 }}>
//             <h3>{p.name}</h3>
//             <p style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {p.email}
//               {p.email && p.mobile ? " · " : ""}
//               {p.mobile}
//             </p>
//             <div className="patient-info-row">
//               {[
//                 p.age ? "Age: " + p.age : null,
//                 p.gender || null,
//                 p.blood ? "Blood: " + p.blood : null,
//               ]
//                 .filter(Boolean)
//                 .map((t, i) => (
//                   <span key={i} className="patient-info-pill">
//                     {t}
//                   </span>
//                 ))}
//             </div>
//           </div>
//           <div style={{ textAlign: "right", flexShrink: 0 }}>
//             <div
//               style={{
//                 fontSize: 11,
//                 color: "var(--gray-400)",
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//                 marginBottom: 4,
//               }}
//             >
//               Total Revenue
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 26,
//                 fontWeight: 600,
//                 color: "var(--teal)",
//                 lineHeight: 1,
//               }}
//             >
//               Rs. {total.toLocaleString("en-IN")}
//             </div>
//             <div
//               style={{ fontSize: 11, color: "var(--gray-400)", marginTop: 2 }}
//             >
//               {visits.length} visit{visits.length !== 1 ? "s" : ""}
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 8,
//               alignSelf: "flex-start",
//               marginTop: 4,
//             }}
//           >
//             <button className="admin-del-btn" onClick={deletePatient}>
//               🗑️ Delete Profile
//             </button>
//           </div>
//         </div>

//         {/* Add Visit Form — original simple layout */}
//         <div className="add-visit-form">
//           <h4>📋 Add New Visit Record</h4>
//           <div className="add-visit-grid">
//             <div>
//               <div className="admin-row-label">Visit Date *</div>
//               <input
//                 type="date"
//                 value={visitForm.date}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, date: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Visit Time</div>
//               <input
//                 type="time"
//                 value={visitForm.time}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, time: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Service Taken *</div>
//               <select
//                 value={visitForm.service}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, service: e.target.value }))
//                 }
//               >
//                 <option value="">Select Service</option>
//                 {SERVICES_LIST.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <div className="admin-row-label">Amount Charged (Rs.)</div>
//               <input
//                 type="text"
//                 placeholder="e.g. 2500"
//                 value={visitForm.amount}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, amount: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div
//                 className="admin-row-label"
//                 style={{ display: "flex", alignItems: "center", gap: 6 }}
//               >
//                 Next Date to Visit
//                 <span
//                   style={{
//                     fontSize: 10,
//                     color: "var(--teal)",
//                     fontWeight: 400,
//                     background: "rgba(13,115,119,0.08)",
//                     padding: "2px 8px",
//                     borderRadius: 100,
//                     border: "1px solid rgba(13,115,119,0.2)",
//                   }}
//                 >
//                   For follow-up
//                 </span>
//               </div>
//               <input
//                 type="date"
//                 value={visitForm.nextVisitDate}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, nextVisitDate: e.target.value }))
//                 }
//                 style={{ marginTop: 6 }}
//               />
//             </div>
//           </div>
//           <div className="admin-row-label" style={{ marginBottom: 6 }}>
//             Doctor Notes / Diagnosis
//           </div>
//           <MedAutocomplete
//             value={visitForm.notes}
//             onChange={(v) => setVisitForm((f) => ({ ...f, notes: v }))}
//             customMeds={customMeds}
//             apiPost={api.post}
//             onCustomSaved={(saved) => {
//               if (saved && saved._id) {
//                 // Add to local state immediately so suggestion appears right away
//                 setCustomMeds((prev) => {
//                   const exists = prev.some(
//                     (m) =>
//                       m._id === saved._id ||
//                       m.name.toLowerCase() === saved.name.toLowerCase(),
//                   );
//                   if (exists) return prev;
//                   return [saved, ...prev];
//                 });
//               } else {
//                 // Fallback refetch if saved object not returned
//                 api
//                   .get("/custommeds")
//                   .then((data) => {
//                     if (Array.isArray(data)) setCustomMeds(data);
//                   })
//                   .catch(() => {});
//               }
//             }}
//           />
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               flexWrap: "wrap",
//               gap: 10,
//               marginTop: 4,
//             }}
//           >
//             <button className="add-visit-save-btn" onClick={saveVisit}>
//               💾 Save Visit Record
//             </button>
//           </div>
//         </div>

//         {/* Visit History */}
//         <div style={{ marginBottom: 12 }}>
//           <div className="admin-section-title" style={{ marginBottom: 8 }}>
//             Visit History
//           </div>
//           <div className="visit-records-list">
//             {visits.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 13,
//                   padding: "10px 0",
//                 }}
//               >
//                 No visits recorded yet. Add the first visit above.
//               </div>
//             ) : (
//               visits.map((v, i) => {
//                 const dtStr =
//                   (v.visitDate || "") +
//                   (v.visitTime ? " at " + v.visitTime : "");
//                 const isFollowUp = /follow[\s\-]?up/i.test(v.notes || "");
//                 return (
//                   <div key={v._id || i} className="visit-record-card">
//                     <button
//                       className="visit-del-btn"
//                       onClick={() => deleteVisit(v._id)}
//                       title="Delete"
//                     >
//                       ✕
//                     </button>
//                     <div className="visit-record-meta">
//                       <span className="visit-record-service">
//                         {v.service || "Visit"}
//                       </span>
//                       <span className="visit-record-date">📅 {dtStr}</span>
//                       {v.amount && (
//                         <span
//                           className="patient-info-pill"
//                           style={{ fontSize: 11 }}
//                         >
//                           Rs. {v.amount}
//                         </span>
//                       )}
//                       {v.doctor && (
//                         <span
//                           style={{
//                             fontSize: 11,
//                             color: "var(--teal)",
//                             fontWeight: 600,
//                             background: "rgba(13,115,119,0.08)",
//                             padding: "2px 8px",
//                             borderRadius: 100,
//                             border: "1px solid rgba(13,115,119,0.2)",
//                           }}
//                         >
//                           👨‍⚕️ {v.doctor}
//                         </span>
//                       )}
//                     </div>
//                     <div className="visit-record-notes">{v.notes || "—"}</div>
//                     {v.nextVisitDate && (
//                       <div
//                         style={{
//                           marginTop: 8,
//                           display: "inline-flex",
//                           alignItems: "center",
//                           gap: 6,
//                           background: isFollowUp
//                             ? "rgba(201,168,76,0.12)"
//                             : "rgba(13,115,119,0.08)",
//                           border:
//                             "1px solid " +
//                             (isFollowUp
//                               ? "rgba(201,168,76,0.35)"
//                               : "rgba(13,115,119,0.2)"),
//                           borderRadius: 100,
//                           padding: "3px 12px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           color: isFollowUp ? "#8b6914" : "var(--teal)",
//                         }}
//                       >
//                         {isFollowUp ? "Follow-Up: " : "Next Visit: "}
//                         {fmtDateShort(v.nextVisitDate)}
//                         {isFollowUp ? " — WhatsApp sent" : ""}
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 8,
//                         marginTop: 10,
//                       }}
//                     >
//                       <button
//                         onClick={() => sendPrescription(v)}
//                         style={{
//                           background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Send Prescription
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </div>

//       {rxModal && (
//         <PrescriptionModal
//           visit={rxModal.visit}
//           patient={rxModal.patient}
//           doctor={rxModal.doctor}
//           onClose={() => setRxModal(null)}
//           showNotify={showNotify}
//         />
//       )}
//     </div>
//   );
// }

// // ── Medicine Database — 1500+ entries (India: dental + clinical + surgical) ──
// const MEDICINE_DB = [
//   // ── ANTIBIOTICS ──────────────────────────────────────────────
//   { name: "Amoxicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 875mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin 125mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin 250mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 375mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 625mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 1000mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 228.5mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Azithromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Clindamycin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 600mg Injection", cat: "Antibiotic Inj" },
//   { name: "Metronidazole 200mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 400mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Infusion", cat: "Antibiotic Inj" },
//   { name: "Ciprofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 750mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 200mg/100ml Infusion", cat: "Antibiotic Inj" },
//   { name: "Doxycycline 100mg Capsule", cat: "Antibiotic" },
//   { name: "Doxycycline 200mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Tinidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ornidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Secnidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Co-Amoxiclav 375mg Tablet", cat: "Antibiotic" },
//   { name: "Co-Amoxiclav 625mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 750mg Tablet", cat: "Antibiotic" },
//   { name: "Ofloxacin 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ofloxacin 400mg Tablet", cat: "Antibiotic" },
//   { name: "Cephalexin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Cephalexin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Cefixime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 400mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 50mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Cefuroxime 250mg Tablet", cat: "Antibiotic" },
//   { name: "Cefuroxime 500mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ceftriaxone 250mg Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 2g Injection", cat: "Antibiotic Inj" },
//   { name: "Amikacin 250mg Injection", cat: "Antibiotic Inj" },
//   { name: "Amikacin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Gentamicin 40mg Injection", cat: "Antibiotic Inj" },
//   { name: "Gentamicin 80mg Injection", cat: "Antibiotic Inj" },
//   { name: "Vancomycin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Vancomycin 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Meropenem 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Meropenem 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Piperacillin + Tazobactam 4.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Imipenem + Cilastatin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Linezolid 600mg Tablet", cat: "Antibiotic" },
//   { name: "Linezolid 600mg Infusion", cat: "Antibiotic Inj" },
//   { name: "Colistin 1 MU Injection", cat: "Antibiotic Inj" },
//   { name: "Tetracycline 250mg Capsule", cat: "Antibiotic" },
//   { name: "Tetracycline 500mg Capsule", cat: "Antibiotic" },
//   { name: "Chloramphenicol 250mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin + Sulbactam 1.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Nitrofurantoin 50mg Capsule", cat: "Antibiotic" },
//   { name: "Nitrofurantoin 100mg Capsule", cat: "Antibiotic" },
//   { name: "Norfloxacin 400mg Tablet", cat: "Antibiotic" },
//   { name: "Trimethoprim + Sulfamethoxazole 480mg Tablet", cat: "Antibiotic" },
//   { name: "Trimethoprim + Sulfamethoxazole 960mg Tablet", cat: "Antibiotic" },
//   { name: "Cefoperazone + Sulbactam 1.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Cefoperazone + Sulbactam 3g Injection", cat: "Antibiotic Inj" },
//   { name: "Ertapenem 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Tigecycline 50mg Injection", cat: "Antibiotic Inj" },
//   { name: "Fosfomycin 3g Sachet", cat: "Antibiotic" },
//   { name: "Rifampicin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Rifampicin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Isoniazid 100mg Tablet", cat: "Antibiotic" },
//   { name: "Isoniazid 300mg Tablet", cat: "Antibiotic" },
//   { name: "Pyrazinamide 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ethambutol 400mg Tablet", cat: "Antibiotic" },
//   { name: "Streptomycin 1g Injection", cat: "Antibiotic Inj" },
//   // ── PAIN KILLERS / NSAIDS ────────────────────────────────────
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 250mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 150mg/ml Drops", cat: "Painkiller" },
//   { name: "Paracetamol 500mg/100ml Infusion", cat: "Painkiller Inj" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 100mg/5ml Syrup", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Injection", cat: "NSAID Inj" },
//   { name: "Ketorolac 10mg Tablet", cat: "NSAID" },
//   { name: "Ketorolac 30mg Injection", cat: "NSAID Inj" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Piroxicam 10mg Tablet", cat: "NSAID" },
//   { name: "Piroxicam 20mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 120mg Tablet", cat: "NSAID" },
//   { name: "Celecoxib 100mg Capsule", cat: "NSAID" },
//   { name: "Celecoxib 200mg Capsule", cat: "NSAID" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol 100mg SR Tablet", cat: "Opioid Analgesic" },
//   { name: "Tramadol 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Morphine 10mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Morphine 15mg Tablet", cat: "Opioid Analgesic" },
//   { name: "Fentanyl 50mcg/ml Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pentazocine 30mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pethidine 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Buprenorphine 0.3mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Tapentadol 50mg Tablet", cat: "Opioid Analgesic" },
//   { name: "Tapentadol 100mg Tablet", cat: "Opioid Analgesic" },
//   // ── LOCAL ANAESTHETICS — DENTAL ─────────────────────────────
//   { name: "Lignocaine 2% Dental Cartridge (1.8ml)", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine + Adrenaline 2% Dental Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% Heavy Spinal Injection", cat: "Local Anaesthetic" },
//   { name: "Mepivacaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Prilocaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Lignocaine 2% Plain Injection 30ml Vial", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine 2% + Adrenaline Injection Vial",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Lignocaine 10% Topical Spray", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 2% Viscous Gel", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 5% Ointment", cat: "Local Anaesthetic Topical" },
//   { name: "Benzocaine 20% Topical Gel", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lignocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine Jelly 2%", cat: "Local Anaesthetic Topical" },
//   { name: "Ropivacaine 0.2% Injection", cat: "Local Anaesthetic" },
//   { name: "Ropivacaine 0.75% Injection", cat: "Local Anaesthetic" },
//   {
//     name: "Tetracaine (Amethocaine) Eye Drops",
//     cat: "Local Anaesthetic Topical",
//   },
//   // ── GENERAL ANAESTHESIA ─────────────────────────────────────
//   { name: "Propofol 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 500mg Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Thiopentone Sodium 500mg Injection", cat: "General Anaesthesia" },
//   { name: "Midazolam 1mg/ml Injection", cat: "Sedative / Anaesthesia" },
//   { name: "Midazolam 5mg/ml Injection", cat: "Sedative / Anaesthesia" },
//   { name: "Midazolam 7.5mg Tablet", cat: "Sedative" },
//   { name: "Isoflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Sevoflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Desflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Nitrous Oxide Gas", cat: "Inhalation Anaesthetic" },
//   { name: "Oxygen Gas Cylinder", cat: "Medical Gas" },
//   { name: "Succinylcholine 100mg Injection", cat: "Muscle Relaxant" },
//   { name: "Vecuronium 4mg Injection", cat: "Muscle Relaxant" },
//   { name: "Atracurium 25mg Injection", cat: "Muscle Relaxant" },
//   { name: "Rocuronium 50mg Injection", cat: "Muscle Relaxant" },
//   { name: "Neostigmine 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Atropine 0.6mg Injection", cat: "Anticholinergic" },
//   { name: "Glycopyrrolate 0.2mg Injection", cat: "Anticholinergic" },
//   // ── STEROIDS / ANTI-INFLAMMATORY ────────────────────────────
//   { name: "Dexamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Betamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 40mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 16mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 40mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 125mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone 10mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone Acetonide 0.1% Oral Paste", cat: "Steroid Topical" },
//   { name: "Kenacort 0.1% Dental Paste", cat: "Steroid Topical" },
//   { name: "Betamethasone Gel Oral 0.025%", cat: "Steroid Topical" },
//   // ── ANTIFUNGALS ─────────────────────────────────────────────
//   { name: "Fluconazole 50mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 2mg/ml Infusion", cat: "Antifungal Inj" },
//   { name: "Itraconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Voriconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Amphotericin B 50mg Injection", cat: "Antifungal Inj" },
//   { name: "Clotrimazole 1% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin 100000 IU/ml Oral Drops", cat: "Antifungal" },
//   { name: "Nystatin 500000 IU Tablet", cat: "Antifungal" },
//   { name: "Clotrimazole + Betamethasone Cream", cat: "Antifungal Topical" },
//   { name: "Ketoconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Ketoconazole 2% Shampoo", cat: "Antifungal Topical" },
//   { name: "Terbinafine 250mg Tablet", cat: "Antifungal" },
//   // ── ANTIVIRAL ───────────────────────────────────────────────
//   { name: "Acyclovir 200mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 400mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 800mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 5% Cream", cat: "Antiviral Topical" },
//   { name: "Acyclovir 250mg Injection", cat: "Antiviral Inj" },
//   { name: "Valacyclovir 500mg Tablet", cat: "Antiviral" },
//   { name: "Valacyclovir 1000mg Tablet", cat: "Antiviral" },
//   { name: "Famciclovir 250mg Tablet", cat: "Antiviral" },
//   { name: "Oseltamivir 75mg Capsule", cat: "Antiviral" },
//   // ── ANTISEPTICS / MOUTHWASH / ORAL CARE ─────────────────────
//   { name: "Chlorhexidine Gluconate 0.2% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine Gluconate 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 1% Gel (Gum Gel)", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 5% Mouthwash / Gargle", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 10% Solution", cat: "Antiseptic" },
//   { name: "Povidone Iodine 5% Ointment", cat: "Antiseptic Topical" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 1.5% Mouthwash", cat: "Dental Antiseptic" },
//   {
//     name: "Benzydamine Hydrochloride 0.15% Mouthwash",
//     cat: "Dental Analgesic Rinse",
//   },
//   { name: "Hexetidine 0.1% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Sodium Fluoride 0.05% Mouthwash", cat: "Fluoride Rinse" },
//   { name: "Sodium Fluoride Varnish 5%", cat: "Fluoride Varnish" },
//   { name: "Fluoride Gel APF 1.23%", cat: "Fluoride Gel" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "Aloe Vera Gel Oral", cat: "Oral Care" },
//   { name: "Hyaluronic Acid Gel 0.2% Oral", cat: "Oral Care" },
//   { name: "Triclosan Toothpaste", cat: "Dental Brand" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Colgate Total Toothpaste", cat: "Dental Brand" },
//   { name: "Pepsodent Toothpaste", cat: "Dental Brand" },
//   { name: "Emoform Toothpaste", cat: "Dental Brand" },
//   { name: "Thermoseal Toothpaste", cat: "Dental Brand" },
//   { name: "Himalaya HiOra Toothpaste", cat: "Dental Brand" },
//   { name: "Dabur Red Toothpaste", cat: "Dental Brand" },
//   { name: "Meswak Toothpaste", cat: "Dental Brand" },
//   { name: "Oral-B Electric Toothbrush Head", cat: "Dental Accessory" },
//   { name: "Interdental Brush", cat: "Dental Accessory" },
//   { name: "Dental Floss", cat: "Dental Accessory" },
//   { name: "Tongue Cleaner", cat: "Dental Accessory" },
//   { name: "Water Flosser / Oral Irrigator", cat: "Dental Accessory" },
//   // ── DENTAL MATERIALS ────────────────────────────────────────
//   { name: "GIC Cement (Glass Ionomer Cement)", cat: "Dental Material" },
//   { name: "GIC Type II Restorative", cat: "Dental Material" },
//   { name: "RMGIC (Resin Modified GIC)", cat: "Dental Material" },
//   { name: "Composite Resin A1 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A2 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A3 Shade", cat: "Dental Material" },
//   { name: "Composite Resin B1 Shade", cat: "Dental Material" },
//   { name: "Flowable Composite", cat: "Dental Material" },
//   { name: "Bulk Fill Composite", cat: "Dental Material" },
//   { name: "IRM (Intermediate Restorative Material)", cat: "Dental Material" },
//   { name: "Zinc Oxide Eugenol Cement", cat: "Dental Material" },
//   { name: "Zinc Phosphate Cement", cat: "Dental Material" },
//   { name: "Zinc Polycarboxylate Cement", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Dycal (Calcium Hydroxide Base)", cat: "Dental Material" },
//   { name: "Cavity Liner (Varnish)", cat: "Dental Material" },
//   { name: "Etchant 37% Phosphoric Acid Gel", cat: "Dental Material" },
//   { name: "Bonding Agent (5th Gen)", cat: "Dental Material" },
//   { name: "Bonding Agent (7th Gen Self-Etch)", cat: "Dental Material" },
//   { name: "Dental Amalgam Capsule", cat: "Dental Material" },
//   { name: "Impression Material Alginate", cat: "Dental Material" },
//   {
//     name: "Impression Material Polyvinyl Siloxane (PVS)",
//     cat: "Dental Material",
//   },
//   { name: "Impression Material Polyether", cat: "Dental Material" },
//   { name: "Zinc Oxide Impression Paste", cat: "Dental Material" },
//   { name: "Plaster of Paris (Type II)", cat: "Dental Material" },
//   { name: "Dental Stone (Type III)", cat: "Dental Material" },
//   { name: "Dental Stone (Type IV)", cat: "Dental Material" },
//   { name: "Acrylic Resin Heat Cure", cat: "Dental Material" },
//   { name: "Acrylic Resin Cold Cure / Self Cure", cat: "Dental Material" },
//   { name: "Denture Base Resin", cat: "Dental Material" },
//   { name: "Denture Reliner", cat: "Dental Material" },
//   { name: "Denture Adhesive Cream", cat: "Dental Material" },
//   { name: "Dental Wax (Sheet Wax)", cat: "Dental Material" },
//   { name: "Boxing Wax", cat: "Dental Material" },
//   { name: "Inlay Wax", cat: "Dental Material" },
//   { name: "Sticky Wax", cat: "Dental Material" },
//   { name: "Orthodontic Wire NiTi 0.012", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire NiTi 0.014", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire NiTi 0.016", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire SS 0.019x0.025", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Metal)", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Ceramic)", cat: "Dental Ortho" },
//   { name: "Orthodontic Elastic Bands", cat: "Dental Ortho" },
//   { name: "Orthodontic Separator Elastics", cat: "Dental Ortho" },
//   { name: "Orthodontic Molar Band", cat: "Dental Ortho" },
//   { name: "Orthodontic Retainer Wire", cat: "Dental Ortho" },
//   { name: "Invisalign Clear Aligner Tray", cat: "Dental Ortho" },
//   { name: "Dental Implant Fixture (Titanium)", cat: "Dental Implant" },
//   { name: "Dental Implant Abutment", cat: "Dental Implant" },
//   { name: "Healing Cap / Cover Screw", cat: "Dental Implant" },
//   { name: "Bone Graft Material (Synthetic HA)", cat: "Dental Implant" },
//   { name: "Bone Graft Material (Xenograft)", cat: "Dental Implant" },
//   { name: "Collagen Membrane (Resorbable)", cat: "Dental Implant" },
//   { name: "Titanium Mesh", cat: "Dental Implant" },
//   { name: "PRP (Platelet Rich Plasma) Kit", cat: "Dental Surgical" },
//   { name: "PRF (Platelet Rich Fibrin) Kit", cat: "Dental Surgical" },
//   { name: "Hemostatic Agent (Gelatin Sponge)", cat: "Dental Surgical" },
//   { name: "Surgicel (Oxidised Cellulose)", cat: "Haemostatic" },
//   { name: "Alvogyl (Dry Socket Dressing)", cat: "Dental Surgical" },
//   { name: "Whitehead Varnish (Iodoform Paste)", cat: "Dental Surgical" },
//   { name: "Ledermix Paste", cat: "Dental Material" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Sealapex)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Zinc Oxide Eugenol)", cat: "Endodontic" },
//   { name: "Gutta Percha Points (ISO 20-80)", cat: "Endodontic" },
//   { name: "Paper Points (Absorbent Points)", cat: "Endodontic" },
//   { name: "EDTA Liquid 17% (Root Canal)", cat: "Endodontic" },
//   { name: "EDTA Gel 17% (Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 2.5% Solution", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% Solution", cat: "Endodontic" },
//   { name: "Chlorhexidine 2% Irrigant", cat: "Endodontic" },
//   { name: "RC Prep (Root Canal Lubricant)", cat: "Endodontic" },
//   { name: "K-Files (Root Canal Files) ISO 6-80", cat: "Endodontic Instrument" },
//   { name: "H-Files (Hedstrom Files) ISO 15-60", cat: "Endodontic Instrument" },
//   { name: "Rotary NiTi Files (ProTaper)", cat: "Endodontic Instrument" },
//   { name: "Rotary NiTi Files (WaveOne Gold)", cat: "Endodontic Instrument" },
//   { name: "Rubber Dam Sheet", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Clamp", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Frame", cat: "Endodontic Accessory" },
//   { name: "Pulp Capping Agent (Vitrebond)", cat: "Endodontic" },
//   { name: "Formocresol Solution", cat: "Endodontic Paediatric" },
//   { name: "Buckley's Formocresol", cat: "Endodontic Paediatric" },
//   {
//     name: "Zinc Oxide + Iodoform Paste (Kri Paste)",
//     cat: "Endodontic Paediatric",
//   },
//   { name: "Stainless Steel Crown (Paediatric)", cat: "Paediatric Dental" },
//   { name: "Fluoride Varnish Duraphat 22600 ppm", cat: "Fluoride Varnish" },
//   // ── SURGICAL INSTRUMENTS ────────────────────────────────────
//   { name: "Scalpel Handle No. 3", cat: "Surgical Instrument" },
//   { name: "Scalpel Handle No. 4", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 11", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 12", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 15", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 23", cat: "Surgical Instrument" },
//   { name: "Scissors (Metzenbaum)", cat: "Surgical Instrument" },
//   { name: "Scissors (Mayo Straight)", cat: "Surgical Instrument" },
//   { name: "Scissors (Mayo Curved)", cat: "Surgical Instrument" },
//   { name: "Scissors (Iris)", cat: "Surgical Instrument" },
//   { name: "Scissors (Dean)", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Straight)", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Curved)", cat: "Surgical Instrument" },
//   { name: "Mosquito Forceps", cat: "Surgical Instrument" },
//   { name: "Tissue Forceps (Adson)", cat: "Surgical Instrument" },
//   { name: "Tissue Forceps (Rat Tooth)", cat: "Surgical Instrument" },
//   { name: "Allis Tissue Forceps", cat: "Surgical Instrument" },
//   { name: "Babcock Forceps", cat: "Surgical Instrument" },
//   { name: "Needle Holder (Mayo Hegar)", cat: "Surgical Instrument" },
//   { name: "Needle Holder (Mathieu)", cat: "Surgical Instrument" },
//   { name: "Retractor (Langenbeck)", cat: "Surgical Instrument" },
//   { name: "Retractor (Army-Navy)", cat: "Surgical Instrument" },
//   { name: "Retractor (Minnesota)", cat: "Surgical Instrument" },
//   { name: "Cheek Retractor (Plastic)", cat: "Dental Instrument" },
//   { name: "Mouth Gag (Doyen)", cat: "Surgical Instrument" },
//   { name: "Periosteal Elevator (Molt No.9)", cat: "Dental Instrument" },
//   { name: "Periosteal Elevator (Freer)", cat: "Dental Instrument" },
//   { name: "Bone Curette (Lucas)", cat: "Dental Instrument" },
//   { name: "Surgical Curette", cat: "Surgical Instrument" },
//   { name: "Bone File", cat: "Dental Instrument" },
//   { name: "Rongeur Forceps (Bone Cutting)", cat: "Surgical Instrument" },
//   { name: "Surgical Mallet", cat: "Surgical Instrument" },
//   { name: "Osteotome", cat: "Surgical Instrument" },
//   { name: "Chisel (Straight)", cat: "Surgical Instrument" },
//   { name: "Suction Tip (Yankauer)", cat: "Surgical Instrument" },
//   { name: "Suction Tip (Dental Fine Tip)", cat: "Dental Instrument" },
//   { name: "Saliva Ejector Tip", cat: "Dental Instrument" },
//   { name: "High Volume Evacuator (HVE) Tip", cat: "Dental Instrument" },
//   { name: "Air/Water Syringe Tip", cat: "Dental Instrument" },
//   // ── DENTAL EXTRACTION FORCEPS ────────────────────────────────
//   { name: "Extraction Forceps Upper Anterior", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Premolar", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Molar (Left)", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Molar (Right)", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Anterior", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Premolar", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Molar", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Roots (Bayonet)", cat: "Dental Instrument" },
//   { name: "Elevator (Straight No. 301)", cat: "Dental Instrument" },
//   { name: "Elevator (Cryer Right)", cat: "Dental Instrument" },
//   { name: "Elevator (Cryer Left)", cat: "Dental Instrument" },
//   { name: "Elevator (Apexo)", cat: "Dental Instrument" },
//   { name: "Elevator (Warwick James)", cat: "Dental Instrument" },
//   { name: "Elevator (Coupland)", cat: "Dental Instrument" },
//   // ── PERIODONTAL INSTRUMENTS ──────────────────────────────────
//   { name: "Ultrasonic Scaler Tip (Universal)", cat: "Periodontal Instrument" },
//   {
//     name: "Ultrasonic Scaler Tip (Subgingival)",
//     cat: "Periodontal Instrument",
//   },
//   { name: "Sickle Scaler H6/H7", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 1/2", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 5/6", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 7/8", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 11/12", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 13/14", cat: "Periodontal Instrument" },
//   { name: "Columbia Curette 4R/4L", cat: "Periodontal Instrument" },
//   { name: "Periodontal Probe (Williams)", cat: "Periodontal Instrument" },
//   { name: "Periodontal Probe (UNC-15)", cat: "Periodontal Instrument" },
//   { name: "Periodontal Probe (CPITN)", cat: "Periodontal Instrument" },
//   { name: "Suture Scissors (Crown Removing)", cat: "Periodontal Instrument" },
//   { name: "Electrosurgery Tip", cat: "Periodontal Instrument" },
//   // ── NEEDLES AND SYRINGES ─────────────────────────────────────
//   { name: "Dental Needle 27G Short (21mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 27G Long (38mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Short (21mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 25G Long (38mm)", cat: "Dental Needle" },
//   {
//     name: "Aspirating Dental Syringe (Breech Loading)",
//     cat: "Dental Instrument",
//   },
//   { name: "Disposable Syringe 1ml (Insulin)", cat: "Syringe" },
//   { name: "Disposable Syringe 2ml", cat: "Syringe" },
//   { name: "Disposable Syringe 5ml", cat: "Syringe" },
//   { name: "Disposable Syringe 10ml", cat: "Syringe" },
//   { name: "Disposable Syringe 20ml", cat: "Syringe" },
//   { name: "Disposable Syringe 50ml (Piston)", cat: "Syringe" },
//   { name: "Needle 18G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 20G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 21G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 22G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 23G x 1 inch", cat: "Needle" },
//   { name: "Needle 24G x 1 inch", cat: "Needle" },
//   { name: "Needle 25G x 5/8 inch", cat: "Needle" },
//   { name: "Needle 26G x 0.5 inch", cat: "Needle" },
//   { name: "IV Cannula 14G (Orange)", cat: "IV Cannula" },
//   { name: "IV Cannula 16G (Grey)", cat: "IV Cannula" },
//   { name: "IV Cannula 18G (Green)", cat: "IV Cannula" },
//   { name: "IV Cannula 20G (Pink)", cat: "IV Cannula" },
//   { name: "IV Cannula 22G (Blue)", cat: "IV Cannula" },
//   { name: "IV Cannula 24G (Yellow)", cat: "IV Cannula" },
//   { name: "Spinal Needle 25G (Quincke)", cat: "Spinal Needle" },
//   { name: "Spinal Needle 26G (Quincke)", cat: "Spinal Needle" },
//   { name: "Epidural Needle 16G (Tuohy)", cat: "Epidural Needle" },
//   { name: "Epidural Catheter", cat: "Epidural Set" },
//   { name: 'Hypodermic Needle 21G x 1.5"', cat: "Needle" },
//   { name: "Scalp Vein Set 21G (Butterfly)", cat: "IV Accessory" },
//   { name: "Scalp Vein Set 23G (Butterfly)", cat: "IV Accessory" },
//   { name: "Scalp Vein Set 25G (Butterfly)", cat: "IV Accessory" },
//   // ── IV FLUIDS / INFUSIONS ────────────────────────────────────
//   { name: "Normal Saline 0.9% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 1000ml Infusion", cat: "IV Fluid" },
//   { name: "Ringer's Lactate 500ml Infusion", cat: "IV Fluid" },
//   { name: "Ringer's Lactate 1000ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 5% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 5% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 10% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 25% 200ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 50% 50ml Injection", cat: "IV Fluid" },
//   { name: "Dextrose 5% + Normal Saline 500ml", cat: "IV Fluid" },
//   { name: "Dextrose Saline (0.45% NaCl + 5% Dextrose)", cat: "IV Fluid" },
//   { name: "Isolyte S 500ml Infusion", cat: "IV Fluid" },
//   { name: "Isolyte P 500ml Infusion (Paediatric)", cat: "IV Fluid" },
//   { name: "Plasma Expander (Haemaccel) 500ml", cat: "IV Fluid" },
//   { name: "Colloid Solution (Albumin 5%) 500ml", cat: "IV Fluid" },
//   { name: "Albumin 25% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Sodium Bicarbonate 7.5% 25ml Injection", cat: "IV Fluid" },
//   { name: "Potassium Chloride 15% 10ml Ampoule", cat: "IV Electrolyte" },
//   { name: "Calcium Gluconate 10% Injection", cat: "IV Electrolyte" },
//   { name: "Magnesium Sulphate 50% Injection", cat: "IV Electrolyte" },
//   { name: "TPN (Total Parenteral Nutrition) Bag", cat: "IV Nutrition" },
//   { name: "Lipid Emulsion 20% Infusion", cat: "IV Nutrition" },
//   // ── ANTIEMETICS / GI ─────────────────────────────────────────
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 2mg/ml Injection", cat: "Antiemetic Inj" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Injection", cat: "Antiemetic Inj" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Promethazine 25mg Tablet", cat: "Antiemetic / Antihistamine" },
//   { name: "Promethazine 25mg Injection", cat: "Antiemetic Inj" },
//   { name: "Granisetron 1mg Tablet", cat: "Antiemetic" },
//   { name: "Pantoprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Ranitidine 150mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ranitidine 50mg Injection", cat: "Antacid Inj" },
//   { name: "Sucralfate Suspension 1g/10ml", cat: "Antacid" },
//   { name: "Antacid Suspension (Digene)", cat: "Antacid" },
//   { name: "Antacid Tablet (Gelusil)", cat: "Antacid" },
//   { name: "Syp Lactulose 10g/15ml", cat: "Laxative" },
//   { name: "Bisacodyl 5mg Tablet", cat: "Laxative" },
//   { name: "Bisacodyl Suppository 10mg", cat: "Laxative" },
//   { name: "Loperamide 2mg Tablet", cat: "Antidiarrhoeal" },
//   { name: "ORS Sachet (WHO Formula)", cat: "Oral Rehydration" },
//   { name: "Zinc Sulphate 20mg Tablet (Paediatric)", cat: "Micronutrient" },
//   // ── ANTIHISTAMINES / ALLERGY ─────────────────────────────────
//   { name: "Cetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 5mg/5ml Syrup", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 180mg Tablet", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 4mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 10mg Injection", cat: "Antihistamine Inj" },
//   { name: "Diphenhydramine 25mg Capsule", cat: "Antihistamine" },
//   { name: "Diphenhydramine Injection", cat: "Antihistamine Inj" },
//   { name: "Adrenaline (Epinephrine) 1mg/ml Injection", cat: "Emergency Drug" },
//   { name: "Hydrocortisone 100mg Injection (Allergy)", cat: "Emergency Drug" },
//   { name: "Epinephrine Auto-Injector (EpiPen)", cat: "Emergency Drug" },
//   // ── CARDIOVASCULAR ───────────────────────────────────────────
//   { name: "Amlodipine 2.5mg Tablet", cat: "Antihypertensive" },
//   { name: "Amlodipine 5mg Tablet", cat: "Antihypertensive" },
//   { name: "Amlodipine 10mg Tablet", cat: "Antihypertensive" },
//   { name: "Atenolol 25mg Tablet", cat: "Beta Blocker" },
//   { name: "Atenolol 50mg Tablet", cat: "Beta Blocker" },
//   { name: "Atenolol 100mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 25mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 50mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 100mg Tablet", cat: "Beta Blocker" },
//   { name: "Propranolol 10mg Tablet", cat: "Beta Blocker" },
//   { name: "Propranolol 40mg Tablet", cat: "Beta Blocker" },
//   { name: "Losartan 25mg Tablet", cat: "Antihypertensive" },
//   { name: "Losartan 50mg Tablet", cat: "Antihypertensive" },
//   { name: "Telmisartan 40mg Tablet", cat: "Antihypertensive" },
//   { name: "Telmisartan 80mg Tablet", cat: "Antihypertensive" },
//   { name: "Ramipril 2.5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Ramipril 5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Enalapril 5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Enalapril 10mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Furosemide 20mg Tablet", cat: "Diuretic" },
//   { name: "Furosemide 40mg Tablet", cat: "Diuretic" },
//   { name: "Furosemide 20mg Injection", cat: "Diuretic Inj" },
//   { name: "Spironolactone 25mg Tablet", cat: "Diuretic" },
//   { name: "Aspirin 75mg Tablet", cat: "Antiplatelet" },
//   { name: "Aspirin 150mg Tablet", cat: "Antiplatelet" },
//   { name: "Clopidogrel 75mg Tablet", cat: "Antiplatelet" },
//   { name: "Atorvastatin 10mg Tablet", cat: "Statin" },
//   { name: "Atorvastatin 20mg Tablet", cat: "Statin" },
//   { name: "Atorvastatin 40mg Tablet", cat: "Statin" },
//   { name: "Nitroglycerin 0.5mg Sublingual Tablet", cat: "Nitrate" },
//   { name: "Nitroglycerin 5mg/ml Infusion", cat: "Nitrate Inj" },
//   { name: "Digoxin 0.25mg Tablet", cat: "Cardiac Glycoside" },
//   { name: "Amiodarone 200mg Tablet", cat: "Antiarrhythmic" },
//   { name: "Warfarin 1mg Tablet", cat: "Anticoagulant" },
//   { name: "Warfarin 5mg Tablet", cat: "Anticoagulant" },
//   { name: "Heparin 5000 IU Injection", cat: "Anticoagulant Inj" },
//   { name: "Protamine Sulphate 10mg Injection", cat: "Anticoagulant Reversal" },
//   // ── DIABETES DRUGS ───────────────────────────────────────────
//   { name: "Metformin 500mg Tablet", cat: "Antidiabetic" },
//   { name: "Metformin 850mg Tablet", cat: "Antidiabetic" },
//   { name: "Metformin 1000mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 1mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 2mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 4mg Tablet", cat: "Antidiabetic" },
//   { name: "Insulin Regular (Soluble) 100 IU/ml", cat: "Insulin" },
//   { name: "Insulin NPH (Isophane) 100 IU/ml", cat: "Insulin" },
//   { name: "Insulin Glargine 100 IU/ml (Lantus)", cat: "Insulin" },
//   { name: "Insulin Aspart 100 IU/ml (Novorapid)", cat: "Insulin" },
//   { name: "Insulin Lispro 100 IU/ml (Humalog)", cat: "Insulin" },
//   // ── VITAMINS / SUPPLEMENTS ───────────────────────────────────
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin C 1000mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule (Weekly)", cat: "Vitamin" },
//   { name: "Vitamin D3 1000 IU Tablet (Daily)", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 500mcg Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 1000mcg Injection", cat: "Vitamin Inj" },
//   { name: "Vitamin K1 10mg Injection", cat: "Vitamin Inj" },
//   { name: "Folic Acid 5mg Tablet", cat: "Vitamin" },
//   { name: "Iron (Ferrous Sulphate) 200mg Tablet", cat: "Iron Supplement" },
//   { name: "Iron + Folic Acid Tablet", cat: "Iron Supplement" },
//   { name: "Iron Sucrose 100mg Injection", cat: "Iron Supplement Inj" },
//   { name: "Calcium Carbonate 500mg Tablet", cat: "Calcium Supplement" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Zinc Sulphate 50mg Tablet", cat: "Micronutrient" },
//   { name: "Magnesium Hydroxide 300mg Tablet", cat: "Mineral Supplement" },
//   { name: "Multivitamin Tablet (Adult)", cat: "Multivitamin" },
//   { name: "Multivitamin Syrup (Paediatric)", cat: "Multivitamin" },
//   // ── HAEMOSTATICS / BLEEDING ──────────────────────────────────
//   { name: "Tranexamic Acid 500mg Tablet", cat: "Haemostatic" },
//   { name: "Tranexamic Acid 250mg/5ml Injection", cat: "Haemostatic Inj" },
//   { name: "Etamsylate 250mg Tablet", cat: "Haemostatic" },
//   { name: "Etamsylate 125mg/2ml Injection", cat: "Haemostatic Inj" },
//   { name: "Gelatin Sponge (Absorbable Haemostat)", cat: "Haemostatic" },
//   { name: "Bone Wax", cat: "Haemostatic Surgical" },
//   { name: "Thrombin Topical Powder", cat: "Haemostatic" },
//   { name: "Fibrin Glue (Tisseel)", cat: "Haemostatic Surgical" },
//   // ── SUTURE MATERIALS ─────────────────────────────────────────
//   { name: "Vicryl (Polyglactin 910) 3-0 Suture", cat: "Suture" },
//   { name: "Vicryl (Polyglactin 910) 4-0 Suture", cat: "Suture" },
//   { name: "Vicryl Rapid 4-0 Suture", cat: "Suture" },
//   { name: "Chromic Catgut 2-0 Suture", cat: "Suture" },
//   { name: "Chromic Catgut 3-0 Suture", cat: "Suture" },
//   { name: "Plain Catgut 2-0 Suture", cat: "Suture" },
//   { name: "Silk Suture 2-0 Black Braided", cat: "Suture" },
//   { name: "Silk Suture 3-0 Black Braided", cat: "Suture" },
//   { name: "Silk Suture 4-0 Black Braided", cat: "Suture" },
//   { name: "Nylon Suture 3-0 (Ethilon)", cat: "Suture" },
//   { name: "Nylon Suture 4-0 (Ethilon)", cat: "Suture" },
//   { name: "Nylon Suture 5-0 (Ethilon)", cat: "Suture" },
//   { name: "Prolene (Polypropylene) 3-0 Suture", cat: "Suture" },
//   { name: "Prolene (Polypropylene) 4-0 Suture", cat: "Suture" },
//   { name: "PDS II (Polydioxanone) 3-0 Suture", cat: "Suture" },
//   { name: "Monocryl 4-0 Suture (Poliglecaprone)", cat: "Suture" },
//   { name: "Stapler Skin (Proximate Plus)", cat: "Surgical Closure" },
//   { name: "Skin Staple Remover", cat: "Surgical Instrument" },
//   { name: "Steri-Strip (Wound Closure Strip)", cat: "Wound Care" },
//   { name: "Surgical Glue (Dermabond / Histoacryl)", cat: "Wound Care" },
//   // ── DRESSINGS / WOUND CARE ───────────────────────────────────
//   { name: "Gauze Swab 4x4 inch (Sterile)", cat: "Dressing" },
//   { name: "Gauze Swab 10x10 cm (Non-Sterile)", cat: "Dressing" },
//   { name: "ABD Pad (Combine Dressing)", cat: "Dressing" },
//   { name: "Crepe Bandage 4 inch", cat: "Bandage" },
//   { name: "Crepe Bandage 6 inch", cat: "Bandage" },
//   { name: "Adhesive Plaster Roll 1 inch", cat: "Bandage" },
//   { name: "Elastic Adhesive Bandage (EAB)", cat: "Bandage" },
//   { name: "Cohesive Bandage", cat: "Bandage" },
//   { name: "Cotton Roll (Non-Sterile)", cat: "Dental Material" },
//   { name: "Cotton Roll Sterile", cat: "Dressing" },
//   { name: "Absorbable Haemostatic Gauze", cat: "Haemostatic Dressing" },
//   { name: "Vaseline Gauze (Petrolatum Gauze)", cat: "Dressing" },
//   { name: "Jelonet Paraffin Gauze", cat: "Dressing" },
//   { name: "Melolin Non-Adherent Dressing", cat: "Dressing" },
//   { name: "Hydrocolloid Dressing (DuoDERM)", cat: "Dressing" },
//   { name: "Hydrogel Dressing", cat: "Dressing" },
//   { name: "Foam Dressing", cat: "Dressing" },
//   { name: "Alginate Dressing", cat: "Dressing" },
//   { name: "Transparent Film Dressing (Tegaderm)", cat: "Dressing" },
//   { name: "Povidone Iodine Gauze", cat: "Dressing" },
//   { name: "Silver Sulfadiazine 1% Cream", cat: "Burns Dressing" },
//   { name: "Bacitracin Ointment", cat: "Topical Antibiotic" },
//   { name: "Mupirocin 2% Ointment (Bactroban)", cat: "Topical Antibiotic" },
//   { name: "Fusidic Acid 2% Cream", cat: "Topical Antibiotic" },
//   { name: "Framycetin (Soframycin) Cream", cat: "Topical Antibiotic" },
//   // ── GLOVES / PPE / DISPOSABLES ───────────────────────────────
//   { name: "Latex Examination Gloves (S/M/L)", cat: "PPE" },
//   { name: "Nitrile Examination Gloves (S/M/L)", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 6.0", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 6.5", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 7.0", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 7.5", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 8.0", cat: "PPE" },
//   { name: "Surgical Mask (3-ply)", cat: "PPE" },
//   { name: "N95 Respirator Mask (FFP2)", cat: "PPE" },
//   { name: "Face Shield", cat: "PPE" },
//   { name: "Surgical Cap / Head Cover", cat: "PPE" },
//   { name: "Shoe Cover (Surgical Boot Cover)", cat: "PPE" },
//   { name: "Sterile Gown (Surgical)", cat: "PPE" },
//   { name: "Disposable Apron", cat: "PPE" },
//   { name: "Safety Goggles", cat: "PPE" },
//   { name: "Sharps Container 5L", cat: "Waste Disposal" },
//   { name: "Yellow Biohazard Bag", cat: "Waste Disposal" },
//   { name: "Red Biohazard Bag", cat: "Waste Disposal" },
//   { name: "IV Line / Infusion Set", cat: "IV Accessory" },
//   { name: "Burette Set (Paediatric IV Set)", cat: "IV Accessory" },
//   { name: "Blood Transfusion Set", cat: "IV Accessory" },
//   { name: "Nasogastric Tube (Ryle's Tube) 14F", cat: "Medical Device" },
//   { name: "Nasogastric Tube 16F", cat: "Medical Device" },
//   { name: "Foley Catheter 14F (2-Way)", cat: "Medical Device" },
//   { name: "Foley Catheter 16F (2-Way)", cat: "Medical Device" },
//   { name: "Foley Catheter 18F (3-Way)", cat: "Medical Device" },
//   { name: "Urobag (Urine Collection Bag)", cat: "Medical Device" },
//   { name: "Tracheostomy Tube (Cuffed) Size 7", cat: "Medical Device" },
//   { name: "Endotracheal Tube (ETT) 7.0 Cuffed", cat: "Anaesthesia Device" },
//   { name: "Endotracheal Tube (ETT) 7.5 Cuffed", cat: "Anaesthesia Device" },
//   { name: "Laryngoscope Blade (Macintosh Size 3)", cat: "Anaesthesia Device" },
//   { name: "Laryngeal Mask Airway (LMA) Size 3", cat: "Anaesthesia Device" },
//   { name: "Oropharyngeal Airway (Guedel) Size 3", cat: "Anaesthesia Device" },
//   { name: "Bag Valve Mask (BVM Resuscitator)", cat: "Emergency Device" },
//   { name: "Pulse Oximeter Probe", cat: "Monitoring Device" },
//   { name: "BP Cuff (Sphygmomanometer Cuff)", cat: "Monitoring Device" },
//   // ── RESPIRATORY / BRONCHODILATORS ───────────────────────────
//   { name: "Salbutamol 2mg Tablet", cat: "Bronchodilator" },
//   { name: "Salbutamol 4mg Tablet", cat: "Bronchodilator" },
//   { name: "Salbutamol 2.5mg/2.5ml Nebulisation", cat: "Bronchodilator" },
//   { name: "Salbutamol Inhaler 100mcg (MDI)", cat: "Bronchodilator Inhaler" },
//   { name: "Ipratropium 0.5mg Nebulisation", cat: "Bronchodilator" },
//   { name: "Budesonide 0.5mg Nebulisation", cat: "Steroid Inhaler" },
//   { name: "Doxofylline 400mg Tablet", cat: "Bronchodilator" },
//   { name: "Deriphylline Injection", cat: "Bronchodilator Inj" },
//   // ── ANTIEPILEPTICS ───────────────────────────────────────────
//   { name: "Phenytoin 100mg Tablet", cat: "Antiepileptic" },
//   { name: "Phenytoin 50mg/ml Injection", cat: "Antiepileptic Inj" },
//   { name: "Valproate 200mg Tablet", cat: "Antiepileptic" },
//   { name: "Valproate 500mg Tablet", cat: "Antiepileptic" },
//   { name: "Levetiracetam 500mg Tablet", cat: "Antiepileptic" },
//   { name: "Lorazepam 4mg Injection", cat: "Antiepileptic / Sedative Inj" },
//   { name: "Diazepam 10mg Injection", cat: "Antiepileptic / Sedative Inj" },
//   { name: "Clonazepam 0.5mg Tablet", cat: "Antiepileptic" },
//   { name: "Clonazepam 2mg Tablet", cat: "Antiepileptic" },
//   // ── VACCINES ─────────────────────────────────────────────────
//   { name: "Tetanus Toxoid 0.5ml Injection", cat: "Vaccine" },
//   { name: "Tetanus + Diphtheria (Td) Vaccine", cat: "Vaccine" },
//   { name: "Influenza Vaccine (Flu Shot)", cat: "Vaccine" },
//   { name: "Typhoid Vaccine (Vi Polysaccharide)", cat: "Vaccine" },
//   { name: "Rabies Vaccine (Post-Exposure)", cat: "Vaccine" },
//   { name: "Rabies Immunoglobulin (Human)", cat: "Vaccine" },
//   { name: "MMR Vaccine", cat: "Vaccine" },
//   { name: "Varicella (Chickenpox) Vaccine", cat: "Vaccine" },
//   { name: "HPV Vaccine (Gardasil 4/9)", cat: "Vaccine" },
//   { name: "COVID-19 Vaccine (Covishield)", cat: "Vaccine" },
//   { name: "COVID-19 Vaccine (Covaxin)", cat: "Vaccine" },
//   { name: "Anti-Tetanus Serum (ATS)", cat: "Antiserum" },
//   { name: "Anti-Snake Venom (Polyvalent)", cat: "Antiserum" },
//   { name: "Anti-Rabies Serum", cat: "Antiserum" },
//   { name: "Anti-Scorpion Venom Serum", cat: "Antiserum" },
//   // ── INVESTIGATIONS / LAB ─────────────────────────────────────
//   { name: "OPG (Orthopantomogram) X-ray", cat: "Dental Investigation" },
//   { name: "IOPA X-ray (Intraoral Periapical)", cat: "Dental Investigation" },
//   { name: "Bitewing X-ray", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Cone Beam CT)", cat: "Dental Investigation" },
//   { name: "Occlusal X-ray", cat: "Dental Investigation" },
//   { name: "Lateral Cephalogram X-ray", cat: "Dental Investigation" },
//   { name: "Chest X-ray PA View", cat: "Investigation" },
//   { name: "Skull X-ray AP + Lateral", cat: "Investigation" },
//   { name: "X-Ray Mandible PA View", cat: "Investigation" },
//   { name: "X-Ray Waters View (PNS)", cat: "Investigation" },
//   { name: "ECG (Electrocardiogram)", cat: "Investigation" },
//   { name: "CT Scan Head Plain", cat: "Investigation" },
//   { name: "CT Scan Neck with Contrast", cat: "Investigation" },
//   { name: "MRI Face and Jaw", cat: "Investigation" },
//   { name: "Ultrasound Neck / Submandibular", cat: "Investigation" },
//   { name: "Complete Blood Count (CBC)", cat: "Lab Test" },
//   { name: "Differential Count (DC)", cat: "Lab Test" },
//   { name: "Blood Sugar Fasting (BSF)", cat: "Lab Test" },
//   { name: "Blood Sugar Post Prandial (BSPP)", cat: "Lab Test" },
//   { name: "Random Blood Sugar (RBS)", cat: "Lab Test" },
//   { name: "HbA1c Test", cat: "Lab Test" },
//   { name: "Liver Function Test (LFT)", cat: "Lab Test" },
//   { name: "Kidney Function Test (KFT) / RFT", cat: "Lab Test" },
//   { name: "Thyroid Function Test (TFT)", cat: "Lab Test" },
//   { name: "Lipid Profile Test", cat: "Lab Test" },
//   { name: "Urine Routine and Microscopy", cat: "Lab Test" },
//   { name: "Blood Group and Rh Typing", cat: "Lab Test" },
//   { name: "Platelet Count", cat: "Lab Test" },
//   { name: "PT / INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "APTT Test", cat: "Lab Test" },
//   { name: "Bleeding Time (BT)", cat: "Lab Test" },
//   { name: "Clotting Time (CT)", cat: "Lab Test" },
//   { name: "ESR (Erythrocyte Sedimentation Rate)", cat: "Lab Test" },
//   { name: "CRP (C-Reactive Protein)", cat: "Lab Test" },
//   { name: "Serum Calcium Test", cat: "Lab Test" },
//   { name: "Serum Phosphorus Test", cat: "Lab Test" },
//   { name: "Serum Vitamin D (25-OH) Test", cat: "Lab Test" },
//   { name: "Serum Vitamin B12 Test", cat: "Lab Test" },
//   { name: "Serum Iron / TIBC Test", cat: "Lab Test" },
//   { name: "HIV Test (ELISA)", cat: "Lab Test" },
//   { name: "HBsAg Test (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HCV Test (Hepatitis C)", cat: "Lab Test" },
//   { name: "VDRL / RPR Test (Syphilis)", cat: "Lab Test" },
//   { name: "Pus Culture and Sensitivity", cat: "Lab Test" },
//   { name: "Blood Culture and Sensitivity", cat: "Lab Test" },
//   { name: "FNAC (Fine Needle Aspiration Cytology)", cat: "Biopsy" },
//   { name: "Incisional Biopsy", cat: "Biopsy" },
//   { name: "Excisional Biopsy", cat: "Biopsy" },
//   { name: "Exfoliative Cytology (Oral Smear)", cat: "Lab Test" },
//   { name: "Histopathology (HPE)", cat: "Lab Test" },
//   // ── EMERGENCY DRUGS ─────────────────────────────────────────
//   { name: "Adrenaline 1:1000 (1mg/ml) Injection", cat: "Emergency Drug" },
//   { name: "Adrenaline 1:10000 Injection (Cardiac)", cat: "Emergency Drug" },
//   { name: "Atropine 0.6mg Injection", cat: "Emergency Drug" },
//   { name: "Sodium Bicarbonate 8.4% Injection", cat: "Emergency Drug" },
//   { name: "Calcium Gluconate 10% Injection", cat: "Emergency Drug" },
//   { name: "Dextrose 50% Injection (Hypoglycaemia)", cat: "Emergency Drug" },
//   { name: "Naloxone 0.4mg Injection (Opioid Reversal)", cat: "Emergency Drug" },
//   {
//     name: "Flumazenil 0.5mg Injection (Benzo Reversal)",
//     cat: "Emergency Drug",
//   },
//   { name: "Dopamine 200mg Infusion", cat: "Emergency Drug Inj" },
//   {
//     name: "Noradrenaline (Norepinephrine) Infusion",
//     cat: "Emergency Drug Inj",
//   },
//   { name: "Vasopressin 20 IU Injection", cat: "Emergency Drug Inj" },
//   { name: "GTN (Glyceryl Trinitrate) Infusion", cat: "Emergency Drug Inj" },
//   {
//     name: "Lignocaine 100mg IV Injection (Arrhythmia)",
//     cat: "Emergency Drug Inj",
//   },
//   { name: "Adenosine 6mg Injection (SVT)", cat: "Emergency Drug Inj" },
//   { name: "Defibrillator Pads (AED Electrode)", cat: "Emergency Device" },
//   ,
//   // ── CONSUMABLES: COTTON & GAUZE ──────────────────────────────
//   { name: "Cotton Roll (Dental Grade)", cat: "Consumable" },
//   { name: "Cotton Pellet Small", cat: "Consumable" },
//   { name: "Cotton Pellet Medium", cat: "Consumable" },
//   { name: "Cotton Pellet Large", cat: "Consumable" },
//   { name: "Absorbent Cotton Wool 500g Roll", cat: "Consumable" },
//   { name: "Absorbent Cotton Wool 100g", cat: "Consumable" },
//   { name: "Gauze Swab 4x4 inch Sterile", cat: "Consumable" },
//   { name: "Gauze Swab 2x2 inch Sterile", cat: "Consumable" },
//   { name: "Gauze Roll 5cm x 5m", cat: "Consumable" },
//   { name: "Gauze Roll 10cm x 5m", cat: "Consumable" },
//   { name: "Non-Woven Gauze Swab 4x4", cat: "Consumable" },
//   { name: "Paraffin Gauze Dressing", cat: "Dressing" },
//   { name: "Betadine Gauze Dressing", cat: "Dressing" },
//   { name: "Ribbon Gauze 1/2 inch (Dental Packing)", cat: "Dental Consumable" },
//   { name: "Ribbon Gauze 1 inch", cat: "Dental Consumable" },
//   { name: "Dry Foil (Dental)", cat: "Dental Consumable" },

//   // ── SALINE & IV FLUIDS ─────────────────────────────────────────
//   { name: "Normal Saline 0.9% 100ml", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 250ml", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 500ml", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 1000ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 100ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 250ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 500ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 1000ml", cat: "IV Fluid" },
//   { name: "Dextrose 10% 500ml", cat: "IV Fluid" },
//   { name: "Dextrose 25% 100ml", cat: "IV Fluid" },
//   { name: "Dextrose 50% 50ml", cat: "IV Fluid" },
//   { name: "Ringer Lactate 500ml", cat: "IV Fluid" },
//   { name: "Ringer Lactate 1000ml", cat: "IV Fluid" },
//   { name: "DNS (Dextrose Normal Saline) 500ml", cat: "IV Fluid" },
//   { name: "DNS 1000ml", cat: "IV Fluid" },
//   { name: "Haemaccel 500ml Infusion", cat: "IV Fluid" },
//   { name: "Gelofusine 500ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 100ml", cat: "IV Fluid" },
//   { name: "Mannitol 20% 250ml", cat: "IV Fluid" },
//   { name: "Sodium Bicarbonate 7.5% 25ml", cat: "IV Electrolyte" },
//   { name: "Sodium Bicarbonate 8.4% 100ml", cat: "IV Electrolyte" },
//   { name: "Potassium Chloride 15% 10ml Ampoule", cat: "IV Electrolyte" },
//   { name: "Calcium Gluconate 10% 10ml Injection", cat: "IV Electrolyte" },
//   { name: "Magnesium Sulphate 50% 2ml Injection", cat: "IV Electrolyte" },

//   // ── NEEDLES ────────────────────────────────────────────────────
//   { name: "Disposable Syringe 1ml (Insulin Type)", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 2ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 5ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 10ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 20ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 50ml", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 18G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 20G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 22G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 24G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 26G", cat: "Needle/Syringe" },
//   { name: "Dental Needle 27G Short", cat: "Dental Needle" },
//   { name: "Dental Needle 27G Long", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Short", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Ultra Short", cat: "Dental Needle" },
//   { name: "Scalp Vein Set (Butterfly) 21G", cat: "IV Accessory" },
//   { name: "Scalp Vein Set (Butterfly) 23G", cat: "IV Accessory" },
//   { name: "Scalp Vein Set (Butterfly) 25G", cat: "IV Accessory" },
//   { name: "IV Cannula 14G (Orange)", cat: "IV Cannula" },
//   { name: "IV Cannula 16G (Grey)", cat: "IV Cannula" },
//   { name: "IV Cannula 18G (Green)", cat: "IV Cannula" },
//   { name: "IV Cannula 20G (Pink)", cat: "IV Cannula" },
//   { name: "IV Cannula 22G (Blue)", cat: "IV Cannula" },
//   { name: "IV Cannula 24G (Yellow) Paediatric", cat: "IV Cannula" },
//   { name: "Spinal Needle 25G (Quincke)", cat: "Spinal Needle" },
//   { name: "Spinal Needle 26G", cat: "Spinal Needle" },
//   { name: "Spinal Needle 27G", cat: "Spinal Needle" },
//   { name: "Epidural Needle 16G (Tuohy)", cat: "Epidural Needle" },
//   { name: "Epidural Needle 17G (Tuohy)", cat: "Epidural Needle" },

//   // ── INJECTIONS & AMPOULES ──────────────────────────────────────
//   {
//     name: "Lignocaine 2% with Adrenaline 1:80000 Cartridge (Dental)",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Lignocaine 2% with Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Lignocaine 2% Plain Cartridge (Dental)", cat: "Local Anaesthetic" },
//   {
//     name: "Articaine 4% with Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% with Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Mepivacaine 3% Plain Cartridge", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% with Adrenaline", cat: "Local Anaesthetic" },
//   { name: "Prilocaine 4% Plain Cartridge", cat: "Local Anaesthetic" },
//   {
//     name: "Benzocaine 20% Topical Gel (Dental)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Lidocaine 2% Topical Jelly", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lidocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine 2% Jelly 30g", cat: "Local Anaesthetic Topical" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 250mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 40mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 125mg Injection", cat: "Steroid Inj" },
//   { name: "Ketorolac 30mg Injection", cat: "NSAID Inj" },
//   { name: "Diclofenac 75mg Injection", cat: "NSAID Inj" },
//   { name: "Tramadol 50mg Injection", cat: "Painkiller Inj" },
//   { name: "Tramadol 100mg Injection", cat: "Painkiller Inj" },
//   { name: "Morphine 10mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pethidine 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Fentanyl 50mcg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Ondansetron 4mg Injection", cat: "Antiemetic Inj" },
//   { name: "Metoclopramide 10mg Injection", cat: "Antiemetic Inj" },
//   { name: "Promethazine 25mg Injection", cat: "Antiemetic Inj" },
//   { name: "Chlorpheniramine 10mg Injection", cat: "Antihistamine Inj" },
//   { name: "Pheniramine 22.75mg Injection", cat: "Antihistamine Inj" },
//   { name: "Midazolam 1mg/ml Injection", cat: "Sedative" },
//   { name: "Midazolam 5mg/ml Injection", cat: "Sedative" },
//   { name: "Diazepam 5mg Injection", cat: "Sedative" },
//   { name: "Propofol 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 200mg Injection", cat: "General Anaesthesia" },
//   { name: "Atropine 0.6mg Injection", cat: "Anticholinergic" },
//   { name: "Neostigmine 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Succinylcholine 100mg Injection", cat: "Muscle Relaxant" },
//   { name: "Vecuronium 4mg Injection", cat: "Muscle Relaxant" },
//   { name: "Atracurium 25mg Injection", cat: "Muscle Relaxant" },
//   { name: "Furosemide 20mg Injection", cat: "Diuretic Inj" },
//   { name: "Furosemide 40mg Injection", cat: "Diuretic Inj" },
//   { name: "Ranitidine 50mg Injection", cat: "Antacid Inj" },
//   { name: "Pantoprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Omeprazole 40mg Injection", cat: "Antacid Inj" },
//   {
//     name: "Phytomenadione (Vitamin K1) 10mg Injection",
//     cat: "Haemostatic Inj",
//   },
//   { name: "Tranexamic Acid 500mg Injection", cat: "Haemostatic Inj" },
//   { name: "Etamsylate 250mg Injection", cat: "Haemostatic Inj" },
//   { name: "Oxytocin 10 IU Injection", cat: "Haemostatic Inj" },
//   { name: "Dextrose 50% 50ml Push", cat: "Emergency Drug Inj" },
//   { name: "Naloxone 0.4mg Injection", cat: "Reversal Agent" },
//   { name: "Flumazenil 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Calcium Gluconate 1g Injection", cat: "Emergency Drug Inj" },

//   // ── SURGICAL INSTRUMENTS ───────────────────────────────────────
//   { name: "Scalpel Handle No. 3", cat: "Surgical Instrument" },
//   { name: "Scalpel Handle No. 4", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 11", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 12", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 15", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 22", cat: "Surgical Instrument" },
//   { name: "Surgical Scissors Straight (Mayo)", cat: "Surgical Instrument" },
//   { name: "Surgical Scissors Curved (Mayo)", cat: "Surgical Instrument" },
//   { name: "Metzenbaum Scissors", cat: "Surgical Instrument" },
//   { name: "Iris Scissors", cat: "Surgical Instrument" },
//   { name: "Dissecting Forceps (Toothed) Adson", cat: "Surgical Instrument" },
//   { name: "Dissecting Forceps (Non-Toothed)", cat: "Surgical Instrument" },
//   { name: "Haemostat (Mosquito Forceps) Straight", cat: "Surgical Instrument" },
//   { name: "Haemostat (Mosquito Forceps) Curved", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Kocher) Straight", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Kocher) Curved", cat: "Surgical Instrument" },
//   { name: "Needle Holder (Mayo-Hegar)", cat: "Surgical Instrument" },
//   { name: "Retractor (Langenbeck) Small", cat: "Surgical Instrument" },
//   { name: "Retractor (Langenbeck) Large", cat: "Surgical Instrument" },
//   { name: "Self-Retaining Retractor (Weitlaner)", cat: "Surgical Instrument" },
//   { name: "Bone Rongeur Forceps", cat: "Surgical Instrument" },
//   { name: "Curette Small", cat: "Surgical Instrument" },
//   { name: "Curette Large", cat: "Surgical Instrument" },
//   { name: "Periosteal Elevator (Molt No.9)", cat: "Dental Instrument" },
//   { name: "Periosteal Elevator (Freer)", cat: "Dental Instrument" },
//   { name: "Luxator (Periotome)", cat: "Dental Instrument" },
//   { name: "Dental Elevator (Straight)", cat: "Dental Instrument" },
//   { name: "Dental Elevator (Cryer)", cat: "Dental Instrument" },
//   { name: "Dental Elevator (Warwick James)", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Anteriors", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Premolars", cat: "Dental Instrument" },
//   {
//     name: "Extraction Forceps Upper Molars (Cowhorn)",
//     cat: "Dental Instrument",
//   },
//   { name: "Extraction Forceps Lower Anteriors", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Molars", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Wisdom", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Wisdom", cat: "Dental Instrument" },
//   { name: "Bone File (Dental)", cat: "Dental Instrument" },
//   { name: "Bone Chisel (Dental)", cat: "Dental Instrument" },
//   { name: "Mallet (Surgical)", cat: "Dental Instrument" },
//   { name: "Rongeur Forceps (Dental)", cat: "Dental Instrument" },
//   { name: "Tissue Scissors (Dental)", cat: "Dental Instrument" },
//   { name: "Tongue Retractor", cat: "Dental Instrument" },
//   { name: "Cheek Retractor (Minnesota)", cat: "Dental Instrument" },
//   { name: "Austin/Channel Retractor", cat: "Dental Instrument" },
//   { name: "Dental Mirror No. 5", cat: "Dental Instrument" },
//   { name: "Dental Probe (CPI/UNC-15)", cat: "Dental Instrument" },
//   { name: "Dental Tweezers (College Pliers)", cat: "Dental Instrument" },
//   { name: "Dental Excavator Double Ended", cat: "Dental Instrument" },
//   { name: "Spoon Excavator Small", cat: "Dental Instrument" },
//   { name: "Spoon Excavator Medium", cat: "Dental Instrument" },
//   { name: "Amalgam Plugger", cat: "Dental Instrument" },
//   { name: "Composite Placement Instrument", cat: "Dental Instrument" },
//   { name: "Burnisher Ball", cat: "Dental Instrument" },
//   { name: "Burnisher Acorn", cat: "Dental Instrument" },
//   { name: "Sickle Scaler (H6/H7)", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 1/2", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 7/8", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 11/12", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 13/14", cat: "Periodontal Instrument" },
//   { name: "Columbia Curette", cat: "Periodontal Instrument" },
//   { name: "Hoe Scaler", cat: "Periodontal Instrument" },
//   { name: "File Scaler", cat: "Periodontal Instrument" },
//   { name: "Ultrasonic Scaler Tip (Slim)", cat: "Periodontal Instrument" },
//   { name: "Ultrasonic Scaler Tip (Universal)", cat: "Periodontal Instrument" },

//   // ── SUTURES ─────────────────────────────────────────────────────
//   { name: "Vicryl 3-0 (Polyglactin) Absorbable", cat: "Suture" },
//   { name: "Vicryl 4-0 Absorbable", cat: "Suture" },
//   { name: "Vicryl 5-0 Absorbable", cat: "Suture" },
//   { name: "Catgut Plain 2-0", cat: "Suture" },
//   { name: "Catgut Plain 3-0", cat: "Suture" },
//   { name: "Catgut Chromic 2-0", cat: "Suture" },
//   { name: "Catgut Chromic 3-0", cat: "Suture" },
//   { name: "Catgut Chromic 4-0", cat: "Suture" },
//   { name: "Silk 2-0 Non-Absorbable", cat: "Suture" },
//   { name: "Silk 3-0 Non-Absorbable (Dental)", cat: "Suture" },
//   { name: "Silk 4-0 Non-Absorbable", cat: "Suture" },
//   { name: "Prolene 4-0 (Polypropylene)", cat: "Suture" },
//   { name: "Prolene 5-0", cat: "Suture" },
//   { name: "Prolene 6-0", cat: "Suture" },
//   { name: "Nylon 3-0 Monofilament", cat: "Suture" },
//   { name: "Nylon 4-0 Monofilament", cat: "Suture" },
//   { name: "Nylon 5-0 Monofilament", cat: "Suture" },
//   { name: "PDS II 3-0 (Polydioxanone)", cat: "Suture" },
//   { name: "PDS II 4-0", cat: "Suture" },
//   { name: "Monocryl 4-0 (Poliglecaprone)", cat: "Suture" },
//   { name: "Monocryl 5-0", cat: "Suture" },
//   { name: "Ethibond 0 (Polyester)", cat: "Suture" },
//   { name: "Ethibond 2-0", cat: "Suture" },
//   { name: "Stapler (Skin Staples)", cat: "Surgical Closure" },
//   { name: "Steri-Strip Wound Closure 6mm", cat: "Surgical Closure" },
//   { name: "Steri-Strip Wound Closure 12mm", cat: "Surgical Closure" },
//   { name: "Tissue Glue (Dermabond/Histoacryl)", cat: "Surgical Closure" },

//   // ── IV DRIP ACCESSORIES ────────────────────────────────────────
//   { name: "IV Infusion Set (Standard)", cat: "IV Accessory" },
//   { name: "IV Infusion Set (Burette 100ml Paediatric)", cat: "IV Accessory" },
//   { name: "Blood Transfusion Set", cat: "IV Accessory" },
//   { name: "Extension Tubing (IV Line)", cat: "IV Accessory" },
//   { name: "Three-Way Stopcock", cat: "IV Accessory" },
//   { name: "Tegaderm IV Dressing 6x7cm", cat: "IV Accessory" },
//   { name: "Transparent Dressing IV Site", cat: "IV Accessory" },
//   { name: "IV Arm Board (Splint)", cat: "IV Accessory" },
//   { name: "Normal Saline Flush 10ml Pre-filled", cat: "IV Accessory" },
//   { name: "Heparin Flush 10 IU/ml", cat: "IV Accessory" },

//   // ── DRESSINGS & WOUND CARE ─────────────────────────────────────
//   { name: "Adhesive Plaster Roll 1 inch", cat: "Wound Care" },
//   { name: "Adhesive Plaster Roll 2 inch", cat: "Wound Care" },
//   { name: "Band-Aid Fabric 1 inch", cat: "Wound Care" },
//   { name: "Crepe Bandage 4 inch", cat: "Bandage" },
//   { name: "Crepe Bandage 6 inch", cat: "Bandage" },
//   { name: "Crepe Bandage 8 inch", cat: "Bandage" },
//   { name: "Elastic Adhesive Bandage 4 inch", cat: "Bandage" },
//   { name: "Cotton Bandage 4 inch", cat: "Bandage" },
//   { name: "Plaster of Paris (POP) Bandage 4 inch", cat: "Bandage" },
//   { name: "Plaster of Paris Bandage 6 inch", cat: "Bandage" },
//   { name: "Zinc Oxide Adhesive Plaster 1 inch", cat: "Wound Care" },
//   { name: "Wound Dressing Large (10x10)", cat: "Dressing" },
//   { name: "Wound Dressing Medium (7.5x7.5)", cat: "Dressing" },
//   { name: "Hydrocolloid Dressing", cat: "Wound Care" },
//   { name: "Foam Dressing", cat: "Wound Care" },
//   { name: "Silver Sulfadiazine 1% Cream (Burns)", cat: "Burns Dressing" },
//   { name: "Bactigras (Chlorhexidine Tulle)", cat: "Dressing" },

//   // ── ANTISEPTICS & DISINFECTANTS ────────────────────────────────
//   { name: "Povidone Iodine 5% Solution (Betadine)", cat: "Antiseptic" },
//   { name: "Povidone Iodine 10% Solution", cat: "Antiseptic" },
//   { name: "Povidone Iodine Surgical Scrub", cat: "Antiseptic" },
//   { name: "Chlorhexidine Gluconate 2% Solution", cat: "Antiseptic" },
//   { name: "Chlorhexidine Gluconate 4% Surgical Scrub", cat: "Antiseptic" },
//   { name: "Chlorhexidine 0.2% Mouthwash (Dental)", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Antiseptic" },
//   {
//     name: "Hydrogen Peroxide 6% (Dental Irrigation)",
//     cat: "Dental Antiseptic",
//   },
//   { name: "Isopropyl Alcohol 70% (Spirit Swabs)", cat: "Antiseptic" },
//   { name: "Alcohol Swabs (Pre-injection)", cat: "Antiseptic" },
//   { name: "Cetrimide + Chlorhexidine Solution", cat: "Antiseptic" },
//   { name: "Sodium Hypochlorite 2.5% (NaOCl - Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% (NaOCl)", cat: "Endodontic" },
//   { name: "EDTA Solution 17% (Root Canal)", cat: "Endodontic" },
//   { name: "EDTA Gel (RC Prep)", cat: "Endodontic" },
//   { name: "Saline Irrigation Solution 500ml", cat: "IV Fluid" },
//   { name: "Saline Nasal Drops", cat: "Consumable" },
//   { name: "Savlon (Cetrimide + Chlorhexidine)", cat: "Antiseptic" },
//   { name: "Dettol Liquid Antiseptic", cat: "Antiseptic" },

//   // ── DENTAL MATERIALS (EXPANDED) ────────────────────────────────
//   { name: "Zinc Oxide Eugenol (ZOE) Cement Base", cat: "Dental Material" },
//   { name: "Zinc Oxide Eugenol Impression Paste", cat: "Dental Material" },
//   { name: "Zinc Phosphate Cement", cat: "Dental Material" },
//   { name: "Zinc Polycarboxylate Cement", cat: "Dental Material" },
//   { name: "Glass Ionomer Cement Type I (Luting)", cat: "Dental Material" },
//   {
//     name: "Glass Ionomer Cement Type II (Restorative)",
//     cat: "Dental Material",
//   },
//   { name: "Glass Ionomer Cement Type III (Lining)", cat: "Dental Material" },
//   { name: "RMGIC (Resin Modified GIC)", cat: "Dental Material" },
//   { name: "Composite Resin Shade A1", cat: "Dental Material" },
//   { name: "Composite Resin Shade A2", cat: "Dental Material" },
//   { name: "Composite Resin Shade A3", cat: "Dental Material" },
//   { name: "Composite Resin Shade A3.5", cat: "Dental Material" },
//   { name: "Composite Resin Shade B1", cat: "Dental Material" },
//   { name: "Flowable Composite Shade A2", cat: "Dental Material" },
//   { name: "Flowable Composite Shade A3", cat: "Dental Material" },
//   { name: "Bonding Agent (5th Generation)", cat: "Dental Material" },
//   { name: "Bonding Agent (7th Generation Self-Etch)", cat: "Dental Material" },
//   { name: "Acid Etchant 37% Phosphoric Acid Gel", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste (Pulp Capping)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Powder", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Cavity Liner (Dycal)", cat: "Dental Material" },
//   { name: "Temporary Restoration Material (Cavit)", cat: "Dental Material" },
//   { name: "IRM Temporary Cement", cat: "Dental Material" },
//   { name: "Zinc Oxide Temp Fill", cat: "Dental Material" },
//   { name: "Alginate Impression Material (Chromatic)", cat: "Dental Material" },
//   { name: "Irreversible Hydrocolloid (Alginate) 500g", cat: "Dental Material" },
//   {
//     name: "Polyvinyl Siloxane (PVS) Impression Light Body",
//     cat: "Dental Material",
//   },
//   { name: "PVS Impression Heavy Body", cat: "Dental Material" },
//   { name: "Polyether Impression Material", cat: "Dental Material" },
//   { name: "Zinc Oxide Impression Paste (ZO Paste)", cat: "Dental Material" },
//   { name: "Plaster of Paris Dental Grade", cat: "Dental Material" },
//   { name: "Type III Dental Stone", cat: "Dental Material" },
//   { name: "Type IV Dental Stone (Die Stone)", cat: "Dental Material" },
//   { name: "Dental Wax (Modelling Wax)", cat: "Dental Material" },
//   { name: "Baseplate Wax", cat: "Dental Material" },
//   { name: "Sticky Wax", cat: "Dental Material" },
//   { name: "Bite Registration Paste", cat: "Dental Material" },
//   { name: "Separating Liquid (Sodium Alginate)", cat: "Dental Material" },
//   { name: "Denture Base Resin (Heat Cure)", cat: "Dental Material" },
//   { name: "Denture Base Resin (Cold Cure)", cat: "Dental Material" },
//   { name: "Denture Repair Resin", cat: "Dental Material" },
//   { name: "Acrylic Teeth Set (Upper)", cat: "Dental Material" },
//   { name: "Acrylic Teeth Set (Lower)", cat: "Dental Material" },
//   { name: "Porcelain Teeth", cat: "Dental Material" },
//   { name: "Chromium Cobalt Alloy (Partial Denture)", cat: "Dental Material" },
//   { name: "Amalgam Alloy Capsules (Pre-dosed)", cat: "Dental Material" },
//   { name: "Mercury (Dental Grade)", cat: "Dental Material" },
//   { name: "Amalgam Capsule Activator", cat: "Dental Accessory" },
//   { name: "Light Cure Composite Bleaching Gel 35%", cat: "Dental Material" },
//   { name: "Carbamide Peroxide 10% (Home Bleaching)", cat: "Dental Material" },
//   { name: "Carbamide Peroxide 16%", cat: "Dental Material" },
//   { name: "Carbamide Peroxide 22%", cat: "Dental Material" },
//   {
//     name: "Hydrogen Peroxide 35% (In-office Bleaching)",
//     cat: "Dental Material",
//   },
//   { name: "Desensitising Agent (Gluma)", cat: "Dental Material" },
//   { name: "Fluoride Varnish 5% NaF (Duraphat)", cat: "Dental Fluoride" },
//   { name: "Fluoride Gel APF 1.23%", cat: "Fluoride Gel" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "Pit & Fissure Sealant (Light Cure)", cat: "Dental Material" },
//   { name: "Pit & Fissure Sealant (Self-Cure)", cat: "Dental Material" },
//   { name: "Crown & Bridge Temporary Cement", cat: "Dental Material" },
//   { name: "Permanent Crown Cement (Ketac Cem)", cat: "Dental Material" },
//   { name: "Resin Cement (Panavia F)", cat: "Dental Material" },
//   { name: "Post & Core Material", cat: "Dental Material" },
//   { name: "Fibre Post (Glass Fibre)", cat: "Dental Material" },
//   { name: "Gutta Percha Points ISO Size 15", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 20", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 25", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 30", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 35", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 40", cat: "Endodontic" },
//   { name: "Gutta Percha Points Standardised Large", cat: "Endodontic" },
//   { name: "Gutta Percha Points Accessory Fine", cat: "Endodontic" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Apexit Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Zinc Oxide Eugenol)", cat: "Endodontic" },
//   { name: "K-File ISO 15 (Root Canal File)", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 20", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 25", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 30", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 35", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 40", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 45", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 50", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 60", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 80", cat: "Endodontic Instrument" },
//   { name: "H-File (Hedstroem) ISO 20", cat: "Endodontic Instrument" },
//   { name: "H-File ISO 25", cat: "Endodontic Instrument" },
//   { name: "H-File ISO 30", cat: "Endodontic Instrument" },
//   { name: "Reamer ISO 15-40 Set", cat: "Endodontic Instrument" },
//   { name: "ProTaper Next Rotary File Set", cat: "Endodontic Instrument" },
//   {
//     name: "WaveOne Gold Primary (Reciprocating)",
//     cat: "Endodontic Instrument",
//   },
//   { name: "Reciproc Blue R25", cat: "Endodontic Instrument" },
//   { name: "Lentulo Spiral Filler", cat: "Endodontic Instrument" },
//   { name: "Plugger Spreader (Gutta Percha)", cat: "Endodontic Instrument" },
//   { name: "Barbed Broach Assorted", cat: "Endodontic Instrument" },
//   { name: "Paper Points ISO 20", cat: "Endodontic Accessory" },
//   { name: "Paper Points ISO 25", cat: "Endodontic Accessory" },
//   { name: "Paper Points ISO 30", cat: "Endodontic Accessory" },
//   { name: "Paper Points ISO 40", cat: "Endodontic Accessory" },
//   { name: "Paper Points Fine (Accessory)", cat: "Endodontic Accessory" },
//   { name: "Apex Locator Tips", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Sheet (Latex)", cat: "Dental Accessory" },
//   { name: "Rubber Dam Frame (Ostby)", cat: "Dental Accessory" },
//   { name: "Rubber Dam Clamp Kit", cat: "Dental Accessory" },
//   { name: "Rubber Dam Punch", cat: "Dental Accessory" },
//   { name: "Saliva Ejector Tips (Disposable)", cat: "Dental Accessory" },
//   { name: "High Volume Evacuation Tip (HVE)", cat: "Dental Accessory" },
//   { name: "Matrix Band (Tofflemire Universal)", cat: "Dental Accessory" },
//   { name: "Sectional Matrix System (Palodent)", cat: "Dental Accessory" },
//   { name: "Wooden Wedge Assorted", cat: "Dental Accessory" },
//   { name: "Interproximal Plastic Wedge", cat: "Dental Accessory" },
//   { name: "Celluloid Crown Form (Anterior)", cat: "Dental Accessory" },
//   {
//     name: "Stainless Steel Crown (Molar Paediatric)",
//     cat: "Paediatric Dental",
//   },
//   { name: "Stainless Steel Crown Kit", cat: "Paediatric Dental" },
//   { name: "Pulpotomy Agent (Formocresol)", cat: "Paediatric Dental" },
//   { name: "Pulpotomy Agent (Ferric Sulphate 15.5%)", cat: "Paediatric Dental" },
//   { name: "Zinc Oxide Eugenol Paediatric Filling", cat: "Paediatric Dental" },

//   // ── ORTHO MATERIALS ────────────────────────────────────────────
//   { name: "Orthodontic Bands (Molar) Upper", cat: "Dental Ortho" },
//   { name: "Orthodontic Bands (Molar) Lower", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Metal Roth)", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Ceramic)", cat: "Dental Ortho" },
//   { name: "Archwire NiTi Round 0.014", cat: "Dental Ortho" },
//   { name: "Archwire NiTi Round 0.016", cat: "Dental Ortho" },
//   { name: "Archwire NiTi Round 0.018", cat: "Dental Ortho" },
//   { name: "Archwire SS Rectangular 0.019x0.025", cat: "Dental Ortho" },
//   { name: "Archwire SS Rectangular 0.021x0.025", cat: "Dental Ortho" },
//   { name: "Ligature Wire (Stainless Steel)", cat: "Dental Ortho" },
//   { name: "Elastic Ligature Ties Assorted", cat: "Dental Ortho" },
//   { name: "Power Chain Elastic", cat: "Dental Ortho" },
//   { name: "Separating Elastics (Orthodontic)", cat: "Dental Ortho" },
//   { name: "Molar Tube (Buccal Tube)", cat: "Dental Ortho" },
//   { name: "Ortho Bracket Adhesive (Light Cure)", cat: "Dental Ortho" },
//   { name: "Band Cement (Glass Ionomer Ortho)", cat: "Dental Ortho" },
//   { name: "Debonding Pliers", cat: "Dental Ortho" },
//   { name: "Ligature Tying Pliers", cat: "Dental Ortho" },
//   { name: "How Pliers", cat: "Dental Ortho" },
//   { name: "Cinching Pliers", cat: "Dental Ortho" },
//   { name: "Wire Cutters (Distal End Cutter)", cat: "Dental Ortho" },
//   { name: "Invisalign Chewies (Aligner Seater)", cat: "Dental Ortho" },
//   { name: "Retainer (Hawley Plate)", cat: "Dental Ortho" },

//   // ── PPE & INFECTION CONTROL ────────────────────────────────────
//   { name: "Nitrile Gloves Small (Powder-Free)", cat: "PPE" },
//   { name: "Nitrile Gloves Medium (Powder-Free)", cat: "PPE" },
//   { name: "Nitrile Gloves Large (Powder-Free)", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 6.5", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 7", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 7.5", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 8", cat: "PPE" },
//   { name: "Examination Gloves (Vinyl) Medium", cat: "PPE" },
//   { name: "3-Ply Surgical Face Mask", cat: "PPE" },
//   { name: "N95 Respirator (NIOSH Approved)", cat: "PPE" },
//   { name: "Surgical Gown (Non-Woven Sterile)", cat: "PPE" },
//   { name: "Disposable Apron (Polythene)", cat: "PPE" },
//   { name: "Shoe Cover (Disposable)", cat: "PPE" },
//   { name: "Head Cover / Surgical Cap", cat: "PPE" },
//   { name: "Face Shield (Dental)", cat: "PPE" },
//   { name: "Safety Goggles", cat: "PPE" },
//   { name: "Bib (Dental Patient)", cat: "Dental Accessory" },
//   { name: "Bib Clips", cat: "Dental Accessory" },
//   { name: "Autoclave Pouches (Self-Seal)", cat: "PPE" },
//   { name: "Sharps Container 5L", cat: "Waste Disposal" },
//   { name: "Sharps Container 1L", cat: "Waste Disposal" },
//   { name: "Biomedical Waste Bag Yellow", cat: "Waste Disposal" },
//   { name: "Biomedical Waste Bag Red", cat: "Waste Disposal" },

//   // ── COMMON OTC / PRESCRIPTION TABLETS ─────────────────────────
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 250mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 100mg/5ml Syrup", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Diclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Aceclofenac + Paracetamol + Serratiopeptidase", cat: "NSAID Combo" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 120mg Tablet", cat: "NSAID" },
//   { name: "Celecoxib 100mg Capsule", cat: "NSAID" },
//   { name: "Celecoxib 200mg Capsule", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Capsule", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   {
//     name: "Trypsin + Chymotrypsin Tablet (Antiflam)",
//     cat: "Enzyme Combination",
//   },
//   { name: "Serratiopeptidase 10mg Tablet", cat: "Enzyme Combination" },
//   { name: "Serratiopeptidase 20mg Tablet", cat: "Enzyme Combination" },
//   { name: "Deflazacort 6mg Tablet", cat: "Steroid" },
//   { name: "Deflazacort 12mg Tablet", cat: "Steroid" },
//   { name: "Deflazacort 30mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 8mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 16mg Tablet", cat: "Steroid" },
//   { name: "Betamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Pantoprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Omeprazole 10mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 40mg Capsule", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 10mg Tablet", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Ranitidine 150mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ranitidine 300mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 4mg/5ml Syrup", cat: "Antiemetic" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Domperidone 1mg/ml Suspension", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Promethazine 10mg Tablet", cat: "Antiemetic / Antihistamine" },
//   { name: "Cetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 5mg/5ml Syrup", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 180mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 2.5mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 4mg Tablet", cat: "Antihistamine" },
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin C 1000mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B Complex + Zinc Capsule", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule", cat: "Vitamin" },
//   { name: "Vitamin D3 1000 IU Tablet", cat: "Vitamin" },
//   { name: "Vitamin E 400mg Capsule", cat: "Vitamin" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Calcium Carbonate 500mg Tablet", cat: "Calcium Supplement" },
//   { name: "Zinc Sulphate 20mg Tablet", cat: "Mineral Supplement" },
//   { name: "Ferrous Sulphate 200mg Tablet", cat: "Iron Supplement" },
//   { name: "Ferrous Ascorbate + Folic Acid Tablet", cat: "Iron Supplement" },

//   // ── TOPICAL MEDICATIONS ────────────────────────────────────────
//   {
//     name: "Triamcinolone Acetonide 0.1% Oral Paste (Kenacort)",
//     cat: "Steroid Topical",
//   },
//   { name: "Triamcinolone Acetonide 0.025% Cream", cat: "Steroid Topical" },
//   { name: "Betamethasone 0.05% Cream", cat: "Steroid Topical" },
//   { name: "Clotrimazole 1% Cream", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin Oral Suspension", cat: "Antifungal" },
//   { name: "Nystatin 100000 IU Tablet", cat: "Antifungal" },
//   { name: "Fluconazole 50mg Tablet", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Tablet", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Mupirocin 2% Ointment (Bactroban)", cat: "Topical Antibiotic" },
//   { name: "Neomycin + Bacitracin Ointment", cat: "Topical Antibiotic" },
//   { name: "Tetracycline 3% Ointment", cat: "Topical Antibiotic" },
//   { name: "Fusidic Acid 2% Cream", cat: "Topical Antibiotic" },
//   { name: "Lignocaine Viscous 2% Mouthwash", cat: "Local Anaesthetic Topical" },
//   {
//     name: "Magic Mouthwash (Lignocaine + Diphenhydramine + Antacid)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Amlexanox 5% Paste (Aphthous Ulcer)", cat: "Oral Care" },
//   { name: "Benzydamine 0.15% Mouthwash (Tantum Verde)", cat: "Oral Care" },
//   { name: "Glycerine + Thymol Mouthwash", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash (Hexetidine 0.1%)", cat: "Dental Antiseptic" },
//   { name: "Listerine Mouthwash (OTC)", cat: "Oral Care" },
//   { name: "Colgate Peroxyl Mouthwash", cat: "Oral Care" },
//   { name: "Orajel (Benzocaine 10%) Topical", cat: "Local Anaesthetic Topical" },
//   { name: "Ulcerex Gel (Choline Salicylate)", cat: "Oral Care" },
//   { name: "Dologel CT (Clove Oil Gel)", cat: "Oral Care" },
//   { name: "Clove Oil (Eugenol)", cat: "Dental Material" },

//   // ── DENTAL IMPLANT MATERIALS ───────────────────────────────────
//   { name: "Titanium Implant Fixture (3.3mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (3.5mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (4.0mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (4.5mm)", cat: "Dental Implant" },
//   { name: "Implant Cover Screw", cat: "Dental Implant" },
//   { name: "Implant Healing Abutment", cat: "Dental Implant" },
//   { name: "Implant Final Abutment", cat: "Dental Implant" },
//   { name: "Implant Impression Coping", cat: "Dental Implant" },
//   { name: "Bone Graft (Autograft)", cat: "Dental Surgical" },
//   { name: "Bone Graft (Xenograft - Bio-Oss)", cat: "Dental Surgical" },
//   { name: "Collagen Membrane (Bio-Gide)", cat: "Dental Surgical" },
//   { name: "PRF (Platelet Rich Fibrin) Kit", cat: "Dental Surgical" },
//   {
//     name: "Haemostatic Agent (Surgicel - Oxidised Cellulose)",
//     cat: "Haemostatic Surgical",
//   },
//   { name: "Haemostatic Foam (Gelfoam)", cat: "Haemostatic" },
//   { name: "Bone Wax", cat: "Haemostatic Surgical" },
//   { name: "Surgical Suction Tip (Frazier)", cat: "Dental Instrument" },

//   // ── LAB INVESTIGATIONS ─────────────────────────────────────────
//   { name: "CBC (Complete Blood Count)", cat: "Lab Test" },
//   { name: "RBS (Random Blood Sugar)", cat: "Lab Test" },
//   { name: "FBS (Fasting Blood Sugar)", cat: "Lab Test" },
//   { name: "HbA1c (Glycated Haemoglobin)", cat: "Lab Test" },
//   { name: "Blood Group & Rh Typing", cat: "Lab Test" },
//   { name: "BT (Bleeding Time) & CT (Clotting Time)", cat: "Lab Test" },
//   { name: "PT/INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "APTT (Activated Partial Thromboplastin Time)", cat: "Lab Test" },
//   { name: "LFT (Liver Function Test)", cat: "Lab Test" },
//   { name: "KFT (Kidney Function Test)", cat: "Lab Test" },
//   { name: "Serum Creatinine", cat: "Lab Test" },
//   { name: "Urine Routine Examination", cat: "Lab Test" },
//   { name: "HBsAg (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HIV (ELISA)", cat: "Lab Test" },
//   { name: "VDRL (Syphilis Test)", cat: "Lab Test" },
//   { name: "Dental Radiograph (IOPA X-ray)", cat: "Dental Investigation" },
//   { name: "Orthopantomogram (OPG) X-ray", cat: "Dental Investigation" },
//   { name: "Lateral Cephalogram X-ray", cat: "Dental Investigation" },
//   {
//     name: "Occlusal X-ray (Maxillary/Mandibular)",
//     cat: "Dental Investigation",
//   },
//   { name: "Bitewing Radiograph", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Dental 3D)", cat: "Dental Investigation" },

//   // ── COMMON BRAND NAMES (INDIA) ─────────────────────────────────
//   {
//     name: "Augmentin 625mg Tablet (Amoxicillin+Clavulanate)",
//     cat: "Antibiotic",
//   },
//   { name: "Azithral 500mg Tablet (Azithromycin)", cat: "Antibiotic" },
//   { name: "Cifran 500mg Tablet (Ciprofloxacin)", cat: "Antibiotic" },
//   { name: "Flagyl 400mg Tablet (Metronidazole)", cat: "Antibiotic" },
//   { name: "Doxy 100mg Capsule (Doxycycline)", cat: "Antibiotic" },
//   { name: "Calpol 650mg Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Dolo 650 Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Combiflam Tablet (Ibuprofen+Paracetamol)", cat: "NSAID Combo" },
//   { name: "Voveran 50mg Tablet (Diclofenac)", cat: "NSAID" },
//   { name: "Brufen 400mg Tablet (Ibuprofen)", cat: "NSAID" },
//   { name: "Ultracet Tablet (Tramadol+Paracetamol)", cat: "Analgesic Combo" },
//   { name: "Pan 40mg Tablet (Pantoprazole)", cat: "Antacid / PPI" },
//   { name: "Omez 20mg Capsule (Omeprazole)", cat: "Antacid / PPI" },
//   { name: "Ondem 4mg Tablet (Ondansetron)", cat: "Antiemetic" },
//   { name: "Stemetil 5mg Tablet (Prochlorperazine)", cat: "Antiemetic" },
//   { name: "Sinarest Tablet (Paracetamol+Phenylephrine)", cat: "Antihistamine" },
//   { name: "Allegra 120mg Tablet (Fexofenadine)", cat: "Antihistamine" },
//   {
//     name: "Montair-LC Tablet (Montelukast+Levocetirizine)",
//     cat: "Antihistamine",
//   },
//   { name: "Calpol Syrup (Paracetamol 120mg)", cat: "Painkiller" },
//   {
//     name: "Pyrimon Syrup (Mefenamic+Paracetamol Paediatric)",
//     cat: "Painkiller",
//   },
//   { name: "Perinorm 10mg Tablet (Metoclopramide)", cat: "Antiemetic" },
//   { name: "Rantac 150mg Tablet (Ranitidine)", cat: "Antacid / H2 Blocker" },
//   { name: "Kenacort Oral Paste (Triamcinolone)", cat: "Steroid Topical" },
//   { name: "Kenalog Injection 40mg (Triamcinolone)", cat: "Steroid Inj" },
//   { name: "Depo-Medrol 40mg Injection", cat: "Steroid Inj" },
//   { name: "Betnesol 0.5mg Tablet (Betamethasone)", cat: "Steroid" },
//   { name: "Wysolone 5mg Tablet (Prednisolone)", cat: "Steroid" },
//   { name: "Defcort 6mg Tablet (Deflazacort)", cat: "Steroid" },
//   { name: "Dexona 0.5mg Tablet (Dexamethasone)", cat: "Steroid" },
//   { name: "Mox 500mg Capsule (Amoxicillin)", cat: "Antibiotic" },
//   { name: "Sporanox 100mg Capsule (Itraconazole)", cat: "Antifungal" },
//   { name: "Zovirax 400mg Tablet (Acyclovir)", cat: "Antiviral" },
//   { name: "Valcivir 500mg Tablet (Valacyclovir)", cat: "Antiviral" },
//   { name: "Neosporin Powder (Neomycin+Bacitracin)", cat: "Topical Antibiotic" },
//   { name: "Betadine Ointment 5%", cat: "Antiseptic Topical" },
//   { name: "Borax Glycerine (Oral Ulcer)", cat: "Oral Care" },
//   { name: "Tantum Verde Mouthwash (Benzydamine)", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Recaldent (CPP-ACP Paste)", cat: "Dental Fluoride" },
//   { name: "Tooth Mousse Plus (GC)", cat: "Dental Fluoride" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Sensodyne Repair & Protect", cat: "Dental Brand" },
//   { name: "Colgate Sensitive Pro-Relief", cat: "Dental Brand" },
//   { name: "Pepsodent Germicheck", cat: "Dental Brand" },
//   { name: "Oral-B Toothbrush Indicator", cat: "Dental Brand" },
//   { name: "GUM Soft-Picks Interdental", cat: "Dental Brand" },
//   { name: "Floss (Oral-B Satin)", cat: "Dental Brand" },
//   { name: "Water Flosser", cat: "Dental Brand" },
//   { name: "Tongue Cleaner (Metal)", cat: "Dental Brand" },
//   { name: "Mouth Guard (Bruxism)", cat: "Dental Brand" },
// ];

// // ── Save a custom medicine — receives apiPost function from component
// // apiPost is api.post from api.js — same URL, same token, guaranteed correct
// function saveCustomMed(name, apiPost) {
//   if (!name || name.trim().length < 3) return Promise.resolve(null);
//   // Must contain at least one letter
//   if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
//   // Skip if already in built-in DB
//   const nameLow = name.trim().toLowerCase();
//   const already = MEDICINE_DB.some((m) => m.name.toLowerCase() === nameLow);
//   if (already) return Promise.resolve(null);
//   // Use api.post — same function used everywhere in this app
//   return apiPost("/custommeds", { name: name.trim(), cat: "Custom" })
//     .then((saved) => saved || null)
//     .catch(() => null);
// }

// // ── Google-style multi-word search — uses combined DB + custom meds from state
// // customMeds is passed in from component state (fetched from backend)
// function googleSearch(query, customMeds = []) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   if (!words.length) return [];

//   // Filter out any malformed entries (no name field)
//   const safeMeds = Array.isArray(customMeds)
//     ? customMeds.filter(
//         (m) => m && typeof m.name === "string" && m.name.trim().length > 0,
//       )
//     : [];

//   const combined = [
//     ...MEDICINE_DB,
//     ...safeMeds.map((m) => ({ ...m, _custom: true })),
//   ];

//   const scored = combined
//     .map((m) => {
//       // Guard against undefined name (safety check)
//       if (!m || typeof m.name !== "string") return { m, score: 0 };
//       const nameLow = m.name.toLowerCase();
//       const catLow = (m.cat || "").toLowerCase();
//       let score = 0;
//       for (const w of words) {
//         if (nameLow.startsWith(w)) score += 5;
//         else if (nameLow.includes(w)) score += 3;
//         else if (catLow.includes(w)) score += 1;
//       }
//       // Boost custom medicines so doctor's own entries appear first
//       if (m._custom) score += 2;
//       return { m, score };
//     })
//     .filter((x) => x.score > 0)
//     .sort((a, b) => b.score - a.score)
//     .map((x) => x.m);

//   return scored.slice(0, 12);
// }

// function highlightWords(text, query) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   let result = text;
//   words.forEach((w) => {
//     const re = new RegExp(
//       "(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
//       "gi",
//     );
//     result = result.replace(re, "<b>$1</b>");
//   });
//   return result;
// }

// // ── MedAutocomplete — Google-style medicine search ───────────
// function MedAutocomplete({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const taRef = React.useRef(null);
//   const wrapperRef = React.useRef(null);
//   const [suggestions, setSuggestions] = React.useState([]);
//   const [activeIdx, setActiveIdx] = React.useState(-1);
//   const [currentQuery, setCurrentQuery] = React.useState("");
//   const queryStartRef = React.useRef(0);
//   const queryEndRef = React.useRef(0);

//   const hideSuggestions = () => {
//     setSuggestions([]);
//     setActiveIdx(-1);
//     setCurrentQuery("");
//   };

//   // Single onChange handler — no onInput conflict
//   const handleChange = (e) => {
//     const ta = e.target;
//     const val = ta.value;
//     const cursor = ta.selectionStart;
//     onChange(val);

//     // Find start of current line/word being typed
//     let lineStart = cursor - 1;
//     while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
//     lineStart++;

//     const query = val.substring(lineStart, cursor);
//     queryStartRef.current = lineStart;
//     queryEndRef.current = cursor;

//     if (query.trim().length < 2) {
//       hideSuggestions();
//       return;
//     }
//     const matches = googleSearch(query, customMeds);
//     if (!matches.length) {
//       hideSuggestions();
//       return;
//     }
//     setCurrentQuery(query);
//     setSuggestions(matches);
//     setActiveIdx(-1);
//   };

//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       suggestions[activeIdx]
//     ) {
//       e.preventDefault();
//       selectMed(suggestions[activeIdx].name);
//     } else if (e.key === "Escape") {
//       hideSuggestions();
//     }
//   };

//   const selectMed = (name) => {
//     const ta = taRef.current;
//     const val = ta.value;
//     const before = val.substring(0, queryStartRef.current);
//     const after = val.substring(queryEndRef.current);
//     const newVal = before + name + after;
//     onChange(newVal);
//     hideSuggestions();
//     // Save to backend using api.post — correct URL guaranteed
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     // Restore cursor position after React re-render
//     setTimeout(() => {
//       if (taRef.current) {
//         const nc = queryStartRef.current + name.length;
//         taRef.current.setSelectionRange(nc, nc);
//         taRef.current.focus();
//         queryEndRef.current = nc;
//       }
//     }, 0);
//   };

//   // On blur — save full meaningful lines typed by doctor as custom medicines
//   const handleBlur = () => {
//     if (!taRef.current) return;
//     const val = taRef.current.value;
//     // Save lines that look like medicine names (>=3 chars, has a letter, not pure numbers)
//     val.split("\n").forEach((line) => {
//       const trimmed = line.trim();
//       if (
//         trimmed.length >= 3 &&
//         /[a-zA-Z]/.test(trimmed) &&
//         !/^[0-9\s]+$/.test(trimmed)
//       ) {
//         saveCustomMed(trimmed, apiPost).then((saved) => {
//           if (saved && onCustomSaved) onCustomSaved(saved);
//         });
//       }
//     });
//   };

//   // Click-outside handler using wrapperRef (not fixed id)
//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
//         hideSuggestions();
//       }
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   return (
//     <>
//       <style>{`
//         .med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}
//         .med-suggestion-item:last-child{border-bottom:none;}
//         .med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}
//         .med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}
//         .med-sug-name{font-weight:500;flex:1;color:#1a1614;}
//         .med-sug-name b{color:#0d7377;font-weight:700;}
//         .med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}
//       `}</style>
//       <div style={{ position: "relative" }} ref={wrapperRef}>
//         <textarea
//           ref={taRef}
//           value={value}
//           onChange={handleChange}
//           onKeyDown={handleKeyDown}
//           onBlur={handleBlur}
//           autoComplete="off"
//           placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
//         />
//         {suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderTop: "none",
//               borderRadius: "0 0 12px 12px",
//               boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
//               zIndex: 99999,
//               maxHeight: 280,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {suggestions.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 className={
//                   "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
//                 }
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   selectMed(m.name);
//                 }}
//               >
//                 <span className="med-sug-icon">💊</span>
//                 <span
//                   className="med-sug-name"
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, currentQuery),
//                   }}
//                 />
//                 <span className="med-sug-cat">{m.cat}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── Prescription Modal — exact original PDF design ────────────
// function PrescriptionModal({ visit, patient, doctor, onClose, showNotify }) {
//   const [pdfUrl, setPdfUrl] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [pdfBlob, setPdfBlob] = useState(null);
//   const [rxMobile, setRxMobile] = useState("");
//   const [fileName, setFileName] = useState("");
//   const [canNativeShare, setCanNativeShare] = useState(false);

//   useEffect(() => {
//     generatePDF();
//   }, []);

//   // Close on Escape
//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     document.addEventListener("keydown", handler);
//     return () => document.removeEventListener("keydown", handler);
//   }, [onClose]);

//   const fmtDateLocal = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr + "T00:00:00");
//     return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
//   };

//   const fmtTimeLocal = (t) => {
//     if (!t) return "";
//     const parts = t.split(":");
//     const hh = parseInt(parts[0]),
//       mm = parts[1];
//     return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
//   };

//   const generatePDF = () => {
//     if (window.jspdf) {
//       buildPDF();
//       return;
//     }
//     const existing = document.getElementById("jspdf-cdn");
//     if (existing) {
//       existing.addEventListener("load", buildPDF);
//       return;
//     }
//     const script = document.createElement("script");
//     script.id = "jspdf-cdn";
//     script.src =
//       "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
//     script.crossOrigin = "anonymous";
//     script.onload = buildPDF;
//     script.onerror = () => setLoading(false);
//     document.head.appendChild(script);
//   };

//   const buildPDF = () => {
//     const { jsPDF } = window.jspdf;
//     const pdf = new jsPDF({
//       unit: "mm",
//       format: "a4",
//       orientation: "portrait",
//     });
//     const W = 210,
//       H = 297;

//     const sf = (c) => pdf.setFillColor(c[0], c[1], c[2]);
//     const sd = (c) => pdf.setDrawColor(c[0], c[1], c[2]);
//     const st = (c) => pdf.setTextColor(c[0], c[1], c[2]);

//     const NAVY = [8, 25, 65],
//       BLUE = [20, 80, 160],
//       BLUE2 = [40, 110, 190];
//     const LBLUE = [210, 228, 248],
//       LBLUE2 = [232, 242, 252],
//       MIDBLUE = [160, 195, 235];
//     const TEAL = [0, 130, 130],
//       TEAL2 = [210, 240, 240];
//     const WHITE = [255, 255, 255],
//       LGRAY = [245, 247, 251],
//       LGRAY2 = [250, 251, 254],
//       LGRAY3 = [240, 243, 248];
//     const GRAY = [115, 118, 130],
//       GRAY2 = [75, 80, 95];
//     const GOLD = [170, 130, 40],
//       GOLD2 = [250, 245, 225];

//     const today = new Date();
//     const todayFmt =
//       today.getDate() +
//       " " +
//       MONTHS[today.getMonth()] +
//       " " +
//       today.getFullYear();
//     const rxNum =
//       "PS-" +
//       today.getFullYear() +
//       ("0" + (today.getMonth() + 1)).slice(-2) +
//       ("0" + today.getDate()).slice(-2) +
//       "-" +
//       Math.floor(1000 + Math.random() * 8999);

//     const visitDate = visit.visitDate || "";
//     const visitTime = visit.visitTime || "";
//     const notes = visit.notes || "";
//     const nextDate = visit.nextVisitDate || "";
//     const service = visit.service || "";
//     const doc = { name: doctor?.name || "Doctor", qual: "", reg: "" };

//     const visitDateFmt = fmtDateLocal(visitDate);
//     const visitTimeFmt = fmtTimeLocal(visitTime);
//     const nextDateFmt = fmtDateLocal(nextDate);

//     // ── Outer border ─────────────────────────────────────────────
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.8);
//     pdf.rect(3.5, 3.5, W - 7, H - 7, "S");
//     sd(LBLUE);
//     pdf.setLineWidth(0.3);
//     pdf.rect(5.5, 5.5, W - 11, H - 11, "S");

//     // ── Header ───────────────────────────────────────────────────
//     sf(NAVY);
//     pdf.rect(3.5, 3.5, W - 7, 46, "F");
//     sf(BLUE);
//     pdf.rect(3.5, 43, W - 7, 10, "F");
//     sf(LBLUE);
//     pdf.rect(3.5, 53, W - 7, 6, "F");

//     st(WHITE);
//     pdf.setFontSize(18);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(doc.name, 14, 19);
//     st(LBLUE);
//     pdf.setFontSize(8);
//     pdf.setFont("helvetica", "normal");
//     pdf.text((doc.qual || "").toUpperCase(), 14, 26);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(14, 28.5, W - 40, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(7);
//     pdf.text("Reg. No.:  " + (doc.reg || "—"), 14, 33.5);
//     pdf.text("Specialisation:  Dental & Oral Health Care", 14, 38.5);

//     st(WHITE);
//     pdf.setFontSize(15);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PEARLSMILE", W - 10, 19, { align: "right" });
//     st(LBLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("DENTAL HOSPITAL", W - 10, 25.5, { align: "right" });
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(W - 72, 28.5, W - 10, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(6.8);
//     pdf.text("12, Dental Plaza, MG Road, Pune - 411001", W - 10, 33.5, {
//       align: "right",
//     });
//     pdf.text("+91 87936 08083  |  care@pearlsmiledental.in", W - 10, 38.5, {
//       align: "right",
//     });

//     st(WHITE);
//     pdf.setFontSize(9);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("DIGITAL PRESCRIPTION", W / 2, 50, { align: "center" });
//     st(LBLUE2);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 10, 50);
//     pdf.text("Date: " + todayFmt, W - 10, 50, { align: "right" });

//     st(BLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PATIENT INFORMATION", W / 2, 57, { align: "center" });

//     // ── Patient info table ────────────────────────────────────────
//     const infoTop = 61;
//     sf(LGRAY3);
//     pdf.rect(10, infoTop, W - 20, 44, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, infoTop, W - 20, 44, "S");
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.2);
//     pdf.line(W / 2, infoTop, W / 2, infoTop + 44);
//     let rdy = infoTop + 11;
//     for (let ri = 0; ri < 3; ri++) {
//       pdf.line(10, rdy, W - 10, rdy);
//       rdy += 11;
//     }

//     const drawCell = (label, value, x, y, maxW) => {
//       st(GRAY2);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.8);
//       pdf.text(label, x + 3, y + 4);
//       st(NAVY);
//       pdf.setFont("helvetica", "normal");
//       pdf.setFontSize(8.5);
//       const val = pdf.splitTextToSize(String(value || "—"), maxW || 75);
//       pdf.text(val[0], x + 3, y + 9.5);
//     };
//     const cHalf = W / 2;
//     drawCell("PATIENT NAME", patient.name || "—", 10, infoTop, cHalf - 16);
//     drawCell("MOBILE", patient.mobile || "—", cHalf, infoTop, cHalf - 16);
//     drawCell("EMAIL", patient.email || "—", 10, infoTop + 11, cHalf - 16);
//     drawCell(
//       "BLOOD GROUP",
//       patient.blood || "—",
//       cHalf,
//       infoTop + 11,
//       cHalf - 16,
//     );
//     drawCell(
//       "AGE / GENDER",
//       (patient.age || "—") + (patient.gender ? "  |  " + patient.gender : ""),
//       10,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell(
//       "VISIT DATE",
//       visitDateFmt + (visitTimeFmt ? " (" + visitTimeFmt + ")" : ""),
//       cHalf,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell("SERVICE/TREATMENT", service || "—", 10, infoTop + 33, cHalf - 16);
//     drawCell(
//       "NEXT VISIT DATE",
//       nextDateFmt || "—",
//       cHalf,
//       infoTop + 33,
//       cHalf - 16,
//     );

//     // ── Clinical Notes ────────────────────────────────────────────
//     const diagTop = infoTop + 50;
//     sf(BLUE);
//     pdf.rect(10, diagTop, W - 20, 8, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(8.5);
//     pdf.text(
//       "Rx   CLINICAL NOTES / DIAGNOSIS & PRESCRIPTION",
//       14,
//       diagTop + 5.5,
//     );
//     st(GOLD);
//     pdf.setFontSize(10);
//     pdf.text("Rx", W - 16, diagTop + 5.5, { align: "right" });

//     const notesBoxH = 56;
//     sf(LGRAY2);
//     pdf.rect(10, diagTop + 8, W - 20, notesBoxH, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, diagTop + 8, W - 20, notesBoxH, "S");
//     sd([215, 225, 240]);
//     pdf.setLineWidth(0.15);
//     for (let rl = 0; rl < 7; rl++)
//       pdf.line(14, diagTop + 16 + rl * 7, W - 14, diagTop + 16 + rl * 7);
//     st(NAVY);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(9.5);
//     const noteLines = pdf.splitTextToSize(
//       notes || "No diagnosis or notes recorded for this visit.",
//       W - 30,
//     );
//     pdf.text(noteLines, 14, diagTop + 15);

//     // ── Next appointment box ──────────────────────────────────────
//     let afterY = diagTop + notesBoxH + 10;
//     if (nextDateFmt) {
//       sf(TEAL2);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "F");
//       sd(TEAL);
//       pdf.setLineWidth(0.4);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "S");
//       sf(TEAL);
//       pdf.roundedRect(10, afterY, 10, 13, 2, 2, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.5);
//       pdf.text("NEXT", 11.2, afterY + 5.5);
//       pdf.text("VISIT", 11.0, afterY + 10);
//       st(TEAL);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(9);
//       pdf.text("Next Appointment:", 24, afterY + 6.5);
//       st(NAVY);
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "bold");
//       pdf.text(nextDateFmt, 72, afterY + 6.5);
//       st(GRAY);
//       pdf.setFontSize(7);
//       pdf.setFont("helvetica", "italic");
//       pdf.text(
//         "Please arrive 10 minutes early and bring this prescription.",
//         24,
//         afterY + 11,
//       );
//       afterY += 19;
//     }

//     // ── General advice box ────────────────────────────────────────
//     const advY = afterY + 4;
//     sf(GOLD2);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "F");
//     sd(GOLD);
//     pdf.setLineWidth(0.35);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "S");
//     sf(GOLD);
//     pdf.roundedRect(10, advY, 10, 20, 2, 2, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(6.2);
//     pdf.text("GEN.", 11.2, advY + 8);
//     pdf.text("ADV.", 11.2, advY + 13.5);
//     st(GOLD);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("General Advice:", 24, advY + 6.5);
//     st(GRAY2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(
//       "1.  Follow all prescribed medicines on time and complete the full course.",
//       24,
//       advY + 11.5,
//     );
//     pdf.text(
//       "2.  Maintain good oral hygiene. Brush gently twice daily.",
//       24,
//       advY + 15.5,
//     );
//     pdf.text(
//       "3.  Avoid very hot, cold, or hard foods until fully healed.",
//       24,
//       advY + 19.2,
//     );

//     // ── Watermark ─────────────────────────────────────────────────
//     pdf.saveGraphicsState();
//     pdf.setGState(new pdf.GState({ opacity: 0.035 }));
//     st(NAVY);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(44);
//     pdf.text("PEARLSMILE", W / 2, H / 2 - 5, { align: "center", angle: 35 });
//     pdf.restoreGraphicsState();

//     // ── Doctor seal ───────────────────────────────────────────────
//     const sigY = Math.max(advY + 28, H - 55);
//     const INK = [28, 52, 140],
//       INK2 = [45, 75, 170];
//     const cx = W - 46,
//       cy = sigY + 13,
//       R = 18;

//     sd(INK);
//     pdf.setLineWidth(1.2);
//     pdf.circle(cx, cy, R, "S");
//     pdf.setLineWidth(0.4);
//     pdf.circle(cx, cy, R - 2.5, "S");

//     const drawStar = (sx, sy, sr) => {
//       const pts = [];
//       for (let si = 0; si < 5; si++) {
//         const ao = (si * 4 * Math.PI) / 5 - Math.PI / 2,
//           ai = ao + (2 * Math.PI) / 5;
//         pts.push({ x: sx + sr * Math.cos(ao), y: sy + sr * Math.sin(ao) });
//         pts.push({
//           x: sx + sr * 0.4 * Math.cos(ai),
//           y: sy + sr * 0.4 * Math.sin(ai),
//         });
//       }
//       pdf.setLineWidth(0.3);
//       sd(INK);
//       sf(INK);
//       pdf.lines(
//         pts.slice(1).map((pt, i) => [pt.x - pts[i].x, pt.y - pts[i].y]),
//         pts[0].x,
//         pts[0].y,
//         [1, 1],
//         "FD",
//         true,
//       );
//     };
//     drawStar(cx - R + 3.5, cy + 1, 2.2);
//     drawStar(cx + R - 3.5, cy + 1, 2.2);

//     const docShort = (doc.name || "Doctor").toUpperCase();
//     sd(INK);
//     st(INK);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(5.8);
//     const topSpan = Math.min(docShort.length * 0.19, 1.3);
//     const topStart = -Math.PI / 2 - topSpan / 2;
//     for (let ti = 0; ti < docShort.length; ti++) {
//       const ta = topStart + (ti / Math.max(docShort.length - 1, 1)) * topSpan;
//       const tx = cx + (R - 1.5) * Math.cos(ta),
//         ty = cy + (R - 1.5) * Math.sin(ta);
//       const trot = ((ta + Math.PI / 2) * 180) / Math.PI;
//       pdf.text(docShort[ti], tx, ty, { align: "center", angle: -trot });
//     }

//     pdf.setFontSize(5.5);
//     const botStr = "PEARLSMILE DENTAL";
//     const botSpan = Math.min(botStr.length * 0.175, 1.4);
//     const botStart = Math.PI / 2 - botSpan / 2;
//     for (let bi = 0; bi < botStr.length; bi++) {
//       const ba = botStart + (bi / Math.max(botStr.length - 1, 1)) * botSpan;
//       const bx = cx + (R - 1.5) * Math.cos(ba),
//         by = cy + (R - 1.5) * Math.sin(ba);
//       const brot = ((ba - Math.PI / 2) * 180) / Math.PI;
//       pdf.text(botStr[bi], bx, by, { align: "center", angle: -brot });
//     }

//     sd(INK);
//     pdf.setLineWidth(0.8);
//     pdf.line(cx, cy - 8, cx, cy + 7);
//     pdf.setLineWidth(0.5);
//     pdf.line(cx, cy - 7.5, cx - 4, cy - 9.5);
//     pdf.line(cx - 4, cy - 9.5, cx - 6, cy - 8);
//     pdf.line(cx - 6, cy - 8, cx - 3, cy - 6.5);
//     pdf.line(cx, cy - 7.5, cx + 4, cy - 9.5);
//     pdf.line(cx + 4, cy - 9.5, cx + 6, cy - 8);
//     pdf.line(cx + 6, cy - 8, cx + 3, cy - 6.5);
//     sf(INK);
//     pdf.circle(cx, cy - 8.2, 1, "F");

//     pdf.setLineWidth(0.6);
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//         [0, -2],
//       ],
//       cx - 3,
//       cy + 5,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [-2, -2],
//         [-2, -2],
//         [0, -2],
//       ],
//       cx + 3,
//       cy + 1,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//       ],
//       cx - 3,
//       cy - 3,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [-2, -2],
//         [-2, -2],
//         [0, -2],
//       ],
//       cx + 3,
//       cy + 5,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//         [0, -2],
//       ],
//       cx - 3,
//       cy + 1,
//       [1, 1],
//       "S",
//     );

//     st(INK);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(4.5);
//     pdf.text("Reg. " + (doc.reg || "—"), cx, cy + R - 5.5, { align: "center" });
//     st(INK2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(6.5);
//     pdf.text("Authorised Signatory", cx, cy + R + 4, { align: "center" });

//     st(GRAY);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 14, sigY + 30);
//     pdf.text("Date: " + todayFmt, W - 14, sigY + 30, { align: "right" });

//     // ── Footer ────────────────────────────────────────────────────
//     sf(NAVY);
//     pdf.rect(3.5, H - 21, W - 7, 17.5, "F");
//     sf(BLUE);
//     pdf.rect(3.5, H - 7, W - 7, 3.5, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(7.5);
//     pdf.text("PearlSmile Dental Hospital", 10, H - 14.5);
//     st(LBLUE);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text("+91 87936 08083", 10, H - 9.5);
//     pdf.text("care@pearlsmiledental.in", W / 2, H - 9.5, { align: "center" });
//     pdf.text("12, Dental Plaza, MG Road, Pune - 411001", W - 10, H - 9.5, {
//       align: "right",
//     });
//     st(LBLUE2);
//     pdf.setFontSize(6);
//     pdf.setFont("helvetica", "italic");
//     pdf.text(
//       "This is a computer-generated prescription from PearlSmile Dental Hospital. Valid only with authorised doctor details.",
//       W / 2,
//       H - 5.5,
//       { align: "center" },
//     );

//     // ── Output ────────────────────────────────────────────────────
//     const blob = pdf.output("blob");
//     const url = URL.createObjectURL(blob);
//     const name =
//       "Prescription_" +
//       (patient.name || "Patient").replace(/\s+/g, "_") +
//       "_" +
//       visitDate +
//       ".pdf";

//     let rawMob = (patient.mobile || "").replace(/[\s\-\(\)\+]/g, "");
//     if (!rawMob.startsWith("91") && rawMob.length === 10)
//       rawMob = "91" + rawMob;

//     setPdfBlob(blob);
//     setPdfUrl(url);
//     setRxMobile(rawMob);
//     setFileName(name);
//     // Show native share button only if Web Share API supports files — exactly like original HTML
//     const testFile = new File([blob], name, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [testFile] })
//     ) {
//       setCanNativeShare(true);
//     }
//     setLoading(false);
//   };

//   const downloadPDF = () => {
//     const link = document.createElement("a");
//     link.href = pdfUrl;
//     link.download = fileName;
//     link.click();
//   };

//   const openFullPreview = () => {
//     if (pdfUrl) window.open(pdfUrl, "_blank");
//   };

//   const shareViaWhatsApp = () => {
//     if (rxMobile) window.open("https://wa.me/" + rxMobile, "_blank");
//     showNotify(
//       "WhatsApp Opened!",
//       "Attach the PDF from the preview and send to patient.",
//     );
//   };

//   const nativeShare = async () => {
//     if (!pdfBlob) return;
//     const file = new File([pdfBlob], fileName, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [file] })
//     ) {
//       navigator
//         .share({
//           title: "Digital Prescription — PearlSmile Dental Hospital",
//           text: "",
//           files: [file],
//         })
//         .then(() => {
//           showNotify("Shared!", "Prescription shared successfully.");
//           // After sharing, open WhatsApp to patient's number directly
//           if (rxMobile) {
//             setTimeout(
//               () => window.open("https://wa.me/" + rxMobile, "_blank"),
//               800,
//             );
//           }
//           onClose();
//         })
//         .catch((err) => {
//           if (err.name !== "AbortError")
//             showNotify("Share Failed", err.message, true);
//         });
//     } else {
//       showNotify(
//         "Not Supported",
//         "Native share not supported on this device/browser.",
//         true,
//       );
//     }
//   };

//   return (
//     <div
//       className="rx-share-overlay open"
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           width: "100%",
//           maxWidth: 540,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//           maxHeight: "92vh",
//         }}
//       >
//         {/* Header */}
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "18px 22px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <span style={{ fontSize: 22 }}>📄</span>
//             <div>
//               <div
//                 style={{
//                   color: "#fff",
//                   fontWeight: 600,
//                   fontSize: 15,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Digital Prescription Ready
//               </div>
//               <div
//                 style={{
//                   color: "rgba(255,255,255,0.55)",
//                   fontSize: 12,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 {patient.name} · {visit.visitDate}
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 17,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             ✕
//           </button>
//         </div>

//         {/* PDF Preview */}
//         <div
//           style={{
//             flex: 1,
//             overflow: "hidden",
//             background: "#f0eeeb",
//             minHeight: 340,
//             position: "relative",
//           }}
//         >
//           {loading && (
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: "#f0eeeb",
//                 gap: 10,
//               }}
//             >
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   border: "3px solid #0d7377",
//                   borderTopColor: "transparent",
//                   borderRadius: "50%",
//                   animation: "spin 0.8s linear infinite",
//                 }}
//               />
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "#5a5550",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Generating PDF…
//               </div>
//             </div>
//           )}
//           {pdfUrl && (
//             <iframe
//               title="prescription"
//               src={pdfUrl}
//               style={{ width: "100%", height: 420, border: "none" }}
//             />
//           )}
//         </div>

//         {/* Action buttons — exactly like original HTML */}
//         <div
//           style={{
//             padding: "16px 20px",
//             display: "flex",
//             flexDirection: "column",
//             gap: 10,
//             background: "#fff",
//           }}
//         >
//           <div style={{ display: "flex", gap: 8 }}>
//             <button
//               onClick={openFullPreview}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//             >
//               🔍 Open Full PDF
//             </button>
//             {canNativeShare && (
//               <button
//                 onClick={nativeShare}
//                 onMouseOver={(e) =>
//                   (e.currentTarget.style.background = "#e5e0d8")
//                 }
//                 onMouseOut={(e) =>
//                   (e.currentTarget.style.background = "#f0eeeb")
//                 }
//                 style={{
//                   flex: 1,
//                   background: "#f0eeeb",
//                   color: "#0a1628",
//                   border: "1.5px solid #ddd9d3",
//                   borderRadius: 10,
//                   padding: 10,
//                   fontSize: 13,
//                   fontWeight: 500,
//                   cursor: "pointer",
//                   fontFamily: "DM Sans,sans-serif",
//                   transition: "background 0.2s",
//                 }}
//               >
//                 📤 Share (Device)
//               </button>
//             )}
//           </div>
//           <p
//             style={{
//               fontSize: 11,
//               color: "#9a9590",
//               textAlign: "center",
//               margin: 0,
//               fontFamily: "DM Sans,sans-serif",
//               lineHeight: 1.5,
//             }}
//           >
//             On mobile: tap "Share (Device)" to send directly via WhatsApp.
//             <br />
//             On desktop: use "Open Full PDF" to view, then share manually.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

////////////////// correct code 5/4/2026 end here////////////////

// /////////////////// correct code start here with table medicine //////////////////

// // ============================================================
// // src/components/admin/PatientsTab.js
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import api from "../../utils/api";

// const SERVICES_LIST = [
//   "General Checkup & Cleaning",
//   "Cosmetic Dentistry / Smile Makeover",
//   "Dental Implants",
//   "Orthodontics / Invisalign",
//   "Root Canal Therapy",
//   "Pediatric Dentistry",
//   "Oral Surgery",
//   "Periodontal Treatment",
//   "Teeth Whitening",
//   "Emergency Dental Care",
//   "Follow-Up Visit",
//   "Other",
// ];

// const MONTHS = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];
// const MONTHS_SHORT = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// function fmtDate(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtDateShort(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS_SHORT[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtTime(t) {
//   if (!t) return "";
//   const parts = t.split(":");
//   const hh = parseInt(parts[0]),
//     mm = parts[1];
//   return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
// }

// function totalRevenue(visits = []) {
//   return visits.reduce((sum, v) => {
//     const n = parseFloat((v.amount || "0").toString().replace(/[^0-9.]/g, ""));
//     return sum + (isNaN(n) ? 0 : n);
//   }, 0);
// }

// export default function PatientsTab({ showNotify, doctor }) {
//   const [patients, setPatients] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showNewForm, setShowNewForm] = useState(false);
//   const [newPat, setNewPat] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     age: "",
//     gender: "",
//     blood: "",
//   });
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [rxModal, setRxModal] = useState(null);
//   // Custom medicines — fetched from backend, shared across all doctors/devices
//   const [customMeds, setCustomMeds] = useState([]);

//   const today = new Date().toISOString().split("T")[0];
//   const nowTime = new Date().toTimeString().slice(0, 5);
//   const [visitForm, setVisitForm] = useState({
//     date: today,
//     time: nowTime,
//     service: "",
//     amount: "",
//     nextVisitDate: "",
//     notes: "",
//     rxRows: [
//       {
//         medicine: "",
//         dosageParts: ["0", "0", "0"],
//         dosageTiming: "after meal",
//         dosage: "",
//         duration: "",
//         route: "ORAL",
//       },
//     ],
//   });

//   const loadPatients = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await api.get("/patients");
//       setPatients(data);
//       setFiltered(data);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     loadPatients();
//   }, [loadPatients]);

//   // Fetch custom medicines from backend on mount — shared across all doctors/devices
//   useEffect(() => {
//     api
//       .get("/custommeds")
//       .then((data) => {
//         if (Array.isArray(data)) setCustomMeds(data);
//       })
//       .catch(() => {});
//   }, []);

//   const filterPatients = (q) => {
//     const term = q.toLowerCase();
//     setFiltered(
//       patients.filter(
//         (p) =>
//           (p.name || "").toLowerCase().includes(term) ||
//           (p.mobile || "").includes(term) ||
//           (p.email || "").toLowerCase().includes(term),
//       ),
//     );
//   };

//   const createPatient = async () => {
//     if (!newPat.name.trim()) {
//       showNotify("Error", "Patient name is required.", true);
//       return;
//     }
//     if (!newPat.mobile.trim()) {
//       showNotify("Error", "Mobile number is required.", true);
//       return;
//     }
//     try {
//       await api.post("/patients", newPat);
//       setNewPat({
//         name: "",
//         mobile: "",
//         email: "",
//         age: "",
//         gender: "",
//         blood: "",
//       });
//       setShowNewForm(false);
//       showNotify(
//         "Patient Profile Created! ✓",
//         "New profile for " + newPat.name + " saved.",
//       );
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const openPatient = async (p) => {
//     try {
//       const full = await api.get("/patients/" + p._id);
//       setSelectedPatient(full);
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deletePatient = async () => {
//     if (
//       !window.confirm(
//         "Delete this patient profile and all their records? This cannot be undone.",
//       )
//     )
//       return;
//     try {
//       await api.delete("/patients/" + selectedPatient._id);
//       showNotify("Profile Deleted", "Patient profile removed.");
//       setSelectedPatient(null);
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const saveVisit = async () => {
//     if (!visitForm.date) {
//       showNotify("Missing Fields", "Please select a visit date.", true);
//       return;
//     }
//     if (!visitForm.service) {
//       showNotify("Missing Fields", "Please select a service.", true);
//       return;
//     }
//     try {
//       const payload = {
//         visitDate: visitForm.date,
//         visitTime: visitForm.time,
//         service: visitForm.service,
//         amount: visitForm.amount,
//         nextVisitDate: visitForm.nextVisitDate,
//         notes: visitForm.notes,
//         doctor: doctor?.name || "",
//         prescription: {
//           medicineRows: visitForm.rxRows.filter((r) => r.medicine.trim()),
//         },
//       };
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/visits",
//         payload,
//       );
//       setSelectedPatient(updated);

//       // ── Auto-create appointment for follow-up date ──────────
//       // If nextVisitDate is set → create an upcoming appointment entry
//       // so it appears in Appointments tab → Upcoming Appointments
//       if (visitForm.nextVisitDate && selectedPatient.mobile) {
//         try {
//           await api.post("/appointments", {
//             name: selectedPatient.name,
//             phone: selectedPatient.mobile,
//             service: visitForm.service,
//             date: visitForm.nextVisitDate,
//             time: "",
//             message: "Follow-up visit from Patient Profile",
//             status: "pending",
//           });
//         } catch (_) {
//           // Silently ignore if appointment creation fails
//         }
//       }

//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });

//       // Follow-up WhatsApp if notes contain "follow-up" and nextVisitDate is set
//       const isFollowUp = /follow[\s\-]?up/i.test(visitForm.notes);
//       if (isFollowUp && visitForm.nextVisitDate && selectedPatient.mobile) {
//         let rawMobile = (selectedPatient.mobile || "").replace(
//           /[\s\-\(\)\+]/g,
//           "",
//         );
//         if (!rawMobile.startsWith("91") && rawMobile.length === 10)
//           rawMobile = "91" + rawMobile;
//         const waMsg = `*PearlSmile Dental Hospital* — Follow-Up Reminder\n\nDear ${selectedPatient.name},\nThis is a reminder for your follow-up appointment.\n\n*Service:* ${visitForm.service}\n*Next Visit:* ${fmtDate(visitForm.nextVisitDate)}\n\nPlease call us to confirm your appointment.\n📞 +91 87936 08083`;
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" +
//                 rawMobile +
//                 "?text=" +
//                 encodeURIComponent(waMsg),
//               "_blank",
//             ),
//           500,
//         );
//         showNotify(
//           "Visit Saved + Follow-Up Appointment Created!",
//           "Reminder sent to " +
//             selectedPatient.name +
//             " for " +
//             fmtDate(visitForm.nextVisitDate) +
//             ". Appointment added to Upcoming.",
//         );
//       } else if (visitForm.nextVisitDate) {
//         showNotify(
//           "Visit Saved + Appointment Created! ✓",
//           "Follow-up appointment for " +
//             fmtDate(visitForm.nextVisitDate) +
//             " added to Upcoming Appointments.",
//         );
//       } else {
//         showNotify(
//           "Visit Record Saved! ✓",
//           "Patient visit has been recorded successfully.",
//         );
//       }
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deleteVisit = async (visitId) => {
//     if (!window.confirm("Delete this visit record?")) return;
//     try {
//       const result = await api.delete(
//         "/patients/" + selectedPatient._id + "/visits/" + visitId,
//       );
//       setSelectedPatient(result.patient);
//       showNotify("Visit Deleted", "Visit record removed.");
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const sendPrescription = (visit) => {
//     // Use the doctor who treated the patient (stored in visit.doctor)
//     // not the currently logged-in doctor
//     const treatingDoctor = visit.doctor ? { name: visit.doctor } : doctor;
//     setRxModal({ visit, patient: selectedPatient, doctor: treatingDoctor });
//   };

//   // ── LIST VIEW ─────────────────────────────────────────────────
//   if (!selectedPatient) {
//     return (
//       <div>
//         <div className="admin-section-title">Patient Profiles</div>
//         <div className="admin-section-desc">
//           Create and manage individual patient profiles. Click a profile to view
//           visit history and add new records.
//         </div>

//         <div className="patients-list-view">
//           <input
//             type="text"
//             className="patient-search-bar"
//             placeholder="🔍 Search patients by name or phone..."
//             onChange={(e) => filterPatients(e.target.value)}
//           />

//           {showNewForm && (
//             <div className="new-patient-form">
//               <h4>➕ Create New Patient Profile</h4>
//               <div className="new-patient-grid">
//                 {[
//                   ["name", "text", "Full Name *", "Patient full name"],
//                   ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
//                   ["email", "email", "Email Address", "patient@email.com"],
//                   ["age", "number", "Age", "Age"],
//                 ].map(([k, t, label, ph]) => (
//                   <div key={k}>
//                     <div className="admin-row-label">{label}</div>
//                     <input
//                       type={t}
//                       placeholder={ph}
//                       value={newPat[k]}
//                       onChange={(e) =>
//                         setNewPat((p) => ({ ...p, [k]: e.target.value }))
//                       }
//                     />
//                   </div>
//                 ))}
//                 <div>
//                   <div className="admin-row-label">Gender</div>
//                   <select
//                     value={newPat.gender}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, gender: e.target.value }))
//                     }
//                   >
//                     <option value="">Select Gender</option>
//                     <option>Male</option>
//                     <option>Female</option>
//                     <option>Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <div className="admin-row-label">Blood Group</div>
//                   <input
//                     type="text"
//                     placeholder="e.g. B+"
//                     value={newPat.blood}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, blood: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//               <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                 <button className="add-visit-save-btn" onClick={createPatient}>
//                   💾 Save Patient Profile
//                 </button>
//                 <button
//                   className="btn-back-patients"
//                   onClick={() => setShowNewForm(false)}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           )}

//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: 14,
//               flexWrap: "wrap",
//               gap: 10,
//             }}
//           >
//             <div style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {loading
//                 ? "Loading patients..."
//                 : `${filtered.length} patient profile${filtered.length !== 1 ? "s" : ""}`}
//             </div>
//             <button
//               className="admin-add-btn"
//               onClick={() => setShowNewForm((s) => !s)}
//             >
//               {showNewForm ? "Cancel" : "+ New Patient Profile"}
//             </button>
//           </div>

//           <div className="patient-profiles-grid">
//             {loading ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "20px 0",
//                   gridColumn: "1/-1",
//                 }}
//               >
//                 Loading...
//               </div>
//             ) : filtered.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "24px 0",
//                   gridColumn: "1/-1",
//                   textAlign: "center",
//                 }}
//               >
//                 No patients yet. Click "+ New Patient Profile" to add your first
//                 patient.
//               </div>
//             ) : (
//               filtered.map((p) => (
//                 <div
//                   key={p._id}
//                   className="patient-profile-card"
//                   onClick={() => openPatient(p)}
//                 >
//                   <div className="patient-avatar-icon">🧑‍⚕️</div>
//                   <div className="patient-card-name">{p.name}</div>
//                   <div className="patient-card-id">📞 {p.mobile || "—"}</div>
//                   <div className="patient-card-visits">
//                     📋 {p.visitCount || 0} visit{p.visitCount !== 1 ? "s" : ""}
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ── DETAIL VIEW ───────────────────────────────────────────────
//   const p = selectedPatient;
//   const visits = p.visits || [];
//   const total = totalRevenue(visits);

//   return (
//     <div>
//       <div className="patient-detail-view open">
//         <div className="patient-detail-header">
//           <button
//             className="btn-back-patients"
//             onClick={() => {
//               setSelectedPatient(null);
//             }}
//           >
//             ← Back to Patients
//           </button>
//           <div
//             className="patient-avatar-icon"
//             style={{ width: 56, height: 56, fontSize: 26 }}
//           >
//             🧑‍⚕️
//           </div>
//           <div style={{ flex: 1 }}>
//             <h3>{p.name}</h3>
//             <p style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {p.email}
//               {p.email && p.mobile ? " · " : ""}
//               {p.mobile}
//             </p>
//             <div className="patient-info-row">
//               {[
//                 p.age ? "Age: " + p.age : null,
//                 p.gender || null,
//                 p.blood ? "Blood: " + p.blood : null,
//               ]
//                 .filter(Boolean)
//                 .map((t, i) => (
//                   <span key={i} className="patient-info-pill">
//                     {t}
//                   </span>
//                 ))}
//             </div>
//           </div>
//           <div style={{ textAlign: "right", flexShrink: 0 }}>
//             <div
//               style={{
//                 fontSize: 11,
//                 color: "var(--gray-400)",
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//                 marginBottom: 4,
//               }}
//             >
//               Total Revenue
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 26,
//                 fontWeight: 600,
//                 color: "var(--teal)",
//                 lineHeight: 1,
//               }}
//             >
//               Rs. {total.toLocaleString("en-IN")}
//             </div>
//             <div
//               style={{ fontSize: 11, color: "var(--gray-400)", marginTop: 2 }}
//             >
//               {visits.length} visit{visits.length !== 1 ? "s" : ""}
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 8,
//               alignSelf: "flex-start",
//               marginTop: 4,
//             }}
//           >
//             <button className="admin-del-btn" onClick={deletePatient}>
//               🗑️ Delete Profile
//             </button>
//           </div>
//         </div>

//         {/* Add Visit Form — original simple layout */}
//         <div className="add-visit-form">
//           <h4>📋 Add New Visit Record</h4>
//           <div className="add-visit-grid">
//             <div>
//               <div className="admin-row-label">Visit Date *</div>
//               <input
//                 type="date"
//                 value={visitForm.date}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, date: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Visit Time</div>
//               <input
//                 type="time"
//                 value={visitForm.time}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, time: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Service Taken *</div>
//               <select
//                 value={visitForm.service}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, service: e.target.value }))
//                 }
//               >
//                 <option value="">Select Service</option>
//                 {SERVICES_LIST.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <div className="admin-row-label">Amount Charged (Rs.)</div>
//               <input
//                 type="text"
//                 placeholder="e.g. 2500"
//                 value={visitForm.amount}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, amount: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div
//                 className="admin-row-label"
//                 style={{ display: "flex", alignItems: "center", gap: 6 }}
//               >
//                 Next Date to Visit
//                 <span
//                   style={{
//                     fontSize: 10,
//                     color: "var(--teal)",
//                     fontWeight: 400,
//                     background: "rgba(13,115,119,0.08)",
//                     padding: "2px 8px",
//                     borderRadius: 100,
//                     border: "1px solid rgba(13,115,119,0.2)",
//                   }}
//                 >
//                   For follow-up
//                 </span>
//               </div>
//               <input
//                 type="date"
//                 value={visitForm.nextVisitDate}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, nextVisitDate: e.target.value }))
//                 }
//                 style={{ marginTop: 6 }}
//               />
//             </div>
//           </div>
//           {/* ── Prescription Table ─────────────────────────── */}
//           <style>{`
//             @media (max-width: 640px) {
//               .rx-table-desktop { display: none !important; }
//               .rx-card-mobile { display: block !important; }
//             }
//             @media (min-width: 641px) {
//               .rx-table-desktop { display: block !important; }
//               .rx-card-mobile { display: none !important; }
//             }
//           `}</style>
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 8 }}
//           >
//             💊 Prescription
//           </div>

//           {/* ── DESKTOP TABLE ── */}
//           <div
//             className="rx-table-desktop"
//             style={{
//               overflowX: "auto",
//               marginBottom: 8,
//               position: "relative",
//               zIndex: 1000,
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: 13,
//                 fontFamily: "'DM Sans',sans-serif",
//                 minWidth: 560,
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                     color: "#fff",
//                   }}
//                 >
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 36,
//                     }}
//                   >
//                     SR.
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     MEDICINE
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     DOSAGE INSTRUCTION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     DURATION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     ROUTE
//                   </th>
//                   <th style={{ padding: "8px 10px", width: 32 }}></th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {visitForm.rxRows.map((row, idx) => (
//                   <tr
//                     key={idx}
//                     style={{
//                       background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                       borderBottom: "1px solid #e8e4e0",
//                     }}
//                   >
//                     <td
//                       style={{
//                         padding: "6px 10px",
//                         color: "#666",
//                         fontSize: 12,
//                         textAlign: "center",
//                       }}
//                     >
//                       {idx + 1}
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <RxMedInput
//                         value={row.medicine}
//                         onChange={(v) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], medicine: v };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         customMeds={customMeds}
//                         apiPost={api.post}
//                         onCustomSaved={(saved) => {
//                           if (saved && saved._id) {
//                             setCustomMeds((prev) => {
//                               const exists = prev.some(
//                                 (m) =>
//                                   m._id === saved._id ||
//                                   m.name.toLowerCase() ===
//                                     saved.name.toLowerCase(),
//                               );
//                               if (exists) return prev;
//                               return [saved, ...prev];
//                             });
//                           } else {
//                             api
//                               .get("/custommeds")
//                               .then((data) => {
//                                 if (Array.isArray(data)) setCustomMeds(data);
//                               })
//                               .catch(() => {});
//                           }
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                           flexWrap: "nowrap",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 2,
//                           }}
//                         >
//                           {["M", "A", "N"].map((label, li) => (
//                             <div
//                               key={label}
//                               style={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   fontSize: 9,
//                                   color: "#888",
//                                   marginBottom: 1,
//                                 }}
//                               >
//                                 {label}
//                               </span>
//                               <input
//                                 type="text"
//                                 maxLength={2}
//                                 value={
//                                   (row.dosageParts || ["0", "0", "0"])[li] ||
//                                   "0"
//                                 }
//                                 onFocus={(e) => {
//                                   if (e.target.value === "0") e.target.select();
//                                 }}
//                                 onChange={(e) => {
//                                   const rows = [...visitForm.rxRows];
//                                   const parts = [
//                                     ...(rows[idx].dosageParts || [
//                                       "0",
//                                       "0",
//                                       "0",
//                                     ]),
//                                   ];
//                                   parts[li] =
//                                     e.target.value === ""
//                                       ? "0"
//                                       : e.target.value;
//                                   rows[idx] = {
//                                     ...rows[idx],
//                                     dosageParts: parts,
//                                     dosage:
//                                       parts.join("-") +
//                                       (rows[idx].dosageTiming
//                                         ? " " + rows[idx].dosageTiming
//                                         : ""),
//                                   };
//                                   setVisitForm((f) => ({ ...f, rxRows: rows }));
//                                 }}
//                                 style={{
//                                   width: 28,
//                                   border: "1px solid #ddd",
//                                   borderRadius: 4,
//                                   padding: "4px 3px",
//                                   fontSize: 12,
//                                   textAlign: "center",
//                                   fontFamily: "'DM Sans',sans-serif",
//                                 }}
//                               />
//                             </div>
//                           ))}
//                         </div>
//                         <select
//                           value={row.dosageTiming || "after meal"}
//                           onChange={(e) => {
//                             const rows = [...visitForm.rxRows];
//                             const parts = rows[idx].dosageParts || [
//                               "0",
//                               "0",
//                               "0",
//                             ];
//                             rows[idx] = {
//                               ...rows[idx],
//                               dosageTiming: e.target.value,
//                               dosage: parts.join("-") + " " + e.target.value,
//                             };
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             border: "1px solid #ddd",
//                             borderRadius: 4,
//                             padding: "4px 5px",
//                             fontSize: 11,
//                             fontFamily: "'DM Sans',sans-serif",
//                             color: "#444",
//                           }}
//                         >
//                           <option>after meal</option>
//                           <option>before meal</option>
//                           <option>with meal</option>
//                           <option>empty stomach</option>
//                           <option>at bedtime</option>
//                           <option>as directed</option>
//                         </select>
//                       </div>
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <input
//                         type="text"
//                         placeholder="e.g. 7 days"
//                         value={row.duration}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = {
//                             ...rows[idx],
//                             duration: e.target.value,
//                           };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 8px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <select
//                         value={row.route}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], route: e.target.value };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 6px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       >
//                         <option>ORAL</option>
//                         <option>TOPICAL</option>
//                         <option>INJECTION</option>
//                         <option>INHALER</option>
//                         <option>DROPS</option>
//                         <option>GARGLE</option>
//                         <option>OTHER</option>
//                       </select>
//                     </td>
//                     <td style={{ padding: "4px 6px", textAlign: "center" }}>
//                       {visitForm.rxRows.length > 1 && (
//                         <button
//                           onClick={() => {
//                             const rows = visitForm.rxRows.filter(
//                               (_, i) => i !== idx,
//                             );
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             background: "none",
//                             border: "none",
//                             color: "#e74c3c",
//                             fontSize: 16,
//                             cursor: "pointer",
//                             padding: "2px 6px",
//                           }}
//                           title="Remove"
//                         >
//                           ✕
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* ── MOBILE CARDS ── */}
//           <div className="rx-card-mobile" style={{ marginBottom: 8 }}>
//             {visitForm.rxRows.map((row, idx) => (
//               <div
//                 key={idx}
//                 style={{
//                   background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                   border: "1px solid #e8e4e0",
//                   borderRadius: 8,
//                   padding: "10px 12px",
//                   marginBottom: 8,
//                   position: "relative",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: 8,
//                   }}
//                 >
//                   <span
//                     style={{
//                       fontSize: 11,
//                       fontWeight: 700,
//                       color: "#0a1628",
//                       background: "rgba(10,22,40,0.08)",
//                       padding: "2px 8px",
//                       borderRadius: 20,
//                     }}
//                   >
//                     #{idx + 1}
//                   </span>
//                   {visitForm.rxRows.length > 1 && (
//                     <button
//                       onClick={() => {
//                         const rows = visitForm.rxRows.filter(
//                           (_, i) => i !== idx,
//                         );
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         background: "none",
//                         border: "none",
//                         color: "#e74c3c",
//                         fontSize: 16,
//                         cursor: "pointer",
//                         padding: "2px 6px",
//                       }}
//                       title="Remove"
//                     >
//                       ✕
//                     </button>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Medicine
//                   </div>
//                   <RxMedInput
//                     value={row.medicine}
//                     onChange={(v) => {
//                       const rows = [...visitForm.rxRows];
//                       rows[idx] = { ...rows[idx], medicine: v };
//                       setVisitForm((f) => ({ ...f, rxRows: rows }));
//                     }}
//                     customMeds={customMeds}
//                     apiPost={api.post}
//                     onCustomSaved={(saved) => {
//                       if (saved && saved._id) {
//                         setCustomMeds((prev) => {
//                           const exists = prev.some(
//                             (m) =>
//                               m._id === saved._id ||
//                               m.name.toLowerCase() === saved.name.toLowerCase(),
//                           );
//                           if (exists) return prev;
//                           return [saved, ...prev];
//                         });
//                       } else {
//                         api
//                           .get("/custommeds")
//                           .then((data) => {
//                             if (Array.isArray(data)) setCustomMeds(data);
//                           })
//                           .catch(() => {});
//                       }
//                     }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Dosage Instruction
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 6,
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <div
//                       style={{ display: "flex", alignItems: "center", gap: 4 }}
//                     >
//                       {["M", "A", "N"].map((label, li) => (
//                         <div
//                           key={label}
//                           style={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                           }}
//                         >
//                           <span
//                             style={{
//                               fontSize: 9,
//                               color: "#888",
//                               marginBottom: 1,
//                             }}
//                           >
//                             {label}
//                           </span>
//                           <input
//                             type="text"
//                             maxLength={2}
//                             value={
//                               (row.dosageParts || ["0", "0", "0"])[li] || "0"
//                             }
//                             onFocus={(e) => {
//                               if (e.target.value === "0") e.target.select();
//                             }}
//                             onChange={(e) => {
//                               const rows = [...visitForm.rxRows];
//                               const parts = [
//                                 ...(rows[idx].dosageParts || ["0", "0", "0"]),
//                               ];
//                               parts[li] =
//                                 e.target.value === "" ? "0" : e.target.value;
//                               rows[idx] = {
//                                 ...rows[idx],
//                                 dosageParts: parts,
//                                 dosage:
//                                   parts.join("-") +
//                                   (rows[idx].dosageTiming
//                                     ? " " + rows[idx].dosageTiming
//                                     : ""),
//                               };
//                               setVisitForm((f) => ({ ...f, rxRows: rows }));
//                             }}
//                             style={{
//                               width: 34,
//                               border: "1px solid #ddd",
//                               borderRadius: 4,
//                               padding: "5px 3px",
//                               fontSize: 13,
//                               textAlign: "center",
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                     <select
//                       value={row.dosageTiming || "after meal"}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         const parts = rows[idx].dosageParts || ["0", "0", "0"];
//                         rows[idx] = {
//                           ...rows[idx],
//                           dosageTiming: e.target.value,
//                           dosage: parts.join("-") + " " + e.target.value,
//                         };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         flex: 1,
//                         border: "1px solid #ddd",
//                         borderRadius: 4,
//                         padding: "5px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         color: "#444",
//                         minWidth: 120,
//                       }}
//                     >
//                       <option>after meal</option>
//                       <option>before meal</option>
//                       <option>with meal</option>
//                       <option>empty stomach</option>
//                       <option>at bedtime</option>
//                       <option>as directed</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div style={{ display: "flex", gap: 8 }}>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Duration
//                     </div>
//                     <input
//                       type="text"
//                       placeholder="e.g. 7 days"
//                       value={row.duration}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], duration: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 8px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         boxSizing: "border-box",
//                       }}
//                     />
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Route
//                     </div>
//                     <select
//                       value={row.route}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], route: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                       }}
//                     >
//                       <option>ORAL</option>
//                       <option>TOPICAL</option>
//                       <option>INJECTION</option>
//                       <option>INHALER</option>
//                       <option>DROPS</option>
//                       <option>GARGLE</option>
//                       <option>OTHER</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button
//             onClick={() =>
//               setVisitForm((f) => ({
//                 ...f,
//                 rxRows: [
//                   ...f.rxRows,
//                   {
//                     medicine: "",
//                     dosageParts: ["0", "0", "0"],
//                     dosageTiming: "after meal",
//                     dosage: "",
//                     duration: "",
//                     route: "ORAL",
//                   },
//                 ],
//               }))
//             }
//             style={{
//               marginTop: 4,
//               marginBottom: 8,
//               background: "rgba(13,115,119,0.08)",
//               border: "1px solid rgba(13,115,119,0.3)",
//               color: "var(--teal)",
//               borderRadius: 7,
//               padding: "6px 16px",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             + Add Medicine
//           </button>

//           {/* ── Doctor Notes / Diagnosis ───────────────────────── */}
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 10 }}
//           >
//             Doctor Notes / Diagnosis
//           </div>
//           <MedAutocomplete
//             value={visitForm.notes}
//             onChange={(v) => setVisitForm((f) => ({ ...f, notes: v }))}
//             customMeds={customMeds}
//             apiPost={api.post}
//             onCustomSaved={(saved) => {
//               if (saved && saved._id) {
//                 // Add to local state immediately so suggestion appears right away
//                 setCustomMeds((prev) => {
//                   const exists = prev.some(
//                     (m) =>
//                       m._id === saved._id ||
//                       m.name.toLowerCase() === saved.name.toLowerCase(),
//                   );
//                   if (exists) return prev;
//                   return [saved, ...prev];
//                 });
//               } else {
//                 // Fallback refetch if saved object not returned
//                 api
//                   .get("/custommeds")
//                   .then((data) => {
//                     if (Array.isArray(data)) setCustomMeds(data);
//                   })
//                   .catch(() => {});
//               }
//             }}
//           />
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               flexWrap: "wrap",
//               gap: 10,
//               marginTop: 4,
//             }}
//           >
//             <button className="add-visit-save-btn" onClick={saveVisit}>
//               💾 Save Visit Record
//             </button>
//           </div>
//         </div>

//         {/* Visit History */}
//         <div style={{ marginBottom: 12 }}>
//           <div className="admin-section-title" style={{ marginBottom: 8 }}>
//             Visit History
//           </div>
//           <div className="visit-records-list">
//             {visits.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 13,
//                   padding: "10px 0",
//                 }}
//               >
//                 No visits recorded yet. Add the first visit above.
//               </div>
//             ) : (
//               visits.map((v, i) => {
//                 const dtStr =
//                   (v.visitDate || "") +
//                   (v.visitTime ? " at " + v.visitTime : "");
//                 const isFollowUp = /follow[\s\-]?up/i.test(v.notes || "");
//                 return (
//                   <div key={v._id || i} className="visit-record-card">
//                     <button
//                       className="visit-del-btn"
//                       onClick={() => deleteVisit(v._id)}
//                       title="Delete"
//                     >
//                       ✕
//                     </button>
//                     <div className="visit-record-meta">
//                       <span className="visit-record-service">
//                         {v.service || "Visit"}
//                       </span>
//                       <span className="visit-record-date">📅 {dtStr}</span>
//                       {v.amount && (
//                         <span
//                           className="patient-info-pill"
//                           style={{ fontSize: 11 }}
//                         >
//                           Rs. {v.amount}
//                         </span>
//                       )}
//                       {v.doctor && (
//                         <span
//                           style={{
//                             fontSize: 11,
//                             color: "var(--teal)",
//                             fontWeight: 600,
//                             background: "rgba(13,115,119,0.08)",
//                             padding: "2px 8px",
//                             borderRadius: 100,
//                             border: "1px solid rgba(13,115,119,0.2)",
//                           }}
//                         >
//                           👨‍⚕️ {v.doctor}
//                         </span>
//                       )}
//                     </div>
//                     <div className="visit-record-notes">{v.notes || "—"}</div>
//                     {v.prescription &&
//                       v.prescription.medicineRows &&
//                       v.prescription.medicineRows.length > 0 && (
//                         <div style={{ marginTop: 10, overflowX: "auto" }}>
//                           <table
//                             style={{
//                               width: "100%",
//                               borderCollapse: "collapse",
//                               fontSize: 12,
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           >
//                             <thead>
//                               <tr
//                                 style={{
//                                   background:
//                                     "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                                   color: "#fff",
//                                 }}
//                               >
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 30,
//                                   }}
//                                 >
//                                   SR.
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   MEDICINE
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   DOSAGE INSTRUCTION
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 90,
//                                   }}
//                                 >
//                                   DUR. / ROUTE
//                                 </th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {v.prescription.medicineRows.map((row, ri) => (
//                                 <tr
//                                   key={ri}
//                                   style={{
//                                     background:
//                                       ri % 2 === 0 ? "#f8f9fc" : "#fff",
//                                     borderBottom: "1px solid #e8e4e0",
//                                   }}
//                                 >
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                       textAlign: "center",
//                                     }}
//                                   >
//                                     {ri + 1}.
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       fontWeight: 600,
//                                       color: "#0a1628",
//                                     }}
//                                   >
//                                     {row.medicine || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#444",
//                                     }}
//                                   >
//                                     {row.dosage || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                     }}
//                                   >
//                                     {row.duration}
//                                     {row.duration && row.route ? " / " : ""}
//                                     {row.route}
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       )}
//                     {v.nextVisitDate && (
//                       <div
//                         style={{
//                           marginTop: 8,
//                           display: "inline-flex",
//                           alignItems: "center",
//                           gap: 6,
//                           background: isFollowUp
//                             ? "rgba(201,168,76,0.12)"
//                             : "rgba(13,115,119,0.08)",
//                           border:
//                             "1px solid " +
//                             (isFollowUp
//                               ? "rgba(201,168,76,0.35)"
//                               : "rgba(13,115,119,0.2)"),
//                           borderRadius: 100,
//                           padding: "3px 12px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           color: isFollowUp ? "#8b6914" : "var(--teal)",
//                         }}
//                       >
//                         {isFollowUp ? "Follow-Up: " : "Next Visit: "}
//                         {fmtDateShort(v.nextVisitDate)}
//                         {isFollowUp ? " — WhatsApp sent" : ""}
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 8,
//                         marginTop: 10,
//                       }}
//                     >
//                       <button
//                         onClick={() => sendPrescription(v)}
//                         style={{
//                           background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Send Prescription
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </div>

//       {rxModal && (
//         <PrescriptionModal
//           visit={rxModal.visit}
//           patient={rxModal.patient}
//           doctor={rxModal.doctor}
//           onClose={() => setRxModal(null)}
//           showNotify={showNotify}
//         />
//       )}
//     </div>
//   );
// }

// // ── Medicine Database — 1500+ entries (India: dental + clinical + surgical) ──
// const MEDICINE_DB = [
//   // ── ANTIBIOTICS ──────────────────────────────────────────────
//   { name: "Amoxicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 875mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin 125mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin 250mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 375mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 625mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 1000mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 228.5mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Azithromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Clindamycin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 600mg Injection", cat: "Antibiotic Inj" },
//   { name: "Metronidazole 200mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 400mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Infusion", cat: "Antibiotic Inj" },
//   { name: "Ciprofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 750mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 200mg/100ml Infusion", cat: "Antibiotic Inj" },
//   { name: "Doxycycline 100mg Capsule", cat: "Antibiotic" },
//   { name: "Doxycycline 200mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Tinidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ornidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Secnidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Co-Amoxiclav 375mg Tablet", cat: "Antibiotic" },
//   { name: "Co-Amoxiclav 625mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 750mg Tablet", cat: "Antibiotic" },
//   { name: "Ofloxacin 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ofloxacin 400mg Tablet", cat: "Antibiotic" },
//   { name: "Cephalexin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Cephalexin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Cefixime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 400mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 50mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Cefuroxime 250mg Tablet", cat: "Antibiotic" },
//   { name: "Cefuroxime 500mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ceftriaxone 250mg Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 2g Injection", cat: "Antibiotic Inj" },
//   { name: "Amikacin 250mg Injection", cat: "Antibiotic Inj" },
//   { name: "Amikacin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Gentamicin 40mg Injection", cat: "Antibiotic Inj" },
//   { name: "Gentamicin 80mg Injection", cat: "Antibiotic Inj" },
//   { name: "Vancomycin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Vancomycin 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Meropenem 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Meropenem 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Piperacillin + Tazobactam 4.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Imipenem + Cilastatin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Linezolid 600mg Tablet", cat: "Antibiotic" },
//   { name: "Linezolid 600mg Infusion", cat: "Antibiotic Inj" },
//   { name: "Colistin 1 MU Injection", cat: "Antibiotic Inj" },
//   { name: "Tetracycline 250mg Capsule", cat: "Antibiotic" },
//   { name: "Tetracycline 500mg Capsule", cat: "Antibiotic" },
//   { name: "Chloramphenicol 250mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin + Sulbactam 1.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Nitrofurantoin 50mg Capsule", cat: "Antibiotic" },
//   { name: "Nitrofurantoin 100mg Capsule", cat: "Antibiotic" },
//   { name: "Norfloxacin 400mg Tablet", cat: "Antibiotic" },
//   { name: "Trimethoprim + Sulfamethoxazole 480mg Tablet", cat: "Antibiotic" },
//   { name: "Trimethoprim + Sulfamethoxazole 960mg Tablet", cat: "Antibiotic" },
//   { name: "Cefoperazone + Sulbactam 1.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Cefoperazone + Sulbactam 3g Injection", cat: "Antibiotic Inj" },
//   { name: "Ertapenem 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Tigecycline 50mg Injection", cat: "Antibiotic Inj" },
//   { name: "Fosfomycin 3g Sachet", cat: "Antibiotic" },
//   { name: "Rifampicin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Rifampicin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Isoniazid 100mg Tablet", cat: "Antibiotic" },
//   { name: "Isoniazid 300mg Tablet", cat: "Antibiotic" },
//   { name: "Pyrazinamide 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ethambutol 400mg Tablet", cat: "Antibiotic" },
//   { name: "Streptomycin 1g Injection", cat: "Antibiotic Inj" },
//   // ── PAIN KILLERS / NSAIDS ────────────────────────────────────
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 250mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 150mg/ml Drops", cat: "Painkiller" },
//   { name: "Paracetamol 500mg/100ml Infusion", cat: "Painkiller Inj" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 100mg/5ml Syrup", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Injection", cat: "NSAID Inj" },
//   { name: "Ketorolac 10mg Tablet", cat: "NSAID" },
//   { name: "Ketorolac 30mg Injection", cat: "NSAID Inj" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Piroxicam 10mg Tablet", cat: "NSAID" },
//   { name: "Piroxicam 20mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 120mg Tablet", cat: "NSAID" },
//   { name: "Celecoxib 100mg Capsule", cat: "NSAID" },
//   { name: "Celecoxib 200mg Capsule", cat: "NSAID" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol 100mg SR Tablet", cat: "Opioid Analgesic" },
//   { name: "Tramadol 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Morphine 10mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Morphine 15mg Tablet", cat: "Opioid Analgesic" },
//   { name: "Fentanyl 50mcg/ml Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pentazocine 30mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pethidine 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Buprenorphine 0.3mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Tapentadol 50mg Tablet", cat: "Opioid Analgesic" },
//   { name: "Tapentadol 100mg Tablet", cat: "Opioid Analgesic" },
//   // ── LOCAL ANAESTHETICS — DENTAL ─────────────────────────────
//   { name: "Lignocaine 2% Dental Cartridge (1.8ml)", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine + Adrenaline 2% Dental Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% Heavy Spinal Injection", cat: "Local Anaesthetic" },
//   { name: "Mepivacaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Prilocaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Lignocaine 2% Plain Injection 30ml Vial", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine 2% + Adrenaline Injection Vial",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Lignocaine 10% Topical Spray", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 2% Viscous Gel", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 5% Ointment", cat: "Local Anaesthetic Topical" },
//   { name: "Benzocaine 20% Topical Gel", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lignocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine Jelly 2%", cat: "Local Anaesthetic Topical" },
//   { name: "Ropivacaine 0.2% Injection", cat: "Local Anaesthetic" },
//   { name: "Ropivacaine 0.75% Injection", cat: "Local Anaesthetic" },
//   {
//     name: "Tetracaine (Amethocaine) Eye Drops",
//     cat: "Local Anaesthetic Topical",
//   },
//   // ── GENERAL ANAESTHESIA ─────────────────────────────────────
//   { name: "Propofol 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 500mg Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Thiopentone Sodium 500mg Injection", cat: "General Anaesthesia" },
//   { name: "Midazolam 1mg/ml Injection", cat: "Sedative / Anaesthesia" },
//   { name: "Midazolam 5mg/ml Injection", cat: "Sedative / Anaesthesia" },
//   { name: "Midazolam 7.5mg Tablet", cat: "Sedative" },
//   { name: "Isoflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Sevoflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Desflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Nitrous Oxide Gas", cat: "Inhalation Anaesthetic" },
//   { name: "Oxygen Gas Cylinder", cat: "Medical Gas" },
//   { name: "Succinylcholine 100mg Injection", cat: "Muscle Relaxant" },
//   { name: "Vecuronium 4mg Injection", cat: "Muscle Relaxant" },
//   { name: "Atracurium 25mg Injection", cat: "Muscle Relaxant" },
//   { name: "Rocuronium 50mg Injection", cat: "Muscle Relaxant" },
//   { name: "Neostigmine 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Atropine 0.6mg Injection", cat: "Anticholinergic" },
//   { name: "Glycopyrrolate 0.2mg Injection", cat: "Anticholinergic" },
//   // ── STEROIDS / ANTI-INFLAMMATORY ────────────────────────────
//   { name: "Dexamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Betamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 40mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 16mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 40mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 125mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone 10mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone Acetonide 0.1% Oral Paste", cat: "Steroid Topical" },
//   { name: "Kenacort 0.1% Dental Paste", cat: "Steroid Topical" },
//   { name: "Betamethasone Gel Oral 0.025%", cat: "Steroid Topical" },
//   // ── ANTIFUNGALS ─────────────────────────────────────────────
//   { name: "Fluconazole 50mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 2mg/ml Infusion", cat: "Antifungal Inj" },
//   { name: "Itraconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Voriconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Amphotericin B 50mg Injection", cat: "Antifungal Inj" },
//   { name: "Clotrimazole 1% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin 100000 IU/ml Oral Drops", cat: "Antifungal" },
//   { name: "Nystatin 500000 IU Tablet", cat: "Antifungal" },
//   { name: "Clotrimazole + Betamethasone Cream", cat: "Antifungal Topical" },
//   { name: "Ketoconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Ketoconazole 2% Shampoo", cat: "Antifungal Topical" },
//   { name: "Terbinafine 250mg Tablet", cat: "Antifungal" },
//   // ── ANTIVIRAL ───────────────────────────────────────────────
//   { name: "Acyclovir 200mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 400mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 800mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 5% Cream", cat: "Antiviral Topical" },
//   { name: "Acyclovir 250mg Injection", cat: "Antiviral Inj" },
//   { name: "Valacyclovir 500mg Tablet", cat: "Antiviral" },
//   { name: "Valacyclovir 1000mg Tablet", cat: "Antiviral" },
//   { name: "Famciclovir 250mg Tablet", cat: "Antiviral" },
//   { name: "Oseltamivir 75mg Capsule", cat: "Antiviral" },
//   // ── ANTISEPTICS / MOUTHWASH / ORAL CARE ─────────────────────
//   { name: "Chlorhexidine Gluconate 0.2% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine Gluconate 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 1% Gel (Gum Gel)", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 5% Mouthwash / Gargle", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 10% Solution", cat: "Antiseptic" },
//   { name: "Povidone Iodine 5% Ointment", cat: "Antiseptic Topical" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 1.5% Mouthwash", cat: "Dental Antiseptic" },
//   {
//     name: "Benzydamine Hydrochloride 0.15% Mouthwash",
//     cat: "Dental Analgesic Rinse",
//   },
//   { name: "Hexetidine 0.1% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Sodium Fluoride 0.05% Mouthwash", cat: "Fluoride Rinse" },
//   { name: "Sodium Fluoride Varnish 5%", cat: "Fluoride Varnish" },
//   { name: "Fluoride Gel APF 1.23%", cat: "Fluoride Gel" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "Aloe Vera Gel Oral", cat: "Oral Care" },
//   { name: "Hyaluronic Acid Gel 0.2% Oral", cat: "Oral Care" },
//   { name: "Triclosan Toothpaste", cat: "Dental Brand" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Colgate Total Toothpaste", cat: "Dental Brand" },
//   { name: "Pepsodent Toothpaste", cat: "Dental Brand" },
//   { name: "Emoform Toothpaste", cat: "Dental Brand" },
//   { name: "Thermoseal Toothpaste", cat: "Dental Brand" },
//   { name: "Himalaya HiOra Toothpaste", cat: "Dental Brand" },
//   { name: "Dabur Red Toothpaste", cat: "Dental Brand" },
//   { name: "Meswak Toothpaste", cat: "Dental Brand" },
//   { name: "Oral-B Electric Toothbrush Head", cat: "Dental Accessory" },
//   { name: "Interdental Brush", cat: "Dental Accessory" },
//   { name: "Dental Floss", cat: "Dental Accessory" },
//   { name: "Tongue Cleaner", cat: "Dental Accessory" },
//   { name: "Water Flosser / Oral Irrigator", cat: "Dental Accessory" },
//   // ── DENTAL MATERIALS ────────────────────────────────────────
//   { name: "GIC Cement (Glass Ionomer Cement)", cat: "Dental Material" },
//   { name: "GIC Type II Restorative", cat: "Dental Material" },
//   { name: "RMGIC (Resin Modified GIC)", cat: "Dental Material" },
//   { name: "Composite Resin A1 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A2 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A3 Shade", cat: "Dental Material" },
//   { name: "Composite Resin B1 Shade", cat: "Dental Material" },
//   { name: "Flowable Composite", cat: "Dental Material" },
//   { name: "Bulk Fill Composite", cat: "Dental Material" },
//   { name: "IRM (Intermediate Restorative Material)", cat: "Dental Material" },
//   { name: "Zinc Oxide Eugenol Cement", cat: "Dental Material" },
//   { name: "Zinc Phosphate Cement", cat: "Dental Material" },
//   { name: "Zinc Polycarboxylate Cement", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Dycal (Calcium Hydroxide Base)", cat: "Dental Material" },
//   { name: "Cavity Liner (Varnish)", cat: "Dental Material" },
//   { name: "Etchant 37% Phosphoric Acid Gel", cat: "Dental Material" },
//   { name: "Bonding Agent (5th Gen)", cat: "Dental Material" },
//   { name: "Bonding Agent (7th Gen Self-Etch)", cat: "Dental Material" },
//   { name: "Dental Amalgam Capsule", cat: "Dental Material" },
//   { name: "Impression Material Alginate", cat: "Dental Material" },
//   {
//     name: "Impression Material Polyvinyl Siloxane (PVS)",
//     cat: "Dental Material",
//   },
//   { name: "Impression Material Polyether", cat: "Dental Material" },
//   { name: "Zinc Oxide Impression Paste", cat: "Dental Material" },
//   { name: "Plaster of Paris (Type II)", cat: "Dental Material" },
//   { name: "Dental Stone (Type III)", cat: "Dental Material" },
//   { name: "Dental Stone (Type IV)", cat: "Dental Material" },
//   { name: "Acrylic Resin Heat Cure", cat: "Dental Material" },
//   { name: "Acrylic Resin Cold Cure / Self Cure", cat: "Dental Material" },
//   { name: "Denture Base Resin", cat: "Dental Material" },
//   { name: "Denture Reliner", cat: "Dental Material" },
//   { name: "Denture Adhesive Cream", cat: "Dental Material" },
//   { name: "Dental Wax (Sheet Wax)", cat: "Dental Material" },
//   { name: "Boxing Wax", cat: "Dental Material" },
//   { name: "Inlay Wax", cat: "Dental Material" },
//   { name: "Sticky Wax", cat: "Dental Material" },
//   { name: "Orthodontic Wire NiTi 0.012", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire NiTi 0.014", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire NiTi 0.016", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire SS 0.019x0.025", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Metal)", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Ceramic)", cat: "Dental Ortho" },
//   { name: "Orthodontic Elastic Bands", cat: "Dental Ortho" },
//   { name: "Orthodontic Separator Elastics", cat: "Dental Ortho" },
//   { name: "Orthodontic Molar Band", cat: "Dental Ortho" },
//   { name: "Orthodontic Retainer Wire", cat: "Dental Ortho" },
//   { name: "Invisalign Clear Aligner Tray", cat: "Dental Ortho" },
//   { name: "Dental Implant Fixture (Titanium)", cat: "Dental Implant" },
//   { name: "Dental Implant Abutment", cat: "Dental Implant" },
//   { name: "Healing Cap / Cover Screw", cat: "Dental Implant" },
//   { name: "Bone Graft Material (Synthetic HA)", cat: "Dental Implant" },
//   { name: "Bone Graft Material (Xenograft)", cat: "Dental Implant" },
//   { name: "Collagen Membrane (Resorbable)", cat: "Dental Implant" },
//   { name: "Titanium Mesh", cat: "Dental Implant" },
//   { name: "PRP (Platelet Rich Plasma) Kit", cat: "Dental Surgical" },
//   { name: "PRF (Platelet Rich Fibrin) Kit", cat: "Dental Surgical" },
//   { name: "Hemostatic Agent (Gelatin Sponge)", cat: "Dental Surgical" },
//   { name: "Surgicel (Oxidised Cellulose)", cat: "Haemostatic" },
//   { name: "Alvogyl (Dry Socket Dressing)", cat: "Dental Surgical" },
//   { name: "Whitehead Varnish (Iodoform Paste)", cat: "Dental Surgical" },
//   { name: "Ledermix Paste", cat: "Dental Material" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Sealapex)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Zinc Oxide Eugenol)", cat: "Endodontic" },
//   { name: "Gutta Percha Points (ISO 20-80)", cat: "Endodontic" },
//   { name: "Paper Points (Absorbent Points)", cat: "Endodontic" },
//   { name: "EDTA Liquid 17% (Root Canal)", cat: "Endodontic" },
//   { name: "EDTA Gel 17% (Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 2.5% Solution", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% Solution", cat: "Endodontic" },
//   { name: "Chlorhexidine 2% Irrigant", cat: "Endodontic" },
//   { name: "RC Prep (Root Canal Lubricant)", cat: "Endodontic" },
//   { name: "K-Files (Root Canal Files) ISO 6-80", cat: "Endodontic Instrument" },
//   { name: "H-Files (Hedstrom Files) ISO 15-60", cat: "Endodontic Instrument" },
//   { name: "Rotary NiTi Files (ProTaper)", cat: "Endodontic Instrument" },
//   { name: "Rotary NiTi Files (WaveOne Gold)", cat: "Endodontic Instrument" },
//   { name: "Rubber Dam Sheet", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Clamp", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Frame", cat: "Endodontic Accessory" },
//   { name: "Pulp Capping Agent (Vitrebond)", cat: "Endodontic" },
//   { name: "Formocresol Solution", cat: "Endodontic Paediatric" },
//   { name: "Buckley's Formocresol", cat: "Endodontic Paediatric" },
//   {
//     name: "Zinc Oxide + Iodoform Paste (Kri Paste)",
//     cat: "Endodontic Paediatric",
//   },
//   { name: "Stainless Steel Crown (Paediatric)", cat: "Paediatric Dental" },
//   { name: "Fluoride Varnish Duraphat 22600 ppm", cat: "Fluoride Varnish" },
//   // ── SURGICAL INSTRUMENTS ────────────────────────────────────
//   { name: "Scalpel Handle No. 3", cat: "Surgical Instrument" },
//   { name: "Scalpel Handle No. 4", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 11", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 12", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 15", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 23", cat: "Surgical Instrument" },
//   { name: "Scissors (Metzenbaum)", cat: "Surgical Instrument" },
//   { name: "Scissors (Mayo Straight)", cat: "Surgical Instrument" },
//   { name: "Scissors (Mayo Curved)", cat: "Surgical Instrument" },
//   { name: "Scissors (Iris)", cat: "Surgical Instrument" },
//   { name: "Scissors (Dean)", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Straight)", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Curved)", cat: "Surgical Instrument" },
//   { name: "Mosquito Forceps", cat: "Surgical Instrument" },
//   { name: "Tissue Forceps (Adson)", cat: "Surgical Instrument" },
//   { name: "Tissue Forceps (Rat Tooth)", cat: "Surgical Instrument" },
//   { name: "Allis Tissue Forceps", cat: "Surgical Instrument" },
//   { name: "Babcock Forceps", cat: "Surgical Instrument" },
//   { name: "Needle Holder (Mayo Hegar)", cat: "Surgical Instrument" },
//   { name: "Needle Holder (Mathieu)", cat: "Surgical Instrument" },
//   { name: "Retractor (Langenbeck)", cat: "Surgical Instrument" },
//   { name: "Retractor (Army-Navy)", cat: "Surgical Instrument" },
//   { name: "Retractor (Minnesota)", cat: "Surgical Instrument" },
//   { name: "Cheek Retractor (Plastic)", cat: "Dental Instrument" },
//   { name: "Mouth Gag (Doyen)", cat: "Surgical Instrument" },
//   { name: "Periosteal Elevator (Molt No.9)", cat: "Dental Instrument" },
//   { name: "Periosteal Elevator (Freer)", cat: "Dental Instrument" },
//   { name: "Bone Curette (Lucas)", cat: "Dental Instrument" },
//   { name: "Surgical Curette", cat: "Surgical Instrument" },
//   { name: "Bone File", cat: "Dental Instrument" },
//   { name: "Rongeur Forceps (Bone Cutting)", cat: "Surgical Instrument" },
//   { name: "Surgical Mallet", cat: "Surgical Instrument" },
//   { name: "Osteotome", cat: "Surgical Instrument" },
//   { name: "Chisel (Straight)", cat: "Surgical Instrument" },
//   { name: "Suction Tip (Yankauer)", cat: "Surgical Instrument" },
//   { name: "Suction Tip (Dental Fine Tip)", cat: "Dental Instrument" },
//   { name: "Saliva Ejector Tip", cat: "Dental Instrument" },
//   { name: "High Volume Evacuator (HVE) Tip", cat: "Dental Instrument" },
//   { name: "Air/Water Syringe Tip", cat: "Dental Instrument" },
//   // ── DENTAL EXTRACTION FORCEPS ────────────────────────────────
//   { name: "Extraction Forceps Upper Anterior", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Premolar", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Molar (Left)", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Molar (Right)", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Anterior", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Premolar", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Molar", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Roots (Bayonet)", cat: "Dental Instrument" },
//   { name: "Elevator (Straight No. 301)", cat: "Dental Instrument" },
//   { name: "Elevator (Cryer Right)", cat: "Dental Instrument" },
//   { name: "Elevator (Cryer Left)", cat: "Dental Instrument" },
//   { name: "Elevator (Apexo)", cat: "Dental Instrument" },
//   { name: "Elevator (Warwick James)", cat: "Dental Instrument" },
//   { name: "Elevator (Coupland)", cat: "Dental Instrument" },
//   // ── PERIODONTAL INSTRUMENTS ──────────────────────────────────
//   { name: "Ultrasonic Scaler Tip (Universal)", cat: "Periodontal Instrument" },
//   {
//     name: "Ultrasonic Scaler Tip (Subgingival)",
//     cat: "Periodontal Instrument",
//   },
//   { name: "Sickle Scaler H6/H7", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 1/2", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 5/6", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 7/8", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 11/12", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 13/14", cat: "Periodontal Instrument" },
//   { name: "Columbia Curette 4R/4L", cat: "Periodontal Instrument" },
//   { name: "Periodontal Probe (Williams)", cat: "Periodontal Instrument" },
//   { name: "Periodontal Probe (UNC-15)", cat: "Periodontal Instrument" },
//   { name: "Periodontal Probe (CPITN)", cat: "Periodontal Instrument" },
//   { name: "Suture Scissors (Crown Removing)", cat: "Periodontal Instrument" },
//   { name: "Electrosurgery Tip", cat: "Periodontal Instrument" },
//   // ── NEEDLES AND SYRINGES ─────────────────────────────────────
//   { name: "Dental Needle 27G Short (21mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 27G Long (38mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Short (21mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 25G Long (38mm)", cat: "Dental Needle" },
//   {
//     name: "Aspirating Dental Syringe (Breech Loading)",
//     cat: "Dental Instrument",
//   },
//   { name: "Disposable Syringe 1ml (Insulin)", cat: "Syringe" },
//   { name: "Disposable Syringe 2ml", cat: "Syringe" },
//   { name: "Disposable Syringe 5ml", cat: "Syringe" },
//   { name: "Disposable Syringe 10ml", cat: "Syringe" },
//   { name: "Disposable Syringe 20ml", cat: "Syringe" },
//   { name: "Disposable Syringe 50ml (Piston)", cat: "Syringe" },
//   { name: "Needle 18G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 20G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 21G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 22G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 23G x 1 inch", cat: "Needle" },
//   { name: "Needle 24G x 1 inch", cat: "Needle" },
//   { name: "Needle 25G x 5/8 inch", cat: "Needle" },
//   { name: "Needle 26G x 0.5 inch", cat: "Needle" },
//   { name: "IV Cannula 14G (Orange)", cat: "IV Cannula" },
//   { name: "IV Cannula 16G (Grey)", cat: "IV Cannula" },
//   { name: "IV Cannula 18G (Green)", cat: "IV Cannula" },
//   { name: "IV Cannula 20G (Pink)", cat: "IV Cannula" },
//   { name: "IV Cannula 22G (Blue)", cat: "IV Cannula" },
//   { name: "IV Cannula 24G (Yellow)", cat: "IV Cannula" },
//   { name: "Spinal Needle 25G (Quincke)", cat: "Spinal Needle" },
//   { name: "Spinal Needle 26G (Quincke)", cat: "Spinal Needle" },
//   { name: "Epidural Needle 16G (Tuohy)", cat: "Epidural Needle" },
//   { name: "Epidural Catheter", cat: "Epidural Set" },
//   { name: 'Hypodermic Needle 21G x 1.5"', cat: "Needle" },
//   { name: "Scalp Vein Set 21G (Butterfly)", cat: "IV Accessory" },
//   { name: "Scalp Vein Set 23G (Butterfly)", cat: "IV Accessory" },
//   { name: "Scalp Vein Set 25G (Butterfly)", cat: "IV Accessory" },
//   // ── IV FLUIDS / INFUSIONS ────────────────────────────────────
//   { name: "Normal Saline 0.9% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 1000ml Infusion", cat: "IV Fluid" },
//   { name: "Ringer's Lactate 500ml Infusion", cat: "IV Fluid" },
//   { name: "Ringer's Lactate 1000ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 5% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 5% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 10% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 25% 200ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 50% 50ml Injection", cat: "IV Fluid" },
//   { name: "Dextrose 5% + Normal Saline 500ml", cat: "IV Fluid" },
//   { name: "Dextrose Saline (0.45% NaCl + 5% Dextrose)", cat: "IV Fluid" },
//   { name: "Isolyte S 500ml Infusion", cat: "IV Fluid" },
//   { name: "Isolyte P 500ml Infusion (Paediatric)", cat: "IV Fluid" },
//   { name: "Plasma Expander (Haemaccel) 500ml", cat: "IV Fluid" },
//   { name: "Colloid Solution (Albumin 5%) 500ml", cat: "IV Fluid" },
//   { name: "Albumin 25% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Sodium Bicarbonate 7.5% 25ml Injection", cat: "IV Fluid" },
//   { name: "Potassium Chloride 15% 10ml Ampoule", cat: "IV Electrolyte" },
//   { name: "Calcium Gluconate 10% Injection", cat: "IV Electrolyte" },
//   { name: "Magnesium Sulphate 50% Injection", cat: "IV Electrolyte" },
//   { name: "TPN (Total Parenteral Nutrition) Bag", cat: "IV Nutrition" },
//   { name: "Lipid Emulsion 20% Infusion", cat: "IV Nutrition" },
//   // ── ANTIEMETICS / GI ─────────────────────────────────────────
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 2mg/ml Injection", cat: "Antiemetic Inj" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Injection", cat: "Antiemetic Inj" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Promethazine 25mg Tablet", cat: "Antiemetic / Antihistamine" },
//   { name: "Promethazine 25mg Injection", cat: "Antiemetic Inj" },
//   { name: "Granisetron 1mg Tablet", cat: "Antiemetic" },
//   { name: "Pantoprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Ranitidine 150mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ranitidine 50mg Injection", cat: "Antacid Inj" },
//   { name: "Sucralfate Suspension 1g/10ml", cat: "Antacid" },
//   { name: "Antacid Suspension (Digene)", cat: "Antacid" },
//   { name: "Antacid Tablet (Gelusil)", cat: "Antacid" },
//   { name: "Syp Lactulose 10g/15ml", cat: "Laxative" },
//   { name: "Bisacodyl 5mg Tablet", cat: "Laxative" },
//   { name: "Bisacodyl Suppository 10mg", cat: "Laxative" },
//   { name: "Loperamide 2mg Tablet", cat: "Antidiarrhoeal" },
//   { name: "ORS Sachet (WHO Formula)", cat: "Oral Rehydration" },
//   { name: "Zinc Sulphate 20mg Tablet (Paediatric)", cat: "Micronutrient" },
//   // ── ANTIHISTAMINES / ALLERGY ─────────────────────────────────
//   { name: "Cetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 5mg/5ml Syrup", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 180mg Tablet", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 4mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 10mg Injection", cat: "Antihistamine Inj" },
//   { name: "Diphenhydramine 25mg Capsule", cat: "Antihistamine" },
//   { name: "Diphenhydramine Injection", cat: "Antihistamine Inj" },
//   { name: "Adrenaline (Epinephrine) 1mg/ml Injection", cat: "Emergency Drug" },
//   { name: "Hydrocortisone 100mg Injection (Allergy)", cat: "Emergency Drug" },
//   { name: "Epinephrine Auto-Injector (EpiPen)", cat: "Emergency Drug" },
//   // ── CARDIOVASCULAR ───────────────────────────────────────────
//   { name: "Amlodipine 2.5mg Tablet", cat: "Antihypertensive" },
//   { name: "Amlodipine 5mg Tablet", cat: "Antihypertensive" },
//   { name: "Amlodipine 10mg Tablet", cat: "Antihypertensive" },
//   { name: "Atenolol 25mg Tablet", cat: "Beta Blocker" },
//   { name: "Atenolol 50mg Tablet", cat: "Beta Blocker" },
//   { name: "Atenolol 100mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 25mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 50mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 100mg Tablet", cat: "Beta Blocker" },
//   { name: "Propranolol 10mg Tablet", cat: "Beta Blocker" },
//   { name: "Propranolol 40mg Tablet", cat: "Beta Blocker" },
//   { name: "Losartan 25mg Tablet", cat: "Antihypertensive" },
//   { name: "Losartan 50mg Tablet", cat: "Antihypertensive" },
//   { name: "Telmisartan 40mg Tablet", cat: "Antihypertensive" },
//   { name: "Telmisartan 80mg Tablet", cat: "Antihypertensive" },
//   { name: "Ramipril 2.5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Ramipril 5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Enalapril 5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Enalapril 10mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Furosemide 20mg Tablet", cat: "Diuretic" },
//   { name: "Furosemide 40mg Tablet", cat: "Diuretic" },
//   { name: "Furosemide 20mg Injection", cat: "Diuretic Inj" },
//   { name: "Spironolactone 25mg Tablet", cat: "Diuretic" },
//   { name: "Aspirin 75mg Tablet", cat: "Antiplatelet" },
//   { name: "Aspirin 150mg Tablet", cat: "Antiplatelet" },
//   { name: "Clopidogrel 75mg Tablet", cat: "Antiplatelet" },
//   { name: "Atorvastatin 10mg Tablet", cat: "Statin" },
//   { name: "Atorvastatin 20mg Tablet", cat: "Statin" },
//   { name: "Atorvastatin 40mg Tablet", cat: "Statin" },
//   { name: "Nitroglycerin 0.5mg Sublingual Tablet", cat: "Nitrate" },
//   { name: "Nitroglycerin 5mg/ml Infusion", cat: "Nitrate Inj" },
//   { name: "Digoxin 0.25mg Tablet", cat: "Cardiac Glycoside" },
//   { name: "Amiodarone 200mg Tablet", cat: "Antiarrhythmic" },
//   { name: "Warfarin 1mg Tablet", cat: "Anticoagulant" },
//   { name: "Warfarin 5mg Tablet", cat: "Anticoagulant" },
//   { name: "Heparin 5000 IU Injection", cat: "Anticoagulant Inj" },
//   { name: "Protamine Sulphate 10mg Injection", cat: "Anticoagulant Reversal" },
//   // ── DIABETES DRUGS ───────────────────────────────────────────
//   { name: "Metformin 500mg Tablet", cat: "Antidiabetic" },
//   { name: "Metformin 850mg Tablet", cat: "Antidiabetic" },
//   { name: "Metformin 1000mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 1mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 2mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 4mg Tablet", cat: "Antidiabetic" },
//   { name: "Insulin Regular (Soluble) 100 IU/ml", cat: "Insulin" },
//   { name: "Insulin NPH (Isophane) 100 IU/ml", cat: "Insulin" },
//   { name: "Insulin Glargine 100 IU/ml (Lantus)", cat: "Insulin" },
//   { name: "Insulin Aspart 100 IU/ml (Novorapid)", cat: "Insulin" },
//   { name: "Insulin Lispro 100 IU/ml (Humalog)", cat: "Insulin" },
//   // ── VITAMINS / SUPPLEMENTS ───────────────────────────────────
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin C 1000mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule (Weekly)", cat: "Vitamin" },
//   { name: "Vitamin D3 1000 IU Tablet (Daily)", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 500mcg Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 1000mcg Injection", cat: "Vitamin Inj" },
//   { name: "Vitamin K1 10mg Injection", cat: "Vitamin Inj" },
//   { name: "Folic Acid 5mg Tablet", cat: "Vitamin" },
//   { name: "Iron (Ferrous Sulphate) 200mg Tablet", cat: "Iron Supplement" },
//   { name: "Iron + Folic Acid Tablet", cat: "Iron Supplement" },
//   { name: "Iron Sucrose 100mg Injection", cat: "Iron Supplement Inj" },
//   { name: "Calcium Carbonate 500mg Tablet", cat: "Calcium Supplement" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Zinc Sulphate 50mg Tablet", cat: "Micronutrient" },
//   { name: "Magnesium Hydroxide 300mg Tablet", cat: "Mineral Supplement" },
//   { name: "Multivitamin Tablet (Adult)", cat: "Multivitamin" },
//   { name: "Multivitamin Syrup (Paediatric)", cat: "Multivitamin" },
//   // ── HAEMOSTATICS / BLEEDING ──────────────────────────────────
//   { name: "Tranexamic Acid 500mg Tablet", cat: "Haemostatic" },
//   { name: "Tranexamic Acid 250mg/5ml Injection", cat: "Haemostatic Inj" },
//   { name: "Etamsylate 250mg Tablet", cat: "Haemostatic" },
//   { name: "Etamsylate 125mg/2ml Injection", cat: "Haemostatic Inj" },
//   { name: "Gelatin Sponge (Absorbable Haemostat)", cat: "Haemostatic" },
//   { name: "Bone Wax", cat: "Haemostatic Surgical" },
//   { name: "Thrombin Topical Powder", cat: "Haemostatic" },
//   { name: "Fibrin Glue (Tisseel)", cat: "Haemostatic Surgical" },
//   // ── SUTURE MATERIALS ─────────────────────────────────────────
//   { name: "Vicryl (Polyglactin 910) 3-0 Suture", cat: "Suture" },
//   { name: "Vicryl (Polyglactin 910) 4-0 Suture", cat: "Suture" },
//   { name: "Vicryl Rapid 4-0 Suture", cat: "Suture" },
//   { name: "Chromic Catgut 2-0 Suture", cat: "Suture" },
//   { name: "Chromic Catgut 3-0 Suture", cat: "Suture" },
//   { name: "Plain Catgut 2-0 Suture", cat: "Suture" },
//   { name: "Silk Suture 2-0 Black Braided", cat: "Suture" },
//   { name: "Silk Suture 3-0 Black Braided", cat: "Suture" },
//   { name: "Silk Suture 4-0 Black Braided", cat: "Suture" },
//   { name: "Nylon Suture 3-0 (Ethilon)", cat: "Suture" },
//   { name: "Nylon Suture 4-0 (Ethilon)", cat: "Suture" },
//   { name: "Nylon Suture 5-0 (Ethilon)", cat: "Suture" },
//   { name: "Prolene (Polypropylene) 3-0 Suture", cat: "Suture" },
//   { name: "Prolene (Polypropylene) 4-0 Suture", cat: "Suture" },
//   { name: "PDS II (Polydioxanone) 3-0 Suture", cat: "Suture" },
//   { name: "Monocryl 4-0 Suture (Poliglecaprone)", cat: "Suture" },
//   { name: "Stapler Skin (Proximate Plus)", cat: "Surgical Closure" },
//   { name: "Skin Staple Remover", cat: "Surgical Instrument" },
//   { name: "Steri-Strip (Wound Closure Strip)", cat: "Wound Care" },
//   { name: "Surgical Glue (Dermabond / Histoacryl)", cat: "Wound Care" },
//   // ── DRESSINGS / WOUND CARE ───────────────────────────────────
//   { name: "Gauze Swab 4x4 inch (Sterile)", cat: "Dressing" },
//   { name: "Gauze Swab 10x10 cm (Non-Sterile)", cat: "Dressing" },
//   { name: "ABD Pad (Combine Dressing)", cat: "Dressing" },
//   { name: "Crepe Bandage 4 inch", cat: "Bandage" },
//   { name: "Crepe Bandage 6 inch", cat: "Bandage" },
//   { name: "Adhesive Plaster Roll 1 inch", cat: "Bandage" },
//   { name: "Elastic Adhesive Bandage (EAB)", cat: "Bandage" },
//   { name: "Cohesive Bandage", cat: "Bandage" },
//   { name: "Cotton Roll (Non-Sterile)", cat: "Dental Material" },
//   { name: "Cotton Roll Sterile", cat: "Dressing" },
//   { name: "Absorbable Haemostatic Gauze", cat: "Haemostatic Dressing" },
//   { name: "Vaseline Gauze (Petrolatum Gauze)", cat: "Dressing" },
//   { name: "Jelonet Paraffin Gauze", cat: "Dressing" },
//   { name: "Melolin Non-Adherent Dressing", cat: "Dressing" },
//   { name: "Hydrocolloid Dressing (DuoDERM)", cat: "Dressing" },
//   { name: "Hydrogel Dressing", cat: "Dressing" },
//   { name: "Foam Dressing", cat: "Dressing" },
//   { name: "Alginate Dressing", cat: "Dressing" },
//   { name: "Transparent Film Dressing (Tegaderm)", cat: "Dressing" },
//   { name: "Povidone Iodine Gauze", cat: "Dressing" },
//   { name: "Silver Sulfadiazine 1% Cream", cat: "Burns Dressing" },
//   { name: "Bacitracin Ointment", cat: "Topical Antibiotic" },
//   { name: "Mupirocin 2% Ointment (Bactroban)", cat: "Topical Antibiotic" },
//   { name: "Fusidic Acid 2% Cream", cat: "Topical Antibiotic" },
//   { name: "Framycetin (Soframycin) Cream", cat: "Topical Antibiotic" },
//   // ── GLOVES / PPE / DISPOSABLES ───────────────────────────────
//   { name: "Latex Examination Gloves (S/M/L)", cat: "PPE" },
//   { name: "Nitrile Examination Gloves (S/M/L)", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 6.0", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 6.5", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 7.0", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 7.5", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 8.0", cat: "PPE" },
//   { name: "Surgical Mask (3-ply)", cat: "PPE" },
//   { name: "N95 Respirator Mask (FFP2)", cat: "PPE" },
//   { name: "Face Shield", cat: "PPE" },
//   { name: "Surgical Cap / Head Cover", cat: "PPE" },
//   { name: "Shoe Cover (Surgical Boot Cover)", cat: "PPE" },
//   { name: "Sterile Gown (Surgical)", cat: "PPE" },
//   { name: "Disposable Apron", cat: "PPE" },
//   { name: "Safety Goggles", cat: "PPE" },
//   { name: "Sharps Container 5L", cat: "Waste Disposal" },
//   { name: "Yellow Biohazard Bag", cat: "Waste Disposal" },
//   { name: "Red Biohazard Bag", cat: "Waste Disposal" },
//   { name: "IV Line / Infusion Set", cat: "IV Accessory" },
//   { name: "Burette Set (Paediatric IV Set)", cat: "IV Accessory" },
//   { name: "Blood Transfusion Set", cat: "IV Accessory" },
//   { name: "Nasogastric Tube (Ryle's Tube) 14F", cat: "Medical Device" },
//   { name: "Nasogastric Tube 16F", cat: "Medical Device" },
//   { name: "Foley Catheter 14F (2-Way)", cat: "Medical Device" },
//   { name: "Foley Catheter 16F (2-Way)", cat: "Medical Device" },
//   { name: "Foley Catheter 18F (3-Way)", cat: "Medical Device" },
//   { name: "Urobag (Urine Collection Bag)", cat: "Medical Device" },
//   { name: "Tracheostomy Tube (Cuffed) Size 7", cat: "Medical Device" },
//   { name: "Endotracheal Tube (ETT) 7.0 Cuffed", cat: "Anaesthesia Device" },
//   { name: "Endotracheal Tube (ETT) 7.5 Cuffed", cat: "Anaesthesia Device" },
//   { name: "Laryngoscope Blade (Macintosh Size 3)", cat: "Anaesthesia Device" },
//   { name: "Laryngeal Mask Airway (LMA) Size 3", cat: "Anaesthesia Device" },
//   { name: "Oropharyngeal Airway (Guedel) Size 3", cat: "Anaesthesia Device" },
//   { name: "Bag Valve Mask (BVM Resuscitator)", cat: "Emergency Device" },
//   { name: "Pulse Oximeter Probe", cat: "Monitoring Device" },
//   { name: "BP Cuff (Sphygmomanometer Cuff)", cat: "Monitoring Device" },
//   // ── RESPIRATORY / BRONCHODILATORS ───────────────────────────
//   { name: "Salbutamol 2mg Tablet", cat: "Bronchodilator" },
//   { name: "Salbutamol 4mg Tablet", cat: "Bronchodilator" },
//   { name: "Salbutamol 2.5mg/2.5ml Nebulisation", cat: "Bronchodilator" },
//   { name: "Salbutamol Inhaler 100mcg (MDI)", cat: "Bronchodilator Inhaler" },
//   { name: "Ipratropium 0.5mg Nebulisation", cat: "Bronchodilator" },
//   { name: "Budesonide 0.5mg Nebulisation", cat: "Steroid Inhaler" },
//   { name: "Doxofylline 400mg Tablet", cat: "Bronchodilator" },
//   { name: "Deriphylline Injection", cat: "Bronchodilator Inj" },
//   // ── ANTIEPILEPTICS ───────────────────────────────────────────
//   { name: "Phenytoin 100mg Tablet", cat: "Antiepileptic" },
//   { name: "Phenytoin 50mg/ml Injection", cat: "Antiepileptic Inj" },
//   { name: "Valproate 200mg Tablet", cat: "Antiepileptic" },
//   { name: "Valproate 500mg Tablet", cat: "Antiepileptic" },
//   { name: "Levetiracetam 500mg Tablet", cat: "Antiepileptic" },
//   { name: "Lorazepam 4mg Injection", cat: "Antiepileptic / Sedative Inj" },
//   { name: "Diazepam 10mg Injection", cat: "Antiepileptic / Sedative Inj" },
//   { name: "Clonazepam 0.5mg Tablet", cat: "Antiepileptic" },
//   { name: "Clonazepam 2mg Tablet", cat: "Antiepileptic" },
//   // ── VACCINES ─────────────────────────────────────────────────
//   { name: "Tetanus Toxoid 0.5ml Injection", cat: "Vaccine" },
//   { name: "Tetanus + Diphtheria (Td) Vaccine", cat: "Vaccine" },
//   { name: "Influenza Vaccine (Flu Shot)", cat: "Vaccine" },
//   { name: "Typhoid Vaccine (Vi Polysaccharide)", cat: "Vaccine" },
//   { name: "Rabies Vaccine (Post-Exposure)", cat: "Vaccine" },
//   { name: "Rabies Immunoglobulin (Human)", cat: "Vaccine" },
//   { name: "MMR Vaccine", cat: "Vaccine" },
//   { name: "Varicella (Chickenpox) Vaccine", cat: "Vaccine" },
//   { name: "HPV Vaccine (Gardasil 4/9)", cat: "Vaccine" },
//   { name: "COVID-19 Vaccine (Covishield)", cat: "Vaccine" },
//   { name: "COVID-19 Vaccine (Covaxin)", cat: "Vaccine" },
//   { name: "Anti-Tetanus Serum (ATS)", cat: "Antiserum" },
//   { name: "Anti-Snake Venom (Polyvalent)", cat: "Antiserum" },
//   { name: "Anti-Rabies Serum", cat: "Antiserum" },
//   { name: "Anti-Scorpion Venom Serum", cat: "Antiserum" },
//   // ── INVESTIGATIONS / LAB ─────────────────────────────────────
//   { name: "OPG (Orthopantomogram) X-ray", cat: "Dental Investigation" },
//   { name: "IOPA X-ray (Intraoral Periapical)", cat: "Dental Investigation" },
//   { name: "Bitewing X-ray", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Cone Beam CT)", cat: "Dental Investigation" },
//   { name: "Occlusal X-ray", cat: "Dental Investigation" },
//   { name: "Lateral Cephalogram X-ray", cat: "Dental Investigation" },
//   { name: "Chest X-ray PA View", cat: "Investigation" },
//   { name: "Skull X-ray AP + Lateral", cat: "Investigation" },
//   { name: "X-Ray Mandible PA View", cat: "Investigation" },
//   { name: "X-Ray Waters View (PNS)", cat: "Investigation" },
//   { name: "ECG (Electrocardiogram)", cat: "Investigation" },
//   { name: "CT Scan Head Plain", cat: "Investigation" },
//   { name: "CT Scan Neck with Contrast", cat: "Investigation" },
//   { name: "MRI Face and Jaw", cat: "Investigation" },
//   { name: "Ultrasound Neck / Submandibular", cat: "Investigation" },
//   { name: "Complete Blood Count (CBC)", cat: "Lab Test" },
//   { name: "Differential Count (DC)", cat: "Lab Test" },
//   { name: "Blood Sugar Fasting (BSF)", cat: "Lab Test" },
//   { name: "Blood Sugar Post Prandial (BSPP)", cat: "Lab Test" },
//   { name: "Random Blood Sugar (RBS)", cat: "Lab Test" },
//   { name: "HbA1c Test", cat: "Lab Test" },
//   { name: "Liver Function Test (LFT)", cat: "Lab Test" },
//   { name: "Kidney Function Test (KFT) / RFT", cat: "Lab Test" },
//   { name: "Thyroid Function Test (TFT)", cat: "Lab Test" },
//   { name: "Lipid Profile Test", cat: "Lab Test" },
//   { name: "Urine Routine and Microscopy", cat: "Lab Test" },
//   { name: "Blood Group and Rh Typing", cat: "Lab Test" },
//   { name: "Platelet Count", cat: "Lab Test" },
//   { name: "PT / INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "APTT Test", cat: "Lab Test" },
//   { name: "Bleeding Time (BT)", cat: "Lab Test" },
//   { name: "Clotting Time (CT)", cat: "Lab Test" },
//   { name: "ESR (Erythrocyte Sedimentation Rate)", cat: "Lab Test" },
//   { name: "CRP (C-Reactive Protein)", cat: "Lab Test" },
//   { name: "Serum Calcium Test", cat: "Lab Test" },
//   { name: "Serum Phosphorus Test", cat: "Lab Test" },
//   { name: "Serum Vitamin D (25-OH) Test", cat: "Lab Test" },
//   { name: "Serum Vitamin B12 Test", cat: "Lab Test" },
//   { name: "Serum Iron / TIBC Test", cat: "Lab Test" },
//   { name: "HIV Test (ELISA)", cat: "Lab Test" },
//   { name: "HBsAg Test (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HCV Test (Hepatitis C)", cat: "Lab Test" },
//   { name: "VDRL / RPR Test (Syphilis)", cat: "Lab Test" },
//   { name: "Pus Culture and Sensitivity", cat: "Lab Test" },
//   { name: "Blood Culture and Sensitivity", cat: "Lab Test" },
//   { name: "FNAC (Fine Needle Aspiration Cytology)", cat: "Biopsy" },
//   { name: "Incisional Biopsy", cat: "Biopsy" },
//   { name: "Excisional Biopsy", cat: "Biopsy" },
//   { name: "Exfoliative Cytology (Oral Smear)", cat: "Lab Test" },
//   { name: "Histopathology (HPE)", cat: "Lab Test" },
//   // ── EMERGENCY DRUGS ─────────────────────────────────────────
//   { name: "Adrenaline 1:1000 (1mg/ml) Injection", cat: "Emergency Drug" },
//   { name: "Adrenaline 1:10000 Injection (Cardiac)", cat: "Emergency Drug" },
//   { name: "Atropine 0.6mg Injection", cat: "Emergency Drug" },
//   { name: "Sodium Bicarbonate 8.4% Injection", cat: "Emergency Drug" },
//   { name: "Calcium Gluconate 10% Injection", cat: "Emergency Drug" },
//   { name: "Dextrose 50% Injection (Hypoglycaemia)", cat: "Emergency Drug" },
//   { name: "Naloxone 0.4mg Injection (Opioid Reversal)", cat: "Emergency Drug" },
//   {
//     name: "Flumazenil 0.5mg Injection (Benzo Reversal)",
//     cat: "Emergency Drug",
//   },
//   { name: "Dopamine 200mg Infusion", cat: "Emergency Drug Inj" },
//   {
//     name: "Noradrenaline (Norepinephrine) Infusion",
//     cat: "Emergency Drug Inj",
//   },
//   { name: "Vasopressin 20 IU Injection", cat: "Emergency Drug Inj" },
//   { name: "GTN (Glyceryl Trinitrate) Infusion", cat: "Emergency Drug Inj" },
//   {
//     name: "Lignocaine 100mg IV Injection (Arrhythmia)",
//     cat: "Emergency Drug Inj",
//   },
//   { name: "Adenosine 6mg Injection (SVT)", cat: "Emergency Drug Inj" },
//   { name: "Defibrillator Pads (AED Electrode)", cat: "Emergency Device" },
//   ,
//   // ── CONSUMABLES: COTTON & GAUZE ──────────────────────────────
//   { name: "Cotton Roll (Dental Grade)", cat: "Consumable" },
//   { name: "Cotton Pellet Small", cat: "Consumable" },
//   { name: "Cotton Pellet Medium", cat: "Consumable" },
//   { name: "Cotton Pellet Large", cat: "Consumable" },
//   { name: "Absorbent Cotton Wool 500g Roll", cat: "Consumable" },
//   { name: "Absorbent Cotton Wool 100g", cat: "Consumable" },
//   { name: "Gauze Swab 4x4 inch Sterile", cat: "Consumable" },
//   { name: "Gauze Swab 2x2 inch Sterile", cat: "Consumable" },
//   { name: "Gauze Roll 5cm x 5m", cat: "Consumable" },
//   { name: "Gauze Roll 10cm x 5m", cat: "Consumable" },
//   { name: "Non-Woven Gauze Swab 4x4", cat: "Consumable" },
//   { name: "Paraffin Gauze Dressing", cat: "Dressing" },
//   { name: "Betadine Gauze Dressing", cat: "Dressing" },
//   { name: "Ribbon Gauze 1/2 inch (Dental Packing)", cat: "Dental Consumable" },
//   { name: "Ribbon Gauze 1 inch", cat: "Dental Consumable" },
//   { name: "Dry Foil (Dental)", cat: "Dental Consumable" },

//   // ── SALINE & IV FLUIDS ─────────────────────────────────────────
//   { name: "Normal Saline 0.9% 100ml", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 250ml", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 500ml", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 1000ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 100ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 250ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 500ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 1000ml", cat: "IV Fluid" },
//   { name: "Dextrose 10% 500ml", cat: "IV Fluid" },
//   { name: "Dextrose 25% 100ml", cat: "IV Fluid" },
//   { name: "Dextrose 50% 50ml", cat: "IV Fluid" },
//   { name: "Ringer Lactate 500ml", cat: "IV Fluid" },
//   { name: "Ringer Lactate 1000ml", cat: "IV Fluid" },
//   { name: "DNS (Dextrose Normal Saline) 500ml", cat: "IV Fluid" },
//   { name: "DNS 1000ml", cat: "IV Fluid" },
//   { name: "Haemaccel 500ml Infusion", cat: "IV Fluid" },
//   { name: "Gelofusine 500ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 100ml", cat: "IV Fluid" },
//   { name: "Mannitol 20% 250ml", cat: "IV Fluid" },
//   { name: "Sodium Bicarbonate 7.5% 25ml", cat: "IV Electrolyte" },
//   { name: "Sodium Bicarbonate 8.4% 100ml", cat: "IV Electrolyte" },
//   { name: "Potassium Chloride 15% 10ml Ampoule", cat: "IV Electrolyte" },
//   { name: "Calcium Gluconate 10% 10ml Injection", cat: "IV Electrolyte" },
//   { name: "Magnesium Sulphate 50% 2ml Injection", cat: "IV Electrolyte" },

//   // ── NEEDLES ────────────────────────────────────────────────────
//   { name: "Disposable Syringe 1ml (Insulin Type)", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 2ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 5ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 10ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 20ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 50ml", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 18G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 20G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 22G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 24G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 26G", cat: "Needle/Syringe" },
//   { name: "Dental Needle 27G Short", cat: "Dental Needle" },
//   { name: "Dental Needle 27G Long", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Short", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Ultra Short", cat: "Dental Needle" },
//   { name: "Scalp Vein Set (Butterfly) 21G", cat: "IV Accessory" },
//   { name: "Scalp Vein Set (Butterfly) 23G", cat: "IV Accessory" },
//   { name: "Scalp Vein Set (Butterfly) 25G", cat: "IV Accessory" },
//   { name: "IV Cannula 14G (Orange)", cat: "IV Cannula" },
//   { name: "IV Cannula 16G (Grey)", cat: "IV Cannula" },
//   { name: "IV Cannula 18G (Green)", cat: "IV Cannula" },
//   { name: "IV Cannula 20G (Pink)", cat: "IV Cannula" },
//   { name: "IV Cannula 22G (Blue)", cat: "IV Cannula" },
//   { name: "IV Cannula 24G (Yellow) Paediatric", cat: "IV Cannula" },
//   { name: "Spinal Needle 25G (Quincke)", cat: "Spinal Needle" },
//   { name: "Spinal Needle 26G", cat: "Spinal Needle" },
//   { name: "Spinal Needle 27G", cat: "Spinal Needle" },
//   { name: "Epidural Needle 16G (Tuohy)", cat: "Epidural Needle" },
//   { name: "Epidural Needle 17G (Tuohy)", cat: "Epidural Needle" },

//   // ── INJECTIONS & AMPOULES ──────────────────────────────────────
//   {
//     name: "Lignocaine 2% with Adrenaline 1:80000 Cartridge (Dental)",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Lignocaine 2% with Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Lignocaine 2% Plain Cartridge (Dental)", cat: "Local Anaesthetic" },
//   {
//     name: "Articaine 4% with Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% with Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Mepivacaine 3% Plain Cartridge", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% with Adrenaline", cat: "Local Anaesthetic" },
//   { name: "Prilocaine 4% Plain Cartridge", cat: "Local Anaesthetic" },
//   {
//     name: "Benzocaine 20% Topical Gel (Dental)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Lidocaine 2% Topical Jelly", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lidocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine 2% Jelly 30g", cat: "Local Anaesthetic Topical" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 250mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 40mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 125mg Injection", cat: "Steroid Inj" },
//   { name: "Ketorolac 30mg Injection", cat: "NSAID Inj" },
//   { name: "Diclofenac 75mg Injection", cat: "NSAID Inj" },
//   { name: "Tramadol 50mg Injection", cat: "Painkiller Inj" },
//   { name: "Tramadol 100mg Injection", cat: "Painkiller Inj" },
//   { name: "Morphine 10mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pethidine 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Fentanyl 50mcg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Ondansetron 4mg Injection", cat: "Antiemetic Inj" },
//   { name: "Metoclopramide 10mg Injection", cat: "Antiemetic Inj" },
//   { name: "Promethazine 25mg Injection", cat: "Antiemetic Inj" },
//   { name: "Chlorpheniramine 10mg Injection", cat: "Antihistamine Inj" },
//   { name: "Pheniramine 22.75mg Injection", cat: "Antihistamine Inj" },
//   { name: "Midazolam 1mg/ml Injection", cat: "Sedative" },
//   { name: "Midazolam 5mg/ml Injection", cat: "Sedative" },
//   { name: "Diazepam 5mg Injection", cat: "Sedative" },
//   { name: "Propofol 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 200mg Injection", cat: "General Anaesthesia" },
//   { name: "Atropine 0.6mg Injection", cat: "Anticholinergic" },
//   { name: "Neostigmine 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Succinylcholine 100mg Injection", cat: "Muscle Relaxant" },
//   { name: "Vecuronium 4mg Injection", cat: "Muscle Relaxant" },
//   { name: "Atracurium 25mg Injection", cat: "Muscle Relaxant" },
//   { name: "Furosemide 20mg Injection", cat: "Diuretic Inj" },
//   { name: "Furosemide 40mg Injection", cat: "Diuretic Inj" },
//   { name: "Ranitidine 50mg Injection", cat: "Antacid Inj" },
//   { name: "Pantoprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Omeprazole 40mg Injection", cat: "Antacid Inj" },
//   {
//     name: "Phytomenadione (Vitamin K1) 10mg Injection",
//     cat: "Haemostatic Inj",
//   },
//   { name: "Tranexamic Acid 500mg Injection", cat: "Haemostatic Inj" },
//   { name: "Etamsylate 250mg Injection", cat: "Haemostatic Inj" },
//   { name: "Oxytocin 10 IU Injection", cat: "Haemostatic Inj" },
//   { name: "Dextrose 50% 50ml Push", cat: "Emergency Drug Inj" },
//   { name: "Naloxone 0.4mg Injection", cat: "Reversal Agent" },
//   { name: "Flumazenil 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Calcium Gluconate 1g Injection", cat: "Emergency Drug Inj" },

//   // ── SURGICAL INSTRUMENTS ───────────────────────────────────────
//   { name: "Scalpel Handle No. 3", cat: "Surgical Instrument" },
//   { name: "Scalpel Handle No. 4", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 11", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 12", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 15", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 22", cat: "Surgical Instrument" },
//   { name: "Surgical Scissors Straight (Mayo)", cat: "Surgical Instrument" },
//   { name: "Surgical Scissors Curved (Mayo)", cat: "Surgical Instrument" },
//   { name: "Metzenbaum Scissors", cat: "Surgical Instrument" },
//   { name: "Iris Scissors", cat: "Surgical Instrument" },
//   { name: "Dissecting Forceps (Toothed) Adson", cat: "Surgical Instrument" },
//   { name: "Dissecting Forceps (Non-Toothed)", cat: "Surgical Instrument" },
//   { name: "Haemostat (Mosquito Forceps) Straight", cat: "Surgical Instrument" },
//   { name: "Haemostat (Mosquito Forceps) Curved", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Kocher) Straight", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Kocher) Curved", cat: "Surgical Instrument" },
//   { name: "Needle Holder (Mayo-Hegar)", cat: "Surgical Instrument" },
//   { name: "Retractor (Langenbeck) Small", cat: "Surgical Instrument" },
//   { name: "Retractor (Langenbeck) Large", cat: "Surgical Instrument" },
//   { name: "Self-Retaining Retractor (Weitlaner)", cat: "Surgical Instrument" },
//   { name: "Bone Rongeur Forceps", cat: "Surgical Instrument" },
//   { name: "Curette Small", cat: "Surgical Instrument" },
//   { name: "Curette Large", cat: "Surgical Instrument" },
//   { name: "Periosteal Elevator (Molt No.9)", cat: "Dental Instrument" },
//   { name: "Periosteal Elevator (Freer)", cat: "Dental Instrument" },
//   { name: "Luxator (Periotome)", cat: "Dental Instrument" },
//   { name: "Dental Elevator (Straight)", cat: "Dental Instrument" },
//   { name: "Dental Elevator (Cryer)", cat: "Dental Instrument" },
//   { name: "Dental Elevator (Warwick James)", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Anteriors", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Premolars", cat: "Dental Instrument" },
//   {
//     name: "Extraction Forceps Upper Molars (Cowhorn)",
//     cat: "Dental Instrument",
//   },
//   { name: "Extraction Forceps Lower Anteriors", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Molars", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Wisdom", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Wisdom", cat: "Dental Instrument" },
//   { name: "Bone File (Dental)", cat: "Dental Instrument" },
//   { name: "Bone Chisel (Dental)", cat: "Dental Instrument" },
//   { name: "Mallet (Surgical)", cat: "Dental Instrument" },
//   { name: "Rongeur Forceps (Dental)", cat: "Dental Instrument" },
//   { name: "Tissue Scissors (Dental)", cat: "Dental Instrument" },
//   { name: "Tongue Retractor", cat: "Dental Instrument" },
//   { name: "Cheek Retractor (Minnesota)", cat: "Dental Instrument" },
//   { name: "Austin/Channel Retractor", cat: "Dental Instrument" },
//   { name: "Dental Mirror No. 5", cat: "Dental Instrument" },
//   { name: "Dental Probe (CPI/UNC-15)", cat: "Dental Instrument" },
//   { name: "Dental Tweezers (College Pliers)", cat: "Dental Instrument" },
//   { name: "Dental Excavator Double Ended", cat: "Dental Instrument" },
//   { name: "Spoon Excavator Small", cat: "Dental Instrument" },
//   { name: "Spoon Excavator Medium", cat: "Dental Instrument" },
//   { name: "Amalgam Plugger", cat: "Dental Instrument" },
//   { name: "Composite Placement Instrument", cat: "Dental Instrument" },
//   { name: "Burnisher Ball", cat: "Dental Instrument" },
//   { name: "Burnisher Acorn", cat: "Dental Instrument" },
//   { name: "Sickle Scaler (H6/H7)", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 1/2", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 7/8", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 11/12", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 13/14", cat: "Periodontal Instrument" },
//   { name: "Columbia Curette", cat: "Periodontal Instrument" },
//   { name: "Hoe Scaler", cat: "Periodontal Instrument" },
//   { name: "File Scaler", cat: "Periodontal Instrument" },
//   { name: "Ultrasonic Scaler Tip (Slim)", cat: "Periodontal Instrument" },
//   { name: "Ultrasonic Scaler Tip (Universal)", cat: "Periodontal Instrument" },

//   // ── SUTURES ─────────────────────────────────────────────────────
//   { name: "Vicryl 3-0 (Polyglactin) Absorbable", cat: "Suture" },
//   { name: "Vicryl 4-0 Absorbable", cat: "Suture" },
//   { name: "Vicryl 5-0 Absorbable", cat: "Suture" },
//   { name: "Catgut Plain 2-0", cat: "Suture" },
//   { name: "Catgut Plain 3-0", cat: "Suture" },
//   { name: "Catgut Chromic 2-0", cat: "Suture" },
//   { name: "Catgut Chromic 3-0", cat: "Suture" },
//   { name: "Catgut Chromic 4-0", cat: "Suture" },
//   { name: "Silk 2-0 Non-Absorbable", cat: "Suture" },
//   { name: "Silk 3-0 Non-Absorbable (Dental)", cat: "Suture" },
//   { name: "Silk 4-0 Non-Absorbable", cat: "Suture" },
//   { name: "Prolene 4-0 (Polypropylene)", cat: "Suture" },
//   { name: "Prolene 5-0", cat: "Suture" },
//   { name: "Prolene 6-0", cat: "Suture" },
//   { name: "Nylon 3-0 Monofilament", cat: "Suture" },
//   { name: "Nylon 4-0 Monofilament", cat: "Suture" },
//   { name: "Nylon 5-0 Monofilament", cat: "Suture" },
//   { name: "PDS II 3-0 (Polydioxanone)", cat: "Suture" },
//   { name: "PDS II 4-0", cat: "Suture" },
//   { name: "Monocryl 4-0 (Poliglecaprone)", cat: "Suture" },
//   { name: "Monocryl 5-0", cat: "Suture" },
//   { name: "Ethibond 0 (Polyester)", cat: "Suture" },
//   { name: "Ethibond 2-0", cat: "Suture" },
//   { name: "Stapler (Skin Staples)", cat: "Surgical Closure" },
//   { name: "Steri-Strip Wound Closure 6mm", cat: "Surgical Closure" },
//   { name: "Steri-Strip Wound Closure 12mm", cat: "Surgical Closure" },
//   { name: "Tissue Glue (Dermabond/Histoacryl)", cat: "Surgical Closure" },

//   // ── IV DRIP ACCESSORIES ────────────────────────────────────────
//   { name: "IV Infusion Set (Standard)", cat: "IV Accessory" },
//   { name: "IV Infusion Set (Burette 100ml Paediatric)", cat: "IV Accessory" },
//   { name: "Blood Transfusion Set", cat: "IV Accessory" },
//   { name: "Extension Tubing (IV Line)", cat: "IV Accessory" },
//   { name: "Three-Way Stopcock", cat: "IV Accessory" },
//   { name: "Tegaderm IV Dressing 6x7cm", cat: "IV Accessory" },
//   { name: "Transparent Dressing IV Site", cat: "IV Accessory" },
//   { name: "IV Arm Board (Splint)", cat: "IV Accessory" },
//   { name: "Normal Saline Flush 10ml Pre-filled", cat: "IV Accessory" },
//   { name: "Heparin Flush 10 IU/ml", cat: "IV Accessory" },

//   // ── DRESSINGS & WOUND CARE ─────────────────────────────────────
//   { name: "Adhesive Plaster Roll 1 inch", cat: "Wound Care" },
//   { name: "Adhesive Plaster Roll 2 inch", cat: "Wound Care" },
//   { name: "Band-Aid Fabric 1 inch", cat: "Wound Care" },
//   { name: "Crepe Bandage 4 inch", cat: "Bandage" },
//   { name: "Crepe Bandage 6 inch", cat: "Bandage" },
//   { name: "Crepe Bandage 8 inch", cat: "Bandage" },
//   { name: "Elastic Adhesive Bandage 4 inch", cat: "Bandage" },
//   { name: "Cotton Bandage 4 inch", cat: "Bandage" },
//   { name: "Plaster of Paris (POP) Bandage 4 inch", cat: "Bandage" },
//   { name: "Plaster of Paris Bandage 6 inch", cat: "Bandage" },
//   { name: "Zinc Oxide Adhesive Plaster 1 inch", cat: "Wound Care" },
//   { name: "Wound Dressing Large (10x10)", cat: "Dressing" },
//   { name: "Wound Dressing Medium (7.5x7.5)", cat: "Dressing" },
//   { name: "Hydrocolloid Dressing", cat: "Wound Care" },
//   { name: "Foam Dressing", cat: "Wound Care" },
//   { name: "Silver Sulfadiazine 1% Cream (Burns)", cat: "Burns Dressing" },
//   { name: "Bactigras (Chlorhexidine Tulle)", cat: "Dressing" },

//   // ── ANTISEPTICS & DISINFECTANTS ────────────────────────────────
//   { name: "Povidone Iodine 5% Solution (Betadine)", cat: "Antiseptic" },
//   { name: "Povidone Iodine 10% Solution", cat: "Antiseptic" },
//   { name: "Povidone Iodine Surgical Scrub", cat: "Antiseptic" },
//   { name: "Chlorhexidine Gluconate 2% Solution", cat: "Antiseptic" },
//   { name: "Chlorhexidine Gluconate 4% Surgical Scrub", cat: "Antiseptic" },
//   { name: "Chlorhexidine 0.2% Mouthwash (Dental)", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Antiseptic" },
//   {
//     name: "Hydrogen Peroxide 6% (Dental Irrigation)",
//     cat: "Dental Antiseptic",
//   },
//   { name: "Isopropyl Alcohol 70% (Spirit Swabs)", cat: "Antiseptic" },
//   { name: "Alcohol Swabs (Pre-injection)", cat: "Antiseptic" },
//   { name: "Cetrimide + Chlorhexidine Solution", cat: "Antiseptic" },
//   { name: "Sodium Hypochlorite 2.5% (NaOCl - Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% (NaOCl)", cat: "Endodontic" },
//   { name: "EDTA Solution 17% (Root Canal)", cat: "Endodontic" },
//   { name: "EDTA Gel (RC Prep)", cat: "Endodontic" },
//   { name: "Saline Irrigation Solution 500ml", cat: "IV Fluid" },
//   { name: "Saline Nasal Drops", cat: "Consumable" },
//   { name: "Savlon (Cetrimide + Chlorhexidine)", cat: "Antiseptic" },
//   { name: "Dettol Liquid Antiseptic", cat: "Antiseptic" },

//   // ── DENTAL MATERIALS (EXPANDED) ────────────────────────────────
//   { name: "Zinc Oxide Eugenol (ZOE) Cement Base", cat: "Dental Material" },
//   { name: "Zinc Oxide Eugenol Impression Paste", cat: "Dental Material" },
//   { name: "Zinc Phosphate Cement", cat: "Dental Material" },
//   { name: "Zinc Polycarboxylate Cement", cat: "Dental Material" },
//   { name: "Glass Ionomer Cement Type I (Luting)", cat: "Dental Material" },
//   {
//     name: "Glass Ionomer Cement Type II (Restorative)",
//     cat: "Dental Material",
//   },
//   { name: "Glass Ionomer Cement Type III (Lining)", cat: "Dental Material" },
//   { name: "RMGIC (Resin Modified GIC)", cat: "Dental Material" },
//   { name: "Composite Resin Shade A1", cat: "Dental Material" },
//   { name: "Composite Resin Shade A2", cat: "Dental Material" },
//   { name: "Composite Resin Shade A3", cat: "Dental Material" },
//   { name: "Composite Resin Shade A3.5", cat: "Dental Material" },
//   { name: "Composite Resin Shade B1", cat: "Dental Material" },
//   { name: "Flowable Composite Shade A2", cat: "Dental Material" },
//   { name: "Flowable Composite Shade A3", cat: "Dental Material" },
//   { name: "Bonding Agent (5th Generation)", cat: "Dental Material" },
//   { name: "Bonding Agent (7th Generation Self-Etch)", cat: "Dental Material" },
//   { name: "Acid Etchant 37% Phosphoric Acid Gel", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste (Pulp Capping)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Powder", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Cavity Liner (Dycal)", cat: "Dental Material" },
//   { name: "Temporary Restoration Material (Cavit)", cat: "Dental Material" },
//   { name: "IRM Temporary Cement", cat: "Dental Material" },
//   { name: "Zinc Oxide Temp Fill", cat: "Dental Material" },
//   { name: "Alginate Impression Material (Chromatic)", cat: "Dental Material" },
//   { name: "Irreversible Hydrocolloid (Alginate) 500g", cat: "Dental Material" },
//   {
//     name: "Polyvinyl Siloxane (PVS) Impression Light Body",
//     cat: "Dental Material",
//   },
//   { name: "PVS Impression Heavy Body", cat: "Dental Material" },
//   { name: "Polyether Impression Material", cat: "Dental Material" },
//   { name: "Zinc Oxide Impression Paste (ZO Paste)", cat: "Dental Material" },
//   { name: "Plaster of Paris Dental Grade", cat: "Dental Material" },
//   { name: "Type III Dental Stone", cat: "Dental Material" },
//   { name: "Type IV Dental Stone (Die Stone)", cat: "Dental Material" },
//   { name: "Dental Wax (Modelling Wax)", cat: "Dental Material" },
//   { name: "Baseplate Wax", cat: "Dental Material" },
//   { name: "Sticky Wax", cat: "Dental Material" },
//   { name: "Bite Registration Paste", cat: "Dental Material" },
//   { name: "Separating Liquid (Sodium Alginate)", cat: "Dental Material" },
//   { name: "Denture Base Resin (Heat Cure)", cat: "Dental Material" },
//   { name: "Denture Base Resin (Cold Cure)", cat: "Dental Material" },
//   { name: "Denture Repair Resin", cat: "Dental Material" },
//   { name: "Acrylic Teeth Set (Upper)", cat: "Dental Material" },
//   { name: "Acrylic Teeth Set (Lower)", cat: "Dental Material" },
//   { name: "Porcelain Teeth", cat: "Dental Material" },
//   { name: "Chromium Cobalt Alloy (Partial Denture)", cat: "Dental Material" },
//   { name: "Amalgam Alloy Capsules (Pre-dosed)", cat: "Dental Material" },
//   { name: "Mercury (Dental Grade)", cat: "Dental Material" },
//   { name: "Amalgam Capsule Activator", cat: "Dental Accessory" },
//   { name: "Light Cure Composite Bleaching Gel 35%", cat: "Dental Material" },
//   { name: "Carbamide Peroxide 10% (Home Bleaching)", cat: "Dental Material" },
//   { name: "Carbamide Peroxide 16%", cat: "Dental Material" },
//   { name: "Carbamide Peroxide 22%", cat: "Dental Material" },
//   {
//     name: "Hydrogen Peroxide 35% (In-office Bleaching)",
//     cat: "Dental Material",
//   },
//   { name: "Desensitising Agent (Gluma)", cat: "Dental Material" },
//   { name: "Fluoride Varnish 5% NaF (Duraphat)", cat: "Dental Fluoride" },
//   { name: "Fluoride Gel APF 1.23%", cat: "Fluoride Gel" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "Pit & Fissure Sealant (Light Cure)", cat: "Dental Material" },
//   { name: "Pit & Fissure Sealant (Self-Cure)", cat: "Dental Material" },
//   { name: "Crown & Bridge Temporary Cement", cat: "Dental Material" },
//   { name: "Permanent Crown Cement (Ketac Cem)", cat: "Dental Material" },
//   { name: "Resin Cement (Panavia F)", cat: "Dental Material" },
//   { name: "Post & Core Material", cat: "Dental Material" },
//   { name: "Fibre Post (Glass Fibre)", cat: "Dental Material" },
//   { name: "Gutta Percha Points ISO Size 15", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 20", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 25", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 30", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 35", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 40", cat: "Endodontic" },
//   { name: "Gutta Percha Points Standardised Large", cat: "Endodontic" },
//   { name: "Gutta Percha Points Accessory Fine", cat: "Endodontic" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Apexit Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Zinc Oxide Eugenol)", cat: "Endodontic" },
//   { name: "K-File ISO 15 (Root Canal File)", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 20", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 25", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 30", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 35", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 40", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 45", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 50", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 60", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 80", cat: "Endodontic Instrument" },
//   { name: "H-File (Hedstroem) ISO 20", cat: "Endodontic Instrument" },
//   { name: "H-File ISO 25", cat: "Endodontic Instrument" },
//   { name: "H-File ISO 30", cat: "Endodontic Instrument" },
//   { name: "Reamer ISO 15-40 Set", cat: "Endodontic Instrument" },
//   { name: "ProTaper Next Rotary File Set", cat: "Endodontic Instrument" },
//   {
//     name: "WaveOne Gold Primary (Reciprocating)",
//     cat: "Endodontic Instrument",
//   },
//   { name: "Reciproc Blue R25", cat: "Endodontic Instrument" },
//   { name: "Lentulo Spiral Filler", cat: "Endodontic Instrument" },
//   { name: "Plugger Spreader (Gutta Percha)", cat: "Endodontic Instrument" },
//   { name: "Barbed Broach Assorted", cat: "Endodontic Instrument" },
//   { name: "Paper Points ISO 20", cat: "Endodontic Accessory" },
//   { name: "Paper Points ISO 25", cat: "Endodontic Accessory" },
//   { name: "Paper Points ISO 30", cat: "Endodontic Accessory" },
//   { name: "Paper Points ISO 40", cat: "Endodontic Accessory" },
//   { name: "Paper Points Fine (Accessory)", cat: "Endodontic Accessory" },
//   { name: "Apex Locator Tips", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Sheet (Latex)", cat: "Dental Accessory" },
//   { name: "Rubber Dam Frame (Ostby)", cat: "Dental Accessory" },
//   { name: "Rubber Dam Clamp Kit", cat: "Dental Accessory" },
//   { name: "Rubber Dam Punch", cat: "Dental Accessory" },
//   { name: "Saliva Ejector Tips (Disposable)", cat: "Dental Accessory" },
//   { name: "High Volume Evacuation Tip (HVE)", cat: "Dental Accessory" },
//   { name: "Matrix Band (Tofflemire Universal)", cat: "Dental Accessory" },
//   { name: "Sectional Matrix System (Palodent)", cat: "Dental Accessory" },
//   { name: "Wooden Wedge Assorted", cat: "Dental Accessory" },
//   { name: "Interproximal Plastic Wedge", cat: "Dental Accessory" },
//   { name: "Celluloid Crown Form (Anterior)", cat: "Dental Accessory" },
//   {
//     name: "Stainless Steel Crown (Molar Paediatric)",
//     cat: "Paediatric Dental",
//   },
//   { name: "Stainless Steel Crown Kit", cat: "Paediatric Dental" },
//   { name: "Pulpotomy Agent (Formocresol)", cat: "Paediatric Dental" },
//   { name: "Pulpotomy Agent (Ferric Sulphate 15.5%)", cat: "Paediatric Dental" },
//   { name: "Zinc Oxide Eugenol Paediatric Filling", cat: "Paediatric Dental" },

//   // ── ORTHO MATERIALS ────────────────────────────────────────────
//   { name: "Orthodontic Bands (Molar) Upper", cat: "Dental Ortho" },
//   { name: "Orthodontic Bands (Molar) Lower", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Metal Roth)", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Ceramic)", cat: "Dental Ortho" },
//   { name: "Archwire NiTi Round 0.014", cat: "Dental Ortho" },
//   { name: "Archwire NiTi Round 0.016", cat: "Dental Ortho" },
//   { name: "Archwire NiTi Round 0.018", cat: "Dental Ortho" },
//   { name: "Archwire SS Rectangular 0.019x0.025", cat: "Dental Ortho" },
//   { name: "Archwire SS Rectangular 0.021x0.025", cat: "Dental Ortho" },
//   { name: "Ligature Wire (Stainless Steel)", cat: "Dental Ortho" },
//   { name: "Elastic Ligature Ties Assorted", cat: "Dental Ortho" },
//   { name: "Power Chain Elastic", cat: "Dental Ortho" },
//   { name: "Separating Elastics (Orthodontic)", cat: "Dental Ortho" },
//   { name: "Molar Tube (Buccal Tube)", cat: "Dental Ortho" },
//   { name: "Ortho Bracket Adhesive (Light Cure)", cat: "Dental Ortho" },
//   { name: "Band Cement (Glass Ionomer Ortho)", cat: "Dental Ortho" },
//   { name: "Debonding Pliers", cat: "Dental Ortho" },
//   { name: "Ligature Tying Pliers", cat: "Dental Ortho" },
//   { name: "How Pliers", cat: "Dental Ortho" },
//   { name: "Cinching Pliers", cat: "Dental Ortho" },
//   { name: "Wire Cutters (Distal End Cutter)", cat: "Dental Ortho" },
//   { name: "Invisalign Chewies (Aligner Seater)", cat: "Dental Ortho" },
//   { name: "Retainer (Hawley Plate)", cat: "Dental Ortho" },

//   // ── PPE & INFECTION CONTROL ────────────────────────────────────
//   { name: "Nitrile Gloves Small (Powder-Free)", cat: "PPE" },
//   { name: "Nitrile Gloves Medium (Powder-Free)", cat: "PPE" },
//   { name: "Nitrile Gloves Large (Powder-Free)", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 6.5", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 7", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 7.5", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 8", cat: "PPE" },
//   { name: "Examination Gloves (Vinyl) Medium", cat: "PPE" },
//   { name: "3-Ply Surgical Face Mask", cat: "PPE" },
//   { name: "N95 Respirator (NIOSH Approved)", cat: "PPE" },
//   { name: "Surgical Gown (Non-Woven Sterile)", cat: "PPE" },
//   { name: "Disposable Apron (Polythene)", cat: "PPE" },
//   { name: "Shoe Cover (Disposable)", cat: "PPE" },
//   { name: "Head Cover / Surgical Cap", cat: "PPE" },
//   { name: "Face Shield (Dental)", cat: "PPE" },
//   { name: "Safety Goggles", cat: "PPE" },
//   { name: "Bib (Dental Patient)", cat: "Dental Accessory" },
//   { name: "Bib Clips", cat: "Dental Accessory" },
//   { name: "Autoclave Pouches (Self-Seal)", cat: "PPE" },
//   { name: "Sharps Container 5L", cat: "Waste Disposal" },
//   { name: "Sharps Container 1L", cat: "Waste Disposal" },
//   { name: "Biomedical Waste Bag Yellow", cat: "Waste Disposal" },
//   { name: "Biomedical Waste Bag Red", cat: "Waste Disposal" },

//   // ── COMMON OTC / PRESCRIPTION TABLETS ─────────────────────────
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 250mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 100mg/5ml Syrup", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Diclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Aceclofenac + Paracetamol + Serratiopeptidase", cat: "NSAID Combo" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 120mg Tablet", cat: "NSAID" },
//   { name: "Celecoxib 100mg Capsule", cat: "NSAID" },
//   { name: "Celecoxib 200mg Capsule", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Capsule", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   {
//     name: "Trypsin + Chymotrypsin Tablet (Antiflam)",
//     cat: "Enzyme Combination",
//   },
//   { name: "Serratiopeptidase 10mg Tablet", cat: "Enzyme Combination" },
//   { name: "Serratiopeptidase 20mg Tablet", cat: "Enzyme Combination" },
//   { name: "Deflazacort 6mg Tablet", cat: "Steroid" },
//   { name: "Deflazacort 12mg Tablet", cat: "Steroid" },
//   { name: "Deflazacort 30mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 8mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 16mg Tablet", cat: "Steroid" },
//   { name: "Betamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Pantoprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Omeprazole 10mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 40mg Capsule", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 10mg Tablet", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Ranitidine 150mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ranitidine 300mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 4mg/5ml Syrup", cat: "Antiemetic" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Domperidone 1mg/ml Suspension", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Promethazine 10mg Tablet", cat: "Antiemetic / Antihistamine" },
//   { name: "Cetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 5mg/5ml Syrup", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 180mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 2.5mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 4mg Tablet", cat: "Antihistamine" },
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin C 1000mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B Complex + Zinc Capsule", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule", cat: "Vitamin" },
//   { name: "Vitamin D3 1000 IU Tablet", cat: "Vitamin" },
//   { name: "Vitamin E 400mg Capsule", cat: "Vitamin" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Calcium Carbonate 500mg Tablet", cat: "Calcium Supplement" },
//   { name: "Zinc Sulphate 20mg Tablet", cat: "Mineral Supplement" },
//   { name: "Ferrous Sulphate 200mg Tablet", cat: "Iron Supplement" },
//   { name: "Ferrous Ascorbate + Folic Acid Tablet", cat: "Iron Supplement" },

//   // ── TOPICAL MEDICATIONS ────────────────────────────────────────
//   {
//     name: "Triamcinolone Acetonide 0.1% Oral Paste (Kenacort)",
//     cat: "Steroid Topical",
//   },
//   { name: "Triamcinolone Acetonide 0.025% Cream", cat: "Steroid Topical" },
//   { name: "Betamethasone 0.05% Cream", cat: "Steroid Topical" },
//   { name: "Clotrimazole 1% Cream", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin Oral Suspension", cat: "Antifungal" },
//   { name: "Nystatin 100000 IU Tablet", cat: "Antifungal" },
//   { name: "Fluconazole 50mg Tablet", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Tablet", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Mupirocin 2% Ointment (Bactroban)", cat: "Topical Antibiotic" },
//   { name: "Neomycin + Bacitracin Ointment", cat: "Topical Antibiotic" },
//   { name: "Tetracycline 3% Ointment", cat: "Topical Antibiotic" },
//   { name: "Fusidic Acid 2% Cream", cat: "Topical Antibiotic" },
//   { name: "Lignocaine Viscous 2% Mouthwash", cat: "Local Anaesthetic Topical" },
//   {
//     name: "Magic Mouthwash (Lignocaine + Diphenhydramine + Antacid)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Amlexanox 5% Paste (Aphthous Ulcer)", cat: "Oral Care" },
//   { name: "Benzydamine 0.15% Mouthwash (Tantum Verde)", cat: "Oral Care" },
//   { name: "Glycerine + Thymol Mouthwash", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash (Hexetidine 0.1%)", cat: "Dental Antiseptic" },
//   { name: "Listerine Mouthwash (OTC)", cat: "Oral Care" },
//   { name: "Colgate Peroxyl Mouthwash", cat: "Oral Care" },
//   { name: "Orajel (Benzocaine 10%) Topical", cat: "Local Anaesthetic Topical" },
//   { name: "Ulcerex Gel (Choline Salicylate)", cat: "Oral Care" },
//   { name: "Dologel CT (Clove Oil Gel)", cat: "Oral Care" },
//   { name: "Clove Oil (Eugenol)", cat: "Dental Material" },

//   // ── DENTAL IMPLANT MATERIALS ───────────────────────────────────
//   { name: "Titanium Implant Fixture (3.3mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (3.5mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (4.0mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (4.5mm)", cat: "Dental Implant" },
//   { name: "Implant Cover Screw", cat: "Dental Implant" },
//   { name: "Implant Healing Abutment", cat: "Dental Implant" },
//   { name: "Implant Final Abutment", cat: "Dental Implant" },
//   { name: "Implant Impression Coping", cat: "Dental Implant" },
//   { name: "Bone Graft (Autograft)", cat: "Dental Surgical" },
//   { name: "Bone Graft (Xenograft - Bio-Oss)", cat: "Dental Surgical" },
//   { name: "Collagen Membrane (Bio-Gide)", cat: "Dental Surgical" },
//   { name: "PRF (Platelet Rich Fibrin) Kit", cat: "Dental Surgical" },
//   {
//     name: "Haemostatic Agent (Surgicel - Oxidised Cellulose)",
//     cat: "Haemostatic Surgical",
//   },
//   { name: "Haemostatic Foam (Gelfoam)", cat: "Haemostatic" },
//   { name: "Bone Wax", cat: "Haemostatic Surgical" },
//   { name: "Surgical Suction Tip (Frazier)", cat: "Dental Instrument" },

//   // ── LAB INVESTIGATIONS ─────────────────────────────────────────
//   { name: "CBC (Complete Blood Count)", cat: "Lab Test" },
//   { name: "RBS (Random Blood Sugar)", cat: "Lab Test" },
//   { name: "FBS (Fasting Blood Sugar)", cat: "Lab Test" },
//   { name: "HbA1c (Glycated Haemoglobin)", cat: "Lab Test" },
//   { name: "Blood Group & Rh Typing", cat: "Lab Test" },
//   { name: "BT (Bleeding Time) & CT (Clotting Time)", cat: "Lab Test" },
//   { name: "PT/INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "APTT (Activated Partial Thromboplastin Time)", cat: "Lab Test" },
//   { name: "LFT (Liver Function Test)", cat: "Lab Test" },
//   { name: "KFT (Kidney Function Test)", cat: "Lab Test" },
//   { name: "Serum Creatinine", cat: "Lab Test" },
//   { name: "Urine Routine Examination", cat: "Lab Test" },
//   { name: "HBsAg (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HIV (ELISA)", cat: "Lab Test" },
//   { name: "VDRL (Syphilis Test)", cat: "Lab Test" },
//   { name: "Dental Radiograph (IOPA X-ray)", cat: "Dental Investigation" },
//   { name: "Orthopantomogram (OPG) X-ray", cat: "Dental Investigation" },
//   { name: "Lateral Cephalogram X-ray", cat: "Dental Investigation" },
//   {
//     name: "Occlusal X-ray (Maxillary/Mandibular)",
//     cat: "Dental Investigation",
//   },
//   { name: "Bitewing Radiograph", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Dental 3D)", cat: "Dental Investigation" },

//   // ── COMMON BRAND NAMES (INDIA) ─────────────────────────────────
//   {
//     name: "Augmentin 625mg Tablet (Amoxicillin+Clavulanate)",
//     cat: "Antibiotic",
//   },
//   { name: "Azithral 500mg Tablet (Azithromycin)", cat: "Antibiotic" },
//   { name: "Cifran 500mg Tablet (Ciprofloxacin)", cat: "Antibiotic" },
//   { name: "Flagyl 400mg Tablet (Metronidazole)", cat: "Antibiotic" },
//   { name: "Doxy 100mg Capsule (Doxycycline)", cat: "Antibiotic" },
//   { name: "Calpol 650mg Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Dolo 650 Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Combiflam Tablet (Ibuprofen+Paracetamol)", cat: "NSAID Combo" },
//   { name: "Voveran 50mg Tablet (Diclofenac)", cat: "NSAID" },
//   { name: "Brufen 400mg Tablet (Ibuprofen)", cat: "NSAID" },
//   { name: "Ultracet Tablet (Tramadol+Paracetamol)", cat: "Analgesic Combo" },
//   { name: "Pan 40mg Tablet (Pantoprazole)", cat: "Antacid / PPI" },
//   { name: "Omez 20mg Capsule (Omeprazole)", cat: "Antacid / PPI" },
//   { name: "Ondem 4mg Tablet (Ondansetron)", cat: "Antiemetic" },
//   { name: "Stemetil 5mg Tablet (Prochlorperazine)", cat: "Antiemetic" },
//   { name: "Sinarest Tablet (Paracetamol+Phenylephrine)", cat: "Antihistamine" },
//   { name: "Allegra 120mg Tablet (Fexofenadine)", cat: "Antihistamine" },
//   {
//     name: "Montair-LC Tablet (Montelukast+Levocetirizine)",
//     cat: "Antihistamine",
//   },
//   { name: "Calpol Syrup (Paracetamol 120mg)", cat: "Painkiller" },
//   {
//     name: "Pyrimon Syrup (Mefenamic+Paracetamol Paediatric)",
//     cat: "Painkiller",
//   },
//   { name: "Perinorm 10mg Tablet (Metoclopramide)", cat: "Antiemetic" },
//   { name: "Rantac 150mg Tablet (Ranitidine)", cat: "Antacid / H2 Blocker" },
//   { name: "Kenacort Oral Paste (Triamcinolone)", cat: "Steroid Topical" },
//   { name: "Kenalog Injection 40mg (Triamcinolone)", cat: "Steroid Inj" },
//   { name: "Depo-Medrol 40mg Injection", cat: "Steroid Inj" },
//   { name: "Betnesol 0.5mg Tablet (Betamethasone)", cat: "Steroid" },
//   { name: "Wysolone 5mg Tablet (Prednisolone)", cat: "Steroid" },
//   { name: "Defcort 6mg Tablet (Deflazacort)", cat: "Steroid" },
//   { name: "Dexona 0.5mg Tablet (Dexamethasone)", cat: "Steroid" },
//   { name: "Mox 500mg Capsule (Amoxicillin)", cat: "Antibiotic" },
//   { name: "Sporanox 100mg Capsule (Itraconazole)", cat: "Antifungal" },
//   { name: "Zovirax 400mg Tablet (Acyclovir)", cat: "Antiviral" },
//   { name: "Valcivir 500mg Tablet (Valacyclovir)", cat: "Antiviral" },
//   { name: "Neosporin Powder (Neomycin+Bacitracin)", cat: "Topical Antibiotic" },
//   { name: "Betadine Ointment 5%", cat: "Antiseptic Topical" },
//   { name: "Borax Glycerine (Oral Ulcer)", cat: "Oral Care" },
//   { name: "Tantum Verde Mouthwash (Benzydamine)", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Recaldent (CPP-ACP Paste)", cat: "Dental Fluoride" },
//   { name: "Tooth Mousse Plus (GC)", cat: "Dental Fluoride" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Sensodyne Repair & Protect", cat: "Dental Brand" },
//   { name: "Colgate Sensitive Pro-Relief", cat: "Dental Brand" },
//   { name: "Pepsodent Germicheck", cat: "Dental Brand" },
//   { name: "Oral-B Toothbrush Indicator", cat: "Dental Brand" },
//   { name: "GUM Soft-Picks Interdental", cat: "Dental Brand" },
//   { name: "Floss (Oral-B Satin)", cat: "Dental Brand" },
//   { name: "Water Flosser", cat: "Dental Brand" },
//   { name: "Tongue Cleaner (Metal)", cat: "Dental Brand" },
//   { name: "Mouth Guard (Bruxism)", cat: "Dental Brand" },
// ];

// // ── Save a custom medicine — receives apiPost function from component
// // apiPost is api.post from api.js — same URL, same token, guaranteed correct
// function saveCustomMed(name, apiPost) {
//   if (!name || name.trim().length < 3) return Promise.resolve(null);
//   // Must contain at least one letter
//   if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
//   // Skip if already in built-in DB
//   const nameLow = name.trim().toLowerCase();
//   const already = MEDICINE_DB.some((m) => m.name.toLowerCase() === nameLow);
//   if (already) return Promise.resolve(null);
//   // Use api.post — same function used everywhere in this app
//   return apiPost("/custommeds", { name: name.trim(), cat: "Custom" })
//     .then((saved) => saved || null)
//     .catch(() => null);
// }

// // ── Google-style multi-word search — uses combined DB + custom meds from state
// // customMeds is passed in from component state (fetched from backend)
// function googleSearch(query, customMeds = []) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   if (!words.length) return [];

//   // Filter out any malformed entries (no name field)
//   const safeMeds = Array.isArray(customMeds)
//     ? customMeds.filter(
//         (m) => m && typeof m.name === "string" && m.name.trim().length > 0,
//       )
//     : [];

//   const combined = [
//     ...MEDICINE_DB,
//     ...safeMeds.map((m) => ({ ...m, _custom: true })),
//   ];

//   const scored = combined
//     .map((m) => {
//       // Guard against undefined name (safety check)
//       if (!m || typeof m.name !== "string") return { m, score: 0 };
//       const nameLow = m.name.toLowerCase();
//       const catLow = (m.cat || "").toLowerCase();
//       let score = 0;
//       for (const w of words) {
//         if (nameLow.startsWith(w)) score += 5;
//         else if (nameLow.includes(w)) score += 3;
//         else if (catLow.includes(w)) score += 1;
//       }
//       // Boost custom medicines so doctor's own entries appear first
//       if (m._custom) score += 2;
//       return { m, score };
//     })
//     .filter((x) => x.score > 0)
//     .sort((a, b) => b.score - a.score)
//     .map((x) => x.m);

//   return scored.slice(0, 12);
// }

// function highlightWords(text, query) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   let result = text;
//   words.forEach((w) => {
//     const re = new RegExp(
//       "(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
//       "gi",
//     );
//     result = result.replace(re, "<b>$1</b>");
//   });
//   return result;
// }

// // ── RxMedInput — single-line medicine autocomplete for prescription table ──
// // Uses position:fixed for dropdown to escape overflow:hidden containers
// function RxMedInput({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const inpRef = React.useRef(null);
//   const wrapRef = React.useRef(null);
//   const [sugs, setSugs] = React.useState([]);
//   const [activeIdx, setActive] = React.useState(-1);
//   const [query, setQuery] = React.useState("");
//   const [dropPos, setDropPos] = React.useState({ top: 0, left: 0, width: 0 });

//   const hide = () => {
//     setSugs([]);
//     setActive(-1);
//     setQuery("");
//   };

//   const calcPos = () => {
//     if (!inpRef.current) return;
//     const r = inpRef.current.getBoundingClientRect();
//     setDropPos({
//       top: r.bottom + window.scrollY,
//       left: r.left + window.scrollX,
//       width: r.width,
//     });
//   };

//   const handleChange = (e) => {
//     const v = e.target.value;
//     onChange(v);
//     if (v.trim().length < 2) {
//       hide();
//       return;
//     }
//     const matches = googleSearch(v, customMeds);
//     if (!matches.length) {
//       hide();
//       return;
//     }
//     setQuery(v);
//     setSugs(matches);
//     setActive(-1);
//     calcPos();
//   };

//   const handleKeyDown = (e) => {
//     if (!sugs.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActive((i) => Math.min(i + 1, sugs.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActive((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       sugs[activeIdx]
//     ) {
//       e.preventDefault();
//       select(sugs[activeIdx].name);
//     } else if (e.key === "Escape") {
//       hide();
//     }
//   };

//   const select = (name) => {
//     onChange(name);
//     hide();
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (inpRef.current) inpRef.current.focus();
//     }, 0);
//   };

//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapRef.current && !wrapRef.current.contains(e.target)) hide();
//     };
//     document.addEventListener("mousedown", handler);
//     window.addEventListener(
//       "scroll",
//       () => {
//         if (sugs.length) calcPos();
//       },
//       true,
//     );
//     return () => {
//       document.removeEventListener("mousedown", handler);
//       window.removeEventListener("scroll", calcPos, true);
//     };
//   }, [sugs.length]);

//   return (
//     <div ref={wrapRef} style={{ position: "relative" }}>
//       <input
//         ref={inpRef}
//         type="text"
//         value={value}
//         onChange={handleChange}
//         onKeyDown={handleKeyDown}
//         placeholder="Type medicine name..."
//         autoComplete="off"
//         style={{
//           width: "100%",
//           border: "1px solid #ddd",
//           borderRadius: 5,
//           padding: "5px 8px",
//           fontSize: 12,
//           fontFamily: "'DM Sans',sans-serif",
//         }}
//       />
//       {sugs.length > 0 && (
//         <div
//           style={{
//             position: "fixed",
//             top: dropPos.top,
//             left: dropPos.left,
//             width: dropPos.width || 260,
//             background: "#fff",
//             border: "1.5px solid #0d7377",
//             borderRadius: 8,
//             boxShadow: "0 8px 32px rgba(13,115,119,0.25)",
//             zIndex: 999999,
//             maxHeight: 220,
//             overflowY: "auto",
//             fontFamily: "'DM Sans',sans-serif",
//           }}
//         >
//           {sugs.map((m, i) => (
//             <div
//               key={m.name + i}
//               style={{
//                 padding: "7px 12px",
//                 cursor: "pointer",
//                 fontSize: 12,
//                 background: i === activeIdx ? "#e8f7f7" : "#fff",
//                 borderBottom: "1px solid #f0eeeb",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 8,
//               }}
//               onMouseDown={(e) => {
//                 e.preventDefault();
//                 select(m.name);
//               }}
//             >
//               <span style={{ fontSize: 13, opacity: 0.6 }}>💊</span>
//               <span
//                 style={{ flex: 1, fontWeight: 500 }}
//                 dangerouslySetInnerHTML={{
//                   __html: highlightWords(m.name, query),
//                 }}
//               />
//               <span
//                 style={{
//                   fontSize: 10,
//                   color: "#9a9590",
//                   background: "#f0eeeb",
//                   padding: "1px 6px",
//                   borderRadius: 20,
//                 }}
//               >
//                 {m.cat}
//               </span>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// // ── MedAutocomplete — Google-style medicine search ───────────
// function MedAutocomplete({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const taRef = React.useRef(null);
//   const wrapperRef = React.useRef(null);
//   const [suggestions, setSuggestions] = React.useState([]);
//   const [activeIdx, setActiveIdx] = React.useState(-1);
//   const [currentQuery, setCurrentQuery] = React.useState("");
//   const queryStartRef = React.useRef(0);
//   const queryEndRef = React.useRef(0);

//   const hideSuggestions = () => {
//     setSuggestions([]);
//     setActiveIdx(-1);
//     setCurrentQuery("");
//   };

//   // Single onChange handler — no onInput conflict
//   const handleChange = (e) => {
//     const ta = e.target;
//     const val = ta.value;
//     const cursor = ta.selectionStart;
//     onChange(val);

//     // Find start of current line/word being typed
//     let lineStart = cursor - 1;
//     while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
//     lineStart++;

//     const query = val.substring(lineStart, cursor);
//     queryStartRef.current = lineStart;
//     queryEndRef.current = cursor;

//     if (query.trim().length < 2) {
//       hideSuggestions();
//       return;
//     }
//     const matches = googleSearch(query, customMeds);
//     if (!matches.length) {
//       hideSuggestions();
//       return;
//     }
//     setCurrentQuery(query);
//     setSuggestions(matches);
//     setActiveIdx(-1);
//   };

//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       suggestions[activeIdx]
//     ) {
//       e.preventDefault();
//       selectMed(suggestions[activeIdx].name);
//     } else if (e.key === "Escape") {
//       hideSuggestions();
//     }
//   };

//   const selectMed = (name) => {
//     const ta = taRef.current;
//     const val = ta.value;
//     const before = val.substring(0, queryStartRef.current);
//     const after = val.substring(queryEndRef.current);
//     const newVal = before + name + after;
//     onChange(newVal);
//     hideSuggestions();
//     // Save to backend using api.post — correct URL guaranteed
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     // Restore cursor position after React re-render
//     setTimeout(() => {
//       if (taRef.current) {
//         const nc = queryStartRef.current + name.length;
//         taRef.current.setSelectionRange(nc, nc);
//         taRef.current.focus();
//         queryEndRef.current = nc;
//       }
//     }, 0);
//   };

//   // On blur — save full meaningful lines typed by doctor as custom medicines
//   const handleBlur = () => {
//     if (!taRef.current) return;
//     const val = taRef.current.value;
//     // Save lines that look like medicine names (>=3 chars, has a letter, not pure numbers)
//     val.split("\n").forEach((line) => {
//       const trimmed = line.trim();
//       if (
//         trimmed.length >= 3 &&
//         /[a-zA-Z]/.test(trimmed) &&
//         !/^[0-9\s]+$/.test(trimmed)
//       ) {
//         saveCustomMed(trimmed, apiPost).then((saved) => {
//           if (saved && onCustomSaved) onCustomSaved(saved);
//         });
//       }
//     });
//   };

//   // Click-outside handler using wrapperRef (not fixed id)
//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
//         hideSuggestions();
//       }
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   return (
//     <>
//       <style>{`
//         .med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}
//         .med-suggestion-item:last-child{border-bottom:none;}
//         .med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}
//         .med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}
//         .med-sug-name{font-weight:500;flex:1;color:#1a1614;}
//         .med-sug-name b{color:#0d7377;font-weight:700;}
//         .med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}
//       `}</style>
//       <div style={{ position: "relative" }} ref={wrapperRef}>
//         <textarea
//           ref={taRef}
//           value={value}
//           onChange={handleChange}
//           onKeyDown={handleKeyDown}
//           onBlur={handleBlur}
//           autoComplete="off"
//           placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
//         />
//         {suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderTop: "none",
//               borderRadius: "0 0 12px 12px",
//               boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
//               zIndex: 99999,
//               maxHeight: 280,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {suggestions.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 className={
//                   "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
//                 }
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   selectMed(m.name);
//                 }}
//               >
//                 <span className="med-sug-icon">💊</span>
//                 <span
//                   className="med-sug-name"
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, currentQuery),
//                   }}
//                 />
//                 <span className="med-sug-cat">{m.cat}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── Prescription Modal — exact original PDF design ────────────
// function PrescriptionModal({ visit, patient, doctor, onClose, showNotify }) {
//   const [pdfUrl, setPdfUrl] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [pdfBlob, setPdfBlob] = useState(null);
//   const [rxMobile, setRxMobile] = useState("");
//   const [fileName, setFileName] = useState("");
//   const [canNativeShare, setCanNativeShare] = useState(false);

//   useEffect(() => {
//     generatePDF();
//   }, []);

//   // Close on Escape
//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     document.addEventListener("keydown", handler);
//     return () => document.removeEventListener("keydown", handler);
//   }, [onClose]);

//   const fmtDateLocal = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr + "T00:00:00");
//     return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
//   };

//   const fmtTimeLocal = (t) => {
//     if (!t) return "";
//     const parts = t.split(":");
//     const hh = parseInt(parts[0]),
//       mm = parts[1];
//     return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
//   };

//   const generatePDF = () => {
//     if (window.jspdf) {
//       buildPDF();
//       return;
//     }
//     const existing = document.getElementById("jspdf-cdn");
//     if (existing) {
//       existing.addEventListener("load", buildPDF);
//       return;
//     }
//     const script = document.createElement("script");
//     script.id = "jspdf-cdn";
//     script.src =
//       "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
//     script.crossOrigin = "anonymous";
//     script.onload = buildPDF;
//     script.onerror = () => setLoading(false);
//     document.head.appendChild(script);
//   };

//   const buildPDF = () => {
//     const { jsPDF } = window.jspdf;
//     const pdf = new jsPDF({
//       unit: "mm",
//       format: "a4",
//       orientation: "portrait",
//     });
//     const W = 210,
//       H = 297;

//     const sf = (c) => pdf.setFillColor(c[0], c[1], c[2]);
//     const sd = (c) => pdf.setDrawColor(c[0], c[1], c[2]);
//     const st = (c) => pdf.setTextColor(c[0], c[1], c[2]);

//     const NAVY = [8, 25, 65],
//       BLUE = [20, 80, 160],
//       BLUE2 = [40, 110, 190];
//     const LBLUE = [210, 228, 248],
//       LBLUE2 = [232, 242, 252],
//       MIDBLUE = [160, 195, 235];
//     const TEAL = [0, 130, 130],
//       TEAL2 = [210, 240, 240];
//     const WHITE = [255, 255, 255],
//       LGRAY = [245, 247, 251],
//       LGRAY2 = [250, 251, 254],
//       LGRAY3 = [240, 243, 248];
//     const GRAY = [115, 118, 130],
//       GRAY2 = [75, 80, 95];
//     const GOLD = [170, 130, 40],
//       GOLD2 = [250, 245, 225];

//     const today = new Date();
//     const todayFmt =
//       today.getDate() +
//       " " +
//       MONTHS[today.getMonth()] +
//       " " +
//       today.getFullYear();
//     const rxNum =
//       "PS-" +
//       today.getFullYear() +
//       ("0" + (today.getMonth() + 1)).slice(-2) +
//       ("0" + today.getDate()).slice(-2) +
//       "-" +
//       Math.floor(1000 + Math.random() * 8999);

//     const visitDate = visit.visitDate || "";
//     const visitTime = visit.visitTime || "";
//     const notes = visit.notes || "";
//     const nextDate = visit.nextVisitDate || "";
//     const service = visit.service || "";
//     const doc = { name: doctor?.name || "Doctor", qual: "", reg: "" };

//     const visitDateFmt = fmtDateLocal(visitDate);
//     const visitTimeFmt = fmtTimeLocal(visitTime);
//     const nextDateFmt = fmtDateLocal(nextDate);

//     // ── Outer border ─────────────────────────────────────────────
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.8);
//     pdf.rect(3.5, 3.5, W - 7, H - 7, "S");
//     sd(LBLUE);
//     pdf.setLineWidth(0.3);
//     pdf.rect(5.5, 5.5, W - 11, H - 11, "S");

//     // ── Header ───────────────────────────────────────────────────
//     sf(NAVY);
//     pdf.rect(3.5, 3.5, W - 7, 46, "F");
//     sf(BLUE);
//     pdf.rect(3.5, 43, W - 7, 10, "F");
//     sf(LBLUE);
//     pdf.rect(3.5, 53, W - 7, 6, "F");

//     st(WHITE);
//     pdf.setFontSize(18);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(doc.name, 14, 19);
//     st(LBLUE);
//     pdf.setFontSize(8);
//     pdf.setFont("helvetica", "normal");
//     pdf.text((doc.qual || "").toUpperCase(), 14, 26);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(14, 28.5, W - 40, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(7);
//     pdf.text("Reg. No.:  " + (doc.reg || "—"), 14, 33.5);
//     pdf.text("Specialisation:  Dental & Oral Health Care", 14, 38.5);

//     st(WHITE);
//     pdf.setFontSize(15);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PEARLSMILE", W - 10, 19, { align: "right" });
//     st(LBLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("DENTAL HOSPITAL", W - 10, 25.5, { align: "right" });
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(W - 72, 28.5, W - 10, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(6.8);
//     pdf.text("12, Dental Plaza, MG Road, Pune - 411001", W - 10, 33.5, {
//       align: "right",
//     });
//     pdf.text("+91 87936 08083  |  care@pearlsmiledental.in", W - 10, 38.5, {
//       align: "right",
//     });

//     st(WHITE);
//     pdf.setFontSize(9);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("DIGITAL PRESCRIPTION", W / 2, 50, { align: "center" });
//     st(LBLUE2);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 10, 50);
//     pdf.text("Date: " + todayFmt, W - 10, 50, { align: "right" });

//     st(BLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PATIENT INFORMATION", W / 2, 57, { align: "center" });

//     // ── Patient info table ────────────────────────────────────────
//     const infoTop = 61;
//     sf(LGRAY3);
//     pdf.rect(10, infoTop, W - 20, 44, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, infoTop, W - 20, 44, "S");
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.2);
//     pdf.line(W / 2, infoTop, W / 2, infoTop + 44);
//     let rdy = infoTop + 11;
//     for (let ri = 0; ri < 3; ri++) {
//       pdf.line(10, rdy, W - 10, rdy);
//       rdy += 11;
//     }

//     const drawCell = (label, value, x, y, maxW) => {
//       st(GRAY2);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.8);
//       pdf.text(label, x + 3, y + 4);
//       st(NAVY);
//       pdf.setFont("helvetica", "normal");
//       pdf.setFontSize(8.5);
//       const val = pdf.splitTextToSize(String(value || "—"), maxW || 75);
//       pdf.text(val[0], x + 3, y + 9.5);
//     };
//     const cHalf = W / 2;
//     drawCell("PATIENT NAME", patient.name || "—", 10, infoTop, cHalf - 16);
//     drawCell("MOBILE", patient.mobile || "—", cHalf, infoTop, cHalf - 16);
//     drawCell("EMAIL", patient.email || "—", 10, infoTop + 11, cHalf - 16);
//     drawCell(
//       "BLOOD GROUP",
//       patient.blood || "—",
//       cHalf,
//       infoTop + 11,
//       cHalf - 16,
//     );
//     drawCell(
//       "AGE / GENDER",
//       (patient.age || "—") + (patient.gender ? "  |  " + patient.gender : ""),
//       10,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell(
//       "VISIT DATE",
//       visitDateFmt + (visitTimeFmt ? " (" + visitTimeFmt + ")" : ""),
//       cHalf,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell("SERVICE/TREATMENT", service || "—", 10, infoTop + 33, cHalf - 16);
//     drawCell(
//       "NEXT VISIT DATE",
//       nextDateFmt || "—",
//       cHalf,
//       infoTop + 33,
//       cHalf - 16,
//     );

//     // ── Prescription Table in PDF (FIRST) ──────────────────────
//     const diagTop = infoTop + 50;
//     const rxRows =
//       visit.prescription && visit.prescription.medicineRows
//         ? visit.prescription.medicineRows.filter(
//             (r) => r.medicine && r.medicine.trim(),
//           )
//         : [];
//     let rxTableEndY = diagTop;
//     if (rxRows.length > 0) {
//       const tTop = diagTop;
//       sf(BLUE);
//       pdf.rect(10, tTop, W - 20, 7, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(7.5);
//       pdf.text("PRESCRIPTION", W / 2, tTop + 5, { align: "center" });
//       const colX = [10, 20, 90, 155, 183];
//       let ry = tTop + 7;
//       sf(LGRAY3);
//       pdf.rect(10, ry, W - 20, 6, "F");
//       [
//         ["SR.", "normal", 6],
//         ["MEDICINE", "bold", 6],
//         ["DOSAGE INSTRUCTION", "normal", 6],
//         ["DURATION", "normal", 6],
//         ["ROUTE", "normal", 6],
//       ].forEach(([h, fw, fs], hi) => {
//         st(GRAY2);
//         pdf.setFont("helvetica", fw);
//         pdf.setFontSize(fs);
//         pdf.text(h, colX[hi] + 1, ry + 4.5);
//       });
//       ry += 6;
//       rxRows.forEach((row, ri) => {
//         sf(ri % 2 === 0 ? LGRAY2 : WHITE);
//         pdf.rect(10, ry, W - 20, 7, "F");
//         sd(LBLUE);
//         pdf.setLineWidth(0.1);
//         pdf.rect(10, ry, W - 20, 7, "S");
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6);
//         pdf.text(String(ri + 1) + ".", colX[0] + 1, ry + 4.5);
//         st(NAVY);
//         pdf.setFont("helvetica", "bold");
//         pdf.setFontSize(7);
//         pdf.text(
//           pdf.splitTextToSize(row.medicine || "", 68)[0] || "",
//           colX[1] + 1,
//           ry + 4.5,
//         );
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6.5);
//         pdf.text(
//           pdf.splitTextToSize(row.dosage || "", 63)[0] || "",
//           colX[2] + 1,
//           ry + 4.5,
//         );
//         pdf.text(row.duration || "", colX[3] + 1, ry + 4.5);
//         pdf.text(row.route || "", colX[4] + 1, ry + 4.5);
//         ry += 7;
//       });
//       rxTableEndY = ry + 4;
//     }

//     // ── Clinical Notes (AFTER Prescription) ──────────────────────
//     const notesTop = rxTableEndY + 4;
//     sf(BLUE);
//     pdf.rect(10, notesTop, W - 20, 8, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(8.5);
//     pdf.text("Rx   CLINICAL NOTES / DIAGNOSIS", 14, notesTop + 5.5);
//     st(GOLD);
//     pdf.setFontSize(10);
//     pdf.text("Rx", W - 16, notesTop + 5.5, { align: "right" });

//     const notesBoxH = 46;
//     sf(LGRAY2);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "S");
//     sd([215, 225, 240]);
//     pdf.setLineWidth(0.15);
//     for (let rl = 0; rl < 6; rl++)
//       pdf.line(14, notesTop + 16 + rl * 7, W - 14, notesTop + 16 + rl * 7);
//     st(NAVY);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(9.5);
//     const noteLines = pdf.splitTextToSize(
//       notes || "No diagnosis or notes recorded for this visit.",
//       W - 30,
//     );
//     pdf.text(noteLines, 14, notesTop + 15);

//     let tableEndY = notesTop + notesBoxH + 8;

//     // ── Next appointment box ──────────────────────────────────────
//     let afterY = tableEndY;
//     if (nextDateFmt) {
//       sf(TEAL2);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "F");
//       sd(TEAL);
//       pdf.setLineWidth(0.4);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "S");
//       sf(TEAL);
//       pdf.roundedRect(10, afterY, 10, 13, 2, 2, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.5);
//       pdf.text("NEXT", 11.2, afterY + 5.5);
//       pdf.text("VISIT", 11.0, afterY + 10);
//       st(TEAL);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(9);
//       pdf.text("Next Appointment:", 24, afterY + 6.5);
//       st(NAVY);
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "bold");
//       pdf.text(nextDateFmt, 72, afterY + 6.5);
//       st(GRAY);
//       pdf.setFontSize(7);
//       pdf.setFont("helvetica", "italic");
//       pdf.text(
//         "Please arrive 10 minutes early and bring this prescription.",
//         24,
//         afterY + 11,
//       );
//       afterY += 19;
//     }

//     // ── General advice box ────────────────────────────────────────
//     const advY = afterY + 4;
//     sf(GOLD2);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "F");
//     sd(GOLD);
//     pdf.setLineWidth(0.35);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "S");
//     sf(GOLD);
//     pdf.roundedRect(10, advY, 10, 20, 2, 2, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(6.2);
//     pdf.text("GEN.", 11.2, advY + 8);
//     pdf.text("ADV.", 11.2, advY + 13.5);
//     st(GOLD);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("General Advice:", 24, advY + 6.5);
//     st(GRAY2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(
//       "1.  Follow all prescribed medicines on time and complete the full course.",
//       24,
//       advY + 11.5,
//     );
//     pdf.text(
//       "2.  Maintain good oral hygiene. Brush gently twice daily.",
//       24,
//       advY + 15.5,
//     );
//     pdf.text(
//       "3.  Avoid very hot, cold, or hard foods until fully healed.",
//       24,
//       advY + 19.2,
//     );

//     // ── Watermark ─────────────────────────────────────────────────
//     pdf.saveGraphicsState();
//     pdf.setGState(new pdf.GState({ opacity: 0.035 }));
//     st(NAVY);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(44);
//     pdf.text("PEARLSMILE", W / 2, H / 2 - 5, { align: "center", angle: 35 });
//     pdf.restoreGraphicsState();

//     // ── Doctor seal ───────────────────────────────────────────────
//     const sigY = Math.max(advY + 28, H - 55);
//     const INK = [28, 52, 140],
//       INK2 = [45, 75, 170];
//     const cx = W - 46,
//       cy = sigY + 13,
//       R = 18;

//     sd(INK);
//     pdf.setLineWidth(1.2);
//     pdf.circle(cx, cy, R, "S");
//     pdf.setLineWidth(0.4);
//     pdf.circle(cx, cy, R - 2.5, "S");

//     const drawStar = (sx, sy, sr) => {
//       const pts = [];
//       for (let si = 0; si < 5; si++) {
//         const ao = (si * 4 * Math.PI) / 5 - Math.PI / 2,
//           ai = ao + (2 * Math.PI) / 5;
//         pts.push({ x: sx + sr * Math.cos(ao), y: sy + sr * Math.sin(ao) });
//         pts.push({
//           x: sx + sr * 0.4 * Math.cos(ai),
//           y: sy + sr * 0.4 * Math.sin(ai),
//         });
//       }
//       pdf.setLineWidth(0.3);
//       sd(INK);
//       sf(INK);
//       pdf.lines(
//         pts.slice(1).map((pt, i) => [pt.x - pts[i].x, pt.y - pts[i].y]),
//         pts[0].x,
//         pts[0].y,
//         [1, 1],
//         "FD",
//         true,
//       );
//     };
//     drawStar(cx - R + 3.5, cy + 1, 2.2);
//     drawStar(cx + R - 3.5, cy + 1, 2.2);

//     const docShort = (doc.name || "Doctor").toUpperCase();
//     sd(INK);
//     st(INK);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(5.8);
//     const topSpan = Math.min(docShort.length * 0.19, 1.3);
//     const topStart = -Math.PI / 2 - topSpan / 2;
//     for (let ti = 0; ti < docShort.length; ti++) {
//       const ta = topStart + (ti / Math.max(docShort.length - 1, 1)) * topSpan;
//       const tx = cx + (R - 1.5) * Math.cos(ta),
//         ty = cy + (R - 1.5) * Math.sin(ta);
//       const trot = ((ta + Math.PI / 2) * 180) / Math.PI;
//       pdf.text(docShort[ti], tx, ty, { align: "center", angle: -trot });
//     }

//     pdf.setFontSize(5.5);
//     const botStr = "PEARLSMILE DENTAL";
//     const botSpan = Math.min(botStr.length * 0.175, 1.4);
//     const botStart = Math.PI / 2 - botSpan / 2;
//     for (let bi = 0; bi < botStr.length; bi++) {
//       const ba = botStart + (bi / Math.max(botStr.length - 1, 1)) * botSpan;
//       const bx = cx + (R - 1.5) * Math.cos(ba),
//         by = cy + (R - 1.5) * Math.sin(ba);
//       const brot = ((ba - Math.PI / 2) * 180) / Math.PI;
//       pdf.text(botStr[bi], bx, by, { align: "center", angle: -brot });
//     }

//     sd(INK);
//     pdf.setLineWidth(0.8);
//     pdf.line(cx, cy - 8, cx, cy + 7);
//     pdf.setLineWidth(0.5);
//     pdf.line(cx, cy - 7.5, cx - 4, cy - 9.5);
//     pdf.line(cx - 4, cy - 9.5, cx - 6, cy - 8);
//     pdf.line(cx - 6, cy - 8, cx - 3, cy - 6.5);
//     pdf.line(cx, cy - 7.5, cx + 4, cy - 9.5);
//     pdf.line(cx + 4, cy - 9.5, cx + 6, cy - 8);
//     pdf.line(cx + 6, cy - 8, cx + 3, cy - 6.5);
//     sf(INK);
//     pdf.circle(cx, cy - 8.2, 1, "F");

//     pdf.setLineWidth(0.6);
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//         [0, -2],
//       ],
//       cx - 3,
//       cy + 5,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [-2, -2],
//         [-2, -2],
//         [0, -2],
//       ],
//       cx + 3,
//       cy + 1,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//       ],
//       cx - 3,
//       cy - 3,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [-2, -2],
//         [-2, -2],
//         [0, -2],
//       ],
//       cx + 3,
//       cy + 5,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//         [0, -2],
//       ],
//       cx - 3,
//       cy + 1,
//       [1, 1],
//       "S",
//     );

//     st(INK);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(4.5);
//     pdf.text("Reg. " + (doc.reg || "—"), cx, cy + R - 5.5, { align: "center" });
//     st(INK2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(6.5);
//     pdf.text("Authorised Signatory", cx, cy + R + 4, { align: "center" });

//     st(GRAY);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 14, sigY + 30);
//     pdf.text("Date: " + todayFmt, W - 14, sigY + 30, { align: "right" });

//     // ── Footer ────────────────────────────────────────────────────
//     sf(NAVY);
//     pdf.rect(3.5, H - 21, W - 7, 17.5, "F");
//     sf(BLUE);
//     pdf.rect(3.5, H - 7, W - 7, 3.5, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(7.5);
//     pdf.text("PearlSmile Dental Hospital", 10, H - 14.5);
//     st(LBLUE);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text("+91 87936 08083", 10, H - 9.5);
//     pdf.text("care@pearlsmiledental.in", W / 2, H - 9.5, { align: "center" });
//     pdf.text("12, Dental Plaza, MG Road, Pune - 411001", W - 10, H - 9.5, {
//       align: "right",
//     });
//     st(LBLUE2);
//     pdf.setFontSize(6);
//     pdf.setFont("helvetica", "italic");
//     pdf.text(
//       "This is a computer-generated prescription from PearlSmile Dental Hospital. Valid only with authorised doctor details.",
//       W / 2,
//       H - 5.5,
//       { align: "center" },
//     );

//     // ── Output ────────────────────────────────────────────────────
//     const blob = pdf.output("blob");
//     const url = URL.createObjectURL(blob);
//     const name =
//       "Prescription_" +
//       (patient.name || "Patient").replace(/\s+/g, "_") +
//       "_" +
//       visitDate +
//       ".pdf";

//     let rawMob = (patient.mobile || "").replace(/[\s\-\(\)\+]/g, "");
//     if (!rawMob.startsWith("91") && rawMob.length === 10)
//       rawMob = "91" + rawMob;

//     setPdfBlob(blob);
//     setPdfUrl(url);
//     setRxMobile(rawMob);
//     setFileName(name);
//     // Show native share button only if Web Share API supports files — exactly like original HTML
//     const testFile = new File([blob], name, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [testFile] })
//     ) {
//       setCanNativeShare(true);
//     }
//     setLoading(false);
//   };

//   const downloadPDF = () => {
//     const link = document.createElement("a");
//     link.href = pdfUrl;
//     link.download = fileName;
//     link.click();
//   };

//   const openFullPreview = () => {
//     if (pdfUrl) window.open(pdfUrl, "_blank");
//   };

//   const shareViaWhatsApp = () => {
//     if (rxMobile) window.open("https://wa.me/" + rxMobile, "_blank");
//     showNotify(
//       "WhatsApp Opened!",
//       "Attach the PDF from the preview and send to patient.",
//     );
//   };

//   const nativeShare = async () => {
//     if (!pdfBlob) return;
//     const file = new File([pdfBlob], fileName, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [file] })
//     ) {
//       navigator
//         .share({
//           title: "Digital Prescription — PearlSmile Dental Hospital",
//           text: "",
//           files: [file],
//         })
//         .then(() => {
//           showNotify("Shared!", "Prescription shared successfully.");
//           // After sharing, open WhatsApp to patient's number directly
//           if (rxMobile) {
//             setTimeout(
//               () => window.open("https://wa.me/" + rxMobile, "_blank"),
//               800,
//             );
//           }
//           onClose();
//         })
//         .catch((err) => {
//           if (err.name !== "AbortError")
//             showNotify("Share Failed", err.message, true);
//         });
//     } else {
//       showNotify(
//         "Not Supported",
//         "Native share not supported on this device/browser.",
//         true,
//       );
//     }
//   };

//   return (
//     <div
//       className="rx-share-overlay open"
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           width: "100%",
//           maxWidth: 540,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//           maxHeight: "92vh",
//         }}
//       >
//         {/* Header */}
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "18px 22px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <span style={{ fontSize: 22 }}>📄</span>
//             <div>
//               <div
//                 style={{
//                   color: "#fff",
//                   fontWeight: 600,
//                   fontSize: 15,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Digital Prescription Ready
//               </div>
//               <div
//                 style={{
//                   color: "rgba(255,255,255,0.55)",
//                   fontSize: 12,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 {patient.name} · {visit.visitDate}
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 17,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             ✕
//           </button>
//         </div>

//         {/* PDF Preview */}
//         <div
//           style={{
//             flex: 1,
//             overflow: "hidden",
//             background: "#f0eeeb",
//             minHeight: 340,
//             position: "relative",
//           }}
//         >
//           {loading && (
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: "#f0eeeb",
//                 gap: 10,
//               }}
//             >
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   border: "3px solid #0d7377",
//                   borderTopColor: "transparent",
//                   borderRadius: "50%",
//                   animation: "spin 0.8s linear infinite",
//                 }}
//               />
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "#5a5550",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Generating PDF…
//               </div>
//             </div>
//           )}
//           {pdfUrl && (
//             <iframe
//               title="prescription"
//               src={pdfUrl}
//               style={{ width: "100%", height: 420, border: "none" }}
//             />
//           )}
//         </div>

//         {/* Action buttons — exactly like original HTML */}
//         <div
//           style={{
//             padding: "16px 20px",
//             display: "flex",
//             flexDirection: "column",
//             gap: 10,
//             background: "#fff",
//           }}
//         >
//           <div style={{ display: "flex", gap: 8 }}>
//             <button
//               onClick={openFullPreview}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//             >
//               🔍 Open Full PDF
//             </button>
//             {canNativeShare && (
//               <button
//                 onClick={nativeShare}
//                 onMouseOver={(e) =>
//                   (e.currentTarget.style.background = "#e5e0d8")
//                 }
//                 onMouseOut={(e) =>
//                   (e.currentTarget.style.background = "#f0eeeb")
//                 }
//                 style={{
//                   flex: 1,
//                   background: "#f0eeeb",
//                   color: "#0a1628",
//                   border: "1.5px solid #ddd9d3",
//                   borderRadius: 10,
//                   padding: 10,
//                   fontSize: 13,
//                   fontWeight: 500,
//                   cursor: "pointer",
//                   fontFamily: "DM Sans,sans-serif",
//                   transition: "background 0.2s",
//                 }}
//               >
//                 📤 Share (Device)
//               </button>
//             )}
//           </div>
//           <p
//             style={{
//               fontSize: 11,
//               color: "#9a9590",
//               textAlign: "center",
//               margin: 0,
//               fontFamily: "DM Sans,sans-serif",
//               lineHeight: 1.5,
//             }}
//           >
//             On mobile: tap "Share (Device)" to send directly via WhatsApp.
//             <br />
//             On desktop: use "Open Full PDF" to view, then share manually.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

// // /////correct code end here with table medicine //////////////////////////////
// // ============================================================
// // src/components/admin/PatientsTab.js
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import api from "../../utils/api";

// const SERVICES_LIST = [
//   "General Checkup & Cleaning",
//   "Cosmetic Dentistry / Smile Makeover",
//   "Dental Implants",
//   "Orthodontics / Invisalign",
//   "Root Canal Therapy",
//   "Pediatric Dentistry",
//   "Oral Surgery",
//   "Periodontal Treatment",
//   "Teeth Whitening",
//   "Emergency Dental Care",
//   "Follow-Up Visit",
//   "Other",
// ];

// const MONTHS = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];
// const MONTHS_SHORT = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// function fmtDate(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtDateShort(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS_SHORT[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtTime(t) {
//   if (!t) return "";
//   const parts = t.split(":");
//   const hh = parseInt(parts[0]),
//     mm = parts[1];
//   return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
// }

// function totalRevenue(visits = []) {
//   return visits.reduce((sum, v) => {
//     const n = parseFloat((v.amount || "0").toString().replace(/[^0-9.]/g, ""));
//     return sum + (isNaN(n) ? 0 : n);
//   }, 0);
// }

// export default function PatientsTab({ showNotify, doctor }) {
//   const [patients, setPatients] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showNewForm, setShowNewForm] = useState(false);
//   const [newPat, setNewPat] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     age: "",
//     gender: "",
//     blood: "",
//   });
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [rxModal, setRxModal] = useState(null);
//   // Custom medicines — fetched from backend, shared across all doctors/devices
//   const [customMeds, setCustomMeds] = useState([]);

//   const today = new Date().toISOString().split("T")[0];
//   const nowTime = new Date().toTimeString().slice(0, 5);
//   const [visitForm, setVisitForm] = useState({
//     date: today,
//     time: nowTime,
//     service: "",
//     amount: "",
//     nextVisitDate: "",
//     notes: "",
//     rxRows: [
//       {
//         medicine: "",
//         dosageParts: ["0", "0", "0"],
//         dosageTiming: "after meal",
//         dosage: "",
//         duration: "",
//         route: "ORAL",
//       },
//     ],
//   });

//   const loadPatients = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await api.get("/patients");
//       setPatients(data);
//       setFiltered(data);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     loadPatients();
//   }, [loadPatients]);

//   // Fetch custom medicines from backend on mount — shared across all doctors/devices
//   useEffect(() => {
//     api
//       .get("/custommeds")
//       .then((data) => {
//         if (Array.isArray(data)) setCustomMeds(data);
//       })
//       .catch(() => {});
//   }, []);

//   const filterPatients = (q) => {
//     const term = q.toLowerCase();
//     setFiltered(
//       patients.filter(
//         (p) =>
//           (p.name || "").toLowerCase().includes(term) ||
//           (p.mobile || "").includes(term) ||
//           (p.email || "").toLowerCase().includes(term),
//       ),
//     );
//   };

//   const createPatient = async () => {
//     if (!newPat.name.trim()) {
//       showNotify("Error", "Patient name is required.", true);
//       return;
//     }
//     if (!newPat.mobile.trim()) {
//       showNotify("Error", "Mobile number is required.", true);
//       return;
//     }
//     try {
//       await api.post("/patients", newPat);
//       setNewPat({
//         name: "",
//         mobile: "",
//         email: "",
//         age: "",
//         gender: "",
//         blood: "",
//       });
//       setShowNewForm(false);
//       showNotify(
//         "Patient Profile Created! ✓",
//         "New profile for " + newPat.name + " saved.",
//       );
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const openPatient = async (p) => {
//     try {
//       const full = await api.get("/patients/" + p._id);
//       setSelectedPatient(full);
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deletePatient = async () => {
//     if (
//       !window.confirm(
//         "Delete this patient profile and all their records? This cannot be undone.",
//       )
//     )
//       return;
//     try {
//       await api.delete("/patients/" + selectedPatient._id);
//       showNotify("Profile Deleted", "Patient profile removed.");
//       setSelectedPatient(null);
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const saveVisit = async () => {
//     if (!visitForm.date) {
//       showNotify("Missing Fields", "Please select a visit date.", true);
//       return;
//     }
//     if (!visitForm.service) {
//       showNotify("Missing Fields", "Please select a service.", true);
//       return;
//     }
//     try {
//       const payload = {
//         visitDate: visitForm.date,
//         visitTime: visitForm.time,
//         service: visitForm.service,
//         amount: visitForm.amount,
//         nextVisitDate: visitForm.nextVisitDate,
//         notes: visitForm.notes,
//         doctor: doctor?.name || "",
//         prescription: {
//           medicineRows: visitForm.rxRows.filter((r) => r.medicine.trim()),
//         },
//       };
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/visits",
//         payload,
//       );
//       setSelectedPatient(updated);

//       // ── Auto-create appointment for follow-up date ──────────
//       // If nextVisitDate is set → create an upcoming appointment entry
//       // so it appears in Appointments tab → Upcoming Appointments
//       if (visitForm.nextVisitDate && selectedPatient.mobile) {
//         try {
//           await api.post("/appointments", {
//             name: selectedPatient.name,
//             phone: selectedPatient.mobile,
//             service: visitForm.service,
//             date: visitForm.nextVisitDate,
//             time: "",
//             message: "Follow-up visit from Patient Profile",
//             status: "pending",
//           });
//         } catch (_) {
//           // Silently ignore if appointment creation fails
//         }
//       }

//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });

//       // Follow-up WhatsApp if notes contain "follow-up" and nextVisitDate is set
//       const isFollowUp = /follow[\s\-]?up/i.test(visitForm.notes);
//       if (isFollowUp && visitForm.nextVisitDate && selectedPatient.mobile) {
//         let rawMobile = (selectedPatient.mobile || "").replace(
//           /[\s\-\(\)\+]/g,
//           "",
//         );
//         if (!rawMobile.startsWith("91") && rawMobile.length === 10)
//           rawMobile = "91" + rawMobile;
//         const waMsg = `*PearlSmile Dental Hospital* — Follow-Up Reminder\n\nDear ${selectedPatient.name},\nThis is a reminder for your follow-up appointment.\n\n*Service:* ${visitForm.service}\n*Next Visit:* ${fmtDate(visitForm.nextVisitDate)}\n\nPlease call us to confirm your appointment.\n📞 +91 87936 08083`;
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" +
//                 rawMobile +
//                 "?text=" +
//                 encodeURIComponent(waMsg),
//               "_blank",
//             ),
//           500,
//         );
//         showNotify(
//           "Visit Saved + Follow-Up Appointment Created!",
//           "Reminder sent to " +
//             selectedPatient.name +
//             " for " +
//             fmtDate(visitForm.nextVisitDate) +
//             ". Appointment added to Upcoming.",
//         );
//       } else if (visitForm.nextVisitDate) {
//         showNotify(
//           "Visit Saved + Appointment Created! ✓",
//           "Follow-up appointment for " +
//             fmtDate(visitForm.nextVisitDate) +
//             " added to Upcoming Appointments.",
//         );
//       } else {
//         showNotify(
//           "Visit Record Saved! ✓",
//           "Patient visit has been recorded successfully.",
//         );
//       }
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deleteVisit = async (visitId) => {
//     if (!window.confirm("Delete this visit record?")) return;
//     try {
//       const result = await api.delete(
//         "/patients/" + selectedPatient._id + "/visits/" + visitId,
//       );
//       setSelectedPatient(result.patient);
//       showNotify("Visit Deleted", "Visit record removed.");
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const sendPrescription = (visit) => {
//     // Use the doctor who treated the patient (stored in visit.doctor)
//     // not the currently logged-in doctor
//     const treatingDoctor = visit.doctor ? { name: visit.doctor } : doctor;
//     setRxModal({ visit, patient: selectedPatient, doctor: treatingDoctor });
//   };

//   // ── LIST VIEW ─────────────────────────────────────────────────
//   if (!selectedPatient) {
//     return (
//       <div>
//         <div className="admin-section-title">Patient Profiles</div>
//         <div className="admin-section-desc">
//           Create and manage individual patient profiles. Click a profile to view
//           visit history and add new records.
//         </div>

//         <div className="patients-list-view">
//           <input
//             type="text"
//             className="patient-search-bar"
//             placeholder="🔍 Search patients by name or phone..."
//             onChange={(e) => filterPatients(e.target.value)}
//           />

//           {showNewForm && (
//             <div className="new-patient-form">
//               <h4>➕ Create New Patient Profile</h4>
//               <div className="new-patient-grid">
//                 {[
//                   ["name", "text", "Full Name *", "Patient full name"],
//                   ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
//                   ["email", "email", "Email Address", "patient@email.com"],
//                   ["age", "number", "Age", "Age"],
//                 ].map(([k, t, label, ph]) => (
//                   <div key={k}>
//                     <div className="admin-row-label">{label}</div>
//                     <input
//                       type={t}
//                       placeholder={ph}
//                       value={newPat[k]}
//                       onChange={(e) =>
//                         setNewPat((p) => ({ ...p, [k]: e.target.value }))
//                       }
//                     />
//                   </div>
//                 ))}
//                 <div>
//                   <div className="admin-row-label">Gender</div>
//                   <select
//                     value={newPat.gender}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, gender: e.target.value }))
//                     }
//                   >
//                     <option value="">Select Gender</option>
//                     <option>Male</option>
//                     <option>Female</option>
//                     <option>Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <div className="admin-row-label">Blood Group</div>
//                   <input
//                     type="text"
//                     placeholder="e.g. B+"
//                     value={newPat.blood}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, blood: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//               <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                 <button className="add-visit-save-btn" onClick={createPatient}>
//                   💾 Save Patient Profile
//                 </button>
//                 <button
//                   className="btn-back-patients"
//                   onClick={() => setShowNewForm(false)}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           )}

//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: 14,
//               flexWrap: "wrap",
//               gap: 10,
//             }}
//           >
//             <div style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {loading
//                 ? "Loading patients..."
//                 : `${filtered.length} patient profile${filtered.length !== 1 ? "s" : ""}`}
//             </div>
//             <button
//               className="admin-add-btn"
//               onClick={() => setShowNewForm((s) => !s)}
//             >
//               {showNewForm ? "Cancel" : "+ New Patient Profile"}
//             </button>
//           </div>

//           <div className="patient-profiles-grid">
//             {loading ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "20px 0",
//                   gridColumn: "1/-1",
//                 }}
//               >
//                 Loading...
//               </div>
//             ) : filtered.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "24px 0",
//                   gridColumn: "1/-1",
//                   textAlign: "center",
//                 }}
//               >
//                 No patients yet. Click "+ New Patient Profile" to add your first
//                 patient.
//               </div>
//             ) : (
//               filtered.map((p) => (
//                 <div
//                   key={p._id}
//                   className="patient-profile-card"
//                   onClick={() => openPatient(p)}
//                 >
//                   <div className="patient-avatar-icon">🧑‍⚕️</div>
//                   <div className="patient-card-name">{p.name}</div>
//                   <div className="patient-card-id">📞 {p.mobile || "—"}</div>
//                   <div className="patient-card-visits">
//                     📋 {p.visitCount || 0} visit{p.visitCount !== 1 ? "s" : ""}
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ── DETAIL VIEW ───────────────────────────────────────────────
//   const p = selectedPatient;
//   const visits = p.visits || [];
//   const total = totalRevenue(visits);

//   return (
//     <div>
//       <div className="patient-detail-view open">
//         <div className="patient-detail-header">
//           <button
//             className="btn-back-patients"
//             onClick={() => {
//               setSelectedPatient(null);
//             }}
//           >
//             ← Back to Patients
//           </button>
//           <div
//             className="patient-avatar-icon"
//             style={{ width: 56, height: 56, fontSize: 26 }}
//           >
//             🧑‍⚕️
//           </div>
//           <div style={{ flex: 1 }}>
//             <h3>{p.name}</h3>
//             <p style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {p.email}
//               {p.email && p.mobile ? " · " : ""}
//               {p.mobile}
//             </p>
//             <div className="patient-info-row">
//               {[
//                 p.age ? "Age: " + p.age : null,
//                 p.gender || null,
//                 p.blood ? "Blood: " + p.blood : null,
//               ]
//                 .filter(Boolean)
//                 .map((t, i) => (
//                   <span key={i} className="patient-info-pill">
//                     {t}
//                   </span>
//                 ))}
//             </div>
//           </div>
//           <div style={{ textAlign: "right", flexShrink: 0 }}>
//             <div
//               style={{
//                 fontSize: 11,
//                 color: "var(--gray-400)",
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//                 marginBottom: 4,
//               }}
//             >
//               Total Revenue
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 26,
//                 fontWeight: 600,
//                 color: "var(--teal)",
//                 lineHeight: 1,
//               }}
//             >
//               Rs. {total.toLocaleString("en-IN")}
//             </div>
//             <div
//               style={{ fontSize: 11, color: "var(--gray-400)", marginTop: 2 }}
//             >
//               {visits.length} visit{visits.length !== 1 ? "s" : ""}
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 8,
//               alignSelf: "flex-start",
//               marginTop: 4,
//             }}
//           >
//             <button className="admin-del-btn" onClick={deletePatient}>
//               🗑️ Delete Profile
//             </button>
//           </div>
//         </div>

//         {/* Add Visit Form — original simple layout */}
//         <div className="add-visit-form">
//           <h4>📋 Add New Visit Record</h4>
//           <div className="add-visit-grid">
//             <div>
//               <div className="admin-row-label">Visit Date *</div>
//               <input
//                 type="date"
//                 value={visitForm.date}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, date: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Visit Time</div>
//               <input
//                 type="time"
//                 value={visitForm.time}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, time: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Service Taken *</div>
//               <select
//                 value={visitForm.service}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, service: e.target.value }))
//                 }
//               >
//                 <option value="">Select Service</option>
//                 {SERVICES_LIST.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <div className="admin-row-label">Amount Charged (Rs.)</div>
//               <input
//                 type="text"
//                 placeholder="e.g. 2500"
//                 value={visitForm.amount}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, amount: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div
//                 className="admin-row-label"
//                 style={{ display: "flex", alignItems: "center", gap: 6 }}
//               >
//                 Next Date to Visit
//                 <span
//                   style={{
//                     fontSize: 10,
//                     color: "var(--teal)",
//                     fontWeight: 400,
//                     background: "rgba(13,115,119,0.08)",
//                     padding: "2px 8px",
//                     borderRadius: 100,
//                     border: "1px solid rgba(13,115,119,0.2)",
//                   }}
//                 >
//                   For follow-up
//                 </span>
//               </div>
//               <input
//                 type="date"
//                 value={visitForm.nextVisitDate}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, nextVisitDate: e.target.value }))
//                 }
//                 style={{ marginTop: 6 }}
//               />
//             </div>
//           </div>
//           {/* ── Prescription Table ─────────────────────────── */}
//           <style>{`
//             @media (max-width: 640px) {
//               .rx-table-desktop { display: none !important; }
//               .rx-card-mobile { display: block !important; }
//             }
//             @media (min-width: 641px) {
//               .rx-table-desktop { display: block !important; }
//               .rx-card-mobile { display: none !important; }
//             }
//           `}</style>
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 8 }}
//           >
//             💊 Prescription
//           </div>

//           {/* ── DESKTOP TABLE ── */}
//           <div
//             className="rx-table-desktop"
//             style={{
//               overflowX: "auto",
//               marginBottom: 8,
//               position: "relative",
//               zIndex: 1000,
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: 13,
//                 fontFamily: "'DM Sans',sans-serif",
//                 minWidth: 560,
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                     color: "#fff",
//                   }}
//                 >
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 36,
//                     }}
//                   >
//                     SR.
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     MEDICINE
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     DOSAGE INSTRUCTION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     DURATION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     ROUTE
//                   </th>
//                   <th style={{ padding: "8px 10px", width: 32 }}></th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {visitForm.rxRows.map((row, idx) => (
//                   <tr
//                     key={idx}
//                     style={{
//                       background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                       borderBottom: "1px solid #e8e4e0",
//                     }}
//                   >
//                     <td
//                       style={{
//                         padding: "6px 10px",
//                         color: "#666",
//                         fontSize: 12,
//                         textAlign: "center",
//                       }}
//                     >
//                       {idx + 1}
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <RxMedInput
//                         value={row.medicine}
//                         onChange={(v) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], medicine: v };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         customMeds={customMeds}
//                         apiPost={api.post}
//                         onCustomSaved={(saved) => {
//                           if (saved && saved._id) {
//                             setCustomMeds((prev) => {
//                               const exists = prev.some(
//                                 (m) =>
//                                   m._id === saved._id ||
//                                   m.name.toLowerCase() ===
//                                     saved.name.toLowerCase(),
//                               );
//                               if (exists) return prev;
//                               return [saved, ...prev];
//                             });
//                           } else {
//                             api
//                               .get("/custommeds")
//                               .then((data) => {
//                                 if (Array.isArray(data)) setCustomMeds(data);
//                               })
//                               .catch(() => {});
//                           }
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                           flexWrap: "nowrap",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 2,
//                           }}
//                         >
//                           {["M", "A", "N"].map((label, li) => (
//                             <div
//                               key={label}
//                               style={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   fontSize: 9,
//                                   color: "#888",
//                                   marginBottom: 1,
//                                 }}
//                               >
//                                 {label}
//                               </span>
//                               <input
//                                 type="text"
//                                 maxLength={2}
//                                 value={
//                                   (row.dosageParts || ["0", "0", "0"])[li] ||
//                                   "0"
//                                 }
//                                 onFocus={(e) => {
//                                   if (e.target.value === "0") e.target.select();
//                                 }}
//                                 onChange={(e) => {
//                                   const rows = [...visitForm.rxRows];
//                                   const parts = [
//                                     ...(rows[idx].dosageParts || [
//                                       "0",
//                                       "0",
//                                       "0",
//                                     ]),
//                                   ];
//                                   parts[li] =
//                                     e.target.value === ""
//                                       ? "0"
//                                       : e.target.value;
//                                   rows[idx] = {
//                                     ...rows[idx],
//                                     dosageParts: parts,
//                                     dosage:
//                                       parts.join("-") +
//                                       (rows[idx].dosageTiming
//                                         ? " " + rows[idx].dosageTiming
//                                         : ""),
//                                   };
//                                   setVisitForm((f) => ({ ...f, rxRows: rows }));
//                                 }}
//                                 style={{
//                                   width: 28,
//                                   border: "1px solid #ddd",
//                                   borderRadius: 4,
//                                   padding: "4px 3px",
//                                   fontSize: 12,
//                                   textAlign: "center",
//                                   fontFamily: "'DM Sans',sans-serif",
//                                 }}
//                               />
//                             </div>
//                           ))}
//                         </div>
//                         <select
//                           value={row.dosageTiming || "after meal"}
//                           onChange={(e) => {
//                             const rows = [...visitForm.rxRows];
//                             const parts = rows[idx].dosageParts || [
//                               "0",
//                               "0",
//                               "0",
//                             ];
//                             rows[idx] = {
//                               ...rows[idx],
//                               dosageTiming: e.target.value,
//                               dosage: parts.join("-") + " " + e.target.value,
//                             };
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             border: "1px solid #ddd",
//                             borderRadius: 4,
//                             padding: "4px 5px",
//                             fontSize: 11,
//                             fontFamily: "'DM Sans',sans-serif",
//                             color: "#444",
//                           }}
//                         >
//                           <option>after meal</option>
//                           <option>before meal</option>
//                           <option>with meal</option>
//                           <option>empty stomach</option>
//                           <option>at bedtime</option>
//                           <option>as directed</option>
//                         </select>
//                       </div>
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <input
//                         type="text"
//                         placeholder="e.g. 7 days"
//                         value={row.duration}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = {
//                             ...rows[idx],
//                             duration: e.target.value,
//                           };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 8px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <select
//                         value={row.route}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], route: e.target.value };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 6px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       >
//                         <option>ORAL</option>
//                         <option>TOPICAL</option>
//                         <option>INJECTION</option>
//                         <option>INHALER</option>
//                         <option>DROPS</option>
//                         <option>GARGLE</option>
//                         <option>OTHER</option>
//                       </select>
//                     </td>
//                     <td style={{ padding: "4px 6px", textAlign: "center" }}>
//                       {visitForm.rxRows.length > 1 && (
//                         <button
//                           onClick={() => {
//                             const rows = visitForm.rxRows.filter(
//                               (_, i) => i !== idx,
//                             );
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             background: "none",
//                             border: "none",
//                             color: "#e74c3c",
//                             fontSize: 16,
//                             cursor: "pointer",
//                             padding: "2px 6px",
//                           }}
//                           title="Remove"
//                         >
//                           ✕
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* ── MOBILE CARDS ── */}
//           <div className="rx-card-mobile" style={{ marginBottom: 8 }}>
//             {visitForm.rxRows.map((row, idx) => (
//               <div
//                 key={idx}
//                 style={{
//                   background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                   border: "1px solid #e8e4e0",
//                   borderRadius: 8,
//                   padding: "10px 12px",
//                   marginBottom: 8,
//                   position: "relative",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: 8,
//                   }}
//                 >
//                   <span
//                     style={{
//                       fontSize: 11,
//                       fontWeight: 700,
//                       color: "#0a1628",
//                       background: "rgba(10,22,40,0.08)",
//                       padding: "2px 8px",
//                       borderRadius: 20,
//                     }}
//                   >
//                     #{idx + 1}
//                   </span>
//                   {visitForm.rxRows.length > 1 && (
//                     <button
//                       onClick={() => {
//                         const rows = visitForm.rxRows.filter(
//                           (_, i) => i !== idx,
//                         );
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         background: "none",
//                         border: "none",
//                         color: "#e74c3c",
//                         fontSize: 16,
//                         cursor: "pointer",
//                         padding: "2px 6px",
//                       }}
//                       title="Remove"
//                     >
//                       ✕
//                     </button>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Medicine
//                   </div>
//                   <RxMedInput
//                     value={row.medicine}
//                     onChange={(v) => {
//                       const rows = [...visitForm.rxRows];
//                       rows[idx] = { ...rows[idx], medicine: v };
//                       setVisitForm((f) => ({ ...f, rxRows: rows }));
//                     }}
//                     customMeds={customMeds}
//                     apiPost={api.post}
//                     onCustomSaved={(saved) => {
//                       if (saved && saved._id) {
//                         setCustomMeds((prev) => {
//                           const exists = prev.some(
//                             (m) =>
//                               m._id === saved._id ||
//                               m.name.toLowerCase() === saved.name.toLowerCase(),
//                           );
//                           if (exists) return prev;
//                           return [saved, ...prev];
//                         });
//                       } else {
//                         api
//                           .get("/custommeds")
//                           .then((data) => {
//                             if (Array.isArray(data)) setCustomMeds(data);
//                           })
//                           .catch(() => {});
//                       }
//                     }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Dosage Instruction
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 6,
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <div
//                       style={{ display: "flex", alignItems: "center", gap: 4 }}
//                     >
//                       {["M", "A", "N"].map((label, li) => (
//                         <div
//                           key={label}
//                           style={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                           }}
//                         >
//                           <span
//                             style={{
//                               fontSize: 9,
//                               color: "#888",
//                               marginBottom: 1,
//                             }}
//                           >
//                             {label}
//                           </span>
//                           <input
//                             type="text"
//                             maxLength={2}
//                             value={
//                               (row.dosageParts || ["0", "0", "0"])[li] || "0"
//                             }
//                             onFocus={(e) => {
//                               if (e.target.value === "0") e.target.select();
//                             }}
//                             onChange={(e) => {
//                               const rows = [...visitForm.rxRows];
//                               const parts = [
//                                 ...(rows[idx].dosageParts || ["0", "0", "0"]),
//                               ];
//                               parts[li] =
//                                 e.target.value === "" ? "0" : e.target.value;
//                               rows[idx] = {
//                                 ...rows[idx],
//                                 dosageParts: parts,
//                                 dosage:
//                                   parts.join("-") +
//                                   (rows[idx].dosageTiming
//                                     ? " " + rows[idx].dosageTiming
//                                     : ""),
//                               };
//                               setVisitForm((f) => ({ ...f, rxRows: rows }));
//                             }}
//                             style={{
//                               width: 34,
//                               border: "1px solid #ddd",
//                               borderRadius: 4,
//                               padding: "5px 3px",
//                               fontSize: 13,
//                               textAlign: "center",
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                     <select
//                       value={row.dosageTiming || "after meal"}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         const parts = rows[idx].dosageParts || ["0", "0", "0"];
//                         rows[idx] = {
//                           ...rows[idx],
//                           dosageTiming: e.target.value,
//                           dosage: parts.join("-") + " " + e.target.value,
//                         };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         flex: 1,
//                         border: "1px solid #ddd",
//                         borderRadius: 4,
//                         padding: "5px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         color: "#444",
//                         minWidth: 120,
//                       }}
//                     >
//                       <option>after meal</option>
//                       <option>before meal</option>
//                       <option>with meal</option>
//                       <option>empty stomach</option>
//                       <option>at bedtime</option>
//                       <option>as directed</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div style={{ display: "flex", gap: 8 }}>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Duration
//                     </div>
//                     <input
//                       type="text"
//                       placeholder="e.g. 7 days"
//                       value={row.duration}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], duration: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 8px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         boxSizing: "border-box",
//                       }}
//                     />
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Route
//                     </div>
//                     <select
//                       value={row.route}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], route: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                       }}
//                     >
//                       <option>ORAL</option>
//                       <option>TOPICAL</option>
//                       <option>INJECTION</option>
//                       <option>INHALER</option>
//                       <option>DROPS</option>
//                       <option>GARGLE</option>
//                       <option>OTHER</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button
//             onClick={() =>
//               setVisitForm((f) => ({
//                 ...f,
//                 rxRows: [
//                   ...f.rxRows,
//                   {
//                     medicine: "",
//                     dosageParts: ["0", "0", "0"],
//                     dosageTiming: "after meal",
//                     dosage: "",
//                     duration: "",
//                     route: "ORAL",
//                   },
//                 ],
//               }))
//             }
//             style={{
//               marginTop: 4,
//               marginBottom: 8,
//               background: "rgba(13,115,119,0.08)",
//               border: "1px solid rgba(13,115,119,0.3)",
//               color: "var(--teal)",
//               borderRadius: 7,
//               padding: "6px 16px",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             + Add Medicine
//           </button>

//           {/* ── Doctor Notes / Diagnosis ───────────────────────── */}
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 10 }}
//           >
//             Doctor Notes / Diagnosis
//           </div>
//           <MedAutocomplete
//             value={visitForm.notes}
//             onChange={(v) => setVisitForm((f) => ({ ...f, notes: v }))}
//             customMeds={customMeds}
//             apiPost={api.post}
//             onCustomSaved={(saved) => {
//               if (saved && saved._id) {
//                 // Add to local state immediately so suggestion appears right away
//                 setCustomMeds((prev) => {
//                   const exists = prev.some(
//                     (m) =>
//                       m._id === saved._id ||
//                       m.name.toLowerCase() === saved.name.toLowerCase(),
//                   );
//                   if (exists) return prev;
//                   return [saved, ...prev];
//                 });
//               } else {
//                 // Fallback refetch if saved object not returned
//                 api
//                   .get("/custommeds")
//                   .then((data) => {
//                     if (Array.isArray(data)) setCustomMeds(data);
//                   })
//                   .catch(() => {});
//               }
//             }}
//           />
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               flexWrap: "wrap",
//               gap: 10,
//               marginTop: 4,
//             }}
//           >
//             <button className="add-visit-save-btn" onClick={saveVisit}>
//               💾 Save Visit Record
//             </button>
//           </div>
//         </div>

//         {/* Visit History */}
//         <div style={{ marginBottom: 12 }}>
//           <div className="admin-section-title" style={{ marginBottom: 8 }}>
//             Visit History
//           </div>
//           <div className="visit-records-list">
//             {visits.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 13,
//                   padding: "10px 0",
//                 }}
//               >
//                 No visits recorded yet. Add the first visit above.
//               </div>
//             ) : (
//               visits.map((v, i) => {
//                 const dtStr =
//                   (v.visitDate || "") +
//                   (v.visitTime ? " at " + v.visitTime : "");
//                 const isFollowUp = /follow[\s\-]?up/i.test(v.notes || "");
//                 return (
//                   <div key={v._id || i} className="visit-record-card">
//                     <button
//                       className="visit-del-btn"
//                       onClick={() => deleteVisit(v._id)}
//                       title="Delete"
//                     >
//                       ✕
//                     </button>
//                     <div className="visit-record-meta">
//                       <span className="visit-record-service">
//                         {v.service || "Visit"}
//                       </span>
//                       <span className="visit-record-date">📅 {dtStr}</span>
//                       {v.amount && (
//                         <span
//                           className="patient-info-pill"
//                           style={{ fontSize: 11 }}
//                         >
//                           Rs. {v.amount}
//                         </span>
//                       )}
//                       {v.doctor && (
//                         <span
//                           style={{
//                             fontSize: 11,
//                             color: "var(--teal)",
//                             fontWeight: 600,
//                             background: "rgba(13,115,119,0.08)",
//                             padding: "2px 8px",
//                             borderRadius: 100,
//                             border: "1px solid rgba(13,115,119,0.2)",
//                           }}
//                         >
//                           👨‍⚕️ {v.doctor}
//                         </span>
//                       )}
//                     </div>
//                     <div className="visit-record-notes">{v.notes || "—"}</div>
//                     {v.prescription &&
//                       v.prescription.medicineRows &&
//                       v.prescription.medicineRows.length > 0 && (
//                         <div style={{ marginTop: 10, overflowX: "auto" }}>
//                           <table
//                             style={{
//                               width: "100%",
//                               borderCollapse: "collapse",
//                               fontSize: 12,
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           >
//                             <thead>
//                               <tr
//                                 style={{
//                                   background:
//                                     "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                                   color: "#fff",
//                                 }}
//                               >
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 30,
//                                   }}
//                                 >
//                                   SR.
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   MEDICINE
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   DOSAGE INSTRUCTION
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 90,
//                                   }}
//                                 >
//                                   DUR. / ROUTE
//                                 </th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {v.prescription.medicineRows.map((row, ri) => (
//                                 <tr
//                                   key={ri}
//                                   style={{
//                                     background:
//                                       ri % 2 === 0 ? "#f8f9fc" : "#fff",
//                                     borderBottom: "1px solid #e8e4e0",
//                                   }}
//                                 >
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                       textAlign: "center",
//                                     }}
//                                   >
//                                     {ri + 1}.
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       fontWeight: 600,
//                                       color: "#0a1628",
//                                     }}
//                                   >
//                                     {row.medicine || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#444",
//                                     }}
//                                   >
//                                     {row.dosage || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                     }}
//                                   >
//                                     {row.duration}
//                                     {row.duration && row.route ? " / " : ""}
//                                     {row.route}
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       )}
//                     {v.nextVisitDate && (
//                       <div
//                         style={{
//                           marginTop: 8,
//                           display: "inline-flex",
//                           alignItems: "center",
//                           gap: 6,
//                           background: isFollowUp
//                             ? "rgba(201,168,76,0.12)"
//                             : "rgba(13,115,119,0.08)",
//                           border:
//                             "1px solid " +
//                             (isFollowUp
//                               ? "rgba(201,168,76,0.35)"
//                               : "rgba(13,115,119,0.2)"),
//                           borderRadius: 100,
//                           padding: "3px 12px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           color: isFollowUp ? "#8b6914" : "var(--teal)",
//                         }}
//                       >
//                         {isFollowUp ? "Follow-Up: " : "Next Visit: "}
//                         {fmtDateShort(v.nextVisitDate)}
//                         {isFollowUp ? " — WhatsApp sent" : ""}
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 8,
//                         marginTop: 10,
//                       }}
//                     >
//                       <button
//                         onClick={() => sendPrescription(v)}
//                         style={{
//                           background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Send Prescription
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </div>

//       {rxModal && (
//         <PrescriptionModal
//           visit={rxModal.visit}
//           patient={rxModal.patient}
//           doctor={rxModal.doctor}
//           onClose={() => setRxModal(null)}
//           showNotify={showNotify}
//         />
//       )}
//     </div>
//   );
// }

// // ── Medicine Database — 1500+ entries (India: dental + clinical + surgical) ──
// const MEDICINE_DB = [
//   // ── ANTIBIOTICS ──────────────────────────────────────────────
//   { name: "Amoxicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 875mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin 125mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin 250mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 375mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 625mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 1000mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 228.5mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Azithromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Clindamycin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 600mg Injection", cat: "Antibiotic Inj" },
//   { name: "Metronidazole 200mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 400mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Infusion", cat: "Antibiotic Inj" },
//   { name: "Ciprofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 750mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 200mg/100ml Infusion", cat: "Antibiotic Inj" },
//   { name: "Doxycycline 100mg Capsule", cat: "Antibiotic" },
//   { name: "Doxycycline 200mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Tinidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ornidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Secnidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Co-Amoxiclav 375mg Tablet", cat: "Antibiotic" },
//   { name: "Co-Amoxiclav 625mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 750mg Tablet", cat: "Antibiotic" },
//   { name: "Ofloxacin 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ofloxacin 400mg Tablet", cat: "Antibiotic" },
//   { name: "Cephalexin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Cephalexin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Cefixime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 400mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 50mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Cefuroxime 250mg Tablet", cat: "Antibiotic" },
//   { name: "Cefuroxime 500mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ceftriaxone 250mg Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 2g Injection", cat: "Antibiotic Inj" },
//   { name: "Amikacin 250mg Injection", cat: "Antibiotic Inj" },
//   { name: "Amikacin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Gentamicin 40mg Injection", cat: "Antibiotic Inj" },
//   { name: "Gentamicin 80mg Injection", cat: "Antibiotic Inj" },
//   { name: "Vancomycin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Vancomycin 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Meropenem 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Meropenem 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Piperacillin + Tazobactam 4.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Imipenem + Cilastatin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Linezolid 600mg Tablet", cat: "Antibiotic" },
//   { name: "Linezolid 600mg Infusion", cat: "Antibiotic Inj" },
//   { name: "Colistin 1 MU Injection", cat: "Antibiotic Inj" },
//   { name: "Tetracycline 250mg Capsule", cat: "Antibiotic" },
//   { name: "Tetracycline 500mg Capsule", cat: "Antibiotic" },
//   { name: "Chloramphenicol 250mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin + Sulbactam 1.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Nitrofurantoin 50mg Capsule", cat: "Antibiotic" },
//   { name: "Nitrofurantoin 100mg Capsule", cat: "Antibiotic" },
//   { name: "Norfloxacin 400mg Tablet", cat: "Antibiotic" },
//   { name: "Trimethoprim + Sulfamethoxazole 480mg Tablet", cat: "Antibiotic" },
//   { name: "Trimethoprim + Sulfamethoxazole 960mg Tablet", cat: "Antibiotic" },
//   { name: "Cefoperazone + Sulbactam 1.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Cefoperazone + Sulbactam 3g Injection", cat: "Antibiotic Inj" },
//   { name: "Ertapenem 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Tigecycline 50mg Injection", cat: "Antibiotic Inj" },
//   { name: "Fosfomycin 3g Sachet", cat: "Antibiotic" },
//   { name: "Rifampicin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Rifampicin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Isoniazid 100mg Tablet", cat: "Antibiotic" },
//   { name: "Isoniazid 300mg Tablet", cat: "Antibiotic" },
//   { name: "Pyrazinamide 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ethambutol 400mg Tablet", cat: "Antibiotic" },
//   { name: "Streptomycin 1g Injection", cat: "Antibiotic Inj" },
//   // ── PAIN KILLERS / NSAIDS ────────────────────────────────────
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 250mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 150mg/ml Drops", cat: "Painkiller" },
//   { name: "Paracetamol 500mg/100ml Infusion", cat: "Painkiller Inj" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 100mg/5ml Syrup", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Injection", cat: "NSAID Inj" },
//   { name: "Ketorolac 10mg Tablet", cat: "NSAID" },
//   { name: "Ketorolac 30mg Injection", cat: "NSAID Inj" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Piroxicam 10mg Tablet", cat: "NSAID" },
//   { name: "Piroxicam 20mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 120mg Tablet", cat: "NSAID" },
//   { name: "Celecoxib 100mg Capsule", cat: "NSAID" },
//   { name: "Celecoxib 200mg Capsule", cat: "NSAID" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol 100mg SR Tablet", cat: "Opioid Analgesic" },
//   { name: "Tramadol 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Morphine 10mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Morphine 15mg Tablet", cat: "Opioid Analgesic" },
//   { name: "Fentanyl 50mcg/ml Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pentazocine 30mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pethidine 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Buprenorphine 0.3mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Tapentadol 50mg Tablet", cat: "Opioid Analgesic" },
//   { name: "Tapentadol 100mg Tablet", cat: "Opioid Analgesic" },
//   // ── LOCAL ANAESTHETICS — DENTAL ─────────────────────────────
//   { name: "Lignocaine 2% Dental Cartridge (1.8ml)", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine + Adrenaline 2% Dental Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% Heavy Spinal Injection", cat: "Local Anaesthetic" },
//   { name: "Mepivacaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Prilocaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Lignocaine 2% Plain Injection 30ml Vial", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine 2% + Adrenaline Injection Vial",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Lignocaine 10% Topical Spray", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 2% Viscous Gel", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 5% Ointment", cat: "Local Anaesthetic Topical" },
//   { name: "Benzocaine 20% Topical Gel", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lignocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine Jelly 2%", cat: "Local Anaesthetic Topical" },
//   { name: "Ropivacaine 0.2% Injection", cat: "Local Anaesthetic" },
//   { name: "Ropivacaine 0.75% Injection", cat: "Local Anaesthetic" },
//   {
//     name: "Tetracaine (Amethocaine) Eye Drops",
//     cat: "Local Anaesthetic Topical",
//   },
//   // ── GENERAL ANAESTHESIA ─────────────────────────────────────
//   { name: "Propofol 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 500mg Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Thiopentone Sodium 500mg Injection", cat: "General Anaesthesia" },
//   { name: "Midazolam 1mg/ml Injection", cat: "Sedative / Anaesthesia" },
//   { name: "Midazolam 5mg/ml Injection", cat: "Sedative / Anaesthesia" },
//   { name: "Midazolam 7.5mg Tablet", cat: "Sedative" },
//   { name: "Isoflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Sevoflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Desflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Nitrous Oxide Gas", cat: "Inhalation Anaesthetic" },
//   { name: "Oxygen Gas Cylinder", cat: "Medical Gas" },
//   { name: "Succinylcholine 100mg Injection", cat: "Muscle Relaxant" },
//   { name: "Vecuronium 4mg Injection", cat: "Muscle Relaxant" },
//   { name: "Atracurium 25mg Injection", cat: "Muscle Relaxant" },
//   { name: "Rocuronium 50mg Injection", cat: "Muscle Relaxant" },
//   { name: "Neostigmine 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Atropine 0.6mg Injection", cat: "Anticholinergic" },
//   { name: "Glycopyrrolate 0.2mg Injection", cat: "Anticholinergic" },
//   // ── STEROIDS / ANTI-INFLAMMATORY ────────────────────────────
//   { name: "Dexamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Betamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 40mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 16mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 40mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 125mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone 10mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone Acetonide 0.1% Oral Paste", cat: "Steroid Topical" },
//   { name: "Kenacort 0.1% Dental Paste", cat: "Steroid Topical" },
//   { name: "Betamethasone Gel Oral 0.025%", cat: "Steroid Topical" },
//   // ── ANTIFUNGALS ─────────────────────────────────────────────
//   { name: "Fluconazole 50mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 2mg/ml Infusion", cat: "Antifungal Inj" },
//   { name: "Itraconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Voriconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Amphotericin B 50mg Injection", cat: "Antifungal Inj" },
//   { name: "Clotrimazole 1% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin 100000 IU/ml Oral Drops", cat: "Antifungal" },
//   { name: "Nystatin 500000 IU Tablet", cat: "Antifungal" },
//   { name: "Clotrimazole + Betamethasone Cream", cat: "Antifungal Topical" },
//   { name: "Ketoconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Ketoconazole 2% Shampoo", cat: "Antifungal Topical" },
//   { name: "Terbinafine 250mg Tablet", cat: "Antifungal" },
//   // ── ANTIVIRAL ───────────────────────────────────────────────
//   { name: "Acyclovir 200mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 400mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 800mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 5% Cream", cat: "Antiviral Topical" },
//   { name: "Acyclovir 250mg Injection", cat: "Antiviral Inj" },
//   { name: "Valacyclovir 500mg Tablet", cat: "Antiviral" },
//   { name: "Valacyclovir 1000mg Tablet", cat: "Antiviral" },
//   { name: "Famciclovir 250mg Tablet", cat: "Antiviral" },
//   { name: "Oseltamivir 75mg Capsule", cat: "Antiviral" },
//   // ── ANTISEPTICS / MOUTHWASH / ORAL CARE ─────────────────────
//   { name: "Chlorhexidine Gluconate 0.2% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine Gluconate 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 1% Gel (Gum Gel)", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 5% Mouthwash / Gargle", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 10% Solution", cat: "Antiseptic" },
//   { name: "Povidone Iodine 5% Ointment", cat: "Antiseptic Topical" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 1.5% Mouthwash", cat: "Dental Antiseptic" },
//   {
//     name: "Benzydamine Hydrochloride 0.15% Mouthwash",
//     cat: "Dental Analgesic Rinse",
//   },
//   { name: "Hexetidine 0.1% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Sodium Fluoride 0.05% Mouthwash", cat: "Fluoride Rinse" },
//   { name: "Sodium Fluoride Varnish 5%", cat: "Fluoride Varnish" },
//   { name: "Fluoride Gel APF 1.23%", cat: "Fluoride Gel" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "Aloe Vera Gel Oral", cat: "Oral Care" },
//   { name: "Hyaluronic Acid Gel 0.2% Oral", cat: "Oral Care" },
//   { name: "Triclosan Toothpaste", cat: "Dental Brand" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Colgate Total Toothpaste", cat: "Dental Brand" },
//   { name: "Pepsodent Toothpaste", cat: "Dental Brand" },
//   { name: "Emoform Toothpaste", cat: "Dental Brand" },
//   { name: "Thermoseal Toothpaste", cat: "Dental Brand" },
//   { name: "Himalaya HiOra Toothpaste", cat: "Dental Brand" },
//   { name: "Dabur Red Toothpaste", cat: "Dental Brand" },
//   { name: "Meswak Toothpaste", cat: "Dental Brand" },
//   { name: "Oral-B Electric Toothbrush Head", cat: "Dental Accessory" },
//   { name: "Interdental Brush", cat: "Dental Accessory" },
//   { name: "Dental Floss", cat: "Dental Accessory" },
//   { name: "Tongue Cleaner", cat: "Dental Accessory" },
//   { name: "Water Flosser / Oral Irrigator", cat: "Dental Accessory" },
//   // ── DENTAL MATERIALS ────────────────────────────────────────
//   { name: "GIC Cement (Glass Ionomer Cement)", cat: "Dental Material" },
//   { name: "GIC Type II Restorative", cat: "Dental Material" },
//   { name: "RMGIC (Resin Modified GIC)", cat: "Dental Material" },
//   { name: "Composite Resin A1 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A2 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A3 Shade", cat: "Dental Material" },
//   { name: "Composite Resin B1 Shade", cat: "Dental Material" },
//   { name: "Flowable Composite", cat: "Dental Material" },
//   { name: "Bulk Fill Composite", cat: "Dental Material" },
//   { name: "IRM (Intermediate Restorative Material)", cat: "Dental Material" },
//   { name: "Zinc Oxide Eugenol Cement", cat: "Dental Material" },
//   { name: "Zinc Phosphate Cement", cat: "Dental Material" },
//   { name: "Zinc Polycarboxylate Cement", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Dycal (Calcium Hydroxide Base)", cat: "Dental Material" },
//   { name: "Cavity Liner (Varnish)", cat: "Dental Material" },
//   { name: "Etchant 37% Phosphoric Acid Gel", cat: "Dental Material" },
//   { name: "Bonding Agent (5th Gen)", cat: "Dental Material" },
//   { name: "Bonding Agent (7th Gen Self-Etch)", cat: "Dental Material" },
//   { name: "Dental Amalgam Capsule", cat: "Dental Material" },
//   { name: "Impression Material Alginate", cat: "Dental Material" },
//   {
//     name: "Impression Material Polyvinyl Siloxane (PVS)",
//     cat: "Dental Material",
//   },
//   { name: "Impression Material Polyether", cat: "Dental Material" },
//   { name: "Zinc Oxide Impression Paste", cat: "Dental Material" },
//   { name: "Plaster of Paris (Type II)", cat: "Dental Material" },
//   { name: "Dental Stone (Type III)", cat: "Dental Material" },
//   { name: "Dental Stone (Type IV)", cat: "Dental Material" },
//   { name: "Acrylic Resin Heat Cure", cat: "Dental Material" },
//   { name: "Acrylic Resin Cold Cure / Self Cure", cat: "Dental Material" },
//   { name: "Denture Base Resin", cat: "Dental Material" },
//   { name: "Denture Reliner", cat: "Dental Material" },
//   { name: "Denture Adhesive Cream", cat: "Dental Material" },
//   { name: "Dental Wax (Sheet Wax)", cat: "Dental Material" },
//   { name: "Boxing Wax", cat: "Dental Material" },
//   { name: "Inlay Wax", cat: "Dental Material" },
//   { name: "Sticky Wax", cat: "Dental Material" },
//   { name: "Orthodontic Wire NiTi 0.012", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire NiTi 0.014", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire NiTi 0.016", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire SS 0.019x0.025", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Metal)", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Ceramic)", cat: "Dental Ortho" },
//   { name: "Orthodontic Elastic Bands", cat: "Dental Ortho" },
//   { name: "Orthodontic Separator Elastics", cat: "Dental Ortho" },
//   { name: "Orthodontic Molar Band", cat: "Dental Ortho" },
//   { name: "Orthodontic Retainer Wire", cat: "Dental Ortho" },
//   { name: "Invisalign Clear Aligner Tray", cat: "Dental Ortho" },
//   { name: "Dental Implant Fixture (Titanium)", cat: "Dental Implant" },
//   { name: "Dental Implant Abutment", cat: "Dental Implant" },
//   { name: "Healing Cap / Cover Screw", cat: "Dental Implant" },
//   { name: "Bone Graft Material (Synthetic HA)", cat: "Dental Implant" },
//   { name: "Bone Graft Material (Xenograft)", cat: "Dental Implant" },
//   { name: "Collagen Membrane (Resorbable)", cat: "Dental Implant" },
//   { name: "Titanium Mesh", cat: "Dental Implant" },
//   { name: "PRP (Platelet Rich Plasma) Kit", cat: "Dental Surgical" },
//   { name: "PRF (Platelet Rich Fibrin) Kit", cat: "Dental Surgical" },
//   { name: "Hemostatic Agent (Gelatin Sponge)", cat: "Dental Surgical" },
//   { name: "Surgicel (Oxidised Cellulose)", cat: "Haemostatic" },
//   { name: "Alvogyl (Dry Socket Dressing)", cat: "Dental Surgical" },
//   { name: "Whitehead Varnish (Iodoform Paste)", cat: "Dental Surgical" },
//   { name: "Ledermix Paste", cat: "Dental Material" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Sealapex)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Zinc Oxide Eugenol)", cat: "Endodontic" },
//   { name: "Gutta Percha Points (ISO 20-80)", cat: "Endodontic" },
//   { name: "Paper Points (Absorbent Points)", cat: "Endodontic" },
//   { name: "EDTA Liquid 17% (Root Canal)", cat: "Endodontic" },
//   { name: "EDTA Gel 17% (Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 2.5% Solution", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% Solution", cat: "Endodontic" },
//   { name: "Chlorhexidine 2% Irrigant", cat: "Endodontic" },
//   { name: "RC Prep (Root Canal Lubricant)", cat: "Endodontic" },
//   { name: "K-Files (Root Canal Files) ISO 6-80", cat: "Endodontic Instrument" },
//   { name: "H-Files (Hedstrom Files) ISO 15-60", cat: "Endodontic Instrument" },
//   { name: "Rotary NiTi Files (ProTaper)", cat: "Endodontic Instrument" },
//   { name: "Rotary NiTi Files (WaveOne Gold)", cat: "Endodontic Instrument" },
//   { name: "Rubber Dam Sheet", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Clamp", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Frame", cat: "Endodontic Accessory" },
//   { name: "Pulp Capping Agent (Vitrebond)", cat: "Endodontic" },
//   { name: "Formocresol Solution", cat: "Endodontic Paediatric" },
//   { name: "Buckley's Formocresol", cat: "Endodontic Paediatric" },
//   {
//     name: "Zinc Oxide + Iodoform Paste (Kri Paste)",
//     cat: "Endodontic Paediatric",
//   },
//   { name: "Stainless Steel Crown (Paediatric)", cat: "Paediatric Dental" },
//   { name: "Fluoride Varnish Duraphat 22600 ppm", cat: "Fluoride Varnish" },
//   // ── SURGICAL INSTRUMENTS ────────────────────────────────────
//   { name: "Scalpel Handle No. 3", cat: "Surgical Instrument" },
//   { name: "Scalpel Handle No. 4", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 11", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 12", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 15", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 23", cat: "Surgical Instrument" },
//   { name: "Scissors (Metzenbaum)", cat: "Surgical Instrument" },
//   { name: "Scissors (Mayo Straight)", cat: "Surgical Instrument" },
//   { name: "Scissors (Mayo Curved)", cat: "Surgical Instrument" },
//   { name: "Scissors (Iris)", cat: "Surgical Instrument" },
//   { name: "Scissors (Dean)", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Straight)", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Curved)", cat: "Surgical Instrument" },
//   { name: "Mosquito Forceps", cat: "Surgical Instrument" },
//   { name: "Tissue Forceps (Adson)", cat: "Surgical Instrument" },
//   { name: "Tissue Forceps (Rat Tooth)", cat: "Surgical Instrument" },
//   { name: "Allis Tissue Forceps", cat: "Surgical Instrument" },
//   { name: "Babcock Forceps", cat: "Surgical Instrument" },
//   { name: "Needle Holder (Mayo Hegar)", cat: "Surgical Instrument" },
//   { name: "Needle Holder (Mathieu)", cat: "Surgical Instrument" },
//   { name: "Retractor (Langenbeck)", cat: "Surgical Instrument" },
//   { name: "Retractor (Army-Navy)", cat: "Surgical Instrument" },
//   { name: "Retractor (Minnesota)", cat: "Surgical Instrument" },
//   { name: "Cheek Retractor (Plastic)", cat: "Dental Instrument" },
//   { name: "Mouth Gag (Doyen)", cat: "Surgical Instrument" },
//   { name: "Periosteal Elevator (Molt No.9)", cat: "Dental Instrument" },
//   { name: "Periosteal Elevator (Freer)", cat: "Dental Instrument" },
//   { name: "Bone Curette (Lucas)", cat: "Dental Instrument" },
//   { name: "Surgical Curette", cat: "Surgical Instrument" },
//   { name: "Bone File", cat: "Dental Instrument" },
//   { name: "Rongeur Forceps (Bone Cutting)", cat: "Surgical Instrument" },
//   { name: "Surgical Mallet", cat: "Surgical Instrument" },
//   { name: "Osteotome", cat: "Surgical Instrument" },
//   { name: "Chisel (Straight)", cat: "Surgical Instrument" },
//   { name: "Suction Tip (Yankauer)", cat: "Surgical Instrument" },
//   { name: "Suction Tip (Dental Fine Tip)", cat: "Dental Instrument" },
//   { name: "Saliva Ejector Tip", cat: "Dental Instrument" },
//   { name: "High Volume Evacuator (HVE) Tip", cat: "Dental Instrument" },
//   { name: "Air/Water Syringe Tip", cat: "Dental Instrument" },
//   // ── DENTAL EXTRACTION FORCEPS ────────────────────────────────
//   { name: "Extraction Forceps Upper Anterior", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Premolar", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Molar (Left)", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Molar (Right)", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Anterior", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Premolar", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Molar", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Roots (Bayonet)", cat: "Dental Instrument" },
//   { name: "Elevator (Straight No. 301)", cat: "Dental Instrument" },
//   { name: "Elevator (Cryer Right)", cat: "Dental Instrument" },
//   { name: "Elevator (Cryer Left)", cat: "Dental Instrument" },
//   { name: "Elevator (Apexo)", cat: "Dental Instrument" },
//   { name: "Elevator (Warwick James)", cat: "Dental Instrument" },
//   { name: "Elevator (Coupland)", cat: "Dental Instrument" },
//   // ── PERIODONTAL INSTRUMENTS ──────────────────────────────────
//   { name: "Ultrasonic Scaler Tip (Universal)", cat: "Periodontal Instrument" },
//   {
//     name: "Ultrasonic Scaler Tip (Subgingival)",
//     cat: "Periodontal Instrument",
//   },
//   { name: "Sickle Scaler H6/H7", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 1/2", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 5/6", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 7/8", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 11/12", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 13/14", cat: "Periodontal Instrument" },
//   { name: "Columbia Curette 4R/4L", cat: "Periodontal Instrument" },
//   { name: "Periodontal Probe (Williams)", cat: "Periodontal Instrument" },
//   { name: "Periodontal Probe (UNC-15)", cat: "Periodontal Instrument" },
//   { name: "Periodontal Probe (CPITN)", cat: "Periodontal Instrument" },
//   { name: "Suture Scissors (Crown Removing)", cat: "Periodontal Instrument" },
//   { name: "Electrosurgery Tip", cat: "Periodontal Instrument" },
//   // ── NEEDLES AND SYRINGES ─────────────────────────────────────
//   { name: "Dental Needle 27G Short (21mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 27G Long (38mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Short (21mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 25G Long (38mm)", cat: "Dental Needle" },
//   {
//     name: "Aspirating Dental Syringe (Breech Loading)",
//     cat: "Dental Instrument",
//   },
//   { name: "Disposable Syringe 1ml (Insulin)", cat: "Syringe" },
//   { name: "Disposable Syringe 2ml", cat: "Syringe" },
//   { name: "Disposable Syringe 5ml", cat: "Syringe" },
//   { name: "Disposable Syringe 10ml", cat: "Syringe" },
//   { name: "Disposable Syringe 20ml", cat: "Syringe" },
//   { name: "Disposable Syringe 50ml (Piston)", cat: "Syringe" },
//   { name: "Needle 18G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 20G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 21G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 22G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 23G x 1 inch", cat: "Needle" },
//   { name: "Needle 24G x 1 inch", cat: "Needle" },
//   { name: "Needle 25G x 5/8 inch", cat: "Needle" },
//   { name: "Needle 26G x 0.5 inch", cat: "Needle" },
//   { name: "IV Cannula 14G (Orange)", cat: "IV Cannula" },
//   { name: "IV Cannula 16G (Grey)", cat: "IV Cannula" },
//   { name: "IV Cannula 18G (Green)", cat: "IV Cannula" },
//   { name: "IV Cannula 20G (Pink)", cat: "IV Cannula" },
//   { name: "IV Cannula 22G (Blue)", cat: "IV Cannula" },
//   { name: "IV Cannula 24G (Yellow)", cat: "IV Cannula" },
//   { name: "Spinal Needle 25G (Quincke)", cat: "Spinal Needle" },
//   { name: "Spinal Needle 26G (Quincke)", cat: "Spinal Needle" },
//   { name: "Epidural Needle 16G (Tuohy)", cat: "Epidural Needle" },
//   { name: "Epidural Catheter", cat: "Epidural Set" },
//   { name: 'Hypodermic Needle 21G x 1.5"', cat: "Needle" },
//   { name: "Scalp Vein Set 21G (Butterfly)", cat: "IV Accessory" },
//   { name: "Scalp Vein Set 23G (Butterfly)", cat: "IV Accessory" },
//   { name: "Scalp Vein Set 25G (Butterfly)", cat: "IV Accessory" },
//   // ── IV FLUIDS / INFUSIONS ────────────────────────────────────
//   { name: "Normal Saline 0.9% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 1000ml Infusion", cat: "IV Fluid" },
//   { name: "Ringer's Lactate 500ml Infusion", cat: "IV Fluid" },
//   { name: "Ringer's Lactate 1000ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 5% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 5% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 10% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 25% 200ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 50% 50ml Injection", cat: "IV Fluid" },
//   { name: "Dextrose 5% + Normal Saline 500ml", cat: "IV Fluid" },
//   { name: "Dextrose Saline (0.45% NaCl + 5% Dextrose)", cat: "IV Fluid" },
//   { name: "Isolyte S 500ml Infusion", cat: "IV Fluid" },
//   { name: "Isolyte P 500ml Infusion (Paediatric)", cat: "IV Fluid" },
//   { name: "Plasma Expander (Haemaccel) 500ml", cat: "IV Fluid" },
//   { name: "Colloid Solution (Albumin 5%) 500ml", cat: "IV Fluid" },
//   { name: "Albumin 25% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Sodium Bicarbonate 7.5% 25ml Injection", cat: "IV Fluid" },
//   { name: "Potassium Chloride 15% 10ml Ampoule", cat: "IV Electrolyte" },
//   { name: "Calcium Gluconate 10% Injection", cat: "IV Electrolyte" },
//   { name: "Magnesium Sulphate 50% Injection", cat: "IV Electrolyte" },
//   { name: "TPN (Total Parenteral Nutrition) Bag", cat: "IV Nutrition" },
//   { name: "Lipid Emulsion 20% Infusion", cat: "IV Nutrition" },
//   // ── ANTIEMETICS / GI ─────────────────────────────────────────
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 2mg/ml Injection", cat: "Antiemetic Inj" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Injection", cat: "Antiemetic Inj" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Promethazine 25mg Tablet", cat: "Antiemetic / Antihistamine" },
//   { name: "Promethazine 25mg Injection", cat: "Antiemetic Inj" },
//   { name: "Granisetron 1mg Tablet", cat: "Antiemetic" },
//   { name: "Pantoprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Ranitidine 150mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ranitidine 50mg Injection", cat: "Antacid Inj" },
//   { name: "Sucralfate Suspension 1g/10ml", cat: "Antacid" },
//   { name: "Antacid Suspension (Digene)", cat: "Antacid" },
//   { name: "Antacid Tablet (Gelusil)", cat: "Antacid" },
//   { name: "Syp Lactulose 10g/15ml", cat: "Laxative" },
//   { name: "Bisacodyl 5mg Tablet", cat: "Laxative" },
//   { name: "Bisacodyl Suppository 10mg", cat: "Laxative" },
//   { name: "Loperamide 2mg Tablet", cat: "Antidiarrhoeal" },
//   { name: "ORS Sachet (WHO Formula)", cat: "Oral Rehydration" },
//   { name: "Zinc Sulphate 20mg Tablet (Paediatric)", cat: "Micronutrient" },
//   // ── ANTIHISTAMINES / ALLERGY ─────────────────────────────────
//   { name: "Cetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 5mg/5ml Syrup", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 180mg Tablet", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 4mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 10mg Injection", cat: "Antihistamine Inj" },
//   { name: "Diphenhydramine 25mg Capsule", cat: "Antihistamine" },
//   { name: "Diphenhydramine Injection", cat: "Antihistamine Inj" },
//   { name: "Adrenaline (Epinephrine) 1mg/ml Injection", cat: "Emergency Drug" },
//   { name: "Hydrocortisone 100mg Injection (Allergy)", cat: "Emergency Drug" },
//   { name: "Epinephrine Auto-Injector (EpiPen)", cat: "Emergency Drug" },
//   // ── CARDIOVASCULAR ───────────────────────────────────────────
//   { name: "Amlodipine 2.5mg Tablet", cat: "Antihypertensive" },
//   { name: "Amlodipine 5mg Tablet", cat: "Antihypertensive" },
//   { name: "Amlodipine 10mg Tablet", cat: "Antihypertensive" },
//   { name: "Atenolol 25mg Tablet", cat: "Beta Blocker" },
//   { name: "Atenolol 50mg Tablet", cat: "Beta Blocker" },
//   { name: "Atenolol 100mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 25mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 50mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 100mg Tablet", cat: "Beta Blocker" },
//   { name: "Propranolol 10mg Tablet", cat: "Beta Blocker" },
//   { name: "Propranolol 40mg Tablet", cat: "Beta Blocker" },
//   { name: "Losartan 25mg Tablet", cat: "Antihypertensive" },
//   { name: "Losartan 50mg Tablet", cat: "Antihypertensive" },
//   { name: "Telmisartan 40mg Tablet", cat: "Antihypertensive" },
//   { name: "Telmisartan 80mg Tablet", cat: "Antihypertensive" },
//   { name: "Ramipril 2.5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Ramipril 5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Enalapril 5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Enalapril 10mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Furosemide 20mg Tablet", cat: "Diuretic" },
//   { name: "Furosemide 40mg Tablet", cat: "Diuretic" },
//   { name: "Furosemide 20mg Injection", cat: "Diuretic Inj" },
//   { name: "Spironolactone 25mg Tablet", cat: "Diuretic" },
//   { name: "Aspirin 75mg Tablet", cat: "Antiplatelet" },
//   { name: "Aspirin 150mg Tablet", cat: "Antiplatelet" },
//   { name: "Clopidogrel 75mg Tablet", cat: "Antiplatelet" },
//   { name: "Atorvastatin 10mg Tablet", cat: "Statin" },
//   { name: "Atorvastatin 20mg Tablet", cat: "Statin" },
//   { name: "Atorvastatin 40mg Tablet", cat: "Statin" },
//   { name: "Nitroglycerin 0.5mg Sublingual Tablet", cat: "Nitrate" },
//   { name: "Nitroglycerin 5mg/ml Infusion", cat: "Nitrate Inj" },
//   { name: "Digoxin 0.25mg Tablet", cat: "Cardiac Glycoside" },
//   { name: "Amiodarone 200mg Tablet", cat: "Antiarrhythmic" },
//   { name: "Warfarin 1mg Tablet", cat: "Anticoagulant" },
//   { name: "Warfarin 5mg Tablet", cat: "Anticoagulant" },
//   { name: "Heparin 5000 IU Injection", cat: "Anticoagulant Inj" },
//   { name: "Protamine Sulphate 10mg Injection", cat: "Anticoagulant Reversal" },
//   // ── DIABETES DRUGS ───────────────────────────────────────────
//   { name: "Metformin 500mg Tablet", cat: "Antidiabetic" },
//   { name: "Metformin 850mg Tablet", cat: "Antidiabetic" },
//   { name: "Metformin 1000mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 1mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 2mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 4mg Tablet", cat: "Antidiabetic" },
//   { name: "Insulin Regular (Soluble) 100 IU/ml", cat: "Insulin" },
//   { name: "Insulin NPH (Isophane) 100 IU/ml", cat: "Insulin" },
//   { name: "Insulin Glargine 100 IU/ml (Lantus)", cat: "Insulin" },
//   { name: "Insulin Aspart 100 IU/ml (Novorapid)", cat: "Insulin" },
//   { name: "Insulin Lispro 100 IU/ml (Humalog)", cat: "Insulin" },
//   // ── VITAMINS / SUPPLEMENTS ───────────────────────────────────
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin C 1000mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule (Weekly)", cat: "Vitamin" },
//   { name: "Vitamin D3 1000 IU Tablet (Daily)", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 500mcg Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 1000mcg Injection", cat: "Vitamin Inj" },
//   { name: "Vitamin K1 10mg Injection", cat: "Vitamin Inj" },
//   { name: "Folic Acid 5mg Tablet", cat: "Vitamin" },
//   { name: "Iron (Ferrous Sulphate) 200mg Tablet", cat: "Iron Supplement" },
//   { name: "Iron + Folic Acid Tablet", cat: "Iron Supplement" },
//   { name: "Iron Sucrose 100mg Injection", cat: "Iron Supplement Inj" },
//   { name: "Calcium Carbonate 500mg Tablet", cat: "Calcium Supplement" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Zinc Sulphate 50mg Tablet", cat: "Micronutrient" },
//   { name: "Magnesium Hydroxide 300mg Tablet", cat: "Mineral Supplement" },
//   { name: "Multivitamin Tablet (Adult)", cat: "Multivitamin" },
//   { name: "Multivitamin Syrup (Paediatric)", cat: "Multivitamin" },
//   // ── HAEMOSTATICS / BLEEDING ──────────────────────────────────
//   { name: "Tranexamic Acid 500mg Tablet", cat: "Haemostatic" },
//   { name: "Tranexamic Acid 250mg/5ml Injection", cat: "Haemostatic Inj" },
//   { name: "Etamsylate 250mg Tablet", cat: "Haemostatic" },
//   { name: "Etamsylate 125mg/2ml Injection", cat: "Haemostatic Inj" },
//   { name: "Gelatin Sponge (Absorbable Haemostat)", cat: "Haemostatic" },
//   { name: "Bone Wax", cat: "Haemostatic Surgical" },
//   { name: "Thrombin Topical Powder", cat: "Haemostatic" },
//   { name: "Fibrin Glue (Tisseel)", cat: "Haemostatic Surgical" },
//   // ── SUTURE MATERIALS ─────────────────────────────────────────
//   { name: "Vicryl (Polyglactin 910) 3-0 Suture", cat: "Suture" },
//   { name: "Vicryl (Polyglactin 910) 4-0 Suture", cat: "Suture" },
//   { name: "Vicryl Rapid 4-0 Suture", cat: "Suture" },
//   { name: "Chromic Catgut 2-0 Suture", cat: "Suture" },
//   { name: "Chromic Catgut 3-0 Suture", cat: "Suture" },
//   { name: "Plain Catgut 2-0 Suture", cat: "Suture" },
//   { name: "Silk Suture 2-0 Black Braided", cat: "Suture" },
//   { name: "Silk Suture 3-0 Black Braided", cat: "Suture" },
//   { name: "Silk Suture 4-0 Black Braided", cat: "Suture" },
//   { name: "Nylon Suture 3-0 (Ethilon)", cat: "Suture" },
//   { name: "Nylon Suture 4-0 (Ethilon)", cat: "Suture" },
//   { name: "Nylon Suture 5-0 (Ethilon)", cat: "Suture" },
//   { name: "Prolene (Polypropylene) 3-0 Suture", cat: "Suture" },
//   { name: "Prolene (Polypropylene) 4-0 Suture", cat: "Suture" },
//   { name: "PDS II (Polydioxanone) 3-0 Suture", cat: "Suture" },
//   { name: "Monocryl 4-0 Suture (Poliglecaprone)", cat: "Suture" },
//   { name: "Stapler Skin (Proximate Plus)", cat: "Surgical Closure" },
//   { name: "Skin Staple Remover", cat: "Surgical Instrument" },
//   { name: "Steri-Strip (Wound Closure Strip)", cat: "Wound Care" },
//   { name: "Surgical Glue (Dermabond / Histoacryl)", cat: "Wound Care" },
//   // ── DRESSINGS / WOUND CARE ───────────────────────────────────
//   { name: "Gauze Swab 4x4 inch (Sterile)", cat: "Dressing" },
//   { name: "Gauze Swab 10x10 cm (Non-Sterile)", cat: "Dressing" },
//   { name: "ABD Pad (Combine Dressing)", cat: "Dressing" },
//   { name: "Crepe Bandage 4 inch", cat: "Bandage" },
//   { name: "Crepe Bandage 6 inch", cat: "Bandage" },
//   { name: "Adhesive Plaster Roll 1 inch", cat: "Bandage" },
//   { name: "Elastic Adhesive Bandage (EAB)", cat: "Bandage" },
//   { name: "Cohesive Bandage", cat: "Bandage" },
//   { name: "Cotton Roll (Non-Sterile)", cat: "Dental Material" },
//   { name: "Cotton Roll Sterile", cat: "Dressing" },
//   { name: "Absorbable Haemostatic Gauze", cat: "Haemostatic Dressing" },
//   { name: "Vaseline Gauze (Petrolatum Gauze)", cat: "Dressing" },
//   { name: "Jelonet Paraffin Gauze", cat: "Dressing" },
//   { name: "Melolin Non-Adherent Dressing", cat: "Dressing" },
//   { name: "Hydrocolloid Dressing (DuoDERM)", cat: "Dressing" },
//   { name: "Hydrogel Dressing", cat: "Dressing" },
//   { name: "Foam Dressing", cat: "Dressing" },
//   { name: "Alginate Dressing", cat: "Dressing" },
//   { name: "Transparent Film Dressing (Tegaderm)", cat: "Dressing" },
//   { name: "Povidone Iodine Gauze", cat: "Dressing" },
//   { name: "Silver Sulfadiazine 1% Cream", cat: "Burns Dressing" },
//   { name: "Bacitracin Ointment", cat: "Topical Antibiotic" },
//   { name: "Mupirocin 2% Ointment (Bactroban)", cat: "Topical Antibiotic" },
//   { name: "Fusidic Acid 2% Cream", cat: "Topical Antibiotic" },
//   { name: "Framycetin (Soframycin) Cream", cat: "Topical Antibiotic" },
//   // ── GLOVES / PPE / DISPOSABLES ───────────────────────────────
//   { name: "Latex Examination Gloves (S/M/L)", cat: "PPE" },
//   { name: "Nitrile Examination Gloves (S/M/L)", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 6.0", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 6.5", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 7.0", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 7.5", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 8.0", cat: "PPE" },
//   { name: "Surgical Mask (3-ply)", cat: "PPE" },
//   { name: "N95 Respirator Mask (FFP2)", cat: "PPE" },
//   { name: "Face Shield", cat: "PPE" },
//   { name: "Surgical Cap / Head Cover", cat: "PPE" },
//   { name: "Shoe Cover (Surgical Boot Cover)", cat: "PPE" },
//   { name: "Sterile Gown (Surgical)", cat: "PPE" },
//   { name: "Disposable Apron", cat: "PPE" },
//   { name: "Safety Goggles", cat: "PPE" },
//   { name: "Sharps Container 5L", cat: "Waste Disposal" },
//   { name: "Yellow Biohazard Bag", cat: "Waste Disposal" },
//   { name: "Red Biohazard Bag", cat: "Waste Disposal" },
//   { name: "IV Line / Infusion Set", cat: "IV Accessory" },
//   { name: "Burette Set (Paediatric IV Set)", cat: "IV Accessory" },
//   { name: "Blood Transfusion Set", cat: "IV Accessory" },
//   { name: "Nasogastric Tube (Ryle's Tube) 14F", cat: "Medical Device" },
//   { name: "Nasogastric Tube 16F", cat: "Medical Device" },
//   { name: "Foley Catheter 14F (2-Way)", cat: "Medical Device" },
//   { name: "Foley Catheter 16F (2-Way)", cat: "Medical Device" },
//   { name: "Foley Catheter 18F (3-Way)", cat: "Medical Device" },
//   { name: "Urobag (Urine Collection Bag)", cat: "Medical Device" },
//   { name: "Tracheostomy Tube (Cuffed) Size 7", cat: "Medical Device" },
//   { name: "Endotracheal Tube (ETT) 7.0 Cuffed", cat: "Anaesthesia Device" },
//   { name: "Endotracheal Tube (ETT) 7.5 Cuffed", cat: "Anaesthesia Device" },
//   { name: "Laryngoscope Blade (Macintosh Size 3)", cat: "Anaesthesia Device" },
//   { name: "Laryngeal Mask Airway (LMA) Size 3", cat: "Anaesthesia Device" },
//   { name: "Oropharyngeal Airway (Guedel) Size 3", cat: "Anaesthesia Device" },
//   { name: "Bag Valve Mask (BVM Resuscitator)", cat: "Emergency Device" },
//   { name: "Pulse Oximeter Probe", cat: "Monitoring Device" },
//   { name: "BP Cuff (Sphygmomanometer Cuff)", cat: "Monitoring Device" },
//   // ── RESPIRATORY / BRONCHODILATORS ───────────────────────────
//   { name: "Salbutamol 2mg Tablet", cat: "Bronchodilator" },
//   { name: "Salbutamol 4mg Tablet", cat: "Bronchodilator" },
//   { name: "Salbutamol 2.5mg/2.5ml Nebulisation", cat: "Bronchodilator" },
//   { name: "Salbutamol Inhaler 100mcg (MDI)", cat: "Bronchodilator Inhaler" },
//   { name: "Ipratropium 0.5mg Nebulisation", cat: "Bronchodilator" },
//   { name: "Budesonide 0.5mg Nebulisation", cat: "Steroid Inhaler" },
//   { name: "Doxofylline 400mg Tablet", cat: "Bronchodilator" },
//   { name: "Deriphylline Injection", cat: "Bronchodilator Inj" },
//   // ── ANTIEPILEPTICS ───────────────────────────────────────────
//   { name: "Phenytoin 100mg Tablet", cat: "Antiepileptic" },
//   { name: "Phenytoin 50mg/ml Injection", cat: "Antiepileptic Inj" },
//   { name: "Valproate 200mg Tablet", cat: "Antiepileptic" },
//   { name: "Valproate 500mg Tablet", cat: "Antiepileptic" },
//   { name: "Levetiracetam 500mg Tablet", cat: "Antiepileptic" },
//   { name: "Lorazepam 4mg Injection", cat: "Antiepileptic / Sedative Inj" },
//   { name: "Diazepam 10mg Injection", cat: "Antiepileptic / Sedative Inj" },
//   { name: "Clonazepam 0.5mg Tablet", cat: "Antiepileptic" },
//   { name: "Clonazepam 2mg Tablet", cat: "Antiepileptic" },
//   // ── VACCINES ─────────────────────────────────────────────────
//   { name: "Tetanus Toxoid 0.5ml Injection", cat: "Vaccine" },
//   { name: "Tetanus + Diphtheria (Td) Vaccine", cat: "Vaccine" },
//   { name: "Influenza Vaccine (Flu Shot)", cat: "Vaccine" },
//   { name: "Typhoid Vaccine (Vi Polysaccharide)", cat: "Vaccine" },
//   { name: "Rabies Vaccine (Post-Exposure)", cat: "Vaccine" },
//   { name: "Rabies Immunoglobulin (Human)", cat: "Vaccine" },
//   { name: "MMR Vaccine", cat: "Vaccine" },
//   { name: "Varicella (Chickenpox) Vaccine", cat: "Vaccine" },
//   { name: "HPV Vaccine (Gardasil 4/9)", cat: "Vaccine" },
//   { name: "COVID-19 Vaccine (Covishield)", cat: "Vaccine" },
//   { name: "COVID-19 Vaccine (Covaxin)", cat: "Vaccine" },
//   { name: "Anti-Tetanus Serum (ATS)", cat: "Antiserum" },
//   { name: "Anti-Snake Venom (Polyvalent)", cat: "Antiserum" },
//   { name: "Anti-Rabies Serum", cat: "Antiserum" },
//   { name: "Anti-Scorpion Venom Serum", cat: "Antiserum" },
//   // ── INVESTIGATIONS / LAB ─────────────────────────────────────
//   { name: "OPG (Orthopantomogram) X-ray", cat: "Dental Investigation" },
//   { name: "IOPA X-ray (Intraoral Periapical)", cat: "Dental Investigation" },
//   { name: "Bitewing X-ray", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Cone Beam CT)", cat: "Dental Investigation" },
//   { name: "Occlusal X-ray", cat: "Dental Investigation" },
//   { name: "Lateral Cephalogram X-ray", cat: "Dental Investigation" },
//   { name: "Chest X-ray PA View", cat: "Investigation" },
//   { name: "Skull X-ray AP + Lateral", cat: "Investigation" },
//   { name: "X-Ray Mandible PA View", cat: "Investigation" },
//   { name: "X-Ray Waters View (PNS)", cat: "Investigation" },
//   { name: "ECG (Electrocardiogram)", cat: "Investigation" },
//   { name: "CT Scan Head Plain", cat: "Investigation" },
//   { name: "CT Scan Neck with Contrast", cat: "Investigation" },
//   { name: "MRI Face and Jaw", cat: "Investigation" },
//   { name: "Ultrasound Neck / Submandibular", cat: "Investigation" },
//   { name: "Complete Blood Count (CBC)", cat: "Lab Test" },
//   { name: "Differential Count (DC)", cat: "Lab Test" },
//   { name: "Blood Sugar Fasting (BSF)", cat: "Lab Test" },
//   { name: "Blood Sugar Post Prandial (BSPP)", cat: "Lab Test" },
//   { name: "Random Blood Sugar (RBS)", cat: "Lab Test" },
//   { name: "HbA1c Test", cat: "Lab Test" },
//   { name: "Liver Function Test (LFT)", cat: "Lab Test" },
//   { name: "Kidney Function Test (KFT) / RFT", cat: "Lab Test" },
//   { name: "Thyroid Function Test (TFT)", cat: "Lab Test" },
//   { name: "Lipid Profile Test", cat: "Lab Test" },
//   { name: "Urine Routine and Microscopy", cat: "Lab Test" },
//   { name: "Blood Group and Rh Typing", cat: "Lab Test" },
//   { name: "Platelet Count", cat: "Lab Test" },
//   { name: "PT / INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "APTT Test", cat: "Lab Test" },
//   { name: "Bleeding Time (BT)", cat: "Lab Test" },
//   { name: "Clotting Time (CT)", cat: "Lab Test" },
//   { name: "ESR (Erythrocyte Sedimentation Rate)", cat: "Lab Test" },
//   { name: "CRP (C-Reactive Protein)", cat: "Lab Test" },
//   { name: "Serum Calcium Test", cat: "Lab Test" },
//   { name: "Serum Phosphorus Test", cat: "Lab Test" },
//   { name: "Serum Vitamin D (25-OH) Test", cat: "Lab Test" },
//   { name: "Serum Vitamin B12 Test", cat: "Lab Test" },
//   { name: "Serum Iron / TIBC Test", cat: "Lab Test" },
//   { name: "HIV Test (ELISA)", cat: "Lab Test" },
//   { name: "HBsAg Test (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HCV Test (Hepatitis C)", cat: "Lab Test" },
//   { name: "VDRL / RPR Test (Syphilis)", cat: "Lab Test" },
//   { name: "Pus Culture and Sensitivity", cat: "Lab Test" },
//   { name: "Blood Culture and Sensitivity", cat: "Lab Test" },
//   { name: "FNAC (Fine Needle Aspiration Cytology)", cat: "Biopsy" },
//   { name: "Incisional Biopsy", cat: "Biopsy" },
//   { name: "Excisional Biopsy", cat: "Biopsy" },
//   { name: "Exfoliative Cytology (Oral Smear)", cat: "Lab Test" },
//   { name: "Histopathology (HPE)", cat: "Lab Test" },
//   // ── EMERGENCY DRUGS ─────────────────────────────────────────
//   { name: "Adrenaline 1:1000 (1mg/ml) Injection", cat: "Emergency Drug" },
//   { name: "Adrenaline 1:10000 Injection (Cardiac)", cat: "Emergency Drug" },
//   { name: "Atropine 0.6mg Injection", cat: "Emergency Drug" },
//   { name: "Sodium Bicarbonate 8.4% Injection", cat: "Emergency Drug" },
//   { name: "Calcium Gluconate 10% Injection", cat: "Emergency Drug" },
//   { name: "Dextrose 50% Injection (Hypoglycaemia)", cat: "Emergency Drug" },
//   { name: "Naloxone 0.4mg Injection (Opioid Reversal)", cat: "Emergency Drug" },
//   {
//     name: "Flumazenil 0.5mg Injection (Benzo Reversal)",
//     cat: "Emergency Drug",
//   },
//   { name: "Dopamine 200mg Infusion", cat: "Emergency Drug Inj" },
//   {
//     name: "Noradrenaline (Norepinephrine) Infusion",
//     cat: "Emergency Drug Inj",
//   },
//   { name: "Vasopressin 20 IU Injection", cat: "Emergency Drug Inj" },
//   { name: "GTN (Glyceryl Trinitrate) Infusion", cat: "Emergency Drug Inj" },
//   {
//     name: "Lignocaine 100mg IV Injection (Arrhythmia)",
//     cat: "Emergency Drug Inj",
//   },
//   { name: "Adenosine 6mg Injection (SVT)", cat: "Emergency Drug Inj" },
//   { name: "Defibrillator Pads (AED Electrode)", cat: "Emergency Device" },
//   ,
//   // ── CONSUMABLES: COTTON & GAUZE ──────────────────────────────
//   { name: "Cotton Roll (Dental Grade)", cat: "Consumable" },
//   { name: "Cotton Pellet Small", cat: "Consumable" },
//   { name: "Cotton Pellet Medium", cat: "Consumable" },
//   { name: "Cotton Pellet Large", cat: "Consumable" },
//   { name: "Absorbent Cotton Wool 500g Roll", cat: "Consumable" },
//   { name: "Absorbent Cotton Wool 100g", cat: "Consumable" },
//   { name: "Gauze Swab 4x4 inch Sterile", cat: "Consumable" },
//   { name: "Gauze Swab 2x2 inch Sterile", cat: "Consumable" },
//   { name: "Gauze Roll 5cm x 5m", cat: "Consumable" },
//   { name: "Gauze Roll 10cm x 5m", cat: "Consumable" },
//   { name: "Non-Woven Gauze Swab 4x4", cat: "Consumable" },
//   { name: "Paraffin Gauze Dressing", cat: "Dressing" },
//   { name: "Betadine Gauze Dressing", cat: "Dressing" },
//   { name: "Ribbon Gauze 1/2 inch (Dental Packing)", cat: "Dental Consumable" },
//   { name: "Ribbon Gauze 1 inch", cat: "Dental Consumable" },
//   { name: "Dry Foil (Dental)", cat: "Dental Consumable" },

//   // ── SALINE & IV FLUIDS ─────────────────────────────────────────
//   { name: "Normal Saline 0.9% 100ml", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 250ml", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 500ml", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 1000ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 100ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 250ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 500ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 1000ml", cat: "IV Fluid" },
//   { name: "Dextrose 10% 500ml", cat: "IV Fluid" },
//   { name: "Dextrose 25% 100ml", cat: "IV Fluid" },
//   { name: "Dextrose 50% 50ml", cat: "IV Fluid" },
//   { name: "Ringer Lactate 500ml", cat: "IV Fluid" },
//   { name: "Ringer Lactate 1000ml", cat: "IV Fluid" },
//   { name: "DNS (Dextrose Normal Saline) 500ml", cat: "IV Fluid" },
//   { name: "DNS 1000ml", cat: "IV Fluid" },
//   { name: "Haemaccel 500ml Infusion", cat: "IV Fluid" },
//   { name: "Gelofusine 500ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 100ml", cat: "IV Fluid" },
//   { name: "Mannitol 20% 250ml", cat: "IV Fluid" },
//   { name: "Sodium Bicarbonate 7.5% 25ml", cat: "IV Electrolyte" },
//   { name: "Sodium Bicarbonate 8.4% 100ml", cat: "IV Electrolyte" },
//   { name: "Potassium Chloride 15% 10ml Ampoule", cat: "IV Electrolyte" },
//   { name: "Calcium Gluconate 10% 10ml Injection", cat: "IV Electrolyte" },
//   { name: "Magnesium Sulphate 50% 2ml Injection", cat: "IV Electrolyte" },

//   // ── NEEDLES ────────────────────────────────────────────────────
//   { name: "Disposable Syringe 1ml (Insulin Type)", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 2ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 5ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 10ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 20ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 50ml", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 18G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 20G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 22G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 24G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 26G", cat: "Needle/Syringe" },
//   { name: "Dental Needle 27G Short", cat: "Dental Needle" },
//   { name: "Dental Needle 27G Long", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Short", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Ultra Short", cat: "Dental Needle" },
//   { name: "Scalp Vein Set (Butterfly) 21G", cat: "IV Accessory" },
//   { name: "Scalp Vein Set (Butterfly) 23G", cat: "IV Accessory" },
//   { name: "Scalp Vein Set (Butterfly) 25G", cat: "IV Accessory" },
//   { name: "IV Cannula 14G (Orange)", cat: "IV Cannula" },
//   { name: "IV Cannula 16G (Grey)", cat: "IV Cannula" },
//   { name: "IV Cannula 18G (Green)", cat: "IV Cannula" },
//   { name: "IV Cannula 20G (Pink)", cat: "IV Cannula" },
//   { name: "IV Cannula 22G (Blue)", cat: "IV Cannula" },
//   { name: "IV Cannula 24G (Yellow) Paediatric", cat: "IV Cannula" },
//   { name: "Spinal Needle 25G (Quincke)", cat: "Spinal Needle" },
//   { name: "Spinal Needle 26G", cat: "Spinal Needle" },
//   { name: "Spinal Needle 27G", cat: "Spinal Needle" },
//   { name: "Epidural Needle 16G (Tuohy)", cat: "Epidural Needle" },
//   { name: "Epidural Needle 17G (Tuohy)", cat: "Epidural Needle" },

//   // ── INJECTIONS & AMPOULES ──────────────────────────────────────
//   {
//     name: "Lignocaine 2% with Adrenaline 1:80000 Cartridge (Dental)",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Lignocaine 2% with Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Lignocaine 2% Plain Cartridge (Dental)", cat: "Local Anaesthetic" },
//   {
//     name: "Articaine 4% with Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% with Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Mepivacaine 3% Plain Cartridge", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% with Adrenaline", cat: "Local Anaesthetic" },
//   { name: "Prilocaine 4% Plain Cartridge", cat: "Local Anaesthetic" },
//   {
//     name: "Benzocaine 20% Topical Gel (Dental)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Lidocaine 2% Topical Jelly", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lidocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine 2% Jelly 30g", cat: "Local Anaesthetic Topical" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 250mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 40mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 125mg Injection", cat: "Steroid Inj" },
//   { name: "Ketorolac 30mg Injection", cat: "NSAID Inj" },
//   { name: "Diclofenac 75mg Injection", cat: "NSAID Inj" },
//   { name: "Tramadol 50mg Injection", cat: "Painkiller Inj" },
//   { name: "Tramadol 100mg Injection", cat: "Painkiller Inj" },
//   { name: "Morphine 10mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pethidine 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Fentanyl 50mcg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Ondansetron 4mg Injection", cat: "Antiemetic Inj" },
//   { name: "Metoclopramide 10mg Injection", cat: "Antiemetic Inj" },
//   { name: "Promethazine 25mg Injection", cat: "Antiemetic Inj" },
//   { name: "Chlorpheniramine 10mg Injection", cat: "Antihistamine Inj" },
//   { name: "Pheniramine 22.75mg Injection", cat: "Antihistamine Inj" },
//   { name: "Midazolam 1mg/ml Injection", cat: "Sedative" },
//   { name: "Midazolam 5mg/ml Injection", cat: "Sedative" },
//   { name: "Diazepam 5mg Injection", cat: "Sedative" },
//   { name: "Propofol 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 200mg Injection", cat: "General Anaesthesia" },
//   { name: "Atropine 0.6mg Injection", cat: "Anticholinergic" },
//   { name: "Neostigmine 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Succinylcholine 100mg Injection", cat: "Muscle Relaxant" },
//   { name: "Vecuronium 4mg Injection", cat: "Muscle Relaxant" },
//   { name: "Atracurium 25mg Injection", cat: "Muscle Relaxant" },
//   { name: "Furosemide 20mg Injection", cat: "Diuretic Inj" },
//   { name: "Furosemide 40mg Injection", cat: "Diuretic Inj" },
//   { name: "Ranitidine 50mg Injection", cat: "Antacid Inj" },
//   { name: "Pantoprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Omeprazole 40mg Injection", cat: "Antacid Inj" },
//   {
//     name: "Phytomenadione (Vitamin K1) 10mg Injection",
//     cat: "Haemostatic Inj",
//   },
//   { name: "Tranexamic Acid 500mg Injection", cat: "Haemostatic Inj" },
//   { name: "Etamsylate 250mg Injection", cat: "Haemostatic Inj" },
//   { name: "Oxytocin 10 IU Injection", cat: "Haemostatic Inj" },
//   { name: "Dextrose 50% 50ml Push", cat: "Emergency Drug Inj" },
//   { name: "Naloxone 0.4mg Injection", cat: "Reversal Agent" },
//   { name: "Flumazenil 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Calcium Gluconate 1g Injection", cat: "Emergency Drug Inj" },

//   // ── SURGICAL INSTRUMENTS ───────────────────────────────────────
//   { name: "Scalpel Handle No. 3", cat: "Surgical Instrument" },
//   { name: "Scalpel Handle No. 4", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 11", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 12", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 15", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 22", cat: "Surgical Instrument" },
//   { name: "Surgical Scissors Straight (Mayo)", cat: "Surgical Instrument" },
//   { name: "Surgical Scissors Curved (Mayo)", cat: "Surgical Instrument" },
//   { name: "Metzenbaum Scissors", cat: "Surgical Instrument" },
//   { name: "Iris Scissors", cat: "Surgical Instrument" },
//   { name: "Dissecting Forceps (Toothed) Adson", cat: "Surgical Instrument" },
//   { name: "Dissecting Forceps (Non-Toothed)", cat: "Surgical Instrument" },
//   { name: "Haemostat (Mosquito Forceps) Straight", cat: "Surgical Instrument" },
//   { name: "Haemostat (Mosquito Forceps) Curved", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Kocher) Straight", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Kocher) Curved", cat: "Surgical Instrument" },
//   { name: "Needle Holder (Mayo-Hegar)", cat: "Surgical Instrument" },
//   { name: "Retractor (Langenbeck) Small", cat: "Surgical Instrument" },
//   { name: "Retractor (Langenbeck) Large", cat: "Surgical Instrument" },
//   { name: "Self-Retaining Retractor (Weitlaner)", cat: "Surgical Instrument" },
//   { name: "Bone Rongeur Forceps", cat: "Surgical Instrument" },
//   { name: "Curette Small", cat: "Surgical Instrument" },
//   { name: "Curette Large", cat: "Surgical Instrument" },
//   { name: "Periosteal Elevator (Molt No.9)", cat: "Dental Instrument" },
//   { name: "Periosteal Elevator (Freer)", cat: "Dental Instrument" },
//   { name: "Luxator (Periotome)", cat: "Dental Instrument" },
//   { name: "Dental Elevator (Straight)", cat: "Dental Instrument" },
//   { name: "Dental Elevator (Cryer)", cat: "Dental Instrument" },
//   { name: "Dental Elevator (Warwick James)", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Anteriors", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Premolars", cat: "Dental Instrument" },
//   {
//     name: "Extraction Forceps Upper Molars (Cowhorn)",
//     cat: "Dental Instrument",
//   },
//   { name: "Extraction Forceps Lower Anteriors", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Molars", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Wisdom", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Wisdom", cat: "Dental Instrument" },
//   { name: "Bone File (Dental)", cat: "Dental Instrument" },
//   { name: "Bone Chisel (Dental)", cat: "Dental Instrument" },
//   { name: "Mallet (Surgical)", cat: "Dental Instrument" },
//   { name: "Rongeur Forceps (Dental)", cat: "Dental Instrument" },
//   { name: "Tissue Scissors (Dental)", cat: "Dental Instrument" },
//   { name: "Tongue Retractor", cat: "Dental Instrument" },
//   { name: "Cheek Retractor (Minnesota)", cat: "Dental Instrument" },
//   { name: "Austin/Channel Retractor", cat: "Dental Instrument" },
//   { name: "Dental Mirror No. 5", cat: "Dental Instrument" },
//   { name: "Dental Probe (CPI/UNC-15)", cat: "Dental Instrument" },
//   { name: "Dental Tweezers (College Pliers)", cat: "Dental Instrument" },
//   { name: "Dental Excavator Double Ended", cat: "Dental Instrument" },
//   { name: "Spoon Excavator Small", cat: "Dental Instrument" },
//   { name: "Spoon Excavator Medium", cat: "Dental Instrument" },
//   { name: "Amalgam Plugger", cat: "Dental Instrument" },
//   { name: "Composite Placement Instrument", cat: "Dental Instrument" },
//   { name: "Burnisher Ball", cat: "Dental Instrument" },
//   { name: "Burnisher Acorn", cat: "Dental Instrument" },
//   { name: "Sickle Scaler (H6/H7)", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 1/2", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 7/8", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 11/12", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 13/14", cat: "Periodontal Instrument" },
//   { name: "Columbia Curette", cat: "Periodontal Instrument" },
//   { name: "Hoe Scaler", cat: "Periodontal Instrument" },
//   { name: "File Scaler", cat: "Periodontal Instrument" },
//   { name: "Ultrasonic Scaler Tip (Slim)", cat: "Periodontal Instrument" },
//   { name: "Ultrasonic Scaler Tip (Universal)", cat: "Periodontal Instrument" },

//   // ── SUTURES ─────────────────────────────────────────────────────
//   { name: "Vicryl 3-0 (Polyglactin) Absorbable", cat: "Suture" },
//   { name: "Vicryl 4-0 Absorbable", cat: "Suture" },
//   { name: "Vicryl 5-0 Absorbable", cat: "Suture" },
//   { name: "Catgut Plain 2-0", cat: "Suture" },
//   { name: "Catgut Plain 3-0", cat: "Suture" },
//   { name: "Catgut Chromic 2-0", cat: "Suture" },
//   { name: "Catgut Chromic 3-0", cat: "Suture" },
//   { name: "Catgut Chromic 4-0", cat: "Suture" },
//   { name: "Silk 2-0 Non-Absorbable", cat: "Suture" },
//   { name: "Silk 3-0 Non-Absorbable (Dental)", cat: "Suture" },
//   { name: "Silk 4-0 Non-Absorbable", cat: "Suture" },
//   { name: "Prolene 4-0 (Polypropylene)", cat: "Suture" },
//   { name: "Prolene 5-0", cat: "Suture" },
//   { name: "Prolene 6-0", cat: "Suture" },
//   { name: "Nylon 3-0 Monofilament", cat: "Suture" },
//   { name: "Nylon 4-0 Monofilament", cat: "Suture" },
//   { name: "Nylon 5-0 Monofilament", cat: "Suture" },
//   { name: "PDS II 3-0 (Polydioxanone)", cat: "Suture" },
//   { name: "PDS II 4-0", cat: "Suture" },
//   { name: "Monocryl 4-0 (Poliglecaprone)", cat: "Suture" },
//   { name: "Monocryl 5-0", cat: "Suture" },
//   { name: "Ethibond 0 (Polyester)", cat: "Suture" },
//   { name: "Ethibond 2-0", cat: "Suture" },
//   { name: "Stapler (Skin Staples)", cat: "Surgical Closure" },
//   { name: "Steri-Strip Wound Closure 6mm", cat: "Surgical Closure" },
//   { name: "Steri-Strip Wound Closure 12mm", cat: "Surgical Closure" },
//   { name: "Tissue Glue (Dermabond/Histoacryl)", cat: "Surgical Closure" },

//   // ── IV DRIP ACCESSORIES ────────────────────────────────────────
//   { name: "IV Infusion Set (Standard)", cat: "IV Accessory" },
//   { name: "IV Infusion Set (Burette 100ml Paediatric)", cat: "IV Accessory" },
//   { name: "Blood Transfusion Set", cat: "IV Accessory" },
//   { name: "Extension Tubing (IV Line)", cat: "IV Accessory" },
//   { name: "Three-Way Stopcock", cat: "IV Accessory" },
//   { name: "Tegaderm IV Dressing 6x7cm", cat: "IV Accessory" },
//   { name: "Transparent Dressing IV Site", cat: "IV Accessory" },
//   { name: "IV Arm Board (Splint)", cat: "IV Accessory" },
//   { name: "Normal Saline Flush 10ml Pre-filled", cat: "IV Accessory" },
//   { name: "Heparin Flush 10 IU/ml", cat: "IV Accessory" },

//   // ── DRESSINGS & WOUND CARE ─────────────────────────────────────
//   { name: "Adhesive Plaster Roll 1 inch", cat: "Wound Care" },
//   { name: "Adhesive Plaster Roll 2 inch", cat: "Wound Care" },
//   { name: "Band-Aid Fabric 1 inch", cat: "Wound Care" },
//   { name: "Crepe Bandage 4 inch", cat: "Bandage" },
//   { name: "Crepe Bandage 6 inch", cat: "Bandage" },
//   { name: "Crepe Bandage 8 inch", cat: "Bandage" },
//   { name: "Elastic Adhesive Bandage 4 inch", cat: "Bandage" },
//   { name: "Cotton Bandage 4 inch", cat: "Bandage" },
//   { name: "Plaster of Paris (POP) Bandage 4 inch", cat: "Bandage" },
//   { name: "Plaster of Paris Bandage 6 inch", cat: "Bandage" },
//   { name: "Zinc Oxide Adhesive Plaster 1 inch", cat: "Wound Care" },
//   { name: "Wound Dressing Large (10x10)", cat: "Dressing" },
//   { name: "Wound Dressing Medium (7.5x7.5)", cat: "Dressing" },
//   { name: "Hydrocolloid Dressing", cat: "Wound Care" },
//   { name: "Foam Dressing", cat: "Wound Care" },
//   { name: "Silver Sulfadiazine 1% Cream (Burns)", cat: "Burns Dressing" },
//   { name: "Bactigras (Chlorhexidine Tulle)", cat: "Dressing" },

//   // ── ANTISEPTICS & DISINFECTANTS ────────────────────────────────
//   { name: "Povidone Iodine 5% Solution (Betadine)", cat: "Antiseptic" },
//   { name: "Povidone Iodine 10% Solution", cat: "Antiseptic" },
//   { name: "Povidone Iodine Surgical Scrub", cat: "Antiseptic" },
//   { name: "Chlorhexidine Gluconate 2% Solution", cat: "Antiseptic" },
//   { name: "Chlorhexidine Gluconate 4% Surgical Scrub", cat: "Antiseptic" },
//   { name: "Chlorhexidine 0.2% Mouthwash (Dental)", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Antiseptic" },
//   {
//     name: "Hydrogen Peroxide 6% (Dental Irrigation)",
//     cat: "Dental Antiseptic",
//   },
//   { name: "Isopropyl Alcohol 70% (Spirit Swabs)", cat: "Antiseptic" },
//   { name: "Alcohol Swabs (Pre-injection)", cat: "Antiseptic" },
//   { name: "Cetrimide + Chlorhexidine Solution", cat: "Antiseptic" },
//   { name: "Sodium Hypochlorite 2.5% (NaOCl - Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% (NaOCl)", cat: "Endodontic" },
//   { name: "EDTA Solution 17% (Root Canal)", cat: "Endodontic" },
//   { name: "EDTA Gel (RC Prep)", cat: "Endodontic" },
//   { name: "Saline Irrigation Solution 500ml", cat: "IV Fluid" },
//   { name: "Saline Nasal Drops", cat: "Consumable" },
//   { name: "Savlon (Cetrimide + Chlorhexidine)", cat: "Antiseptic" },
//   { name: "Dettol Liquid Antiseptic", cat: "Antiseptic" },

//   // ── DENTAL MATERIALS (EXPANDED) ────────────────────────────────
//   { name: "Zinc Oxide Eugenol (ZOE) Cement Base", cat: "Dental Material" },
//   { name: "Zinc Oxide Eugenol Impression Paste", cat: "Dental Material" },
//   { name: "Zinc Phosphate Cement", cat: "Dental Material" },
//   { name: "Zinc Polycarboxylate Cement", cat: "Dental Material" },
//   { name: "Glass Ionomer Cement Type I (Luting)", cat: "Dental Material" },
//   {
//     name: "Glass Ionomer Cement Type II (Restorative)",
//     cat: "Dental Material",
//   },
//   { name: "Glass Ionomer Cement Type III (Lining)", cat: "Dental Material" },
//   { name: "RMGIC (Resin Modified GIC)", cat: "Dental Material" },
//   { name: "Composite Resin Shade A1", cat: "Dental Material" },
//   { name: "Composite Resin Shade A2", cat: "Dental Material" },
//   { name: "Composite Resin Shade A3", cat: "Dental Material" },
//   { name: "Composite Resin Shade A3.5", cat: "Dental Material" },
//   { name: "Composite Resin Shade B1", cat: "Dental Material" },
//   { name: "Flowable Composite Shade A2", cat: "Dental Material" },
//   { name: "Flowable Composite Shade A3", cat: "Dental Material" },
//   { name: "Bonding Agent (5th Generation)", cat: "Dental Material" },
//   { name: "Bonding Agent (7th Generation Self-Etch)", cat: "Dental Material" },
//   { name: "Acid Etchant 37% Phosphoric Acid Gel", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste (Pulp Capping)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Powder", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Cavity Liner (Dycal)", cat: "Dental Material" },
//   { name: "Temporary Restoration Material (Cavit)", cat: "Dental Material" },
//   { name: "IRM Temporary Cement", cat: "Dental Material" },
//   { name: "Zinc Oxide Temp Fill", cat: "Dental Material" },
//   { name: "Alginate Impression Material (Chromatic)", cat: "Dental Material" },
//   { name: "Irreversible Hydrocolloid (Alginate) 500g", cat: "Dental Material" },
//   {
//     name: "Polyvinyl Siloxane (PVS) Impression Light Body",
//     cat: "Dental Material",
//   },
//   { name: "PVS Impression Heavy Body", cat: "Dental Material" },
//   { name: "Polyether Impression Material", cat: "Dental Material" },
//   { name: "Zinc Oxide Impression Paste (ZO Paste)", cat: "Dental Material" },
//   { name: "Plaster of Paris Dental Grade", cat: "Dental Material" },
//   { name: "Type III Dental Stone", cat: "Dental Material" },
//   { name: "Type IV Dental Stone (Die Stone)", cat: "Dental Material" },
//   { name: "Dental Wax (Modelling Wax)", cat: "Dental Material" },
//   { name: "Baseplate Wax", cat: "Dental Material" },
//   { name: "Sticky Wax", cat: "Dental Material" },
//   { name: "Bite Registration Paste", cat: "Dental Material" },
//   { name: "Separating Liquid (Sodium Alginate)", cat: "Dental Material" },
//   { name: "Denture Base Resin (Heat Cure)", cat: "Dental Material" },
//   { name: "Denture Base Resin (Cold Cure)", cat: "Dental Material" },
//   { name: "Denture Repair Resin", cat: "Dental Material" },
//   { name: "Acrylic Teeth Set (Upper)", cat: "Dental Material" },
//   { name: "Acrylic Teeth Set (Lower)", cat: "Dental Material" },
//   { name: "Porcelain Teeth", cat: "Dental Material" },
//   { name: "Chromium Cobalt Alloy (Partial Denture)", cat: "Dental Material" },
//   { name: "Amalgam Alloy Capsules (Pre-dosed)", cat: "Dental Material" },
//   { name: "Mercury (Dental Grade)", cat: "Dental Material" },
//   { name: "Amalgam Capsule Activator", cat: "Dental Accessory" },
//   { name: "Light Cure Composite Bleaching Gel 35%", cat: "Dental Material" },
//   { name: "Carbamide Peroxide 10% (Home Bleaching)", cat: "Dental Material" },
//   { name: "Carbamide Peroxide 16%", cat: "Dental Material" },
//   { name: "Carbamide Peroxide 22%", cat: "Dental Material" },
//   {
//     name: "Hydrogen Peroxide 35% (In-office Bleaching)",
//     cat: "Dental Material",
//   },
//   { name: "Desensitising Agent (Gluma)", cat: "Dental Material" },
//   { name: "Fluoride Varnish 5% NaF (Duraphat)", cat: "Dental Fluoride" },
//   { name: "Fluoride Gel APF 1.23%", cat: "Fluoride Gel" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "Pit & Fissure Sealant (Light Cure)", cat: "Dental Material" },
//   { name: "Pit & Fissure Sealant (Self-Cure)", cat: "Dental Material" },
//   { name: "Crown & Bridge Temporary Cement", cat: "Dental Material" },
//   { name: "Permanent Crown Cement (Ketac Cem)", cat: "Dental Material" },
//   { name: "Resin Cement (Panavia F)", cat: "Dental Material" },
//   { name: "Post & Core Material", cat: "Dental Material" },
//   { name: "Fibre Post (Glass Fibre)", cat: "Dental Material" },
//   { name: "Gutta Percha Points ISO Size 15", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 20", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 25", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 30", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 35", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 40", cat: "Endodontic" },
//   { name: "Gutta Percha Points Standardised Large", cat: "Endodontic" },
//   { name: "Gutta Percha Points Accessory Fine", cat: "Endodontic" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Apexit Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Zinc Oxide Eugenol)", cat: "Endodontic" },
//   { name: "K-File ISO 15 (Root Canal File)", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 20", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 25", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 30", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 35", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 40", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 45", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 50", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 60", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 80", cat: "Endodontic Instrument" },
//   { name: "H-File (Hedstroem) ISO 20", cat: "Endodontic Instrument" },
//   { name: "H-File ISO 25", cat: "Endodontic Instrument" },
//   { name: "H-File ISO 30", cat: "Endodontic Instrument" },
//   { name: "Reamer ISO 15-40 Set", cat: "Endodontic Instrument" },
//   { name: "ProTaper Next Rotary File Set", cat: "Endodontic Instrument" },
//   {
//     name: "WaveOne Gold Primary (Reciprocating)",
//     cat: "Endodontic Instrument",
//   },
//   { name: "Reciproc Blue R25", cat: "Endodontic Instrument" },
//   { name: "Lentulo Spiral Filler", cat: "Endodontic Instrument" },
//   { name: "Plugger Spreader (Gutta Percha)", cat: "Endodontic Instrument" },
//   { name: "Barbed Broach Assorted", cat: "Endodontic Instrument" },
//   { name: "Paper Points ISO 20", cat: "Endodontic Accessory" },
//   { name: "Paper Points ISO 25", cat: "Endodontic Accessory" },
//   { name: "Paper Points ISO 30", cat: "Endodontic Accessory" },
//   { name: "Paper Points ISO 40", cat: "Endodontic Accessory" },
//   { name: "Paper Points Fine (Accessory)", cat: "Endodontic Accessory" },
//   { name: "Apex Locator Tips", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Sheet (Latex)", cat: "Dental Accessory" },
//   { name: "Rubber Dam Frame (Ostby)", cat: "Dental Accessory" },
//   { name: "Rubber Dam Clamp Kit", cat: "Dental Accessory" },
//   { name: "Rubber Dam Punch", cat: "Dental Accessory" },
//   { name: "Saliva Ejector Tips (Disposable)", cat: "Dental Accessory" },
//   { name: "High Volume Evacuation Tip (HVE)", cat: "Dental Accessory" },
//   { name: "Matrix Band (Tofflemire Universal)", cat: "Dental Accessory" },
//   { name: "Sectional Matrix System (Palodent)", cat: "Dental Accessory" },
//   { name: "Wooden Wedge Assorted", cat: "Dental Accessory" },
//   { name: "Interproximal Plastic Wedge", cat: "Dental Accessory" },
//   { name: "Celluloid Crown Form (Anterior)", cat: "Dental Accessory" },
//   {
//     name: "Stainless Steel Crown (Molar Paediatric)",
//     cat: "Paediatric Dental",
//   },
//   { name: "Stainless Steel Crown Kit", cat: "Paediatric Dental" },
//   { name: "Pulpotomy Agent (Formocresol)", cat: "Paediatric Dental" },
//   { name: "Pulpotomy Agent (Ferric Sulphate 15.5%)", cat: "Paediatric Dental" },
//   { name: "Zinc Oxide Eugenol Paediatric Filling", cat: "Paediatric Dental" },

//   // ── ORTHO MATERIALS ────────────────────────────────────────────
//   { name: "Orthodontic Bands (Molar) Upper", cat: "Dental Ortho" },
//   { name: "Orthodontic Bands (Molar) Lower", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Metal Roth)", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Ceramic)", cat: "Dental Ortho" },
//   { name: "Archwire NiTi Round 0.014", cat: "Dental Ortho" },
//   { name: "Archwire NiTi Round 0.016", cat: "Dental Ortho" },
//   { name: "Archwire NiTi Round 0.018", cat: "Dental Ortho" },
//   { name: "Archwire SS Rectangular 0.019x0.025", cat: "Dental Ortho" },
//   { name: "Archwire SS Rectangular 0.021x0.025", cat: "Dental Ortho" },
//   { name: "Ligature Wire (Stainless Steel)", cat: "Dental Ortho" },
//   { name: "Elastic Ligature Ties Assorted", cat: "Dental Ortho" },
//   { name: "Power Chain Elastic", cat: "Dental Ortho" },
//   { name: "Separating Elastics (Orthodontic)", cat: "Dental Ortho" },
//   { name: "Molar Tube (Buccal Tube)", cat: "Dental Ortho" },
//   { name: "Ortho Bracket Adhesive (Light Cure)", cat: "Dental Ortho" },
//   { name: "Band Cement (Glass Ionomer Ortho)", cat: "Dental Ortho" },
//   { name: "Debonding Pliers", cat: "Dental Ortho" },
//   { name: "Ligature Tying Pliers", cat: "Dental Ortho" },
//   { name: "How Pliers", cat: "Dental Ortho" },
//   { name: "Cinching Pliers", cat: "Dental Ortho" },
//   { name: "Wire Cutters (Distal End Cutter)", cat: "Dental Ortho" },
//   { name: "Invisalign Chewies (Aligner Seater)", cat: "Dental Ortho" },
//   { name: "Retainer (Hawley Plate)", cat: "Dental Ortho" },

//   // ── PPE & INFECTION CONTROL ────────────────────────────────────
//   { name: "Nitrile Gloves Small (Powder-Free)", cat: "PPE" },
//   { name: "Nitrile Gloves Medium (Powder-Free)", cat: "PPE" },
//   { name: "Nitrile Gloves Large (Powder-Free)", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 6.5", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 7", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 7.5", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 8", cat: "PPE" },
//   { name: "Examination Gloves (Vinyl) Medium", cat: "PPE" },
//   { name: "3-Ply Surgical Face Mask", cat: "PPE" },
//   { name: "N95 Respirator (NIOSH Approved)", cat: "PPE" },
//   { name: "Surgical Gown (Non-Woven Sterile)", cat: "PPE" },
//   { name: "Disposable Apron (Polythene)", cat: "PPE" },
//   { name: "Shoe Cover (Disposable)", cat: "PPE" },
//   { name: "Head Cover / Surgical Cap", cat: "PPE" },
//   { name: "Face Shield (Dental)", cat: "PPE" },
//   { name: "Safety Goggles", cat: "PPE" },
//   { name: "Bib (Dental Patient)", cat: "Dental Accessory" },
//   { name: "Bib Clips", cat: "Dental Accessory" },
//   { name: "Autoclave Pouches (Self-Seal)", cat: "PPE" },
//   { name: "Sharps Container 5L", cat: "Waste Disposal" },
//   { name: "Sharps Container 1L", cat: "Waste Disposal" },
//   { name: "Biomedical Waste Bag Yellow", cat: "Waste Disposal" },
//   { name: "Biomedical Waste Bag Red", cat: "Waste Disposal" },

//   // ── COMMON OTC / PRESCRIPTION TABLETS ─────────────────────────
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 250mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 100mg/5ml Syrup", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Diclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Aceclofenac + Paracetamol + Serratiopeptidase", cat: "NSAID Combo" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 120mg Tablet", cat: "NSAID" },
//   { name: "Celecoxib 100mg Capsule", cat: "NSAID" },
//   { name: "Celecoxib 200mg Capsule", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Capsule", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   {
//     name: "Trypsin + Chymotrypsin Tablet (Antiflam)",
//     cat: "Enzyme Combination",
//   },
//   { name: "Serratiopeptidase 10mg Tablet", cat: "Enzyme Combination" },
//   { name: "Serratiopeptidase 20mg Tablet", cat: "Enzyme Combination" },
//   { name: "Deflazacort 6mg Tablet", cat: "Steroid" },
//   { name: "Deflazacort 12mg Tablet", cat: "Steroid" },
//   { name: "Deflazacort 30mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 8mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 16mg Tablet", cat: "Steroid" },
//   { name: "Betamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Pantoprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Omeprazole 10mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 40mg Capsule", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 10mg Tablet", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Ranitidine 150mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ranitidine 300mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 4mg/5ml Syrup", cat: "Antiemetic" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Domperidone 1mg/ml Suspension", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Promethazine 10mg Tablet", cat: "Antiemetic / Antihistamine" },
//   { name: "Cetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 5mg/5ml Syrup", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 180mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 2.5mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 4mg Tablet", cat: "Antihistamine" },
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin C 1000mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B Complex + Zinc Capsule", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule", cat: "Vitamin" },
//   { name: "Vitamin D3 1000 IU Tablet", cat: "Vitamin" },
//   { name: "Vitamin E 400mg Capsule", cat: "Vitamin" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Calcium Carbonate 500mg Tablet", cat: "Calcium Supplement" },
//   { name: "Zinc Sulphate 20mg Tablet", cat: "Mineral Supplement" },
//   { name: "Ferrous Sulphate 200mg Tablet", cat: "Iron Supplement" },
//   { name: "Ferrous Ascorbate + Folic Acid Tablet", cat: "Iron Supplement" },

//   // ── TOPICAL MEDICATIONS ────────────────────────────────────────
//   {
//     name: "Triamcinolone Acetonide 0.1% Oral Paste (Kenacort)",
//     cat: "Steroid Topical",
//   },
//   { name: "Triamcinolone Acetonide 0.025% Cream", cat: "Steroid Topical" },
//   { name: "Betamethasone 0.05% Cream", cat: "Steroid Topical" },
//   { name: "Clotrimazole 1% Cream", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin Oral Suspension", cat: "Antifungal" },
//   { name: "Nystatin 100000 IU Tablet", cat: "Antifungal" },
//   { name: "Fluconazole 50mg Tablet", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Tablet", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Mupirocin 2% Ointment (Bactroban)", cat: "Topical Antibiotic" },
//   { name: "Neomycin + Bacitracin Ointment", cat: "Topical Antibiotic" },
//   { name: "Tetracycline 3% Ointment", cat: "Topical Antibiotic" },
//   { name: "Fusidic Acid 2% Cream", cat: "Topical Antibiotic" },
//   { name: "Lignocaine Viscous 2% Mouthwash", cat: "Local Anaesthetic Topical" },
//   {
//     name: "Magic Mouthwash (Lignocaine + Diphenhydramine + Antacid)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Amlexanox 5% Paste (Aphthous Ulcer)", cat: "Oral Care" },
//   { name: "Benzydamine 0.15% Mouthwash (Tantum Verde)", cat: "Oral Care" },
//   { name: "Glycerine + Thymol Mouthwash", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash (Hexetidine 0.1%)", cat: "Dental Antiseptic" },
//   { name: "Listerine Mouthwash (OTC)", cat: "Oral Care" },
//   { name: "Colgate Peroxyl Mouthwash", cat: "Oral Care" },
//   { name: "Orajel (Benzocaine 10%) Topical", cat: "Local Anaesthetic Topical" },
//   { name: "Ulcerex Gel (Choline Salicylate)", cat: "Oral Care" },
//   { name: "Dologel CT (Clove Oil Gel)", cat: "Oral Care" },
//   { name: "Clove Oil (Eugenol)", cat: "Dental Material" },

//   // ── DENTAL IMPLANT MATERIALS ───────────────────────────────────
//   { name: "Titanium Implant Fixture (3.3mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (3.5mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (4.0mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (4.5mm)", cat: "Dental Implant" },
//   { name: "Implant Cover Screw", cat: "Dental Implant" },
//   { name: "Implant Healing Abutment", cat: "Dental Implant" },
//   { name: "Implant Final Abutment", cat: "Dental Implant" },
//   { name: "Implant Impression Coping", cat: "Dental Implant" },
//   { name: "Bone Graft (Autograft)", cat: "Dental Surgical" },
//   { name: "Bone Graft (Xenograft - Bio-Oss)", cat: "Dental Surgical" },
//   { name: "Collagen Membrane (Bio-Gide)", cat: "Dental Surgical" },
//   { name: "PRF (Platelet Rich Fibrin) Kit", cat: "Dental Surgical" },
//   {
//     name: "Haemostatic Agent (Surgicel - Oxidised Cellulose)",
//     cat: "Haemostatic Surgical",
//   },
//   { name: "Haemostatic Foam (Gelfoam)", cat: "Haemostatic" },
//   { name: "Bone Wax", cat: "Haemostatic Surgical" },
//   { name: "Surgical Suction Tip (Frazier)", cat: "Dental Instrument" },

//   // ── LAB INVESTIGATIONS ─────────────────────────────────────────
//   { name: "CBC (Complete Blood Count)", cat: "Lab Test" },
//   { name: "RBS (Random Blood Sugar)", cat: "Lab Test" },
//   { name: "FBS (Fasting Blood Sugar)", cat: "Lab Test" },
//   { name: "HbA1c (Glycated Haemoglobin)", cat: "Lab Test" },
//   { name: "Blood Group & Rh Typing", cat: "Lab Test" },
//   { name: "BT (Bleeding Time) & CT (Clotting Time)", cat: "Lab Test" },
//   { name: "PT/INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "APTT (Activated Partial Thromboplastin Time)", cat: "Lab Test" },
//   { name: "LFT (Liver Function Test)", cat: "Lab Test" },
//   { name: "KFT (Kidney Function Test)", cat: "Lab Test" },
//   { name: "Serum Creatinine", cat: "Lab Test" },
//   { name: "Urine Routine Examination", cat: "Lab Test" },
//   { name: "HBsAg (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HIV (ELISA)", cat: "Lab Test" },
//   { name: "VDRL (Syphilis Test)", cat: "Lab Test" },
//   { name: "Dental Radiograph (IOPA X-ray)", cat: "Dental Investigation" },
//   { name: "Orthopantomogram (OPG) X-ray", cat: "Dental Investigation" },
//   { name: "Lateral Cephalogram X-ray", cat: "Dental Investigation" },
//   {
//     name: "Occlusal X-ray (Maxillary/Mandibular)",
//     cat: "Dental Investigation",
//   },
//   { name: "Bitewing Radiograph", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Dental 3D)", cat: "Dental Investigation" },

//   // ── COMMON BRAND NAMES (INDIA) ─────────────────────────────────
//   {
//     name: "Augmentin 625mg Tablet (Amoxicillin+Clavulanate)",
//     cat: "Antibiotic",
//   },
//   { name: "Azithral 500mg Tablet (Azithromycin)", cat: "Antibiotic" },
//   { name: "Cifran 500mg Tablet (Ciprofloxacin)", cat: "Antibiotic" },
//   { name: "Flagyl 400mg Tablet (Metronidazole)", cat: "Antibiotic" },
//   { name: "Doxy 100mg Capsule (Doxycycline)", cat: "Antibiotic" },
//   { name: "Calpol 650mg Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Dolo 650 Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Combiflam Tablet (Ibuprofen+Paracetamol)", cat: "NSAID Combo" },
//   { name: "Voveran 50mg Tablet (Diclofenac)", cat: "NSAID" },
//   { name: "Brufen 400mg Tablet (Ibuprofen)", cat: "NSAID" },
//   { name: "Ultracet Tablet (Tramadol+Paracetamol)", cat: "Analgesic Combo" },
//   { name: "Pan 40mg Tablet (Pantoprazole)", cat: "Antacid / PPI" },
//   { name: "Omez 20mg Capsule (Omeprazole)", cat: "Antacid / PPI" },
//   { name: "Ondem 4mg Tablet (Ondansetron)", cat: "Antiemetic" },
//   { name: "Stemetil 5mg Tablet (Prochlorperazine)", cat: "Antiemetic" },
//   { name: "Sinarest Tablet (Paracetamol+Phenylephrine)", cat: "Antihistamine" },
//   { name: "Allegra 120mg Tablet (Fexofenadine)", cat: "Antihistamine" },
//   {
//     name: "Montair-LC Tablet (Montelukast+Levocetirizine)",
//     cat: "Antihistamine",
//   },
//   { name: "Calpol Syrup (Paracetamol 120mg)", cat: "Painkiller" },
//   {
//     name: "Pyrimon Syrup (Mefenamic+Paracetamol Paediatric)",
//     cat: "Painkiller",
//   },
//   { name: "Perinorm 10mg Tablet (Metoclopramide)", cat: "Antiemetic" },
//   { name: "Rantac 150mg Tablet (Ranitidine)", cat: "Antacid / H2 Blocker" },
//   { name: "Kenacort Oral Paste (Triamcinolone)", cat: "Steroid Topical" },
//   { name: "Kenalog Injection 40mg (Triamcinolone)", cat: "Steroid Inj" },
//   { name: "Depo-Medrol 40mg Injection", cat: "Steroid Inj" },
//   { name: "Betnesol 0.5mg Tablet (Betamethasone)", cat: "Steroid" },
//   { name: "Wysolone 5mg Tablet (Prednisolone)", cat: "Steroid" },
//   { name: "Defcort 6mg Tablet (Deflazacort)", cat: "Steroid" },
//   { name: "Dexona 0.5mg Tablet (Dexamethasone)", cat: "Steroid" },
//   { name: "Mox 500mg Capsule (Amoxicillin)", cat: "Antibiotic" },
//   { name: "Sporanox 100mg Capsule (Itraconazole)", cat: "Antifungal" },
//   { name: "Zovirax 400mg Tablet (Acyclovir)", cat: "Antiviral" },
//   { name: "Valcivir 500mg Tablet (Valacyclovir)", cat: "Antiviral" },
//   { name: "Neosporin Powder (Neomycin+Bacitracin)", cat: "Topical Antibiotic" },
//   { name: "Betadine Ointment 5%", cat: "Antiseptic Topical" },
//   { name: "Borax Glycerine (Oral Ulcer)", cat: "Oral Care" },
//   { name: "Tantum Verde Mouthwash (Benzydamine)", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Recaldent (CPP-ACP Paste)", cat: "Dental Fluoride" },
//   { name: "Tooth Mousse Plus (GC)", cat: "Dental Fluoride" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Sensodyne Repair & Protect", cat: "Dental Brand" },
//   { name: "Colgate Sensitive Pro-Relief", cat: "Dental Brand" },
//   { name: "Pepsodent Germicheck", cat: "Dental Brand" },
//   { name: "Oral-B Toothbrush Indicator", cat: "Dental Brand" },
//   { name: "GUM Soft-Picks Interdental", cat: "Dental Brand" },
//   { name: "Floss (Oral-B Satin)", cat: "Dental Brand" },
//   { name: "Water Flosser", cat: "Dental Brand" },
//   { name: "Tongue Cleaner (Metal)", cat: "Dental Brand" },
//   { name: "Mouth Guard (Bruxism)", cat: "Dental Brand" },
// ];

// // ── Save a custom medicine — receives apiPost function from component
// // apiPost is api.post from api.js — same URL, same token, guaranteed correct
// function saveCustomMed(name, apiPost) {
//   if (!name || name.trim().length < 3) return Promise.resolve(null);
//   // Must contain at least one letter
//   if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
//   // Skip if already in built-in DB
//   const nameLow = name.trim().toLowerCase();
//   const already = MEDICINE_DB.some((m) => m.name.toLowerCase() === nameLow);
//   if (already) return Promise.resolve(null);
//   // Use api.post — same function used everywhere in this app
//   return apiPost("/custommeds", { name: name.trim(), cat: "Custom" })
//     .then((saved) => saved || null)
//     .catch(() => null);
// }

// // ── Google-style multi-word search — uses combined DB + custom meds from state
// // customMeds is passed in from component state (fetched from backend)
// function googleSearch(query, customMeds = []) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   if (!words.length) return [];

//   // Filter out any malformed entries (no name field)
//   const safeMeds = Array.isArray(customMeds)
//     ? customMeds.filter(
//         (m) => m && typeof m.name === "string" && m.name.trim().length > 0,
//       )
//     : [];

//   const combined = [
//     ...MEDICINE_DB,
//     ...safeMeds.map((m) => ({ ...m, _custom: true })),
//   ];

//   const scored = combined
//     .map((m) => {
//       // Guard against undefined name (safety check)
//       if (!m || typeof m.name !== "string") return { m, score: 0 };
//       const nameLow = m.name.toLowerCase();
//       const catLow = (m.cat || "").toLowerCase();
//       let score = 0;
//       for (const w of words) {
//         if (nameLow.startsWith(w)) score += 5;
//         else if (nameLow.includes(w)) score += 3;
//         else if (catLow.includes(w)) score += 1;
//       }
//       // Boost custom medicines so doctor's own entries appear first
//       if (m._custom) score += 2;
//       return { m, score };
//     })
//     .filter((x) => x.score > 0)
//     .sort((a, b) => b.score - a.score)
//     .map((x) => x.m);

//   return scored.slice(0, 12);
// }

// function highlightWords(text, query) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   let result = text;
//   words.forEach((w) => {
//     const re = new RegExp(
//       "(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
//       "gi",
//     );
//     result = result.replace(re, "<b>$1</b>");
//   });
//   return result;
// }

// // ── RxMedInput — single-line medicine autocomplete for prescription table ──
// // Uses position:fixed for dropdown to escape overflow:hidden containers.
// // FIX: getBoundingClientRect() returns viewport-relative coords.
// // position:fixed is also viewport-relative — so do NOT add window.scrollY/scrollX.
// function RxMedInput({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const inpRef = React.useRef(null);
//   const wrapRef = React.useRef(null);
//   const [sugs, setSugs] = React.useState([]);
//   const [activeIdx, setActive] = React.useState(-1);
//   const [query, setQuery] = React.useState("");
//   const [dropPos, setDropPos] = React.useState({ top: 0, left: 0, width: 0 });

//   const hide = () => {
//     setSugs([]);
//     setActive(-1);
//     setQuery("");
//   };

//   // FIX: position:fixed is viewport-relative — use r.bottom/r.left directly,
//   //      NOT r.bottom + window.scrollY (that caused dropdown to fly off-screen)
//   const calcPos = () => {
//     if (!inpRef.current) return;
//     const r = inpRef.current.getBoundingClientRect();
//     // Flip upward if dropdown would go below viewport
//     const spaceBelow = window.innerHeight - r.bottom;
//     const dropH = Math.min(220, sugs.length * 36);
//     const top =
//       spaceBelow > dropH || spaceBelow > 100
//         ? r.bottom // enough space below: open downward
//         : r.top - dropH; // not enough: open upward
//     setDropPos({ top, left: r.left, width: r.width });
//   };

//   const handleChange = (e) => {
//     const v = e.target.value;
//     onChange(v);
//     if (v.trim().length < 2) {
//       hide();
//       return;
//     }
//     const matches = googleSearch(v, customMeds);
//     if (!matches.length) {
//       hide();
//       return;
//     }
//     setQuery(v);
//     setSugs(matches);
//     setActive(-1);
//     // calcPos called after state update so refs are current
//     requestAnimationFrame(() => {
//       if (!inpRef.current) return;
//       const r = inpRef.current.getBoundingClientRect();
//       const spaceBelow = window.innerHeight - r.bottom;
//       const dropH = Math.min(220, matches.length * 36);
//       const top =
//         spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//       setDropPos({ top, left: r.left, width: r.width });
//     });
//   };

//   const handleKeyDown = (e) => {
//     if (!sugs.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActive((i) => Math.min(i + 1, sugs.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActive((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       sugs[activeIdx]
//     ) {
//       e.preventDefault();
//       select(sugs[activeIdx].name);
//     } else if (e.key === "Escape") {
//       hide();
//     }
//   };

//   const select = (name) => {
//     onChange(name);
//     hide();
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (inpRef.current) inpRef.current.focus();
//     }, 0);
//   };

//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapRef.current && !wrapRef.current.contains(e.target)) hide();
//     };
//     document.addEventListener("mousedown", handler);
//     // Recalculate position on any scroll (modal scroll, page scroll, etc.)
//     const scrollHandler = () => {
//       if (sugs.length > 0) calcPos();
//     };
//     window.addEventListener("scroll", scrollHandler, true);
//     return () => {
//       document.removeEventListener("mousedown", handler);
//       window.removeEventListener("scroll", scrollHandler, true);
//     };
//   }, [sugs.length]);

//   return (
//     <div ref={wrapRef} style={{ position: "relative" }}>
//       <input
//         ref={inpRef}
//         type="text"
//         value={value}
//         onChange={handleChange}
//         onKeyDown={handleKeyDown}
//         placeholder="Type medicine name..."
//         autoComplete="off"
//         style={{
//           width: "100%",
//           border: "1px solid #ddd",
//           borderRadius: 5,
//           padding: "5px 8px",
//           fontSize: 12,
//           fontFamily: "'DM Sans',sans-serif",
//         }}
//       />
//       {sugs.length > 0 && (
//         <div
//           style={{
//             position: "fixed",
//             top: dropPos.top,
//             left: dropPos.left,
//             width: Math.max(dropPos.width, 280),
//             background: "#fff",
//             border: "1.5px solid #0d7377",
//             borderRadius: 8,
//             boxShadow: "0 8px 32px rgba(13,115,119,0.28)",
//             zIndex: 999999,
//             maxHeight: 220,
//             overflowY: "auto",
//             fontFamily: "'DM Sans',sans-serif",
//           }}
//         >
//           {sugs.map((m, i) => (
//             <div
//               key={m.name + i}
//               style={{
//                 padding: "7px 12px",
//                 cursor: "pointer",
//                 fontSize: 12,
//                 background: i === activeIdx ? "#e8f7f7" : "#fff",
//                 borderBottom: "1px solid #f0eeeb",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 8,
//               }}
//               onMouseDown={(e) => {
//                 e.preventDefault();
//                 select(m.name);
//               }}
//               onMouseEnter={() => setActive(i)}
//             >
//               <span style={{ fontSize: 13, opacity: 0.6, flexShrink: 0 }}>
//                 💊
//               </span>
//               <span
//                 style={{ flex: 1, fontWeight: 500 }}
//                 dangerouslySetInnerHTML={{
//                   __html: highlightWords(m.name, query),
//                 }}
//               />
//               <span
//                 style={{
//                   fontSize: 10,
//                   color: "#9a9590",
//                   background: "#f0eeeb",
//                   padding: "1px 6px",
//                   borderRadius: 20,
//                   flexShrink: 0,
//                 }}
//               >
//                 {m.cat}
//               </span>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// // ── MedAutocomplete — Google-style medicine search ───────────
// function MedAutocomplete({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const taRef = React.useRef(null);
//   const wrapperRef = React.useRef(null);
//   const [suggestions, setSuggestions] = React.useState([]);
//   const [activeIdx, setActiveIdx] = React.useState(-1);
//   const [currentQuery, setCurrentQuery] = React.useState("");
//   const queryStartRef = React.useRef(0);
//   const queryEndRef = React.useRef(0);

//   const hideSuggestions = () => {
//     setSuggestions([]);
//     setActiveIdx(-1);
//     setCurrentQuery("");
//   };

//   // Single onChange handler — no onInput conflict
//   const handleChange = (e) => {
//     const ta = e.target;
//     const val = ta.value;
//     const cursor = ta.selectionStart;
//     onChange(val);

//     // Find start of current line/word being typed
//     let lineStart = cursor - 1;
//     while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
//     lineStart++;

//     const query = val.substring(lineStart, cursor);
//     queryStartRef.current = lineStart;
//     queryEndRef.current = cursor;

//     if (query.trim().length < 2) {
//       hideSuggestions();
//       return;
//     }
//     const matches = googleSearch(query, customMeds);
//     if (!matches.length) {
//       hideSuggestions();
//       return;
//     }
//     setCurrentQuery(query);
//     setSuggestions(matches);
//     setActiveIdx(-1);
//   };

//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       suggestions[activeIdx]
//     ) {
//       e.preventDefault();
//       selectMed(suggestions[activeIdx].name);
//     } else if (e.key === "Escape") {
//       hideSuggestions();
//     }
//   };

//   const selectMed = (name) => {
//     const ta = taRef.current;
//     const val = ta.value;
//     const before = val.substring(0, queryStartRef.current);
//     const after = val.substring(queryEndRef.current);
//     const newVal = before + name + after;
//     onChange(newVal);
//     hideSuggestions();
//     // Save to backend using api.post — correct URL guaranteed
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     // Restore cursor position after React re-render
//     setTimeout(() => {
//       if (taRef.current) {
//         const nc = queryStartRef.current + name.length;
//         taRef.current.setSelectionRange(nc, nc);
//         taRef.current.focus();
//         queryEndRef.current = nc;
//       }
//     }, 0);
//   };

//   // On blur — save full meaningful lines typed by doctor as custom medicines
//   const handleBlur = () => {
//     if (!taRef.current) return;
//     const val = taRef.current.value;
//     // Save lines that look like medicine names (>=3 chars, has a letter, not pure numbers)
//     val.split("\n").forEach((line) => {
//       const trimmed = line.trim();
//       if (
//         trimmed.length >= 3 &&
//         /[a-zA-Z]/.test(trimmed) &&
//         !/^[0-9\s]+$/.test(trimmed)
//       ) {
//         saveCustomMed(trimmed, apiPost).then((saved) => {
//           if (saved && onCustomSaved) onCustomSaved(saved);
//         });
//       }
//     });
//   };

//   // Click-outside handler using wrapperRef (not fixed id)
//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
//         hideSuggestions();
//       }
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   return (
//     <>
//       <style>{`
//         .med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}
//         .med-suggestion-item:last-child{border-bottom:none;}
//         .med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}
//         .med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}
//         .med-sug-name{font-weight:500;flex:1;color:#1a1614;}
//         .med-sug-name b{color:#0d7377;font-weight:700;}
//         .med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}
//       `}</style>
//       <div style={{ position: "relative" }} ref={wrapperRef}>
//         <textarea
//           ref={taRef}
//           value={value}
//           onChange={handleChange}
//           onKeyDown={handleKeyDown}
//           onBlur={handleBlur}
//           autoComplete="off"
//           placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
//         />
//         {suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderTop: "none",
//               borderRadius: "0 0 12px 12px",
//               boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
//               zIndex: 99999,
//               maxHeight: 280,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {suggestions.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 className={
//                   "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
//                 }
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   selectMed(m.name);
//                 }}
//               >
//                 <span className="med-sug-icon">💊</span>
//                 <span
//                   className="med-sug-name"
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, currentQuery),
//                   }}
//                 />
//                 <span className="med-sug-cat">{m.cat}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── Prescription Modal — exact original PDF design ────────────
// function PrescriptionModal({ visit, patient, doctor, onClose, showNotify }) {
//   const [pdfUrl, setPdfUrl] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [pdfBlob, setPdfBlob] = useState(null);
//   const [rxMobile, setRxMobile] = useState("");
//   const [fileName, setFileName] = useState("");
//   const [canNativeShare, setCanNativeShare] = useState(false);

//   useEffect(() => {
//     generatePDF();
//   }, []);

//   // Close on Escape
//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     document.addEventListener("keydown", handler);
//     return () => document.removeEventListener("keydown", handler);
//   }, [onClose]);

//   const fmtDateLocal = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr + "T00:00:00");
//     return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
//   };

//   const fmtTimeLocal = (t) => {
//     if (!t) return "";
//     const parts = t.split(":");
//     const hh = parseInt(parts[0]),
//       mm = parts[1];
//     return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
//   };

//   const generatePDF = () => {
//     if (window.jspdf) {
//       buildPDF();
//       return;
//     }
//     const existing = document.getElementById("jspdf-cdn");
//     if (existing) {
//       existing.addEventListener("load", buildPDF);
//       return;
//     }
//     const script = document.createElement("script");
//     script.id = "jspdf-cdn";
//     script.src =
//       "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
//     script.crossOrigin = "anonymous";
//     script.onload = buildPDF;
//     script.onerror = () => setLoading(false);
//     document.head.appendChild(script);
//   };

//   const buildPDF = () => {
//     const { jsPDF } = window.jspdf;
//     const pdf = new jsPDF({
//       unit: "mm",
//       format: "a4",
//       orientation: "portrait",
//     });
//     const W = 210,
//       H = 297;

//     const sf = (c) => pdf.setFillColor(c[0], c[1], c[2]);
//     const sd = (c) => pdf.setDrawColor(c[0], c[1], c[2]);
//     const st = (c) => pdf.setTextColor(c[0], c[1], c[2]);

//     const NAVY = [8, 25, 65],
//       BLUE = [20, 80, 160],
//       BLUE2 = [40, 110, 190];
//     const LBLUE = [210, 228, 248],
//       LBLUE2 = [232, 242, 252],
//       MIDBLUE = [160, 195, 235];
//     const TEAL = [0, 130, 130],
//       TEAL2 = [210, 240, 240];
//     const WHITE = [255, 255, 255],
//       LGRAY = [245, 247, 251],
//       LGRAY2 = [250, 251, 254],
//       LGRAY3 = [240, 243, 248];
//     const GRAY = [115, 118, 130],
//       GRAY2 = [75, 80, 95];
//     const GOLD = [170, 130, 40],
//       GOLD2 = [250, 245, 225];

//     const today = new Date();
//     const todayFmt =
//       today.getDate() +
//       " " +
//       MONTHS[today.getMonth()] +
//       " " +
//       today.getFullYear();
//     const rxNum =
//       "PS-" +
//       today.getFullYear() +
//       ("0" + (today.getMonth() + 1)).slice(-2) +
//       ("0" + today.getDate()).slice(-2) +
//       "-" +
//       Math.floor(1000 + Math.random() * 8999);

//     const visitDate = visit.visitDate || "";
//     const visitTime = visit.visitTime || "";
//     const notes = visit.notes || "";
//     const nextDate = visit.nextVisitDate || "";
//     const service = visit.service || "";
//     const doc = { name: doctor?.name || "Doctor", qual: "", reg: "" };

//     const visitDateFmt = fmtDateLocal(visitDate);
//     const visitTimeFmt = fmtTimeLocal(visitTime);
//     const nextDateFmt = fmtDateLocal(nextDate);

//     // ── Outer border ─────────────────────────────────────────────
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.8);
//     pdf.rect(3.5, 3.5, W - 7, H - 7, "S");
//     sd(LBLUE);
//     pdf.setLineWidth(0.3);
//     pdf.rect(5.5, 5.5, W - 11, H - 11, "S");

//     // ── Header ───────────────────────────────────────────────────
//     sf(NAVY);
//     pdf.rect(3.5, 3.5, W - 7, 46, "F");
//     sf(BLUE);
//     pdf.rect(3.5, 43, W - 7, 10, "F");
//     sf(LBLUE);
//     pdf.rect(3.5, 53, W - 7, 6, "F");

//     st(WHITE);
//     pdf.setFontSize(18);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(doc.name, 14, 19);
//     st(LBLUE);
//     pdf.setFontSize(8);
//     pdf.setFont("helvetica", "normal");
//     pdf.text((doc.qual || "").toUpperCase(), 14, 26);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(14, 28.5, W - 40, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(7);
//     pdf.text("Reg. No.:  " + (doc.reg || "—"), 14, 33.5);
//     pdf.text("Specialisation:  Dental & Oral Health Care", 14, 38.5);

//     st(WHITE);
//     pdf.setFontSize(15);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PEARLSMILE", W - 10, 19, { align: "right" });
//     st(LBLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("DENTAL HOSPITAL", W - 10, 25.5, { align: "right" });
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(W - 72, 28.5, W - 10, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(6.8);
//     pdf.text("12, Dental Plaza, MG Road, Pune - 411001", W - 10, 33.5, {
//       align: "right",
//     });
//     pdf.text("+91 87936 08083  |  care@pearlsmiledental.in", W - 10, 38.5, {
//       align: "right",
//     });

//     st(WHITE);
//     pdf.setFontSize(9);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("DIGITAL PRESCRIPTION", W / 2, 50, { align: "center" });
//     st(LBLUE2);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 10, 50);
//     pdf.text("Date: " + todayFmt, W - 10, 50, { align: "right" });

//     st(BLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PATIENT INFORMATION", W / 2, 57, { align: "center" });

//     // ── Patient info table ────────────────────────────────────────
//     const infoTop = 61;
//     sf(LGRAY3);
//     pdf.rect(10, infoTop, W - 20, 44, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, infoTop, W - 20, 44, "S");
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.2);
//     pdf.line(W / 2, infoTop, W / 2, infoTop + 44);
//     let rdy = infoTop + 11;
//     for (let ri = 0; ri < 3; ri++) {
//       pdf.line(10, rdy, W - 10, rdy);
//       rdy += 11;
//     }

//     const drawCell = (label, value, x, y, maxW) => {
//       st(GRAY2);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.8);
//       pdf.text(label, x + 3, y + 4);
//       st(NAVY);
//       pdf.setFont("helvetica", "normal");
//       pdf.setFontSize(8.5);
//       const val = pdf.splitTextToSize(String(value || "—"), maxW || 75);
//       pdf.text(val[0], x + 3, y + 9.5);
//     };
//     const cHalf = W / 2;
//     drawCell("PATIENT NAME", patient.name || "—", 10, infoTop, cHalf - 16);
//     drawCell("MOBILE", patient.mobile || "—", cHalf, infoTop, cHalf - 16);
//     drawCell("EMAIL", patient.email || "—", 10, infoTop + 11, cHalf - 16);
//     drawCell(
//       "BLOOD GROUP",
//       patient.blood || "—",
//       cHalf,
//       infoTop + 11,
//       cHalf - 16,
//     );
//     drawCell(
//       "AGE / GENDER",
//       (patient.age || "—") + (patient.gender ? "  |  " + patient.gender : ""),
//       10,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell(
//       "VISIT DATE",
//       visitDateFmt + (visitTimeFmt ? " (" + visitTimeFmt + ")" : ""),
//       cHalf,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell("SERVICE/TREATMENT", service || "—", 10, infoTop + 33, cHalf - 16);
//     drawCell(
//       "NEXT VISIT DATE",
//       nextDateFmt || "—",
//       cHalf,
//       infoTop + 33,
//       cHalf - 16,
//     );

//     // ── Prescription Table in PDF (FIRST) ──────────────────────
//     const diagTop = infoTop + 50;
//     const rxRows =
//       visit.prescription && visit.prescription.medicineRows
//         ? visit.prescription.medicineRows.filter(
//             (r) => r.medicine && r.medicine.trim(),
//           )
//         : [];
//     let rxTableEndY = diagTop;
//     if (rxRows.length > 0) {
//       const tTop = diagTop;
//       sf(BLUE);
//       pdf.rect(10, tTop, W - 20, 7, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(7.5);
//       pdf.text("PRESCRIPTION", W / 2, tTop + 5, { align: "center" });
//       const colX = [10, 20, 90, 155, 183];
//       let ry = tTop + 7;
//       sf(LGRAY3);
//       pdf.rect(10, ry, W - 20, 6, "F");
//       [
//         ["SR.", "normal", 6],
//         ["MEDICINE", "bold", 6],
//         ["DOSAGE INSTRUCTION", "normal", 6],
//         ["DURATION", "normal", 6],
//         ["ROUTE", "normal", 6],
//       ].forEach(([h, fw, fs], hi) => {
//         st(GRAY2);
//         pdf.setFont("helvetica", fw);
//         pdf.setFontSize(fs);
//         pdf.text(h, colX[hi] + 1, ry + 4.5);
//       });
//       ry += 6;
//       rxRows.forEach((row, ri) => {
//         sf(ri % 2 === 0 ? LGRAY2 : WHITE);
//         pdf.rect(10, ry, W - 20, 7, "F");
//         sd(LBLUE);
//         pdf.setLineWidth(0.1);
//         pdf.rect(10, ry, W - 20, 7, "S");
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6);
//         pdf.text(String(ri + 1) + ".", colX[0] + 1, ry + 4.5);
//         st(NAVY);
//         pdf.setFont("helvetica", "bold");
//         pdf.setFontSize(7);
//         pdf.text(
//           pdf.splitTextToSize(row.medicine || "", 68)[0] || "",
//           colX[1] + 1,
//           ry + 4.5,
//         );
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6.5);
//         pdf.text(
//           pdf.splitTextToSize(row.dosage || "", 63)[0] || "",
//           colX[2] + 1,
//           ry + 4.5,
//         );
//         pdf.text(row.duration || "", colX[3] + 1, ry + 4.5);
//         pdf.text(row.route || "", colX[4] + 1, ry + 4.5);
//         ry += 7;
//       });
//       rxTableEndY = ry + 4;
//     }

//     // ── Clinical Notes (AFTER Prescription) ──────────────────────
//     const notesTop = rxTableEndY + 4;
//     sf(BLUE);
//     pdf.rect(10, notesTop, W - 20, 8, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(8.5);
//     pdf.text("Rx   CLINICAL NOTES / DIAGNOSIS", 14, notesTop + 5.5);
//     st(GOLD);
//     pdf.setFontSize(10);
//     pdf.text("Rx", W - 16, notesTop + 5.5, { align: "right" });

//     const notesBoxH = 46;
//     sf(LGRAY2);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "S");
//     sd([215, 225, 240]);
//     pdf.setLineWidth(0.15);
//     for (let rl = 0; rl < 6; rl++)
//       pdf.line(14, notesTop + 16 + rl * 7, W - 14, notesTop + 16 + rl * 7);
//     st(NAVY);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(9.5);
//     const noteLines = pdf.splitTextToSize(
//       notes || "No diagnosis or notes recorded for this visit.",
//       W - 30,
//     );
//     pdf.text(noteLines, 14, notesTop + 15);

//     let tableEndY = notesTop + notesBoxH + 8;

//     // ── Next appointment box ──────────────────────────────────────
//     let afterY = tableEndY;
//     if (nextDateFmt) {
//       sf(TEAL2);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "F");
//       sd(TEAL);
//       pdf.setLineWidth(0.4);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "S");
//       sf(TEAL);
//       pdf.roundedRect(10, afterY, 10, 13, 2, 2, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.5);
//       pdf.text("NEXT", 11.2, afterY + 5.5);
//       pdf.text("VISIT", 11.0, afterY + 10);
//       st(TEAL);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(9);
//       pdf.text("Next Appointment:", 24, afterY + 6.5);
//       st(NAVY);
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "bold");
//       pdf.text(nextDateFmt, 72, afterY + 6.5);
//       st(GRAY);
//       pdf.setFontSize(7);
//       pdf.setFont("helvetica", "italic");
//       pdf.text(
//         "Please arrive 10 minutes early and bring this prescription.",
//         24,
//         afterY + 11,
//       );
//       afterY += 19;
//     }

//     // ── General advice box ────────────────────────────────────────
//     const advY = afterY + 4;
//     sf(GOLD2);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "F");
//     sd(GOLD);
//     pdf.setLineWidth(0.35);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "S");
//     sf(GOLD);
//     pdf.roundedRect(10, advY, 10, 20, 2, 2, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(6.2);
//     pdf.text("GEN.", 11.2, advY + 8);
//     pdf.text("ADV.", 11.2, advY + 13.5);
//     st(GOLD);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("General Advice:", 24, advY + 6.5);
//     st(GRAY2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(
//       "1.  Follow all prescribed medicines on time and complete the full course.",
//       24,
//       advY + 11.5,
//     );
//     pdf.text(
//       "2.  Maintain good oral hygiene. Brush gently twice daily.",
//       24,
//       advY + 15.5,
//     );
//     pdf.text(
//       "3.  Avoid very hot, cold, or hard foods until fully healed.",
//       24,
//       advY + 19.2,
//     );

//     // ── Watermark ─────────────────────────────────────────────────
//     pdf.saveGraphicsState();
//     pdf.setGState(new pdf.GState({ opacity: 0.035 }));
//     st(NAVY);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(44);
//     pdf.text("PEARLSMILE", W / 2, H / 2 - 5, { align: "center", angle: 35 });
//     pdf.restoreGraphicsState();

//     // ── Doctor seal ───────────────────────────────────────────────
//     const sigY = Math.max(advY + 28, H - 55);
//     const INK = [28, 52, 140],
//       INK2 = [45, 75, 170];
//     const cx = W - 46,
//       cy = sigY + 13,
//       R = 18;

//     sd(INK);
//     pdf.setLineWidth(1.2);
//     pdf.circle(cx, cy, R, "S");
//     pdf.setLineWidth(0.4);
//     pdf.circle(cx, cy, R - 2.5, "S");

//     const drawStar = (sx, sy, sr) => {
//       const pts = [];
//       for (let si = 0; si < 5; si++) {
//         const ao = (si * 4 * Math.PI) / 5 - Math.PI / 2,
//           ai = ao + (2 * Math.PI) / 5;
//         pts.push({ x: sx + sr * Math.cos(ao), y: sy + sr * Math.sin(ao) });
//         pts.push({
//           x: sx + sr * 0.4 * Math.cos(ai),
//           y: sy + sr * 0.4 * Math.sin(ai),
//         });
//       }
//       pdf.setLineWidth(0.3);
//       sd(INK);
//       sf(INK);
//       pdf.lines(
//         pts.slice(1).map((pt, i) => [pt.x - pts[i].x, pt.y - pts[i].y]),
//         pts[0].x,
//         pts[0].y,
//         [1, 1],
//         "FD",
//         true,
//       );
//     };
//     drawStar(cx - R + 3.5, cy + 1, 2.2);
//     drawStar(cx + R - 3.5, cy + 1, 2.2);

//     const docShort = (doc.name || "Doctor").toUpperCase();
//     sd(INK);
//     st(INK);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(5.8);
//     const topSpan = Math.min(docShort.length * 0.19, 1.3);
//     const topStart = -Math.PI / 2 - topSpan / 2;
//     for (let ti = 0; ti < docShort.length; ti++) {
//       const ta = topStart + (ti / Math.max(docShort.length - 1, 1)) * topSpan;
//       const tx = cx + (R - 1.5) * Math.cos(ta),
//         ty = cy + (R - 1.5) * Math.sin(ta);
//       const trot = ((ta + Math.PI / 2) * 180) / Math.PI;
//       pdf.text(docShort[ti], tx, ty, { align: "center", angle: -trot });
//     }

//     pdf.setFontSize(5.5);
//     const botStr = "PEARLSMILE DENTAL";
//     const botSpan = Math.min(botStr.length * 0.175, 1.4);
//     const botStart = Math.PI / 2 - botSpan / 2;
//     for (let bi = 0; bi < botStr.length; bi++) {
//       const ba = botStart + (bi / Math.max(botStr.length - 1, 1)) * botSpan;
//       const bx = cx + (R - 1.5) * Math.cos(ba),
//         by = cy + (R - 1.5) * Math.sin(ba);
//       const brot = ((ba - Math.PI / 2) * 180) / Math.PI;
//       pdf.text(botStr[bi], bx, by, { align: "center", angle: -brot });
//     }

//     sd(INK);
//     pdf.setLineWidth(0.8);
//     pdf.line(cx, cy - 8, cx, cy + 7);
//     pdf.setLineWidth(0.5);
//     pdf.line(cx, cy - 7.5, cx - 4, cy - 9.5);
//     pdf.line(cx - 4, cy - 9.5, cx - 6, cy - 8);
//     pdf.line(cx - 6, cy - 8, cx - 3, cy - 6.5);
//     pdf.line(cx, cy - 7.5, cx + 4, cy - 9.5);
//     pdf.line(cx + 4, cy - 9.5, cx + 6, cy - 8);
//     pdf.line(cx + 6, cy - 8, cx + 3, cy - 6.5);
//     sf(INK);
//     pdf.circle(cx, cy - 8.2, 1, "F");

//     pdf.setLineWidth(0.6);
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//         [0, -2],
//       ],
//       cx - 3,
//       cy + 5,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [-2, -2],
//         [-2, -2],
//         [0, -2],
//       ],
//       cx + 3,
//       cy + 1,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//       ],
//       cx - 3,
//       cy - 3,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [-2, -2],
//         [-2, -2],
//         [0, -2],
//       ],
//       cx + 3,
//       cy + 5,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//         [0, -2],
//       ],
//       cx - 3,
//       cy + 1,
//       [1, 1],
//       "S",
//     );

//     st(INK);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(4.5);
//     pdf.text("Reg. " + (doc.reg || "—"), cx, cy + R - 5.5, { align: "center" });
//     st(INK2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(6.5);
//     pdf.text("Authorised Signatory", cx, cy + R + 4, { align: "center" });

//     st(GRAY);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 14, sigY + 30);
//     pdf.text("Date: " + todayFmt, W - 14, sigY + 30, { align: "right" });

//     // ── Footer ────────────────────────────────────────────────────
//     sf(NAVY);
//     pdf.rect(3.5, H - 21, W - 7, 17.5, "F");
//     sf(BLUE);
//     pdf.rect(3.5, H - 7, W - 7, 3.5, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(7.5);
//     pdf.text("PearlSmile Dental Hospital", 10, H - 14.5);
//     st(LBLUE);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text("+91 87936 08083", 10, H - 9.5);
//     pdf.text("care@pearlsmiledental.in", W / 2, H - 9.5, { align: "center" });
//     pdf.text("12, Dental Plaza, MG Road, Pune - 411001", W - 10, H - 9.5, {
//       align: "right",
//     });
//     st(LBLUE2);
//     pdf.setFontSize(6);
//     pdf.setFont("helvetica", "italic");
//     pdf.text(
//       "This is a computer-generated prescription from PearlSmile Dental Hospital. Valid only with authorised doctor details.",
//       W / 2,
//       H - 5.5,
//       { align: "center" },
//     );

//     // ── Output ────────────────────────────────────────────────────
//     const blob = pdf.output("blob");
//     const url = URL.createObjectURL(blob);
//     const name =
//       "Prescription_" +
//       (patient.name || "Patient").replace(/\s+/g, "_") +
//       "_" +
//       visitDate +
//       ".pdf";

//     let rawMob = (patient.mobile || "").replace(/[\s\-\(\)\+]/g, "");
//     if (!rawMob.startsWith("91") && rawMob.length === 10)
//       rawMob = "91" + rawMob;

//     setPdfBlob(blob);
//     setPdfUrl(url);
//     setRxMobile(rawMob);
//     setFileName(name);
//     // Show native share button only if Web Share API supports files — exactly like original HTML
//     const testFile = new File([blob], name, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [testFile] })
//     ) {
//       setCanNativeShare(true);
//     }
//     setLoading(false);
//   };

//   const downloadPDF = () => {
//     const link = document.createElement("a");
//     link.href = pdfUrl;
//     link.download = fileName;
//     link.click();
//   };

//   const openFullPreview = () => {
//     if (pdfUrl) window.open(pdfUrl, "_blank");
//   };

//   const shareViaWhatsApp = () => {
//     if (rxMobile) window.open("https://wa.me/" + rxMobile, "_blank");
//     showNotify(
//       "WhatsApp Opened!",
//       "Attach the PDF from the preview and send to patient.",
//     );
//   };

//   const nativeShare = async () => {
//     if (!pdfBlob) return;
//     const file = new File([pdfBlob], fileName, { type: "application/pdf" });
//     // ── Step 1: Auto-download PDF silently so it is in Downloads ────
//     const dlLink = document.createElement("a");
//     dlLink.href = pdfUrl;
//     dlLink.download = fileName;
//     dlLink.click();
//     // ── Step 2: Try native share (mobile) — WhatsApp appears in sheet ──
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [file] })
//     ) {
//       navigator
//         .share({
//           title: "Digital Prescription — PearlSmile Dental Hospital",
//           text: "Dear Patient, please find your digital prescription attached.",
//           files: [file],
//         })
//         .then(() => {
//           showNotify("Sent! ✓", "Prescription shared successfully.");
//           onClose();
//         })
//         .catch((err) => {
//           // If cancelled or failed, open WhatsApp directly with patient number
//           if (err.name !== "AbortError") {
//             if (rxMobile) {
//               const waMsg = encodeURIComponent(
//                 "Dear Patient, your digital prescription has been generated. Please find the PDF file attached.",
//               );
//               window.open(
//                 "https://wa.me/" + rxMobile + "?text=" + waMsg,
//                 "_blank",
//               );
//             }
//           }
//         });
//     } else {
//       // ── Desktop: open WhatsApp directly with patient number ─────────
//       if (rxMobile) {
//         const waMsg = encodeURIComponent(
//           "Dear Patient, your digital prescription has been downloaded. Please check the PDF in your Downloads folder.",
//         );
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" + rxMobile + "?text=" + waMsg,
//               "_blank",
//             ),
//           600,
//         );
//         showNotify(
//           "PDF Downloaded + WhatsApp Opened! ✓",
//           "Prescription saved. WhatsApp opened to patient number.",
//         );
//       } else {
//         showNotify("PDF Downloaded ✓", "Prescription saved. Share manually.");
//       }
//     }
//   };

//   return (
//     <div
//       className="rx-share-overlay open"
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           width: "100%",
//           maxWidth: 540,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//           maxHeight: "92vh",
//         }}
//       >
//         {/* Header */}
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "18px 22px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <span style={{ fontSize: 22 }}>📄</span>
//             <div>
//               <div
//                 style={{
//                   color: "#fff",
//                   fontWeight: 600,
//                   fontSize: 15,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Digital Prescription Ready
//               </div>
//               <div
//                 style={{
//                   color: "rgba(255,255,255,0.55)",
//                   fontSize: 12,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 {patient.name} · {visit.visitDate}
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 17,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             ✕
//           </button>
//         </div>

//         {/* PDF Preview */}
//         <div
//           style={{
//             flex: 1,
//             overflow: "hidden",
//             background: "#f0eeeb",
//             minHeight: 340,
//             position: "relative",
//           }}
//         >
//           {loading && (
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: "#f0eeeb",
//                 gap: 10,
//               }}
//             >
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   border: "3px solid #0d7377",
//                   borderTopColor: "transparent",
//                   borderRadius: "50%",
//                   animation: "spin 0.8s linear infinite",
//                 }}
//               />
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "#5a5550",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Generating PDF…
//               </div>
//             </div>
//           )}
//           {pdfUrl && (
//             <iframe
//               title="prescription"
//               src={pdfUrl}
//               style={{ width: "100%", height: 420, border: "none" }}
//             />
//           )}
//         </div>

//         {/* Action buttons — exactly like original HTML */}
//         <div
//           style={{
//             padding: "16px 20px",
//             display: "flex",
//             flexDirection: "column",
//             gap: 10,
//             background: "#fff",
//           }}
//         >
//           <div style={{ display: "flex", gap: 8 }}>
//             <button
//               onClick={openFullPreview}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//             >
//               🔍 Open Full PDF
//             </button>
//             {canNativeShare && (
//               <button
//                 onClick={nativeShare}
//                 onMouseOver={(e) =>
//                   (e.currentTarget.style.background = "#e5e0d8")
//                 }
//                 onMouseOut={(e) =>
//                   (e.currentTarget.style.background = "#f0eeeb")
//                 }
//                 style={{
//                   flex: 1,
//                   background: "#f0eeeb",
//                   color: "#0a1628",
//                   border: "1.5px solid #ddd9d3",
//                   borderRadius: 10,
//                   padding: 10,
//                   fontSize: 13,
//                   fontWeight: 500,
//                   cursor: "pointer",
//                   fontFamily: "DM Sans,sans-serif",
//                   transition: "background 0.2s",
//                 }}
//               >
//                 📤 Share (Device)
//               </button>
//             )}
//           </div>
//           <p
//             style={{
//               fontSize: 11,
//               color: "#9a9590",
//               textAlign: "center",
//               margin: 0,
//               fontFamily: "DM Sans,sans-serif",
//               lineHeight: 1.5,
//             }}
//           >
//             On mobile: tap "Share (Device)" to send directly via WhatsApp.
//             <br />
//             On desktop: use "Open Full PDF" to view, then share manually.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

//////// last code for opening Patient mobile number////////

// // ============================================================
// // src/components/admin/PatientsTab.js
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import api from "../../utils/api";

// const SERVICES_LIST = [
//   "General Checkup & Cleaning",
//   "Cosmetic Dentistry / Smile Makeover",
//   "Dental Implants",
//   "Orthodontics / Invisalign",
//   "Root Canal Therapy",
//   "Pediatric Dentistry",
//   "Oral Surgery",
//   "Periodontal Treatment",
//   "Teeth Whitening",
//   "Emergency Dental Care",
//   "Follow-Up Visit",
//   "Other",
// ];

// const MONTHS = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];
// const MONTHS_SHORT = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// function fmtDate(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtDateShort(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS_SHORT[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtTime(t) {
//   if (!t) return "";
//   const parts = t.split(":");
//   const hh = parseInt(parts[0]),
//     mm = parts[1];
//   return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
// }

// function totalRevenue(visits = []) {
//   return visits.reduce((sum, v) => {
//     const n = parseFloat((v.amount || "0").toString().replace(/[^0-9.]/g, ""));
//     return sum + (isNaN(n) ? 0 : n);
//   }, 0);
// }

// export default function PatientsTab({ showNotify, doctor }) {
//   const [patients, setPatients] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showNewForm, setShowNewForm] = useState(false);
//   const [newPat, setNewPat] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     age: "",
//     gender: "",
//     blood: "",
//   });
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [rxModal, setRxModal] = useState(null);
//   // Custom medicines — fetched from backend, shared across all doctors/devices
//   const [customMeds, setCustomMeds] = useState([]);

//   const today = new Date().toISOString().split("T")[0];
//   const nowTime = new Date().toTimeString().slice(0, 5);
//   const [visitForm, setVisitForm] = useState({
//     date: today,
//     time: nowTime,
//     service: "",
//     amount: "",
//     nextVisitDate: "",
//     notes: "",
//     rxRows: [
//       {
//         medicine: "",
//         dosageParts: ["0", "0", "0"],
//         dosageTiming: "after meal",
//         dosage: "",
//         duration: "",
//         route: "ORAL",
//       },
//     ],
//   });

//   const loadPatients = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await api.get("/patients");
//       setPatients(data);
//       setFiltered(data);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     loadPatients();
//   }, [loadPatients]);

//   // Fetch custom medicines from backend on mount — shared across all doctors/devices
//   useEffect(() => {
//     api
//       .get("/custommeds")
//       .then((data) => {
//         if (Array.isArray(data)) setCustomMeds(data);
//       })
//       .catch(() => {});
//   }, []);

//   const filterPatients = (q) => {
//     const term = q.toLowerCase();
//     setFiltered(
//       patients.filter(
//         (p) =>
//           (p.name || "").toLowerCase().includes(term) ||
//           (p.mobile || "").includes(term) ||
//           (p.email || "").toLowerCase().includes(term),
//       ),
//     );
//   };

//   const createPatient = async () => {
//     if (!newPat.name.trim()) {
//       showNotify("Error", "Patient name is required.", true);
//       return;
//     }
//     if (!newPat.mobile.trim()) {
//       showNotify("Error", "Mobile number is required.", true);
//       return;
//     }
//     try {
//       await api.post("/patients", newPat);
//       setNewPat({
//         name: "",
//         mobile: "",
//         email: "",
//         age: "",
//         gender: "",
//         blood: "",
//       });
//       setShowNewForm(false);
//       showNotify(
//         "Patient Profile Created! ✓",
//         "New profile for " + newPat.name + " saved.",
//       );
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const openPatient = async (p) => {
//     try {
//       const full = await api.get("/patients/" + p._id);
//       setSelectedPatient(full);
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deletePatient = async () => {
//     if (
//       !window.confirm(
//         "Delete this patient profile and all their records? This cannot be undone.",
//       )
//     )
//       return;
//     try {
//       await api.delete("/patients/" + selectedPatient._id);
//       showNotify("Profile Deleted", "Patient profile removed.");
//       setSelectedPatient(null);
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const saveVisit = async () => {
//     if (!visitForm.date) {
//       showNotify("Missing Fields", "Please select a visit date.", true);
//       return;
//     }
//     if (!visitForm.service) {
//       showNotify("Missing Fields", "Please select a service.", true);
//       return;
//     }
//     try {
//       const payload = {
//         visitDate: visitForm.date,
//         visitTime: visitForm.time,
//         service: visitForm.service,
//         amount: visitForm.amount,
//         nextVisitDate: visitForm.nextVisitDate,
//         notes: visitForm.notes,
//         doctor: doctor?.name || "",
//         prescription: {
//           medicineRows: visitForm.rxRows.filter((r) => r.medicine.trim()),
//         },
//       };
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/visits",
//         payload,
//       );
//       setSelectedPatient(updated);

//       // ── Auto-create appointment for follow-up date ──────────
//       // If nextVisitDate is set → create an upcoming appointment entry
//       // so it appears in Appointments tab → Upcoming Appointments
//       if (visitForm.nextVisitDate && selectedPatient.mobile) {
//         try {
//           await api.post("/appointments", {
//             name: selectedPatient.name,
//             phone: selectedPatient.mobile,
//             service: visitForm.service,
//             date: visitForm.nextVisitDate,
//             time: "",
//             message: "Follow-up visit from Patient Profile",
//             status: "pending",
//           });
//         } catch (_) {
//           // Silently ignore if appointment creation fails
//         }
//       }

//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });

//       // Follow-up WhatsApp if notes contain "follow-up" and nextVisitDate is set
//       const isFollowUp = /follow[\s\-]?up/i.test(visitForm.notes);
//       if (isFollowUp && visitForm.nextVisitDate && selectedPatient.mobile) {
//         let rawMobile = (selectedPatient.mobile || "").replace(
//           /[\s\-\(\)\+]/g,
//           "",
//         );
//         if (!rawMobile.startsWith("91") && rawMobile.length === 10)
//           rawMobile = "91" + rawMobile;
//         const waMsg = `*PearlSmile Dental Hospital* — Follow-Up Reminder\n\nDear ${selectedPatient.name},\nThis is a reminder for your follow-up appointment.\n\n*Service:* ${visitForm.service}\n*Next Visit:* ${fmtDate(visitForm.nextVisitDate)}\n\nPlease call us to confirm your appointment.\n📞 +91 87936 08083`;
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" +
//                 rawMobile +
//                 "?text=" +
//                 encodeURIComponent(waMsg),
//               "_blank",
//             ),
//           500,
//         );
//         showNotify(
//           "Visit Saved + Follow-Up Appointment Created!",
//           "Reminder sent to " +
//             selectedPatient.name +
//             " for " +
//             fmtDate(visitForm.nextVisitDate) +
//             ". Appointment added to Upcoming.",
//         );
//       } else if (visitForm.nextVisitDate) {
//         showNotify(
//           "Visit Saved + Appointment Created! ✓",
//           "Follow-up appointment for " +
//             fmtDate(visitForm.nextVisitDate) +
//             " added to Upcoming Appointments.",
//         );
//       } else {
//         showNotify(
//           "Visit Record Saved! ✓",
//           "Patient visit has been recorded successfully.",
//         );
//       }
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deleteVisit = async (visitId) => {
//     if (!window.confirm("Delete this visit record?")) return;
//     try {
//       const result = await api.delete(
//         "/patients/" + selectedPatient._id + "/visits/" + visitId,
//       );
//       setSelectedPatient(result.patient);
//       showNotify("Visit Deleted", "Visit record removed.");
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const sendPrescription = (visit) => {
//     // Use the doctor who treated the patient (stored in visit.doctor)
//     // not the currently logged-in doctor
//     const treatingDoctor = visit.doctor ? { name: visit.doctor } : doctor;
//     setRxModal({ visit, patient: selectedPatient, doctor: treatingDoctor });
//   };

//   // ── LIST VIEW ─────────────────────────────────────────────────
//   if (!selectedPatient) {
//     return (
//       <div>
//         <div className="admin-section-title">Patient Profiles</div>
//         <div className="admin-section-desc">
//           Create and manage individual patient profiles. Click a profile to view
//           visit history and add new records.
//         </div>

//         <div className="patients-list-view">
//           <input
//             type="text"
//             className="patient-search-bar"
//             placeholder="🔍 Search patients by name or phone..."
//             onChange={(e) => filterPatients(e.target.value)}
//           />

//           {showNewForm && (
//             <div className="new-patient-form">
//               <h4>➕ Create New Patient Profile</h4>
//               <div className="new-patient-grid">
//                 {[
//                   ["name", "text", "Full Name *", "Patient full name"],
//                   ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
//                   ["email", "email", "Email Address", "patient@email.com"],
//                   ["age", "number", "Age", "Age"],
//                 ].map(([k, t, label, ph]) => (
//                   <div key={k}>
//                     <div className="admin-row-label">{label}</div>
//                     <input
//                       type={t}
//                       placeholder={ph}
//                       value={newPat[k]}
//                       onChange={(e) =>
//                         setNewPat((p) => ({ ...p, [k]: e.target.value }))
//                       }
//                     />
//                   </div>
//                 ))}
//                 <div>
//                   <div className="admin-row-label">Gender</div>
//                   <select
//                     value={newPat.gender}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, gender: e.target.value }))
//                     }
//                   >
//                     <option value="">Select Gender</option>
//                     <option>Male</option>
//                     <option>Female</option>
//                     <option>Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <div className="admin-row-label">Blood Group</div>
//                   <input
//                     type="text"
//                     placeholder="e.g. B+"
//                     value={newPat.blood}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, blood: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//               <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                 <button className="add-visit-save-btn" onClick={createPatient}>
//                   💾 Save Patient Profile
//                 </button>
//                 <button
//                   className="btn-back-patients"
//                   onClick={() => setShowNewForm(false)}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           )}

//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: 14,
//               flexWrap: "wrap",
//               gap: 10,
//             }}
//           >
//             <div style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {loading
//                 ? "Loading patients..."
//                 : `${filtered.length} patient profile${filtered.length !== 1 ? "s" : ""}`}
//             </div>
//             <button
//               className="admin-add-btn"
//               onClick={() => setShowNewForm((s) => !s)}
//             >
//               {showNewForm ? "Cancel" : "+ New Patient Profile"}
//             </button>
//           </div>

//           <div className="patient-profiles-grid">
//             {loading ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "20px 0",
//                   gridColumn: "1/-1",
//                 }}
//               >
//                 Loading...
//               </div>
//             ) : filtered.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "24px 0",
//                   gridColumn: "1/-1",
//                   textAlign: "center",
//                 }}
//               >
//                 No patients yet. Click "+ New Patient Profile" to add your first
//                 patient.
//               </div>
//             ) : (
//               filtered.map((p) => (
//                 <div
//                   key={p._id}
//                   className="patient-profile-card"
//                   onClick={() => openPatient(p)}
//                 >
//                   <div className="patient-avatar-icon">🧑‍⚕️</div>
//                   <div className="patient-card-name">{p.name}</div>
//                   <div className="patient-card-id">📞 {p.mobile || "—"}</div>
//                   <div className="patient-card-visits">
//                     📋 {p.visitCount || 0} visit{p.visitCount !== 1 ? "s" : ""}
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ── DETAIL VIEW ───────────────────────────────────────────────
//   const p = selectedPatient;
//   const visits = p.visits || [];
//   const total = totalRevenue(visits);

//   return (
//     <div>
//       <div className="patient-detail-view open">
//         <div className="patient-detail-header">
//           <button
//             className="btn-back-patients"
//             onClick={() => {
//               setSelectedPatient(null);
//             }}
//           >
//             ← Back to Patients
//           </button>
//           <div
//             className="patient-avatar-icon"
//             style={{ width: 56, height: 56, fontSize: 26 }}
//           >
//             🧑‍⚕️
//           </div>
//           <div style={{ flex: 1 }}>
//             <h3>{p.name}</h3>
//             <p style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {p.email}
//               {p.email && p.mobile ? " · " : ""}
//               {p.mobile}
//             </p>
//             <div className="patient-info-row">
//               {[
//                 p.age ? "Age: " + p.age : null,
//                 p.gender || null,
//                 p.blood ? "Blood: " + p.blood : null,
//               ]
//                 .filter(Boolean)
//                 .map((t, i) => (
//                   <span key={i} className="patient-info-pill">
//                     {t}
//                   </span>
//                 ))}
//             </div>
//           </div>
//           <div style={{ textAlign: "right", flexShrink: 0 }}>
//             <div
//               style={{
//                 fontSize: 11,
//                 color: "var(--gray-400)",
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//                 marginBottom: 4,
//               }}
//             >
//               Total Revenue
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 26,
//                 fontWeight: 600,
//                 color: "var(--teal)",
//                 lineHeight: 1,
//               }}
//             >
//               Rs. {total.toLocaleString("en-IN")}
//             </div>
//             <div
//               style={{ fontSize: 11, color: "var(--gray-400)", marginTop: 2 }}
//             >
//               {visits.length} visit{visits.length !== 1 ? "s" : ""}
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 8,
//               alignSelf: "flex-start",
//               marginTop: 4,
//             }}
//           >
//             <button className="admin-del-btn" onClick={deletePatient}>
//               🗑️ Delete Profile
//             </button>
//           </div>
//         </div>

//         {/* Add Visit Form — original simple layout */}
//         <div className="add-visit-form">
//           <h4>📋 Add New Visit Record</h4>
//           <div className="add-visit-grid">
//             <div>
//               <div className="admin-row-label">Visit Date *</div>
//               <input
//                 type="date"
//                 value={visitForm.date}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, date: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Visit Time</div>
//               <input
//                 type="time"
//                 value={visitForm.time}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, time: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Service Taken *</div>
//               <select
//                 value={visitForm.service}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, service: e.target.value }))
//                 }
//               >
//                 <option value="">Select Service</option>
//                 {SERVICES_LIST.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <div className="admin-row-label">Amount Charged (Rs.)</div>
//               <input
//                 type="text"
//                 placeholder="e.g. 2500"
//                 value={visitForm.amount}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, amount: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div
//                 className="admin-row-label"
//                 style={{ display: "flex", alignItems: "center", gap: 6 }}
//               >
//                 Next Date to Visit
//                 <span
//                   style={{
//                     fontSize: 10,
//                     color: "var(--teal)",
//                     fontWeight: 400,
//                     background: "rgba(13,115,119,0.08)",
//                     padding: "2px 8px",
//                     borderRadius: 100,
//                     border: "1px solid rgba(13,115,119,0.2)",
//                   }}
//                 >
//                   For follow-up
//                 </span>
//               </div>
//               <input
//                 type="date"
//                 value={visitForm.nextVisitDate}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, nextVisitDate: e.target.value }))
//                 }
//                 style={{ marginTop: 6 }}
//               />
//             </div>
//           </div>
//           {/* ── Prescription Table ─────────────────────────── */}
//           <style>{`
//             @media (max-width: 640px) {
//               .rx-table-desktop { display: none !important; }
//               .rx-card-mobile { display: block !important; }
//             }
//             @media (min-width: 641px) {
//               .rx-table-desktop { display: block !important; }
//               .rx-card-mobile { display: none !important; }
//             }
//           `}</style>
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 8 }}
//           >
//             💊 Prescription
//           </div>

//           {/* ── DESKTOP TABLE ── */}
//           <div
//             className="rx-table-desktop"
//             style={{
//               overflowX: "auto",
//               marginBottom: 8,
//               position: "relative",
//               zIndex: 1000,
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: 13,
//                 fontFamily: "'DM Sans',sans-serif",
//                 minWidth: 560,
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                     color: "#fff",
//                   }}
//                 >
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 36,
//                     }}
//                   >
//                     SR.
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     MEDICINE
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     DOSAGE INSTRUCTION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     DURATION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     ROUTE
//                   </th>
//                   <th style={{ padding: "8px 10px", width: 32 }}></th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {visitForm.rxRows.map((row, idx) => (
//                   <tr
//                     key={idx}
//                     style={{
//                       background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                       borderBottom: "1px solid #e8e4e0",
//                     }}
//                   >
//                     <td
//                       style={{
//                         padding: "6px 10px",
//                         color: "#666",
//                         fontSize: 12,
//                         textAlign: "center",
//                       }}
//                     >
//                       {idx + 1}
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <RxMedInput
//                         value={row.medicine}
//                         onChange={(v) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], medicine: v };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         customMeds={customMeds}
//                         apiPost={api.post}
//                         onCustomSaved={(saved) => {
//                           if (saved && saved._id) {
//                             setCustomMeds((prev) => {
//                               const exists = prev.some(
//                                 (m) =>
//                                   m._id === saved._id ||
//                                   m.name.toLowerCase() ===
//                                     saved.name.toLowerCase(),
//                               );
//                               if (exists) return prev;
//                               return [saved, ...prev];
//                             });
//                           } else {
//                             api
//                               .get("/custommeds")
//                               .then((data) => {
//                                 if (Array.isArray(data)) setCustomMeds(data);
//                               })
//                               .catch(() => {});
//                           }
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                           flexWrap: "nowrap",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 2,
//                           }}
//                         >
//                           {["M", "A", "N"].map((label, li) => (
//                             <div
//                               key={label}
//                               style={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   fontSize: 9,
//                                   color: "#888",
//                                   marginBottom: 1,
//                                 }}
//                               >
//                                 {label}
//                               </span>
//                               <input
//                                 type="text"
//                                 maxLength={2}
//                                 value={
//                                   (row.dosageParts || ["0", "0", "0"])[li] ||
//                                   "0"
//                                 }
//                                 onFocus={(e) => {
//                                   if (e.target.value === "0") e.target.select();
//                                 }}
//                                 onChange={(e) => {
//                                   const rows = [...visitForm.rxRows];
//                                   const parts = [
//                                     ...(rows[idx].dosageParts || [
//                                       "0",
//                                       "0",
//                                       "0",
//                                     ]),
//                                   ];
//                                   parts[li] =
//                                     e.target.value === ""
//                                       ? "0"
//                                       : e.target.value;
//                                   rows[idx] = {
//                                     ...rows[idx],
//                                     dosageParts: parts,
//                                     dosage:
//                                       parts.join("-") +
//                                       (rows[idx].dosageTiming
//                                         ? " " + rows[idx].dosageTiming
//                                         : ""),
//                                   };
//                                   setVisitForm((f) => ({ ...f, rxRows: rows }));
//                                 }}
//                                 style={{
//                                   width: 28,
//                                   border: "1px solid #ddd",
//                                   borderRadius: 4,
//                                   padding: "4px 3px",
//                                   fontSize: 12,
//                                   textAlign: "center",
//                                   fontFamily: "'DM Sans',sans-serif",
//                                 }}
//                               />
//                             </div>
//                           ))}
//                         </div>
//                         <select
//                           value={row.dosageTiming || "after meal"}
//                           onChange={(e) => {
//                             const rows = [...visitForm.rxRows];
//                             const parts = rows[idx].dosageParts || [
//                               "0",
//                               "0",
//                               "0",
//                             ];
//                             rows[idx] = {
//                               ...rows[idx],
//                               dosageTiming: e.target.value,
//                               dosage: parts.join("-") + " " + e.target.value,
//                             };
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             border: "1px solid #ddd",
//                             borderRadius: 4,
//                             padding: "4px 5px",
//                             fontSize: 11,
//                             fontFamily: "'DM Sans',sans-serif",
//                             color: "#444",
//                           }}
//                         >
//                           <option>after meal</option>
//                           <option>before meal</option>
//                           <option>with meal</option>
//                           <option>empty stomach</option>
//                           <option>at bedtime</option>
//                           <option>as directed</option>
//                         </select>
//                       </div>
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <input
//                         type="text"
//                         placeholder="e.g. 7 days"
//                         value={row.duration}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = {
//                             ...rows[idx],
//                             duration: e.target.value,
//                           };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 8px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <select
//                         value={row.route}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], route: e.target.value };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 6px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       >
//                         <option>ORAL</option>
//                         <option>TOPICAL</option>
//                         <option>INJECTION</option>
//                         <option>INHALER</option>
//                         <option>DROPS</option>
//                         <option>GARGLE</option>
//                         <option>OTHER</option>
//                       </select>
//                     </td>
//                     <td style={{ padding: "4px 6px", textAlign: "center" }}>
//                       {visitForm.rxRows.length > 1 && (
//                         <button
//                           onClick={() => {
//                             const rows = visitForm.rxRows.filter(
//                               (_, i) => i !== idx,
//                             );
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             background: "none",
//                             border: "none",
//                             color: "#e74c3c",
//                             fontSize: 16,
//                             cursor: "pointer",
//                             padding: "2px 6px",
//                           }}
//                           title="Remove"
//                         >
//                           ✕
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* ── MOBILE CARDS ── */}
//           <div className="rx-card-mobile" style={{ marginBottom: 8 }}>
//             {visitForm.rxRows.map((row, idx) => (
//               <div
//                 key={idx}
//                 style={{
//                   background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                   border: "1px solid #e8e4e0",
//                   borderRadius: 8,
//                   padding: "10px 12px",
//                   marginBottom: 8,
//                   position: "relative",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: 8,
//                   }}
//                 >
//                   <span
//                     style={{
//                       fontSize: 11,
//                       fontWeight: 700,
//                       color: "#0a1628",
//                       background: "rgba(10,22,40,0.08)",
//                       padding: "2px 8px",
//                       borderRadius: 20,
//                     }}
//                   >
//                     #{idx + 1}
//                   </span>
//                   {visitForm.rxRows.length > 1 && (
//                     <button
//                       onClick={() => {
//                         const rows = visitForm.rxRows.filter(
//                           (_, i) => i !== idx,
//                         );
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         background: "none",
//                         border: "none",
//                         color: "#e74c3c",
//                         fontSize: 16,
//                         cursor: "pointer",
//                         padding: "2px 6px",
//                       }}
//                       title="Remove"
//                     >
//                       ✕
//                     </button>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Medicine
//                   </div>
//                   <RxMedInput
//                     value={row.medicine}
//                     onChange={(v) => {
//                       const rows = [...visitForm.rxRows];
//                       rows[idx] = { ...rows[idx], medicine: v };
//                       setVisitForm((f) => ({ ...f, rxRows: rows }));
//                     }}
//                     customMeds={customMeds}
//                     apiPost={api.post}
//                     onCustomSaved={(saved) => {
//                       if (saved && saved._id) {
//                         setCustomMeds((prev) => {
//                           const exists = prev.some(
//                             (m) =>
//                               m._id === saved._id ||
//                               m.name.toLowerCase() === saved.name.toLowerCase(),
//                           );
//                           if (exists) return prev;
//                           return [saved, ...prev];
//                         });
//                       } else {
//                         api
//                           .get("/custommeds")
//                           .then((data) => {
//                             if (Array.isArray(data)) setCustomMeds(data);
//                           })
//                           .catch(() => {});
//                       }
//                     }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Dosage Instruction
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 6,
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <div
//                       style={{ display: "flex", alignItems: "center", gap: 4 }}
//                     >
//                       {["M", "A", "N"].map((label, li) => (
//                         <div
//                           key={label}
//                           style={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                           }}
//                         >
//                           <span
//                             style={{
//                               fontSize: 9,
//                               color: "#888",
//                               marginBottom: 1,
//                             }}
//                           >
//                             {label}
//                           </span>
//                           <input
//                             type="text"
//                             maxLength={2}
//                             value={
//                               (row.dosageParts || ["0", "0", "0"])[li] || "0"
//                             }
//                             onFocus={(e) => {
//                               if (e.target.value === "0") e.target.select();
//                             }}
//                             onChange={(e) => {
//                               const rows = [...visitForm.rxRows];
//                               const parts = [
//                                 ...(rows[idx].dosageParts || ["0", "0", "0"]),
//                               ];
//                               parts[li] =
//                                 e.target.value === "" ? "0" : e.target.value;
//                               rows[idx] = {
//                                 ...rows[idx],
//                                 dosageParts: parts,
//                                 dosage:
//                                   parts.join("-") +
//                                   (rows[idx].dosageTiming
//                                     ? " " + rows[idx].dosageTiming
//                                     : ""),
//                               };
//                               setVisitForm((f) => ({ ...f, rxRows: rows }));
//                             }}
//                             style={{
//                               width: 34,
//                               border: "1px solid #ddd",
//                               borderRadius: 4,
//                               padding: "5px 3px",
//                               fontSize: 13,
//                               textAlign: "center",
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                     <select
//                       value={row.dosageTiming || "after meal"}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         const parts = rows[idx].dosageParts || ["0", "0", "0"];
//                         rows[idx] = {
//                           ...rows[idx],
//                           dosageTiming: e.target.value,
//                           dosage: parts.join("-") + " " + e.target.value,
//                         };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         flex: 1,
//                         border: "1px solid #ddd",
//                         borderRadius: 4,
//                         padding: "5px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         color: "#444",
//                         minWidth: 120,
//                       }}
//                     >
//                       <option>after meal</option>
//                       <option>before meal</option>
//                       <option>with meal</option>
//                       <option>empty stomach</option>
//                       <option>at bedtime</option>
//                       <option>as directed</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div style={{ display: "flex", gap: 8 }}>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Duration
//                     </div>
//                     <input
//                       type="text"
//                       placeholder="e.g. 7 days"
//                       value={row.duration}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], duration: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 8px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         boxSizing: "border-box",
//                       }}
//                     />
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Route
//                     </div>
//                     <select
//                       value={row.route}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], route: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                       }}
//                     >
//                       <option>ORAL</option>
//                       <option>TOPICAL</option>
//                       <option>INJECTION</option>
//                       <option>INHALER</option>
//                       <option>DROPS</option>
//                       <option>GARGLE</option>
//                       <option>OTHER</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button
//             onClick={() =>
//               setVisitForm((f) => ({
//                 ...f,
//                 rxRows: [
//                   ...f.rxRows,
//                   {
//                     medicine: "",
//                     dosageParts: ["0", "0", "0"],
//                     dosageTiming: "after meal",
//                     dosage: "",
//                     duration: "",
//                     route: "ORAL",
//                   },
//                 ],
//               }))
//             }
//             style={{
//               marginTop: 4,
//               marginBottom: 8,
//               background: "rgba(13,115,119,0.08)",
//               border: "1px solid rgba(13,115,119,0.3)",
//               color: "var(--teal)",
//               borderRadius: 7,
//               padding: "6px 16px",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             + Add Medicine
//           </button>

//           {/* ── Doctor Notes / Diagnosis ───────────────────────── */}
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 10 }}
//           >
//             Doctor Notes / Diagnosis
//           </div>
//           <MedAutocomplete
//             value={visitForm.notes}
//             onChange={(v) => setVisitForm((f) => ({ ...f, notes: v }))}
//             customMeds={customMeds}
//             apiPost={api.post}
//             onCustomSaved={(saved) => {
//               if (saved && saved._id) {
//                 // Add to local state immediately so suggestion appears right away
//                 setCustomMeds((prev) => {
//                   const exists = prev.some(
//                     (m) =>
//                       m._id === saved._id ||
//                       m.name.toLowerCase() === saved.name.toLowerCase(),
//                   );
//                   if (exists) return prev;
//                   return [saved, ...prev];
//                 });
//               } else {
//                 // Fallback refetch if saved object not returned
//                 api
//                   .get("/custommeds")
//                   .then((data) => {
//                     if (Array.isArray(data)) setCustomMeds(data);
//                   })
//                   .catch(() => {});
//               }
//             }}
//           />
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               flexWrap: "wrap",
//               gap: 10,
//               marginTop: 4,
//             }}
//           >
//             <button className="add-visit-save-btn" onClick={saveVisit}>
//               💾 Save Visit Record
//             </button>
//           </div>
//         </div>

//         {/* Visit History */}
//         <div style={{ marginBottom: 12 }}>
//           <div className="admin-section-title" style={{ marginBottom: 8 }}>
//             Visit History
//           </div>
//           <div className="visit-records-list">
//             {visits.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 13,
//                   padding: "10px 0",
//                 }}
//               >
//                 No visits recorded yet. Add the first visit above.
//               </div>
//             ) : (
//               visits.map((v, i) => {
//                 const dtStr =
//                   (v.visitDate || "") +
//                   (v.visitTime ? " at " + v.visitTime : "");
//                 const isFollowUp = /follow[\s\-]?up/i.test(v.notes || "");
//                 return (
//                   <div key={v._id || i} className="visit-record-card">
//                     <button
//                       className="visit-del-btn"
//                       onClick={() => deleteVisit(v._id)}
//                       title="Delete"
//                     >
//                       ✕
//                     </button>
//                     <div className="visit-record-meta">
//                       <span className="visit-record-service">
//                         {v.service || "Visit"}
//                       </span>
//                       <span className="visit-record-date">📅 {dtStr}</span>
//                       {v.amount && (
//                         <span
//                           className="patient-info-pill"
//                           style={{ fontSize: 11 }}
//                         >
//                           Rs. {v.amount}
//                         </span>
//                       )}
//                       {v.doctor && (
//                         <span
//                           style={{
//                             fontSize: 11,
//                             color: "var(--teal)",
//                             fontWeight: 600,
//                             background: "rgba(13,115,119,0.08)",
//                             padding: "2px 8px",
//                             borderRadius: 100,
//                             border: "1px solid rgba(13,115,119,0.2)",
//                           }}
//                         >
//                           👨‍⚕️ {v.doctor}
//                         </span>
//                       )}
//                     </div>
//                     <div className="visit-record-notes">{v.notes || "—"}</div>
//                     {v.prescription &&
//                       v.prescription.medicineRows &&
//                       v.prescription.medicineRows.length > 0 && (
//                         <div style={{ marginTop: 10, overflowX: "auto" }}>
//                           <table
//                             style={{
//                               width: "100%",
//                               borderCollapse: "collapse",
//                               fontSize: 12,
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           >
//                             <thead>
//                               <tr
//                                 style={{
//                                   background:
//                                     "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                                   color: "#fff",
//                                 }}
//                               >
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 30,
//                                   }}
//                                 >
//                                   SR.
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   MEDICINE
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   DOSAGE INSTRUCTION
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 90,
//                                   }}
//                                 >
//                                   DUR. / ROUTE
//                                 </th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {v.prescription.medicineRows.map((row, ri) => (
//                                 <tr
//                                   key={ri}
//                                   style={{
//                                     background:
//                                       ri % 2 === 0 ? "#f8f9fc" : "#fff",
//                                     borderBottom: "1px solid #e8e4e0",
//                                   }}
//                                 >
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                       textAlign: "center",
//                                     }}
//                                   >
//                                     {ri + 1}.
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       fontWeight: 600,
//                                       color: "#0a1628",
//                                     }}
//                                   >
//                                     {row.medicine || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#444",
//                                     }}
//                                   >
//                                     {row.dosage || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                     }}
//                                   >
//                                     {row.duration}
//                                     {row.duration && row.route ? " / " : ""}
//                                     {row.route}
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       )}
//                     {v.nextVisitDate && (
//                       <div
//                         style={{
//                           marginTop: 8,
//                           display: "inline-flex",
//                           alignItems: "center",
//                           gap: 6,
//                           background: isFollowUp
//                             ? "rgba(201,168,76,0.12)"
//                             : "rgba(13,115,119,0.08)",
//                           border:
//                             "1px solid " +
//                             (isFollowUp
//                               ? "rgba(201,168,76,0.35)"
//                               : "rgba(13,115,119,0.2)"),
//                           borderRadius: 100,
//                           padding: "3px 12px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           color: isFollowUp ? "#8b6914" : "var(--teal)",
//                         }}
//                       >
//                         {isFollowUp ? "Follow-Up: " : "Next Visit: "}
//                         {fmtDateShort(v.nextVisitDate)}
//                         {isFollowUp ? " — WhatsApp sent" : ""}
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 8,
//                         marginTop: 10,
//                         flexWrap: "wrap",
//                       }}
//                     >
//                       <button
//                         onClick={() => sendPrescription(v)}
//                         style={{
//                           background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Send Prescription
//                       </button>
//                       <button
//                         onClick={() => {
//                           let mob = (p.mobile || "").replace(
//                             /[\s\-\(\)\+]/g,
//                             "",
//                           );
//                           if (!mob) {
//                             alert("No mobile number saved for this patient.");
//                             return;
//                           }
//                           if (!mob.startsWith("91") && mob.length === 10)
//                             mob = "91" + mob;
//                           const msg = encodeURIComponent(
//                             ` *Welcome to PearlSmile Dental Hospital!*\n\n` +
//                               `Dear ${p.name},\n\n` +
//                               `We warmly welcome you to our family. It is a pleasure to have you with us.\n\n` +
//                               `We are committed to providing you the best dental care and a comfortable experience throughout your journey with us.\n\n` +
//                               `_Wishing you great health and a beautiful smile!_\n` +
//                               `— *PearlSmile Dental Hospital Team*`,
//                           );
//                           window.open(
//                             "https://wa.me/" + mob + "?text=" + msg,
//                             "_blank",
//                           );
//                         }}
//                         style={{
//                           background: "linear-gradient(135deg,#25d366,#128c7e)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Patient Number
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>
//       </div>

//       {rxModal && (
//         <PrescriptionModal
//           visit={rxModal.visit}
//           patient={rxModal.patient}
//           doctor={rxModal.doctor}
//           onClose={() => setRxModal(null)}
//           showNotify={showNotify}
//         />
//       )}
//     </div>
//   );
// }

// // ── Medicine Database — 1500+ entries (India: dental + clinical + surgical) ──
// const MEDICINE_DB = [
//   // ── ANTIBIOTICS ──────────────────────────────────────────────
//   { name: "Amoxicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 875mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin 125mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin 250mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 375mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 625mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 1000mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 228.5mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Azithromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Clindamycin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 600mg Injection", cat: "Antibiotic Inj" },
//   { name: "Metronidazole 200mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 400mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Infusion", cat: "Antibiotic Inj" },
//   { name: "Ciprofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 750mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 200mg/100ml Infusion", cat: "Antibiotic Inj" },
//   { name: "Doxycycline 100mg Capsule", cat: "Antibiotic" },
//   { name: "Doxycycline 200mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Tinidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ornidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Secnidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Co-Amoxiclav 375mg Tablet", cat: "Antibiotic" },
//   { name: "Co-Amoxiclav 625mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 750mg Tablet", cat: "Antibiotic" },
//   { name: "Ofloxacin 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ofloxacin 400mg Tablet", cat: "Antibiotic" },
//   { name: "Cephalexin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Cephalexin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Cefixime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 400mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 50mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Cefuroxime 250mg Tablet", cat: "Antibiotic" },
//   { name: "Cefuroxime 500mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ceftriaxone 250mg Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 2g Injection", cat: "Antibiotic Inj" },
//   { name: "Amikacin 250mg Injection", cat: "Antibiotic Inj" },
//   { name: "Amikacin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Gentamicin 40mg Injection", cat: "Antibiotic Inj" },
//   { name: "Gentamicin 80mg Injection", cat: "Antibiotic Inj" },
//   { name: "Vancomycin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Vancomycin 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Meropenem 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Meropenem 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Piperacillin + Tazobactam 4.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Imipenem + Cilastatin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Linezolid 600mg Tablet", cat: "Antibiotic" },
//   { name: "Linezolid 600mg Infusion", cat: "Antibiotic Inj" },
//   { name: "Colistin 1 MU Injection", cat: "Antibiotic Inj" },
//   { name: "Tetracycline 250mg Capsule", cat: "Antibiotic" },
//   { name: "Tetracycline 500mg Capsule", cat: "Antibiotic" },
//   { name: "Chloramphenicol 250mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin + Sulbactam 1.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Nitrofurantoin 50mg Capsule", cat: "Antibiotic" },
//   { name: "Nitrofurantoin 100mg Capsule", cat: "Antibiotic" },
//   { name: "Norfloxacin 400mg Tablet", cat: "Antibiotic" },
//   { name: "Trimethoprim + Sulfamethoxazole 480mg Tablet", cat: "Antibiotic" },
//   { name: "Trimethoprim + Sulfamethoxazole 960mg Tablet", cat: "Antibiotic" },
//   { name: "Cefoperazone + Sulbactam 1.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Cefoperazone + Sulbactam 3g Injection", cat: "Antibiotic Inj" },
//   { name: "Ertapenem 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Tigecycline 50mg Injection", cat: "Antibiotic Inj" },
//   { name: "Fosfomycin 3g Sachet", cat: "Antibiotic" },
//   { name: "Rifampicin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Rifampicin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Isoniazid 100mg Tablet", cat: "Antibiotic" },
//   { name: "Isoniazid 300mg Tablet", cat: "Antibiotic" },
//   { name: "Pyrazinamide 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ethambutol 400mg Tablet", cat: "Antibiotic" },
//   { name: "Streptomycin 1g Injection", cat: "Antibiotic Inj" },
//   // ── PAIN KILLERS / NSAIDS ────────────────────────────────────
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 250mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 150mg/ml Drops", cat: "Painkiller" },
//   { name: "Paracetamol 500mg/100ml Infusion", cat: "Painkiller Inj" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 100mg/5ml Syrup", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Injection", cat: "NSAID Inj" },
//   { name: "Ketorolac 10mg Tablet", cat: "NSAID" },
//   { name: "Ketorolac 30mg Injection", cat: "NSAID Inj" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Piroxicam 10mg Tablet", cat: "NSAID" },
//   { name: "Piroxicam 20mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 120mg Tablet", cat: "NSAID" },
//   { name: "Celecoxib 100mg Capsule", cat: "NSAID" },
//   { name: "Celecoxib 200mg Capsule", cat: "NSAID" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol 100mg SR Tablet", cat: "Opioid Analgesic" },
//   { name: "Tramadol 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Morphine 10mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Morphine 15mg Tablet", cat: "Opioid Analgesic" },
//   { name: "Fentanyl 50mcg/ml Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pentazocine 30mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pethidine 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Buprenorphine 0.3mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Tapentadol 50mg Tablet", cat: "Opioid Analgesic" },
//   { name: "Tapentadol 100mg Tablet", cat: "Opioid Analgesic" },
//   // ── LOCAL ANAESTHETICS — DENTAL ─────────────────────────────
//   { name: "Lignocaine 2% Dental Cartridge (1.8ml)", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine + Adrenaline 2% Dental Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% Heavy Spinal Injection", cat: "Local Anaesthetic" },
//   { name: "Mepivacaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Prilocaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Lignocaine 2% Plain Injection 30ml Vial", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine 2% + Adrenaline Injection Vial",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Lignocaine 10% Topical Spray", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 2% Viscous Gel", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 5% Ointment", cat: "Local Anaesthetic Topical" },
//   { name: "Benzocaine 20% Topical Gel", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lignocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine Jelly 2%", cat: "Local Anaesthetic Topical" },
//   { name: "Ropivacaine 0.2% Injection", cat: "Local Anaesthetic" },
//   { name: "Ropivacaine 0.75% Injection", cat: "Local Anaesthetic" },
//   {
//     name: "Tetracaine (Amethocaine) Eye Drops",
//     cat: "Local Anaesthetic Topical",
//   },
//   // ── GENERAL ANAESTHESIA ─────────────────────────────────────
//   { name: "Propofol 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 500mg Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Thiopentone Sodium 500mg Injection", cat: "General Anaesthesia" },
//   { name: "Midazolam 1mg/ml Injection", cat: "Sedative / Anaesthesia" },
//   { name: "Midazolam 5mg/ml Injection", cat: "Sedative / Anaesthesia" },
//   { name: "Midazolam 7.5mg Tablet", cat: "Sedative" },
//   { name: "Isoflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Sevoflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Desflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Nitrous Oxide Gas", cat: "Inhalation Anaesthetic" },
//   { name: "Oxygen Gas Cylinder", cat: "Medical Gas" },
//   { name: "Succinylcholine 100mg Injection", cat: "Muscle Relaxant" },
//   { name: "Vecuronium 4mg Injection", cat: "Muscle Relaxant" },
//   { name: "Atracurium 25mg Injection", cat: "Muscle Relaxant" },
//   { name: "Rocuronium 50mg Injection", cat: "Muscle Relaxant" },
//   { name: "Neostigmine 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Atropine 0.6mg Injection", cat: "Anticholinergic" },
//   { name: "Glycopyrrolate 0.2mg Injection", cat: "Anticholinergic" },
//   // ── STEROIDS / ANTI-INFLAMMATORY ────────────────────────────
//   { name: "Dexamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Betamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 40mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 16mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 40mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 125mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone 10mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone Acetonide 0.1% Oral Paste", cat: "Steroid Topical" },
//   { name: "Kenacort 0.1% Dental Paste", cat: "Steroid Topical" },
//   { name: "Betamethasone Gel Oral 0.025%", cat: "Steroid Topical" },
//   // ── ANTIFUNGALS ─────────────────────────────────────────────
//   { name: "Fluconazole 50mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 2mg/ml Infusion", cat: "Antifungal Inj" },
//   { name: "Itraconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Voriconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Amphotericin B 50mg Injection", cat: "Antifungal Inj" },
//   { name: "Clotrimazole 1% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin 100000 IU/ml Oral Drops", cat: "Antifungal" },
//   { name: "Nystatin 500000 IU Tablet", cat: "Antifungal" },
//   { name: "Clotrimazole + Betamethasone Cream", cat: "Antifungal Topical" },
//   { name: "Ketoconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Ketoconazole 2% Shampoo", cat: "Antifungal Topical" },
//   { name: "Terbinafine 250mg Tablet", cat: "Antifungal" },
//   // ── ANTIVIRAL ───────────────────────────────────────────────
//   { name: "Acyclovir 200mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 400mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 800mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 5% Cream", cat: "Antiviral Topical" },
//   { name: "Acyclovir 250mg Injection", cat: "Antiviral Inj" },
//   { name: "Valacyclovir 500mg Tablet", cat: "Antiviral" },
//   { name: "Valacyclovir 1000mg Tablet", cat: "Antiviral" },
//   { name: "Famciclovir 250mg Tablet", cat: "Antiviral" },
//   { name: "Oseltamivir 75mg Capsule", cat: "Antiviral" },
//   // ── ANTISEPTICS / MOUTHWASH / ORAL CARE ─────────────────────
//   { name: "Chlorhexidine Gluconate 0.2% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine Gluconate 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 1% Gel (Gum Gel)", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 5% Mouthwash / Gargle", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 10% Solution", cat: "Antiseptic" },
//   { name: "Povidone Iodine 5% Ointment", cat: "Antiseptic Topical" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 1.5% Mouthwash", cat: "Dental Antiseptic" },
//   {
//     name: "Benzydamine Hydrochloride 0.15% Mouthwash",
//     cat: "Dental Analgesic Rinse",
//   },
//   { name: "Hexetidine 0.1% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Sodium Fluoride 0.05% Mouthwash", cat: "Fluoride Rinse" },
//   { name: "Sodium Fluoride Varnish 5%", cat: "Fluoride Varnish" },
//   { name: "Fluoride Gel APF 1.23%", cat: "Fluoride Gel" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "Aloe Vera Gel Oral", cat: "Oral Care" },
//   { name: "Hyaluronic Acid Gel 0.2% Oral", cat: "Oral Care" },
//   { name: "Triclosan Toothpaste", cat: "Dental Brand" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Colgate Total Toothpaste", cat: "Dental Brand" },
//   { name: "Pepsodent Toothpaste", cat: "Dental Brand" },
//   { name: "Emoform Toothpaste", cat: "Dental Brand" },
//   { name: "Thermoseal Toothpaste", cat: "Dental Brand" },
//   { name: "Himalaya HiOra Toothpaste", cat: "Dental Brand" },
//   { name: "Dabur Red Toothpaste", cat: "Dental Brand" },
//   { name: "Meswak Toothpaste", cat: "Dental Brand" },
//   { name: "Oral-B Electric Toothbrush Head", cat: "Dental Accessory" },
//   { name: "Interdental Brush", cat: "Dental Accessory" },
//   { name: "Dental Floss", cat: "Dental Accessory" },
//   { name: "Tongue Cleaner", cat: "Dental Accessory" },
//   { name: "Water Flosser / Oral Irrigator", cat: "Dental Accessory" },
//   // ── DENTAL MATERIALS ────────────────────────────────────────
//   { name: "GIC Cement (Glass Ionomer Cement)", cat: "Dental Material" },
//   { name: "GIC Type II Restorative", cat: "Dental Material" },
//   { name: "RMGIC (Resin Modified GIC)", cat: "Dental Material" },
//   { name: "Composite Resin A1 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A2 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A3 Shade", cat: "Dental Material" },
//   { name: "Composite Resin B1 Shade", cat: "Dental Material" },
//   { name: "Flowable Composite", cat: "Dental Material" },
//   { name: "Bulk Fill Composite", cat: "Dental Material" },
//   { name: "IRM (Intermediate Restorative Material)", cat: "Dental Material" },
//   { name: "Zinc Oxide Eugenol Cement", cat: "Dental Material" },
//   { name: "Zinc Phosphate Cement", cat: "Dental Material" },
//   { name: "Zinc Polycarboxylate Cement", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Dycal (Calcium Hydroxide Base)", cat: "Dental Material" },
//   { name: "Cavity Liner (Varnish)", cat: "Dental Material" },
//   { name: "Etchant 37% Phosphoric Acid Gel", cat: "Dental Material" },
//   { name: "Bonding Agent (5th Gen)", cat: "Dental Material" },
//   { name: "Bonding Agent (7th Gen Self-Etch)", cat: "Dental Material" },
//   { name: "Dental Amalgam Capsule", cat: "Dental Material" },
//   { name: "Impression Material Alginate", cat: "Dental Material" },
//   {
//     name: "Impression Material Polyvinyl Siloxane (PVS)",
//     cat: "Dental Material",
//   },
//   { name: "Impression Material Polyether", cat: "Dental Material" },
//   { name: "Zinc Oxide Impression Paste", cat: "Dental Material" },
//   { name: "Plaster of Paris (Type II)", cat: "Dental Material" },
//   { name: "Dental Stone (Type III)", cat: "Dental Material" },
//   { name: "Dental Stone (Type IV)", cat: "Dental Material" },
//   { name: "Acrylic Resin Heat Cure", cat: "Dental Material" },
//   { name: "Acrylic Resin Cold Cure / Self Cure", cat: "Dental Material" },
//   { name: "Denture Base Resin", cat: "Dental Material" },
//   { name: "Denture Reliner", cat: "Dental Material" },
//   { name: "Denture Adhesive Cream", cat: "Dental Material" },
//   { name: "Dental Wax (Sheet Wax)", cat: "Dental Material" },
//   { name: "Boxing Wax", cat: "Dental Material" },
//   { name: "Inlay Wax", cat: "Dental Material" },
//   { name: "Sticky Wax", cat: "Dental Material" },
//   { name: "Orthodontic Wire NiTi 0.012", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire NiTi 0.014", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire NiTi 0.016", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire SS 0.019x0.025", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Metal)", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Ceramic)", cat: "Dental Ortho" },
//   { name: "Orthodontic Elastic Bands", cat: "Dental Ortho" },
//   { name: "Orthodontic Separator Elastics", cat: "Dental Ortho" },
//   { name: "Orthodontic Molar Band", cat: "Dental Ortho" },
//   { name: "Orthodontic Retainer Wire", cat: "Dental Ortho" },
//   { name: "Invisalign Clear Aligner Tray", cat: "Dental Ortho" },
//   { name: "Dental Implant Fixture (Titanium)", cat: "Dental Implant" },
//   { name: "Dental Implant Abutment", cat: "Dental Implant" },
//   { name: "Healing Cap / Cover Screw", cat: "Dental Implant" },
//   { name: "Bone Graft Material (Synthetic HA)", cat: "Dental Implant" },
//   { name: "Bone Graft Material (Xenograft)", cat: "Dental Implant" },
//   { name: "Collagen Membrane (Resorbable)", cat: "Dental Implant" },
//   { name: "Titanium Mesh", cat: "Dental Implant" },
//   { name: "PRP (Platelet Rich Plasma) Kit", cat: "Dental Surgical" },
//   { name: "PRF (Platelet Rich Fibrin) Kit", cat: "Dental Surgical" },
//   { name: "Hemostatic Agent (Gelatin Sponge)", cat: "Dental Surgical" },
//   { name: "Surgicel (Oxidised Cellulose)", cat: "Haemostatic" },
//   { name: "Alvogyl (Dry Socket Dressing)", cat: "Dental Surgical" },
//   { name: "Whitehead Varnish (Iodoform Paste)", cat: "Dental Surgical" },
//   { name: "Ledermix Paste", cat: "Dental Material" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Sealapex)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Zinc Oxide Eugenol)", cat: "Endodontic" },
//   { name: "Gutta Percha Points (ISO 20-80)", cat: "Endodontic" },
//   { name: "Paper Points (Absorbent Points)", cat: "Endodontic" },
//   { name: "EDTA Liquid 17% (Root Canal)", cat: "Endodontic" },
//   { name: "EDTA Gel 17% (Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 2.5% Solution", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% Solution", cat: "Endodontic" },
//   { name: "Chlorhexidine 2% Irrigant", cat: "Endodontic" },
//   { name: "RC Prep (Root Canal Lubricant)", cat: "Endodontic" },
//   { name: "K-Files (Root Canal Files) ISO 6-80", cat: "Endodontic Instrument" },
//   { name: "H-Files (Hedstrom Files) ISO 15-60", cat: "Endodontic Instrument" },
//   { name: "Rotary NiTi Files (ProTaper)", cat: "Endodontic Instrument" },
//   { name: "Rotary NiTi Files (WaveOne Gold)", cat: "Endodontic Instrument" },
//   { name: "Rubber Dam Sheet", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Clamp", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Frame", cat: "Endodontic Accessory" },
//   { name: "Pulp Capping Agent (Vitrebond)", cat: "Endodontic" },
//   { name: "Formocresol Solution", cat: "Endodontic Paediatric" },
//   { name: "Buckley's Formocresol", cat: "Endodontic Paediatric" },
//   {
//     name: "Zinc Oxide + Iodoform Paste (Kri Paste)",
//     cat: "Endodontic Paediatric",
//   },
//   { name: "Stainless Steel Crown (Paediatric)", cat: "Paediatric Dental" },
//   { name: "Fluoride Varnish Duraphat 22600 ppm", cat: "Fluoride Varnish" },
//   // ── SURGICAL INSTRUMENTS ────────────────────────────────────
//   { name: "Scalpel Handle No. 3", cat: "Surgical Instrument" },
//   { name: "Scalpel Handle No. 4", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 11", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 12", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 15", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 23", cat: "Surgical Instrument" },
//   { name: "Scissors (Metzenbaum)", cat: "Surgical Instrument" },
//   { name: "Scissors (Mayo Straight)", cat: "Surgical Instrument" },
//   { name: "Scissors (Mayo Curved)", cat: "Surgical Instrument" },
//   { name: "Scissors (Iris)", cat: "Surgical Instrument" },
//   { name: "Scissors (Dean)", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Straight)", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Curved)", cat: "Surgical Instrument" },
//   { name: "Mosquito Forceps", cat: "Surgical Instrument" },
//   { name: "Tissue Forceps (Adson)", cat: "Surgical Instrument" },
//   { name: "Tissue Forceps (Rat Tooth)", cat: "Surgical Instrument" },
//   { name: "Allis Tissue Forceps", cat: "Surgical Instrument" },
//   { name: "Babcock Forceps", cat: "Surgical Instrument" },
//   { name: "Needle Holder (Mayo Hegar)", cat: "Surgical Instrument" },
//   { name: "Needle Holder (Mathieu)", cat: "Surgical Instrument" },
//   { name: "Retractor (Langenbeck)", cat: "Surgical Instrument" },
//   { name: "Retractor (Army-Navy)", cat: "Surgical Instrument" },
//   { name: "Retractor (Minnesota)", cat: "Surgical Instrument" },
//   { name: "Cheek Retractor (Plastic)", cat: "Dental Instrument" },
//   { name: "Mouth Gag (Doyen)", cat: "Surgical Instrument" },
//   { name: "Periosteal Elevator (Molt No.9)", cat: "Dental Instrument" },
//   { name: "Periosteal Elevator (Freer)", cat: "Dental Instrument" },
//   { name: "Bone Curette (Lucas)", cat: "Dental Instrument" },
//   { name: "Surgical Curette", cat: "Surgical Instrument" },
//   { name: "Bone File", cat: "Dental Instrument" },
//   { name: "Rongeur Forceps (Bone Cutting)", cat: "Surgical Instrument" },
//   { name: "Surgical Mallet", cat: "Surgical Instrument" },
//   { name: "Osteotome", cat: "Surgical Instrument" },
//   { name: "Chisel (Straight)", cat: "Surgical Instrument" },
//   { name: "Suction Tip (Yankauer)", cat: "Surgical Instrument" },
//   { name: "Suction Tip (Dental Fine Tip)", cat: "Dental Instrument" },
//   { name: "Saliva Ejector Tip", cat: "Dental Instrument" },
//   { name: "High Volume Evacuator (HVE) Tip", cat: "Dental Instrument" },
//   { name: "Air/Water Syringe Tip", cat: "Dental Instrument" },
//   // ── DENTAL EXTRACTION FORCEPS ────────────────────────────────
//   { name: "Extraction Forceps Upper Anterior", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Premolar", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Molar (Left)", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Molar (Right)", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Anterior", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Premolar", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Molar", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Roots (Bayonet)", cat: "Dental Instrument" },
//   { name: "Elevator (Straight No. 301)", cat: "Dental Instrument" },
//   { name: "Elevator (Cryer Right)", cat: "Dental Instrument" },
//   { name: "Elevator (Cryer Left)", cat: "Dental Instrument" },
//   { name: "Elevator (Apexo)", cat: "Dental Instrument" },
//   { name: "Elevator (Warwick James)", cat: "Dental Instrument" },
//   { name: "Elevator (Coupland)", cat: "Dental Instrument" },
//   // ── PERIODONTAL INSTRUMENTS ──────────────────────────────────
//   { name: "Ultrasonic Scaler Tip (Universal)", cat: "Periodontal Instrument" },
//   {
//     name: "Ultrasonic Scaler Tip (Subgingival)",
//     cat: "Periodontal Instrument",
//   },
//   { name: "Sickle Scaler H6/H7", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 1/2", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 5/6", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 7/8", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 11/12", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette 13/14", cat: "Periodontal Instrument" },
//   { name: "Columbia Curette 4R/4L", cat: "Periodontal Instrument" },
//   { name: "Periodontal Probe (Williams)", cat: "Periodontal Instrument" },
//   { name: "Periodontal Probe (UNC-15)", cat: "Periodontal Instrument" },
//   { name: "Periodontal Probe (CPITN)", cat: "Periodontal Instrument" },
//   { name: "Suture Scissors (Crown Removing)", cat: "Periodontal Instrument" },
//   { name: "Electrosurgery Tip", cat: "Periodontal Instrument" },
//   // ── NEEDLES AND SYRINGES ─────────────────────────────────────
//   { name: "Dental Needle 27G Short (21mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 27G Long (38mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Short (21mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 25G Long (38mm)", cat: "Dental Needle" },
//   {
//     name: "Aspirating Dental Syringe (Breech Loading)",
//     cat: "Dental Instrument",
//   },
//   { name: "Disposable Syringe 1ml (Insulin)", cat: "Syringe" },
//   { name: "Disposable Syringe 2ml", cat: "Syringe" },
//   { name: "Disposable Syringe 5ml", cat: "Syringe" },
//   { name: "Disposable Syringe 10ml", cat: "Syringe" },
//   { name: "Disposable Syringe 20ml", cat: "Syringe" },
//   { name: "Disposable Syringe 50ml (Piston)", cat: "Syringe" },
//   { name: "Needle 18G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 20G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 21G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 22G x 1.5 inch", cat: "Needle" },
//   { name: "Needle 23G x 1 inch", cat: "Needle" },
//   { name: "Needle 24G x 1 inch", cat: "Needle" },
//   { name: "Needle 25G x 5/8 inch", cat: "Needle" },
//   { name: "Needle 26G x 0.5 inch", cat: "Needle" },
//   { name: "IV Cannula 14G (Orange)", cat: "IV Cannula" },
//   { name: "IV Cannula 16G (Grey)", cat: "IV Cannula" },
//   { name: "IV Cannula 18G (Green)", cat: "IV Cannula" },
//   { name: "IV Cannula 20G (Pink)", cat: "IV Cannula" },
//   { name: "IV Cannula 22G (Blue)", cat: "IV Cannula" },
//   { name: "IV Cannula 24G (Yellow)", cat: "IV Cannula" },
//   { name: "Spinal Needle 25G (Quincke)", cat: "Spinal Needle" },
//   { name: "Spinal Needle 26G (Quincke)", cat: "Spinal Needle" },
//   { name: "Epidural Needle 16G (Tuohy)", cat: "Epidural Needle" },
//   { name: "Epidural Catheter", cat: "Epidural Set" },
//   { name: 'Hypodermic Needle 21G x 1.5"', cat: "Needle" },
//   { name: "Scalp Vein Set 21G (Butterfly)", cat: "IV Accessory" },
//   { name: "Scalp Vein Set 23G (Butterfly)", cat: "IV Accessory" },
//   { name: "Scalp Vein Set 25G (Butterfly)", cat: "IV Accessory" },
//   // ── IV FLUIDS / INFUSIONS ────────────────────────────────────
//   { name: "Normal Saline 0.9% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 1000ml Infusion", cat: "IV Fluid" },
//   { name: "Ringer's Lactate 500ml Infusion", cat: "IV Fluid" },
//   { name: "Ringer's Lactate 1000ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 5% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 5% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 10% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 25% 200ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 50% 50ml Injection", cat: "IV Fluid" },
//   { name: "Dextrose 5% + Normal Saline 500ml", cat: "IV Fluid" },
//   { name: "Dextrose Saline (0.45% NaCl + 5% Dextrose)", cat: "IV Fluid" },
//   { name: "Isolyte S 500ml Infusion", cat: "IV Fluid" },
//   { name: "Isolyte P 500ml Infusion (Paediatric)", cat: "IV Fluid" },
//   { name: "Plasma Expander (Haemaccel) 500ml", cat: "IV Fluid" },
//   { name: "Colloid Solution (Albumin 5%) 500ml", cat: "IV Fluid" },
//   { name: "Albumin 25% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Sodium Bicarbonate 7.5% 25ml Injection", cat: "IV Fluid" },
//   { name: "Potassium Chloride 15% 10ml Ampoule", cat: "IV Electrolyte" },
//   { name: "Calcium Gluconate 10% Injection", cat: "IV Electrolyte" },
//   { name: "Magnesium Sulphate 50% Injection", cat: "IV Electrolyte" },
//   { name: "TPN (Total Parenteral Nutrition) Bag", cat: "IV Nutrition" },
//   { name: "Lipid Emulsion 20% Infusion", cat: "IV Nutrition" },
//   // ── ANTIEMETICS / GI ─────────────────────────────────────────
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 2mg/ml Injection", cat: "Antiemetic Inj" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Injection", cat: "Antiemetic Inj" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Promethazine 25mg Tablet", cat: "Antiemetic / Antihistamine" },
//   { name: "Promethazine 25mg Injection", cat: "Antiemetic Inj" },
//   { name: "Granisetron 1mg Tablet", cat: "Antiemetic" },
//   { name: "Pantoprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Ranitidine 150mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ranitidine 50mg Injection", cat: "Antacid Inj" },
//   { name: "Sucralfate Suspension 1g/10ml", cat: "Antacid" },
//   { name: "Antacid Suspension (Digene)", cat: "Antacid" },
//   { name: "Antacid Tablet (Gelusil)", cat: "Antacid" },
//   { name: "Syp Lactulose 10g/15ml", cat: "Laxative" },
//   { name: "Bisacodyl 5mg Tablet", cat: "Laxative" },
//   { name: "Bisacodyl Suppository 10mg", cat: "Laxative" },
//   { name: "Loperamide 2mg Tablet", cat: "Antidiarrhoeal" },
//   { name: "ORS Sachet (WHO Formula)", cat: "Oral Rehydration" },
//   { name: "Zinc Sulphate 20mg Tablet (Paediatric)", cat: "Micronutrient" },
//   // ── ANTIHISTAMINES / ALLERGY ─────────────────────────────────
//   { name: "Cetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 5mg/5ml Syrup", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 180mg Tablet", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 4mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 10mg Injection", cat: "Antihistamine Inj" },
//   { name: "Diphenhydramine 25mg Capsule", cat: "Antihistamine" },
//   { name: "Diphenhydramine Injection", cat: "Antihistamine Inj" },
//   { name: "Adrenaline (Epinephrine) 1mg/ml Injection", cat: "Emergency Drug" },
//   { name: "Hydrocortisone 100mg Injection (Allergy)", cat: "Emergency Drug" },
//   { name: "Epinephrine Auto-Injector (EpiPen)", cat: "Emergency Drug" },
//   // ── CARDIOVASCULAR ───────────────────────────────────────────
//   { name: "Amlodipine 2.5mg Tablet", cat: "Antihypertensive" },
//   { name: "Amlodipine 5mg Tablet", cat: "Antihypertensive" },
//   { name: "Amlodipine 10mg Tablet", cat: "Antihypertensive" },
//   { name: "Atenolol 25mg Tablet", cat: "Beta Blocker" },
//   { name: "Atenolol 50mg Tablet", cat: "Beta Blocker" },
//   { name: "Atenolol 100mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 25mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 50mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 100mg Tablet", cat: "Beta Blocker" },
//   { name: "Propranolol 10mg Tablet", cat: "Beta Blocker" },
//   { name: "Propranolol 40mg Tablet", cat: "Beta Blocker" },
//   { name: "Losartan 25mg Tablet", cat: "Antihypertensive" },
//   { name: "Losartan 50mg Tablet", cat: "Antihypertensive" },
//   { name: "Telmisartan 40mg Tablet", cat: "Antihypertensive" },
//   { name: "Telmisartan 80mg Tablet", cat: "Antihypertensive" },
//   { name: "Ramipril 2.5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Ramipril 5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Enalapril 5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Enalapril 10mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Furosemide 20mg Tablet", cat: "Diuretic" },
//   { name: "Furosemide 40mg Tablet", cat: "Diuretic" },
//   { name: "Furosemide 20mg Injection", cat: "Diuretic Inj" },
//   { name: "Spironolactone 25mg Tablet", cat: "Diuretic" },
//   { name: "Aspirin 75mg Tablet", cat: "Antiplatelet" },
//   { name: "Aspirin 150mg Tablet", cat: "Antiplatelet" },
//   { name: "Clopidogrel 75mg Tablet", cat: "Antiplatelet" },
//   { name: "Atorvastatin 10mg Tablet", cat: "Statin" },
//   { name: "Atorvastatin 20mg Tablet", cat: "Statin" },
//   { name: "Atorvastatin 40mg Tablet", cat: "Statin" },
//   { name: "Nitroglycerin 0.5mg Sublingual Tablet", cat: "Nitrate" },
//   { name: "Nitroglycerin 5mg/ml Infusion", cat: "Nitrate Inj" },
//   { name: "Digoxin 0.25mg Tablet", cat: "Cardiac Glycoside" },
//   { name: "Amiodarone 200mg Tablet", cat: "Antiarrhythmic" },
//   { name: "Warfarin 1mg Tablet", cat: "Anticoagulant" },
//   { name: "Warfarin 5mg Tablet", cat: "Anticoagulant" },
//   { name: "Heparin 5000 IU Injection", cat: "Anticoagulant Inj" },
//   { name: "Protamine Sulphate 10mg Injection", cat: "Anticoagulant Reversal" },
//   // ── DIABETES DRUGS ───────────────────────────────────────────
//   { name: "Metformin 500mg Tablet", cat: "Antidiabetic" },
//   { name: "Metformin 850mg Tablet", cat: "Antidiabetic" },
//   { name: "Metformin 1000mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 1mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 2mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 4mg Tablet", cat: "Antidiabetic" },
//   { name: "Insulin Regular (Soluble) 100 IU/ml", cat: "Insulin" },
//   { name: "Insulin NPH (Isophane) 100 IU/ml", cat: "Insulin" },
//   { name: "Insulin Glargine 100 IU/ml (Lantus)", cat: "Insulin" },
//   { name: "Insulin Aspart 100 IU/ml (Novorapid)", cat: "Insulin" },
//   { name: "Insulin Lispro 100 IU/ml (Humalog)", cat: "Insulin" },
//   // ── VITAMINS / SUPPLEMENTS ───────────────────────────────────
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin C 1000mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule (Weekly)", cat: "Vitamin" },
//   { name: "Vitamin D3 1000 IU Tablet (Daily)", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 500mcg Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 1000mcg Injection", cat: "Vitamin Inj" },
//   { name: "Vitamin K1 10mg Injection", cat: "Vitamin Inj" },
//   { name: "Folic Acid 5mg Tablet", cat: "Vitamin" },
//   { name: "Iron (Ferrous Sulphate) 200mg Tablet", cat: "Iron Supplement" },
//   { name: "Iron + Folic Acid Tablet", cat: "Iron Supplement" },
//   { name: "Iron Sucrose 100mg Injection", cat: "Iron Supplement Inj" },
//   { name: "Calcium Carbonate 500mg Tablet", cat: "Calcium Supplement" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Zinc Sulphate 50mg Tablet", cat: "Micronutrient" },
//   { name: "Magnesium Hydroxide 300mg Tablet", cat: "Mineral Supplement" },
//   { name: "Multivitamin Tablet (Adult)", cat: "Multivitamin" },
//   { name: "Multivitamin Syrup (Paediatric)", cat: "Multivitamin" },
//   // ── HAEMOSTATICS / BLEEDING ──────────────────────────────────
//   { name: "Tranexamic Acid 500mg Tablet", cat: "Haemostatic" },
//   { name: "Tranexamic Acid 250mg/5ml Injection", cat: "Haemostatic Inj" },
//   { name: "Etamsylate 250mg Tablet", cat: "Haemostatic" },
//   { name: "Etamsylate 125mg/2ml Injection", cat: "Haemostatic Inj" },
//   { name: "Gelatin Sponge (Absorbable Haemostat)", cat: "Haemostatic" },
//   { name: "Bone Wax", cat: "Haemostatic Surgical" },
//   { name: "Thrombin Topical Powder", cat: "Haemostatic" },
//   { name: "Fibrin Glue (Tisseel)", cat: "Haemostatic Surgical" },
//   // ── SUTURE MATERIALS ─────────────────────────────────────────
//   { name: "Vicryl (Polyglactin 910) 3-0 Suture", cat: "Suture" },
//   { name: "Vicryl (Polyglactin 910) 4-0 Suture", cat: "Suture" },
//   { name: "Vicryl Rapid 4-0 Suture", cat: "Suture" },
//   { name: "Chromic Catgut 2-0 Suture", cat: "Suture" },
//   { name: "Chromic Catgut 3-0 Suture", cat: "Suture" },
//   { name: "Plain Catgut 2-0 Suture", cat: "Suture" },
//   { name: "Silk Suture 2-0 Black Braided", cat: "Suture" },
//   { name: "Silk Suture 3-0 Black Braided", cat: "Suture" },
//   { name: "Silk Suture 4-0 Black Braided", cat: "Suture" },
//   { name: "Nylon Suture 3-0 (Ethilon)", cat: "Suture" },
//   { name: "Nylon Suture 4-0 (Ethilon)", cat: "Suture" },
//   { name: "Nylon Suture 5-0 (Ethilon)", cat: "Suture" },
//   { name: "Prolene (Polypropylene) 3-0 Suture", cat: "Suture" },
//   { name: "Prolene (Polypropylene) 4-0 Suture", cat: "Suture" },
//   { name: "PDS II (Polydioxanone) 3-0 Suture", cat: "Suture" },
//   { name: "Monocryl 4-0 Suture (Poliglecaprone)", cat: "Suture" },
//   { name: "Stapler Skin (Proximate Plus)", cat: "Surgical Closure" },
//   { name: "Skin Staple Remover", cat: "Surgical Instrument" },
//   { name: "Steri-Strip (Wound Closure Strip)", cat: "Wound Care" },
//   { name: "Surgical Glue (Dermabond / Histoacryl)", cat: "Wound Care" },
//   // ── DRESSINGS / WOUND CARE ───────────────────────────────────
//   { name: "Gauze Swab 4x4 inch (Sterile)", cat: "Dressing" },
//   { name: "Gauze Swab 10x10 cm (Non-Sterile)", cat: "Dressing" },
//   { name: "ABD Pad (Combine Dressing)", cat: "Dressing" },
//   { name: "Crepe Bandage 4 inch", cat: "Bandage" },
//   { name: "Crepe Bandage 6 inch", cat: "Bandage" },
//   { name: "Adhesive Plaster Roll 1 inch", cat: "Bandage" },
//   { name: "Elastic Adhesive Bandage (EAB)", cat: "Bandage" },
//   { name: "Cohesive Bandage", cat: "Bandage" },
//   { name: "Cotton Roll (Non-Sterile)", cat: "Dental Material" },
//   { name: "Cotton Roll Sterile", cat: "Dressing" },
//   { name: "Absorbable Haemostatic Gauze", cat: "Haemostatic Dressing" },
//   { name: "Vaseline Gauze (Petrolatum Gauze)", cat: "Dressing" },
//   { name: "Jelonet Paraffin Gauze", cat: "Dressing" },
//   { name: "Melolin Non-Adherent Dressing", cat: "Dressing" },
//   { name: "Hydrocolloid Dressing (DuoDERM)", cat: "Dressing" },
//   { name: "Hydrogel Dressing", cat: "Dressing" },
//   { name: "Foam Dressing", cat: "Dressing" },
//   { name: "Alginate Dressing", cat: "Dressing" },
//   { name: "Transparent Film Dressing (Tegaderm)", cat: "Dressing" },
//   { name: "Povidone Iodine Gauze", cat: "Dressing" },
//   { name: "Silver Sulfadiazine 1% Cream", cat: "Burns Dressing" },
//   { name: "Bacitracin Ointment", cat: "Topical Antibiotic" },
//   { name: "Mupirocin 2% Ointment (Bactroban)", cat: "Topical Antibiotic" },
//   { name: "Fusidic Acid 2% Cream", cat: "Topical Antibiotic" },
//   { name: "Framycetin (Soframycin) Cream", cat: "Topical Antibiotic" },
//   // ── GLOVES / PPE / DISPOSABLES ───────────────────────────────
//   { name: "Latex Examination Gloves (S/M/L)", cat: "PPE" },
//   { name: "Nitrile Examination Gloves (S/M/L)", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 6.0", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 6.5", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 7.0", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 7.5", cat: "PPE" },
//   { name: "Sterile Surgical Gloves 8.0", cat: "PPE" },
//   { name: "Surgical Mask (3-ply)", cat: "PPE" },
//   { name: "N95 Respirator Mask (FFP2)", cat: "PPE" },
//   { name: "Face Shield", cat: "PPE" },
//   { name: "Surgical Cap / Head Cover", cat: "PPE" },
//   { name: "Shoe Cover (Surgical Boot Cover)", cat: "PPE" },
//   { name: "Sterile Gown (Surgical)", cat: "PPE" },
//   { name: "Disposable Apron", cat: "PPE" },
//   { name: "Safety Goggles", cat: "PPE" },
//   { name: "Sharps Container 5L", cat: "Waste Disposal" },
//   { name: "Yellow Biohazard Bag", cat: "Waste Disposal" },
//   { name: "Red Biohazard Bag", cat: "Waste Disposal" },
//   { name: "IV Line / Infusion Set", cat: "IV Accessory" },
//   { name: "Burette Set (Paediatric IV Set)", cat: "IV Accessory" },
//   { name: "Blood Transfusion Set", cat: "IV Accessory" },
//   { name: "Nasogastric Tube (Ryle's Tube) 14F", cat: "Medical Device" },
//   { name: "Nasogastric Tube 16F", cat: "Medical Device" },
//   { name: "Foley Catheter 14F (2-Way)", cat: "Medical Device" },
//   { name: "Foley Catheter 16F (2-Way)", cat: "Medical Device" },
//   { name: "Foley Catheter 18F (3-Way)", cat: "Medical Device" },
//   { name: "Urobag (Urine Collection Bag)", cat: "Medical Device" },
//   { name: "Tracheostomy Tube (Cuffed) Size 7", cat: "Medical Device" },
//   { name: "Endotracheal Tube (ETT) 7.0 Cuffed", cat: "Anaesthesia Device" },
//   { name: "Endotracheal Tube (ETT) 7.5 Cuffed", cat: "Anaesthesia Device" },
//   { name: "Laryngoscope Blade (Macintosh Size 3)", cat: "Anaesthesia Device" },
//   { name: "Laryngeal Mask Airway (LMA) Size 3", cat: "Anaesthesia Device" },
//   { name: "Oropharyngeal Airway (Guedel) Size 3", cat: "Anaesthesia Device" },
//   { name: "Bag Valve Mask (BVM Resuscitator)", cat: "Emergency Device" },
//   { name: "Pulse Oximeter Probe", cat: "Monitoring Device" },
//   { name: "BP Cuff (Sphygmomanometer Cuff)", cat: "Monitoring Device" },
//   // ── RESPIRATORY / BRONCHODILATORS ───────────────────────────
//   { name: "Salbutamol 2mg Tablet", cat: "Bronchodilator" },
//   { name: "Salbutamol 4mg Tablet", cat: "Bronchodilator" },
//   { name: "Salbutamol 2.5mg/2.5ml Nebulisation", cat: "Bronchodilator" },
//   { name: "Salbutamol Inhaler 100mcg (MDI)", cat: "Bronchodilator Inhaler" },
//   { name: "Ipratropium 0.5mg Nebulisation", cat: "Bronchodilator" },
//   { name: "Budesonide 0.5mg Nebulisation", cat: "Steroid Inhaler" },
//   { name: "Doxofylline 400mg Tablet", cat: "Bronchodilator" },
//   { name: "Deriphylline Injection", cat: "Bronchodilator Inj" },
//   // ── ANTIEPILEPTICS ───────────────────────────────────────────
//   { name: "Phenytoin 100mg Tablet", cat: "Antiepileptic" },
//   { name: "Phenytoin 50mg/ml Injection", cat: "Antiepileptic Inj" },
//   { name: "Valproate 200mg Tablet", cat: "Antiepileptic" },
//   { name: "Valproate 500mg Tablet", cat: "Antiepileptic" },
//   { name: "Levetiracetam 500mg Tablet", cat: "Antiepileptic" },
//   { name: "Lorazepam 4mg Injection", cat: "Antiepileptic / Sedative Inj" },
//   { name: "Diazepam 10mg Injection", cat: "Antiepileptic / Sedative Inj" },
//   { name: "Clonazepam 0.5mg Tablet", cat: "Antiepileptic" },
//   { name: "Clonazepam 2mg Tablet", cat: "Antiepileptic" },
//   // ── VACCINES ─────────────────────────────────────────────────
//   { name: "Tetanus Toxoid 0.5ml Injection", cat: "Vaccine" },
//   { name: "Tetanus + Diphtheria (Td) Vaccine", cat: "Vaccine" },
//   { name: "Influenza Vaccine (Flu Shot)", cat: "Vaccine" },
//   { name: "Typhoid Vaccine (Vi Polysaccharide)", cat: "Vaccine" },
//   { name: "Rabies Vaccine (Post-Exposure)", cat: "Vaccine" },
//   { name: "Rabies Immunoglobulin (Human)", cat: "Vaccine" },
//   { name: "MMR Vaccine", cat: "Vaccine" },
//   { name: "Varicella (Chickenpox) Vaccine", cat: "Vaccine" },
//   { name: "HPV Vaccine (Gardasil 4/9)", cat: "Vaccine" },
//   { name: "COVID-19 Vaccine (Covishield)", cat: "Vaccine" },
//   { name: "COVID-19 Vaccine (Covaxin)", cat: "Vaccine" },
//   { name: "Anti-Tetanus Serum (ATS)", cat: "Antiserum" },
//   { name: "Anti-Snake Venom (Polyvalent)", cat: "Antiserum" },
//   { name: "Anti-Rabies Serum", cat: "Antiserum" },
//   { name: "Anti-Scorpion Venom Serum", cat: "Antiserum" },
//   // ── INVESTIGATIONS / LAB ─────────────────────────────────────
//   { name: "OPG (Orthopantomogram) X-ray", cat: "Dental Investigation" },
//   { name: "IOPA X-ray (Intraoral Periapical)", cat: "Dental Investigation" },
//   { name: "Bitewing X-ray", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Cone Beam CT)", cat: "Dental Investigation" },
//   { name: "Occlusal X-ray", cat: "Dental Investigation" },
//   { name: "Lateral Cephalogram X-ray", cat: "Dental Investigation" },
//   { name: "Chest X-ray PA View", cat: "Investigation" },
//   { name: "Skull X-ray AP + Lateral", cat: "Investigation" },
//   { name: "X-Ray Mandible PA View", cat: "Investigation" },
//   { name: "X-Ray Waters View (PNS)", cat: "Investigation" },
//   { name: "ECG (Electrocardiogram)", cat: "Investigation" },
//   { name: "CT Scan Head Plain", cat: "Investigation" },
//   { name: "CT Scan Neck with Contrast", cat: "Investigation" },
//   { name: "MRI Face and Jaw", cat: "Investigation" },
//   { name: "Ultrasound Neck / Submandibular", cat: "Investigation" },
//   { name: "Complete Blood Count (CBC)", cat: "Lab Test" },
//   { name: "Differential Count (DC)", cat: "Lab Test" },
//   { name: "Blood Sugar Fasting (BSF)", cat: "Lab Test" },
//   { name: "Blood Sugar Post Prandial (BSPP)", cat: "Lab Test" },
//   { name: "Random Blood Sugar (RBS)", cat: "Lab Test" },
//   { name: "HbA1c Test", cat: "Lab Test" },
//   { name: "Liver Function Test (LFT)", cat: "Lab Test" },
//   { name: "Kidney Function Test (KFT) / RFT", cat: "Lab Test" },
//   { name: "Thyroid Function Test (TFT)", cat: "Lab Test" },
//   { name: "Lipid Profile Test", cat: "Lab Test" },
//   { name: "Urine Routine and Microscopy", cat: "Lab Test" },
//   { name: "Blood Group and Rh Typing", cat: "Lab Test" },
//   { name: "Platelet Count", cat: "Lab Test" },
//   { name: "PT / INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "APTT Test", cat: "Lab Test" },
//   { name: "Bleeding Time (BT)", cat: "Lab Test" },
//   { name: "Clotting Time (CT)", cat: "Lab Test" },
//   { name: "ESR (Erythrocyte Sedimentation Rate)", cat: "Lab Test" },
//   { name: "CRP (C-Reactive Protein)", cat: "Lab Test" },
//   { name: "Serum Calcium Test", cat: "Lab Test" },
//   { name: "Serum Phosphorus Test", cat: "Lab Test" },
//   { name: "Serum Vitamin D (25-OH) Test", cat: "Lab Test" },
//   { name: "Serum Vitamin B12 Test", cat: "Lab Test" },
//   { name: "Serum Iron / TIBC Test", cat: "Lab Test" },
//   { name: "HIV Test (ELISA)", cat: "Lab Test" },
//   { name: "HBsAg Test (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HCV Test (Hepatitis C)", cat: "Lab Test" },
//   { name: "VDRL / RPR Test (Syphilis)", cat: "Lab Test" },
//   { name: "Pus Culture and Sensitivity", cat: "Lab Test" },
//   { name: "Blood Culture and Sensitivity", cat: "Lab Test" },
//   { name: "FNAC (Fine Needle Aspiration Cytology)", cat: "Biopsy" },
//   { name: "Incisional Biopsy", cat: "Biopsy" },
//   { name: "Excisional Biopsy", cat: "Biopsy" },
//   { name: "Exfoliative Cytology (Oral Smear)", cat: "Lab Test" },
//   { name: "Histopathology (HPE)", cat: "Lab Test" },
//   // ── EMERGENCY DRUGS ─────────────────────────────────────────
//   { name: "Adrenaline 1:1000 (1mg/ml) Injection", cat: "Emergency Drug" },
//   { name: "Adrenaline 1:10000 Injection (Cardiac)", cat: "Emergency Drug" },
//   { name: "Atropine 0.6mg Injection", cat: "Emergency Drug" },
//   { name: "Sodium Bicarbonate 8.4% Injection", cat: "Emergency Drug" },
//   { name: "Calcium Gluconate 10% Injection", cat: "Emergency Drug" },
//   { name: "Dextrose 50% Injection (Hypoglycaemia)", cat: "Emergency Drug" },
//   { name: "Naloxone 0.4mg Injection (Opioid Reversal)", cat: "Emergency Drug" },
//   {
//     name: "Flumazenil 0.5mg Injection (Benzo Reversal)",
//     cat: "Emergency Drug",
//   },
//   { name: "Dopamine 200mg Infusion", cat: "Emergency Drug Inj" },
//   {
//     name: "Noradrenaline (Norepinephrine) Infusion",
//     cat: "Emergency Drug Inj",
//   },
//   { name: "Vasopressin 20 IU Injection", cat: "Emergency Drug Inj" },
//   { name: "GTN (Glyceryl Trinitrate) Infusion", cat: "Emergency Drug Inj" },
//   {
//     name: "Lignocaine 100mg IV Injection (Arrhythmia)",
//     cat: "Emergency Drug Inj",
//   },
//   { name: "Adenosine 6mg Injection (SVT)", cat: "Emergency Drug Inj" },
//   { name: "Defibrillator Pads (AED Electrode)", cat: "Emergency Device" },
//   ,
//   // ── CONSUMABLES: COTTON & GAUZE ──────────────────────────────
//   { name: "Cotton Roll (Dental Grade)", cat: "Consumable" },
//   { name: "Cotton Pellet Small", cat: "Consumable" },
//   { name: "Cotton Pellet Medium", cat: "Consumable" },
//   { name: "Cotton Pellet Large", cat: "Consumable" },
//   { name: "Absorbent Cotton Wool 500g Roll", cat: "Consumable" },
//   { name: "Absorbent Cotton Wool 100g", cat: "Consumable" },
//   { name: "Gauze Swab 4x4 inch Sterile", cat: "Consumable" },
//   { name: "Gauze Swab 2x2 inch Sterile", cat: "Consumable" },
//   { name: "Gauze Roll 5cm x 5m", cat: "Consumable" },
//   { name: "Gauze Roll 10cm x 5m", cat: "Consumable" },
//   { name: "Non-Woven Gauze Swab 4x4", cat: "Consumable" },
//   { name: "Paraffin Gauze Dressing", cat: "Dressing" },
//   { name: "Betadine Gauze Dressing", cat: "Dressing" },
//   { name: "Ribbon Gauze 1/2 inch (Dental Packing)", cat: "Dental Consumable" },
//   { name: "Ribbon Gauze 1 inch", cat: "Dental Consumable" },
//   { name: "Dry Foil (Dental)", cat: "Dental Consumable" },

//   // ── SALINE & IV FLUIDS ─────────────────────────────────────────
//   { name: "Normal Saline 0.9% 100ml", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 250ml", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 500ml", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 1000ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 100ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 250ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 500ml", cat: "IV Fluid" },
//   { name: "Dextrose 5% 1000ml", cat: "IV Fluid" },
//   { name: "Dextrose 10% 500ml", cat: "IV Fluid" },
//   { name: "Dextrose 25% 100ml", cat: "IV Fluid" },
//   { name: "Dextrose 50% 50ml", cat: "IV Fluid" },
//   { name: "Ringer Lactate 500ml", cat: "IV Fluid" },
//   { name: "Ringer Lactate 1000ml", cat: "IV Fluid" },
//   { name: "DNS (Dextrose Normal Saline) 500ml", cat: "IV Fluid" },
//   { name: "DNS 1000ml", cat: "IV Fluid" },
//   { name: "Haemaccel 500ml Infusion", cat: "IV Fluid" },
//   { name: "Gelofusine 500ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 100ml", cat: "IV Fluid" },
//   { name: "Mannitol 20% 250ml", cat: "IV Fluid" },
//   { name: "Sodium Bicarbonate 7.5% 25ml", cat: "IV Electrolyte" },
//   { name: "Sodium Bicarbonate 8.4% 100ml", cat: "IV Electrolyte" },
//   { name: "Potassium Chloride 15% 10ml Ampoule", cat: "IV Electrolyte" },
//   { name: "Calcium Gluconate 10% 10ml Injection", cat: "IV Electrolyte" },
//   { name: "Magnesium Sulphate 50% 2ml Injection", cat: "IV Electrolyte" },

//   // ── NEEDLES ────────────────────────────────────────────────────
//   { name: "Disposable Syringe 1ml (Insulin Type)", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 2ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 5ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 10ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 20ml", cat: "Needle/Syringe" },
//   { name: "Disposable Syringe 50ml", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 18G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 20G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 22G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 24G", cat: "Needle/Syringe" },
//   { name: "Hypodermic Needle 26G", cat: "Needle/Syringe" },
//   { name: "Dental Needle 27G Short", cat: "Dental Needle" },
//   { name: "Dental Needle 27G Long", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Short", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Ultra Short", cat: "Dental Needle" },
//   { name: "Scalp Vein Set (Butterfly) 21G", cat: "IV Accessory" },
//   { name: "Scalp Vein Set (Butterfly) 23G", cat: "IV Accessory" },
//   { name: "Scalp Vein Set (Butterfly) 25G", cat: "IV Accessory" },
//   { name: "IV Cannula 14G (Orange)", cat: "IV Cannula" },
//   { name: "IV Cannula 16G (Grey)", cat: "IV Cannula" },
//   { name: "IV Cannula 18G (Green)", cat: "IV Cannula" },
//   { name: "IV Cannula 20G (Pink)", cat: "IV Cannula" },
//   { name: "IV Cannula 22G (Blue)", cat: "IV Cannula" },
//   { name: "IV Cannula 24G (Yellow) Paediatric", cat: "IV Cannula" },
//   { name: "Spinal Needle 25G (Quincke)", cat: "Spinal Needle" },
//   { name: "Spinal Needle 26G", cat: "Spinal Needle" },
//   { name: "Spinal Needle 27G", cat: "Spinal Needle" },
//   { name: "Epidural Needle 16G (Tuohy)", cat: "Epidural Needle" },
//   { name: "Epidural Needle 17G (Tuohy)", cat: "Epidural Needle" },

//   // ── INJECTIONS & AMPOULES ──────────────────────────────────────
//   {
//     name: "Lignocaine 2% with Adrenaline 1:80000 Cartridge (Dental)",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Lignocaine 2% with Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Lignocaine 2% Plain Cartridge (Dental)", cat: "Local Anaesthetic" },
//   {
//     name: "Articaine 4% with Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% with Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Mepivacaine 3% Plain Cartridge", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% with Adrenaline", cat: "Local Anaesthetic" },
//   { name: "Prilocaine 4% Plain Cartridge", cat: "Local Anaesthetic" },
//   {
//     name: "Benzocaine 20% Topical Gel (Dental)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Lidocaine 2% Topical Jelly", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lidocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine 2% Jelly 30g", cat: "Local Anaesthetic Topical" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 250mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 40mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 125mg Injection", cat: "Steroid Inj" },
//   { name: "Ketorolac 30mg Injection", cat: "NSAID Inj" },
//   { name: "Diclofenac 75mg Injection", cat: "NSAID Inj" },
//   { name: "Tramadol 50mg Injection", cat: "Painkiller Inj" },
//   { name: "Tramadol 100mg Injection", cat: "Painkiller Inj" },
//   { name: "Morphine 10mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pethidine 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Fentanyl 50mcg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Ondansetron 4mg Injection", cat: "Antiemetic Inj" },
//   { name: "Metoclopramide 10mg Injection", cat: "Antiemetic Inj" },
//   { name: "Promethazine 25mg Injection", cat: "Antiemetic Inj" },
//   { name: "Chlorpheniramine 10mg Injection", cat: "Antihistamine Inj" },
//   { name: "Pheniramine 22.75mg Injection", cat: "Antihistamine Inj" },
//   { name: "Midazolam 1mg/ml Injection", cat: "Sedative" },
//   { name: "Midazolam 5mg/ml Injection", cat: "Sedative" },
//   { name: "Diazepam 5mg Injection", cat: "Sedative" },
//   { name: "Propofol 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 200mg Injection", cat: "General Anaesthesia" },
//   { name: "Atropine 0.6mg Injection", cat: "Anticholinergic" },
//   { name: "Neostigmine 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Succinylcholine 100mg Injection", cat: "Muscle Relaxant" },
//   { name: "Vecuronium 4mg Injection", cat: "Muscle Relaxant" },
//   { name: "Atracurium 25mg Injection", cat: "Muscle Relaxant" },
//   { name: "Furosemide 20mg Injection", cat: "Diuretic Inj" },
//   { name: "Furosemide 40mg Injection", cat: "Diuretic Inj" },
//   { name: "Ranitidine 50mg Injection", cat: "Antacid Inj" },
//   { name: "Pantoprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Omeprazole 40mg Injection", cat: "Antacid Inj" },
//   {
//     name: "Phytomenadione (Vitamin K1) 10mg Injection",
//     cat: "Haemostatic Inj",
//   },
//   { name: "Tranexamic Acid 500mg Injection", cat: "Haemostatic Inj" },
//   { name: "Etamsylate 250mg Injection", cat: "Haemostatic Inj" },
//   { name: "Oxytocin 10 IU Injection", cat: "Haemostatic Inj" },
//   { name: "Dextrose 50% 50ml Push", cat: "Emergency Drug Inj" },
//   { name: "Naloxone 0.4mg Injection", cat: "Reversal Agent" },
//   { name: "Flumazenil 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Calcium Gluconate 1g Injection", cat: "Emergency Drug Inj" },

//   // ── SURGICAL INSTRUMENTS ───────────────────────────────────────
//   { name: "Scalpel Handle No. 3", cat: "Surgical Instrument" },
//   { name: "Scalpel Handle No. 4", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 11", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 12", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 15", cat: "Surgical Instrument" },
//   { name: "Scalpel Blade No. 22", cat: "Surgical Instrument" },
//   { name: "Surgical Scissors Straight (Mayo)", cat: "Surgical Instrument" },
//   { name: "Surgical Scissors Curved (Mayo)", cat: "Surgical Instrument" },
//   { name: "Metzenbaum Scissors", cat: "Surgical Instrument" },
//   { name: "Iris Scissors", cat: "Surgical Instrument" },
//   { name: "Dissecting Forceps (Toothed) Adson", cat: "Surgical Instrument" },
//   { name: "Dissecting Forceps (Non-Toothed)", cat: "Surgical Instrument" },
//   { name: "Haemostat (Mosquito Forceps) Straight", cat: "Surgical Instrument" },
//   { name: "Haemostat (Mosquito Forceps) Curved", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Kocher) Straight", cat: "Surgical Instrument" },
//   { name: "Artery Forceps (Kocher) Curved", cat: "Surgical Instrument" },
//   { name: "Needle Holder (Mayo-Hegar)", cat: "Surgical Instrument" },
//   { name: "Retractor (Langenbeck) Small", cat: "Surgical Instrument" },
//   { name: "Retractor (Langenbeck) Large", cat: "Surgical Instrument" },
//   { name: "Self-Retaining Retractor (Weitlaner)", cat: "Surgical Instrument" },
//   { name: "Bone Rongeur Forceps", cat: "Surgical Instrument" },
//   { name: "Curette Small", cat: "Surgical Instrument" },
//   { name: "Curette Large", cat: "Surgical Instrument" },
//   { name: "Periosteal Elevator (Molt No.9)", cat: "Dental Instrument" },
//   { name: "Periosteal Elevator (Freer)", cat: "Dental Instrument" },
//   { name: "Luxator (Periotome)", cat: "Dental Instrument" },
//   { name: "Dental Elevator (Straight)", cat: "Dental Instrument" },
//   { name: "Dental Elevator (Cryer)", cat: "Dental Instrument" },
//   { name: "Dental Elevator (Warwick James)", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Anteriors", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Premolars", cat: "Dental Instrument" },
//   {
//     name: "Extraction Forceps Upper Molars (Cowhorn)",
//     cat: "Dental Instrument",
//   },
//   { name: "Extraction Forceps Lower Anteriors", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Molars", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Upper Wisdom", cat: "Dental Instrument" },
//   { name: "Extraction Forceps Lower Wisdom", cat: "Dental Instrument" },
//   { name: "Bone File (Dental)", cat: "Dental Instrument" },
//   { name: "Bone Chisel (Dental)", cat: "Dental Instrument" },
//   { name: "Mallet (Surgical)", cat: "Dental Instrument" },
//   { name: "Rongeur Forceps (Dental)", cat: "Dental Instrument" },
//   { name: "Tissue Scissors (Dental)", cat: "Dental Instrument" },
//   { name: "Tongue Retractor", cat: "Dental Instrument" },
//   { name: "Cheek Retractor (Minnesota)", cat: "Dental Instrument" },
//   { name: "Austin/Channel Retractor", cat: "Dental Instrument" },
//   { name: "Dental Mirror No. 5", cat: "Dental Instrument" },
//   { name: "Dental Probe (CPI/UNC-15)", cat: "Dental Instrument" },
//   { name: "Dental Tweezers (College Pliers)", cat: "Dental Instrument" },
//   { name: "Dental Excavator Double Ended", cat: "Dental Instrument" },
//   { name: "Spoon Excavator Small", cat: "Dental Instrument" },
//   { name: "Spoon Excavator Medium", cat: "Dental Instrument" },
//   { name: "Amalgam Plugger", cat: "Dental Instrument" },
//   { name: "Composite Placement Instrument", cat: "Dental Instrument" },
//   { name: "Burnisher Ball", cat: "Dental Instrument" },
//   { name: "Burnisher Acorn", cat: "Dental Instrument" },
//   { name: "Sickle Scaler (H6/H7)", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 1/2", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 7/8", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 11/12", cat: "Periodontal Instrument" },
//   { name: "Gracey Curette No. 13/14", cat: "Periodontal Instrument" },
//   { name: "Columbia Curette", cat: "Periodontal Instrument" },
//   { name: "Hoe Scaler", cat: "Periodontal Instrument" },
//   { name: "File Scaler", cat: "Periodontal Instrument" },
//   { name: "Ultrasonic Scaler Tip (Slim)", cat: "Periodontal Instrument" },
//   { name: "Ultrasonic Scaler Tip (Universal)", cat: "Periodontal Instrument" },

//   // ── SUTURES ─────────────────────────────────────────────────────
//   { name: "Vicryl 3-0 (Polyglactin) Absorbable", cat: "Suture" },
//   { name: "Vicryl 4-0 Absorbable", cat: "Suture" },
//   { name: "Vicryl 5-0 Absorbable", cat: "Suture" },
//   { name: "Catgut Plain 2-0", cat: "Suture" },
//   { name: "Catgut Plain 3-0", cat: "Suture" },
//   { name: "Catgut Chromic 2-0", cat: "Suture" },
//   { name: "Catgut Chromic 3-0", cat: "Suture" },
//   { name: "Catgut Chromic 4-0", cat: "Suture" },
//   { name: "Silk 2-0 Non-Absorbable", cat: "Suture" },
//   { name: "Silk 3-0 Non-Absorbable (Dental)", cat: "Suture" },
//   { name: "Silk 4-0 Non-Absorbable", cat: "Suture" },
//   { name: "Prolene 4-0 (Polypropylene)", cat: "Suture" },
//   { name: "Prolene 5-0", cat: "Suture" },
//   { name: "Prolene 6-0", cat: "Suture" },
//   { name: "Nylon 3-0 Monofilament", cat: "Suture" },
//   { name: "Nylon 4-0 Monofilament", cat: "Suture" },
//   { name: "Nylon 5-0 Monofilament", cat: "Suture" },
//   { name: "PDS II 3-0 (Polydioxanone)", cat: "Suture" },
//   { name: "PDS II 4-0", cat: "Suture" },
//   { name: "Monocryl 4-0 (Poliglecaprone)", cat: "Suture" },
//   { name: "Monocryl 5-0", cat: "Suture" },
//   { name: "Ethibond 0 (Polyester)", cat: "Suture" },
//   { name: "Ethibond 2-0", cat: "Suture" },
//   { name: "Stapler (Skin Staples)", cat: "Surgical Closure" },
//   { name: "Steri-Strip Wound Closure 6mm", cat: "Surgical Closure" },
//   { name: "Steri-Strip Wound Closure 12mm", cat: "Surgical Closure" },
//   { name: "Tissue Glue (Dermabond/Histoacryl)", cat: "Surgical Closure" },

//   // ── IV DRIP ACCESSORIES ────────────────────────────────────────
//   { name: "IV Infusion Set (Standard)", cat: "IV Accessory" },
//   { name: "IV Infusion Set (Burette 100ml Paediatric)", cat: "IV Accessory" },
//   { name: "Blood Transfusion Set", cat: "IV Accessory" },
//   { name: "Extension Tubing (IV Line)", cat: "IV Accessory" },
//   { name: "Three-Way Stopcock", cat: "IV Accessory" },
//   { name: "Tegaderm IV Dressing 6x7cm", cat: "IV Accessory" },
//   { name: "Transparent Dressing IV Site", cat: "IV Accessory" },
//   { name: "IV Arm Board (Splint)", cat: "IV Accessory" },
//   { name: "Normal Saline Flush 10ml Pre-filled", cat: "IV Accessory" },
//   { name: "Heparin Flush 10 IU/ml", cat: "IV Accessory" },

//   // ── DRESSINGS & WOUND CARE ─────────────────────────────────────
//   { name: "Adhesive Plaster Roll 1 inch", cat: "Wound Care" },
//   { name: "Adhesive Plaster Roll 2 inch", cat: "Wound Care" },
//   { name: "Band-Aid Fabric 1 inch", cat: "Wound Care" },
//   { name: "Crepe Bandage 4 inch", cat: "Bandage" },
//   { name: "Crepe Bandage 6 inch", cat: "Bandage" },
//   { name: "Crepe Bandage 8 inch", cat: "Bandage" },
//   { name: "Elastic Adhesive Bandage 4 inch", cat: "Bandage" },
//   { name: "Cotton Bandage 4 inch", cat: "Bandage" },
//   { name: "Plaster of Paris (POP) Bandage 4 inch", cat: "Bandage" },
//   { name: "Plaster of Paris Bandage 6 inch", cat: "Bandage" },
//   { name: "Zinc Oxide Adhesive Plaster 1 inch", cat: "Wound Care" },
//   { name: "Wound Dressing Large (10x10)", cat: "Dressing" },
//   { name: "Wound Dressing Medium (7.5x7.5)", cat: "Dressing" },
//   { name: "Hydrocolloid Dressing", cat: "Wound Care" },
//   { name: "Foam Dressing", cat: "Wound Care" },
//   { name: "Silver Sulfadiazine 1% Cream (Burns)", cat: "Burns Dressing" },
//   { name: "Bactigras (Chlorhexidine Tulle)", cat: "Dressing" },

//   // ── ANTISEPTICS & DISINFECTANTS ────────────────────────────────
//   { name: "Povidone Iodine 5% Solution (Betadine)", cat: "Antiseptic" },
//   { name: "Povidone Iodine 10% Solution", cat: "Antiseptic" },
//   { name: "Povidone Iodine Surgical Scrub", cat: "Antiseptic" },
//   { name: "Chlorhexidine Gluconate 2% Solution", cat: "Antiseptic" },
//   { name: "Chlorhexidine Gluconate 4% Surgical Scrub", cat: "Antiseptic" },
//   { name: "Chlorhexidine 0.2% Mouthwash (Dental)", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Antiseptic" },
//   {
//     name: "Hydrogen Peroxide 6% (Dental Irrigation)",
//     cat: "Dental Antiseptic",
//   },
//   { name: "Isopropyl Alcohol 70% (Spirit Swabs)", cat: "Antiseptic" },
//   { name: "Alcohol Swabs (Pre-injection)", cat: "Antiseptic" },
//   { name: "Cetrimide + Chlorhexidine Solution", cat: "Antiseptic" },
//   { name: "Sodium Hypochlorite 2.5% (NaOCl - Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% (NaOCl)", cat: "Endodontic" },
//   { name: "EDTA Solution 17% (Root Canal)", cat: "Endodontic" },
//   { name: "EDTA Gel (RC Prep)", cat: "Endodontic" },
//   { name: "Saline Irrigation Solution 500ml", cat: "IV Fluid" },
//   { name: "Saline Nasal Drops", cat: "Consumable" },
//   { name: "Savlon (Cetrimide + Chlorhexidine)", cat: "Antiseptic" },
//   { name: "Dettol Liquid Antiseptic", cat: "Antiseptic" },

//   // ── DENTAL MATERIALS (EXPANDED) ────────────────────────────────
//   { name: "Zinc Oxide Eugenol (ZOE) Cement Base", cat: "Dental Material" },
//   { name: "Zinc Oxide Eugenol Impression Paste", cat: "Dental Material" },
//   { name: "Zinc Phosphate Cement", cat: "Dental Material" },
//   { name: "Zinc Polycarboxylate Cement", cat: "Dental Material" },
//   { name: "Glass Ionomer Cement Type I (Luting)", cat: "Dental Material" },
//   {
//     name: "Glass Ionomer Cement Type II (Restorative)",
//     cat: "Dental Material",
//   },
//   { name: "Glass Ionomer Cement Type III (Lining)", cat: "Dental Material" },
//   { name: "RMGIC (Resin Modified GIC)", cat: "Dental Material" },
//   { name: "Composite Resin Shade A1", cat: "Dental Material" },
//   { name: "Composite Resin Shade A2", cat: "Dental Material" },
//   { name: "Composite Resin Shade A3", cat: "Dental Material" },
//   { name: "Composite Resin Shade A3.5", cat: "Dental Material" },
//   { name: "Composite Resin Shade B1", cat: "Dental Material" },
//   { name: "Flowable Composite Shade A2", cat: "Dental Material" },
//   { name: "Flowable Composite Shade A3", cat: "Dental Material" },
//   { name: "Bonding Agent (5th Generation)", cat: "Dental Material" },
//   { name: "Bonding Agent (7th Generation Self-Etch)", cat: "Dental Material" },
//   { name: "Acid Etchant 37% Phosphoric Acid Gel", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste (Pulp Capping)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Powder", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Cavity Liner (Dycal)", cat: "Dental Material" },
//   { name: "Temporary Restoration Material (Cavit)", cat: "Dental Material" },
//   { name: "IRM Temporary Cement", cat: "Dental Material" },
//   { name: "Zinc Oxide Temp Fill", cat: "Dental Material" },
//   { name: "Alginate Impression Material (Chromatic)", cat: "Dental Material" },
//   { name: "Irreversible Hydrocolloid (Alginate) 500g", cat: "Dental Material" },
//   {
//     name: "Polyvinyl Siloxane (PVS) Impression Light Body",
//     cat: "Dental Material",
//   },
//   { name: "PVS Impression Heavy Body", cat: "Dental Material" },
//   { name: "Polyether Impression Material", cat: "Dental Material" },
//   { name: "Zinc Oxide Impression Paste (ZO Paste)", cat: "Dental Material" },
//   { name: "Plaster of Paris Dental Grade", cat: "Dental Material" },
//   { name: "Type III Dental Stone", cat: "Dental Material" },
//   { name: "Type IV Dental Stone (Die Stone)", cat: "Dental Material" },
//   { name: "Dental Wax (Modelling Wax)", cat: "Dental Material" },
//   { name: "Baseplate Wax", cat: "Dental Material" },
//   { name: "Sticky Wax", cat: "Dental Material" },
//   { name: "Bite Registration Paste", cat: "Dental Material" },
//   { name: "Separating Liquid (Sodium Alginate)", cat: "Dental Material" },
//   { name: "Denture Base Resin (Heat Cure)", cat: "Dental Material" },
//   { name: "Denture Base Resin (Cold Cure)", cat: "Dental Material" },
//   { name: "Denture Repair Resin", cat: "Dental Material" },
//   { name: "Acrylic Teeth Set (Upper)", cat: "Dental Material" },
//   { name: "Acrylic Teeth Set (Lower)", cat: "Dental Material" },
//   { name: "Porcelain Teeth", cat: "Dental Material" },
//   { name: "Chromium Cobalt Alloy (Partial Denture)", cat: "Dental Material" },
//   { name: "Amalgam Alloy Capsules (Pre-dosed)", cat: "Dental Material" },
//   { name: "Mercury (Dental Grade)", cat: "Dental Material" },
//   { name: "Amalgam Capsule Activator", cat: "Dental Accessory" },
//   { name: "Light Cure Composite Bleaching Gel 35%", cat: "Dental Material" },
//   { name: "Carbamide Peroxide 10% (Home Bleaching)", cat: "Dental Material" },
//   { name: "Carbamide Peroxide 16%", cat: "Dental Material" },
//   { name: "Carbamide Peroxide 22%", cat: "Dental Material" },
//   {
//     name: "Hydrogen Peroxide 35% (In-office Bleaching)",
//     cat: "Dental Material",
//   },
//   { name: "Desensitising Agent (Gluma)", cat: "Dental Material" },
//   { name: "Fluoride Varnish 5% NaF (Duraphat)", cat: "Dental Fluoride" },
//   { name: "Fluoride Gel APF 1.23%", cat: "Fluoride Gel" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "Pit & Fissure Sealant (Light Cure)", cat: "Dental Material" },
//   { name: "Pit & Fissure Sealant (Self-Cure)", cat: "Dental Material" },
//   { name: "Crown & Bridge Temporary Cement", cat: "Dental Material" },
//   { name: "Permanent Crown Cement (Ketac Cem)", cat: "Dental Material" },
//   { name: "Resin Cement (Panavia F)", cat: "Dental Material" },
//   { name: "Post & Core Material", cat: "Dental Material" },
//   { name: "Fibre Post (Glass Fibre)", cat: "Dental Material" },
//   { name: "Gutta Percha Points ISO Size 15", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 20", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 25", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 30", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 35", cat: "Endodontic" },
//   { name: "Gutta Percha Points ISO Size 40", cat: "Endodontic" },
//   { name: "Gutta Percha Points Standardised Large", cat: "Endodontic" },
//   { name: "Gutta Percha Points Accessory Fine", cat: "Endodontic" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Apexit Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Zinc Oxide Eugenol)", cat: "Endodontic" },
//   { name: "K-File ISO 15 (Root Canal File)", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 20", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 25", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 30", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 35", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 40", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 45", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 50", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 60", cat: "Endodontic Instrument" },
//   { name: "K-File ISO 80", cat: "Endodontic Instrument" },
//   { name: "H-File (Hedstroem) ISO 20", cat: "Endodontic Instrument" },
//   { name: "H-File ISO 25", cat: "Endodontic Instrument" },
//   { name: "H-File ISO 30", cat: "Endodontic Instrument" },
//   { name: "Reamer ISO 15-40 Set", cat: "Endodontic Instrument" },
//   { name: "ProTaper Next Rotary File Set", cat: "Endodontic Instrument" },
//   {
//     name: "WaveOne Gold Primary (Reciprocating)",
//     cat: "Endodontic Instrument",
//   },
//   { name: "Reciproc Blue R25", cat: "Endodontic Instrument" },
//   { name: "Lentulo Spiral Filler", cat: "Endodontic Instrument" },
//   { name: "Plugger Spreader (Gutta Percha)", cat: "Endodontic Instrument" },
//   { name: "Barbed Broach Assorted", cat: "Endodontic Instrument" },
//   { name: "Paper Points ISO 20", cat: "Endodontic Accessory" },
//   { name: "Paper Points ISO 25", cat: "Endodontic Accessory" },
//   { name: "Paper Points ISO 30", cat: "Endodontic Accessory" },
//   { name: "Paper Points ISO 40", cat: "Endodontic Accessory" },
//   { name: "Paper Points Fine (Accessory)", cat: "Endodontic Accessory" },
//   { name: "Apex Locator Tips", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Sheet (Latex)", cat: "Dental Accessory" },
//   { name: "Rubber Dam Frame (Ostby)", cat: "Dental Accessory" },
//   { name: "Rubber Dam Clamp Kit", cat: "Dental Accessory" },
//   { name: "Rubber Dam Punch", cat: "Dental Accessory" },
//   { name: "Saliva Ejector Tips (Disposable)", cat: "Dental Accessory" },
//   { name: "High Volume Evacuation Tip (HVE)", cat: "Dental Accessory" },
//   { name: "Matrix Band (Tofflemire Universal)", cat: "Dental Accessory" },
//   { name: "Sectional Matrix System (Palodent)", cat: "Dental Accessory" },
//   { name: "Wooden Wedge Assorted", cat: "Dental Accessory" },
//   { name: "Interproximal Plastic Wedge", cat: "Dental Accessory" },
//   { name: "Celluloid Crown Form (Anterior)", cat: "Dental Accessory" },
//   {
//     name: "Stainless Steel Crown (Molar Paediatric)",
//     cat: "Paediatric Dental",
//   },
//   { name: "Stainless Steel Crown Kit", cat: "Paediatric Dental" },
//   { name: "Pulpotomy Agent (Formocresol)", cat: "Paediatric Dental" },
//   { name: "Pulpotomy Agent (Ferric Sulphate 15.5%)", cat: "Paediatric Dental" },
//   { name: "Zinc Oxide Eugenol Paediatric Filling", cat: "Paediatric Dental" },

//   // ── ORTHO MATERIALS ────────────────────────────────────────────
//   { name: "Orthodontic Bands (Molar) Upper", cat: "Dental Ortho" },
//   { name: "Orthodontic Bands (Molar) Lower", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Metal Roth)", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Ceramic)", cat: "Dental Ortho" },
//   { name: "Archwire NiTi Round 0.014", cat: "Dental Ortho" },
//   { name: "Archwire NiTi Round 0.016", cat: "Dental Ortho" },
//   { name: "Archwire NiTi Round 0.018", cat: "Dental Ortho" },
//   { name: "Archwire SS Rectangular 0.019x0.025", cat: "Dental Ortho" },
//   { name: "Archwire SS Rectangular 0.021x0.025", cat: "Dental Ortho" },
//   { name: "Ligature Wire (Stainless Steel)", cat: "Dental Ortho" },
//   { name: "Elastic Ligature Ties Assorted", cat: "Dental Ortho" },
//   { name: "Power Chain Elastic", cat: "Dental Ortho" },
//   { name: "Separating Elastics (Orthodontic)", cat: "Dental Ortho" },
//   { name: "Molar Tube (Buccal Tube)", cat: "Dental Ortho" },
//   { name: "Ortho Bracket Adhesive (Light Cure)", cat: "Dental Ortho" },
//   { name: "Band Cement (Glass Ionomer Ortho)", cat: "Dental Ortho" },
//   { name: "Debonding Pliers", cat: "Dental Ortho" },
//   { name: "Ligature Tying Pliers", cat: "Dental Ortho" },
//   { name: "How Pliers", cat: "Dental Ortho" },
//   { name: "Cinching Pliers", cat: "Dental Ortho" },
//   { name: "Wire Cutters (Distal End Cutter)", cat: "Dental Ortho" },
//   { name: "Invisalign Chewies (Aligner Seater)", cat: "Dental Ortho" },
//   { name: "Retainer (Hawley Plate)", cat: "Dental Ortho" },

//   // ── PPE & INFECTION CONTROL ────────────────────────────────────
//   { name: "Nitrile Gloves Small (Powder-Free)", cat: "PPE" },
//   { name: "Nitrile Gloves Medium (Powder-Free)", cat: "PPE" },
//   { name: "Nitrile Gloves Large (Powder-Free)", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 6.5", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 7", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 7.5", cat: "PPE" },
//   { name: "Latex Surgical Gloves Size 8", cat: "PPE" },
//   { name: "Examination Gloves (Vinyl) Medium", cat: "PPE" },
//   { name: "3-Ply Surgical Face Mask", cat: "PPE" },
//   { name: "N95 Respirator (NIOSH Approved)", cat: "PPE" },
//   { name: "Surgical Gown (Non-Woven Sterile)", cat: "PPE" },
//   { name: "Disposable Apron (Polythene)", cat: "PPE" },
//   { name: "Shoe Cover (Disposable)", cat: "PPE" },
//   { name: "Head Cover / Surgical Cap", cat: "PPE" },
//   { name: "Face Shield (Dental)", cat: "PPE" },
//   { name: "Safety Goggles", cat: "PPE" },
//   { name: "Bib (Dental Patient)", cat: "Dental Accessory" },
//   { name: "Bib Clips", cat: "Dental Accessory" },
//   { name: "Autoclave Pouches (Self-Seal)", cat: "PPE" },
//   { name: "Sharps Container 5L", cat: "Waste Disposal" },
//   { name: "Sharps Container 1L", cat: "Waste Disposal" },
//   { name: "Biomedical Waste Bag Yellow", cat: "Waste Disposal" },
//   { name: "Biomedical Waste Bag Red", cat: "Waste Disposal" },

//   // ── COMMON OTC / PRESCRIPTION TABLETS ─────────────────────────
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 250mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 100mg/5ml Syrup", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Diclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Aceclofenac + Paracetamol + Serratiopeptidase", cat: "NSAID Combo" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 120mg Tablet", cat: "NSAID" },
//   { name: "Celecoxib 100mg Capsule", cat: "NSAID" },
//   { name: "Celecoxib 200mg Capsule", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Capsule", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   {
//     name: "Trypsin + Chymotrypsin Tablet (Antiflam)",
//     cat: "Enzyme Combination",
//   },
//   { name: "Serratiopeptidase 10mg Tablet", cat: "Enzyme Combination" },
//   { name: "Serratiopeptidase 20mg Tablet", cat: "Enzyme Combination" },
//   { name: "Deflazacort 6mg Tablet", cat: "Steroid" },
//   { name: "Deflazacort 12mg Tablet", cat: "Steroid" },
//   { name: "Deflazacort 30mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 8mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 16mg Tablet", cat: "Steroid" },
//   { name: "Betamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Pantoprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Omeprazole 10mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 40mg Capsule", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 10mg Tablet", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Ranitidine 150mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ranitidine 300mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 4mg/5ml Syrup", cat: "Antiemetic" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Domperidone 1mg/ml Suspension", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Promethazine 10mg Tablet", cat: "Antiemetic / Antihistamine" },
//   { name: "Cetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 5mg/5ml Syrup", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 180mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 2.5mg Tablet", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 4mg Tablet", cat: "Antihistamine" },
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin C 1000mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B Complex + Zinc Capsule", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule", cat: "Vitamin" },
//   { name: "Vitamin D3 1000 IU Tablet", cat: "Vitamin" },
//   { name: "Vitamin E 400mg Capsule", cat: "Vitamin" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Calcium Carbonate 500mg Tablet", cat: "Calcium Supplement" },
//   { name: "Zinc Sulphate 20mg Tablet", cat: "Mineral Supplement" },
//   { name: "Ferrous Sulphate 200mg Tablet", cat: "Iron Supplement" },
//   { name: "Ferrous Ascorbate + Folic Acid Tablet", cat: "Iron Supplement" },

//   // ── TOPICAL MEDICATIONS ────────────────────────────────────────
//   {
//     name: "Triamcinolone Acetonide 0.1% Oral Paste (Kenacort)",
//     cat: "Steroid Topical",
//   },
//   { name: "Triamcinolone Acetonide 0.025% Cream", cat: "Steroid Topical" },
//   { name: "Betamethasone 0.05% Cream", cat: "Steroid Topical" },
//   { name: "Clotrimazole 1% Cream", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin Oral Suspension", cat: "Antifungal" },
//   { name: "Nystatin 100000 IU Tablet", cat: "Antifungal" },
//   { name: "Fluconazole 50mg Tablet", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Tablet", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Mupirocin 2% Ointment (Bactroban)", cat: "Topical Antibiotic" },
//   { name: "Neomycin + Bacitracin Ointment", cat: "Topical Antibiotic" },
//   { name: "Tetracycline 3% Ointment", cat: "Topical Antibiotic" },
//   { name: "Fusidic Acid 2% Cream", cat: "Topical Antibiotic" },
//   { name: "Lignocaine Viscous 2% Mouthwash", cat: "Local Anaesthetic Topical" },
//   {
//     name: "Magic Mouthwash (Lignocaine + Diphenhydramine + Antacid)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Amlexanox 5% Paste (Aphthous Ulcer)", cat: "Oral Care" },
//   { name: "Benzydamine 0.15% Mouthwash (Tantum Verde)", cat: "Oral Care" },
//   { name: "Glycerine + Thymol Mouthwash", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash (Hexetidine 0.1%)", cat: "Dental Antiseptic" },
//   { name: "Listerine Mouthwash (OTC)", cat: "Oral Care" },
//   { name: "Colgate Peroxyl Mouthwash", cat: "Oral Care" },
//   { name: "Orajel (Benzocaine 10%) Topical", cat: "Local Anaesthetic Topical" },
//   { name: "Ulcerex Gel (Choline Salicylate)", cat: "Oral Care" },
//   { name: "Dologel CT (Clove Oil Gel)", cat: "Oral Care" },
//   { name: "Clove Oil (Eugenol)", cat: "Dental Material" },

//   // ── DENTAL IMPLANT MATERIALS ───────────────────────────────────
//   { name: "Titanium Implant Fixture (3.3mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (3.5mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (4.0mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (4.5mm)", cat: "Dental Implant" },
//   { name: "Implant Cover Screw", cat: "Dental Implant" },
//   { name: "Implant Healing Abutment", cat: "Dental Implant" },
//   { name: "Implant Final Abutment", cat: "Dental Implant" },
//   { name: "Implant Impression Coping", cat: "Dental Implant" },
//   { name: "Bone Graft (Autograft)", cat: "Dental Surgical" },
//   { name: "Bone Graft (Xenograft - Bio-Oss)", cat: "Dental Surgical" },
//   { name: "Collagen Membrane (Bio-Gide)", cat: "Dental Surgical" },
//   { name: "PRF (Platelet Rich Fibrin) Kit", cat: "Dental Surgical" },
//   {
//     name: "Haemostatic Agent (Surgicel - Oxidised Cellulose)",
//     cat: "Haemostatic Surgical",
//   },
//   { name: "Haemostatic Foam (Gelfoam)", cat: "Haemostatic" },
//   { name: "Bone Wax", cat: "Haemostatic Surgical" },
//   { name: "Surgical Suction Tip (Frazier)", cat: "Dental Instrument" },

//   // ── LAB INVESTIGATIONS ─────────────────────────────────────────
//   { name: "CBC (Complete Blood Count)", cat: "Lab Test" },
//   { name: "RBS (Random Blood Sugar)", cat: "Lab Test" },
//   { name: "FBS (Fasting Blood Sugar)", cat: "Lab Test" },
//   { name: "HbA1c (Glycated Haemoglobin)", cat: "Lab Test" },
//   { name: "Blood Group & Rh Typing", cat: "Lab Test" },
//   { name: "BT (Bleeding Time) & CT (Clotting Time)", cat: "Lab Test" },
//   { name: "PT/INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "APTT (Activated Partial Thromboplastin Time)", cat: "Lab Test" },
//   { name: "LFT (Liver Function Test)", cat: "Lab Test" },
//   { name: "KFT (Kidney Function Test)", cat: "Lab Test" },
//   { name: "Serum Creatinine", cat: "Lab Test" },
//   { name: "Urine Routine Examination", cat: "Lab Test" },
//   { name: "HBsAg (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "Anti-HIV (ELISA)", cat: "Lab Test" },
//   { name: "VDRL (Syphilis Test)", cat: "Lab Test" },
//   { name: "Dental Radiograph (IOPA X-ray)", cat: "Dental Investigation" },
//   { name: "Orthopantomogram (OPG) X-ray", cat: "Dental Investigation" },
//   { name: "Lateral Cephalogram X-ray", cat: "Dental Investigation" },
//   {
//     name: "Occlusal X-ray (Maxillary/Mandibular)",
//     cat: "Dental Investigation",
//   },
//   { name: "Bitewing Radiograph", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Dental 3D)", cat: "Dental Investigation" },

//   // ── COMMON BRAND NAMES (INDIA) ─────────────────────────────────
//   {
//     name: "Augmentin 625mg Tablet (Amoxicillin+Clavulanate)",
//     cat: "Antibiotic",
//   },
//   { name: "Azithral 500mg Tablet (Azithromycin)", cat: "Antibiotic" },
//   { name: "Cifran 500mg Tablet (Ciprofloxacin)", cat: "Antibiotic" },
//   { name: "Flagyl 400mg Tablet (Metronidazole)", cat: "Antibiotic" },
//   { name: "Doxy 100mg Capsule (Doxycycline)", cat: "Antibiotic" },
//   { name: "Calpol 650mg Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Dolo 650 Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Combiflam Tablet (Ibuprofen+Paracetamol)", cat: "NSAID Combo" },
//   { name: "Voveran 50mg Tablet (Diclofenac)", cat: "NSAID" },
//   { name: "Brufen 400mg Tablet (Ibuprofen)", cat: "NSAID" },
//   { name: "Ultracet Tablet (Tramadol+Paracetamol)", cat: "Analgesic Combo" },
//   { name: "Pan 40mg Tablet (Pantoprazole)", cat: "Antacid / PPI" },
//   { name: "Omez 20mg Capsule (Omeprazole)", cat: "Antacid / PPI" },
//   { name: "Ondem 4mg Tablet (Ondansetron)", cat: "Antiemetic" },
//   { name: "Stemetil 5mg Tablet (Prochlorperazine)", cat: "Antiemetic" },
//   { name: "Sinarest Tablet (Paracetamol+Phenylephrine)", cat: "Antihistamine" },
//   { name: "Allegra 120mg Tablet (Fexofenadine)", cat: "Antihistamine" },
//   {
//     name: "Montair-LC Tablet (Montelukast+Levocetirizine)",
//     cat: "Antihistamine",
//   },
//   { name: "Calpol Syrup (Paracetamol 120mg)", cat: "Painkiller" },
//   {
//     name: "Pyrimon Syrup (Mefenamic+Paracetamol Paediatric)",
//     cat: "Painkiller",
//   },
//   { name: "Perinorm 10mg Tablet (Metoclopramide)", cat: "Antiemetic" },
//   { name: "Rantac 150mg Tablet (Ranitidine)", cat: "Antacid / H2 Blocker" },
//   { name: "Kenacort Oral Paste (Triamcinolone)", cat: "Steroid Topical" },
//   { name: "Kenalog Injection 40mg (Triamcinolone)", cat: "Steroid Inj" },
//   { name: "Depo-Medrol 40mg Injection", cat: "Steroid Inj" },
//   { name: "Betnesol 0.5mg Tablet (Betamethasone)", cat: "Steroid" },
//   { name: "Wysolone 5mg Tablet (Prednisolone)", cat: "Steroid" },
//   { name: "Defcort 6mg Tablet (Deflazacort)", cat: "Steroid" },
//   { name: "Dexona 0.5mg Tablet (Dexamethasone)", cat: "Steroid" },
//   { name: "Mox 500mg Capsule (Amoxicillin)", cat: "Antibiotic" },
//   { name: "Sporanox 100mg Capsule (Itraconazole)", cat: "Antifungal" },
//   { name: "Zovirax 400mg Tablet (Acyclovir)", cat: "Antiviral" },
//   { name: "Valcivir 500mg Tablet (Valacyclovir)", cat: "Antiviral" },
//   { name: "Neosporin Powder (Neomycin+Bacitracin)", cat: "Topical Antibiotic" },
//   { name: "Betadine Ointment 5%", cat: "Antiseptic Topical" },
//   { name: "Borax Glycerine (Oral Ulcer)", cat: "Oral Care" },
//   { name: "Tantum Verde Mouthwash (Benzydamine)", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Recaldent (CPP-ACP Paste)", cat: "Dental Fluoride" },
//   { name: "Tooth Mousse Plus (GC)", cat: "Dental Fluoride" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Sensodyne Repair & Protect", cat: "Dental Brand" },
//   { name: "Colgate Sensitive Pro-Relief", cat: "Dental Brand" },
//   { name: "Pepsodent Germicheck", cat: "Dental Brand" },
//   { name: "Oral-B Toothbrush Indicator", cat: "Dental Brand" },
//   { name: "GUM Soft-Picks Interdental", cat: "Dental Brand" },
//   { name: "Floss (Oral-B Satin)", cat: "Dental Brand" },
//   { name: "Water Flosser", cat: "Dental Brand" },
//   { name: "Tongue Cleaner (Metal)", cat: "Dental Brand" },
//   { name: "Mouth Guard (Bruxism)", cat: "Dental Brand" },
// ];

// // ── Save a custom medicine — receives apiPost function from component
// // apiPost is api.post from api.js — same URL, same token, guaranteed correct
// function saveCustomMed(name, apiPost) {
//   if (!name || name.trim().length < 3) return Promise.resolve(null);
//   // Must contain at least one letter
//   if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
//   // Skip if already in built-in DB
//   const nameLow = name.trim().toLowerCase();
//   const already = MEDICINE_DB.some((m) => m.name.toLowerCase() === nameLow);
//   if (already) return Promise.resolve(null);
//   // Use api.post — same function used everywhere in this app
//   return apiPost("/custommeds", { name: name.trim(), cat: "Custom" })
//     .then((saved) => saved || null)
//     .catch(() => null);
// }

// // ── Google-style multi-word search — uses combined DB + custom meds from state
// // customMeds is passed in from component state (fetched from backend)
// function googleSearch(query, customMeds = []) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   if (!words.length) return [];

//   // Filter out any malformed entries (no name field)
//   const safeMeds = Array.isArray(customMeds)
//     ? customMeds.filter(
//         (m) => m && typeof m.name === "string" && m.name.trim().length > 0,
//       )
//     : [];

//   const combined = [
//     ...MEDICINE_DB,
//     ...safeMeds.map((m) => ({ ...m, _custom: true })),
//   ];

//   const scored = combined
//     .map((m) => {
//       // Guard against undefined name (safety check)
//       if (!m || typeof m.name !== "string") return { m, score: 0 };
//       const nameLow = m.name.toLowerCase();
//       const catLow = (m.cat || "").toLowerCase();
//       let score = 0;
//       for (const w of words) {
//         if (nameLow.startsWith(w)) score += 5;
//         else if (nameLow.includes(w)) score += 3;
//         else if (catLow.includes(w)) score += 1;
//       }
//       // Boost custom medicines so doctor's own entries appear first
//       if (m._custom) score += 2;
//       return { m, score };
//     })
//     .filter((x) => x.score > 0)
//     .sort((a, b) => b.score - a.score)
//     .map((x) => x.m);

//   return scored.slice(0, 12);
// }

// function highlightWords(text, query) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   let result = text;
//   words.forEach((w) => {
//     const re = new RegExp(
//       "(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
//       "gi",
//     );
//     result = result.replace(re, "<b>$1</b>");
//   });
//   return result;
// }

// // ── RxMedInput — single-line medicine autocomplete for prescription table ──
// // Uses position:fixed for dropdown to escape overflow:hidden containers.
// // FIX: getBoundingClientRect() returns viewport-relative coords.
// // position:fixed is also viewport-relative — so do NOT add window.scrollY/scrollX.
// function RxMedInput({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const inpRef = React.useRef(null);
//   const wrapRef = React.useRef(null);
//   const [sugs, setSugs] = React.useState([]);
//   const [activeIdx, setActive] = React.useState(-1);
//   const [query, setQuery] = React.useState("");
//   const [dropPos, setDropPos] = React.useState({ top: 0, left: 0, width: 0 });

//   const hide = () => {
//     setSugs([]);
//     setActive(-1);
//     setQuery("");
//   };

//   // FIX: position:fixed is viewport-relative — use r.bottom/r.left directly,
//   //      NOT r.bottom + window.scrollY (that caused dropdown to fly off-screen)
//   const calcPos = () => {
//     if (!inpRef.current) return;
//     const r = inpRef.current.getBoundingClientRect();
//     // Flip upward if dropdown would go below viewport
//     const spaceBelow = window.innerHeight - r.bottom;
//     const dropH = Math.min(220, sugs.length * 36);
//     const top =
//       spaceBelow > dropH || spaceBelow > 100
//         ? r.bottom // enough space below: open downward
//         : r.top - dropH; // not enough: open upward
//     setDropPos({ top, left: r.left, width: r.width });
//   };

//   const handleChange = (e) => {
//     const v = e.target.value;
//     onChange(v);
//     if (v.trim().length < 2) {
//       hide();
//       return;
//     }
//     const matches = googleSearch(v, customMeds);
//     if (!matches.length) {
//       hide();
//       return;
//     }
//     setQuery(v);
//     setSugs(matches);
//     setActive(-1);
//     // calcPos called after state update so refs are current
//     requestAnimationFrame(() => {
//       if (!inpRef.current) return;
//       const r = inpRef.current.getBoundingClientRect();
//       const spaceBelow = window.innerHeight - r.bottom;
//       const dropH = Math.min(220, matches.length * 36);
//       const top =
//         spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//       setDropPos({ top, left: r.left, width: r.width });
//     });
//   };

//   const handleKeyDown = (e) => {
//     if (!sugs.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActive((i) => Math.min(i + 1, sugs.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActive((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       sugs[activeIdx]
//     ) {
//       e.preventDefault();
//       select(sugs[activeIdx].name);
//     } else if (e.key === "Escape") {
//       hide();
//     }
//   };

//   const select = (name) => {
//     onChange(name);
//     hide();
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (inpRef.current) inpRef.current.focus();
//     }, 0);
//   };

//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapRef.current && !wrapRef.current.contains(e.target)) hide();
//     };
//     document.addEventListener("mousedown", handler);
//     // Recalculate position on any scroll (modal scroll, page scroll, etc.)
//     const scrollHandler = () => {
//       if (sugs.length > 0) calcPos();
//     };
//     window.addEventListener("scroll", scrollHandler, true);
//     return () => {
//       document.removeEventListener("mousedown", handler);
//       window.removeEventListener("scroll", scrollHandler, true);
//     };
//   }, [sugs.length]);

//   return (
//     <div ref={wrapRef} style={{ position: "relative" }}>
//       <input
//         ref={inpRef}
//         type="text"
//         value={value}
//         onChange={handleChange}
//         onKeyDown={handleKeyDown}
//         placeholder="Type medicine name..."
//         autoComplete="off"
//         style={{
//           width: "100%",
//           border: "1px solid #ddd",
//           borderRadius: 5,
//           padding: "5px 8px",
//           fontSize: 12,
//           fontFamily: "'DM Sans',sans-serif",
//         }}
//       />
//       {sugs.length > 0 && (
//         <div
//           style={{
//             position: "fixed",
//             top: dropPos.top,
//             left: dropPos.left,
//             width: Math.max(dropPos.width, 280),
//             background: "#fff",
//             border: "1.5px solid #0d7377",
//             borderRadius: 8,
//             boxShadow: "0 8px 32px rgba(13,115,119,0.28)",
//             zIndex: 999999,
//             maxHeight: 220,
//             overflowY: "auto",
//             fontFamily: "'DM Sans',sans-serif",
//           }}
//         >
//           {sugs.map((m, i) => (
//             <div
//               key={m.name + i}
//               style={{
//                 padding: "7px 12px",
//                 cursor: "pointer",
//                 fontSize: 12,
//                 background: i === activeIdx ? "#e8f7f7" : "#fff",
//                 borderBottom: "1px solid #f0eeeb",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 8,
//               }}
//               onMouseDown={(e) => {
//                 e.preventDefault();
//                 select(m.name);
//               }}
//               onMouseEnter={() => setActive(i)}
//             >
//               <span style={{ fontSize: 13, opacity: 0.6, flexShrink: 0 }}>
//                 💊
//               </span>
//               <span
//                 style={{ flex: 1, fontWeight: 500 }}
//                 dangerouslySetInnerHTML={{
//                   __html: highlightWords(m.name, query),
//                 }}
//               />
//               <span
//                 style={{
//                   fontSize: 10,
//                   color: "#9a9590",
//                   background: "#f0eeeb",
//                   padding: "1px 6px",
//                   borderRadius: 20,
//                   flexShrink: 0,
//                 }}
//               >
//                 {m.cat}
//               </span>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// // ── MedAutocomplete — Google-style medicine search ───────────
// function MedAutocomplete({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const taRef = React.useRef(null);
//   const wrapperRef = React.useRef(null);
//   const [suggestions, setSuggestions] = React.useState([]);
//   const [activeIdx, setActiveIdx] = React.useState(-1);
//   const [currentQuery, setCurrentQuery] = React.useState("");
//   const queryStartRef = React.useRef(0);
//   const queryEndRef = React.useRef(0);

//   const hideSuggestions = () => {
//     setSuggestions([]);
//     setActiveIdx(-1);
//     setCurrentQuery("");
//   };

//   // Single onChange handler — no onInput conflict
//   const handleChange = (e) => {
//     const ta = e.target;
//     const val = ta.value;
//     const cursor = ta.selectionStart;
//     onChange(val);

//     // Find start of current line/word being typed
//     let lineStart = cursor - 1;
//     while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
//     lineStart++;

//     const query = val.substring(lineStart, cursor);
//     queryStartRef.current = lineStart;
//     queryEndRef.current = cursor;

//     if (query.trim().length < 2) {
//       hideSuggestions();
//       return;
//     }
//     const matches = googleSearch(query, customMeds);
//     if (!matches.length) {
//       hideSuggestions();
//       return;
//     }
//     setCurrentQuery(query);
//     setSuggestions(matches);
//     setActiveIdx(-1);
//   };

//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       suggestions[activeIdx]
//     ) {
//       e.preventDefault();
//       selectMed(suggestions[activeIdx].name);
//     } else if (e.key === "Escape") {
//       hideSuggestions();
//     }
//   };

//   const selectMed = (name) => {
//     const ta = taRef.current;
//     const val = ta.value;
//     const before = val.substring(0, queryStartRef.current);
//     const after = val.substring(queryEndRef.current);
//     const newVal = before + name + after;
//     onChange(newVal);
//     hideSuggestions();
//     // Save to backend using api.post — correct URL guaranteed
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     // Restore cursor position after React re-render
//     setTimeout(() => {
//       if (taRef.current) {
//         const nc = queryStartRef.current + name.length;
//         taRef.current.setSelectionRange(nc, nc);
//         taRef.current.focus();
//         queryEndRef.current = nc;
//       }
//     }, 0);
//   };

//   // On blur — save full meaningful lines typed by doctor as custom medicines
//   const handleBlur = () => {
//     if (!taRef.current) return;
//     const val = taRef.current.value;
//     // Save lines that look like medicine names (>=3 chars, has a letter, not pure numbers)
//     val.split("\n").forEach((line) => {
//       const trimmed = line.trim();
//       if (
//         trimmed.length >= 3 &&
//         /[a-zA-Z]/.test(trimmed) &&
//         !/^[0-9\s]+$/.test(trimmed)
//       ) {
//         saveCustomMed(trimmed, apiPost).then((saved) => {
//           if (saved && onCustomSaved) onCustomSaved(saved);
//         });
//       }
//     });
//   };

//   // Click-outside handler using wrapperRef (not fixed id)
//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
//         hideSuggestions();
//       }
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   return (
//     <>
//       <style>{`
//         .med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}
//         .med-suggestion-item:last-child{border-bottom:none;}
//         .med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}
//         .med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}
//         .med-sug-name{font-weight:500;flex:1;color:#1a1614;}
//         .med-sug-name b{color:#0d7377;font-weight:700;}
//         .med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}
//       `}</style>
//       <div style={{ position: "relative" }} ref={wrapperRef}>
//         <textarea
//           ref={taRef}
//           value={value}
//           onChange={handleChange}
//           onKeyDown={handleKeyDown}
//           onBlur={handleBlur}
//           autoComplete="off"
//           placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
//         />
//         {suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderTop: "none",
//               borderRadius: "0 0 12px 12px",
//               boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
//               zIndex: 99999,
//               maxHeight: 280,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {suggestions.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 className={
//                   "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
//                 }
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   selectMed(m.name);
//                 }}
//               >
//                 <span className="med-sug-icon">💊</span>
//                 <span
//                   className="med-sug-name"
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, currentQuery),
//                   }}
//                 />
//                 <span className="med-sug-cat">{m.cat}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── Prescription Modal — exact original PDF design ────────────
// function PrescriptionModal({ visit, patient, doctor, onClose, showNotify }) {
//   const [pdfUrl, setPdfUrl] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [pdfBlob, setPdfBlob] = useState(null);
//   const [rxMobile, setRxMobile] = useState("");
//   const [fileName, setFileName] = useState("");
//   const [canNativeShare, setCanNativeShare] = useState(false);

//   useEffect(() => {
//     generatePDF();
//   }, []);

//   // Close on Escape
//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     document.addEventListener("keydown", handler);
//     return () => document.removeEventListener("keydown", handler);
//   }, [onClose]);

//   const fmtDateLocal = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr + "T00:00:00");
//     return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
//   };

//   const fmtTimeLocal = (t) => {
//     if (!t) return "";
//     const parts = t.split(":");
//     const hh = parseInt(parts[0]),
//       mm = parts[1];
//     return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
//   };

//   const generatePDF = () => {
//     if (window.jspdf) {
//       buildPDF();
//       return;
//     }
//     const existing = document.getElementById("jspdf-cdn");
//     if (existing) {
//       existing.addEventListener("load", buildPDF);
//       return;
//     }
//     const script = document.createElement("script");
//     script.id = "jspdf-cdn";
//     script.src =
//       "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
//     script.crossOrigin = "anonymous";
//     script.onload = buildPDF;
//     script.onerror = () => setLoading(false);
//     document.head.appendChild(script);
//   };

//   const buildPDF = () => {
//     const { jsPDF } = window.jspdf;
//     const pdf = new jsPDF({
//       unit: "mm",
//       format: "a4",
//       orientation: "portrait",
//     });
//     const W = 210,
//       H = 297;

//     const sf = (c) => pdf.setFillColor(c[0], c[1], c[2]);
//     const sd = (c) => pdf.setDrawColor(c[0], c[1], c[2]);
//     const st = (c) => pdf.setTextColor(c[0], c[1], c[2]);

//     const NAVY = [8, 25, 65],
//       BLUE = [20, 80, 160],
//       BLUE2 = [40, 110, 190];
//     const LBLUE = [210, 228, 248],
//       LBLUE2 = [232, 242, 252],
//       MIDBLUE = [160, 195, 235];
//     const TEAL = [0, 130, 130],
//       TEAL2 = [210, 240, 240];
//     const WHITE = [255, 255, 255],
//       LGRAY = [245, 247, 251],
//       LGRAY2 = [250, 251, 254],
//       LGRAY3 = [240, 243, 248];
//     const GRAY = [115, 118, 130],
//       GRAY2 = [75, 80, 95];
//     const GOLD = [170, 130, 40],
//       GOLD2 = [250, 245, 225];

//     const today = new Date();
//     const todayFmt =
//       today.getDate() +
//       " " +
//       MONTHS[today.getMonth()] +
//       " " +
//       today.getFullYear();
//     const rxNum =
//       "PS-" +
//       today.getFullYear() +
//       ("0" + (today.getMonth() + 1)).slice(-2) +
//       ("0" + today.getDate()).slice(-2) +
//       "-" +
//       Math.floor(1000 + Math.random() * 8999);

//     const visitDate = visit.visitDate || "";
//     const visitTime = visit.visitTime || "";
//     const notes = visit.notes || "";
//     const nextDate = visit.nextVisitDate || "";
//     const service = visit.service || "";
//     const doc = { name: doctor?.name || "Doctor", qual: "", reg: "" };

//     const visitDateFmt = fmtDateLocal(visitDate);
//     const visitTimeFmt = fmtTimeLocal(visitTime);
//     const nextDateFmt = fmtDateLocal(nextDate);

//     // ── Outer border ─────────────────────────────────────────────
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.8);
//     pdf.rect(3.5, 3.5, W - 7, H - 7, "S");
//     sd(LBLUE);
//     pdf.setLineWidth(0.3);
//     pdf.rect(5.5, 5.5, W - 11, H - 11, "S");

//     // ── Header ───────────────────────────────────────────────────
//     sf(NAVY);
//     pdf.rect(3.5, 3.5, W - 7, 46, "F");
//     sf(BLUE);
//     pdf.rect(3.5, 43, W - 7, 10, "F");
//     sf(LBLUE);
//     pdf.rect(3.5, 53, W - 7, 6, "F");

//     st(WHITE);
//     pdf.setFontSize(18);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(doc.name, 14, 19);
//     st(LBLUE);
//     pdf.setFontSize(8);
//     pdf.setFont("helvetica", "normal");
//     pdf.text((doc.qual || "").toUpperCase(), 14, 26);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(14, 28.5, W - 40, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(7);
//     pdf.text("Reg. No.:  " + (doc.reg || "—"), 14, 33.5);
//     pdf.text("Specialisation:  Dental & Oral Health Care", 14, 38.5);

//     st(WHITE);
//     pdf.setFontSize(15);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PEARLSMILE", W - 10, 19, { align: "right" });
//     st(LBLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("DENTAL HOSPITAL", W - 10, 25.5, { align: "right" });
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(W - 72, 28.5, W - 10, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(6.8);
//     pdf.text("12, Dental Plaza, MG Road, Pune - 411001", W - 10, 33.5, {
//       align: "right",
//     });
//     pdf.text("+91 87936 08083  |  care@pearlsmiledental.in", W - 10, 38.5, {
//       align: "right",
//     });

//     st(WHITE);
//     pdf.setFontSize(9);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("DIGITAL PRESCRIPTION", W / 2, 50, { align: "center" });
//     st(LBLUE2);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 10, 50);
//     pdf.text("Date: " + todayFmt, W - 10, 50, { align: "right" });

//     st(BLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PATIENT INFORMATION", W / 2, 57, { align: "center" });

//     // ── Patient info table ────────────────────────────────────────
//     const infoTop = 61;
//     sf(LGRAY3);
//     pdf.rect(10, infoTop, W - 20, 44, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, infoTop, W - 20, 44, "S");
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.2);
//     pdf.line(W / 2, infoTop, W / 2, infoTop + 44);
//     let rdy = infoTop + 11;
//     for (let ri = 0; ri < 3; ri++) {
//       pdf.line(10, rdy, W - 10, rdy);
//       rdy += 11;
//     }

//     const drawCell = (label, value, x, y, maxW) => {
//       st(GRAY2);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.8);
//       pdf.text(label, x + 3, y + 4);
//       st(NAVY);
//       pdf.setFont("helvetica", "normal");
//       pdf.setFontSize(8.5);
//       const val = pdf.splitTextToSize(String(value || "—"), maxW || 75);
//       pdf.text(val[0], x + 3, y + 9.5);
//     };
//     const cHalf = W / 2;
//     drawCell("PATIENT NAME", patient.name || "—", 10, infoTop, cHalf - 16);
//     drawCell("MOBILE", patient.mobile || "—", cHalf, infoTop, cHalf - 16);
//     drawCell("EMAIL", patient.email || "—", 10, infoTop + 11, cHalf - 16);
//     drawCell(
//       "BLOOD GROUP",
//       patient.blood || "—",
//       cHalf,
//       infoTop + 11,
//       cHalf - 16,
//     );
//     drawCell(
//       "AGE / GENDER",
//       (patient.age || "—") + (patient.gender ? "  |  " + patient.gender : ""),
//       10,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell(
//       "VISIT DATE",
//       visitDateFmt + (visitTimeFmt ? " (" + visitTimeFmt + ")" : ""),
//       cHalf,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell("SERVICE/TREATMENT", service || "—", 10, infoTop + 33, cHalf - 16);
//     drawCell(
//       "NEXT VISIT DATE",
//       nextDateFmt || "—",
//       cHalf,
//       infoTop + 33,
//       cHalf - 16,
//     );

//     // ── Prescription Table in PDF (FIRST) ──────────────────────
//     const diagTop = infoTop + 50;
//     const rxRows =
//       visit.prescription && visit.prescription.medicineRows
//         ? visit.prescription.medicineRows.filter(
//             (r) => r.medicine && r.medicine.trim(),
//           )
//         : [];
//     let rxTableEndY = diagTop;
//     if (rxRows.length > 0) {
//       const tTop = diagTop;
//       sf(BLUE);
//       pdf.rect(10, tTop, W - 20, 7, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(7.5);
//       pdf.text("PRESCRIPTION", W / 2, tTop + 5, { align: "center" });
//       const colX = [10, 20, 90, 155, 183];
//       let ry = tTop + 7;
//       sf(LGRAY3);
//       pdf.rect(10, ry, W - 20, 6, "F");
//       [
//         ["SR.", "normal", 6],
//         ["MEDICINE", "bold", 6],
//         ["DOSAGE INSTRUCTION", "normal", 6],
//         ["DURATION", "normal", 6],
//         ["ROUTE", "normal", 6],
//       ].forEach(([h, fw, fs], hi) => {
//         st(GRAY2);
//         pdf.setFont("helvetica", fw);
//         pdf.setFontSize(fs);
//         pdf.text(h, colX[hi] + 1, ry + 4.5);
//       });
//       ry += 6;
//       rxRows.forEach((row, ri) => {
//         sf(ri % 2 === 0 ? LGRAY2 : WHITE);
//         pdf.rect(10, ry, W - 20, 7, "F");
//         sd(LBLUE);
//         pdf.setLineWidth(0.1);
//         pdf.rect(10, ry, W - 20, 7, "S");
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6);
//         pdf.text(String(ri + 1) + ".", colX[0] + 1, ry + 4.5);
//         st(NAVY);
//         pdf.setFont("helvetica", "bold");
//         pdf.setFontSize(7);
//         pdf.text(
//           pdf.splitTextToSize(row.medicine || "", 68)[0] || "",
//           colX[1] + 1,
//           ry + 4.5,
//         );
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6.5);
//         pdf.text(
//           pdf.splitTextToSize(row.dosage || "", 63)[0] || "",
//           colX[2] + 1,
//           ry + 4.5,
//         );
//         pdf.text(row.duration || "", colX[3] + 1, ry + 4.5);
//         pdf.text(row.route || "", colX[4] + 1, ry + 4.5);
//         ry += 7;
//       });
//       rxTableEndY = ry + 4;
//     }

//     // ── Clinical Notes (AFTER Prescription) ──────────────────────
//     const notesTop = rxTableEndY + 4;
//     sf(BLUE);
//     pdf.rect(10, notesTop, W - 20, 8, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(8.5);
//     pdf.text("Rx   CLINICAL NOTES / DIAGNOSIS", 14, notesTop + 5.5);
//     st(GOLD);
//     pdf.setFontSize(10);
//     pdf.text("Rx", W - 16, notesTop + 5.5, { align: "right" });

//     const notesBoxH = 46;
//     sf(LGRAY2);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "S");
//     sd([215, 225, 240]);
//     pdf.setLineWidth(0.15);
//     for (let rl = 0; rl < 6; rl++)
//       pdf.line(14, notesTop + 16 + rl * 7, W - 14, notesTop + 16 + rl * 7);
//     st(NAVY);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(9.5);
//     const noteLines = pdf.splitTextToSize(
//       notes || "No diagnosis or notes recorded for this visit.",
//       W - 30,
//     );
//     pdf.text(noteLines, 14, notesTop + 15);

//     let tableEndY = notesTop + notesBoxH + 8;

//     // ── Next appointment box ──────────────────────────────────────
//     let afterY = tableEndY;
//     if (nextDateFmt) {
//       sf(TEAL2);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "F");
//       sd(TEAL);
//       pdf.setLineWidth(0.4);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "S");
//       sf(TEAL);
//       pdf.roundedRect(10, afterY, 10, 13, 2, 2, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.5);
//       pdf.text("NEXT", 11.2, afterY + 5.5);
//       pdf.text("VISIT", 11.0, afterY + 10);
//       st(TEAL);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(9);
//       pdf.text("Next Appointment:", 24, afterY + 6.5);
//       st(NAVY);
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "bold");
//       pdf.text(nextDateFmt, 72, afterY + 6.5);
//       st(GRAY);
//       pdf.setFontSize(7);
//       pdf.setFont("helvetica", "italic");
//       pdf.text(
//         "Please arrive 10 minutes early and bring this prescription.",
//         24,
//         afterY + 11,
//       );
//       afterY += 19;
//     }

//     // ── General advice box ────────────────────────────────────────
//     const advY = afterY + 4;
//     sf(GOLD2);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "F");
//     sd(GOLD);
//     pdf.setLineWidth(0.35);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "S");
//     sf(GOLD);
//     pdf.roundedRect(10, advY, 10, 20, 2, 2, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(6.2);
//     pdf.text("GEN.", 11.2, advY + 8);
//     pdf.text("ADV.", 11.2, advY + 13.5);
//     st(GOLD);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("General Advice:", 24, advY + 6.5);
//     st(GRAY2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(
//       "1.  Follow all prescribed medicines on time and complete the full course.",
//       24,
//       advY + 11.5,
//     );
//     pdf.text(
//       "2.  Maintain good oral hygiene. Brush gently twice daily.",
//       24,
//       advY + 15.5,
//     );
//     pdf.text(
//       "3.  Avoid very hot, cold, or hard foods until fully healed.",
//       24,
//       advY + 19.2,
//     );

//     // ── Watermark ─────────────────────────────────────────────────
//     pdf.saveGraphicsState();
//     pdf.setGState(new pdf.GState({ opacity: 0.035 }));
//     st(NAVY);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(44);
//     pdf.text("PEARLSMILE", W / 2, H / 2 - 5, { align: "center", angle: 35 });
//     pdf.restoreGraphicsState();

//     // ── Doctor seal ───────────────────────────────────────────────
//     const sigY = Math.max(advY + 28, H - 55);
//     const INK = [28, 52, 140],
//       INK2 = [45, 75, 170];
//     const cx = W - 46,
//       cy = sigY + 13,
//       R = 18;

//     sd(INK);
//     pdf.setLineWidth(1.2);
//     pdf.circle(cx, cy, R, "S");
//     pdf.setLineWidth(0.4);
//     pdf.circle(cx, cy, R - 2.5, "S");

//     const drawStar = (sx, sy, sr) => {
//       const pts = [];
//       for (let si = 0; si < 5; si++) {
//         const ao = (si * 4 * Math.PI) / 5 - Math.PI / 2,
//           ai = ao + (2 * Math.PI) / 5;
//         pts.push({ x: sx + sr * Math.cos(ao), y: sy + sr * Math.sin(ao) });
//         pts.push({
//           x: sx + sr * 0.4 * Math.cos(ai),
//           y: sy + sr * 0.4 * Math.sin(ai),
//         });
//       }
//       pdf.setLineWidth(0.3);
//       sd(INK);
//       sf(INK);
//       pdf.lines(
//         pts.slice(1).map((pt, i) => [pt.x - pts[i].x, pt.y - pts[i].y]),
//         pts[0].x,
//         pts[0].y,
//         [1, 1],
//         "FD",
//         true,
//       );
//     };
//     drawStar(cx - R + 3.5, cy + 1, 2.2);
//     drawStar(cx + R - 3.5, cy + 1, 2.2);

//     const docShort = (doc.name || "Doctor").toUpperCase();
//     sd(INK);
//     st(INK);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(5.8);
//     const topSpan = Math.min(docShort.length * 0.19, 1.3);
//     const topStart = -Math.PI / 2 - topSpan / 2;
//     for (let ti = 0; ti < docShort.length; ti++) {
//       const ta = topStart + (ti / Math.max(docShort.length - 1, 1)) * topSpan;
//       const tx = cx + (R - 1.5) * Math.cos(ta),
//         ty = cy + (R - 1.5) * Math.sin(ta);
//       const trot = ((ta + Math.PI / 2) * 180) / Math.PI;
//       pdf.text(docShort[ti], tx, ty, { align: "center", angle: -trot });
//     }

//     pdf.setFontSize(5.5);
//     const botStr = "PEARLSMILE DENTAL";
//     const botSpan = Math.min(botStr.length * 0.175, 1.4);
//     const botStart = Math.PI / 2 - botSpan / 2;
//     for (let bi = 0; bi < botStr.length; bi++) {
//       const ba = botStart + (bi / Math.max(botStr.length - 1, 1)) * botSpan;
//       const bx = cx + (R - 1.5) * Math.cos(ba),
//         by = cy + (R - 1.5) * Math.sin(ba);
//       const brot = ((ba - Math.PI / 2) * 180) / Math.PI;
//       pdf.text(botStr[bi], bx, by, { align: "center", angle: -brot });
//     }

//     sd(INK);
//     pdf.setLineWidth(0.8);
//     pdf.line(cx, cy - 8, cx, cy + 7);
//     pdf.setLineWidth(0.5);
//     pdf.line(cx, cy - 7.5, cx - 4, cy - 9.5);
//     pdf.line(cx - 4, cy - 9.5, cx - 6, cy - 8);
//     pdf.line(cx - 6, cy - 8, cx - 3, cy - 6.5);
//     pdf.line(cx, cy - 7.5, cx + 4, cy - 9.5);
//     pdf.line(cx + 4, cy - 9.5, cx + 6, cy - 8);
//     pdf.line(cx + 6, cy - 8, cx + 3, cy - 6.5);
//     sf(INK);
//     pdf.circle(cx, cy - 8.2, 1, "F");

//     pdf.setLineWidth(0.6);
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//         [0, -2],
//       ],
//       cx - 3,
//       cy + 5,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [-2, -2],
//         [-2, -2],
//         [0, -2],
//       ],
//       cx + 3,
//       cy + 1,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//       ],
//       cx - 3,
//       cy - 3,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [-2, -2],
//         [-2, -2],
//         [0, -2],
//       ],
//       cx + 3,
//       cy + 5,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//         [0, -2],
//       ],
//       cx - 3,
//       cy + 1,
//       [1, 1],
//       "S",
//     );

//     st(INK);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(4.5);
//     pdf.text("Reg. " + (doc.reg || "—"), cx, cy + R - 5.5, { align: "center" });
//     st(INK2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(6.5);
//     pdf.text("Authorised Signatory", cx, cy + R + 4, { align: "center" });

//     st(GRAY);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 14, sigY + 30);
//     pdf.text("Date: " + todayFmt, W - 14, sigY + 30, { align: "right" });

//     // ── Footer ────────────────────────────────────────────────────
//     sf(NAVY);
//     pdf.rect(3.5, H - 21, W - 7, 17.5, "F");
//     sf(BLUE);
//     pdf.rect(3.5, H - 7, W - 7, 3.5, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(7.5);
//     pdf.text("PearlSmile Dental Hospital", 10, H - 14.5);
//     st(LBLUE);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text("+91 87936 08083", 10, H - 9.5);
//     pdf.text("care@pearlsmiledental.in", W / 2, H - 9.5, { align: "center" });
//     pdf.text("12, Dental Plaza, MG Road, Pune - 411001", W - 10, H - 9.5, {
//       align: "right",
//     });
//     st(LBLUE2);
//     pdf.setFontSize(6);
//     pdf.setFont("helvetica", "italic");
//     pdf.text(
//       "This is a computer-generated prescription from PearlSmile Dental Hospital. Valid only with authorised doctor details.",
//       W / 2,
//       H - 5.5,
//       { align: "center" },
//     );

//     // ── Output ────────────────────────────────────────────────────
//     const blob = pdf.output("blob");
//     const url = URL.createObjectURL(blob);
//     const name =
//       "Prescription_" +
//       (patient.name || "Patient").replace(/\s+/g, "_") +
//       "_" +
//       visitDate +
//       ".pdf";

//     let rawMob = (patient.mobile || "").replace(/[\s\-\(\)\+]/g, "");
//     if (!rawMob.startsWith("91") && rawMob.length === 10)
//       rawMob = "91" + rawMob;

//     setPdfBlob(blob);
//     setPdfUrl(url);
//     setRxMobile(rawMob);
//     setFileName(name);
//     // Show native share button only if Web Share API supports files — exactly like original HTML
//     const testFile = new File([blob], name, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [testFile] })
//     ) {
//       setCanNativeShare(true);
//     }
//     setLoading(false);
//   };

//   const downloadPDF = () => {
//     const link = document.createElement("a");
//     link.href = pdfUrl;
//     link.download = fileName;
//     link.click();
//   };

//   const openFullPreview = () => {
//     if (pdfUrl) window.open(pdfUrl, "_blank");
//   };

//   const shareViaWhatsApp = () => {
//     if (rxMobile) window.open("https://wa.me/" + rxMobile, "_blank");
//     showNotify(
//       "WhatsApp Opened!",
//       "Attach the PDF from the preview and send to patient.",
//     );
//   };

//   const nativeShare = async () => {
//     if (!pdfBlob) return;
//     const file = new File([pdfBlob], fileName, { type: "application/pdf" });
//     // ── Step 1: Auto-download PDF silently so it is in Downloads ────
//     const dlLink = document.createElement("a");
//     dlLink.href = pdfUrl;
//     dlLink.download = fileName;
//     dlLink.click();
//     // ── Step 2: Try native share (mobile) — WhatsApp appears in sheet ──
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [file] })
//     ) {
//       navigator
//         .share({
//           title: "Digital Prescription — PearlSmile Dental Hospital",
//           text: "Dear Patient, please find your digital prescription attached.",
//           files: [file],
//         })
//         .then(() => {
//           showNotify("Sent! ✓", "Prescription shared successfully.");
//           onClose();
//         })
//         .catch((err) => {
//           // If cancelled or failed, open WhatsApp directly with patient number
//           if (err.name !== "AbortError") {
//             if (rxMobile) {
//               const waMsg = encodeURIComponent(
//                 "Dear Patient, your digital prescription has been generated. Please find the PDF file attached.",
//               );
//               window.open(
//                 "https://wa.me/" + rxMobile + "?text=" + waMsg,
//                 "_blank",
//               );
//             }
//           }
//         });
//     } else {
//       // ── Desktop: open WhatsApp directly with patient number ─────────
//       if (rxMobile) {
//         const waMsg = encodeURIComponent(
//           "Dear Patient, your digital prescription has been downloaded. Please check the PDF in your Downloads folder.",
//         );
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" + rxMobile + "?text=" + waMsg,
//               "_blank",
//             ),
//           600,
//         );
//         showNotify(
//           "PDF Downloaded + WhatsApp Opened! ✓",
//           "Prescription saved. WhatsApp opened to patient number.",
//         );
//       } else {
//         showNotify("PDF Downloaded ✓", "Prescription saved. Share manually.");
//       }
//     }
//   };

//   return (
//     <div
//       className="rx-share-overlay open"
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           width: "100%",
//           maxWidth: 540,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//           maxHeight: "92vh",
//         }}
//       >
//         {/* Header */}
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "18px 22px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <span style={{ fontSize: 22 }}>📄</span>
//             <div>
//               <div
//                 style={{
//                   color: "#fff",
//                   fontWeight: 600,
//                   fontSize: 15,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Digital Prescription Ready
//               </div>
//               <div
//                 style={{
//                   color: "rgba(255,255,255,0.55)",
//                   fontSize: 12,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 {patient.name} · {visit.visitDate}
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 17,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             ✕
//           </button>
//         </div>

//         {/* PDF Preview */}
//         <div
//           style={{
//             flex: 1,
//             overflow: "hidden",
//             background: "#f0eeeb",
//             minHeight: 340,
//             position: "relative",
//           }}
//         >
//           {loading && (
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: "#f0eeeb",
//                 gap: 10,
//               }}
//             >
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   border: "3px solid #0d7377",
//                   borderTopColor: "transparent",
//                   borderRadius: "50%",
//                   animation: "spin 0.8s linear infinite",
//                 }}
//               />
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "#5a5550",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Generating PDF…
//               </div>
//             </div>
//           )}
//           {pdfUrl && (
//             <iframe
//               title="prescription"
//               src={pdfUrl}
//               style={{ width: "100%", height: 420, border: "none" }}
//             />
//           )}
//         </div>

//         {/* Action buttons — exactly like original HTML */}
//         <div
//           style={{
//             padding: "16px 20px",
//             display: "flex",
//             flexDirection: "column",
//             gap: 10,
//             background: "#fff",
//           }}
//         >
//           <div style={{ display: "flex", gap: 8 }}>
//             <button
//               onClick={openFullPreview}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//             >
//               🔍 Open Full PDF
//             </button>
//             {canNativeShare && (
//               <button
//                 onClick={nativeShare}
//                 onMouseOver={(e) =>
//                   (e.currentTarget.style.background = "#e5e0d8")
//                 }
//                 onMouseOut={(e) =>
//                   (e.currentTarget.style.background = "#f0eeeb")
//                 }
//                 style={{
//                   flex: 1,
//                   background: "#f0eeeb",
//                   color: "#0a1628",
//                   border: "1.5px solid #ddd9d3",
//                   borderRadius: 10,
//                   padding: 10,
//                   fontSize: 13,
//                   fontWeight: 500,
//                   cursor: "pointer",
//                   fontFamily: "DM Sans,sans-serif",
//                   transition: "background 0.2s",
//                 }}
//               >
//                 📤 Share (Device)
//               </button>
//             )}
//           </div>
//           <p
//             style={{
//               fontSize: 11,
//               color: "#9a9590",
//               textAlign: "center",
//               margin: 0,
//               fontFamily: "DM Sans,sans-serif",
//               lineHeight: 1.5,
//             }}
//           >
//             On mobile: tap "Share (Device)" to send directly via WhatsApp.
//             <br />
//             On desktop: use "Open Full PDF" to view, then share manually.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

//mice

// // mice test 2
// // ============================================================
// // src/components/admin/PatientsTab.js
// // ✅ All original code untouched
// // ✅ NEW: 🎤 Microphone / Speech-to-text in Doctor Notes
// // ✅ NEW: 🧪 Lab Reports section (add URL, save permanently, delete)
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import api from "../../utils/api";

// const SERVICES_LIST = [
//   "General Checkup & Cleaning",
//   "Cosmetic Dentistry / Smile Makeover",
//   "Dental Implants",
//   "Orthodontics / Invisalign",
//   "Root Canal Therapy",
//   "Pediatric Dentistry",
//   "Oral Surgery",
//   "Periodontal Treatment",
//   "Teeth Whitening",
//   "Emergency Dental Care",
//   "Follow-Up Visit",
//   "Other",
// ];

// const MONTHS = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];
// const MONTHS_SHORT = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// function fmtDate(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtDateShort(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS_SHORT[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtTime(t) {
//   if (!t) return "";
//   const parts = t.split(":");
//   const hh = parseInt(parts[0]),
//     mm = parts[1];
//   return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
// }

// function totalRevenue(visits = []) {
//   return visits.reduce((sum, v) => {
//     const n = parseFloat((v.amount || "0").toString().replace(/[^0-9.]/g, ""));
//     return sum + (isNaN(n) ? 0 : n);
//   }, 0);
// }

// export default function PatientsTab({ showNotify, doctor }) {
//   const [patients, setPatients] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showNewForm, setShowNewForm] = useState(false);
//   const [newPat, setNewPat] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     age: "",
//     gender: "",
//     blood: "",
//   });
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [rxModal, setRxModal] = useState(null);
//   const [customMeds, setCustomMeds] = useState([]);

//   // ✅ NEW — Lab Reports state
//   const [labReports, setLabReports] = useState([]);
//   const [labName, setLabName] = useState("");
//   const [labUrl, setLabUrl] = useState("");
//   const [labSaving, setLabSaving] = useState(false);
//   const [labUploading, setLabUploading] = useState(false);

//   const today = new Date().toISOString().split("T")[0];
//   const nowTime = new Date().toTimeString().slice(0, 5);
//   const [visitForm, setVisitForm] = useState({
//     date: today,
//     time: nowTime,
//     service: "",
//     amount: "",
//     nextVisitDate: "",
//     notes: "",
//     rxRows: [
//       {
//         medicine: "",
//         dosageParts: ["0", "0", "0"],
//         dosageTiming: "after meal",
//         dosage: "",
//         duration: "",
//         route: "ORAL",
//       },
//     ],
//   });

//   const loadPatients = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await api.get("/patients");
//       setPatients(data);
//       setFiltered(data);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     loadPatients();
//   }, [loadPatients]);

//   useEffect(() => {
//     api
//       .get("/custommeds")
//       .then((data) => {
//         if (Array.isArray(data)) setCustomMeds(data);
//       })
//       .catch(() => {});
//   }, []);

//   const filterPatients = (q) => {
//     const term = q.toLowerCase();
//     setFiltered(
//       patients.filter(
//         (p) =>
//           (p.name || "").toLowerCase().includes(term) ||
//           (p.mobile || "").includes(term) ||
//           (p.email || "").toLowerCase().includes(term),
//       ),
//     );
//   };

//   const createPatient = async () => {
//     if (!newPat.name.trim()) {
//       showNotify("Error", "Patient name is required.", true);
//       return;
//     }
//     if (!newPat.mobile.trim()) {
//       showNotify("Error", "Mobile number is required.", true);
//       return;
//     }
//     try {
//       await api.post("/patients", newPat);
//       setNewPat({
//         name: "",
//         mobile: "",
//         email: "",
//         age: "",
//         gender: "",
//         blood: "",
//       });
//       setShowNewForm(false);
//       showNotify(
//         "Patient Profile Created! ✓",
//         "New profile for " + newPat.name + " saved.",
//       );
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const openPatient = async (p) => {
//     try {
//       const full = await api.get("/patients/" + p._id);
//       setSelectedPatient(full);
//       // ✅ NEW — load lab reports
//       setLabReports(full.labReports || []);
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deletePatient = async () => {
//     if (
//       !window.confirm(
//         "Delete this patient profile and all their records? This cannot be undone.",
//       )
//     )
//       return;
//     try {
//       await api.delete("/patients/" + selectedPatient._id);
//       showNotify("Profile Deleted", "Patient profile removed.");
//       setSelectedPatient(null);
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const saveVisit = async () => {
//     if (!visitForm.date) {
//       showNotify("Missing Fields", "Please select a visit date.", true);
//       return;
//     }
//     if (!visitForm.service) {
//       showNotify("Missing Fields", "Please select a service.", true);
//       return;
//     }
//     try {
//       const payload = {
//         visitDate: visitForm.date,
//         visitTime: visitForm.time,
//         service: visitForm.service,
//         amount: visitForm.amount,
//         nextVisitDate: visitForm.nextVisitDate,
//         notes: visitForm.notes,
//         doctor: doctor?.name || "",
//         prescription: {
//           medicineRows: visitForm.rxRows.filter((r) => r.medicine.trim()),
//         },
//       };
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/visits",
//         payload,
//       );
//       setSelectedPatient(updated);

//       if (visitForm.nextVisitDate && selectedPatient.mobile) {
//         try {
//           await api.post("/appointments", {
//             name: selectedPatient.name,
//             phone: selectedPatient.mobile,
//             service: visitForm.service,
//             date: visitForm.nextVisitDate,
//             time: "",
//             message: "Follow-up visit from Patient Profile",
//             status: "pending",
//           });
//         } catch (_) {}
//       }

//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });

//       const isFollowUp = /follow[\s\-]?up/i.test(visitForm.notes);
//       if (isFollowUp && visitForm.nextVisitDate && selectedPatient.mobile) {
//         let rawMobile = (selectedPatient.mobile || "").replace(
//           /[\s\-\(\)\+]/g,
//           "",
//         );
//         if (!rawMobile.startsWith("91") && rawMobile.length === 10)
//           rawMobile = "91" + rawMobile;
//         const waMsg = `*PearlSmile Dental Hospital* — Follow-Up Reminder\n\nDear ${selectedPatient.name},\nThis is a reminder for your follow-up appointment.\n\n*Service:* ${visitForm.service}\n*Next Visit:* ${fmtDate(visitForm.nextVisitDate)}\n\nPlease call us to confirm your appointment.\n📞 +91 87936 08083`;
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" +
//                 rawMobile +
//                 "?text=" +
//                 encodeURIComponent(waMsg),
//               "_blank",
//             ),
//           500,
//         );
//         showNotify(
//           "Visit Saved + Follow-Up Appointment Created!",
//           "Reminder sent to " +
//             selectedPatient.name +
//             " for " +
//             fmtDate(visitForm.nextVisitDate) +
//             ". Appointment added to Upcoming.",
//         );
//       } else if (visitForm.nextVisitDate) {
//         showNotify(
//           "Visit Saved + Appointment Created! ✓",
//           "Follow-up appointment for " +
//             fmtDate(visitForm.nextVisitDate) +
//             " added to Upcoming Appointments.",
//         );
//       } else {
//         showNotify(
//           "Visit Record Saved! ✓",
//           "Patient visit has been recorded successfully.",
//         );
//       }
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deleteVisit = async (visitId) => {
//     if (!window.confirm("Delete this visit record?")) return;
//     try {
//       const result = await api.delete(
//         "/patients/" + selectedPatient._id + "/visits/" + visitId,
//       );
//       setSelectedPatient(result.patient);
//       showNotify("Visit Deleted", "Visit record removed.");
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const sendPrescription = (visit) => {
//     const treatingDoctor = visit.doctor ? { name: visit.doctor } : doctor;
//     setRxModal({ visit, patient: selectedPatient, doctor: treatingDoctor });
//   };

//   // ✅ NEW — Save Lab Report permanently to MongoDB
//   const saveLabReport = async () => {
//     if (!labName.trim()) {
//       showNotify("Error", "Please enter a report name.", true);
//       return;
//     }
//     if (!labUrl.trim()) {
//       showNotify("Error", "Please enter the file URL.", true);
//       return;
//     }
//     setLabSaving(true);
//     try {
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/labreports",
//         {
//           name: labName.trim(),
//           url: labUrl.trim(),
//         },
//       );
//       setLabReports(updated.labReports || []);
//       setSelectedPatient((prev) => ({
//         ...prev,
//         labReports: updated.labReports || [],
//       }));
//       setLabName("");
//       setLabUrl("");
//       showNotify(
//         "Lab Report Saved! ✓",
//         "Report saved permanently to patient profile.",
//       );
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLabSaving(false);
//   };

//   // ✅ NEW — Delete Lab Report
//   const deleteLabReport = async (reportId) => {
//     if (!window.confirm("Delete this lab report?")) return;
//     try {
//       const updated = await api.delete(
//         "/patients/" + selectedPatient._id + "/labreports/" + reportId,
//       );
//       setLabReports(updated.labReports || []);
//       setSelectedPatient((prev) => ({
//         ...prev,
//         labReports: updated.labReports || [],
//       }));
//       showNotify("Report Deleted", "Lab report removed.");
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   // ── LIST VIEW ─────────────────────────────────────────────────
//   if (!selectedPatient) {
//     return (
//       <div>
//         <div className="admin-section-title">Patient Profiles</div>
//         <div className="admin-section-desc">
//           Create and manage individual patient profiles. Click a profile to view
//           visit history and add new records.
//         </div>
//         <div className="patients-list-view">
//           <input
//             type="text"
//             className="patient-search-bar"
//             placeholder="🔍 Search patients by name or phone..."
//             onChange={(e) => filterPatients(e.target.value)}
//           />
//           {showNewForm && (
//             <div className="new-patient-form">
//               <h4>➕ Create New Patient Profile</h4>
//               <div className="new-patient-grid">
//                 {[
//                   ["name", "text", "Full Name *", "Patient full name"],
//                   ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
//                   ["email", "email", "Email Address", "patient@email.com"],
//                   ["age", "number", "Age", "Age"],
//                 ].map(([k, t, label, ph]) => (
//                   <div key={k}>
//                     <div className="admin-row-label">{label}</div>
//                     <input
//                       type={t}
//                       placeholder={ph}
//                       value={newPat[k]}
//                       onChange={(e) =>
//                         setNewPat((p) => ({ ...p, [k]: e.target.value }))
//                       }
//                     />
//                   </div>
//                 ))}
//                 <div>
//                   <div className="admin-row-label">Gender</div>
//                   <select
//                     value={newPat.gender}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, gender: e.target.value }))
//                     }
//                   >
//                     <option value="">Select Gender</option>
//                     <option>Male</option>
//                     <option>Female</option>
//                     <option>Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <div className="admin-row-label">Blood Group</div>
//                   <input
//                     type="text"
//                     placeholder="e.g. B+"
//                     value={newPat.blood}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, blood: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//               <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                 <button className="add-visit-save-btn" onClick={createPatient}>
//                   💾 Save Patient Profile
//                 </button>
//                 <button
//                   className="btn-back-patients"
//                   onClick={() => setShowNewForm(false)}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           )}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: 14,
//               flexWrap: "wrap",
//               gap: 10,
//             }}
//           >
//             <div style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {loading
//                 ? "Loading patients..."
//                 : `${filtered.length} patient profile${filtered.length !== 1 ? "s" : ""}`}
//             </div>
//             <button
//               className="admin-add-btn"
//               onClick={() => setShowNewForm((s) => !s)}
//             >
//               {showNewForm ? "Cancel" : "+ New Patient Profile"}
//             </button>
//           </div>
//           <div className="patient-profiles-grid">
//             {loading ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "20px 0",
//                   gridColumn: "1/-1",
//                 }}
//               >
//                 Loading...
//               </div>
//             ) : filtered.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "24px 0",
//                   gridColumn: "1/-1",
//                   textAlign: "center",
//                 }}
//               >
//                 No patients yet. Click "+ New Patient Profile" to add your first
//                 patient.
//               </div>
//             ) : (
//               filtered.map((p) => (
//                 <div
//                   key={p._id}
//                   className="patient-profile-card"
//                   onClick={() => openPatient(p)}
//                 >
//                   <div className="patient-avatar-icon">🧑‍⚕️</div>
//                   <div className="patient-card-name">{p.name}</div>
//                   <div className="patient-card-id">📞 {p.mobile || "—"}</div>
//                   <div className="patient-card-visits">
//                     📋 {p.visitCount || 0} visit{p.visitCount !== 1 ? "s" : ""}
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ── DETAIL VIEW ───────────────────────────────────────────────
//   const p = selectedPatient;
//   const visits = p.visits || [];
//   const total = totalRevenue(visits);

//   return (
//     <div>
//       <div className="patient-detail-view open">
//         <div className="patient-detail-header">
//           <button
//             className="btn-back-patients"
//             onClick={() => {
//               setSelectedPatient(null);
//             }}
//           >
//             ← Back to Patients
//           </button>
//           <div
//             className="patient-avatar-icon"
//             style={{ width: 56, height: 56, fontSize: 26 }}
//           >
//             🧑‍⚕️
//           </div>
//           <div style={{ flex: 1 }}>
//             <h3>{p.name}</h3>
//             <p style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {p.email}
//               {p.email && p.mobile ? " · " : ""}
//               {p.mobile}
//             </p>
//             <div className="patient-info-row">
//               {[
//                 p.age ? "Age: " + p.age : null,
//                 p.gender || null,
//                 p.blood ? "Blood: " + p.blood : null,
//               ]
//                 .filter(Boolean)
//                 .map((t, i) => (
//                   <span key={i} className="patient-info-pill">
//                     {t}
//                   </span>
//                 ))}
//             </div>
//           </div>
//           <div style={{ textAlign: "right", flexShrink: 0 }}>
//             <div
//               style={{
//                 fontSize: 11,
//                 color: "var(--gray-400)",
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//                 marginBottom: 4,
//               }}
//             >
//               Total Revenue
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 26,
//                 fontWeight: 600,
//                 color: "var(--teal)",
//                 lineHeight: 1,
//               }}
//             >
//               Rs. {total.toLocaleString("en-IN")}
//             </div>
//             <div
//               style={{ fontSize: 11, color: "var(--gray-400)", marginTop: 2 }}
//             >
//               {visits.length} visit{visits.length !== 1 ? "s" : ""}
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 8,
//               alignSelf: "flex-start",
//               marginTop: 4,
//             }}
//           >
//             <button className="admin-del-btn" onClick={deletePatient}>
//               🗑️ Delete Profile
//             </button>
//           </div>
//         </div>

//         {/* Add Visit Form — original simple layout */}
//         <div className="add-visit-form">
//           <h4>📋 Add New Visit Record</h4>
//           <div className="add-visit-grid">
//             <div>
//               <div className="admin-row-label">Visit Date *</div>
//               <input
//                 type="date"
//                 value={visitForm.date}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, date: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Visit Time</div>
//               <input
//                 type="time"
//                 value={visitForm.time}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, time: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Service Taken *</div>
//               <select
//                 value={visitForm.service}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, service: e.target.value }))
//                 }
//               >
//                 <option value="">Select Service</option>
//                 {SERVICES_LIST.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <div className="admin-row-label">Amount Charged (Rs.)</div>
//               <input
//                 type="text"
//                 placeholder="e.g. 2500"
//                 value={visitForm.amount}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, amount: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div
//                 className="admin-row-label"
//                 style={{ display: "flex", alignItems: "center", gap: 6 }}
//               >
//                 Next Date to Visit
//                 <span
//                   style={{
//                     fontSize: 10,
//                     color: "var(--teal)",
//                     fontWeight: 400,
//                     background: "rgba(13,115,119,0.08)",
//                     padding: "2px 8px",
//                     borderRadius: 100,
//                     border: "1px solid rgba(13,115,119,0.2)",
//                   }}
//                 >
//                   For follow-up
//                 </span>
//               </div>
//               <input
//                 type="date"
//                 value={visitForm.nextVisitDate}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, nextVisitDate: e.target.value }))
//                 }
//                 style={{ marginTop: 6 }}
//               />
//             </div>
//           </div>

//           {/* ── Prescription Table ─────────────────────────── */}
//           <style>{`
//             @media (max-width: 640px) { .rx-table-desktop { display: none !important; } .rx-card-mobile { display: block !important; } }
//             @media (min-width: 641px) { .rx-table-desktop { display: block !important; } .rx-card-mobile { display: none !important; } }
//             @keyframes micPulse { 0%,100% { box-shadow: 0 0 0 0 rgba(220,38,38,0.5); } 70% { box-shadow: 0 0 0 10px rgba(220,38,38,0); } }
//             .mic-active { animation: micPulse 1.2s ease-in-out infinite; background: #dc2626 !important; border-color: #dc2626 !important; }
//           `}</style>
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 8 }}
//           >
//             💊 Prescription
//           </div>

//           {/* ── DESKTOP TABLE ── */}
//           <div
//             className="rx-table-desktop"
//             style={{
//               overflowX: "auto",
//               marginBottom: 8,
//               position: "relative",
//               zIndex: 1000,
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: 13,
//                 fontFamily: "'DM Sans',sans-serif",
//                 minWidth: 560,
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                     color: "#fff",
//                   }}
//                 >
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 36,
//                     }}
//                   >
//                     SR.
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     MEDICINE
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     DOSAGE INSTRUCTION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     DURATION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     ROUTE
//                   </th>
//                   <th style={{ padding: "8px 10px", width: 32 }}></th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {visitForm.rxRows.map((row, idx) => (
//                   <tr
//                     key={idx}
//                     style={{
//                       background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                       borderBottom: "1px solid #e8e4e0",
//                     }}
//                   >
//                     <td
//                       style={{
//                         padding: "6px 10px",
//                         color: "#666",
//                         fontSize: 12,
//                         textAlign: "center",
//                       }}
//                     >
//                       {idx + 1}
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <RxMedInput
//                         value={row.medicine}
//                         onChange={(v) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], medicine: v };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         customMeds={customMeds}
//                         apiPost={api.post}
//                         onCustomSaved={(saved) => {
//                           if (saved && saved._id) {
//                             setCustomMeds((prev) => {
//                               const exists = prev.some(
//                                 (m) =>
//                                   m._id === saved._id ||
//                                   m.name.toLowerCase() ===
//                                     saved.name.toLowerCase(),
//                               );
//                               if (exists) return prev;
//                               return [saved, ...prev];
//                             });
//                           } else {
//                             api
//                               .get("/custommeds")
//                               .then((data) => {
//                                 if (Array.isArray(data)) setCustomMeds(data);
//                               })
//                               .catch(() => {});
//                           }
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                           flexWrap: "nowrap",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 2,
//                           }}
//                         >
//                           {["M", "A", "N"].map((label, li) => (
//                             <div
//                               key={label}
//                               style={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   fontSize: 9,
//                                   color: "#888",
//                                   marginBottom: 1,
//                                 }}
//                               >
//                                 {label}
//                               </span>
//                               <input
//                                 type="text"
//                                 maxLength={2}
//                                 value={
//                                   (row.dosageParts || ["0", "0", "0"])[li] ||
//                                   "0"
//                                 }
//                                 onFocus={(e) => {
//                                   if (e.target.value === "0") e.target.select();
//                                 }}
//                                 onChange={(e) => {
//                                   const rows = [...visitForm.rxRows];
//                                   const parts = [
//                                     ...(rows[idx].dosageParts || [
//                                       "0",
//                                       "0",
//                                       "0",
//                                     ]),
//                                   ];
//                                   parts[li] =
//                                     e.target.value === ""
//                                       ? "0"
//                                       : e.target.value;
//                                   rows[idx] = {
//                                     ...rows[idx],
//                                     dosageParts: parts,
//                                     dosage:
//                                       parts.join("-") +
//                                       (rows[idx].dosageTiming
//                                         ? " " + rows[idx].dosageTiming
//                                         : ""),
//                                   };
//                                   setVisitForm((f) => ({ ...f, rxRows: rows }));
//                                 }}
//                                 style={{
//                                   width: 28,
//                                   border: "1px solid #ddd",
//                                   borderRadius: 4,
//                                   padding: "4px 3px",
//                                   fontSize: 12,
//                                   textAlign: "center",
//                                   fontFamily: "'DM Sans',sans-serif",
//                                 }}
//                               />
//                             </div>
//                           ))}
//                         </div>
//                         <select
//                           value={row.dosageTiming || "after meal"}
//                           onChange={(e) => {
//                             const rows = [...visitForm.rxRows];
//                             const parts = rows[idx].dosageParts || [
//                               "0",
//                               "0",
//                               "0",
//                             ];
//                             rows[idx] = {
//                               ...rows[idx],
//                               dosageTiming: e.target.value,
//                               dosage: parts.join("-") + " " + e.target.value,
//                             };
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             border: "1px solid #ddd",
//                             borderRadius: 4,
//                             padding: "4px 5px",
//                             fontSize: 11,
//                             fontFamily: "'DM Sans',sans-serif",
//                             color: "#444",
//                           }}
//                         >
//                           <option>after meal</option>
//                           <option>before meal</option>
//                           <option>with meal</option>
//                           <option>empty stomach</option>
//                           <option>at bedtime</option>
//                           <option>as directed</option>
//                         </select>
//                       </div>
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <input
//                         type="text"
//                         placeholder="e.g. 7 days"
//                         value={row.duration}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = {
//                             ...rows[idx],
//                             duration: e.target.value,
//                           };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 8px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <select
//                         value={row.route}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], route: e.target.value };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 6px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       >
//                         <option>ORAL</option>
//                         <option>TOPICAL</option>
//                         <option>INJECTION</option>
//                         <option>INHALER</option>
//                         <option>DROPS</option>
//                         <option>GARGLE</option>
//                         <option>OTHER</option>
//                       </select>
//                     </td>
//                     <td style={{ padding: "4px 6px", textAlign: "center" }}>
//                       {visitForm.rxRows.length > 1 && (
//                         <button
//                           onClick={() => {
//                             const rows = visitForm.rxRows.filter(
//                               (_, i) => i !== idx,
//                             );
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             background: "none",
//                             border: "none",
//                             color: "#e74c3c",
//                             fontSize: 16,
//                             cursor: "pointer",
//                             padding: "2px 6px",
//                           }}
//                           title="Remove"
//                         >
//                           ✕
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* ── MOBILE CARDS ── */}
//           <div className="rx-card-mobile" style={{ marginBottom: 8 }}>
//             {visitForm.rxRows.map((row, idx) => (
//               <div
//                 key={idx}
//                 style={{
//                   background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                   border: "1px solid #e8e4e0",
//                   borderRadius: 8,
//                   padding: "10px 12px",
//                   marginBottom: 8,
//                   position: "relative",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: 8,
//                   }}
//                 >
//                   <span
//                     style={{
//                       fontSize: 11,
//                       fontWeight: 700,
//                       color: "#0a1628",
//                       background: "rgba(10,22,40,0.08)",
//                       padding: "2px 8px",
//                       borderRadius: 20,
//                     }}
//                   >
//                     #{idx + 1}
//                   </span>
//                   {visitForm.rxRows.length > 1 && (
//                     <button
//                       onClick={() => {
//                         const rows = visitForm.rxRows.filter(
//                           (_, i) => i !== idx,
//                         );
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         background: "none",
//                         border: "none",
//                         color: "#e74c3c",
//                         fontSize: 16,
//                         cursor: "pointer",
//                         padding: "2px 6px",
//                       }}
//                       title="Remove"
//                     >
//                       ✕
//                     </button>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Medicine
//                   </div>
//                   <RxMedInput
//                     value={row.medicine}
//                     onChange={(v) => {
//                       const rows = [...visitForm.rxRows];
//                       rows[idx] = { ...rows[idx], medicine: v };
//                       setVisitForm((f) => ({ ...f, rxRows: rows }));
//                     }}
//                     customMeds={customMeds}
//                     apiPost={api.post}
//                     onCustomSaved={(saved) => {
//                       if (saved && saved._id) {
//                         setCustomMeds((prev) => {
//                           const exists = prev.some(
//                             (m) =>
//                               m._id === saved._id ||
//                               m.name.toLowerCase() === saved.name.toLowerCase(),
//                           );
//                           if (exists) return prev;
//                           return [saved, ...prev];
//                         });
//                       } else {
//                         api
//                           .get("/custommeds")
//                           .then((data) => {
//                             if (Array.isArray(data)) setCustomMeds(data);
//                           })
//                           .catch(() => {});
//                       }
//                     }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Dosage Instruction
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 6,
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <div
//                       style={{ display: "flex", alignItems: "center", gap: 4 }}
//                     >
//                       {["M", "A", "N"].map((label, li) => (
//                         <div
//                           key={label}
//                           style={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                           }}
//                         >
//                           <span
//                             style={{
//                               fontSize: 9,
//                               color: "#888",
//                               marginBottom: 1,
//                             }}
//                           >
//                             {label}
//                           </span>
//                           <input
//                             type="text"
//                             maxLength={2}
//                             value={
//                               (row.dosageParts || ["0", "0", "0"])[li] || "0"
//                             }
//                             onFocus={(e) => {
//                               if (e.target.value === "0") e.target.select();
//                             }}
//                             onChange={(e) => {
//                               const rows = [...visitForm.rxRows];
//                               const parts = [
//                                 ...(rows[idx].dosageParts || ["0", "0", "0"]),
//                               ];
//                               parts[li] =
//                                 e.target.value === "" ? "0" : e.target.value;
//                               rows[idx] = {
//                                 ...rows[idx],
//                                 dosageParts: parts,
//                                 dosage:
//                                   parts.join("-") +
//                                   (rows[idx].dosageTiming
//                                     ? " " + rows[idx].dosageTiming
//                                     : ""),
//                               };
//                               setVisitForm((f) => ({ ...f, rxRows: rows }));
//                             }}
//                             style={{
//                               width: 34,
//                               border: "1px solid #ddd",
//                               borderRadius: 4,
//                               padding: "5px 3px",
//                               fontSize: 13,
//                               textAlign: "center",
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                     <select
//                       value={row.dosageTiming || "after meal"}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         const parts = rows[idx].dosageParts || ["0", "0", "0"];
//                         rows[idx] = {
//                           ...rows[idx],
//                           dosageTiming: e.target.value,
//                           dosage: parts.join("-") + " " + e.target.value,
//                         };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         flex: 1,
//                         border: "1px solid #ddd",
//                         borderRadius: 4,
//                         padding: "5px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         color: "#444",
//                         minWidth: 120,
//                       }}
//                     >
//                       <option>after meal</option>
//                       <option>before meal</option>
//                       <option>with meal</option>
//                       <option>empty stomach</option>
//                       <option>at bedtime</option>
//                       <option>as directed</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div style={{ display: "flex", gap: 8 }}>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Duration
//                     </div>
//                     <input
//                       type="text"
//                       placeholder="e.g. 7 days"
//                       value={row.duration}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], duration: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 8px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         boxSizing: "border-box",
//                       }}
//                     />
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Route
//                     </div>
//                     <select
//                       value={row.route}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], route: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                       }}
//                     >
//                       <option>ORAL</option>
//                       <option>TOPICAL</option>
//                       <option>INJECTION</option>
//                       <option>INHALER</option>
//                       <option>DROPS</option>
//                       <option>GARGLE</option>
//                       <option>OTHER</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button
//             onClick={() =>
//               setVisitForm((f) => ({
//                 ...f,
//                 rxRows: [
//                   ...f.rxRows,
//                   {
//                     medicine: "",
//                     dosageParts: ["0", "0", "0"],
//                     dosageTiming: "after meal",
//                     dosage: "",
//                     duration: "",
//                     route: "ORAL",
//                   },
//                 ],
//               }))
//             }
//             style={{
//               marginTop: 4,
//               marginBottom: 8,
//               background: "rgba(13,115,119,0.08)",
//               border: "1px solid rgba(13,115,119,0.3)",
//               color: "var(--teal)",
//               borderRadius: 7,
//               padding: "6px 16px",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             + Add Medicine
//           </button>

//           {/* ── Doctor Notes / Diagnosis — ✅ NOW WITH 🎤 MIC ───────── */}
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 10 }}
//           >
//             Doctor Notes / Diagnosis
//           </div>
//           <MedAutocompleteWithMic
//             value={visitForm.notes}
//             onChange={(v) => setVisitForm((f) => ({ ...f, notes: v }))}
//             customMeds={customMeds}
//             apiPost={api.post}
//             onCustomSaved={(saved) => {
//               if (saved && saved._id) {
//                 setCustomMeds((prev) => {
//                   const exists = prev.some(
//                     (m) =>
//                       m._id === saved._id ||
//                       m.name.toLowerCase() === saved.name.toLowerCase(),
//                   );
//                   if (exists) return prev;
//                   return [saved, ...prev];
//                 });
//               } else {
//                 api
//                   .get("/custommeds")
//                   .then((data) => {
//                     if (Array.isArray(data)) setCustomMeds(data);
//                   })
//                   .catch(() => {});
//               }
//             }}
//           />
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               flexWrap: "wrap",
//               gap: 10,
//               marginTop: 4,
//             }}
//           >
//             <button className="add-visit-save-btn" onClick={saveVisit}>
//               💾 Save Visit Record
//             </button>
//           </div>
//         </div>

//         {/* Visit History */}
//         <div style={{ marginBottom: 12 }}>
//           <div className="admin-section-title" style={{ marginBottom: 8 }}>
//             Visit History
//           </div>
//           <div className="visit-records-list">
//             {visits.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 13,
//                   padding: "10px 0",
//                 }}
//               >
//                 No visits recorded yet. Add the first visit above.
//               </div>
//             ) : (
//               visits.map((v, i) => {
//                 const dtStr =
//                   (v.visitDate || "") +
//                   (v.visitTime ? " at " + v.visitTime : "");
//                 const isFollowUp = /follow[\s\-]?up/i.test(v.notes || "");
//                 return (
//                   <div key={v._id || i} className="visit-record-card">
//                     <button
//                       className="visit-del-btn"
//                       onClick={() => deleteVisit(v._id)}
//                       title="Delete"
//                     >
//                       ✕
//                     </button>
//                     <div className="visit-record-meta">
//                       <span className="visit-record-service">
//                         {v.service || "Visit"}
//                       </span>
//                       <span className="visit-record-date">📅 {dtStr}</span>
//                       {v.amount && (
//                         <span
//                           className="patient-info-pill"
//                           style={{ fontSize: 11 }}
//                         >
//                           Rs. {v.amount}
//                         </span>
//                       )}
//                       {v.doctor && (
//                         <span
//                           style={{
//                             fontSize: 11,
//                             color: "var(--teal)",
//                             fontWeight: 600,
//                             background: "rgba(13,115,119,0.08)",
//                             padding: "2px 8px",
//                             borderRadius: 100,
//                             border: "1px solid rgba(13,115,119,0.2)",
//                           }}
//                         >
//                           👨‍⚕️ {v.doctor}
//                         </span>
//                       )}
//                     </div>
//                     <div className="visit-record-notes">{v.notes || "—"}</div>
//                     {v.prescription &&
//                       v.prescription.medicineRows &&
//                       v.prescription.medicineRows.length > 0 && (
//                         <div style={{ marginTop: 10, overflowX: "auto" }}>
//                           <table
//                             style={{
//                               width: "100%",
//                               borderCollapse: "collapse",
//                               fontSize: 12,
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           >
//                             <thead>
//                               <tr
//                                 style={{
//                                   background:
//                                     "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                                   color: "#fff",
//                                 }}
//                               >
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 30,
//                                   }}
//                                 >
//                                   SR.
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   MEDICINE
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   DOSAGE INSTRUCTION
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 90,
//                                   }}
//                                 >
//                                   DUR. / ROUTE
//                                 </th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {v.prescription.medicineRows.map((row, ri) => (
//                                 <tr
//                                   key={ri}
//                                   style={{
//                                     background:
//                                       ri % 2 === 0 ? "#f8f9fc" : "#fff",
//                                     borderBottom: "1px solid #e8e4e0",
//                                   }}
//                                 >
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                       textAlign: "center",
//                                     }}
//                                   >
//                                     {ri + 1}.
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       fontWeight: 600,
//                                       color: "#0a1628",
//                                     }}
//                                   >
//                                     {row.medicine || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#444",
//                                     }}
//                                   >
//                                     {row.dosage || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                     }}
//                                   >
//                                     {row.duration}
//                                     {row.duration && row.route ? " / " : ""}
//                                     {row.route}
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       )}
//                     {v.nextVisitDate && (
//                       <div
//                         style={{
//                           marginTop: 8,
//                           display: "inline-flex",
//                           alignItems: "center",
//                           gap: 6,
//                           background: isFollowUp
//                             ? "rgba(201,168,76,0.12)"
//                             : "rgba(13,115,119,0.08)",
//                           border:
//                             "1px solid " +
//                             (isFollowUp
//                               ? "rgba(201,168,76,0.35)"
//                               : "rgba(13,115,119,0.2)"),
//                           borderRadius: 100,
//                           padding: "3px 12px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           color: isFollowUp ? "#8b6914" : "var(--teal)",
//                         }}
//                       >
//                         {isFollowUp ? "Follow-Up: " : "Next Visit: "}
//                         {fmtDateShort(v.nextVisitDate)}
//                         {isFollowUp ? " — WhatsApp sent" : ""}
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 8,
//                         marginTop: 10,
//                         flexWrap: "wrap",
//                       }}
//                     >
//                       <button
//                         onClick={() => sendPrescription(v)}
//                         style={{
//                           background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Send Prescription
//                       </button>
//                       <button
//                         onClick={() => {
//                           let mob = (p.mobile || "").replace(
//                             /[\s\-\(\)\+]/g,
//                             "",
//                           );
//                           if (!mob) {
//                             alert("No mobile number saved for this patient.");
//                             return;
//                           }
//                           if (!mob.startsWith("91") && mob.length === 10)
//                             mob = "91" + mob;
//                           const msg = encodeURIComponent(
//                             ` *Welcome to PearlSmile Dental Hospital!*\n\nDear ${p.name},\n\nWe warmly welcome you to our family. It is a pleasure to have you with us.\n\nWe are committed to providing you the best dental care and a comfortable experience throughout your journey with us.\n\n_Wishing you great health and a beautiful smile!_\n— *PearlSmile Dental Hospital Team*`,
//                           );
//                           window.open(
//                             "https://wa.me/" + mob + "?text=" + msg,
//                             "_blank",
//                           );
//                         }}
//                         style={{
//                           background: "linear-gradient(135deg,#25d366,#128c7e)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Patient Number
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>

//         {/* ✅ NEW: Lab Reports Section */}
//         <div style={{ marginBottom: 24 }}>
//           <div className="admin-section-title" style={{ marginBottom: 8 }}>
//             🧪 Lab Reports
//           </div>
//           <div style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
//             Upload patient lab reports by pasting a public file URL (Google
//             Drive, Dropbox, etc). Saved permanently to this patient profile.
//           </div>
//           {/* Add Report Form */}
//           <div
//             style={{
//               background: "#f8fafc",
//               border: "1.5px solid #e2e8f0",
//               borderRadius: 12,
//               padding: 16,
//               marginBottom: 16,
//             }}
//           >
//             {/* Row 1: Report Name */}
//             <div style={{ marginBottom: 12 }}>
//               <div
//                 style={{
//                   fontSize: 12,
//                   fontWeight: 600,
//                   color: "#475569",
//                   marginBottom: 4,
//                 }}
//               >
//                 Report Name *
//               </div>
//               <input
//                 type="text"
//                 placeholder="e.g. Blood Report, X-Ray, OPG"
//                 value={labName}
//                 onChange={(e) => setLabName(e.target.value)}
//                 style={{
//                   width: "100%",
//                   padding: "9px 12px",
//                   borderRadius: 8,
//                   border: "1.5px solid #e2e8f0",
//                   fontSize: 13,
//                   fontFamily: "DM Sans,sans-serif",
//                   outline: "none",
//                   background: "#fff",
//                   boxSizing: "border-box",
//                 }}
//               />
//             </div>
//             {/* Row 2: File Upload OR URL */}
//             <div style={{ marginBottom: 12 }}>
//               <div
//                 style={{
//                   fontSize: 12,
//                   fontWeight: 600,
//                   color: "#475569",
//                   marginBottom: 8,
//                 }}
//               >
//                 Attach File or Paste URL *
//               </div>
//               {/* File Upload Button */}
//               <div
//                 style={{
//                   display: "flex",
//                   gap: 10,
//                   alignItems: "center",
//                   marginBottom: 8,
//                   flexWrap: "wrap",
//                 }}
//               >
//                 <label
//                   style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 7,
//                     padding: "9px 16px",
//                     background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                     color: "#fff",
//                     borderRadius: 8,
//                     fontSize: 13,
//                     fontWeight: 600,
//                     cursor: "pointer",
//                     fontFamily: "DM Sans,sans-serif",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   📎 Upload File
//                   <input
//                     type="file"
//                     accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
//                     style={{ display: "none" }}
//                     onChange={(e) => {
//                       const file = e.target.files[0];
//                       if (!file) return;
//                       // Auto-fill report name from filename if empty
//                       if (!labName.trim()) {
//                         setLabName(file.name.replace(/\.[^/.]+$/, ""));
//                       }
//                       setLabUploading(true);
//                       setLabUrl(""); // clear URL field
//                       // Convert to base64 data URL for preview; store as data URL
//                       const reader = new FileReader();
//                       reader.onload = (ev) => {
//                         setLabUrl(ev.target.result);
//                         setLabUploading(false);
//                       };
//                       reader.onerror = () => {
//                         showNotify("Error", "Could not read file.", true);
//                         setLabUploading(false);
//                       };
//                       reader.readAsDataURL(file);
//                     }}
//                   />
//                 </label>
//                 <span style={{ fontSize: 12, color: "#94a3b8" }}>
//                   or paste a public link below
//                 </span>
//               </div>
//               {/* URL Input */}
//               <input
//                 type="url"
//                 placeholder="https://drive.google.com/file/d/... or https://cloudinary.com/..."
//                 value={labUrl.startsWith("data:") ? "" : labUrl}
//                 onChange={(e) => setLabUrl(e.target.value)}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter") saveLabReport();
//                 }}
//                 disabled={labUrl.startsWith("data:")}
//                 style={{
//                   width: "100%",
//                   padding: "9px 12px",
//                   borderRadius: 8,
//                   border: "1.5px solid #e2e8f0",
//                   fontSize: 13,
//                   fontFamily: "DM Sans,sans-serif",
//                   outline: "none",
//                   background: labUrl.startsWith("data:") ? "#f1f5f9" : "#fff",
//                   boxSizing: "border-box",
//                   color: labUrl.startsWith("data:") ? "#94a3b8" : "#0a1628",
//                 }}
//               />
//               {/* File preview strip */}
//               {labUrl.startsWith("data:") && (
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 10,
//                     marginTop: 8,
//                     background: "#f0fdf4",
//                     border: "1px solid #86efac",
//                     borderRadius: 8,
//                     padding: "8px 12px",
//                   }}
//                 >
//                   <span style={{ fontSize: 18 }}>
//                     {labUrl.startsWith("data:image") ? "🖼️" : "📄"}
//                   </span>
//                   <span
//                     style={{
//                       fontSize: 12,
//                       color: "#16a34a",
//                       fontWeight: 600,
//                       flex: 1,
//                     }}
//                   >
//                     File loaded and ready to save
//                   </span>
//                   <button
//                     onClick={() => {
//                       setLabUrl("");
//                     }}
//                     style={{
//                       background: "none",
//                       border: "none",
//                       color: "#dc2626",
//                       cursor: "pointer",
//                       fontSize: 13,
//                       fontWeight: 600,
//                     }}
//                   >
//                     ✕ Remove
//                   </button>
//                 </div>
//               )}
//             </div>
//             {/* Save Button */}
//             <button
//               onClick={saveLabReport}
//               disabled={labSaving || labUploading}
//               style={{
//                 padding: "10px 22px",
//                 background:
//                   labSaving || labUploading
//                     ? "#94a3b8"
//                     : "linear-gradient(135deg,#0d7377,#14a0a5)",
//                 color: "#fff",
//                 border: "none",
//                 borderRadius: 8,
//                 fontSize: 13,
//                 fontWeight: 700,
//                 cursor: labSaving || labUploading ? "not-allowed" : "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//               }}
//             >
//               {labUploading
//                 ? "⏳ Loading file..."
//                 : labSaving
//                   ? "Saving..."
//                   : "💾 Save Report"}
//             </button>
//             <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 8 }}>
//               💡 Upload: PDF, images, Word, Excel (stored in this browser
//               session). For permanent cloud storage paste a Google Drive /
//               Cloudinary public link.
//             </div>
//           </div>
//           {/* Lab Reports List */}
//           {labReports.length === 0 ? (
//             <div style={{ color: "#94a3b8", fontSize: 13, padding: "12px 0" }}>
//               No lab reports saved yet. Add the first report above.
//             </div>
//           ) : (
//             <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//               {labReports.map((report, i) => (
//                 <div
//                   key={report._id || i}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 12,
//                     background: "#fff",
//                     border: "1.5px solid #e2e8f0",
//                     borderRadius: 10,
//                     padding: "12px 16px",
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: 40,
//                       height: 40,
//                       background: "rgba(13,115,119,0.08)",
//                       borderRadius: 8,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       fontSize: 20,
//                       flexShrink: 0,
//                     }}
//                   >
//                     🧪
//                   </div>
//                   <div style={{ flex: 1, minWidth: 0 }}>
//                     <div
//                       style={{
//                         fontWeight: 600,
//                         fontSize: 14,
//                         color: "#0a1628",
//                         marginBottom: 2,
//                       }}
//                     >
//                       {report.name}
//                     </div>
//                     <div style={{ fontSize: 11, color: "#94a3b8" }}>
//                       {report.uploadedAt
//                         ? new Date(report.uploadedAt).toLocaleDateString(
//                             "en-IN",
//                             { day: "numeric", month: "short", year: "numeric" },
//                           )
//                         : ""}
//                     </div>
//                   </div>
//                   <a
//                     href={report.url}
//                     target="_blank"
//                     rel="noreferrer"
//                     style={{
//                       padding: "7px 14px",
//                       background: "rgba(13,115,119,0.08)",
//                       color: "#0d7377",
//                       border: "1px solid rgba(13,115,119,0.2)",
//                       borderRadius: 8,
//                       fontSize: 12,
//                       fontWeight: 600,
//                       textDecoration: "none",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     🔗 View Report
//                   </a>
//                   <button
//                     onClick={() => deleteLabReport(report._id)}
//                     style={{
//                       padding: "7px 10px",
//                       background: "#fef2f2",
//                       color: "#dc2626",
//                       border: "1px solid #fca5a5",
//                       borderRadius: 8,
//                       fontSize: 12,
//                       cursor: "pointer",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     🗑️ Delete
//                   </button>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>

//       {rxModal && (
//         <PrescriptionModal
//           visit={rxModal.visit}
//           patient={rxModal.patient}
//           doctor={rxModal.doctor}
//           onClose={() => setRxModal(null)}
//           showNotify={showNotify}
//         />
//       )}
//     </div>
//   );
// }

// // ── Medicine Database ─────────────────────────────────────────
// const MEDICINE_DB = [
//   { name: "Amoxicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 875mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin 125mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin 250mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 375mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 625mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 1000mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 228.5mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Azithromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Clindamycin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 600mg Injection", cat: "Antibiotic Inj" },
//   { name: "Metronidazole 200mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 400mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Infusion", cat: "Antibiotic Inj" },
//   { name: "Ciprofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 750mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 200mg/100ml Infusion", cat: "Antibiotic Inj" },
//   { name: "Doxycycline 100mg Capsule", cat: "Antibiotic" },
//   { name: "Doxycycline 200mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Tinidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ornidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Secnidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Co-Amoxiclav 375mg Tablet", cat: "Antibiotic" },
//   { name: "Co-Amoxiclav 625mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 750mg Tablet", cat: "Antibiotic" },
//   { name: "Ofloxacin 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ofloxacin 400mg Tablet", cat: "Antibiotic" },
//   { name: "Cephalexin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Cephalexin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Cefixime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 400mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 50mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Cefuroxime 250mg Tablet", cat: "Antibiotic" },
//   { name: "Cefuroxime 500mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ceftriaxone 250mg Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 2g Injection", cat: "Antibiotic Inj" },
//   { name: "Amikacin 250mg Injection", cat: "Antibiotic Inj" },
//   { name: "Amikacin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Gentamicin 40mg Injection", cat: "Antibiotic Inj" },
//   { name: "Gentamicin 80mg Injection", cat: "Antibiotic Inj" },
//   { name: "Vancomycin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Vancomycin 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Meropenem 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Meropenem 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Piperacillin + Tazobactam 4.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Imipenem + Cilastatin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Linezolid 600mg Tablet", cat: "Antibiotic" },
//   { name: "Linezolid 600mg Infusion", cat: "Antibiotic Inj" },
//   { name: "Colistin 1 MU Injection", cat: "Antibiotic Inj" },
//   { name: "Tetracycline 250mg Capsule", cat: "Antibiotic" },
//   { name: "Tetracycline 500mg Capsule", cat: "Antibiotic" },
//   { name: "Chloramphenicol 250mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin + Sulbactam 1.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Nitrofurantoin 50mg Capsule", cat: "Antibiotic" },
//   { name: "Nitrofurantoin 100mg Capsule", cat: "Antibiotic" },
//   { name: "Norfloxacin 400mg Tablet", cat: "Antibiotic" },
//   { name: "Trimethoprim + Sulfamethoxazole 480mg Tablet", cat: "Antibiotic" },
//   { name: "Trimethoprim + Sulfamethoxazole 960mg Tablet", cat: "Antibiotic" },
//   { name: "Cefoperazone + Sulbactam 1.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Cefoperazone + Sulbactam 3g Injection", cat: "Antibiotic Inj" },
//   { name: "Ertapenem 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Tigecycline 50mg Injection", cat: "Antibiotic Inj" },
//   { name: "Fosfomycin 3g Sachet", cat: "Antibiotic" },
//   { name: "Rifampicin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Rifampicin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Isoniazid 100mg Tablet", cat: "Antibiotic" },
//   { name: "Isoniazid 300mg Tablet", cat: "Antibiotic" },
//   { name: "Pyrazinamide 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ethambutol 400mg Tablet", cat: "Antibiotic" },
//   { name: "Streptomycin 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 250mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 150mg/ml Drops", cat: "Painkiller" },
//   { name: "Paracetamol 500mg/100ml Infusion", cat: "Painkiller Inj" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 100mg/5ml Syrup", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Injection", cat: "NSAID Inj" },
//   { name: "Ketorolac 10mg Tablet", cat: "NSAID" },
//   { name: "Ketorolac 30mg Injection", cat: "NSAID Inj" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Piroxicam 10mg Tablet", cat: "NSAID" },
//   { name: "Piroxicam 20mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 120mg Tablet", cat: "NSAID" },
//   { name: "Celecoxib 100mg Capsule", cat: "NSAID" },
//   { name: "Celecoxib 200mg Capsule", cat: "NSAID" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol 100mg SR Tablet", cat: "Opioid Analgesic" },
//   { name: "Tramadol 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Morphine 10mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Morphine 15mg Tablet", cat: "Opioid Analgesic" },
//   { name: "Fentanyl 50mcg/ml Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pentazocine 30mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pethidine 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Buprenorphine 0.3mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Tapentadol 50mg Tablet", cat: "Opioid Analgesic" },
//   { name: "Tapentadol 100mg Tablet", cat: "Opioid Analgesic" },
//   { name: "Lignocaine 2% Dental Cartridge (1.8ml)", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine + Adrenaline 2% Dental Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% Heavy Spinal Injection", cat: "Local Anaesthetic" },
//   { name: "Mepivacaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Prilocaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Lignocaine 2% Plain Injection 30ml Vial", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine 2% + Adrenaline Injection Vial",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Lignocaine 10% Topical Spray", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 2% Viscous Gel", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 5% Ointment", cat: "Local Anaesthetic Topical" },
//   { name: "Benzocaine 20% Topical Gel", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lignocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine Jelly 2%", cat: "Local Anaesthetic Topical" },
//   { name: "Ropivacaine 0.2% Injection", cat: "Local Anaesthetic" },
//   { name: "Ropivacaine 0.75% Injection", cat: "Local Anaesthetic" },
//   {
//     name: "Tetracaine (Amethocaine) Eye Drops",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Propofol 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 500mg Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Thiopentone Sodium 500mg Injection", cat: "General Anaesthesia" },
//   { name: "Midazolam 1mg/ml Injection", cat: "Sedative / Anaesthesia" },
//   { name: "Midazolam 5mg/ml Injection", cat: "Sedative / Anaesthesia" },
//   { name: "Midazolam 7.5mg Tablet", cat: "Sedative" },
//   { name: "Isoflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Sevoflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Desflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Nitrous Oxide Gas", cat: "Inhalation Anaesthetic" },
//   { name: "Oxygen Gas Cylinder", cat: "Medical Gas" },
//   { name: "Succinylcholine 100mg Injection", cat: "Muscle Relaxant" },
//   { name: "Vecuronium 4mg Injection", cat: "Muscle Relaxant" },
//   { name: "Atracurium 25mg Injection", cat: "Muscle Relaxant" },
//   { name: "Rocuronium 50mg Injection", cat: "Muscle Relaxant" },
//   { name: "Neostigmine 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Atropine 0.6mg Injection", cat: "Anticholinergic" },
//   { name: "Glycopyrrolate 0.2mg Injection", cat: "Anticholinergic" },
//   { name: "Dexamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Betamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 40mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 16mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 40mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 125mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone 10mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone Acetonide 0.1% Oral Paste", cat: "Steroid Topical" },
//   { name: "Kenacort 0.1% Dental Paste", cat: "Steroid Topical" },
//   { name: "Betamethasone Gel Oral 0.025%", cat: "Steroid Topical" },
//   { name: "Fluconazole 50mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 2mg/ml Infusion", cat: "Antifungal Inj" },
//   { name: "Itraconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Voriconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Amphotericin B 50mg Injection", cat: "Antifungal Inj" },
//   { name: "Clotrimazole 1% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin 100000 IU/ml Oral Drops", cat: "Antifungal" },
//   { name: "Nystatin 500000 IU Tablet", cat: "Antifungal" },
//   { name: "Clotrimazole + Betamethasone Cream", cat: "Antifungal Topical" },
//   { name: "Ketoconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Ketoconazole 2% Shampoo", cat: "Antifungal Topical" },
//   { name: "Terbinafine 250mg Tablet", cat: "Antifungal" },
//   { name: "Acyclovir 200mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 400mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 800mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 5% Cream", cat: "Antiviral Topical" },
//   { name: "Acyclovir 250mg Injection", cat: "Antiviral Inj" },
//   { name: "Valacyclovir 500mg Tablet", cat: "Antiviral" },
//   { name: "Valacyclovir 1000mg Tablet", cat: "Antiviral" },
//   { name: "Famciclovir 250mg Tablet", cat: "Antiviral" },
//   { name: "Oseltamivir 75mg Capsule", cat: "Antiviral" },
//   { name: "Chlorhexidine Gluconate 0.2% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine Gluconate 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 1% Gel (Gum Gel)", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 5% Mouthwash / Gargle", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 10% Solution", cat: "Antiseptic" },
//   { name: "Povidone Iodine 5% Ointment", cat: "Antiseptic Topical" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 1.5% Mouthwash", cat: "Dental Antiseptic" },
//   {
//     name: "Benzydamine Hydrochloride 0.15% Mouthwash",
//     cat: "Dental Analgesic Rinse",
//   },
//   { name: "Hexetidine 0.1% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Sodium Fluoride 0.05% Mouthwash", cat: "Fluoride Rinse" },
//   { name: "Sodium Fluoride Varnish 5%", cat: "Fluoride Varnish" },
//   { name: "Fluoride Gel APF 1.23%", cat: "Fluoride Gel" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "Aloe Vera Gel Oral", cat: "Oral Care" },
//   { name: "Hyaluronic Acid Gel 0.2% Oral", cat: "Oral Care" },
//   { name: "Triclosan Toothpaste", cat: "Dental Brand" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Colgate Total Toothpaste", cat: "Dental Brand" },
//   { name: "Pepsodent Toothpaste", cat: "Dental Brand" },
//   { name: "Emoform Toothpaste", cat: "Dental Brand" },
//   { name: "Thermoseal Toothpaste", cat: "Dental Brand" },
//   { name: "Himalaya HiOra Toothpaste", cat: "Dental Brand" },
//   { name: "Dabur Red Toothpaste", cat: "Dental Brand" },
//   { name: "Meswak Toothpaste", cat: "Dental Brand" },
//   { name: "Oral-B Electric Toothbrush Head", cat: "Dental Accessory" },
//   { name: "Interdental Brush", cat: "Dental Accessory" },
//   { name: "Dental Floss", cat: "Dental Accessory" },
//   { name: "Tongue Cleaner", cat: "Dental Accessory" },
//   { name: "Water Flosser / Oral Irrigator", cat: "Dental Accessory" },
//   { name: "GIC Cement (Glass Ionomer Cement)", cat: "Dental Material" },
//   { name: "GIC Type II Restorative", cat: "Dental Material" },
//   { name: "RMGIC (Resin Modified GIC)", cat: "Dental Material" },
//   { name: "Composite Resin A1 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A2 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A3 Shade", cat: "Dental Material" },
//   { name: "Composite Resin B1 Shade", cat: "Dental Material" },
//   { name: "Flowable Composite", cat: "Dental Material" },
//   { name: "Bulk Fill Composite", cat: "Dental Material" },
//   { name: "IRM (Intermediate Restorative Material)", cat: "Dental Material" },
//   { name: "Zinc Oxide Eugenol Cement", cat: "Dental Material" },
//   { name: "Zinc Phosphate Cement", cat: "Dental Material" },
//   { name: "Zinc Polycarboxylate Cement", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Dycal (Calcium Hydroxide Base)", cat: "Dental Material" },
//   { name: "Cavity Liner (Varnish)", cat: "Dental Material" },
//   { name: "Etchant 37% Phosphoric Acid Gel", cat: "Dental Material" },
//   { name: "Bonding Agent (5th Gen)", cat: "Dental Material" },
//   { name: "Bonding Agent (7th Gen Self-Etch)", cat: "Dental Material" },
//   { name: "Dental Amalgam Capsule", cat: "Dental Material" },
//   { name: "Impression Material Alginate", cat: "Dental Material" },
//   {
//     name: "Impression Material Polyvinyl Siloxane (PVS)",
//     cat: "Dental Material",
//   },
//   { name: "Impression Material Polyether", cat: "Dental Material" },
//   { name: "Zinc Oxide Impression Paste", cat: "Dental Material" },
//   { name: "Plaster of Paris (Type II)", cat: "Dental Material" },
//   { name: "Dental Stone (Type III)", cat: "Dental Material" },
//   { name: "Dental Stone (Type IV)", cat: "Dental Material" },
//   { name: "Acrylic Resin Heat Cure", cat: "Dental Material" },
//   { name: "Acrylic Resin Cold Cure / Self Cure", cat: "Dental Material" },
//   { name: "Denture Base Resin", cat: "Dental Material" },
//   { name: "Denture Reliner", cat: "Dental Material" },
//   { name: "Denture Adhesive Cream", cat: "Dental Material" },
//   { name: "Dental Wax (Sheet Wax)", cat: "Dental Material" },
//   { name: "Boxing Wax", cat: "Dental Material" },
//   { name: "Inlay Wax", cat: "Dental Material" },
//   { name: "Sticky Wax", cat: "Dental Material" },
//   { name: "Orthodontic Wire NiTi 0.012", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire NiTi 0.014", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire NiTi 0.016", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire SS 0.019x0.025", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Metal)", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Ceramic)", cat: "Dental Ortho" },
//   { name: "Orthodontic Elastic Bands", cat: "Dental Ortho" },
//   { name: "Orthodontic Separator Elastics", cat: "Dental Ortho" },
//   { name: "Orthodontic Molar Band", cat: "Dental Ortho" },
//   { name: "Orthodontic Retainer Wire", cat: "Dental Ortho" },
//   { name: "Invisalign Clear Aligner Tray", cat: "Dental Ortho" },
//   { name: "Dental Implant Fixture (Titanium)", cat: "Dental Implant" },
//   { name: "Dental Implant Abutment", cat: "Dental Implant" },
//   { name: "Healing Cap / Cover Screw", cat: "Dental Implant" },
//   { name: "Bone Graft Material (Synthetic HA)", cat: "Dental Implant" },
//   { name: "Bone Graft Material (Xenograft)", cat: "Dental Implant" },
//   { name: "Collagen Membrane (Resorbable)", cat: "Dental Implant" },
//   { name: "Titanium Mesh", cat: "Dental Implant" },
//   { name: "PRP (Platelet Rich Plasma) Kit", cat: "Dental Surgical" },
//   { name: "PRF (Platelet Rich Fibrin) Kit", cat: "Dental Surgical" },
//   { name: "Hemostatic Agent (Gelatin Sponge)", cat: "Dental Surgical" },
//   { name: "Surgicel (Oxidised Cellulose)", cat: "Haemostatic" },
//   { name: "Alvogyl (Dry Socket Dressing)", cat: "Dental Surgical" },
//   { name: "Whitehead Varnish (Iodoform Paste)", cat: "Dental Surgical" },
//   { name: "Ledermix Paste", cat: "Dental Material" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Sealapex)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Zinc Oxide Eugenol)", cat: "Endodontic" },
//   { name: "Gutta Percha Points (ISO 20-80)", cat: "Endodontic" },
//   { name: "Paper Points (Absorbent Points)", cat: "Endodontic" },
//   { name: "EDTA Liquid 17% (Root Canal)", cat: "Endodontic" },
//   { name: "EDTA Gel 17% (Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 2.5% Solution", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% Solution", cat: "Endodontic" },
//   { name: "Chlorhexidine 2% Irrigant", cat: "Endodontic" },
//   { name: "RC Prep (Root Canal Lubricant)", cat: "Endodontic" },
//   { name: "K-Files (Root Canal Files) ISO 6-80", cat: "Endodontic Instrument" },
//   { name: "H-Files (Hedstrom Files) ISO 15-60", cat: "Endodontic Instrument" },
//   { name: "Rotary NiTi Files (ProTaper)", cat: "Endodontic Instrument" },
//   { name: "Rotary NiTi Files (WaveOne Gold)", cat: "Endodontic Instrument" },
//   { name: "Rubber Dam Sheet", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Clamp", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Frame", cat: "Endodontic Accessory" },
//   { name: "Pulp Capping Agent (Vitrebond)", cat: "Endodontic" },
//   { name: "Formocresol Solution", cat: "Endodontic Paediatric" },
//   { name: "Buckley's Formocresol", cat: "Endodontic Paediatric" },
//   {
//     name: "Zinc Oxide + Iodoform Paste (Kri Paste)",
//     cat: "Endodontic Paediatric",
//   },
//   { name: "Stainless Steel Crown (Paediatric)", cat: "Paediatric Dental" },
//   { name: "Fluoride Varnish Duraphat 22600 ppm", cat: "Fluoride Varnish" },
//   { name: "Dental Needle 27G Short (21mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 27G Long (38mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Short (21mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 25G Long (38mm)", cat: "Dental Needle" },
//   {
//     name: "Aspirating Dental Syringe (Breech Loading)",
//     cat: "Dental Instrument",
//   },
//   { name: "Disposable Syringe 1ml (Insulin)", cat: "Syringe" },
//   { name: "Disposable Syringe 2ml", cat: "Syringe" },
//   { name: "Disposable Syringe 5ml", cat: "Syringe" },
//   { name: "Disposable Syringe 10ml", cat: "Syringe" },
//   { name: "Disposable Syringe 20ml", cat: "Syringe" },
//   { name: "Disposable Syringe 50ml (Piston)", cat: "Syringe" },
//   { name: "Normal Saline 0.9% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 1000ml Infusion", cat: "IV Fluid" },
//   { name: "Ringer's Lactate 500ml Infusion", cat: "IV Fluid" },
//   { name: "Ringer's Lactate 1000ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 5% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 2mg/ml Injection", cat: "Antiemetic Inj" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Injection", cat: "Antiemetic Inj" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Pantoprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Ranitidine 150mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Sucralfate Suspension 1g/10ml", cat: "Antacid" },
//   { name: "Cetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 5mg/5ml Syrup", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 180mg Tablet", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 4mg Tablet", cat: "Antihistamine" },
//   { name: "Adrenaline (Epinephrine) 1mg/ml Injection", cat: "Emergency Drug" },
//   { name: "Hydrocortisone 100mg Injection (Allergy)", cat: "Emergency Drug" },
//   { name: "Epinephrine Auto-Injector (EpiPen)", cat: "Emergency Drug" },
//   { name: "Amlodipine 5mg Tablet", cat: "Antihypertensive" },
//   { name: "Atenolol 50mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 50mg Tablet", cat: "Beta Blocker" },
//   { name: "Losartan 50mg Tablet", cat: "Antihypertensive" },
//   { name: "Telmisartan 40mg Tablet", cat: "Antihypertensive" },
//   { name: "Telmisartan 80mg Tablet", cat: "Antihypertensive" },
//   { name: "Ramipril 5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Furosemide 40mg Tablet", cat: "Diuretic" },
//   { name: "Aspirin 75mg Tablet", cat: "Antiplatelet" },
//   { name: "Clopidogrel 75mg Tablet", cat: "Antiplatelet" },
//   { name: "Atorvastatin 20mg Tablet", cat: "Statin" },
//   { name: "Atorvastatin 40mg Tablet", cat: "Statin" },
//   { name: "Metformin 500mg Tablet", cat: "Antidiabetic" },
//   { name: "Metformin 850mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 2mg Tablet", cat: "Antidiabetic" },
//   { name: "Insulin Regular (Soluble) 100 IU/ml", cat: "Insulin" },
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin C 1000mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule (Weekly)", cat: "Vitamin" },
//   { name: "Vitamin D3 1000 IU Tablet (Daily)", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 500mcg Tablet", cat: "Vitamin" },
//   { name: "Folic Acid 5mg Tablet", cat: "Vitamin" },
//   { name: "Iron (Ferrous Sulphate) 200mg Tablet", cat: "Iron Supplement" },
//   { name: "Iron + Folic Acid Tablet", cat: "Iron Supplement" },
//   { name: "Calcium Carbonate 500mg Tablet", cat: "Calcium Supplement" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Zinc Sulphate 50mg Tablet", cat: "Micronutrient" },
//   { name: "Multivitamin Tablet (Adult)", cat: "Multivitamin" },
//   { name: "Tranexamic Acid 500mg Tablet", cat: "Haemostatic" },
//   { name: "Tranexamic Acid 250mg/5ml Injection", cat: "Haemostatic Inj" },
//   { name: "Etamsylate 250mg Tablet", cat: "Haemostatic" },
//   { name: "Gelatin Sponge (Absorbable Haemostat)", cat: "Haemostatic" },
//   { name: "Bone Wax", cat: "Haemostatic Surgical" },
//   { name: "Vicryl (Polyglactin 910) 3-0 Suture", cat: "Suture" },
//   { name: "Vicryl (Polyglactin 910) 4-0 Suture", cat: "Suture" },
//   { name: "Vicryl Rapid 4-0 Suture", cat: "Suture" },
//   { name: "Chromic Catgut 2-0 Suture", cat: "Suture" },
//   { name: "Chromic Catgut 3-0 Suture", cat: "Suture" },
//   { name: "Plain Catgut 2-0 Suture", cat: "Suture" },
//   { name: "Silk Suture 3-0 Black Braided", cat: "Suture" },
//   { name: "Silk Suture 4-0 Black Braided", cat: "Suture" },
//   { name: "Nylon Suture 3-0 (Ethilon)", cat: "Suture" },
//   { name: "Nylon Suture 4-0 (Ethilon)", cat: "Suture" },
//   { name: "Gauze Swab 4x4 inch (Sterile)", cat: "Dressing" },
//   { name: "Cotton Roll (Non-Sterile)", cat: "Dental Material" },
//   { name: "Cotton Roll (Dental Grade)", cat: "Consumable" },
//   { name: "Cotton Pellet Small", cat: "Consumable" },
//   { name: "Ribbon Gauze 1/2 inch (Dental Packing)", cat: "Dental Consumable" },
//   { name: "Dry Foil (Dental)", cat: "Dental Consumable" },
//   { name: "Tetanus Toxoid 0.5ml Injection", cat: "Vaccine" },
//   { name: "Influenza Vaccine (Flu Shot)", cat: "Vaccine" },
//   { name: "MMR Vaccine", cat: "Vaccine" },
//   { name: "Anti-Tetanus Serum (ATS)", cat: "Antiserum" },
//   { name: "OPG (Orthopantomogram) X-ray", cat: "Dental Investigation" },
//   { name: "IOPA X-ray (Intraoral Periapical)", cat: "Dental Investigation" },
//   { name: "Bitewing X-ray", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Cone Beam CT)", cat: "Dental Investigation" },
//   { name: "Lateral Cephalogram X-ray", cat: "Dental Investigation" },
//   { name: "Complete Blood Count (CBC)", cat: "Lab Test" },
//   { name: "Blood Sugar Fasting (BSF)", cat: "Lab Test" },
//   { name: "Random Blood Sugar (RBS)", cat: "Lab Test" },
//   { name: "HbA1c Test", cat: "Lab Test" },
//   { name: "Liver Function Test (LFT)", cat: "Lab Test" },
//   { name: "Kidney Function Test (KFT) / RFT", cat: "Lab Test" },
//   { name: "Lipid Profile Test", cat: "Lab Test" },
//   { name: "Blood Group and Rh Typing", cat: "Lab Test" },
//   { name: "PT / INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "APTT Test", cat: "Lab Test" },
//   { name: "Bleeding Time (BT)", cat: "Lab Test" },
//   { name: "Clotting Time (CT)", cat: "Lab Test" },
//   { name: "HBsAg Test (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "HIV Test (ELISA)", cat: "Lab Test" },
//   { name: "Adrenaline 1:1000 (1mg/ml) Injection", cat: "Emergency Drug" },
//   { name: "Atropine 0.6mg Injection", cat: "Emergency Drug" },
//   { name: "Sodium Bicarbonate 8.4% Injection", cat: "Emergency Drug" },
//   { name: "Dextrose 50% Injection (Hypoglycaemia)", cat: "Emergency Drug" },
//   { name: "Naloxone 0.4mg Injection (Opioid Reversal)", cat: "Emergency Drug" },
//   {
//     name: "Augmentin 625mg Tablet (Amoxicillin+Clavulanate)",
//     cat: "Antibiotic",
//   },
//   { name: "Azithral 500mg Tablet (Azithromycin)", cat: "Antibiotic" },
//   { name: "Cifran 500mg Tablet (Ciprofloxacin)", cat: "Antibiotic" },
//   { name: "Flagyl 400mg Tablet (Metronidazole)", cat: "Antibiotic" },
//   { name: "Doxy 100mg Capsule (Doxycycline)", cat: "Antibiotic" },
//   { name: "Calpol 650mg Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Dolo 650 Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Combiflam Tablet (Ibuprofen+Paracetamol)", cat: "NSAID Combo" },
//   { name: "Voveran 50mg Tablet (Diclofenac)", cat: "NSAID" },
//   { name: "Brufen 400mg Tablet (Ibuprofen)", cat: "NSAID" },
//   { name: "Ultracet Tablet (Tramadol+Paracetamol)", cat: "Analgesic Combo" },
//   { name: "Pan 40mg Tablet (Pantoprazole)", cat: "Antacid / PPI" },
//   { name: "Omez 20mg Capsule (Omeprazole)", cat: "Antacid / PPI" },
//   { name: "Ondem 4mg Tablet (Ondansetron)", cat: "Antiemetic" },
//   { name: "Allegra 120mg Tablet (Fexofenadine)", cat: "Antihistamine" },
//   {
//     name: "Montair-LC Tablet (Montelukast+Levocetirizine)",
//     cat: "Antihistamine",
//   },
//   { name: "Rantac 150mg Tablet (Ranitidine)", cat: "Antacid / H2 Blocker" },
//   { name: "Kenacort Oral Paste (Triamcinolone)", cat: "Steroid Topical" },
//   { name: "Kenalog Injection 40mg (Triamcinolone)", cat: "Steroid Inj" },
//   { name: "Depo-Medrol 40mg Injection", cat: "Steroid Inj" },
//   { name: "Betnesol 0.5mg Tablet (Betamethasone)", cat: "Steroid" },
//   { name: "Wysolone 5mg Tablet (Prednisolone)", cat: "Steroid" },
//   { name: "Defcort 6mg Tablet (Deflazacort)", cat: "Steroid" },
//   { name: "Dexona 0.5mg Tablet (Dexamethasone)", cat: "Steroid" },
//   { name: "Mox 500mg Capsule (Amoxicillin)", cat: "Antibiotic" },
//   { name: "Sporanox 100mg Capsule (Itraconazole)", cat: "Antifungal" },
//   { name: "Zovirax 400mg Tablet (Acyclovir)", cat: "Antiviral" },
//   { name: "Valcivir 500mg Tablet (Valacyclovir)", cat: "Antiviral" },
//   { name: "Betadine Ointment 5%", cat: "Antiseptic Topical" },
//   { name: "Borax Glycerine (Oral Ulcer)", cat: "Oral Care" },
//   { name: "Tantum Verde Mouthwash (Benzydamine)", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Recaldent (CPP-ACP Paste)", cat: "Dental Fluoride" },
//   { name: "Tooth Mousse Plus (GC)", cat: "Dental Fluoride" },
//   { name: "Sensodyne Repair & Protect", cat: "Dental Brand" },
//   { name: "Colgate Sensitive Pro-Relief", cat: "Dental Brand" },
//   { name: "Mouth Guard (Bruxism)", cat: "Dental Brand" },
//   {
//     name: "Triamcinolone Acetonide 0.1% Oral Paste (Kenacort)",
//     cat: "Steroid Topical",
//   },
//   { name: "Clotrimazole 1% Cream", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin Oral Suspension", cat: "Antifungal" },
//   { name: "Mupirocin 2% Ointment (Bactroban)", cat: "Topical Antibiotic" },
//   { name: "Lignocaine Viscous 2% Mouthwash", cat: "Local Anaesthetic Topical" },
//   { name: "Amlexanox 5% Paste (Aphthous Ulcer)", cat: "Oral Care" },
//   { name: "Benzydamine 0.15% Mouthwash (Tantum Verde)", cat: "Oral Care" },
//   { name: "Ulcerex Gel (Choline Salicylate)", cat: "Oral Care" },
//   { name: "Dologel CT (Clove Oil Gel)", cat: "Oral Care" },
//   { name: "Clove Oil (Eugenol)", cat: "Dental Material" },
//   { name: "Titanium Implant Fixture (3.3mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (4.0mm)", cat: "Dental Implant" },
//   { name: "Implant Cover Screw", cat: "Dental Implant" },
//   { name: "Implant Healing Abutment", cat: "Dental Implant" },
//   { name: "Bone Graft (Xenograft - Bio-Oss)", cat: "Dental Surgical" },
//   { name: "Collagen Membrane (Bio-Gide)", cat: "Dental Surgical" },
//   { name: "Haemostatic Foam (Gelfoam)", cat: "Haemostatic" },
//   { name: "Surgical Suction Tip (Frazier)", cat: "Dental Instrument" },
//   { name: "CBC (Complete Blood Count)", cat: "Lab Test" },
//   { name: "RBS (Random Blood Sugar)", cat: "Lab Test" },
//   { name: "HbA1c (Glycated Haemoglobin)", cat: "Lab Test" },
//   { name: "Blood Group & Rh Typing", cat: "Lab Test" },
//   { name: "BT (Bleeding Time) & CT (Clotting Time)", cat: "Lab Test" },
//   { name: "PT/INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "LFT (Liver Function Test)", cat: "Lab Test" },
//   { name: "KFT (Kidney Function Test)", cat: "Lab Test" },
//   { name: "Dental Radiograph (IOPA X-ray)", cat: "Dental Investigation" },
//   { name: "Orthopantomogram (OPG) X-ray", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Dental 3D)", cat: "Dental Investigation" },
//   { name: "Aceclofenac + Paracetamol + Serratiopeptidase", cat: "NSAID Combo" },
//   { name: "Serratiopeptidase 10mg Tablet", cat: "Enzyme Combination" },
//   { name: "Serratiopeptidase 20mg Tablet", cat: "Enzyme Combination" },
//   { name: "Deflazacort 6mg Tablet", cat: "Steroid" },
//   { name: "Deflazacort 12mg Tablet", cat: "Steroid" },
//   { name: "Deflazacort 30mg Tablet", cat: "Steroid" },
//   { name: "Omeprazole 10mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 40mg Capsule", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 10mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Ranitidine 300mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ondansetron 4mg/5ml Syrup", cat: "Antiemetic" },
//   { name: "Domperidone 1mg/ml Suspension", cat: "Antiemetic" },
//   { name: "Levocetirizine 2.5mg Tablet", cat: "Antihistamine" },
//   { name: "Vitamin C 1000mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin B Complex + Zinc Capsule", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule", cat: "Vitamin" },
//   { name: "Vitamin E 400mg Capsule", cat: "Vitamin" },
//   { name: "Zinc Sulphate 20mg Tablet", cat: "Mineral Supplement" },
//   { name: "Ferrous Sulphate 200mg Tablet", cat: "Iron Supplement" },
//   { name: "Ferrous Ascorbate + Folic Acid Tablet", cat: "Iron Supplement" },
// ];

// function saveCustomMed(name, apiPost) {
//   if (!name || name.trim().length < 3) return Promise.resolve(null);
//   if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
//   const nameLow = name.trim().toLowerCase();
//   const already = MEDICINE_DB.some(
//     (m) => m && m.name && m.name.toLowerCase() === nameLow,
//   );
//   if (already) return Promise.resolve(null);
//   return apiPost("/custommeds", { name: name.trim(), cat: "Custom" })
//     .then((saved) => saved || null)
//     .catch(() => null);
// }

// function googleSearch(query, customMeds = []) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   if (!words.length) return [];
//   const safeMeds = Array.isArray(customMeds)
//     ? customMeds.filter(
//         (m) => m && typeof m.name === "string" && m.name.trim().length > 0,
//       )
//     : [];
//   const combined = [
//     ...MEDICINE_DB.filter(Boolean),
//     ...safeMeds.map((m) => ({ ...m, _custom: true })),
//   ];
//   const scored = combined
//     .map((m) => {
//       if (!m || typeof m.name !== "string") return { m, score: 0 };
//       const nameLow = m.name.toLowerCase();
//       const catLow = (m.cat || "").toLowerCase();
//       let score = 0;
//       for (const w of words) {
//         if (nameLow.startsWith(w)) score += 5;
//         else if (nameLow.includes(w)) score += 3;
//         else if (catLow.includes(w)) score += 1;
//       }
//       if (m._custom) score += 2;
//       return { m, score };
//     })
//     .filter((x) => x.score > 0)
//     .sort((a, b) => b.score - a.score)
//     .map((x) => x.m);
//   return scored.slice(0, 12);
// }

// function highlightWords(text, query) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   let result = text;
//   words.forEach((w) => {
//     const re = new RegExp(
//       "(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
//       "gi",
//     );
//     result = result.replace(re, "<b>$1</b>");
//   });
//   return result;
// }

// // ── RxMedInput — original unchanged ─────────────────────────
// function RxMedInput({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const inpRef = React.useRef(null);
//   const wrapRef = React.useRef(null);
//   const [sugs, setSugs] = React.useState([]);
//   const [activeIdx, setActive] = React.useState(-1);
//   const [query, setQuery] = React.useState("");
//   const [dropPos, setDropPos] = React.useState({ top: 0, left: 0, width: 0 });

//   const hide = () => {
//     setSugs([]);
//     setActive(-1);
//     setQuery("");
//   };

//   const handleChange = (e) => {
//     const v = e.target.value;
//     onChange(v);
//     if (v.trim().length < 2) {
//       hide();
//       return;
//     }
//     const matches = googleSearch(v, customMeds);
//     if (!matches.length) {
//       hide();
//       return;
//     }
//     setQuery(v);
//     setSugs(matches);
//     setActive(-1);
//     requestAnimationFrame(() => {
//       if (!inpRef.current) return;
//       const r = inpRef.current.getBoundingClientRect();
//       const spaceBelow = window.innerHeight - r.bottom;
//       const dropH = Math.min(220, matches.length * 36);
//       const top =
//         spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//       setDropPos({ top, left: r.left, width: r.width });
//     });
//   };

//   const handleKeyDown = (e) => {
//     if (!sugs.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActive((i) => Math.min(i + 1, sugs.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActive((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       sugs[activeIdx]
//     ) {
//       e.preventDefault();
//       select(sugs[activeIdx].name);
//     } else if (e.key === "Escape") hide();
//   };

//   const select = (name) => {
//     onChange(name);
//     hide();
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (inpRef.current) inpRef.current.focus();
//     }, 0);
//   };

//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapRef.current && !wrapRef.current.contains(e.target)) hide();
//     };
//     document.addEventListener("mousedown", handler);
//     const scrollHandler = () => {
//       if (sugs.length > 0 && inpRef.current) {
//         const r = inpRef.current.getBoundingClientRect();
//         const spaceBelow = window.innerHeight - r.bottom;
//         const dropH = Math.min(220, sugs.length * 36);
//         const top =
//           spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//         setDropPos({ top, left: r.left, width: r.width });
//       }
//     };
//     window.addEventListener("scroll", scrollHandler, true);
//     return () => {
//       document.removeEventListener("mousedown", handler);
//       window.removeEventListener("scroll", scrollHandler, true);
//     };
//   }, [sugs.length]);

//   return (
//     <div ref={wrapRef} style={{ position: "relative" }}>
//       <input
//         ref={inpRef}
//         type="text"
//         value={value}
//         onChange={handleChange}
//         onKeyDown={handleKeyDown}
//         placeholder="Type medicine name..."
//         autoComplete="off"
//         style={{
//           width: "100%",
//           border: "1px solid #ddd",
//           borderRadius: 5,
//           padding: "5px 8px",
//           fontSize: 12,
//           fontFamily: "'DM Sans',sans-serif",
//         }}
//       />
//       {sugs.length > 0 && (
//         <div
//           style={{
//             position: "fixed",
//             top: dropPos.top,
//             left: dropPos.left,
//             width: Math.max(dropPos.width, 280),
//             background: "#fff",
//             border: "1.5px solid #0d7377",
//             borderRadius: 8,
//             boxShadow: "0 8px 32px rgba(13,115,119,0.28)",
//             zIndex: 999999,
//             maxHeight: 220,
//             overflowY: "auto",
//             fontFamily: "'DM Sans',sans-serif",
//           }}
//         >
//           {sugs.map((m, i) => (
//             <div
//               key={m.name + i}
//               style={{
//                 padding: "7px 12px",
//                 cursor: "pointer",
//                 fontSize: 12,
//                 background: i === activeIdx ? "#e8f7f7" : "#fff",
//                 borderBottom: "1px solid #f0eeeb",
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 8,
//               }}
//               onMouseDown={(e) => {
//                 e.preventDefault();
//                 select(m.name);
//               }}
//               onMouseEnter={() => setActive(i)}
//             >
//               <span style={{ fontSize: 13, opacity: 0.6, flexShrink: 0 }}>
//                 💊
//               </span>
//               <span
//                 style={{ flex: 1, fontWeight: 500 }}
//                 dangerouslySetInnerHTML={{
//                   __html: highlightWords(m.name, query),
//                 }}
//               />
//               <span
//                 style={{
//                   fontSize: 10,
//                   color: "#9a9590",
//                   background: "#f0eeeb",
//                   padding: "1px 6px",
//                   borderRadius: 20,
//                   flexShrink: 0,
//                 }}
//               >
//                 {m.cat}
//               </span>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// // ── MedAutocomplete — original unchanged ─────────────────────
// function MedAutocomplete({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const taRef = React.useRef(null);
//   const wrapperRef = React.useRef(null);
//   const [suggestions, setSuggestions] = React.useState([]);
//   const [activeIdx, setActiveIdx] = React.useState(-1);
//   const [currentQuery, setCurrentQuery] = React.useState("");
//   const queryStartRef = React.useRef(0);
//   const queryEndRef = React.useRef(0);

//   const hideSuggestions = () => {
//     setSuggestions([]);
//     setActiveIdx(-1);
//     setCurrentQuery("");
//   };

//   const handleChange = (e) => {
//     const ta = e.target;
//     const val = ta.value;
//     const cursor = ta.selectionStart;
//     onChange(val);
//     let lineStart = cursor - 1;
//     while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
//     lineStart++;
//     const query = val.substring(lineStart, cursor);
//     queryStartRef.current = lineStart;
//     queryEndRef.current = cursor;
//     if (query.trim().length < 2) {
//       hideSuggestions();
//       return;
//     }
//     const matches = googleSearch(query, customMeds);
//     if (!matches.length) {
//       hideSuggestions();
//       return;
//     }
//     setCurrentQuery(query);
//     setSuggestions(matches);
//     setActiveIdx(-1);
//   };

//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       suggestions[activeIdx]
//     ) {
//       e.preventDefault();
//       selectMed(suggestions[activeIdx].name);
//     } else if (e.key === "Escape") hideSuggestions();
//   };

//   const selectMed = (name) => {
//     const ta = taRef.current;
//     const val = ta.value;
//     const before = val.substring(0, queryStartRef.current);
//     const after = val.substring(queryEndRef.current);
//     onChange(before + name + after);
//     hideSuggestions();
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (taRef.current) {
//         const nc = queryStartRef.current + name.length;
//         taRef.current.setSelectionRange(nc, nc);
//         taRef.current.focus();
//         queryEndRef.current = nc;
//       }
//     }, 0);
//   };

//   const handleBlur = () => {
//     if (!taRef.current) return;
//     const val = taRef.current.value;
//     val.split("\n").forEach((line) => {
//       const trimmed = line.trim();
//       if (
//         trimmed.length >= 3 &&
//         /[a-zA-Z]/.test(trimmed) &&
//         !/^[0-9\s]+$/.test(trimmed)
//       ) {
//         saveCustomMed(trimmed, apiPost).then((saved) => {
//           if (saved && onCustomSaved) onCustomSaved(saved);
//         });
//       }
//     });
//   };

//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target))
//         hideSuggestions();
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   return (
//     <>
//       <style>{`
//         .med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}
//         .med-suggestion-item:last-child{border-bottom:none;}
//         .med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}
//         .med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}
//         .med-sug-name{font-weight:500;flex:1;color:#1a1614;}
//         .med-sug-name b{color:#0d7377;font-weight:700;}
//         .med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}
//       `}</style>
//       <div style={{ position: "relative" }} ref={wrapperRef}>
//         <textarea
//           ref={taRef}
//           value={value}
//           onChange={handleChange}
//           onKeyDown={handleKeyDown}
//           onBlur={handleBlur}
//           autoComplete="off"
//           placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
//         />
//         {suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderTop: "none",
//               borderRadius: "0 0 12px 12px",
//               boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
//               zIndex: 99999,
//               maxHeight: 280,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {suggestions.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 className={
//                   "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
//                 }
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   selectMed(m.name);
//                 }}
//               >
//                 <span className="med-sug-icon">💊</span>
//                 <span
//                   className="med-sug-name"
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, currentQuery),
//                   }}
//                 />
//                 <span className="med-sug-cat">{m.cat}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── ✅ NEW: MedAutocompleteWithMic — Doctor Notes + 🎤 Microphone ──
// function MedAutocompleteWithMic({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
//   apiPost,
// }) {
//   const taRef = React.useRef(null);
//   const wrapperRef = React.useRef(null);
//   const recognitionRef = React.useRef(null);
//   const [suggestions, setSuggestions] = React.useState([]);
//   const [activeIdx, setActiveIdx] = React.useState(-1);
//   const [currentQuery, setCurrentQuery] = React.useState("");
//   const [isRecording, setIsRecording] = React.useState(false);
//   const [micSupported, setMicSupported] = React.useState(false);
//   const queryStartRef = React.useRef(0);
//   const queryEndRef = React.useRef(0);

//   React.useEffect(() => {
//     const SpeechRec =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     setMicSupported(!!SpeechRec);
//   }, []);

//   const hideSuggestions = () => {
//     setSuggestions([]);
//     setActiveIdx(-1);
//     setCurrentQuery("");
//   };

//   const handleChange = (e) => {
//     const ta = e.target;
//     const val = ta.value;
//     const cursor = ta.selectionStart;
//     onChange(val);
//     let lineStart = cursor - 1;
//     while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
//     lineStart++;
//     const query = val.substring(lineStart, cursor);
//     queryStartRef.current = lineStart;
//     queryEndRef.current = cursor;
//     if (query.trim().length < 2) {
//       hideSuggestions();
//       return;
//     }
//     const matches = googleSearch(query, customMeds);
//     if (!matches.length) {
//       hideSuggestions();
//       return;
//     }
//     setCurrentQuery(query);
//     setSuggestions(matches);
//     setActiveIdx(-1);
//   };

//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       suggestions[activeIdx]
//     ) {
//       e.preventDefault();
//       selectMed(suggestions[activeIdx].name);
//     } else if (e.key === "Escape") hideSuggestions();
//   };

//   const selectMed = (name) => {
//     const ta = taRef.current;
//     const val = ta.value;
//     const before = val.substring(0, queryStartRef.current);
//     const after = val.substring(queryEndRef.current);
//     onChange(before + name + after);
//     hideSuggestions();
//     saveCustomMed(name, apiPost).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (taRef.current) {
//         const nc = queryStartRef.current + name.length;
//         taRef.current.setSelectionRange(nc, nc);
//         taRef.current.focus();
//         queryEndRef.current = nc;
//       }
//     }, 0);
//   };

//   const handleBlur = () => {
//     if (!taRef.current) return;
//     const val = taRef.current.value;
//     val.split("\n").forEach((line) => {
//       const trimmed = line.trim();
//       if (
//         trimmed.length >= 3 &&
//         /[a-zA-Z]/.test(trimmed) &&
//         !/^[0-9\s]+$/.test(trimmed)
//       ) {
//         saveCustomMed(trimmed, apiPost).then((saved) => {
//           if (saved && onCustomSaved) onCustomSaved(saved);
//         });
//       }
//     });
//   };

//   // ✅ Mic toggle — start/stop speech recognition
//   // FIX: capture baseText ONCE when recording starts, accumulate finals separately
//   // so interim results never cause duplication
//   const toggleMic = () => {
//     const SpeechRec =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (!SpeechRec) {
//       alert(
//         "Your browser does not support speech recognition.\nPlease use Chrome on Android or desktop.",
//       );
//       return;
//     }
//     if (isRecording) {
//       if (recognitionRef.current) {
//         recognitionRef.current.stop();
//       }
//       setIsRecording(false);
//       return;
//     }
//     const recognition = new SpeechRec();
//     recognitionRef.current = recognition;
//     recognition.lang = "en-IN";
//     recognition.continuous = true;
//     recognition.interimResults = true;
//     recognition.maxAlternatives = 1;
//     // ✅ Capture the existing textarea value ONCE when recording starts
//     // Never read taRef.current.value inside onresult — that causes duplication
//     const baseText = taRef.current ? taRef.current.value : "";
//     const prefix =
//       baseText.length > 0 && !baseText.endsWith(" ")
//         ? baseText + " "
//         : baseText;
//     let committedText = ""; // accumulates only FINAL results
//     recognition.onstart = () => setIsRecording(true);
//     recognition.onresult = (e) => {
//       // Rebuild committed from scratch on each event (safe, no duplication)
//       let finalSoFar = "";
//       let interimSoFar = "";
//       for (let i = 0; i < e.results.length; i++) {
//         if (e.results[i].isFinal) {
//           finalSoFar += e.results[i][0].transcript + " ";
//         } else {
//           interimSoFar += e.results[i][0].transcript;
//         }
//       }
//       // Display: original text + all finals so far + current interim
//       onChange(prefix + finalSoFar + interimSoFar);
//     };
//     recognition.onerror = (e) => {
//       setIsRecording(false);
//       if (e.error !== "aborted") alert("Mic error: " + e.error);
//     };
//     recognition.onend = () => setIsRecording(false);
//     recognition.start();
//   };

//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target))
//         hideSuggestions();
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   React.useEffect(() => {
//     return () => {
//       if (recognitionRef.current) {
//         try {
//           recognitionRef.current.stop();
//         } catch (_) {}
//       }
//     };
//   }, []);

//   return (
//     <>
//       <style>{`
//         .mic-active { animation: micPulse 1.2s ease-in-out infinite; background: #dc2626 !important; border-color: #dc2626 !important; }
//       `}</style>
//       <div style={{ position: "relative" }} ref={wrapperRef}>
//         <div style={{ position: "relative" }}>
//           <textarea
//             ref={taRef}
//             value={value}
//             onChange={handleChange}
//             onKeyDown={handleKeyDown}
//             onBlur={handleBlur}
//             autoComplete="off"
//             style={{ paddingRight: micSupported ? "48px" : undefined }}
//             placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
//           />
//           {/* ✅ Mic Button */}
//           {micSupported && (
//             <button
//               type="button"
//               onClick={toggleMic}
//               className={isRecording ? "mic-active" : ""}
//               title={isRecording ? "Stop Recording" : "Start Voice Input"}
//               style={{
//                 position: "absolute",
//                 right: 8,
//                 bottom: 8,
//                 width: 34,
//                 height: 34,
//                 borderRadius: "50%",
//                 background: isRecording ? "#dc2626" : "rgba(13,115,119,0.1)",
//                 border: `1.5px solid ${isRecording ? "#dc2626" : "rgba(13,115,119,0.3)"}`,
//                 color: isRecording ? "#fff" : "#0d7377",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 cursor: "pointer",
//                 fontSize: 16,
//                 transition: "all 0.2s",
//                 zIndex: 10,
//               }}
//             >
//               {isRecording ? "⏹" : "🎤"}
//             </button>
//           )}
//         </div>
//         {/* Recording indicator */}
//         {isRecording && (
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 6,
//               marginTop: 4,
//               fontSize: 12,
//               color: "#dc2626",
//               fontFamily: "DM Sans,sans-serif",
//             }}
//           >
//             <span
//               style={{
//                 width: 8,
//                 height: 8,
//                 borderRadius: "50%",
//                 background: "#dc2626",
//                 display: "inline-block",
//                 animation: "micPulse 1s ease-in-out infinite",
//               }}
//             ></span>
//             Recording… speak now. Tap ⏹ to stop.
//           </div>
//         )}
//         {suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderTop: "none",
//               borderRadius: "0 0 12px 12px",
//               boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
//               zIndex: 99999,
//               maxHeight: 280,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {suggestions.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 className={
//                   "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
//                 }
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   selectMed(m.name);
//                 }}
//               >
//                 <span className="med-sug-icon">💊</span>
//                 <span
//                   className="med-sug-name"
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, currentQuery),
//                   }}
//                 />
//                 <span className="med-sug-cat">{m.cat}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── Prescription Modal — exact original PDF design ────────────
// function PrescriptionModal({ visit, patient, doctor, onClose, showNotify }) {
//   const [pdfUrl, setPdfUrl] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [pdfBlob, setPdfBlob] = useState(null);
//   const [rxMobile, setRxMobile] = useState("");
//   const [fileName, setFileName] = useState("");
//   const [canNativeShare, setCanNativeShare] = useState(false);

//   useEffect(() => {
//     generatePDF();
//   }, []);
//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     document.addEventListener("keydown", handler);
//     return () => document.removeEventListener("keydown", handler);
//   }, [onClose]);

//   const fmtDateLocal = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr + "T00:00:00");
//     return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
//   };
//   const fmtTimeLocal = (t) => {
//     if (!t) return "";
//     const parts = t.split(":");
//     const hh = parseInt(parts[0]),
//       mm = parts[1];
//     return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
//   };

//   const generatePDF = () => {
//     if (window.jspdf) {
//       buildPDF();
//       return;
//     }
//     const existing = document.getElementById("jspdf-cdn");
//     if (existing) {
//       existing.addEventListener("load", buildPDF);
//       return;
//     }
//     const script = document.createElement("script");
//     script.id = "jspdf-cdn";
//     script.src =
//       "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
//     script.crossOrigin = "anonymous";
//     script.onload = buildPDF;
//     script.onerror = () => setLoading(false);
//     document.head.appendChild(script);
//   };

//   const buildPDF = () => {
//     const { jsPDF } = window.jspdf;
//     const pdf = new jsPDF({
//       unit: "mm",
//       format: "a4",
//       orientation: "portrait",
//     });
//     const W = 210,
//       H = 297;
//     const sf = (c) => pdf.setFillColor(c[0], c[1], c[2]);
//     const sd = (c) => pdf.setDrawColor(c[0], c[1], c[2]);
//     const st = (c) => pdf.setTextColor(c[0], c[1], c[2]);
//     const NAVY = [8, 25, 65],
//       BLUE = [20, 80, 160];
//     const LBLUE = [210, 228, 248],
//       LBLUE2 = [232, 242, 252],
//       MIDBLUE = [160, 195, 235];
//     const TEAL = [0, 130, 130],
//       TEAL2 = [210, 240, 240];
//     const WHITE = [255, 255, 255],
//       LGRAY = [245, 247, 251],
//       LGRAY2 = [250, 251, 254],
//       LGRAY3 = [240, 243, 248];
//     const GRAY = [115, 118, 130],
//       GRAY2 = [75, 80, 95];
//     const GOLD = [170, 130, 40],
//       GOLD2 = [250, 245, 225];
//     const today = new Date();
//     const todayFmt =
//       today.getDate() +
//       " " +
//       MONTHS[today.getMonth()] +
//       " " +
//       today.getFullYear();
//     const rxNum =
//       "PS-" +
//       today.getFullYear() +
//       ("0" + (today.getMonth() + 1)).slice(-2) +
//       ("0" + today.getDate()).slice(-2) +
//       "-" +
//       Math.floor(1000 + Math.random() * 8999);
//     const visitDate = visit.visitDate || "",
//       visitTime = visit.visitTime || "",
//       notes = visit.notes || "",
//       nextDate = visit.nextVisitDate || "",
//       service = visit.service || "";
//     const doc = { name: doctor?.name || "Doctor", qual: "", reg: "" };
//     const visitDateFmt = fmtDateLocal(visitDate),
//       visitTimeFmt = fmtTimeLocal(visitTime),
//       nextDateFmt = fmtDateLocal(nextDate);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.8);
//     pdf.rect(3.5, 3.5, W - 7, H - 7, "S");
//     sd(LBLUE);
//     pdf.setLineWidth(0.3);
//     pdf.rect(5.5, 5.5, W - 11, H - 11, "S");
//     sf(NAVY);
//     pdf.rect(3.5, 3.5, W - 7, 46, "F");
//     sf(BLUE);
//     pdf.rect(3.5, 43, W - 7, 10, "F");
//     sf(LBLUE);
//     pdf.rect(3.5, 53, W - 7, 6, "F");
//     st(WHITE);
//     pdf.setFontSize(18);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(doc.name, 14, 19);
//     st(LBLUE);
//     pdf.setFontSize(8);
//     pdf.setFont("helvetica", "normal");
//     pdf.text((doc.qual || "").toUpperCase(), 14, 26);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(14, 28.5, W - 40, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(7);
//     pdf.text("Reg. No.:  " + (doc.reg || "—"), 14, 33.5);
//     pdf.text("Specialisation:  Dental & Oral Health Care", 14, 38.5);
//     st(WHITE);
//     pdf.setFontSize(15);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PEARLSMILE", W - 10, 19, { align: "right" });
//     st(LBLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("DENTAL HOSPITAL", W - 10, 25.5, { align: "right" });
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(W - 72, 28.5, W - 10, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(6.8);
//     pdf.text("12, Dental Plaza, MG Road, Pune - 411001", W - 10, 33.5, {
//       align: "right",
//     });
//     pdf.text("+91 87936 08083  |  care@pearlsmiledental.in", W - 10, 38.5, {
//       align: "right",
//     });
//     st(WHITE);
//     pdf.setFontSize(9);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("DIGITAL PRESCRIPTION", W / 2, 50, { align: "center" });
//     st(LBLUE2);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 10, 50);
//     pdf.text("Date: " + todayFmt, W - 10, 50, { align: "right" });
//     st(BLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PATIENT INFORMATION", W / 2, 57, { align: "center" });
//     const infoTop = 61;
//     sf(LGRAY3);
//     pdf.rect(10, infoTop, W - 20, 44, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, infoTop, W - 20, 44, "S");
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.2);
//     pdf.line(W / 2, infoTop, W / 2, infoTop + 44);
//     let rdy = infoTop + 11;
//     for (let ri = 0; ri < 3; ri++) {
//       pdf.line(10, rdy, W - 10, rdy);
//       rdy += 11;
//     }
//     const drawCell = (label, value, x, y, maxW) => {
//       st(GRAY2);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.8);
//       pdf.text(label, x + 3, y + 4);
//       st(NAVY);
//       pdf.setFont("helvetica", "normal");
//       pdf.setFontSize(8.5);
//       const val = pdf.splitTextToSize(String(value || "—"), maxW || 75);
//       pdf.text(val[0], x + 3, y + 9.5);
//     };
//     const cHalf = W / 2;
//     drawCell("PATIENT NAME", patient.name || "—", 10, infoTop, cHalf - 16);
//     drawCell("MOBILE", patient.mobile || "—", cHalf, infoTop, cHalf - 16);
//     drawCell("EMAIL", patient.email || "—", 10, infoTop + 11, cHalf - 16);
//     drawCell(
//       "BLOOD GROUP",
//       patient.blood || "—",
//       cHalf,
//       infoTop + 11,
//       cHalf - 16,
//     );
//     drawCell(
//       "AGE / GENDER",
//       (patient.age || "—") + (patient.gender ? "  |  " + patient.gender : ""),
//       10,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell(
//       "VISIT DATE",
//       visitDateFmt + (visitTimeFmt ? " (" + visitTimeFmt + ")" : ""),
//       cHalf,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell("SERVICE/TREATMENT", service || "—", 10, infoTop + 33, cHalf - 16);
//     drawCell(
//       "NEXT VISIT DATE",
//       nextDateFmt || "—",
//       cHalf,
//       infoTop + 33,
//       cHalf - 16,
//     );
//     const diagTop = infoTop + 50;
//     const rxRows =
//       visit.prescription && visit.prescription.medicineRows
//         ? visit.prescription.medicineRows.filter(
//             (r) => r.medicine && r.medicine.trim(),
//           )
//         : [];
//     let rxTableEndY = diagTop;
//     if (rxRows.length > 0) {
//       const tTop = diagTop;
//       sf(BLUE);
//       pdf.rect(10, tTop, W - 20, 7, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(7.5);
//       pdf.text("PRESCRIPTION", W / 2, tTop + 5, { align: "center" });
//       const colX = [10, 20, 90, 155, 183];
//       let ry = tTop + 7;
//       sf(LGRAY3);
//       pdf.rect(10, ry, W - 20, 6, "F");
//       [
//         ["SR.", "normal", 6],
//         ["MEDICINE", "bold", 6],
//         ["DOSAGE INSTRUCTION", "normal", 6],
//         ["DURATION", "normal", 6],
//         ["ROUTE", "normal", 6],
//       ].forEach(([h, fw, fs], hi) => {
//         st(GRAY2);
//         pdf.setFont("helvetica", fw);
//         pdf.setFontSize(fs);
//         pdf.text(h, colX[hi] + 1, ry + 4.5);
//       });
//       ry += 6;
//       rxRows.forEach((row, ri) => {
//         sf(ri % 2 === 0 ? LGRAY2 : WHITE);
//         pdf.rect(10, ry, W - 20, 7, "F");
//         sd(LBLUE);
//         pdf.setLineWidth(0.1);
//         pdf.rect(10, ry, W - 20, 7, "S");
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6);
//         pdf.text(String(ri + 1) + ".", colX[0] + 1, ry + 4.5);
//         st(NAVY);
//         pdf.setFont("helvetica", "bold");
//         pdf.setFontSize(7);
//         pdf.text(
//           pdf.splitTextToSize(row.medicine || "", 68)[0] || "",
//           colX[1] + 1,
//           ry + 4.5,
//         );
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6.5);
//         pdf.text(
//           pdf.splitTextToSize(row.dosage || "", 63)[0] || "",
//           colX[2] + 1,
//           ry + 4.5,
//         );
//         pdf.text(row.duration || "", colX[3] + 1, ry + 4.5);
//         pdf.text(row.route || "", colX[4] + 1, ry + 4.5);
//         ry += 7;
//       });
//       rxTableEndY = ry + 4;
//     }
//     const notesTop = rxTableEndY + 4;
//     sf(BLUE);
//     pdf.rect(10, notesTop, W - 20, 8, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(8.5);
//     pdf.text("Rx   CLINICAL NOTES / DIAGNOSIS", 14, notesTop + 5.5);
//     st(GOLD);
//     pdf.setFontSize(10);
//     pdf.text("Rx", W - 16, notesTop + 5.5, { align: "right" });
//     const notesBoxH = 46;
//     sf(LGRAY2);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "S");
//     sd([215, 225, 240]);
//     pdf.setLineWidth(0.15);
//     for (let rl = 0; rl < 6; rl++)
//       pdf.line(14, notesTop + 16 + rl * 7, W - 14, notesTop + 16 + rl * 7);
//     st(NAVY);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(9.5);
//     const noteLines = pdf.splitTextToSize(
//       notes || "No diagnosis or notes recorded for this visit.",
//       W - 30,
//     );
//     pdf.text(noteLines, 14, notesTop + 15);
//     let tableEndY = notesTop + notesBoxH + 8;
//     let afterY = tableEndY;
//     if (nextDateFmt) {
//       sf(TEAL2);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "F");
//       sd(TEAL);
//       pdf.setLineWidth(0.4);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "S");
//       sf(TEAL);
//       pdf.roundedRect(10, afterY, 10, 13, 2, 2, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.5);
//       pdf.text("NEXT", 11.2, afterY + 5.5);
//       pdf.text("VISIT", 11.0, afterY + 10);
//       st(TEAL);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(9);
//       pdf.text("Next Appointment:", 24, afterY + 6.5);
//       st(NAVY);
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "bold");
//       pdf.text(nextDateFmt, 72, afterY + 6.5);
//       st(GRAY);
//       pdf.setFontSize(7);
//       pdf.setFont("helvetica", "italic");
//       pdf.text(
//         "Please arrive 10 minutes early and bring this prescription.",
//         24,
//         afterY + 11,
//       );
//       afterY += 19;
//     }
//     const advY = afterY + 4;
//     sf(GOLD2);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "F");
//     sd(GOLD);
//     pdf.setLineWidth(0.35);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "S");
//     sf(GOLD);
//     pdf.roundedRect(10, advY, 10, 20, 2, 2, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(6.2);
//     pdf.text("GEN.", 11.2, advY + 8);
//     pdf.text("ADV.", 11.2, advY + 13.5);
//     st(GOLD);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("General Advice:", 24, advY + 6.5);
//     st(GRAY2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(
//       "1.  Follow all prescribed medicines on time and complete the full course.",
//       24,
//       advY + 11.5,
//     );
//     pdf.text(
//       "2.  Maintain good oral hygiene. Brush gently twice daily.",
//       24,
//       advY + 15.5,
//     );
//     pdf.text(
//       "3.  Avoid very hot, cold, or hard foods until fully healed.",
//       24,
//       advY + 19.2,
//     );
//     pdf.saveGraphicsState();
//     pdf.setGState(new pdf.GState({ opacity: 0.035 }));
//     st(NAVY);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(44);
//     pdf.text("PEARLSMILE", W / 2, H / 2 - 5, { align: "center", angle: 35 });
//     pdf.restoreGraphicsState();
//     const sigY = Math.max(advY + 28, H - 55);
//     const INK = [28, 52, 140],
//       INK2 = [45, 75, 170];
//     const cx = W - 46,
//       cy = sigY + 13,
//       R = 18;
//     sd(INK);
//     pdf.setLineWidth(1.2);
//     pdf.circle(cx, cy, R, "S");
//     pdf.setLineWidth(0.4);
//     pdf.circle(cx, cy, R - 2.5, "S");
//     const drawStar = (sx, sy, sr) => {
//       const pts = [];
//       for (let si = 0; si < 5; si++) {
//         const ao = (si * 4 * Math.PI) / 5 - Math.PI / 2,
//           ai = ao + (2 * Math.PI) / 5;
//         pts.push({ x: sx + sr * Math.cos(ao), y: sy + sr * Math.sin(ao) });
//         pts.push({
//           x: sx + sr * 0.4 * Math.cos(ai),
//           y: sy + sr * 0.4 * Math.sin(ai),
//         });
//       }
//       pdf.setLineWidth(0.3);
//       sd(INK);
//       sf(INK);
//       pdf.lines(
//         pts.slice(1).map((pt, i) => [pt.x - pts[i].x, pt.y - pts[i].y]),
//         pts[0].x,
//         pts[0].y,
//         [1, 1],
//         "FD",
//         true,
//       );
//     };
//     drawStar(cx - R + 3.5, cy + 1, 2.2);
//     drawStar(cx + R - 3.5, cy + 1, 2.2);
//     const docShort = (doc.name || "Doctor").toUpperCase();
//     sd(INK);
//     st(INK);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(5.8);
//     const topSpan = Math.min(docShort.length * 0.19, 1.3),
//       topStart = -Math.PI / 2 - topSpan / 2;
//     for (let ti = 0; ti < docShort.length; ti++) {
//       const ta = topStart + (ti / Math.max(docShort.length - 1, 1)) * topSpan;
//       const tx = cx + (R - 1.5) * Math.cos(ta),
//         ty = cy + (R - 1.5) * Math.sin(ta);
//       const trot = ((ta + Math.PI / 2) * 180) / Math.PI;
//       pdf.text(docShort[ti], tx, ty, { align: "center", angle: -trot });
//     }
//     pdf.setFontSize(5.5);
//     const botStr = "PEARLSMILE DENTAL";
//     const botSpan = Math.min(botStr.length * 0.175, 1.4),
//       botStart = Math.PI / 2 - botSpan / 2;
//     for (let bi = 0; bi < botStr.length; bi++) {
//       const ba = botStart + (bi / Math.max(botStr.length - 1, 1)) * botSpan;
//       const bx = cx + (R - 1.5) * Math.cos(ba),
//         by = cy + (R - 1.5) * Math.sin(ba);
//       const brot = ((ba - Math.PI / 2) * 180) / Math.PI;
//       pdf.text(botStr[bi], bx, by, { align: "center", angle: -brot });
//     }
//     sd(INK);
//     pdf.setLineWidth(0.8);
//     pdf.line(cx, cy - 8, cx, cy + 7);
//     pdf.setLineWidth(0.5);
//     pdf.line(cx, cy - 7.5, cx - 4, cy - 9.5);
//     pdf.line(cx - 4, cy - 9.5, cx - 6, cy - 8);
//     pdf.line(cx - 6, cy - 8, cx - 3, cy - 6.5);
//     pdf.line(cx, cy - 7.5, cx + 4, cy - 9.5);
//     pdf.line(cx + 4, cy - 9.5, cx + 6, cy - 8);
//     pdf.line(cx + 6, cy - 8, cx + 3, cy - 6.5);
//     sf(INK);
//     pdf.circle(cx, cy - 8.2, 1, "F");
//     pdf.setLineWidth(0.6);
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//         [0, -2],
//       ],
//       cx - 3,
//       cy + 5,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [-2, -2],
//         [-2, -2],
//         [0, -2],
//       ],
//       cx + 3,
//       cy + 1,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//       ],
//       cx - 3,
//       cy - 3,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [-2, -2],
//         [-2, -2],
//         [0, -2],
//       ],
//       cx + 3,
//       cy + 5,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//         [0, -2],
//       ],
//       cx - 3,
//       cy + 1,
//       [1, 1],
//       "S",
//     );
//     st(INK);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(4.5);
//     pdf.text("Reg. " + (doc.reg || "—"), cx, cy + R - 5.5, { align: "center" });
//     st(INK2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(6.5);
//     pdf.text("Authorised Signatory", cx, cy + R + 4, { align: "center" });
//     st(GRAY);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 14, sigY + 30);
//     pdf.text("Date: " + todayFmt, W - 14, sigY + 30, { align: "right" });
//     sf(NAVY);
//     pdf.rect(3.5, H - 21, W - 7, 17.5, "F");
//     sf(BLUE);
//     pdf.rect(3.5, H - 7, W - 7, 3.5, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(7.5);
//     pdf.text("PearlSmile Dental Hospital", 10, H - 14.5);
//     st(LBLUE);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text("+91 87936 08083", 10, H - 9.5);
//     pdf.text("care@pearlsmiledental.in", W / 2, H - 9.5, { align: "center" });
//     pdf.text("12, Dental Plaza, MG Road, Pune - 411001", W - 10, H - 9.5, {
//       align: "right",
//     });
//     st(LBLUE2);
//     pdf.setFontSize(6);
//     pdf.setFont("helvetica", "italic");
//     pdf.text(
//       "This is a computer-generated prescription from PearlSmile Dental Hospital. Valid only with authorised doctor details.",
//       W / 2,
//       H - 5.5,
//       { align: "center" },
//     );
//     const blob = pdf.output("blob");
//     const url = URL.createObjectURL(blob);
//     const name =
//       "Prescription_" +
//       (patient.name || "Patient").replace(/\s+/g, "_") +
//       "_" +
//       visitDate +
//       ".pdf";
//     let rawMob = (patient.mobile || "").replace(/[\s\-\(\)\+]/g, "");
//     if (!rawMob.startsWith("91") && rawMob.length === 10)
//       rawMob = "91" + rawMob;
//     setPdfBlob(blob);
//     setPdfUrl(url);
//     setRxMobile(rawMob);
//     setFileName(name);
//     const testFile = new File([blob], name, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [testFile] })
//     )
//       setCanNativeShare(true);
//     setLoading(false);
//   };

//   const openFullPreview = () => {
//     if (pdfUrl) window.open(pdfUrl, "_blank");
//   };

//   const nativeShare = async () => {
//     if (!pdfBlob) return;
//     const file = new File([pdfBlob], fileName, { type: "application/pdf" });
//     const dlLink = document.createElement("a");
//     dlLink.href = pdfUrl;
//     dlLink.download = fileName;
//     dlLink.click();
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [file] })
//     ) {
//       navigator
//         .share({
//           title: "Digital Prescription — PearlSmile Dental Hospital",
//           text: "Dear Patient, please find your digital prescription attached.",
//           files: [file],
//         })
//         .then(() => {
//           showNotify("Sent! ✓", "Prescription shared successfully.");
//           onClose();
//         })
//         .catch((err) => {
//           if (err.name !== "AbortError") {
//             if (rxMobile) {
//               const waMsg = encodeURIComponent(
//                 "Dear Patient, your digital prescription has been generated. Please find the PDF file attached.",
//               );
//               window.open(
//                 "https://wa.me/" + rxMobile + "?text=" + waMsg,
//                 "_blank",
//               );
//             }
//           }
//         });
//     } else {
//       if (rxMobile) {
//         const waMsg = encodeURIComponent(
//           "Dear Patient, your digital prescription has been downloaded. Please check the PDF in your Downloads folder.",
//         );
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" + rxMobile + "?text=" + waMsg,
//               "_blank",
//             ),
//           600,
//         );
//         showNotify(
//           "PDF Downloaded + WhatsApp Opened! ✓",
//           "Prescription saved. WhatsApp opened to patient number.",
//         );
//       } else {
//         showNotify("PDF Downloaded ✓", "Prescription saved. Share manually.");
//       }
//     }
//   };

//   return (
//     <div
//       className="rx-share-overlay open"
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           width: "100%",
//           maxWidth: 540,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//           maxHeight: "92vh",
//         }}
//       >
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "18px 22px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <span style={{ fontSize: 22 }}>📄</span>
//             <div>
//               <div
//                 style={{
//                   color: "#fff",
//                   fontWeight: 600,
//                   fontSize: 15,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Digital Prescription Ready
//               </div>
//               <div
//                 style={{
//                   color: "rgba(255,255,255,0.55)",
//                   fontSize: 12,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 {patient.name} · {visit.visitDate}
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 17,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             ✕
//           </button>
//         </div>
//         <div
//           style={{
//             flex: 1,
//             overflow: "hidden",
//             background: "#f0eeeb",
//             minHeight: 340,
//             position: "relative",
//           }}
//         >
//           {loading && (
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: "#f0eeeb",
//                 gap: 10,
//               }}
//             >
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   border: "3px solid #0d7377",
//                   borderTopColor: "transparent",
//                   borderRadius: "50%",
//                   animation: "spin 0.8s linear infinite",
//                 }}
//               />
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "#5a5550",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Generating PDF…
//               </div>
//             </div>
//           )}
//           {pdfUrl && (
//             <iframe
//               title="prescription"
//               src={pdfUrl}
//               style={{ width: "100%", height: 420, border: "none" }}
//             />
//           )}
//         </div>
//         <div
//           style={{
//             padding: "16px 20px",
//             display: "flex",
//             flexDirection: "column",
//             gap: 10,
//             background: "#fff",
//           }}
//         >
//           <div style={{ display: "flex", gap: 8 }}>
//             <button
//               onClick={openFullPreview}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//             >
//               🔍 Open Full PDF
//             </button>
//             {canNativeShare && (
//               <button
//                 onClick={nativeShare}
//                 onMouseOver={(e) =>
//                   (e.currentTarget.style.background = "#e5e0d8")
//                 }
//                 onMouseOut={(e) =>
//                   (e.currentTarget.style.background = "#f0eeeb")
//                 }
//                 style={{
//                   flex: 1,
//                   background: "#f0eeeb",
//                   color: "#0a1628",
//                   border: "1.5px solid #ddd9d3",
//                   borderRadius: 10,
//                   padding: 10,
//                   fontSize: 13,
//                   fontWeight: 500,
//                   cursor: "pointer",
//                   fontFamily: "DM Sans,sans-serif",
//                   transition: "background 0.2s",
//                 }}
//               >
//                 📤 Share (Device)
//               </button>
//             )}
//           </div>
//           <p
//             style={{
//               fontSize: 11,
//               color: "#9a9590",
//               textAlign: "center",
//               margin: 0,
//               fontFamily: "DM Sans,sans-serif",
//               lineHeight: 1.5,
//             }}
//           >
//             On mobile: tap "Share (Device)" to send directly via WhatsApp.
//             <br />
//             On desktop: use "Open Full PDF" to view, then share manually.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

// // custom fixed
// // ============================================================
// // src/components/admin/PatientsTab.js
// // ✅ All original code untouched
// // ✅ NEW: 🎤 Microphone / Speech-to-text in Doctor Notes
// // ✅ NEW: 🧪 Lab Reports section (add URL, save permanently, delete)
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import ReactDOM from "react-dom";
// import api from "../../utils/api";

// const SERVICES_LIST = [
//   "General Checkup & Cleaning",
//   "Cosmetic Dentistry / Smile Makeover",
//   "Dental Implants",
//   "Orthodontics / Invisalign",
//   "Root Canal Therapy",
//   "Pediatric Dentistry",
//   "Oral Surgery",
//   "Periodontal Treatment",
//   "Teeth Whitening",
//   "Emergency Dental Care",
//   "Follow-Up Visit",
//   "Other",
// ];

// const MONTHS = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];
// const MONTHS_SHORT = [
//   "Jan",
//   "Feb",
//   "Mar",
//   "Apr",
//   "May",
//   "Jun",
//   "Jul",
//   "Aug",
//   "Sep",
//   "Oct",
//   "Nov",
//   "Dec",
// ];

// function fmtDate(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtDateShort(dateStr) {
//   if (!dateStr) return "";
//   const d = new Date(dateStr + "T00:00:00");
//   return d.getDate() + " " + MONTHS_SHORT[d.getMonth()] + " " + d.getFullYear();
// }

// function fmtTime(t) {
//   if (!t) return "";
//   const parts = t.split(":");
//   const hh = parseInt(parts[0]),
//     mm = parts[1];
//   return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
// }

// function totalRevenue(visits = []) {
//   return visits.reduce((sum, v) => {
//     const n = parseFloat((v.amount || "0").toString().replace(/[^0-9.]/g, ""));
//     return sum + (isNaN(n) ? 0 : n);
//   }, 0);
// }

// export default function PatientsTab({ showNotify, doctor }) {
//   const [patients, setPatients] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showNewForm, setShowNewForm] = useState(false);
//   const [newPat, setNewPat] = useState({
//     name: "",
//     mobile: "",
//     email: "",
//     age: "",
//     gender: "",
//     blood: "",
//   });
//   const [selectedPatient, setSelectedPatient] = useState(null);
//   const [rxModal, setRxModal] = useState(null);
//   const [customMeds, setCustomMeds] = useState([]);

//   // ✅ NEW — Lab Reports state
//   const [labReports, setLabReports] = useState([]);
//   const [labName, setLabName] = useState("");
//   const [labUrl, setLabUrl] = useState("");
//   const [labSaving, setLabSaving] = useState(false);
//   const [labUploading, setLabUploading] = useState(false);

//   const today = new Date().toISOString().split("T")[0];
//   const nowTime = new Date().toTimeString().slice(0, 5);
//   const [visitForm, setVisitForm] = useState({
//     date: today,
//     time: nowTime,
//     service: "",
//     amount: "",
//     nextVisitDate: "",
//     notes: "",
//     rxRows: [
//       {
//         medicine: "",
//         dosageParts: ["0", "0", "0"],
//         dosageTiming: "after meal",
//         dosage: "",
//         duration: "",
//         route: "ORAL",
//       },
//     ],
//   });

//   const loadPatients = useCallback(async () => {
//     setLoading(true);
//     try {
//       const data = await api.get("/patients");
//       setPatients(data);
//       setFiltered(data);
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLoading(false);
//   }, []);

//   useEffect(() => {
//     loadPatients();
//   }, [loadPatients]);

//   useEffect(() => {
//     api
//       .get("/custommeds")
//       .then((data) => {
//         if (Array.isArray(data)) setCustomMeds(data);
//       })
//       .catch(() => {});
//   }, []);

//   const filterPatients = (q) => {
//     const term = q.toLowerCase();
//     setFiltered(
//       patients.filter(
//         (p) =>
//           (p.name || "").toLowerCase().includes(term) ||
//           (p.mobile || "").includes(term) ||
//           (p.email || "").toLowerCase().includes(term),
//       ),
//     );
//   };

//   const createPatient = async () => {
//     if (!newPat.name.trim()) {
//       showNotify("Error", "Patient name is required.", true);
//       return;
//     }
//     if (!newPat.mobile.trim()) {
//       showNotify("Error", "Mobile number is required.", true);
//       return;
//     }
//     try {
//       await api.post("/patients", newPat);
//       setNewPat({
//         name: "",
//         mobile: "",
//         email: "",
//         age: "",
//         gender: "",
//         blood: "",
//       });
//       setShowNewForm(false);
//       showNotify(
//         "Patient Profile Created! ✓",
//         "New profile for " + newPat.name + " saved.",
//       );
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const openPatient = async (p) => {
//     try {
//       const full = await api.get("/patients/" + p._id);
//       setSelectedPatient(full);
//       // ✅ NEW — load lab reports
//       setLabReports(full.labReports || []);
//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deletePatient = async () => {
//     if (
//       !window.confirm(
//         "Delete this patient profile and all their records? This cannot be undone.",
//       )
//     )
//       return;
//     try {
//       await api.delete("/patients/" + selectedPatient._id);
//       showNotify("Profile Deleted", "Patient profile removed.");
//       setSelectedPatient(null);
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const saveVisit = async () => {
//     if (!visitForm.date) {
//       showNotify("Missing Fields", "Please select a visit date.", true);
//       return;
//     }
//     if (!visitForm.service) {
//       showNotify("Missing Fields", "Please select a service.", true);
//       return;
//     }
//     try {
//       const payload = {
//         visitDate: visitForm.date,
//         visitTime: visitForm.time,
//         service: visitForm.service,
//         amount: visitForm.amount,
//         nextVisitDate: visitForm.nextVisitDate,
//         notes: visitForm.notes,
//         doctor: doctor?.name || "",
//         prescription: {
//           medicineRows: visitForm.rxRows.filter((r) => r.medicine.trim()),
//         },
//       };
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/visits",
//         payload,
//       );
//       setSelectedPatient(updated);

//       if (visitForm.nextVisitDate && selectedPatient.mobile) {
//         try {
//           await api.post("/appointments", {
//             name: selectedPatient.name,
//             phone: selectedPatient.mobile,
//             service: visitForm.service,
//             date: visitForm.nextVisitDate,
//             time: "",
//             message: "Follow-up visit from Patient Profile",
//             status: "pending",
//           });
//         } catch (_) {}
//       }

//       setVisitForm({
//         date: today,
//         time: nowTime,
//         service: "",
//         amount: "",
//         nextVisitDate: "",
//         notes: "",
//         rxRows: [
//           {
//             medicine: "",
//             dosageParts: ["0", "0", "0"],
//             dosageTiming: "after meal",
//             dosage: "",
//             duration: "",
//             route: "ORAL",
//           },
//         ],
//       });

//       const isFollowUp = /follow[\s\-]?up/i.test(visitForm.notes);
//       if (isFollowUp && visitForm.nextVisitDate && selectedPatient.mobile) {
//         let rawMobile = (selectedPatient.mobile || "").replace(
//           /[\s\-\(\)\+]/g,
//           "",
//         );
//         if (!rawMobile.startsWith("91") && rawMobile.length === 10)
//           rawMobile = "91" + rawMobile;
//         const waMsg = `*PearlSmile Dental Hospital* — Follow-Up Reminder\n\nDear ${selectedPatient.name},\nThis is a reminder for your follow-up appointment.\n\n*Service:* ${visitForm.service}\n*Next Visit:* ${fmtDate(visitForm.nextVisitDate)}\n\nPlease call us to confirm your appointment.\n📞 +91 87936 08083`;
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" +
//                 rawMobile +
//                 "?text=" +
//                 encodeURIComponent(waMsg),
//               "_blank",
//             ),
//           500,
//         );
//         showNotify(
//           "Visit Saved + Follow-Up Appointment Created!",
//           "Reminder sent to " +
//             selectedPatient.name +
//             " for " +
//             fmtDate(visitForm.nextVisitDate) +
//             ". Appointment added to Upcoming.",
//         );
//       } else if (visitForm.nextVisitDate) {
//         showNotify(
//           "Visit Saved + Appointment Created! ✓",
//           "Follow-up appointment for " +
//             fmtDate(visitForm.nextVisitDate) +
//             " added to Upcoming Appointments.",
//         );
//       } else {
//         showNotify(
//           "Visit Record Saved! ✓",
//           "Patient visit has been recorded successfully.",
//         );
//       }
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const deleteVisit = async (visitId) => {
//     if (!window.confirm("Delete this visit record?")) return;
//     try {
//       const result = await api.delete(
//         "/patients/" + selectedPatient._id + "/visits/" + visitId,
//       );
//       setSelectedPatient(result.patient);
//       showNotify("Visit Deleted", "Visit record removed.");
//       loadPatients();
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   const sendPrescription = (visit) => {
//     const treatingDoctor = visit.doctor ? { name: visit.doctor } : doctor;
//     setRxModal({ visit, patient: selectedPatient, doctor: treatingDoctor });
//   };

//   // ✅ NEW — Save Lab Report permanently to MongoDB
//   const saveLabReport = async () => {
//     if (!labName.trim()) {
//       showNotify("Error", "Please enter a report name.", true);
//       return;
//     }
//     if (!labUrl.trim()) {
//       showNotify("Error", "Please enter the file URL.", true);
//       return;
//     }
//     setLabSaving(true);
//     try {
//       const updated = await api.post(
//         "/patients/" + selectedPatient._id + "/labreports",
//         {
//           name: labName.trim(),
//           url: labUrl.trim(),
//         },
//       );
//       setLabReports(updated.labReports || []);
//       setSelectedPatient((prev) => ({
//         ...prev,
//         labReports: updated.labReports || [],
//       }));
//       setLabName("");
//       setLabUrl("");
//       showNotify(
//         "Lab Report Saved! ✓",
//         "Report saved permanently to patient profile.",
//       );
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//     setLabSaving(false);
//   };

//   // ✅ NEW — Delete Lab Report
//   const deleteLabReport = async (reportId) => {
//     if (!window.confirm("Delete this lab report?")) return;
//     try {
//       const updated = await api.delete(
//         "/patients/" + selectedPatient._id + "/labreports/" + reportId,
//       );
//       setLabReports(updated.labReports || []);
//       setSelectedPatient((prev) => ({
//         ...prev,
//         labReports: updated.labReports || [],
//       }));
//       showNotify("Report Deleted", "Lab report removed.");
//     } catch (err) {
//       showNotify("Error", err.message, true);
//     }
//   };

//   // ── LIST VIEW ─────────────────────────────────────────────────
//   if (!selectedPatient) {
//     return (
//       <div>
//         <div className="admin-section-title">Patient Profiles</div>
//         <div className="admin-section-desc">
//           Create and manage individual patient profiles. Click a profile to view
//           visit history and add new records.
//         </div>
//         <div className="patients-list-view">
//           <input
//             type="text"
//             className="patient-search-bar"
//             placeholder="🔍 Search patients by name or phone..."
//             onChange={(e) => filterPatients(e.target.value)}
//           />
//           {showNewForm && (
//             <div className="new-patient-form">
//               <h4>➕ Create New Patient Profile</h4>
//               <div className="new-patient-grid">
//                 {[
//                   ["name", "text", "Full Name *", "Patient full name"],
//                   ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
//                   ["email", "email", "Email Address", "patient@email.com"],
//                   ["age", "number", "Age", "Age"],
//                 ].map(([k, t, label, ph]) => (
//                   <div key={k}>
//                     <div className="admin-row-label">{label}</div>
//                     <input
//                       type={t}
//                       placeholder={ph}
//                       value={newPat[k]}
//                       onChange={(e) =>
//                         setNewPat((p) => ({ ...p, [k]: e.target.value }))
//                       }
//                     />
//                   </div>
//                 ))}
//                 <div>
//                   <div className="admin-row-label">Gender</div>
//                   <select
//                     value={newPat.gender}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, gender: e.target.value }))
//                     }
//                   >
//                     <option value="">Select Gender</option>
//                     <option>Male</option>
//                     <option>Female</option>
//                     <option>Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <div className="admin-row-label">Blood Group</div>
//                   <input
//                     type="text"
//                     placeholder="e.g. B+"
//                     value={newPat.blood}
//                     onChange={(e) =>
//                       setNewPat((p) => ({ ...p, blood: e.target.value }))
//                     }
//                   />
//                 </div>
//               </div>
//               <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
//                 <button className="add-visit-save-btn" onClick={createPatient}>
//                   💾 Save Patient Profile
//                 </button>
//                 <button
//                   className="btn-back-patients"
//                   onClick={() => setShowNewForm(false)}
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           )}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               marginBottom: 14,
//               flexWrap: "wrap",
//               gap: 10,
//             }}
//           >
//             <div style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {loading
//                 ? "Loading patients..."
//                 : `${filtered.length} patient profile${filtered.length !== 1 ? "s" : ""}`}
//             </div>
//             <button
//               className="admin-add-btn"
//               onClick={() => setShowNewForm((s) => !s)}
//             >
//               {showNewForm ? "Cancel" : "+ New Patient Profile"}
//             </button>
//           </div>
//           <div className="patient-profiles-grid">
//             {loading ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "20px 0",
//                   gridColumn: "1/-1",
//                 }}
//               >
//                 Loading...
//               </div>
//             ) : filtered.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 14,
//                   padding: "24px 0",
//                   gridColumn: "1/-1",
//                   textAlign: "center",
//                 }}
//               >
//                 No patients yet. Click "+ New Patient Profile" to add your first
//                 patient.
//               </div>
//             ) : (
//               filtered.map((p) => (
//                 <div
//                   key={p._id}
//                   className="patient-profile-card"
//                   onClick={() => openPatient(p)}
//                 >
//                   <div className="patient-avatar-icon">🧑‍⚕️</div>
//                   <div className="patient-card-name">{p.name}</div>
//                   <div className="patient-card-id">📞 {p.mobile || "—"}</div>
//                   <div className="patient-card-visits">
//                     📋 {p.visitCount || 0} visit{p.visitCount !== 1 ? "s" : ""}
//                   </div>
//                 </div>
//               ))
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // ── DETAIL VIEW ───────────────────────────────────────────────
//   const p = selectedPatient;
//   const visits = p.visits || [];
//   const total = totalRevenue(visits);

//   return (
//     <div>
//       <div className="patient-detail-view open">
//         <div className="patient-detail-header">
//           <button
//             className="btn-back-patients"
//             onClick={() => {
//               setSelectedPatient(null);
//             }}
//           >
//             ← Back to Patients
//           </button>
//           <div
//             className="patient-avatar-icon"
//             style={{ width: 56, height: 56, fontSize: 26 }}
//           >
//             🧑‍⚕️
//           </div>
//           <div style={{ flex: 1 }}>
//             <h3>{p.name}</h3>
//             <p style={{ fontSize: 13, color: "var(--gray-400)" }}>
//               {p.email}
//               {p.email && p.mobile ? " · " : ""}
//               {p.mobile}
//             </p>
//             <div className="patient-info-row">
//               {[
//                 p.age ? "Age: " + p.age : null,
//                 p.gender || null,
//                 p.blood ? "Blood: " + p.blood : null,
//               ]
//                 .filter(Boolean)
//                 .map((t, i) => (
//                   <span key={i} className="patient-info-pill">
//                     {t}
//                   </span>
//                 ))}
//             </div>
//           </div>
//           <div style={{ textAlign: "right", flexShrink: 0 }}>
//             <div
//               style={{
//                 fontSize: 11,
//                 color: "var(--gray-400)",
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//                 marginBottom: 4,
//               }}
//             >
//               Total Revenue
//             </div>
//             <div
//               style={{
//                 fontFamily: "Cormorant Garamond,serif",
//                 fontSize: 26,
//                 fontWeight: 600,
//                 color: "var(--teal)",
//                 lineHeight: 1,
//               }}
//             >
//               Rs. {total.toLocaleString("en-IN")}
//             </div>
//             <div
//               style={{ fontSize: 11, color: "var(--gray-400)", marginTop: 2 }}
//             >
//               {visits.length} visit{visits.length !== 1 ? "s" : ""}
//             </div>
//           </div>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 8,
//               alignSelf: "flex-start",
//               marginTop: 4,
//             }}
//           >
//             <button className="admin-del-btn" onClick={deletePatient}>
//               🗑️ Delete Profile
//             </button>
//           </div>
//         </div>

//         {/* Add Visit Form — original simple layout */}
//         <div className="add-visit-form">
//           <h4>📋 Add New Visit Record</h4>
//           <div className="add-visit-grid">
//             <div>
//               <div className="admin-row-label">Visit Date *</div>
//               <input
//                 type="date"
//                 value={visitForm.date}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, date: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Visit Time</div>
//               <input
//                 type="time"
//                 value={visitForm.time}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, time: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div className="admin-row-label">Service Taken *</div>
//               <select
//                 value={visitForm.service}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, service: e.target.value }))
//                 }
//               >
//                 <option value="">Select Service</option>
//                 {SERVICES_LIST.map((s) => (
//                   <option key={s} value={s}>
//                     {s}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <div className="admin-row-label">Amount Charged (Rs.)</div>
//               <input
//                 type="text"
//                 placeholder="e.g. 2500"
//                 value={visitForm.amount}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, amount: e.target.value }))
//                 }
//               />
//             </div>
//             <div>
//               <div
//                 className="admin-row-label"
//                 style={{ display: "flex", alignItems: "center", gap: 6 }}
//               >
//                 Next Date to Visit
//                 <span
//                   style={{
//                     fontSize: 10,
//                     color: "var(--teal)",
//                     fontWeight: 400,
//                     background: "rgba(13,115,119,0.08)",
//                     padding: "2px 8px",
//                     borderRadius: 100,
//                     border: "1px solid rgba(13,115,119,0.2)",
//                   }}
//                 >
//                   For follow-up
//                 </span>
//               </div>
//               <input
//                 type="date"
//                 value={visitForm.nextVisitDate}
//                 onChange={(e) =>
//                   setVisitForm((f) => ({ ...f, nextVisitDate: e.target.value }))
//                 }
//                 style={{ marginTop: 6 }}
//               />
//             </div>
//           </div>

//           {/* ── Prescription Table ─────────────────────────── */}
//           <style>{`
//             @media (max-width: 640px) { .rx-table-desktop { display: none !important; } .rx-card-mobile { display: block !important; } }
//             @media (min-width: 641px) { .rx-table-desktop { display: block !important; } .rx-card-mobile { display: none !important; } }
//             @keyframes micPulse { 0%,100% { box-shadow: 0 0 0 0 rgba(220,38,38,0.5); } 70% { box-shadow: 0 0 0 10px rgba(220,38,38,0); } }
//             .mic-active { animation: micPulse 1.2s ease-in-out infinite; background: #dc2626 !important; border-color: #dc2626 !important; }
//           `}</style>
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 8 }}
//           >
//             💊 Prescription
//           </div>

//           {/* ── DESKTOP TABLE ── */}
//           <div
//             className="rx-table-desktop"
//             style={{
//               overflowX: "auto",
//               marginBottom: 8,
//               position: "relative",
//               zIndex: 1000,
//             }}
//           >
//             <table
//               style={{
//                 width: "100%",
//                 borderCollapse: "collapse",
//                 fontSize: 13,
//                 fontFamily: "'DM Sans',sans-serif",
//                 minWidth: 560,
//               }}
//             >
//               <thead>
//                 <tr
//                   style={{
//                     background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                     color: "#fff",
//                   }}
//                 >
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 36,
//                     }}
//                   >
//                     SR.
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     MEDICINE
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                     }}
//                   >
//                     DOSAGE INSTRUCTION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     DURATION
//                   </th>
//                   <th
//                     style={{
//                       padding: "8px 10px",
//                       textAlign: "left",
//                       fontWeight: 600,
//                       fontSize: 12,
//                       width: 95,
//                     }}
//                   >
//                     ROUTE
//                   </th>
//                   <th style={{ padding: "8px 10px", width: 32 }}></th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {visitForm.rxRows.map((row, idx) => (
//                   <tr
//                     key={idx}
//                     style={{
//                       background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                       borderBottom: "1px solid #e8e4e0",
//                     }}
//                   >
//                     <td
//                       style={{
//                         padding: "6px 10px",
//                         color: "#666",
//                         fontSize: 12,
//                         textAlign: "center",
//                       }}
//                     >
//                       {idx + 1}
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <RxMedInput
//                         value={row.medicine}
//                         onChange={(v) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], medicine: v };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         customMeds={customMeds}
//                         onCustomSaved={(saved) => {
//                           if (saved && saved._id) {
//                             setCustomMeds((prev) => {
//                               const exists = prev.some(
//                                 (m) =>
//                                   m._id === saved._id ||
//                                   m.name.toLowerCase() ===
//                                     saved.name.toLowerCase(),
//                               );
//                               if (exists) return prev;
//                               return [saved, ...prev];
//                             });
//                           } else {
//                             api
//                               .get("/custommeds")
//                               .then((data) => {
//                                 if (Array.isArray(data)) setCustomMeds(data);
//                               })
//                               .catch(() => {});
//                           }
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 4,
//                           flexWrap: "nowrap",
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 2,
//                           }}
//                         >
//                           {["M", "A", "N"].map((label, li) => (
//                             <div
//                               key={label}
//                               style={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: "center",
//                               }}
//                             >
//                               <span
//                                 style={{
//                                   fontSize: 9,
//                                   color: "#888",
//                                   marginBottom: 1,
//                                 }}
//                               >
//                                 {label}
//                               </span>
//                               <input
//                                 type="text"
//                                 maxLength={2}
//                                 value={
//                                   (row.dosageParts || ["0", "0", "0"])[li] ||
//                                   "0"
//                                 }
//                                 onFocus={(e) => {
//                                   if (e.target.value === "0") e.target.select();
//                                 }}
//                                 onChange={(e) => {
//                                   const rows = [...visitForm.rxRows];
//                                   const parts = [
//                                     ...(rows[idx].dosageParts || [
//                                       "0",
//                                       "0",
//                                       "0",
//                                     ]),
//                                   ];
//                                   parts[li] =
//                                     e.target.value === ""
//                                       ? "0"
//                                       : e.target.value;
//                                   rows[idx] = {
//                                     ...rows[idx],
//                                     dosageParts: parts,
//                                     dosage:
//                                       parts.join("-") +
//                                       (rows[idx].dosageTiming
//                                         ? " " + rows[idx].dosageTiming
//                                         : ""),
//                                   };
//                                   setVisitForm((f) => ({ ...f, rxRows: rows }));
//                                 }}
//                                 style={{
//                                   width: 28,
//                                   border: "1px solid #ddd",
//                                   borderRadius: 4,
//                                   padding: "4px 3px",
//                                   fontSize: 12,
//                                   textAlign: "center",
//                                   fontFamily: "'DM Sans',sans-serif",
//                                 }}
//                               />
//                             </div>
//                           ))}
//                         </div>
//                         <select
//                           value={row.dosageTiming || "after meal"}
//                           onChange={(e) => {
//                             const rows = [...visitForm.rxRows];
//                             const parts = rows[idx].dosageParts || [
//                               "0",
//                               "0",
//                               "0",
//                             ];
//                             rows[idx] = {
//                               ...rows[idx],
//                               dosageTiming: e.target.value,
//                               dosage: parts.join("-") + " " + e.target.value,
//                             };
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             border: "1px solid #ddd",
//                             borderRadius: 4,
//                             padding: "4px 5px",
//                             fontSize: 11,
//                             fontFamily: "'DM Sans',sans-serif",
//                             color: "#444",
//                           }}
//                         >
//                           <option>after meal</option>
//                           <option>before meal</option>
//                           <option>with meal</option>
//                           <option>empty stomach</option>
//                           <option>at bedtime</option>
//                           <option>as directed</option>
//                         </select>
//                       </div>
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <input
//                         type="text"
//                         placeholder="e.g. 7 days"
//                         value={row.duration}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = {
//                             ...rows[idx],
//                             duration: e.target.value,
//                           };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 8px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       />
//                     </td>
//                     <td style={{ padding: "4px 6px" }}>
//                       <select
//                         value={row.route}
//                         onChange={(e) => {
//                           const rows = [...visitForm.rxRows];
//                           rows[idx] = { ...rows[idx], route: e.target.value };
//                           setVisitForm((f) => ({ ...f, rxRows: rows }));
//                         }}
//                         style={{
//                           width: "100%",
//                           border: "1px solid #ddd",
//                           borderRadius: 5,
//                           padding: "5px 6px",
//                           fontSize: 12,
//                           fontFamily: "'DM Sans',sans-serif",
//                         }}
//                       >
//                         <option>ORAL</option>
//                         <option>TOPICAL</option>
//                         <option>INJECTION</option>
//                         <option>INHALER</option>
//                         <option>DROPS</option>
//                         <option>GARGLE</option>
//                         <option>OTHER</option>
//                       </select>
//                     </td>
//                     <td style={{ padding: "4px 6px", textAlign: "center" }}>
//                       {visitForm.rxRows.length > 1 && (
//                         <button
//                           onClick={() => {
//                             const rows = visitForm.rxRows.filter(
//                               (_, i) => i !== idx,
//                             );
//                             setVisitForm((f) => ({ ...f, rxRows: rows }));
//                           }}
//                           style={{
//                             background: "none",
//                             border: "none",
//                             color: "#e74c3c",
//                             fontSize: 16,
//                             cursor: "pointer",
//                             padding: "2px 6px",
//                           }}
//                           title="Remove"
//                         >
//                           ✕
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* ── MOBILE CARDS ── */}
//           <div className="rx-card-mobile" style={{ marginBottom: 8 }}>
//             {visitForm.rxRows.map((row, idx) => (
//               <div
//                 key={idx}
//                 style={{
//                   background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
//                   border: "1px solid #e8e4e0",
//                   borderRadius: 8,
//                   padding: "10px 12px",
//                   marginBottom: 8,
//                   position: "relative",
//                 }}
//               >
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     marginBottom: 8,
//                   }}
//                 >
//                   <span
//                     style={{
//                       fontSize: 11,
//                       fontWeight: 700,
//                       color: "#0a1628",
//                       background: "rgba(10,22,40,0.08)",
//                       padding: "2px 8px",
//                       borderRadius: 20,
//                     }}
//                   >
//                     #{idx + 1}
//                   </span>
//                   {visitForm.rxRows.length > 1 && (
//                     <button
//                       onClick={() => {
//                         const rows = visitForm.rxRows.filter(
//                           (_, i) => i !== idx,
//                         );
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         background: "none",
//                         border: "none",
//                         color: "#e74c3c",
//                         fontSize: 16,
//                         cursor: "pointer",
//                         padding: "2px 6px",
//                       }}
//                       title="Remove"
//                     >
//                       ✕
//                     </button>
//                   )}
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Medicine
//                   </div>
//                   <RxMedInput
//                     value={row.medicine}
//                     onChange={(v) => {
//                       const rows = [...visitForm.rxRows];
//                       rows[idx] = { ...rows[idx], medicine: v };
//                       setVisitForm((f) => ({ ...f, rxRows: rows }));
//                     }}
//                     customMeds={customMeds}
//                     onCustomSaved={(saved) => {
//                       if (saved && saved._id) {
//                         setCustomMeds((prev) => {
//                           const exists = prev.some(
//                             (m) =>
//                               m._id === saved._id ||
//                               m.name.toLowerCase() === saved.name.toLowerCase(),
//                           );
//                           if (exists) return prev;
//                           return [saved, ...prev];
//                         });
//                       } else {
//                         api
//                           .get("/custommeds")
//                           .then((data) => {
//                             if (Array.isArray(data)) setCustomMeds(data);
//                           })
//                           .catch(() => {});
//                       }
//                     }}
//                   />
//                 </div>
//                 <div style={{ marginBottom: 8 }}>
//                   <div
//                     style={{
//                       fontSize: 10,
//                       color: "#888",
//                       fontWeight: 600,
//                       marginBottom: 3,
//                       textTransform: "uppercase",
//                     }}
//                   >
//                     Dosage Instruction
//                   </div>
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 6,
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <div
//                       style={{ display: "flex", alignItems: "center", gap: 4 }}
//                     >
//                       {["M", "A", "N"].map((label, li) => (
//                         <div
//                           key={label}
//                           style={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                           }}
//                         >
//                           <span
//                             style={{
//                               fontSize: 9,
//                               color: "#888",
//                               marginBottom: 1,
//                             }}
//                           >
//                             {label}
//                           </span>
//                           <input
//                             type="text"
//                             maxLength={2}
//                             value={
//                               (row.dosageParts || ["0", "0", "0"])[li] || "0"
//                             }
//                             onFocus={(e) => {
//                               if (e.target.value === "0") e.target.select();
//                             }}
//                             onChange={(e) => {
//                               const rows = [...visitForm.rxRows];
//                               const parts = [
//                                 ...(rows[idx].dosageParts || ["0", "0", "0"]),
//                               ];
//                               parts[li] =
//                                 e.target.value === "" ? "0" : e.target.value;
//                               rows[idx] = {
//                                 ...rows[idx],
//                                 dosageParts: parts,
//                                 dosage:
//                                   parts.join("-") +
//                                   (rows[idx].dosageTiming
//                                     ? " " + rows[idx].dosageTiming
//                                     : ""),
//                               };
//                               setVisitForm((f) => ({ ...f, rxRows: rows }));
//                             }}
//                             style={{
//                               width: 34,
//                               border: "1px solid #ddd",
//                               borderRadius: 4,
//                               padding: "5px 3px",
//                               fontSize: 13,
//                               textAlign: "center",
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           />
//                         </div>
//                       ))}
//                     </div>
//                     <select
//                       value={row.dosageTiming || "after meal"}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         const parts = rows[idx].dosageParts || ["0", "0", "0"];
//                         rows[idx] = {
//                           ...rows[idx],
//                           dosageTiming: e.target.value,
//                           dosage: parts.join("-") + " " + e.target.value,
//                         };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         flex: 1,
//                         border: "1px solid #ddd",
//                         borderRadius: 4,
//                         padding: "5px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         color: "#444",
//                         minWidth: 120,
//                       }}
//                     >
//                       <option>after meal</option>
//                       <option>before meal</option>
//                       <option>with meal</option>
//                       <option>empty stomach</option>
//                       <option>at bedtime</option>
//                       <option>as directed</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div style={{ display: "flex", gap: 8 }}>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Duration
//                     </div>
//                     <input
//                       type="text"
//                       placeholder="e.g. 7 days"
//                       value={row.duration}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], duration: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 8px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                         boxSizing: "border-box",
//                       }}
//                     />
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <div
//                       style={{
//                         fontSize: 10,
//                         color: "#888",
//                         fontWeight: 600,
//                         marginBottom: 3,
//                         textTransform: "uppercase",
//                       }}
//                     >
//                       Route
//                     </div>
//                     <select
//                       value={row.route}
//                       onChange={(e) => {
//                         const rows = [...visitForm.rxRows];
//                         rows[idx] = { ...rows[idx], route: e.target.value };
//                         setVisitForm((f) => ({ ...f, rxRows: rows }));
//                       }}
//                       style={{
//                         width: "100%",
//                         border: "1px solid #ddd",
//                         borderRadius: 5,
//                         padding: "6px 6px",
//                         fontSize: 12,
//                         fontFamily: "'DM Sans',sans-serif",
//                       }}
//                     >
//                       <option>ORAL</option>
//                       <option>TOPICAL</option>
//                       <option>INJECTION</option>
//                       <option>INHALER</option>
//                       <option>DROPS</option>
//                       <option>GARGLE</option>
//                       <option>OTHER</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button
//             onClick={() =>
//               setVisitForm((f) => ({
//                 ...f,
//                 rxRows: [
//                   ...f.rxRows,
//                   {
//                     medicine: "",
//                     dosageParts: ["0", "0", "0"],
//                     dosageTiming: "after meal",
//                     dosage: "",
//                     duration: "",
//                     route: "ORAL",
//                   },
//                 ],
//               }))
//             }
//             style={{
//               marginTop: 4,
//               marginBottom: 8,
//               background: "rgba(13,115,119,0.08)",
//               border: "1px solid rgba(13,115,119,0.3)",
//               color: "var(--teal)",
//               borderRadius: 7,
//               padding: "6px 16px",
//               fontSize: 12,
//               fontWeight: 600,
//               cursor: "pointer",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             + Add Medicine
//           </button>

//           {/* ── Doctor Notes / Diagnosis — ✅ NOW WITH 🎤 MIC ───────── */}
//           <div
//             className="admin-row-label"
//             style={{ marginBottom: 6, marginTop: 10 }}
//           >
//             Doctor Notes / Diagnosis
//           </div>
//           <MedAutocompleteWithMic
//             value={visitForm.notes}
//             onChange={(v) => setVisitForm((f) => ({ ...f, notes: v }))}
//             customMeds={customMeds}
//             onCustomSaved={(saved) => {
//               if (saved && saved._id) {
//                 setCustomMeds((prev) => {
//                   const exists = prev.some(
//                     (m) =>
//                       m._id === saved._id ||
//                       m.name.toLowerCase() === saved.name.toLowerCase(),
//                   );
//                   if (exists) return prev;
//                   return [saved, ...prev];
//                 });
//               } else {
//                 api
//                   .get("/custommeds")
//                   .then((data) => {
//                     if (Array.isArray(data)) setCustomMeds(data);
//                   })
//                   .catch(() => {});
//               }
//             }}
//           />
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               flexWrap: "wrap",
//               gap: 10,
//               marginTop: 4,
//             }}
//           >
//             <button className="add-visit-save-btn" onClick={saveVisit}>
//               💾 Save Visit Record
//             </button>
//           </div>
//         </div>

//         {/* Visit History */}
//         <div style={{ marginBottom: 12 }}>
//           <div className="admin-section-title" style={{ marginBottom: 8 }}>
//             Visit History
//           </div>
//           <div className="visit-records-list">
//             {visits.length === 0 ? (
//               <div
//                 style={{
//                   color: "var(--gray-400)",
//                   fontSize: 13,
//                   padding: "10px 0",
//                 }}
//               >
//                 No visits recorded yet. Add the first visit above.
//               </div>
//             ) : (
//               visits.map((v, i) => {
//                 const dtStr =
//                   (v.visitDate || "") +
//                   (v.visitTime ? " at " + v.visitTime : "");
//                 const isFollowUp = /follow[\s\-]?up/i.test(v.notes || "");
//                 return (
//                   <div key={v._id || i} className="visit-record-card">
//                     <button
//                       className="visit-del-btn"
//                       onClick={() => deleteVisit(v._id)}
//                       title="Delete"
//                     >
//                       ✕
//                     </button>
//                     <div className="visit-record-meta">
//                       <span className="visit-record-service">
//                         {v.service || "Visit"}
//                       </span>
//                       <span className="visit-record-date">📅 {dtStr}</span>
//                       {v.amount && (
//                         <span
//                           className="patient-info-pill"
//                           style={{ fontSize: 11 }}
//                         >
//                           Rs. {v.amount}
//                         </span>
//                       )}
//                       {v.doctor && (
//                         <span
//                           style={{
//                             fontSize: 11,
//                             color: "var(--teal)",
//                             fontWeight: 600,
//                             background: "rgba(13,115,119,0.08)",
//                             padding: "2px 8px",
//                             borderRadius: 100,
//                             border: "1px solid rgba(13,115,119,0.2)",
//                           }}
//                         >
//                           👨‍⚕️ {v.doctor}
//                         </span>
//                       )}
//                     </div>
//                     <div className="visit-record-notes">{v.notes || "—"}</div>
//                     {v.prescription &&
//                       v.prescription.medicineRows &&
//                       v.prescription.medicineRows.length > 0 && (
//                         <div style={{ marginTop: 10, overflowX: "auto" }}>
//                           <table
//                             style={{
//                               width: "100%",
//                               borderCollapse: "collapse",
//                               fontSize: 12,
//                               fontFamily: "'DM Sans',sans-serif",
//                             }}
//                           >
//                             <thead>
//                               <tr
//                                 style={{
//                                   background:
//                                     "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                                   color: "#fff",
//                                 }}
//                               >
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 30,
//                                   }}
//                                 >
//                                   SR.
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   MEDICINE
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                   }}
//                                 >
//                                   DOSAGE INSTRUCTION
//                                 </th>
//                                 <th
//                                   style={{
//                                     padding: "6px 8px",
//                                     textAlign: "left",
//                                     fontWeight: 600,
//                                     fontSize: 11,
//                                     width: 90,
//                                   }}
//                                 >
//                                   DUR. / ROUTE
//                                 </th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {v.prescription.medicineRows.map((row, ri) => (
//                                 <tr
//                                   key={ri}
//                                   style={{
//                                     background:
//                                       ri % 2 === 0 ? "#f8f9fc" : "#fff",
//                                     borderBottom: "1px solid #e8e4e0",
//                                   }}
//                                 >
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                       textAlign: "center",
//                                     }}
//                                   >
//                                     {ri + 1}.
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       fontWeight: 600,
//                                       color: "#0a1628",
//                                     }}
//                                   >
//                                     {row.medicine || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#444",
//                                     }}
//                                   >
//                                     {row.dosage || "—"}
//                                   </td>
//                                   <td
//                                     style={{
//                                       padding: "5px 8px",
//                                       color: "#666",
//                                       fontSize: 11,
//                                     }}
//                                   >
//                                     {row.duration}
//                                     {row.duration && row.route ? " / " : ""}
//                                     {row.route}
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </table>
//                         </div>
//                       )}
//                     {v.nextVisitDate && (
//                       <div
//                         style={{
//                           marginTop: 8,
//                           display: "inline-flex",
//                           alignItems: "center",
//                           gap: 6,
//                           background: isFollowUp
//                             ? "rgba(201,168,76,0.12)"
//                             : "rgba(13,115,119,0.08)",
//                           border:
//                             "1px solid " +
//                             (isFollowUp
//                               ? "rgba(201,168,76,0.35)"
//                               : "rgba(13,115,119,0.2)"),
//                           borderRadius: 100,
//                           padding: "3px 12px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           color: isFollowUp ? "#8b6914" : "var(--teal)",
//                         }}
//                       >
//                         {isFollowUp ? "Follow-Up: " : "Next Visit: "}
//                         {fmtDateShort(v.nextVisitDate)}
//                         {isFollowUp ? " — WhatsApp sent" : ""}
//                       </div>
//                     )}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 8,
//                         marginTop: 10,
//                         flexWrap: "wrap",
//                       }}
//                     >
//                       <button
//                         onClick={() => sendPrescription(v)}
//                         style={{
//                           background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Send Prescription
//                       </button>
//                       <button
//                         onClick={() => {
//                           let mob = (p.mobile || "").replace(
//                             /[\s\-\(\)\+]/g,
//                             "",
//                           );
//                           if (!mob) {
//                             alert("No mobile number saved for this patient.");
//                             return;
//                           }
//                           if (!mob.startsWith("91") && mob.length === 10)
//                             mob = "91" + mob;
//                           const msg = encodeURIComponent(
//                             ` *Welcome to PearlSmile Dental Hospital!*\n\nDear ${p.name},\n\nWe warmly welcome you to our family. It is a pleasure to have you with us.\n\nWe are committed to providing you the best dental care and a comfortable experience throughout your journey with us.\n\n_Wishing you great health and a beautiful smile!_\n— *PearlSmile Dental Hospital Team*`,
//                           );
//                           window.open(
//                             "https://wa.me/" + mob + "?text=" + msg,
//                             "_blank",
//                           );
//                         }}
//                         style={{
//                           background: "linear-gradient(135deg,#25d366,#128c7e)",
//                           color: "white",
//                           border: "none",
//                           borderRadius: 7,
//                           padding: "7px 14px",
//                           fontSize: 12,
//                           fontWeight: 500,
//                           cursor: "pointer",
//                           fontFamily: "'DM Sans',sans-serif",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 6,
//                           transition: "opacity 0.2s",
//                         }}
//                         onMouseOver={(e) =>
//                           (e.currentTarget.style.opacity = "0.85")
//                         }
//                         onMouseOut={(e) =>
//                           (e.currentTarget.style.opacity = "1")
//                         }
//                       >
//                         <svg
//                           width="13"
//                           height="13"
//                           viewBox="0 0 24 24"
//                           fill="white"
//                         >
//                           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
//                           <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
//                         </svg>
//                         Patient Number
//                       </button>
//                     </div>
//                   </div>
//                 );
//               })
//             )}
//           </div>
//         </div>

//         {/* ✅ NEW: Lab Reports Section */}
//         <div style={{ marginBottom: 24 }}>
//           <div className="admin-section-title" style={{ marginBottom: 8 }}>
//             🧪 Lab Reports
//           </div>
//           <div style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
//             Upload patient lab reports by pasting a public file URL (Google
//             Drive, Dropbox, etc). Saved permanently to this patient profile.
//           </div>
//           {/* Add Report Form */}
//           <div
//             style={{
//               background: "#f8fafc",
//               border: "1.5px solid #e2e8f0",
//               borderRadius: 12,
//               padding: 16,
//               marginBottom: 16,
//             }}
//           >
//             {/* Row 1: Report Name */}
//             <div style={{ marginBottom: 12 }}>
//               <div
//                 style={{
//                   fontSize: 12,
//                   fontWeight: 600,
//                   color: "#475569",
//                   marginBottom: 4,
//                 }}
//               >
//                 Report Name *
//               </div>
//               <input
//                 type="text"
//                 placeholder="e.g. Blood Report, X-Ray, OPG"
//                 value={labName}
//                 onChange={(e) => setLabName(e.target.value)}
//                 style={{
//                   width: "100%",
//                   padding: "9px 12px",
//                   borderRadius: 8,
//                   border: "1.5px solid #e2e8f0",
//                   fontSize: 13,
//                   fontFamily: "DM Sans,sans-serif",
//                   outline: "none",
//                   background: "#fff",
//                   boxSizing: "border-box",
//                 }}
//               />
//             </div>
//             {/* Row 2: File Upload OR URL */}
//             <div style={{ marginBottom: 12 }}>
//               <div
//                 style={{
//                   fontSize: 12,
//                   fontWeight: 600,
//                   color: "#475569",
//                   marginBottom: 8,
//                 }}
//               >
//                 Attach File or Paste URL *
//               </div>
//               {/* File Upload Button */}
//               <div
//                 style={{
//                   display: "flex",
//                   gap: 10,
//                   alignItems: "center",
//                   marginBottom: 8,
//                   flexWrap: "wrap",
//                 }}
//               >
//                 <label
//                   style={{
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 7,
//                     padding: "9px 16px",
//                     background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//                     color: "#fff",
//                     borderRadius: 8,
//                     fontSize: 13,
//                     fontWeight: 600,
//                     cursor: "pointer",
//                     fontFamily: "DM Sans,sans-serif",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   📎 Upload File
//                   <input
//                     type="file"
//                     accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
//                     style={{ display: "none" }}
//                     onChange={(e) => {
//                       const file = e.target.files[0];
//                       if (!file) return;
//                       // Auto-fill report name from filename if empty
//                       if (!labName.trim()) {
//                         setLabName(file.name.replace(/\.[^/.]+$/, ""));
//                       }
//                       setLabUploading(true);
//                       setLabUrl(""); // clear URL field
//                       // Convert to base64 data URL for preview; store as data URL
//                       const reader = new FileReader();
//                       reader.onload = (ev) => {
//                         setLabUrl(ev.target.result);
//                         setLabUploading(false);
//                       };
//                       reader.onerror = () => {
//                         showNotify("Error", "Could not read file.", true);
//                         setLabUploading(false);
//                       };
//                       reader.readAsDataURL(file);
//                     }}
//                   />
//                 </label>
//                 <span style={{ fontSize: 12, color: "#94a3b8" }}>
//                   or paste a public link below
//                 </span>
//               </div>
//               {/* URL Input */}
//               <input
//                 type="url"
//                 placeholder="https://drive.google.com/file/d/... or https://cloudinary.com/..."
//                 value={labUrl.startsWith("data:") ? "" : labUrl}
//                 onChange={(e) => setLabUrl(e.target.value)}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter") saveLabReport();
//                 }}
//                 disabled={labUrl.startsWith("data:")}
//                 style={{
//                   width: "100%",
//                   padding: "9px 12px",
//                   borderRadius: 8,
//                   border: "1.5px solid #e2e8f0",
//                   fontSize: 13,
//                   fontFamily: "DM Sans,sans-serif",
//                   outline: "none",
//                   background: labUrl.startsWith("data:") ? "#f1f5f9" : "#fff",
//                   boxSizing: "border-box",
//                   color: labUrl.startsWith("data:") ? "#94a3b8" : "#0a1628",
//                 }}
//               />
//               {/* File preview strip */}
//               {labUrl.startsWith("data:") && (
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 10,
//                     marginTop: 8,
//                     background: "#f0fdf4",
//                     border: "1px solid #86efac",
//                     borderRadius: 8,
//                     padding: "8px 12px",
//                   }}
//                 >
//                   <span style={{ fontSize: 18 }}>
//                     {labUrl.startsWith("data:image") ? "🖼️" : "📄"}
//                   </span>
//                   <span
//                     style={{
//                       fontSize: 12,
//                       color: "#16a34a",
//                       fontWeight: 600,
//                       flex: 1,
//                     }}
//                   >
//                     File loaded and ready to save
//                   </span>
//                   <button
//                     onClick={() => {
//                       setLabUrl("");
//                     }}
//                     style={{
//                       background: "none",
//                       border: "none",
//                       color: "#dc2626",
//                       cursor: "pointer",
//                       fontSize: 13,
//                       fontWeight: 600,
//                     }}
//                   >
//                     ✕ Remove
//                   </button>
//                 </div>
//               )}
//             </div>
//             {/* Save Button */}
//             <button
//               onClick={saveLabReport}
//               disabled={labSaving || labUploading}
//               style={{
//                 padding: "10px 22px",
//                 background:
//                   labSaving || labUploading
//                     ? "#94a3b8"
//                     : "linear-gradient(135deg,#0d7377,#14a0a5)",
//                 color: "#fff",
//                 border: "none",
//                 borderRadius: 8,
//                 fontSize: 13,
//                 fontWeight: 700,
//                 cursor: labSaving || labUploading ? "not-allowed" : "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//               }}
//             >
//               {labUploading
//                 ? "⏳ Loading file..."
//                 : labSaving
//                   ? "Saving..."
//                   : "💾 Save Report"}
//             </button>
//             <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 8 }}>
//               💡 Upload: PDF, images, Word, Excel (stored in this browser
//               session). For permanent cloud storage paste a Google Drive /
//               Cloudinary public link.
//             </div>
//           </div>
//           {/* Lab Reports List */}
//           {labReports.length === 0 ? (
//             <div style={{ color: "#94a3b8", fontSize: 13, padding: "12px 0" }}>
//               No lab reports saved yet. Add the first report above.
//             </div>
//           ) : (
//             <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//               {labReports.map((report, i) => (
//                 <div
//                   key={report._id || i}
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 12,
//                     background: "#fff",
//                     border: "1.5px solid #e2e8f0",
//                     borderRadius: 10,
//                     padding: "12px 16px",
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: 40,
//                       height: 40,
//                       background: "rgba(13,115,119,0.08)",
//                       borderRadius: 8,
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       fontSize: 20,
//                       flexShrink: 0,
//                     }}
//                   >
//                     🧪
//                   </div>
//                   <div style={{ flex: 1, minWidth: 0 }}>
//                     <div
//                       style={{
//                         fontWeight: 600,
//                         fontSize: 14,
//                         color: "#0a1628",
//                         marginBottom: 2,
//                       }}
//                     >
//                       {report.name}
//                     </div>
//                     <div style={{ fontSize: 11, color: "#94a3b8" }}>
//                       {report.uploadedAt
//                         ? new Date(report.uploadedAt).toLocaleDateString(
//                             "en-IN",
//                             { day: "numeric", month: "short", year: "numeric" },
//                           )
//                         : ""}
//                     </div>
//                   </div>
//                   <a
//                     href={report.url}
//                     target="_blank"
//                     rel="noreferrer"
//                     style={{
//                       padding: "7px 14px",
//                       background: "rgba(13,115,119,0.08)",
//                       color: "#0d7377",
//                       border: "1px solid rgba(13,115,119,0.2)",
//                       borderRadius: 8,
//                       fontSize: 12,
//                       fontWeight: 600,
//                       textDecoration: "none",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     🔗 View Report
//                   </a>
//                   <button
//                     onClick={() => deleteLabReport(report._id)}
//                     style={{
//                       padding: "7px 10px",
//                       background: "#fef2f2",
//                       color: "#dc2626",
//                       border: "1px solid #fca5a5",
//                       borderRadius: 8,
//                       fontSize: 12,
//                       cursor: "pointer",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                     🗑️ Delete
//                   </button>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>

//       {rxModal && (
//         <PrescriptionModal
//           visit={rxModal.visit}
//           patient={rxModal.patient}
//           doctor={rxModal.doctor}
//           onClose={() => setRxModal(null)}
//           showNotify={showNotify}
//         />
//       )}
//     </div>
//   );
// }

// // ── Medicine Database ─────────────────────────────────────────
// const MEDICINE_DB = [
//   { name: "Amoxicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Amoxicillin 875mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin 125mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin 250mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 375mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 625mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 1000mg Tablet", cat: "Antibiotic" },
//   { name: "Amoxicillin + Clavulanate 228.5mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Azithromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Azithromycin 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Clindamycin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Clindamycin 600mg Injection", cat: "Antibiotic Inj" },
//   { name: "Metronidazole 200mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 400mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Metronidazole 200mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Metronidazole 500mg Infusion", cat: "Antibiotic Inj" },
//   { name: "Ciprofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 750mg Tablet", cat: "Antibiotic" },
//   { name: "Ciprofloxacin 200mg/100ml Infusion", cat: "Antibiotic Inj" },
//   { name: "Doxycycline 100mg Capsule", cat: "Antibiotic" },
//   { name: "Doxycycline 200mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Erythromycin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Tinidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ornidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Secnidazole 500mg Tablet", cat: "Antibiotic" },
//   { name: "Co-Amoxiclav 375mg Tablet", cat: "Antibiotic" },
//   { name: "Co-Amoxiclav 625mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 250mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 500mg Tablet", cat: "Antibiotic" },
//   { name: "Levofloxacin 750mg Tablet", cat: "Antibiotic" },
//   { name: "Ofloxacin 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ofloxacin 400mg Tablet", cat: "Antibiotic" },
//   { name: "Cephalexin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Cephalexin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Cefixime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 400mg Tablet", cat: "Antibiotic" },
//   { name: "Cefixime 50mg/5ml Syrup", cat: "Antibiotic" },
//   { name: "Cefuroxime 250mg Tablet", cat: "Antibiotic" },
//   { name: "Cefuroxime 500mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 100mg Tablet", cat: "Antibiotic" },
//   { name: "Cefpodoxime 200mg Tablet", cat: "Antibiotic" },
//   { name: "Ceftriaxone 250mg Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Ceftriaxone 2g Injection", cat: "Antibiotic Inj" },
//   { name: "Amikacin 250mg Injection", cat: "Antibiotic Inj" },
//   { name: "Amikacin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Gentamicin 40mg Injection", cat: "Antibiotic Inj" },
//   { name: "Gentamicin 80mg Injection", cat: "Antibiotic Inj" },
//   { name: "Vancomycin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Vancomycin 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Meropenem 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Meropenem 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Piperacillin + Tazobactam 4.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Imipenem + Cilastatin 500mg Injection", cat: "Antibiotic Inj" },
//   { name: "Linezolid 600mg Tablet", cat: "Antibiotic" },
//   { name: "Linezolid 600mg Infusion", cat: "Antibiotic Inj" },
//   { name: "Colistin 1 MU Injection", cat: "Antibiotic Inj" },
//   { name: "Tetracycline 250mg Capsule", cat: "Antibiotic" },
//   { name: "Tetracycline 500mg Capsule", cat: "Antibiotic" },
//   { name: "Chloramphenicol 250mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin 250mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin 500mg Capsule", cat: "Antibiotic" },
//   { name: "Ampicillin + Sulbactam 1.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Nitrofurantoin 50mg Capsule", cat: "Antibiotic" },
//   { name: "Nitrofurantoin 100mg Capsule", cat: "Antibiotic" },
//   { name: "Norfloxacin 400mg Tablet", cat: "Antibiotic" },
//   { name: "Trimethoprim + Sulfamethoxazole 480mg Tablet", cat: "Antibiotic" },
//   { name: "Trimethoprim + Sulfamethoxazole 960mg Tablet", cat: "Antibiotic" },
//   { name: "Cefoperazone + Sulbactam 1.5g Injection", cat: "Antibiotic Inj" },
//   { name: "Cefoperazone + Sulbactam 3g Injection", cat: "Antibiotic Inj" },
//   { name: "Ertapenem 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Tigecycline 50mg Injection", cat: "Antibiotic Inj" },
//   { name: "Fosfomycin 3g Sachet", cat: "Antibiotic" },
//   { name: "Rifampicin 150mg Capsule", cat: "Antibiotic" },
//   { name: "Rifampicin 300mg Capsule", cat: "Antibiotic" },
//   { name: "Isoniazid 100mg Tablet", cat: "Antibiotic" },
//   { name: "Isoniazid 300mg Tablet", cat: "Antibiotic" },
//   { name: "Pyrazinamide 500mg Tablet", cat: "Antibiotic" },
//   { name: "Ethambutol 400mg Tablet", cat: "Antibiotic" },
//   { name: "Streptomycin 1g Injection", cat: "Antibiotic Inj" },
//   { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
//   { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 250mg/5ml Syrup", cat: "Painkiller" },
//   { name: "Paracetamol 150mg/ml Drops", cat: "Painkiller" },
//   { name: "Paracetamol 500mg/100ml Infusion", cat: "Painkiller Inj" },
//   { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
//   { name: "Ibuprofen 100mg/5ml Syrup", cat: "NSAID" },
//   { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Tablet", cat: "NSAID" },
//   { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
//   { name: "Diclofenac 75mg Injection", cat: "NSAID Inj" },
//   { name: "Ketorolac 10mg Tablet", cat: "NSAID" },
//   { name: "Ketorolac 30mg Injection", cat: "NSAID Inj" },
//   { name: "Naproxen 250mg Tablet", cat: "NSAID" },
//   { name: "Naproxen 500mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 250mg Tablet", cat: "NSAID" },
//   { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
//   { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
//   { name: "Piroxicam 10mg Tablet", cat: "NSAID" },
//   { name: "Piroxicam 20mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
//   { name: "Etoricoxib 120mg Tablet", cat: "NSAID" },
//   { name: "Celecoxib 100mg Capsule", cat: "NSAID" },
//   { name: "Celecoxib 200mg Capsule", cat: "NSAID" },
//   { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
//   { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
//   { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
//   { name: "Tramadol 100mg SR Tablet", cat: "Opioid Analgesic" },
//   { name: "Tramadol 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
//   { name: "Morphine 10mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Morphine 15mg Tablet", cat: "Opioid Analgesic" },
//   { name: "Fentanyl 50mcg/ml Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pentazocine 30mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Pethidine 50mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Buprenorphine 0.3mg Injection", cat: "Opioid Analgesic Inj" },
//   { name: "Tapentadol 50mg Tablet", cat: "Opioid Analgesic" },
//   { name: "Tapentadol 100mg Tablet", cat: "Opioid Analgesic" },
//   { name: "Lignocaine 2% Dental Cartridge (1.8ml)", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine + Adrenaline 2% Dental Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:100000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   {
//     name: "Articaine 4% + Adrenaline 1:200000 Cartridge",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
//   { name: "Bupivacaine 0.5% Heavy Spinal Injection", cat: "Local Anaesthetic" },
//   { name: "Mepivacaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Prilocaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
//   { name: "Lignocaine 2% Plain Injection 30ml Vial", cat: "Local Anaesthetic" },
//   {
//     name: "Lignocaine 2% + Adrenaline Injection Vial",
//     cat: "Local Anaesthetic",
//   },
//   { name: "Lignocaine 10% Topical Spray", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 2% Viscous Gel", cat: "Local Anaesthetic Topical" },
//   { name: "Lignocaine 5% Ointment", cat: "Local Anaesthetic Topical" },
//   { name: "Benzocaine 20% Topical Gel", cat: "Local Anaesthetic Topical" },
//   {
//     name: "EMLA Cream (Lignocaine + Prilocaine)",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Xylocaine Jelly 2%", cat: "Local Anaesthetic Topical" },
//   { name: "Ropivacaine 0.2% Injection", cat: "Local Anaesthetic" },
//   { name: "Ropivacaine 0.75% Injection", cat: "Local Anaesthetic" },
//   {
//     name: "Tetracaine (Amethocaine) Eye Drops",
//     cat: "Local Anaesthetic Topical",
//   },
//   { name: "Propofol 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 500mg Injection", cat: "General Anaesthesia" },
//   { name: "Ketamine 10mg/ml Injection", cat: "General Anaesthesia" },
//   { name: "Thiopentone Sodium 500mg Injection", cat: "General Anaesthesia" },
//   { name: "Midazolam 1mg/ml Injection", cat: "Sedative / Anaesthesia" },
//   { name: "Midazolam 5mg/ml Injection", cat: "Sedative / Anaesthesia" },
//   { name: "Midazolam 7.5mg Tablet", cat: "Sedative" },
//   { name: "Isoflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Sevoflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Desflurane Inhalation", cat: "Inhalation Anaesthetic" },
//   { name: "Nitrous Oxide Gas", cat: "Inhalation Anaesthetic" },
//   { name: "Oxygen Gas Cylinder", cat: "Medical Gas" },
//   { name: "Succinylcholine 100mg Injection", cat: "Muscle Relaxant" },
//   { name: "Vecuronium 4mg Injection", cat: "Muscle Relaxant" },
//   { name: "Atracurium 25mg Injection", cat: "Muscle Relaxant" },
//   { name: "Rocuronium 50mg Injection", cat: "Muscle Relaxant" },
//   { name: "Neostigmine 0.5mg Injection", cat: "Reversal Agent" },
//   { name: "Atropine 0.6mg Injection", cat: "Anticholinergic" },
//   { name: "Glycopyrrolate 0.2mg Injection", cat: "Anticholinergic" },
//   { name: "Dexamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Tablet", cat: "Steroid" },
//   { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
//   { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
//   { name: "Betamethasone 0.5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
//   { name: "Prednisolone 40mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 16mg Tablet", cat: "Steroid" },
//   { name: "Methylprednisolone 40mg Injection", cat: "Steroid Inj" },
//   { name: "Methylprednisolone 125mg Injection", cat: "Steroid Inj" },
//   { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone 10mg Injection", cat: "Steroid Inj" },
//   { name: "Triamcinolone Acetonide 0.1% Oral Paste", cat: "Steroid Topical" },
//   { name: "Kenacort 0.1% Dental Paste", cat: "Steroid Topical" },
//   { name: "Betamethasone Gel Oral 0.025%", cat: "Steroid Topical" },
//   { name: "Fluconazole 50mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 150mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 200mg Capsule", cat: "Antifungal" },
//   { name: "Fluconazole 2mg/ml Infusion", cat: "Antifungal Inj" },
//   { name: "Itraconazole 100mg Capsule", cat: "Antifungal" },
//   { name: "Voriconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Amphotericin B 50mg Injection", cat: "Antifungal Inj" },
//   { name: "Clotrimazole 1% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin 100000 IU/ml Oral Drops", cat: "Antifungal" },
//   { name: "Nystatin 500000 IU Tablet", cat: "Antifungal" },
//   { name: "Clotrimazole + Betamethasone Cream", cat: "Antifungal Topical" },
//   { name: "Ketoconazole 200mg Tablet", cat: "Antifungal" },
//   { name: "Ketoconazole 2% Shampoo", cat: "Antifungal Topical" },
//   { name: "Terbinafine 250mg Tablet", cat: "Antifungal" },
//   { name: "Acyclovir 200mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 400mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 800mg Tablet", cat: "Antiviral" },
//   { name: "Acyclovir 5% Cream", cat: "Antiviral Topical" },
//   { name: "Acyclovir 250mg Injection", cat: "Antiviral Inj" },
//   { name: "Valacyclovir 500mg Tablet", cat: "Antiviral" },
//   { name: "Valacyclovir 1000mg Tablet", cat: "Antiviral" },
//   { name: "Famciclovir 250mg Tablet", cat: "Antiviral" },
//   { name: "Oseltamivir 75mg Capsule", cat: "Antiviral" },
//   { name: "Chlorhexidine Gluconate 0.2% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine Gluconate 0.12% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Chlorhexidine 1% Gel (Gum Gel)", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 5% Mouthwash / Gargle", cat: "Dental Antiseptic" },
//   { name: "Povidone Iodine 10% Solution", cat: "Antiseptic" },
//   { name: "Povidone Iodine 5% Ointment", cat: "Antiseptic Topical" },
//   { name: "Hydrogen Peroxide 3% Solution", cat: "Dental Antiseptic" },
//   { name: "Hydrogen Peroxide 1.5% Mouthwash", cat: "Dental Antiseptic" },
//   {
//     name: "Benzydamine Hydrochloride 0.15% Mouthwash",
//     cat: "Dental Analgesic Rinse",
//   },
//   { name: "Hexetidine 0.1% Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Sodium Fluoride 0.05% Mouthwash", cat: "Fluoride Rinse" },
//   { name: "Sodium Fluoride Varnish 5%", cat: "Fluoride Varnish" },
//   { name: "Fluoride Gel APF 1.23%", cat: "Fluoride Gel" },
//   { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
//   { name: "Aloe Vera Gel Oral", cat: "Oral Care" },
//   { name: "Hyaluronic Acid Gel 0.2% Oral", cat: "Oral Care" },
//   { name: "Triclosan Toothpaste", cat: "Dental Brand" },
//   { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
//   { name: "Colgate Total Toothpaste", cat: "Dental Brand" },
//   { name: "Pepsodent Toothpaste", cat: "Dental Brand" },
//   { name: "Emoform Toothpaste", cat: "Dental Brand" },
//   { name: "Thermoseal Toothpaste", cat: "Dental Brand" },
//   { name: "Himalaya HiOra Toothpaste", cat: "Dental Brand" },
//   { name: "Dabur Red Toothpaste", cat: "Dental Brand" },
//   { name: "Meswak Toothpaste", cat: "Dental Brand" },
//   { name: "Oral-B Electric Toothbrush Head", cat: "Dental Accessory" },
//   { name: "Interdental Brush", cat: "Dental Accessory" },
//   { name: "Dental Floss", cat: "Dental Accessory" },
//   { name: "Tongue Cleaner", cat: "Dental Accessory" },
//   { name: "Water Flosser / Oral Irrigator", cat: "Dental Accessory" },
//   { name: "GIC Cement (Glass Ionomer Cement)", cat: "Dental Material" },
//   { name: "GIC Type II Restorative", cat: "Dental Material" },
//   { name: "RMGIC (Resin Modified GIC)", cat: "Dental Material" },
//   { name: "Composite Resin A1 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A2 Shade", cat: "Dental Material" },
//   { name: "Composite Resin A3 Shade", cat: "Dental Material" },
//   { name: "Composite Resin B1 Shade", cat: "Dental Material" },
//   { name: "Flowable Composite", cat: "Dental Material" },
//   { name: "Bulk Fill Composite", cat: "Dental Material" },
//   { name: "IRM (Intermediate Restorative Material)", cat: "Dental Material" },
//   { name: "Zinc Oxide Eugenol Cement", cat: "Dental Material" },
//   { name: "Zinc Phosphate Cement", cat: "Dental Material" },
//   { name: "Zinc Polycarboxylate Cement", cat: "Dental Material" },
//   { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
//   { name: "Calcium Hydroxide Paste", cat: "Dental Material" },
//   { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
//   { name: "Dycal (Calcium Hydroxide Base)", cat: "Dental Material" },
//   { name: "Cavity Liner (Varnish)", cat: "Dental Material" },
//   { name: "Etchant 37% Phosphoric Acid Gel", cat: "Dental Material" },
//   { name: "Bonding Agent (5th Gen)", cat: "Dental Material" },
//   { name: "Bonding Agent (7th Gen Self-Etch)", cat: "Dental Material" },
//   { name: "Dental Amalgam Capsule", cat: "Dental Material" },
//   { name: "Impression Material Alginate", cat: "Dental Material" },
//   {
//     name: "Impression Material Polyvinyl Siloxane (PVS)",
//     cat: "Dental Material",
//   },
//   { name: "Impression Material Polyether", cat: "Dental Material" },
//   { name: "Zinc Oxide Impression Paste", cat: "Dental Material" },
//   { name: "Plaster of Paris (Type II)", cat: "Dental Material" },
//   { name: "Dental Stone (Type III)", cat: "Dental Material" },
//   { name: "Dental Stone (Type IV)", cat: "Dental Material" },
//   { name: "Acrylic Resin Heat Cure", cat: "Dental Material" },
//   { name: "Acrylic Resin Cold Cure / Self Cure", cat: "Dental Material" },
//   { name: "Denture Base Resin", cat: "Dental Material" },
//   { name: "Denture Reliner", cat: "Dental Material" },
//   { name: "Denture Adhesive Cream", cat: "Dental Material" },
//   { name: "Dental Wax (Sheet Wax)", cat: "Dental Material" },
//   { name: "Boxing Wax", cat: "Dental Material" },
//   { name: "Inlay Wax", cat: "Dental Material" },
//   { name: "Sticky Wax", cat: "Dental Material" },
//   { name: "Orthodontic Wire NiTi 0.012", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire NiTi 0.014", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire NiTi 0.016", cat: "Dental Ortho" },
//   { name: "Orthodontic Wire SS 0.019x0.025", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Metal)", cat: "Dental Ortho" },
//   { name: "Orthodontic Brackets (Ceramic)", cat: "Dental Ortho" },
//   { name: "Orthodontic Elastic Bands", cat: "Dental Ortho" },
//   { name: "Orthodontic Separator Elastics", cat: "Dental Ortho" },
//   { name: "Orthodontic Molar Band", cat: "Dental Ortho" },
//   { name: "Orthodontic Retainer Wire", cat: "Dental Ortho" },
//   { name: "Invisalign Clear Aligner Tray", cat: "Dental Ortho" },
//   { name: "Dental Implant Fixture (Titanium)", cat: "Dental Implant" },
//   { name: "Dental Implant Abutment", cat: "Dental Implant" },
//   { name: "Healing Cap / Cover Screw", cat: "Dental Implant" },
//   { name: "Bone Graft Material (Synthetic HA)", cat: "Dental Implant" },
//   { name: "Bone Graft Material (Xenograft)", cat: "Dental Implant" },
//   { name: "Collagen Membrane (Resorbable)", cat: "Dental Implant" },
//   { name: "Titanium Mesh", cat: "Dental Implant" },
//   { name: "PRP (Platelet Rich Plasma) Kit", cat: "Dental Surgical" },
//   { name: "PRF (Platelet Rich Fibrin) Kit", cat: "Dental Surgical" },
//   { name: "Hemostatic Agent (Gelatin Sponge)", cat: "Dental Surgical" },
//   { name: "Surgicel (Oxidised Cellulose)", cat: "Haemostatic" },
//   { name: "Alvogyl (Dry Socket Dressing)", cat: "Dental Surgical" },
//   { name: "Whitehead Varnish (Iodoform Paste)", cat: "Dental Surgical" },
//   { name: "Ledermix Paste", cat: "Dental Material" },
//   { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Sealapex)", cat: "Endodontic" },
//   { name: "Root Canal Sealer (Zinc Oxide Eugenol)", cat: "Endodontic" },
//   { name: "Gutta Percha Points (ISO 20-80)", cat: "Endodontic" },
//   { name: "Paper Points (Absorbent Points)", cat: "Endodontic" },
//   { name: "EDTA Liquid 17% (Root Canal)", cat: "Endodontic" },
//   { name: "EDTA Gel 17% (Root Canal)", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 2.5% Solution", cat: "Endodontic" },
//   { name: "Sodium Hypochlorite 5.25% Solution", cat: "Endodontic" },
//   { name: "Chlorhexidine 2% Irrigant", cat: "Endodontic" },
//   { name: "RC Prep (Root Canal Lubricant)", cat: "Endodontic" },
//   { name: "K-Files (Root Canal Files) ISO 6-80", cat: "Endodontic Instrument" },
//   { name: "H-Files (Hedstrom Files) ISO 15-60", cat: "Endodontic Instrument" },
//   { name: "Rotary NiTi Files (ProTaper)", cat: "Endodontic Instrument" },
//   { name: "Rotary NiTi Files (WaveOne Gold)", cat: "Endodontic Instrument" },
//   { name: "Rubber Dam Sheet", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Clamp", cat: "Endodontic Accessory" },
//   { name: "Rubber Dam Frame", cat: "Endodontic Accessory" },
//   { name: "Pulp Capping Agent (Vitrebond)", cat: "Endodontic" },
//   { name: "Formocresol Solution", cat: "Endodontic Paediatric" },
//   { name: "Buckley's Formocresol", cat: "Endodontic Paediatric" },
//   {
//     name: "Zinc Oxide + Iodoform Paste (Kri Paste)",
//     cat: "Endodontic Paediatric",
//   },
//   { name: "Stainless Steel Crown (Paediatric)", cat: "Paediatric Dental" },
//   { name: "Fluoride Varnish Duraphat 22600 ppm", cat: "Fluoride Varnish" },
//   { name: "Dental Needle 27G Short (21mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 27G Long (38mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 30G Short (21mm)", cat: "Dental Needle" },
//   { name: "Dental Needle 25G Long (38mm)", cat: "Dental Needle" },
//   {
//     name: "Aspirating Dental Syringe (Breech Loading)",
//     cat: "Dental Instrument",
//   },
//   { name: "Disposable Syringe 1ml (Insulin)", cat: "Syringe" },
//   { name: "Disposable Syringe 2ml", cat: "Syringe" },
//   { name: "Disposable Syringe 5ml", cat: "Syringe" },
//   { name: "Disposable Syringe 10ml", cat: "Syringe" },
//   { name: "Disposable Syringe 20ml", cat: "Syringe" },
//   { name: "Disposable Syringe 50ml (Piston)", cat: "Syringe" },
//   { name: "Normal Saline 0.9% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Normal Saline 0.9% 1000ml Infusion", cat: "IV Fluid" },
//   { name: "Ringer's Lactate 500ml Infusion", cat: "IV Fluid" },
//   { name: "Ringer's Lactate 1000ml Infusion", cat: "IV Fluid" },
//   { name: "Dextrose 5% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 100ml Infusion", cat: "IV Fluid" },
//   { name: "Mannitol 20% 500ml Infusion", cat: "IV Fluid" },
//   { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
//   { name: "Ondansetron 2mg/ml Injection", cat: "Antiemetic Inj" },
//   { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
//   { name: "Metoclopramide 10mg Injection", cat: "Antiemetic Inj" },
//   { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
//   { name: "Pantoprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Pantoprazole 40mg Injection", cat: "Antacid Inj" },
//   { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 40mg Tablet", cat: "Antacid / PPI" },
//   { name: "Ranitidine 150mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Sucralfate Suspension 1g/10ml", cat: "Antacid" },
//   { name: "Cetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Cetirizine 5mg/5ml Syrup", cat: "Antihistamine" },
//   { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
//   { name: "Fexofenadine 180mg Tablet", cat: "Antihistamine" },
//   { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
//   { name: "Chlorpheniramine 4mg Tablet", cat: "Antihistamine" },
//   { name: "Adrenaline (Epinephrine) 1mg/ml Injection", cat: "Emergency Drug" },
//   { name: "Hydrocortisone 100mg Injection (Allergy)", cat: "Emergency Drug" },
//   { name: "Epinephrine Auto-Injector (EpiPen)", cat: "Emergency Drug" },
//   { name: "Amlodipine 5mg Tablet", cat: "Antihypertensive" },
//   { name: "Atenolol 50mg Tablet", cat: "Beta Blocker" },
//   { name: "Metoprolol 50mg Tablet", cat: "Beta Blocker" },
//   { name: "Losartan 50mg Tablet", cat: "Antihypertensive" },
//   { name: "Telmisartan 40mg Tablet", cat: "Antihypertensive" },
//   { name: "Telmisartan 80mg Tablet", cat: "Antihypertensive" },
//   { name: "Ramipril 5mg Tablet", cat: "ACE Inhibitor" },
//   { name: "Furosemide 40mg Tablet", cat: "Diuretic" },
//   { name: "Aspirin 75mg Tablet", cat: "Antiplatelet" },
//   { name: "Clopidogrel 75mg Tablet", cat: "Antiplatelet" },
//   { name: "Atorvastatin 20mg Tablet", cat: "Statin" },
//   { name: "Atorvastatin 40mg Tablet", cat: "Statin" },
//   { name: "Metformin 500mg Tablet", cat: "Antidiabetic" },
//   { name: "Metformin 850mg Tablet", cat: "Antidiabetic" },
//   { name: "Glimepiride 2mg Tablet", cat: "Antidiabetic" },
//   { name: "Insulin Regular (Soluble) 100 IU/ml", cat: "Insulin" },
//   { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin C 1000mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule (Weekly)", cat: "Vitamin" },
//   { name: "Vitamin D3 1000 IU Tablet (Daily)", cat: "Vitamin" },
//   { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
//   { name: "Vitamin B12 500mcg Tablet", cat: "Vitamin" },
//   { name: "Folic Acid 5mg Tablet", cat: "Vitamin" },
//   { name: "Iron (Ferrous Sulphate) 200mg Tablet", cat: "Iron Supplement" },
//   { name: "Iron + Folic Acid Tablet", cat: "Iron Supplement" },
//   { name: "Calcium Carbonate 500mg Tablet", cat: "Calcium Supplement" },
//   { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
//   { name: "Zinc Sulphate 50mg Tablet", cat: "Micronutrient" },
//   { name: "Multivitamin Tablet (Adult)", cat: "Multivitamin" },
//   { name: "Tranexamic Acid 500mg Tablet", cat: "Haemostatic" },
//   { name: "Tranexamic Acid 250mg/5ml Injection", cat: "Haemostatic Inj" },
//   { name: "Etamsylate 250mg Tablet", cat: "Haemostatic" },
//   { name: "Gelatin Sponge (Absorbable Haemostat)", cat: "Haemostatic" },
//   { name: "Bone Wax", cat: "Haemostatic Surgical" },
//   { name: "Vicryl (Polyglactin 910) 3-0 Suture", cat: "Suture" },
//   { name: "Vicryl (Polyglactin 910) 4-0 Suture", cat: "Suture" },
//   { name: "Vicryl Rapid 4-0 Suture", cat: "Suture" },
//   { name: "Chromic Catgut 2-0 Suture", cat: "Suture" },
//   { name: "Chromic Catgut 3-0 Suture", cat: "Suture" },
//   { name: "Plain Catgut 2-0 Suture", cat: "Suture" },
//   { name: "Silk Suture 3-0 Black Braided", cat: "Suture" },
//   { name: "Silk Suture 4-0 Black Braided", cat: "Suture" },
//   { name: "Nylon Suture 3-0 (Ethilon)", cat: "Suture" },
//   { name: "Nylon Suture 4-0 (Ethilon)", cat: "Suture" },
//   { name: "Gauze Swab 4x4 inch (Sterile)", cat: "Dressing" },
//   { name: "Cotton Roll (Non-Sterile)", cat: "Dental Material" },
//   { name: "Cotton Roll (Dental Grade)", cat: "Consumable" },
//   { name: "Cotton Pellet Small", cat: "Consumable" },
//   { name: "Ribbon Gauze 1/2 inch (Dental Packing)", cat: "Dental Consumable" },
//   { name: "Dry Foil (Dental)", cat: "Dental Consumable" },
//   { name: "Tetanus Toxoid 0.5ml Injection", cat: "Vaccine" },
//   { name: "Influenza Vaccine (Flu Shot)", cat: "Vaccine" },
//   { name: "MMR Vaccine", cat: "Vaccine" },
//   { name: "Anti-Tetanus Serum (ATS)", cat: "Antiserum" },
//   { name: "OPG (Orthopantomogram) X-ray", cat: "Dental Investigation" },
//   { name: "IOPA X-ray (Intraoral Periapical)", cat: "Dental Investigation" },
//   { name: "Bitewing X-ray", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Cone Beam CT)", cat: "Dental Investigation" },
//   { name: "Lateral Cephalogram X-ray", cat: "Dental Investigation" },
//   { name: "Complete Blood Count (CBC)", cat: "Lab Test" },
//   { name: "Blood Sugar Fasting (BSF)", cat: "Lab Test" },
//   { name: "Random Blood Sugar (RBS)", cat: "Lab Test" },
//   { name: "HbA1c Test", cat: "Lab Test" },
//   { name: "Liver Function Test (LFT)", cat: "Lab Test" },
//   { name: "Kidney Function Test (KFT) / RFT", cat: "Lab Test" },
//   { name: "Lipid Profile Test", cat: "Lab Test" },
//   { name: "Blood Group and Rh Typing", cat: "Lab Test" },
//   { name: "PT / INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "APTT Test", cat: "Lab Test" },
//   { name: "Bleeding Time (BT)", cat: "Lab Test" },
//   { name: "Clotting Time (CT)", cat: "Lab Test" },
//   { name: "HBsAg Test (Hepatitis B Surface Antigen)", cat: "Lab Test" },
//   { name: "HIV Test (ELISA)", cat: "Lab Test" },
//   { name: "Adrenaline 1:1000 (1mg/ml) Injection", cat: "Emergency Drug" },
//   { name: "Atropine 0.6mg Injection", cat: "Emergency Drug" },
//   { name: "Sodium Bicarbonate 8.4% Injection", cat: "Emergency Drug" },
//   { name: "Dextrose 50% Injection (Hypoglycaemia)", cat: "Emergency Drug" },
//   { name: "Naloxone 0.4mg Injection (Opioid Reversal)", cat: "Emergency Drug" },
//   {
//     name: "Augmentin 625mg Tablet (Amoxicillin+Clavulanate)",
//     cat: "Antibiotic",
//   },
//   { name: "Azithral 500mg Tablet (Azithromycin)", cat: "Antibiotic" },
//   { name: "Cifran 500mg Tablet (Ciprofloxacin)", cat: "Antibiotic" },
//   { name: "Flagyl 400mg Tablet (Metronidazole)", cat: "Antibiotic" },
//   { name: "Doxy 100mg Capsule (Doxycycline)", cat: "Antibiotic" },
//   { name: "Calpol 650mg Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Dolo 650 Tablet (Paracetamol)", cat: "Painkiller" },
//   { name: "Combiflam Tablet (Ibuprofen+Paracetamol)", cat: "NSAID Combo" },
//   { name: "Voveran 50mg Tablet (Diclofenac)", cat: "NSAID" },
//   { name: "Brufen 400mg Tablet (Ibuprofen)", cat: "NSAID" },
//   { name: "Ultracet Tablet (Tramadol+Paracetamol)", cat: "Analgesic Combo" },
//   { name: "Pan 40mg Tablet (Pantoprazole)", cat: "Antacid / PPI" },
//   { name: "Omez 20mg Capsule (Omeprazole)", cat: "Antacid / PPI" },
//   { name: "Ondem 4mg Tablet (Ondansetron)", cat: "Antiemetic" },
//   { name: "Allegra 120mg Tablet (Fexofenadine)", cat: "Antihistamine" },
//   {
//     name: "Montair-LC Tablet (Montelukast+Levocetirizine)",
//     cat: "Antihistamine",
//   },
//   { name: "Rantac 150mg Tablet (Ranitidine)", cat: "Antacid / H2 Blocker" },
//   { name: "Kenacort Oral Paste (Triamcinolone)", cat: "Steroid Topical" },
//   { name: "Kenalog Injection 40mg (Triamcinolone)", cat: "Steroid Inj" },
//   { name: "Depo-Medrol 40mg Injection", cat: "Steroid Inj" },
//   { name: "Betnesol 0.5mg Tablet (Betamethasone)", cat: "Steroid" },
//   { name: "Wysolone 5mg Tablet (Prednisolone)", cat: "Steroid" },
//   { name: "Defcort 6mg Tablet (Deflazacort)", cat: "Steroid" },
//   { name: "Dexona 0.5mg Tablet (Dexamethasone)", cat: "Steroid" },
//   { name: "Mox 500mg Capsule (Amoxicillin)", cat: "Antibiotic" },
//   { name: "Sporanox 100mg Capsule (Itraconazole)", cat: "Antifungal" },
//   { name: "Zovirax 400mg Tablet (Acyclovir)", cat: "Antiviral" },
//   { name: "Valcivir 500mg Tablet (Valacyclovir)", cat: "Antiviral" },
//   { name: "Betadine Ointment 5%", cat: "Antiseptic Topical" },
//   { name: "Borax Glycerine (Oral Ulcer)", cat: "Oral Care" },
//   { name: "Tantum Verde Mouthwash (Benzydamine)", cat: "Oral Care" },
//   { name: "Hexidine Mouthwash", cat: "Dental Antiseptic" },
//   { name: "Recaldent (CPP-ACP Paste)", cat: "Dental Fluoride" },
//   { name: "Tooth Mousse Plus (GC)", cat: "Dental Fluoride" },
//   { name: "Sensodyne Repair & Protect", cat: "Dental Brand" },
//   { name: "Colgate Sensitive Pro-Relief", cat: "Dental Brand" },
//   { name: "Mouth Guard (Bruxism)", cat: "Dental Brand" },
//   {
//     name: "Triamcinolone Acetonide 0.1% Oral Paste (Kenacort)",
//     cat: "Steroid Topical",
//   },
//   { name: "Clotrimazole 1% Cream", cat: "Antifungal Topical" },
//   { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
//   { name: "Nystatin Oral Suspension", cat: "Antifungal" },
//   { name: "Mupirocin 2% Ointment (Bactroban)", cat: "Topical Antibiotic" },
//   { name: "Lignocaine Viscous 2% Mouthwash", cat: "Local Anaesthetic Topical" },
//   { name: "Amlexanox 5% Paste (Aphthous Ulcer)", cat: "Oral Care" },
//   { name: "Benzydamine 0.15% Mouthwash (Tantum Verde)", cat: "Oral Care" },
//   { name: "Ulcerex Gel (Choline Salicylate)", cat: "Oral Care" },
//   { name: "Dologel CT (Clove Oil Gel)", cat: "Oral Care" },
//   { name: "Clove Oil (Eugenol)", cat: "Dental Material" },
//   { name: "Titanium Implant Fixture (3.3mm)", cat: "Dental Implant" },
//   { name: "Titanium Implant Fixture (4.0mm)", cat: "Dental Implant" },
//   { name: "Implant Cover Screw", cat: "Dental Implant" },
//   { name: "Implant Healing Abutment", cat: "Dental Implant" },
//   { name: "Bone Graft (Xenograft - Bio-Oss)", cat: "Dental Surgical" },
//   { name: "Collagen Membrane (Bio-Gide)", cat: "Dental Surgical" },
//   { name: "Haemostatic Foam (Gelfoam)", cat: "Haemostatic" },
//   { name: "Surgical Suction Tip (Frazier)", cat: "Dental Instrument" },
//   { name: "CBC (Complete Blood Count)", cat: "Lab Test" },
//   { name: "RBS (Random Blood Sugar)", cat: "Lab Test" },
//   { name: "HbA1c (Glycated Haemoglobin)", cat: "Lab Test" },
//   { name: "Blood Group & Rh Typing", cat: "Lab Test" },
//   { name: "BT (Bleeding Time) & CT (Clotting Time)", cat: "Lab Test" },
//   { name: "PT/INR (Prothrombin Time)", cat: "Lab Test" },
//   { name: "LFT (Liver Function Test)", cat: "Lab Test" },
//   { name: "KFT (Kidney Function Test)", cat: "Lab Test" },
//   { name: "Dental Radiograph (IOPA X-ray)", cat: "Dental Investigation" },
//   { name: "Orthopantomogram (OPG) X-ray", cat: "Dental Investigation" },
//   { name: "CBCT Scan (Dental 3D)", cat: "Dental Investigation" },
//   { name: "Aceclofenac + Paracetamol + Serratiopeptidase", cat: "NSAID Combo" },
//   { name: "Serratiopeptidase 10mg Tablet", cat: "Enzyme Combination" },
//   { name: "Serratiopeptidase 20mg Tablet", cat: "Enzyme Combination" },
//   { name: "Deflazacort 6mg Tablet", cat: "Steroid" },
//   { name: "Deflazacort 12mg Tablet", cat: "Steroid" },
//   { name: "Deflazacort 30mg Tablet", cat: "Steroid" },
//   { name: "Omeprazole 10mg Capsule", cat: "Antacid / PPI" },
//   { name: "Omeprazole 40mg Capsule", cat: "Antacid / PPI" },
//   { name: "Rabeprazole 10mg Tablet", cat: "Antacid / PPI" },
//   { name: "Esomeprazole 20mg Tablet", cat: "Antacid / PPI" },
//   { name: "Ranitidine 300mg Tablet", cat: "Antacid / H2 Blocker" },
//   { name: "Ondansetron 4mg/5ml Syrup", cat: "Antiemetic" },
//   { name: "Domperidone 1mg/ml Suspension", cat: "Antiemetic" },
//   { name: "Levocetirizine 2.5mg Tablet", cat: "Antihistamine" },
//   { name: "Vitamin C 1000mg Tablet", cat: "Vitamin" },
//   { name: "Vitamin B Complex + Zinc Capsule", cat: "Vitamin" },
//   { name: "Vitamin D3 60000 IU Capsule", cat: "Vitamin" },
//   { name: "Vitamin E 400mg Capsule", cat: "Vitamin" },
//   { name: "Zinc Sulphate 20mg Tablet", cat: "Mineral Supplement" },
//   { name: "Ferrous Sulphate 200mg Tablet", cat: "Iron Supplement" },
//   { name: "Ferrous Ascorbate + Folic Acid Tablet", cat: "Iron Supplement" },
// ];

// function saveCustomMed(name) {
//   if (!name || name.trim().length < 3) return Promise.resolve(null);
//   if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
//   const nameLow = name.trim().toLowerCase();
//   const already = MEDICINE_DB.some(
//     (m) => m && m.name && m.name.toLowerCase() === nameLow,
//   );
//   if (already) return Promise.resolve(null);
//   // ✅ Call api.post directly — NOT via prop — so auth token is always included
//   return api
//     .post("/custommeds", { name: name.trim(), cat: "Custom" })
//     .then((saved) => saved || null)
//     .catch(() => null);
// }

// function googleSearch(query, customMeds = []) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   if (!words.length) return [];
//   const safeMeds = Array.isArray(customMeds)
//     ? customMeds.filter(
//         (m) => m && typeof m.name === "string" && m.name.trim().length > 0,
//       )
//     : [];
//   const combined = [
//     ...MEDICINE_DB.filter(Boolean),
//     ...safeMeds.map((m) => ({ ...m, _custom: true })),
//   ];
//   const scored = combined
//     .map((m) => {
//       if (!m || typeof m.name !== "string") return { m, score: 0 };
//       const nameLow = m.name.toLowerCase();
//       const catLow = (m.cat || "").toLowerCase();
//       let score = 0;
//       for (const w of words) {
//         if (nameLow.startsWith(w)) score += 5;
//         else if (nameLow.includes(w)) score += 3;
//         else if (catLow.includes(w)) score += 1;
//       }
//       if (m._custom) score += 2;
//       return { m, score };
//     })
//     .filter((x) => x.score > 0)
//     .sort((a, b) => b.score - a.score)
//     .map((x) => x.m);
//   return scored.slice(0, 12);
// }

// function highlightWords(text, query) {
//   const words = query
//     .toLowerCase()
//     .trim()
//     .split(/\s+/)
//     .filter((w) => w.length > 0);
//   let result = text;
//   words.forEach((w) => {
//     const re = new RegExp(
//       "(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
//       "gi",
//     );
//     result = result.replace(re, "<b>$1</b>");
//   });
//   return result;
// }

// // ── RxMedInput — original unchanged ─────────────────────────
// function RxMedInput({ value, onChange, customMeds = [], onCustomSaved }) {
//   const inpRef = React.useRef(null);
//   const wrapRef = React.useRef(null);
//   const [sugs, setSugs] = React.useState([]);
//   const [activeIdx, setActive] = React.useState(-1);
//   const [query, setQuery] = React.useState("");
//   const [dropPos, setDropPos] = React.useState({ top: 0, left: 0, width: 0 });

//   const hide = () => {
//     setSugs([]);
//     setActive(-1);
//     setQuery("");
//   };

//   const handleChange = (e) => {
//     const v = e.target.value;
//     onChange(v);
//     if (v.trim().length < 2) {
//       hide();
//       return;
//     }
//     const matches = googleSearch(v, customMeds);
//     if (!matches.length) {
//       hide();
//       return;
//     }
//     setQuery(v);
//     setSugs(matches);
//     setActive(-1);
//     requestAnimationFrame(() => {
//       if (!inpRef.current) return;
//       const r = inpRef.current.getBoundingClientRect();
//       const spaceBelow = window.innerHeight - r.bottom;
//       const dropH = Math.min(220, matches.length * 36);
//       const top =
//         spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//       setDropPos({ top, left: r.left, width: r.width });
//     });
//   };

//   const handleKeyDown = (e) => {
//     if (!sugs.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActive((i) => Math.min(i + 1, sugs.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActive((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       sugs[activeIdx]
//     ) {
//       e.preventDefault();
//       select(sugs[activeIdx].name);
//     } else if (e.key === "Escape") hide();
//   };

//   const select = (name) => {
//     onChange(name);
//     hide();
//     saveCustomMed(name).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (inpRef.current) inpRef.current.focus();
//     }, 0);
//   };

//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapRef.current && !wrapRef.current.contains(e.target)) hide();
//     };
//     document.addEventListener("mousedown", handler);
//     const scrollHandler = () => {
//       if (sugs.length > 0 && inpRef.current) {
//         const r = inpRef.current.getBoundingClientRect();
//         const spaceBelow = window.innerHeight - r.bottom;
//         const dropH = Math.min(220, sugs.length * 36);
//         const top =
//           spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
//         setDropPos({ top, left: r.left, width: r.width });
//       }
//     };
//     window.addEventListener("scroll", scrollHandler, true);
//     return () => {
//       document.removeEventListener("mousedown", handler);
//       window.removeEventListener("scroll", scrollHandler, true);
//     };
//   }, [sugs.length]);

//   return (
//     <div ref={wrapRef} style={{ position: "relative" }}>
//       <input
//         ref={inpRef}
//         type="text"
//         value={value}
//         onChange={handleChange}
//         onKeyDown={handleKeyDown}
//         placeholder="Type medicine name..."
//         autoComplete="off"
//         style={{
//           width: "100%",
//           border: "1px solid #ddd",
//           borderRadius: 5,
//           padding: "5px 8px",
//           fontSize: 12,
//           fontFamily: "'DM Sans',sans-serif",
//         }}
//       />
//       {sugs.length > 0 &&
//         ReactDOM.createPortal(
//           <div
//             style={{
//               position: "fixed",
//               top: dropPos.top,
//               left: dropPos.left,
//               width: Math.max(dropPos.width, 280),
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderRadius: 8,
//               boxShadow: "0 8px 32px rgba(13,115,119,0.28)",
//               zIndex: 999999,
//               maxHeight: 220,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {sugs.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 style={{
//                   padding: "7px 12px",
//                   cursor: "pointer",
//                   fontSize: 12,
//                   background: i === activeIdx ? "#e8f7f7" : "#fff",
//                   borderBottom: "1px solid #f0eeeb",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 8,
//                 }}
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   select(m.name);
//                 }}
//                 onMouseEnter={() => setActive(i)}
//               >
//                 <span style={{ fontSize: 13, opacity: 0.6, flexShrink: 0 }}>
//                   💊
//                 </span>
//                 <span
//                   style={{ flex: 1, fontWeight: 500 }}
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, query),
//                   }}
//                 />
//                 <span
//                   style={{
//                     fontSize: 10,
//                     color: "#9a9590",
//                     background: "#f0eeeb",
//                     padding: "1px 6px",
//                     borderRadius: 20,
//                     flexShrink: 0,
//                   }}
//                 >
//                   {m.cat}
//                 </span>
//               </div>
//             ))}
//           </div>,
//           document.body,
//         )}
//     </div>
//   );
// }

// // ── MedAutocomplete — original unchanged ─────────────────────
// function MedAutocomplete({ value, onChange, customMeds = [], onCustomSaved }) {
//   const taRef = React.useRef(null);
//   const wrapperRef = React.useRef(null);
//   const [suggestions, setSuggestions] = React.useState([]);
//   const [activeIdx, setActiveIdx] = React.useState(-1);
//   const [currentQuery, setCurrentQuery] = React.useState("");
//   const queryStartRef = React.useRef(0);
//   const queryEndRef = React.useRef(0);

//   const hideSuggestions = () => {
//     setSuggestions([]);
//     setActiveIdx(-1);
//     setCurrentQuery("");
//   };

//   const handleChange = (e) => {
//     const ta = e.target;
//     const val = ta.value;
//     const cursor = ta.selectionStart;
//     onChange(val);
//     let lineStart = cursor - 1;
//     while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
//     lineStart++;
//     const query = val.substring(lineStart, cursor);
//     queryStartRef.current = lineStart;
//     queryEndRef.current = cursor;
//     if (query.trim().length < 2) {
//       hideSuggestions();
//       return;
//     }
//     const matches = googleSearch(query, customMeds);
//     if (!matches.length) {
//       hideSuggestions();
//       return;
//     }
//     setCurrentQuery(query);
//     setSuggestions(matches);
//     setActiveIdx(-1);
//   };

//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       suggestions[activeIdx]
//     ) {
//       e.preventDefault();
//       selectMed(suggestions[activeIdx].name);
//     } else if (e.key === "Escape") hideSuggestions();
//   };

//   const selectMed = (name) => {
//     const ta = taRef.current;
//     const val = ta.value;
//     const before = val.substring(0, queryStartRef.current);
//     const after = val.substring(queryEndRef.current);
//     onChange(before + name + after);
//     hideSuggestions();
//     saveCustomMed(name).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (taRef.current) {
//         const nc = queryStartRef.current + name.length;
//         taRef.current.setSelectionRange(nc, nc);
//         taRef.current.focus();
//         queryEndRef.current = nc;
//       }
//     }, 0);
//   };

//   const handleBlur = () => {
//     if (!taRef.current) return;
//     const val = taRef.current.value;
//     val.split("\n").forEach((line) => {
//       const trimmed = line.trim();
//       if (
//         trimmed.length >= 3 &&
//         /[a-zA-Z]/.test(trimmed) &&
//         !/^[0-9\s]+$/.test(trimmed)
//       ) {
//         saveCustomMed(trimmed).then((saved) => {
//           if (saved && onCustomSaved) onCustomSaved(saved);
//         });
//       }
//     });
//   };

//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target))
//         hideSuggestions();
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   return (
//     <>
//       <style>{`
//         .med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}
//         .med-suggestion-item:last-child{border-bottom:none;}
//         .med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}
//         .med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}
//         .med-sug-name{font-weight:500;flex:1;color:#1a1614;}
//         .med-sug-name b{color:#0d7377;font-weight:700;}
//         .med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}
//       `}</style>
//       <div style={{ position: "relative" }} ref={wrapperRef}>
//         <textarea
//           ref={taRef}
//           value={value}
//           onChange={handleChange}
//           onKeyDown={handleKeyDown}
//           onBlur={handleBlur}
//           autoComplete="off"
//           placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
//         />
//         {suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderTop: "none",
//               borderRadius: "0 0 12px 12px",
//               boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
//               zIndex: 99999,
//               maxHeight: 280,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {suggestions.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 className={
//                   "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
//                 }
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   selectMed(m.name);
//                 }}
//               >
//                 <span className="med-sug-icon">💊</span>
//                 <span
//                   className="med-sug-name"
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, currentQuery),
//                   }}
//                 />
//                 <span className="med-sug-cat">{m.cat}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── ✅ NEW: MedAutocompleteWithMic — Doctor Notes + 🎤 Microphone ──
// function MedAutocompleteWithMic({
//   value,
//   onChange,
//   customMeds = [],
//   onCustomSaved,
// }) {
//   const taRef = React.useRef(null);
//   const wrapperRef = React.useRef(null);
//   const recognitionRef = React.useRef(null);
//   const [suggestions, setSuggestions] = React.useState([]);
//   const [activeIdx, setActiveIdx] = React.useState(-1);
//   const [currentQuery, setCurrentQuery] = React.useState("");
//   const [isRecording, setIsRecording] = React.useState(false);
//   const [micSupported, setMicSupported] = React.useState(false);
//   const queryStartRef = React.useRef(0);
//   const queryEndRef = React.useRef(0);

//   React.useEffect(() => {
//     const SpeechRec =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     setMicSupported(!!SpeechRec);
//   }, []);

//   const hideSuggestions = () => {
//     setSuggestions([]);
//     setActiveIdx(-1);
//     setCurrentQuery("");
//   };

//   const handleChange = (e) => {
//     const ta = e.target;
//     const val = ta.value;
//     const cursor = ta.selectionStart;
//     onChange(val);
//     let lineStart = cursor - 1;
//     while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
//     lineStart++;
//     const query = val.substring(lineStart, cursor);
//     queryStartRef.current = lineStart;
//     queryEndRef.current = cursor;
//     if (query.trim().length < 2) {
//       hideSuggestions();
//       return;
//     }
//     const matches = googleSearch(query, customMeds);
//     if (!matches.length) {
//       hideSuggestions();
//       return;
//     }
//     setCurrentQuery(query);
//     setSuggestions(matches);
//     setActiveIdx(-1);
//   };

//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;
//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
//     } else if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIdx((i) => Math.max(i - 1, 0));
//     } else if (
//       (e.key === "Enter" || e.key === "Tab") &&
//       activeIdx >= 0 &&
//       suggestions[activeIdx]
//     ) {
//       e.preventDefault();
//       selectMed(suggestions[activeIdx].name);
//     } else if (e.key === "Escape") hideSuggestions();
//   };

//   const selectMed = (name) => {
//     const ta = taRef.current;
//     const val = ta.value;
//     const before = val.substring(0, queryStartRef.current);
//     const after = val.substring(queryEndRef.current);
//     onChange(before + name + after);
//     hideSuggestions();
//     saveCustomMed(name).then((saved) => {
//       if (onCustomSaved) onCustomSaved(saved || null);
//     });
//     setTimeout(() => {
//       if (taRef.current) {
//         const nc = queryStartRef.current + name.length;
//         taRef.current.setSelectionRange(nc, nc);
//         taRef.current.focus();
//         queryEndRef.current = nc;
//       }
//     }, 0);
//   };

//   const handleBlur = () => {
//     if (!taRef.current) return;
//     const val = taRef.current.value;
//     val.split("\n").forEach((line) => {
//       const trimmed = line.trim();
//       if (
//         trimmed.length >= 3 &&
//         /[a-zA-Z]/.test(trimmed) &&
//         !/^[0-9\s]+$/.test(trimmed)
//       ) {
//         saveCustomMed(trimmed).then((saved) => {
//           if (saved && onCustomSaved) onCustomSaved(saved);
//         });
//       }
//     });
//   };

//   // ✅ Mic toggle — start/stop speech recognition
//   // FIX: capture baseText ONCE when recording starts, accumulate finals separately
//   // so interim results never cause duplication
//   const toggleMic = () => {
//     const SpeechRec =
//       window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (!SpeechRec) {
//       alert(
//         "Your browser does not support speech recognition.\nPlease use Chrome on Android or desktop.",
//       );
//       return;
//     }
//     if (isRecording) {
//       if (recognitionRef.current) {
//         recognitionRef.current.stop();
//       }
//       setIsRecording(false);
//       return;
//     }
//     const recognition = new SpeechRec();
//     recognitionRef.current = recognition;
//     recognition.lang = "en-IN";
//     recognition.continuous = true;
//     recognition.interimResults = true;
//     recognition.maxAlternatives = 1;
//     // ✅ Capture the existing textarea value ONCE when recording starts
//     // Never read taRef.current.value inside onresult — that causes duplication
//     const baseText = taRef.current ? taRef.current.value : "";
//     const prefix =
//       baseText.length > 0 && !baseText.endsWith(" ")
//         ? baseText + " "
//         : baseText;
//     let committedText = ""; // accumulates only FINAL results
//     recognition.onstart = () => setIsRecording(true);
//     recognition.onresult = (e) => {
//       // Rebuild committed from scratch on each event (safe, no duplication)
//       let finalSoFar = "";
//       let interimSoFar = "";
//       for (let i = 0; i < e.results.length; i++) {
//         if (e.results[i].isFinal) {
//           finalSoFar += e.results[i][0].transcript + " ";
//         } else {
//           interimSoFar += e.results[i][0].transcript;
//         }
//       }
//       // Display: original text + all finals so far + current interim
//       onChange(prefix + finalSoFar + interimSoFar);
//     };
//     recognition.onerror = (e) => {
//       setIsRecording(false);
//       if (e.error !== "aborted") alert("Mic error: " + e.error);
//     };
//     recognition.onend = () => setIsRecording(false);
//     recognition.start();
//   };

//   React.useEffect(() => {
//     const handler = (e) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(e.target))
//         hideSuggestions();
//     };
//     document.addEventListener("mousedown", handler);
//     return () => document.removeEventListener("mousedown", handler);
//   }, []);

//   React.useEffect(() => {
//     return () => {
//       if (recognitionRef.current) {
//         try {
//           recognitionRef.current.stop();
//         } catch (_) {}
//       }
//     };
//   }, []);

//   return (
//     <>
//       <style>{`
//         .mic-active { animation: micPulse 1.2s ease-in-out infinite; background: #dc2626 !important; border-color: #dc2626 !important; }
//       `}</style>
//       <div style={{ position: "relative" }} ref={wrapperRef}>
//         <div style={{ position: "relative" }}>
//           <textarea
//             ref={taRef}
//             value={value}
//             onChange={handleChange}
//             onKeyDown={handleKeyDown}
//             onBlur={handleBlur}
//             autoComplete="off"
//             style={{ paddingRight: micSupported ? "48px" : undefined }}
//             placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
//           />
//           {/* ✅ Mic Button */}
//           {micSupported && (
//             <button
//               type="button"
//               onClick={toggleMic}
//               className={isRecording ? "mic-active" : ""}
//               title={isRecording ? "Stop Recording" : "Start Voice Input"}
//               style={{
//                 position: "absolute",
//                 right: 8,
//                 bottom: 8,
//                 width: 34,
//                 height: 34,
//                 borderRadius: "50%",
//                 background: isRecording ? "#dc2626" : "rgba(13,115,119,0.1)",
//                 border: `1.5px solid ${isRecording ? "#dc2626" : "rgba(13,115,119,0.3)"}`,
//                 color: isRecording ? "#fff" : "#0d7377",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 cursor: "pointer",
//                 fontSize: 16,
//                 transition: "all 0.2s",
//                 zIndex: 10,
//               }}
//             >
//               {isRecording ? "⏹" : "🎤"}
//             </button>
//           )}
//         </div>
//         {/* Recording indicator */}
//         {isRecording && (
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 6,
//               marginTop: 4,
//               fontSize: 12,
//               color: "#dc2626",
//               fontFamily: "DM Sans,sans-serif",
//             }}
//           >
//             <span
//               style={{
//                 width: 8,
//                 height: 8,
//                 borderRadius: "50%",
//                 background: "#dc2626",
//                 display: "inline-block",
//                 animation: "micPulse 1s ease-in-out infinite",
//               }}
//             ></span>
//             Recording… speak now. Tap ⏹ to stop.
//           </div>
//         )}
//         {suggestions.length > 0 && (
//           <div
//             style={{
//               position: "absolute",
//               left: 0,
//               right: 0,
//               background: "#fff",
//               border: "1.5px solid #0d7377",
//               borderTop: "none",
//               borderRadius: "0 0 12px 12px",
//               boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
//               zIndex: 99999,
//               maxHeight: 280,
//               overflowY: "auto",
//               fontFamily: "'DM Sans',sans-serif",
//             }}
//           >
//             {suggestions.map((m, i) => (
//               <div
//                 key={m.name + i}
//                 className={
//                   "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
//                 }
//                 onMouseDown={(e) => {
//                   e.preventDefault();
//                   selectMed(m.name);
//                 }}
//               >
//                 <span className="med-sug-icon">💊</span>
//                 <span
//                   className="med-sug-name"
//                   dangerouslySetInnerHTML={{
//                     __html: highlightWords(m.name, currentQuery),
//                   }}
//                 />
//                 <span className="med-sug-cat">{m.cat}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }

// // ── Prescription Modal — exact original PDF design ────────────
// function PrescriptionModal({ visit, patient, doctor, onClose, showNotify }) {
//   const [pdfUrl, setPdfUrl] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [pdfBlob, setPdfBlob] = useState(null);
//   const [rxMobile, setRxMobile] = useState("");
//   const [fileName, setFileName] = useState("");
//   const [canNativeShare, setCanNativeShare] = useState(false);

//   useEffect(() => {
//     generatePDF();
//   }, []);
//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape") onClose();
//     };
//     document.addEventListener("keydown", handler);
//     return () => document.removeEventListener("keydown", handler);
//   }, [onClose]);

//   const fmtDateLocal = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr + "T00:00:00");
//     return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
//   };
//   const fmtTimeLocal = (t) => {
//     if (!t) return "";
//     const parts = t.split(":");
//     const hh = parseInt(parts[0]),
//       mm = parts[1];
//     return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
//   };

//   const generatePDF = () => {
//     if (window.jspdf) {
//       buildPDF();
//       return;
//     }
//     const existing = document.getElementById("jspdf-cdn");
//     if (existing) {
//       existing.addEventListener("load", buildPDF);
//       return;
//     }
//     const script = document.createElement("script");
//     script.id = "jspdf-cdn";
//     script.src =
//       "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
//     script.crossOrigin = "anonymous";
//     script.onload = buildPDF;
//     script.onerror = () => setLoading(false);
//     document.head.appendChild(script);
//   };

//   const buildPDF = () => {
//     const { jsPDF } = window.jspdf;
//     const pdf = new jsPDF({
//       unit: "mm",
//       format: "a4",
//       orientation: "portrait",
//     });
//     const W = 210,
//       H = 297;
//     const sf = (c) => pdf.setFillColor(c[0], c[1], c[2]);
//     const sd = (c) => pdf.setDrawColor(c[0], c[1], c[2]);
//     const st = (c) => pdf.setTextColor(c[0], c[1], c[2]);
//     const NAVY = [8, 25, 65],
//       BLUE = [20, 80, 160];
//     const LBLUE = [210, 228, 248],
//       LBLUE2 = [232, 242, 252],
//       MIDBLUE = [160, 195, 235];
//     const TEAL = [0, 130, 130],
//       TEAL2 = [210, 240, 240];
//     const WHITE = [255, 255, 255],
//       LGRAY = [245, 247, 251],
//       LGRAY2 = [250, 251, 254],
//       LGRAY3 = [240, 243, 248];
//     const GRAY = [115, 118, 130],
//       GRAY2 = [75, 80, 95];
//     const GOLD = [170, 130, 40],
//       GOLD2 = [250, 245, 225];
//     const today = new Date();
//     const todayFmt =
//       today.getDate() +
//       " " +
//       MONTHS[today.getMonth()] +
//       " " +
//       today.getFullYear();
//     const rxNum =
//       "PS-" +
//       today.getFullYear() +
//       ("0" + (today.getMonth() + 1)).slice(-2) +
//       ("0" + today.getDate()).slice(-2) +
//       "-" +
//       Math.floor(1000 + Math.random() * 8999);
//     const visitDate = visit.visitDate || "",
//       visitTime = visit.visitTime || "",
//       notes = visit.notes || "",
//       nextDate = visit.nextVisitDate || "",
//       service = visit.service || "";
//     const doc = { name: doctor?.name || "Doctor", qual: "", reg: "" };
//     const visitDateFmt = fmtDateLocal(visitDate),
//       visitTimeFmt = fmtTimeLocal(visitTime),
//       nextDateFmt = fmtDateLocal(nextDate);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.8);
//     pdf.rect(3.5, 3.5, W - 7, H - 7, "S");
//     sd(LBLUE);
//     pdf.setLineWidth(0.3);
//     pdf.rect(5.5, 5.5, W - 11, H - 11, "S");
//     sf(NAVY);
//     pdf.rect(3.5, 3.5, W - 7, 46, "F");
//     sf(BLUE);
//     pdf.rect(3.5, 43, W - 7, 10, "F");
//     sf(LBLUE);
//     pdf.rect(3.5, 53, W - 7, 6, "F");
//     st(WHITE);
//     pdf.setFontSize(18);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(doc.name, 14, 19);
//     st(LBLUE);
//     pdf.setFontSize(8);
//     pdf.setFont("helvetica", "normal");
//     pdf.text((doc.qual || "").toUpperCase(), 14, 26);
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(14, 28.5, W - 40, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(7);
//     pdf.text("Reg. No.:  " + (doc.reg || "—"), 14, 33.5);
//     pdf.text("Specialisation:  Dental & Oral Health Care", 14, 38.5);
//     st(WHITE);
//     pdf.setFontSize(15);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PEARLSMILE", W - 10, 19, { align: "right" });
//     st(LBLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("DENTAL HOSPITAL", W - 10, 25.5, { align: "right" });
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.line(W - 72, 28.5, W - 10, 28.5);
//     st(LGRAY);
//     pdf.setFontSize(6.8);
//     pdf.text("12, Dental Plaza, MG Road, Pune - 411001", W - 10, 33.5, {
//       align: "right",
//     });
//     pdf.text("+91 87936 08083  |  care@pearlsmiledental.in", W - 10, 38.5, {
//       align: "right",
//     });
//     st(WHITE);
//     pdf.setFontSize(9);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("DIGITAL PRESCRIPTION", W / 2, 50, { align: "center" });
//     st(LBLUE2);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 10, 50);
//     pdf.text("Date: " + todayFmt, W - 10, 50, { align: "right" });
//     st(BLUE);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("PATIENT INFORMATION", W / 2, 57, { align: "center" });
//     const infoTop = 61;
//     sf(LGRAY3);
//     pdf.rect(10, infoTop, W - 20, 44, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, infoTop, W - 20, 44, "S");
//     sd(MIDBLUE);
//     pdf.setLineWidth(0.2);
//     pdf.line(W / 2, infoTop, W / 2, infoTop + 44);
//     let rdy = infoTop + 11;
//     for (let ri = 0; ri < 3; ri++) {
//       pdf.line(10, rdy, W - 10, rdy);
//       rdy += 11;
//     }
//     const drawCell = (label, value, x, y, maxW) => {
//       st(GRAY2);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.8);
//       pdf.text(label, x + 3, y + 4);
//       st(NAVY);
//       pdf.setFont("helvetica", "normal");
//       pdf.setFontSize(8.5);
//       const val = pdf.splitTextToSize(String(value || "—"), maxW || 75);
//       pdf.text(val[0], x + 3, y + 9.5);
//     };
//     const cHalf = W / 2;
//     drawCell("PATIENT NAME", patient.name || "—", 10, infoTop, cHalf - 16);
//     drawCell("MOBILE", patient.mobile || "—", cHalf, infoTop, cHalf - 16);
//     drawCell("EMAIL", patient.email || "—", 10, infoTop + 11, cHalf - 16);
//     drawCell(
//       "BLOOD GROUP",
//       patient.blood || "—",
//       cHalf,
//       infoTop + 11,
//       cHalf - 16,
//     );
//     drawCell(
//       "AGE / GENDER",
//       (patient.age || "—") + (patient.gender ? "  |  " + patient.gender : ""),
//       10,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell(
//       "VISIT DATE",
//       visitDateFmt + (visitTimeFmt ? " (" + visitTimeFmt + ")" : ""),
//       cHalf,
//       infoTop + 22,
//       cHalf - 16,
//     );
//     drawCell("SERVICE/TREATMENT", service || "—", 10, infoTop + 33, cHalf - 16);
//     drawCell(
//       "NEXT VISIT DATE",
//       nextDateFmt || "—",
//       cHalf,
//       infoTop + 33,
//       cHalf - 16,
//     );
//     const diagTop = infoTop + 50;
//     const rxRows =
//       visit.prescription && visit.prescription.medicineRows
//         ? visit.prescription.medicineRows.filter(
//             (r) => r.medicine && r.medicine.trim(),
//           )
//         : [];
//     let rxTableEndY = diagTop;
//     if (rxRows.length > 0) {
//       const tTop = diagTop;
//       sf(BLUE);
//       pdf.rect(10, tTop, W - 20, 7, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(7.5);
//       pdf.text("PRESCRIPTION", W / 2, tTop + 5, { align: "center" });
//       const colX = [10, 20, 90, 155, 183];
//       let ry = tTop + 7;
//       sf(LGRAY3);
//       pdf.rect(10, ry, W - 20, 6, "F");
//       [
//         ["SR.", "normal", 6],
//         ["MEDICINE", "bold", 6],
//         ["DOSAGE INSTRUCTION", "normal", 6],
//         ["DURATION", "normal", 6],
//         ["ROUTE", "normal", 6],
//       ].forEach(([h, fw, fs], hi) => {
//         st(GRAY2);
//         pdf.setFont("helvetica", fw);
//         pdf.setFontSize(fs);
//         pdf.text(h, colX[hi] + 1, ry + 4.5);
//       });
//       ry += 6;
//       rxRows.forEach((row, ri) => {
//         sf(ri % 2 === 0 ? LGRAY2 : WHITE);
//         pdf.rect(10, ry, W - 20, 7, "F");
//         sd(LBLUE);
//         pdf.setLineWidth(0.1);
//         pdf.rect(10, ry, W - 20, 7, "S");
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6);
//         pdf.text(String(ri + 1) + ".", colX[0] + 1, ry + 4.5);
//         st(NAVY);
//         pdf.setFont("helvetica", "bold");
//         pdf.setFontSize(7);
//         pdf.text(
//           pdf.splitTextToSize(row.medicine || "", 68)[0] || "",
//           colX[1] + 1,
//           ry + 4.5,
//         );
//         st(GRAY2);
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(6.5);
//         pdf.text(
//           pdf.splitTextToSize(row.dosage || "", 63)[0] || "",
//           colX[2] + 1,
//           ry + 4.5,
//         );
//         pdf.text(row.duration || "", colX[3] + 1, ry + 4.5);
//         pdf.text(row.route || "", colX[4] + 1, ry + 4.5);
//         ry += 7;
//       });
//       rxTableEndY = ry + 4;
//     }
//     const notesTop = rxTableEndY + 4;
//     sf(BLUE);
//     pdf.rect(10, notesTop, W - 20, 8, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(8.5);
//     pdf.text("Rx   CLINICAL NOTES / DIAGNOSIS", 14, notesTop + 5.5);
//     st(GOLD);
//     pdf.setFontSize(10);
//     pdf.text("Rx", W - 16, notesTop + 5.5, { align: "right" });
//     const notesBoxH = 46;
//     sf(LGRAY2);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "F");
//     sd(LBLUE);
//     pdf.setLineWidth(0.25);
//     pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "S");
//     sd([215, 225, 240]);
//     pdf.setLineWidth(0.15);
//     for (let rl = 0; rl < 6; rl++)
//       pdf.line(14, notesTop + 16 + rl * 7, W - 14, notesTop + 16 + rl * 7);
//     st(NAVY);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(9.5);
//     const noteLines = pdf.splitTextToSize(
//       notes || "No diagnosis or notes recorded for this visit.",
//       W - 30,
//     );
//     pdf.text(noteLines, 14, notesTop + 15);
//     let tableEndY = notesTop + notesBoxH + 8;
//     let afterY = tableEndY;
//     if (nextDateFmt) {
//       sf(TEAL2);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "F");
//       sd(TEAL);
//       pdf.setLineWidth(0.4);
//       pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "S");
//       sf(TEAL);
//       pdf.roundedRect(10, afterY, 10, 13, 2, 2, "F");
//       st(WHITE);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(6.5);
//       pdf.text("NEXT", 11.2, afterY + 5.5);
//       pdf.text("VISIT", 11.0, afterY + 10);
//       st(TEAL);
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(9);
//       pdf.text("Next Appointment:", 24, afterY + 6.5);
//       st(NAVY);
//       pdf.setFontSize(10);
//       pdf.setFont("helvetica", "bold");
//       pdf.text(nextDateFmt, 72, afterY + 6.5);
//       st(GRAY);
//       pdf.setFontSize(7);
//       pdf.setFont("helvetica", "italic");
//       pdf.text(
//         "Please arrive 10 minutes early and bring this prescription.",
//         24,
//         afterY + 11,
//       );
//       afterY += 19;
//     }
//     const advY = afterY + 4;
//     sf(GOLD2);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "F");
//     sd(GOLD);
//     pdf.setLineWidth(0.35);
//     pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "S");
//     sf(GOLD);
//     pdf.roundedRect(10, advY, 10, 20, 2, 2, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(6.2);
//     pdf.text("GEN.", 11.2, advY + 8);
//     pdf.text("ADV.", 11.2, advY + 13.5);
//     st(GOLD);
//     pdf.setFontSize(7.5);
//     pdf.setFont("helvetica", "bold");
//     pdf.text("General Advice:", 24, advY + 6.5);
//     st(GRAY2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text(
//       "1.  Follow all prescribed medicines on time and complete the full course.",
//       24,
//       advY + 11.5,
//     );
//     pdf.text(
//       "2.  Maintain good oral hygiene. Brush gently twice daily.",
//       24,
//       advY + 15.5,
//     );
//     pdf.text(
//       "3.  Avoid very hot, cold, or hard foods until fully healed.",
//       24,
//       advY + 19.2,
//     );
//     pdf.saveGraphicsState();
//     pdf.setGState(new pdf.GState({ opacity: 0.035 }));
//     st(NAVY);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(44);
//     pdf.text("PEARLSMILE", W / 2, H / 2 - 5, { align: "center", angle: 35 });
//     pdf.restoreGraphicsState();
//     const sigY = Math.max(advY + 28, H - 55);
//     const INK = [28, 52, 140],
//       INK2 = [45, 75, 170];
//     const cx = W - 46,
//       cy = sigY + 13,
//       R = 18;
//     sd(INK);
//     pdf.setLineWidth(1.2);
//     pdf.circle(cx, cy, R, "S");
//     pdf.setLineWidth(0.4);
//     pdf.circle(cx, cy, R - 2.5, "S");
//     const drawStar = (sx, sy, sr) => {
//       const pts = [];
//       for (let si = 0; si < 5; si++) {
//         const ao = (si * 4 * Math.PI) / 5 - Math.PI / 2,
//           ai = ao + (2 * Math.PI) / 5;
//         pts.push({ x: sx + sr * Math.cos(ao), y: sy + sr * Math.sin(ao) });
//         pts.push({
//           x: sx + sr * 0.4 * Math.cos(ai),
//           y: sy + sr * 0.4 * Math.sin(ai),
//         });
//       }
//       pdf.setLineWidth(0.3);
//       sd(INK);
//       sf(INK);
//       pdf.lines(
//         pts.slice(1).map((pt, i) => [pt.x - pts[i].x, pt.y - pts[i].y]),
//         pts[0].x,
//         pts[0].y,
//         [1, 1],
//         "FD",
//         true,
//       );
//     };
//     drawStar(cx - R + 3.5, cy + 1, 2.2);
//     drawStar(cx + R - 3.5, cy + 1, 2.2);
//     const docShort = (doc.name || "Doctor").toUpperCase();
//     sd(INK);
//     st(INK);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(5.8);
//     const topSpan = Math.min(docShort.length * 0.19, 1.3),
//       topStart = -Math.PI / 2 - topSpan / 2;
//     for (let ti = 0; ti < docShort.length; ti++) {
//       const ta = topStart + (ti / Math.max(docShort.length - 1, 1)) * topSpan;
//       const tx = cx + (R - 1.5) * Math.cos(ta),
//         ty = cy + (R - 1.5) * Math.sin(ta);
//       const trot = ((ta + Math.PI / 2) * 180) / Math.PI;
//       pdf.text(docShort[ti], tx, ty, { align: "center", angle: -trot });
//     }
//     pdf.setFontSize(5.5);
//     const botStr = "PEARLSMILE DENTAL";
//     const botSpan = Math.min(botStr.length * 0.175, 1.4),
//       botStart = Math.PI / 2 - botSpan / 2;
//     for (let bi = 0; bi < botStr.length; bi++) {
//       const ba = botStart + (bi / Math.max(botStr.length - 1, 1)) * botSpan;
//       const bx = cx + (R - 1.5) * Math.cos(ba),
//         by = cy + (R - 1.5) * Math.sin(ba);
//       const brot = ((ba - Math.PI / 2) * 180) / Math.PI;
//       pdf.text(botStr[bi], bx, by, { align: "center", angle: -brot });
//     }
//     sd(INK);
//     pdf.setLineWidth(0.8);
//     pdf.line(cx, cy - 8, cx, cy + 7);
//     pdf.setLineWidth(0.5);
//     pdf.line(cx, cy - 7.5, cx - 4, cy - 9.5);
//     pdf.line(cx - 4, cy - 9.5, cx - 6, cy - 8);
//     pdf.line(cx - 6, cy - 8, cx - 3, cy - 6.5);
//     pdf.line(cx, cy - 7.5, cx + 4, cy - 9.5);
//     pdf.line(cx + 4, cy - 9.5, cx + 6, cy - 8);
//     pdf.line(cx + 6, cy - 8, cx + 3, cy - 6.5);
//     sf(INK);
//     pdf.circle(cx, cy - 8.2, 1, "F");
//     pdf.setLineWidth(0.6);
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//         [0, -2],
//       ],
//       cx - 3,
//       cy + 5,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [-2, -2],
//         [-2, -2],
//         [0, -2],
//       ],
//       cx + 3,
//       cy + 1,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//       ],
//       cx - 3,
//       cy - 3,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [-2, -2],
//         [-2, -2],
//         [0, -2],
//       ],
//       cx + 3,
//       cy + 5,
//       [1, 1],
//       "S",
//     );
//     pdf.lines(
//       [
//         [2, -2],
//         [2, -2],
//         [0, -2],
//       ],
//       cx - 3,
//       cy + 1,
//       [1, 1],
//       "S",
//     );
//     st(INK);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(4.5);
//     pdf.text("Reg. " + (doc.reg || "—"), cx, cy + R - 5.5, { align: "center" });
//     st(INK2);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(6.5);
//     pdf.text("Authorised Signatory", cx, cy + R + 4, { align: "center" });
//     st(GRAY);
//     pdf.setFontSize(7);
//     pdf.setFont("helvetica", "normal");
//     pdf.text("Rx No.: " + rxNum, 14, sigY + 30);
//     pdf.text("Date: " + todayFmt, W - 14, sigY + 30, { align: "right" });
//     sf(NAVY);
//     pdf.rect(3.5, H - 21, W - 7, 17.5, "F");
//     sf(BLUE);
//     pdf.rect(3.5, H - 7, W - 7, 3.5, "F");
//     st(WHITE);
//     pdf.setFont("helvetica", "bold");
//     pdf.setFontSize(7.5);
//     pdf.text("PearlSmile Dental Hospital", 10, H - 14.5);
//     st(LBLUE);
//     pdf.setFont("helvetica", "normal");
//     pdf.setFontSize(7);
//     pdf.text("+91 87936 08083", 10, H - 9.5);
//     pdf.text("care@pearlsmiledental.in", W / 2, H - 9.5, { align: "center" });
//     pdf.text("12, Dental Plaza, MG Road, Pune - 411001", W - 10, H - 9.5, {
//       align: "right",
//     });
//     st(LBLUE2);
//     pdf.setFontSize(6);
//     pdf.setFont("helvetica", "italic");
//     pdf.text(
//       "This is a computer-generated prescription from PearlSmile Dental Hospital. Valid only with authorised doctor details.",
//       W / 2,
//       H - 5.5,
//       { align: "center" },
//     );
//     const blob = pdf.output("blob");
//     const url = URL.createObjectURL(blob);
//     const name =
//       "Prescription_" +
//       (patient.name || "Patient").replace(/\s+/g, "_") +
//       "_" +
//       visitDate +
//       ".pdf";
//     let rawMob = (patient.mobile || "").replace(/[\s\-\(\)\+]/g, "");
//     if (!rawMob.startsWith("91") && rawMob.length === 10)
//       rawMob = "91" + rawMob;
//     setPdfBlob(blob);
//     setPdfUrl(url);
//     setRxMobile(rawMob);
//     setFileName(name);
//     const testFile = new File([blob], name, { type: "application/pdf" });
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [testFile] })
//     )
//       setCanNativeShare(true);
//     setLoading(false);
//   };

//   const openFullPreview = () => {
//     if (pdfUrl) window.open(pdfUrl, "_blank");
//   };

//   const nativeShare = async () => {
//     if (!pdfBlob) return;
//     const file = new File([pdfBlob], fileName, { type: "application/pdf" });
//     const dlLink = document.createElement("a");
//     dlLink.href = pdfUrl;
//     dlLink.download = fileName;
//     dlLink.click();
//     if (
//       navigator.share &&
//       navigator.canShare &&
//       navigator.canShare({ files: [file] })
//     ) {
//       navigator
//         .share({
//           title: "Digital Prescription — PearlSmile Dental Hospital",
//           text: "Dear Patient, please find your digital prescription attached.",
//           files: [file],
//         })
//         .then(() => {
//           showNotify("Sent! ✓", "Prescription shared successfully.");
//           onClose();
//         })
//         .catch((err) => {
//           if (err.name !== "AbortError") {
//             if (rxMobile) {
//               const waMsg = encodeURIComponent(
//                 "Dear Patient, your digital prescription has been generated. Please find the PDF file attached.",
//               );
//               window.open(
//                 "https://wa.me/" + rxMobile + "?text=" + waMsg,
//                 "_blank",
//               );
//             }
//           }
//         });
//     } else {
//       if (rxMobile) {
//         const waMsg = encodeURIComponent(
//           "Dear Patient, your digital prescription has been downloaded. Please check the PDF in your Downloads folder.",
//         );
//         setTimeout(
//           () =>
//             window.open(
//               "https://wa.me/" + rxMobile + "?text=" + waMsg,
//               "_blank",
//             ),
//           600,
//         );
//         showNotify(
//           "PDF Downloaded + WhatsApp Opened! ✓",
//           "Prescription saved. WhatsApp opened to patient number.",
//         );
//       } else {
//         showNotify("PDF Downloaded ✓", "Prescription saved. Share manually.");
//       }
//     }
//   };

//   return (
//     <div
//       className="rx-share-overlay open"
//       onClick={(e) => {
//         if (e.target === e.currentTarget) onClose();
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 20,
//           width: "100%",
//           maxWidth: 540,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
//           overflow: "hidden",
//           display: "flex",
//           flexDirection: "column",
//           maxHeight: "92vh",
//         }}
//       >
//         <div
//           style={{
//             background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
//             padding: "18px 22px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <span style={{ fontSize: 22 }}>📄</span>
//             <div>
//               <div
//                 style={{
//                   color: "#fff",
//                   fontWeight: 600,
//                   fontSize: 15,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Digital Prescription Ready
//               </div>
//               <div
//                 style={{
//                   color: "rgba(255,255,255,0.55)",
//                   fontSize: 12,
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 {patient.name} · {visit.visitDate}
//               </div>
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               background: "rgba(255,255,255,0.12)",
//               border: "none",
//               color: "#fff",
//               width: 32,
//               height: 32,
//               borderRadius: "50%",
//               fontSize: 17,
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             ✕
//           </button>
//         </div>
//         <div
//           style={{
//             flex: 1,
//             overflow: "hidden",
//             background: "#f0eeeb",
//             minHeight: 340,
//             position: "relative",
//           }}
//         >
//           {loading && (
//             <div
//               style={{
//                 position: "absolute",
//                 inset: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: "#f0eeeb",
//                 gap: 10,
//               }}
//             >
//               <div
//                 style={{
//                   width: 36,
//                   height: 36,
//                   border: "3px solid #0d7377",
//                   borderTopColor: "transparent",
//                   borderRadius: "50%",
//                   animation: "spin 0.8s linear infinite",
//                 }}
//               />
//               <div
//                 style={{
//                   fontSize: 13,
//                   color: "#5a5550",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Generating PDF…
//               </div>
//             </div>
//           )}
//           {pdfUrl && (
//             <iframe
//               title="prescription"
//               src={pdfUrl}
//               style={{ width: "100%", height: 420, border: "none" }}
//             />
//           )}
//         </div>
//         <div
//           style={{
//             padding: "16px 20px",
//             display: "flex",
//             flexDirection: "column",
//             gap: 10,
//             background: "#fff",
//           }}
//         >
//           <div style={{ display: "flex", gap: 8 }}>
//             <button
//               onClick={openFullPreview}
//               onMouseOver={(e) =>
//                 (e.currentTarget.style.background = "#e5e0d8")
//               }
//               onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
//               style={{
//                 flex: 1,
//                 background: "#f0eeeb",
//                 color: "#0a1628",
//                 border: "1.5px solid #ddd9d3",
//                 borderRadius: 10,
//                 padding: 10,
//                 fontSize: 13,
//                 fontWeight: 500,
//                 cursor: "pointer",
//                 fontFamily: "DM Sans,sans-serif",
//                 transition: "background 0.2s",
//               }}
//             >
//               🔍 Open Full PDF
//             </button>
//             {canNativeShare && (
//               <button
//                 onClick={nativeShare}
//                 onMouseOver={(e) =>
//                   (e.currentTarget.style.background = "#e5e0d8")
//                 }
//                 onMouseOut={(e) =>
//                   (e.currentTarget.style.background = "#f0eeeb")
//                 }
//                 style={{
//                   flex: 1,
//                   background: "#f0eeeb",
//                   color: "#0a1628",
//                   border: "1.5px solid #ddd9d3",
//                   borderRadius: 10,
//                   padding: 10,
//                   fontSize: 13,
//                   fontWeight: 500,
//                   cursor: "pointer",
//                   fontFamily: "DM Sans,sans-serif",
//                   transition: "background 0.2s",
//                 }}
//               >
//                 📤 Share (Device)
//               </button>
//             )}
//           </div>
//           <p
//             style={{
//               fontSize: 11,
//               color: "#9a9590",
//               textAlign: "center",
//               margin: 0,
//               fontFamily: "DM Sans,sans-serif",
//               lineHeight: 1.5,
//             }}
//           >
//             On mobile: tap "Share (Device)" to send directly via WhatsApp.
//             <br />
//             On desktop: use "Open Full PDF" to view, then share manually.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

//////////// excel export feature

// ============================================================
// src/components/admin/PatientsTab.js
// ✅ All original code untouched
// ✅ NEW: 🎤 Microphone / Speech-to-text in Doctor Notes
// ✅ NEW: 🧪 Lab Reports section (add URL, save permanently, delete)
// ============================================================
import React, { useState, useEffect, useCallback } from "react";
import ReactDOM from "react-dom";
import api from "../../utils/api";

const SERVICES_LIST = [
  "General Checkup & Cleaning",
  "Cosmetic Dentistry / Smile Makeover",
  "Dental Implants",
  "Orthodontics / Invisalign",
  "Root Canal Therapy",
  "Pediatric Dentistry",
  "Oral Surgery",
  "Periodontal Treatment",
  "Teeth Whitening",
  "Emergency Dental Care",
  "Follow-Up Visit",
  "Other",
];

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const MONTHS_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

function fmtDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr + "T00:00:00");
  return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
}

function fmtDateShort(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr + "T00:00:00");
  return d.getDate() + " " + MONTHS_SHORT[d.getMonth()] + " " + d.getFullYear();
}

function fmtTime(t) {
  if (!t) return "";
  const parts = t.split(":");
  const hh = parseInt(parts[0]),
    mm = parts[1];
  return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
}

function totalRevenue(visits = []) {
  return visits.reduce((sum, v) => {
    const n = parseFloat((v.amount || "0").toString().replace(/[^0-9.]/g, ""));
    return sum + (isNaN(n) ? 0 : n);
  }, 0);
}

// ✅ NEW — Load SheetJS dynamically for Excel export
function loadSheetJS() {
  return new Promise((resolve) => {
    if (window.XLSX) return resolve(true);
    if (document.getElementById("sheetjs-cdn")) {
      const check = setInterval(() => {
        if (window.XLSX) {
          clearInterval(check);
          resolve(true);
        }
      }, 100);
      return;
    }
    const s = document.createElement("script");
    s.id = "sheetjs-cdn";
    s.src =
      "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });
}

export default function PatientsTab({ showNotify, doctor }) {
  const [patients, setPatients] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNewForm, setShowNewForm] = useState(false);
  const [newPat, setNewPat] = useState({
    name: "",
    mobile: "",
    email: "",
    age: "",
    gender: "",
    blood: "",
  });
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [rxModal, setRxModal] = useState(null);
  const [customMeds, setCustomMeds] = useState([]);

  // ✅ NEW — Lab Reports state
  const [labReports, setLabReports] = useState([]);
  const [labName, setLabName] = useState("");
  const [labUrl, setLabUrl] = useState("");
  const [labSaving, setLabSaving] = useState(false);
  const [labUploading, setLabUploading] = useState(false);

  // ✅ NEW — Daily Report state
  const [reportDate, setReportDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const [exporting, setExporting] = useState(false);

  const today = new Date().toISOString().split("T")[0];
  const nowTime = new Date().toTimeString().slice(0, 5);
  const [visitForm, setVisitForm] = useState({
    date: today,
    time: nowTime,
    service: "",
    amount: "",
    nextVisitDate: "",
    notes: "",
    rxRows: [
      {
        medicine: "",
        dosageParts: ["0", "0", "0"],
        dosageTiming: "after meal",
        dosage: "",
        duration: "",
        route: "ORAL",
      },
    ],
  });

  const loadPatients = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api.get("/patients");
      setPatients(data);
      setFiltered(data);
    } catch (err) {
      showNotify("Error", err.message, true);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    loadPatients();
  }, [loadPatients]);

  useEffect(() => {
    api
      .get("/custommeds")
      .then((data) => {
        if (Array.isArray(data)) setCustomMeds(data);
      })
      .catch(() => {});
  }, []);

  const filterPatients = (q) => {
    const term = q.toLowerCase();
    setFiltered(
      patients.filter(
        (p) =>
          (p.name || "").toLowerCase().includes(term) ||
          (p.mobile || "").includes(term) ||
          (p.email || "").toLowerCase().includes(term),
      ),
    );
  };

  const createPatient = async () => {
    if (!newPat.name.trim()) {
      showNotify("Error", "Patient name is required.", true);
      return;
    }
    if (!newPat.mobile.trim()) {
      showNotify("Error", "Mobile number is required.", true);
      return;
    }
    try {
      await api.post("/patients", newPat);
      setNewPat({
        name: "",
        mobile: "",
        email: "",
        age: "",
        gender: "",
        blood: "",
      });
      setShowNewForm(false);
      showNotify(
        "Patient Profile Created! ✓",
        "New profile for " + newPat.name + " saved.",
      );
      loadPatients();
    } catch (err) {
      showNotify("Error", err.message, true);
    }
  };

  const openPatient = async (p) => {
    try {
      const full = await api.get("/patients/" + p._id);
      setSelectedPatient(full);
      // ✅ NEW — load lab reports
      setLabReports(full.labReports || []);
      setVisitForm({
        date: today,
        time: nowTime,
        service: "",
        amount: "",
        nextVisitDate: "",
        notes: "",
        rxRows: [
          {
            medicine: "",
            dosageParts: ["0", "0", "0"],
            dosageTiming: "after meal",
            dosage: "",
            duration: "",
            route: "ORAL",
          },
        ],
      });
    } catch (err) {
      showNotify("Error", err.message, true);
    }
  };

  const deletePatient = async () => {
    if (
      !window.confirm(
        "Delete this patient profile and all their records? This cannot be undone.",
      )
    )
      return;
    try {
      await api.delete("/patients/" + selectedPatient._id);
      showNotify("Profile Deleted", "Patient profile removed.");
      setSelectedPatient(null);
      loadPatients();
    } catch (err) {
      showNotify("Error", err.message, true);
    }
  };

  const saveVisit = async () => {
    if (!visitForm.date) {
      showNotify("Missing Fields", "Please select a visit date.", true);
      return;
    }
    if (!visitForm.service) {
      showNotify("Missing Fields", "Please select a service.", true);
      return;
    }
    try {
      const payload = {
        visitDate: visitForm.date,
        visitTime: visitForm.time,
        service: visitForm.service,
        amount: visitForm.amount,
        nextVisitDate: visitForm.nextVisitDate,
        notes: visitForm.notes,
        doctor: doctor?.name || "",
        prescription: {
          medicineRows: visitForm.rxRows.filter((r) => r.medicine.trim()),
        },
      };
      const updated = await api.post(
        "/patients/" + selectedPatient._id + "/visits",
        payload,
      );
      setSelectedPatient(updated);

      if (visitForm.nextVisitDate && selectedPatient.mobile) {
        try {
          await api.post("/appointments", {
            name: selectedPatient.name,
            phone: selectedPatient.mobile,
            service: visitForm.service,
            date: visitForm.nextVisitDate,
            time: "",
            message: "Follow-up visit from Patient Profile",
            status: "pending",
          });
        } catch (_) {}
      }

      setVisitForm({
        date: today,
        time: nowTime,
        service: "",
        amount: "",
        nextVisitDate: "",
        notes: "",
        rxRows: [
          {
            medicine: "",
            dosageParts: ["0", "0", "0"],
            dosageTiming: "after meal",
            dosage: "",
            duration: "",
            route: "ORAL",
          },
        ],
      });

      const isFollowUp = /follow[\s\-]?up/i.test(visitForm.notes);
      if (isFollowUp && visitForm.nextVisitDate && selectedPatient.mobile) {
        let rawMobile = (selectedPatient.mobile || "").replace(
          /[\s\-\(\)\+]/g,
          "",
        );
        if (!rawMobile.startsWith("91") && rawMobile.length === 10)
          rawMobile = "91" + rawMobile;
        const waMsg = `*PearlSmile Dental Hospital* — Follow-Up Reminder\n\nDear ${selectedPatient.name},\nThis is a reminder for your follow-up appointment.\n\n*Service:* ${visitForm.service}\n*Next Visit:* ${fmtDate(visitForm.nextVisitDate)}\n\nPlease call us to confirm your appointment.\n📞 +91 87936 08083`;
        setTimeout(
          () =>
            window.open(
              "https://wa.me/" +
                rawMobile +
                "?text=" +
                encodeURIComponent(waMsg),
              "_blank",
            ),
          500,
        );
        showNotify(
          "Visit Saved + Follow-Up Appointment Created!",
          "Reminder sent to " +
            selectedPatient.name +
            " for " +
            fmtDate(visitForm.nextVisitDate) +
            ". Appointment added to Upcoming.",
        );
      } else if (visitForm.nextVisitDate) {
        showNotify(
          "Visit Saved + Appointment Created! ✓",
          "Follow-up appointment for " +
            fmtDate(visitForm.nextVisitDate) +
            " added to Upcoming Appointments.",
        );
      } else {
        showNotify(
          "Visit Record Saved! ✓",
          "Patient visit has been recorded successfully.",
        );
      }
      loadPatients();
    } catch (err) {
      showNotify("Error", err.message, true);
    }
  };

  const deleteVisit = async (visitId) => {
    if (!window.confirm("Delete this visit record?")) return;
    try {
      const result = await api.delete(
        "/patients/" + selectedPatient._id + "/visits/" + visitId,
      );
      setSelectedPatient(result.patient);
      showNotify("Visit Deleted", "Visit record removed.");
      loadPatients();
    } catch (err) {
      showNotify("Error", err.message, true);
    }
  };

  const sendPrescription = (visit) => {
    const treatingDoctor = visit.doctor ? { name: visit.doctor } : doctor;
    setRxModal({ visit, patient: selectedPatient, doctor: treatingDoctor });
  };

  // ✅ NEW — Save Lab Report permanently to MongoDB
  const saveLabReport = async () => {
    if (!labName.trim()) {
      showNotify("Error", "Please enter a report name.", true);
      return;
    }
    if (!labUrl.trim()) {
      showNotify("Error", "Please enter the file URL.", true);
      return;
    }
    setLabSaving(true);
    try {
      const updated = await api.post(
        "/patients/" + selectedPatient._id + "/labreports",
        {
          name: labName.trim(),
          url: labUrl.trim(),
        },
      );
      setLabReports(updated.labReports || []);
      setSelectedPatient((prev) => ({
        ...prev,
        labReports: updated.labReports || [],
      }));
      setLabName("");
      setLabUrl("");
      showNotify(
        "Lab Report Saved! ✓",
        "Report saved permanently to patient profile.",
      );
    } catch (err) {
      showNotify("Error", err.message, true);
    }
    setLabSaving(false);
  };

  // ✅ NEW — Delete Lab Report
  const deleteLabReport = async (reportId) => {
    if (!window.confirm("Delete this lab report?")) return;
    try {
      const updated = await api.delete(
        "/patients/" + selectedPatient._id + "/labreports/" + reportId,
      );
      setLabReports(updated.labReports || []);
      setSelectedPatient((prev) => ({
        ...prev,
        labReports: updated.labReports || [],
      }));
      showNotify("Report Deleted", "Lab report removed.");
    } catch (err) {
      showNotify("Error", err.message, true);
    }
  };

  // ✅ NEW — Export Daily Patient Report to Excel
  const exportDailyReport = async () => {
    setExporting(true);
    try {
      const ok = await loadSheetJS();
      if (!ok || !window.XLSX) {
        showNotify(
          "Error",
          "Could not load Excel library. Check your internet connection.",
          true,
        );
        setExporting(false);
        return;
      }
      const allPatients = await api.get("/patients");
      const rows = [];
      let srNo = 1;
      for (const pat of allPatients) {
        let fullPat;
        try {
          fullPat = await api.get("/patients/" + pat._id);
        } catch (_) {
          continue;
        }
        const dayVisits = (fullPat.visits || []).filter(
          (v) => v.visitDate === reportDate,
        );
        for (const v of dayVisits) {
          const medicines = (v.prescription?.medicineRows || [])
            .filter((r) => r.medicine && r.medicine.trim())
            .map((r) => {
              let med = r.medicine;
              if (r.dosage) med += " (" + r.dosage + ")";
              if (r.duration) med += " - " + r.duration;
              if (r.route && r.route !== "ORAL") med += " [" + r.route + "]";
              return med;
            })
            .join("; ");
          rows.push({
            "Sr No": srNo++,
            Date: fmtDateShort(v.visitDate),
            Time: v.visitTime ? fmtTime(v.visitTime) : "—",
            "Patient Name": fullPat.name || "—",
            Age: fullPat.age || "—",
            Gender: fullPat.gender || "—",
            Phone: fullPat.mobile || "—",
            "Doctor Name": v.doctor || doctor?.name || "—",
            Service: v.service || "—",
            "Diagnosis / Notes": v.notes || "—",
            Medicines: medicines || "—",
            "Amount (Rs.)": v.amount || "0",
          });
        }
      }
      if (rows.length === 0) {
        showNotify(
          "No Patients",
          "No patients visited on " + fmtDateShort(reportDate) + ".",
          true,
        );
        setExporting(false);
        return;
      }
      const XLSX = window.XLSX;
      const ws = XLSX.utils.json_to_sheet(rows);
      ws["!cols"] = [
        { wch: 6 },
        { wch: 14 },
        { wch: 10 },
        { wch: 22 },
        { wch: 6 },
        { wch: 8 },
        { wch: 14 },
        { wch: 20 },
        { wch: 24 },
        { wch: 36 },
        { wch: 48 },
        { wch: 12 },
      ];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        wb,
        ws,
        "Patients_" + reportDate.replace(/-/g, ""),
      );
      const summaryData = [
        { Report: "Daily Patient Report" },
        { Report: "Hospital: PearlSmile Dental Hospital" },
        { Report: "Date: " + fmtDateShort(reportDate) },
        { Report: "Total Patients: " + rows.length },
        {
          Report:
            "Total Revenue: Rs. " +
            rows
              .reduce(
                (s, r) =>
                  s +
                  parseFloat(
                    (r["Amount (Rs.)"] || "0")
                      .toString()
                      .replace(/[^0-9.]/g, "") || 0,
                  ),
                0,
              )
              .toLocaleString("en-IN"),
        },
        { Report: "Generated: " + new Date().toLocaleString("en-IN") },
      ];
      const wsSummary = XLSX.utils.json_to_sheet(summaryData);
      wsSummary["!cols"] = [{ wch: 50 }];
      XLSX.utils.book_append_sheet(wb, wsSummary, "Summary");
      const fileName = "PearlSmile_Daily_Report_" + reportDate + ".xlsx";
      XLSX.writeFile(wb, fileName);
      showNotify(
        "✅ Report Downloaded!",
        rows.length +
          " patient" +
          (rows.length !== 1 ? "s" : "") +
          " on " +
          fmtDateShort(reportDate) +
          ". File: " +
          fileName,
      );
    } catch (err) {
      showNotify("Error", "Failed to export: " + err.message, true);
    }
    setExporting(false);
  };

  // ── LIST VIEW ─────────────────────────────────────────────────
  if (!selectedPatient) {
    return (
      <div>
        <div className="admin-section-title">Patient Profiles</div>
        <div className="admin-section-desc">
          Create and manage individual patient profiles. Click a profile to view
          visit history and add new records.
        </div>

        {/* ✅ NEW — Daily Report Export Bar */}
        <div
          style={{
            background: "linear-gradient(135deg,#0a1628,#0d2444)",
            borderRadius: 14,
            padding: "16px 20px",
            marginBottom: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <div>
            <div
              style={{
                fontSize: 14,
                fontWeight: 700,
                color: "#fff",
                marginBottom: 3,
              }}
            >
              📊 Daily Patient Report
            </div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)" }}>
              Export all patients who visited on a selected date as Excel
              (.xlsx)
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              flexWrap: "wrap",
            }}
          >
            <input
              type="date"
              value={reportDate}
              onChange={(e) => setReportDate(e.target.value)}
              style={{
                fontSize: 13,
                padding: "7px 12px",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: 8,
                background: "rgba(255,255,255,0.08)",
                color: "#fff",
                fontFamily: "DM Sans,sans-serif",
                cursor: "pointer",
              }}
            />
            <button
              onClick={exportDailyReport}
              disabled={exporting}
              style={{
                padding: "8px 18px",
                background: exporting
                  ? "#475569"
                  : "linear-gradient(135deg,#0d7377,#14a0a5)",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                fontSize: 13,
                fontWeight: 700,
                cursor: exporting ? "not-allowed" : "pointer",
                fontFamily: "DM Sans,sans-serif",
                whiteSpace: "nowrap",
              }}
            >
              {exporting ? "⏳ Exporting..." : "⬇️ Export Excel"}
            </button>
          </div>
        </div>

        <div className="patients-list-view">
          <input
            type="text"
            className="patient-search-bar"
            placeholder="🔍 Search patients by name or phone..."
            onChange={(e) => filterPatients(e.target.value)}
          />
          {showNewForm && (
            <div className="new-patient-form">
              <h4>➕ Create New Patient Profile</h4>
              <div className="new-patient-grid">
                {[
                  ["name", "text", "Full Name *", "Patient full name"],
                  ["mobile", "tel", "Mobile Number *", "+91 98765 43210"],
                  ["email", "email", "Email Address", "patient@email.com"],
                  ["age", "number", "Age", "Age"],
                ].map(([k, t, label, ph]) => (
                  <div key={k}>
                    <div className="admin-row-label">{label}</div>
                    <input
                      type={t}
                      placeholder={ph}
                      value={newPat[k]}
                      onChange={(e) =>
                        setNewPat((p) => ({ ...p, [k]: e.target.value }))
                      }
                    />
                  </div>
                ))}
                <div>
                  <div className="admin-row-label">Gender</div>
                  <select
                    value={newPat.gender}
                    onChange={(e) =>
                      setNewPat((p) => ({ ...p, gender: e.target.value }))
                    }
                  >
                    <option value="">Select Gender</option>
                    <option>Male</option>
                    <option>Female</option>
                    <option>Other</option>
                  </select>
                </div>
                <div>
                  <div className="admin-row-label">Blood Group</div>
                  <input
                    type="text"
                    placeholder="e.g. B+"
                    value={newPat.blood}
                    onChange={(e) =>
                      setNewPat((p) => ({ ...p, blood: e.target.value }))
                    }
                  />
                </div>
              </div>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                <button className="add-visit-save-btn" onClick={createPatient}>
                  💾 Save Patient Profile
                </button>
                <button
                  className="btn-back-patients"
                  onClick={() => setShowNewForm(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 14,
              flexWrap: "wrap",
              gap: 10,
            }}
          >
            <div style={{ fontSize: 13, color: "var(--gray-400)" }}>
              {loading
                ? "Loading patients..."
                : `${filtered.length} patient profile${filtered.length !== 1 ? "s" : ""}`}
            </div>
            <button
              className="admin-add-btn"
              onClick={() => setShowNewForm((s) => !s)}
            >
              {showNewForm ? "Cancel" : "+ New Patient Profile"}
            </button>
          </div>
          <div className="patient-profiles-grid">
            {loading ? (
              <div
                style={{
                  color: "var(--gray-400)",
                  fontSize: 14,
                  padding: "20px 0",
                  gridColumn: "1/-1",
                }}
              >
                Loading...
              </div>
            ) : filtered.length === 0 ? (
              <div
                style={{
                  color: "var(--gray-400)",
                  fontSize: 14,
                  padding: "24px 0",
                  gridColumn: "1/-1",
                  textAlign: "center",
                }}
              >
                No patients yet. Click "+ New Patient Profile" to add your first
                patient.
              </div>
            ) : (
              filtered.map((p) => (
                <div
                  key={p._id}
                  className="patient-profile-card"
                  onClick={() => openPatient(p)}
                >
                  <div className="patient-avatar-icon">🧑‍⚕️</div>
                  <div className="patient-card-name">{p.name}</div>
                  <div className="patient-card-id">📞 {p.mobile || "—"}</div>
                  <div className="patient-card-visits">
                    📋 {p.visitCount || 0} visit{p.visitCount !== 1 ? "s" : ""}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    );
  }

  // ── DETAIL VIEW ───────────────────────────────────────────────
  const p = selectedPatient;
  const visits = p.visits || [];
  const total = totalRevenue(visits);

  return (
    <div>
      <div className="patient-detail-view open">
        <div className="patient-detail-header">
          <button
            className="btn-back-patients"
            onClick={() => {
              setSelectedPatient(null);
            }}
          >
            ← Back to Patients
          </button>
          <div
            className="patient-avatar-icon"
            style={{ width: 56, height: 56, fontSize: 26 }}
          >
            🧑‍⚕️
          </div>
          <div style={{ flex: 1 }}>
            <h3>{p.name}</h3>
            <p style={{ fontSize: 13, color: "var(--gray-400)" }}>
              {p.email}
              {p.email && p.mobile ? " · " : ""}
              {p.mobile}
            </p>
            <div className="patient-info-row">
              {[
                p.age ? "Age: " + p.age : null,
                p.gender || null,
                p.blood ? "Blood: " + p.blood : null,
              ]
                .filter(Boolean)
                .map((t, i) => (
                  <span key={i} className="patient-info-pill">
                    {t}
                  </span>
                ))}
            </div>
          </div>
          <div style={{ textAlign: "right", flexShrink: 0 }}>
            <div
              style={{
                fontSize: 11,
                color: "var(--gray-400)",
                letterSpacing: "0.5px",
                textTransform: "uppercase",
                marginBottom: 4,
              }}
            >
              Total Revenue
            </div>
            <div
              style={{
                fontFamily: "Cormorant Garamond,serif",
                fontSize: 26,
                fontWeight: 600,
                color: "var(--teal)",
                lineHeight: 1,
              }}
            >
              Rs. {total.toLocaleString("en-IN")}
            </div>
            <div
              style={{ fontSize: 11, color: "var(--gray-400)", marginTop: 2 }}
            >
              {visits.length} visit{visits.length !== 1 ? "s" : ""}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              alignSelf: "flex-start",
              marginTop: 4,
            }}
          >
            <button className="admin-del-btn" onClick={deletePatient}>
              🗑️ Delete Profile
            </button>
          </div>
        </div>

        {/* Add Visit Form — original simple layout */}
        <div className="add-visit-form">
          <h4>📋 Add New Visit Record</h4>
          <div className="add-visit-grid">
            <div>
              <div className="admin-row-label">Visit Date *</div>
              <input
                type="date"
                value={visitForm.date}
                onChange={(e) =>
                  setVisitForm((f) => ({ ...f, date: e.target.value }))
                }
              />
            </div>
            <div>
              <div className="admin-row-label">Visit Time</div>
              <input
                type="time"
                value={visitForm.time}
                onChange={(e) =>
                  setVisitForm((f) => ({ ...f, time: e.target.value }))
                }
              />
            </div>
            <div>
              <div className="admin-row-label">Service Taken *</div>
              <select
                value={visitForm.service}
                onChange={(e) =>
                  setVisitForm((f) => ({ ...f, service: e.target.value }))
                }
              >
                <option value="">Select Service</option>
                {SERVICES_LIST.map((s) => (
                  <option key={s} value={s}>
                    {s}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <div className="admin-row-label">Amount Charged (Rs.)</div>
              <input
                type="text"
                placeholder="e.g. 2500"
                value={visitForm.amount}
                onChange={(e) =>
                  setVisitForm((f) => ({ ...f, amount: e.target.value }))
                }
              />
            </div>
            <div>
              <div
                className="admin-row-label"
                style={{ display: "flex", alignItems: "center", gap: 6 }}
              >
                Next Date to Visit
                <span
                  style={{
                    fontSize: 10,
                    color: "var(--teal)",
                    fontWeight: 400,
                    background: "rgba(13,115,119,0.08)",
                    padding: "2px 8px",
                    borderRadius: 100,
                    border: "1px solid rgba(13,115,119,0.2)",
                  }}
                >
                  For follow-up
                </span>
              </div>
              <input
                type="date"
                value={visitForm.nextVisitDate}
                onChange={(e) =>
                  setVisitForm((f) => ({ ...f, nextVisitDate: e.target.value }))
                }
                style={{ marginTop: 6 }}
              />
            </div>
          </div>

          {/* ── Prescription Table ─────────────────────────── */}
          <style>{`
            @media (max-width: 640px) { .rx-table-desktop { display: none !important; } .rx-card-mobile { display: block !important; } }
            @media (min-width: 641px) { .rx-table-desktop { display: block !important; } .rx-card-mobile { display: none !important; } }
            @keyframes micPulse { 0%,100% { box-shadow: 0 0 0 0 rgba(220,38,38,0.5); } 70% { box-shadow: 0 0 0 10px rgba(220,38,38,0); } }
            .mic-active { animation: micPulse 1.2s ease-in-out infinite; background: #dc2626 !important; border-color: #dc2626 !important; }
          `}</style>
          <div
            className="admin-row-label"
            style={{ marginBottom: 6, marginTop: 8 }}
          >
            💊 Prescription
          </div>

          {/* ── DESKTOP TABLE ── */}
          <div
            className="rx-table-desktop"
            style={{
              overflowX: "auto",
              marginBottom: 8,
              position: "relative",
              zIndex: 1000,
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: 13,
                fontFamily: "'DM Sans',sans-serif",
                minWidth: 560,
              }}
            >
              <thead>
                <tr
                  style={{
                    background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
                    color: "#fff",
                  }}
                >
                  <th
                    style={{
                      padding: "8px 10px",
                      textAlign: "left",
                      fontWeight: 600,
                      fontSize: 12,
                      width: 36,
                    }}
                  >
                    SR.
                  </th>
                  <th
                    style={{
                      padding: "8px 10px",
                      textAlign: "left",
                      fontWeight: 600,
                      fontSize: 12,
                    }}
                  >
                    MEDICINE
                  </th>
                  <th
                    style={{
                      padding: "8px 10px",
                      textAlign: "left",
                      fontWeight: 600,
                      fontSize: 12,
                    }}
                  >
                    DOSAGE INSTRUCTION
                  </th>
                  <th
                    style={{
                      padding: "8px 10px",
                      textAlign: "left",
                      fontWeight: 600,
                      fontSize: 12,
                      width: 95,
                    }}
                  >
                    DURATION
                  </th>
                  <th
                    style={{
                      padding: "8px 10px",
                      textAlign: "left",
                      fontWeight: 600,
                      fontSize: 12,
                      width: 95,
                    }}
                  >
                    ROUTE
                  </th>
                  <th style={{ padding: "8px 10px", width: 32 }}></th>
                </tr>
              </thead>
              <tbody>
                {visitForm.rxRows.map((row, idx) => (
                  <tr
                    key={idx}
                    style={{
                      background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
                      borderBottom: "1px solid #e8e4e0",
                    }}
                  >
                    <td
                      style={{
                        padding: "6px 10px",
                        color: "#666",
                        fontSize: 12,
                        textAlign: "center",
                      }}
                    >
                      {idx + 1}
                    </td>
                    <td style={{ padding: "4px 6px" }}>
                      <RxMedInput
                        value={row.medicine}
                        onChange={(v) => {
                          const rows = [...visitForm.rxRows];
                          rows[idx] = { ...rows[idx], medicine: v };
                          setVisitForm((f) => ({ ...f, rxRows: rows }));
                        }}
                        customMeds={customMeds}
                        onCustomSaved={(saved) => {
                          if (saved && saved._id) {
                            setCustomMeds((prev) => {
                              const exists = prev.some(
                                (m) =>
                                  m._id === saved._id ||
                                  m.name.toLowerCase() ===
                                    saved.name.toLowerCase(),
                              );
                              if (exists) return prev;
                              return [saved, ...prev];
                            });
                          } else {
                            api
                              .get("/custommeds")
                              .then((data) => {
                                if (Array.isArray(data)) setCustomMeds(data);
                              })
                              .catch(() => {});
                          }
                        }}
                      />
                    </td>
                    <td style={{ padding: "4px 6px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                          flexWrap: "nowrap",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          {["M", "A", "N"].map((label, li) => (
                            <div
                              key={label}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: 9,
                                  color: "#888",
                                  marginBottom: 1,
                                }}
                              >
                                {label}
                              </span>
                              <input
                                type="text"
                                maxLength={2}
                                value={
                                  (row.dosageParts || ["0", "0", "0"])[li] ||
                                  "0"
                                }
                                onFocus={(e) => {
                                  if (e.target.value === "0") e.target.select();
                                }}
                                onChange={(e) => {
                                  const rows = [...visitForm.rxRows];
                                  const parts = [
                                    ...(rows[idx].dosageParts || [
                                      "0",
                                      "0",
                                      "0",
                                    ]),
                                  ];
                                  parts[li] =
                                    e.target.value === ""
                                      ? "0"
                                      : e.target.value;
                                  rows[idx] = {
                                    ...rows[idx],
                                    dosageParts: parts,
                                    dosage:
                                      parts.join("-") +
                                      (rows[idx].dosageTiming
                                        ? " " + rows[idx].dosageTiming
                                        : ""),
                                  };
                                  setVisitForm((f) => ({ ...f, rxRows: rows }));
                                }}
                                style={{
                                  width: 28,
                                  border: "1px solid #ddd",
                                  borderRadius: 4,
                                  padding: "4px 3px",
                                  fontSize: 12,
                                  textAlign: "center",
                                  fontFamily: "'DM Sans',sans-serif",
                                }}
                              />
                            </div>
                          ))}
                        </div>
                        <select
                          value={row.dosageTiming || "after meal"}
                          onChange={(e) => {
                            const rows = [...visitForm.rxRows];
                            const parts = rows[idx].dosageParts || [
                              "0",
                              "0",
                              "0",
                            ];
                            rows[idx] = {
                              ...rows[idx],
                              dosageTiming: e.target.value,
                              dosage: parts.join("-") + " " + e.target.value,
                            };
                            setVisitForm((f) => ({ ...f, rxRows: rows }));
                          }}
                          style={{
                            border: "1px solid #ddd",
                            borderRadius: 4,
                            padding: "4px 5px",
                            fontSize: 11,
                            fontFamily: "'DM Sans',sans-serif",
                            color: "#444",
                          }}
                        >
                          <option>after meal</option>
                          <option>before meal</option>
                          <option>with meal</option>
                          <option>empty stomach</option>
                          <option>at bedtime</option>
                          <option>as directed</option>
                        </select>
                      </div>
                    </td>
                    <td style={{ padding: "4px 6px" }}>
                      <input
                        type="text"
                        placeholder="e.g. 7 days"
                        value={row.duration}
                        onChange={(e) => {
                          const rows = [...visitForm.rxRows];
                          rows[idx] = {
                            ...rows[idx],
                            duration: e.target.value,
                          };
                          setVisitForm((f) => ({ ...f, rxRows: rows }));
                        }}
                        style={{
                          width: "100%",
                          border: "1px solid #ddd",
                          borderRadius: 5,
                          padding: "5px 8px",
                          fontSize: 12,
                          fontFamily: "'DM Sans',sans-serif",
                        }}
                      />
                    </td>
                    <td style={{ padding: "4px 6px" }}>
                      <select
                        value={row.route}
                        onChange={(e) => {
                          const rows = [...visitForm.rxRows];
                          rows[idx] = { ...rows[idx], route: e.target.value };
                          setVisitForm((f) => ({ ...f, rxRows: rows }));
                        }}
                        style={{
                          width: "100%",
                          border: "1px solid #ddd",
                          borderRadius: 5,
                          padding: "5px 6px",
                          fontSize: 12,
                          fontFamily: "'DM Sans',sans-serif",
                        }}
                      >
                        <option>ORAL</option>
                        <option>TOPICAL</option>
                        <option>INJECTION</option>
                        <option>INHALER</option>
                        <option>DROPS</option>
                        <option>GARGLE</option>
                        <option>OTHER</option>
                      </select>
                    </td>
                    <td style={{ padding: "4px 6px", textAlign: "center" }}>
                      {visitForm.rxRows.length > 1 && (
                        <button
                          onClick={() => {
                            const rows = visitForm.rxRows.filter(
                              (_, i) => i !== idx,
                            );
                            setVisitForm((f) => ({ ...f, rxRows: rows }));
                          }}
                          style={{
                            background: "none",
                            border: "none",
                            color: "#e74c3c",
                            fontSize: 16,
                            cursor: "pointer",
                            padding: "2px 6px",
                          }}
                          title="Remove"
                        >
                          ✕
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* ── MOBILE CARDS ── */}
          <div className="rx-card-mobile" style={{ marginBottom: 8 }}>
            {visitForm.rxRows.map((row, idx) => (
              <div
                key={idx}
                style={{
                  background: idx % 2 === 0 ? "#f8f9fc" : "#fff",
                  border: "1px solid #e8e4e0",
                  borderRadius: 8,
                  padding: "10px 12px",
                  marginBottom: 8,
                  position: "relative",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 8,
                  }}
                >
                  <span
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: "#0a1628",
                      background: "rgba(10,22,40,0.08)",
                      padding: "2px 8px",
                      borderRadius: 20,
                    }}
                  >
                    #{idx + 1}
                  </span>
                  {visitForm.rxRows.length > 1 && (
                    <button
                      onClick={() => {
                        const rows = visitForm.rxRows.filter(
                          (_, i) => i !== idx,
                        );
                        setVisitForm((f) => ({ ...f, rxRows: rows }));
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#e74c3c",
                        fontSize: 16,
                        cursor: "pointer",
                        padding: "2px 6px",
                      }}
                      title="Remove"
                    >
                      ✕
                    </button>
                  )}
                </div>
                <div style={{ marginBottom: 8 }}>
                  <div
                    style={{
                      fontSize: 10,
                      color: "#888",
                      fontWeight: 600,
                      marginBottom: 3,
                      textTransform: "uppercase",
                    }}
                  >
                    Medicine
                  </div>
                  <RxMedInput
                    value={row.medicine}
                    onChange={(v) => {
                      const rows = [...visitForm.rxRows];
                      rows[idx] = { ...rows[idx], medicine: v };
                      setVisitForm((f) => ({ ...f, rxRows: rows }));
                    }}
                    customMeds={customMeds}
                    onCustomSaved={(saved) => {
                      if (saved && saved._id) {
                        setCustomMeds((prev) => {
                          const exists = prev.some(
                            (m) =>
                              m._id === saved._id ||
                              m.name.toLowerCase() === saved.name.toLowerCase(),
                          );
                          if (exists) return prev;
                          return [saved, ...prev];
                        });
                      } else {
                        api
                          .get("/custommeds")
                          .then((data) => {
                            if (Array.isArray(data)) setCustomMeds(data);
                          })
                          .catch(() => {});
                      }
                    }}
                  />
                </div>
                <div style={{ marginBottom: 8 }}>
                  <div
                    style={{
                      fontSize: 10,
                      color: "#888",
                      fontWeight: 600,
                      marginBottom: 3,
                      textTransform: "uppercase",
                    }}
                  >
                    Dosage Instruction
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                      flexWrap: "wrap",
                    }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 4 }}
                    >
                      {["M", "A", "N"].map((label, li) => (
                        <div
                          key={label}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              fontSize: 9,
                              color: "#888",
                              marginBottom: 1,
                            }}
                          >
                            {label}
                          </span>
                          <input
                            type="text"
                            maxLength={2}
                            value={
                              (row.dosageParts || ["0", "0", "0"])[li] || "0"
                            }
                            onFocus={(e) => {
                              if (e.target.value === "0") e.target.select();
                            }}
                            onChange={(e) => {
                              const rows = [...visitForm.rxRows];
                              const parts = [
                                ...(rows[idx].dosageParts || ["0", "0", "0"]),
                              ];
                              parts[li] =
                                e.target.value === "" ? "0" : e.target.value;
                              rows[idx] = {
                                ...rows[idx],
                                dosageParts: parts,
                                dosage:
                                  parts.join("-") +
                                  (rows[idx].dosageTiming
                                    ? " " + rows[idx].dosageTiming
                                    : ""),
                              };
                              setVisitForm((f) => ({ ...f, rxRows: rows }));
                            }}
                            style={{
                              width: 34,
                              border: "1px solid #ddd",
                              borderRadius: 4,
                              padding: "5px 3px",
                              fontSize: 13,
                              textAlign: "center",
                              fontFamily: "'DM Sans',sans-serif",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                    <select
                      value={row.dosageTiming || "after meal"}
                      onChange={(e) => {
                        const rows = [...visitForm.rxRows];
                        const parts = rows[idx].dosageParts || ["0", "0", "0"];
                        rows[idx] = {
                          ...rows[idx],
                          dosageTiming: e.target.value,
                          dosage: parts.join("-") + " " + e.target.value,
                        };
                        setVisitForm((f) => ({ ...f, rxRows: rows }));
                      }}
                      style={{
                        flex: 1,
                        border: "1px solid #ddd",
                        borderRadius: 4,
                        padding: "5px 6px",
                        fontSize: 12,
                        fontFamily: "'DM Sans',sans-serif",
                        color: "#444",
                        minWidth: 120,
                      }}
                    >
                      <option>after meal</option>
                      <option>before meal</option>
                      <option>with meal</option>
                      <option>empty stomach</option>
                      <option>at bedtime</option>
                      <option>as directed</option>
                    </select>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontSize: 10,
                        color: "#888",
                        fontWeight: 600,
                        marginBottom: 3,
                        textTransform: "uppercase",
                      }}
                    >
                      Duration
                    </div>
                    <input
                      type="text"
                      placeholder="e.g. 7 days"
                      value={row.duration}
                      onChange={(e) => {
                        const rows = [...visitForm.rxRows];
                        rows[idx] = { ...rows[idx], duration: e.target.value };
                        setVisitForm((f) => ({ ...f, rxRows: rows }));
                      }}
                      style={{
                        width: "100%",
                        border: "1px solid #ddd",
                        borderRadius: 5,
                        padding: "6px 8px",
                        fontSize: 12,
                        fontFamily: "'DM Sans',sans-serif",
                        boxSizing: "border-box",
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        fontSize: 10,
                        color: "#888",
                        fontWeight: 600,
                        marginBottom: 3,
                        textTransform: "uppercase",
                      }}
                    >
                      Route
                    </div>
                    <select
                      value={row.route}
                      onChange={(e) => {
                        const rows = [...visitForm.rxRows];
                        rows[idx] = { ...rows[idx], route: e.target.value };
                        setVisitForm((f) => ({ ...f, rxRows: rows }));
                      }}
                      style={{
                        width: "100%",
                        border: "1px solid #ddd",
                        borderRadius: 5,
                        padding: "6px 6px",
                        fontSize: 12,
                        fontFamily: "'DM Sans',sans-serif",
                      }}
                    >
                      <option>ORAL</option>
                      <option>TOPICAL</option>
                      <option>INJECTION</option>
                      <option>INHALER</option>
                      <option>DROPS</option>
                      <option>GARGLE</option>
                      <option>OTHER</option>
                    </select>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={() =>
              setVisitForm((f) => ({
                ...f,
                rxRows: [
                  ...f.rxRows,
                  {
                    medicine: "",
                    dosageParts: ["0", "0", "0"],
                    dosageTiming: "after meal",
                    dosage: "",
                    duration: "",
                    route: "ORAL",
                  },
                ],
              }))
            }
            style={{
              marginTop: 4,
              marginBottom: 8,
              background: "rgba(13,115,119,0.08)",
              border: "1px solid rgba(13,115,119,0.3)",
              color: "var(--teal)",
              borderRadius: 7,
              padding: "6px 16px",
              fontSize: 12,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "'DM Sans',sans-serif",
            }}
          >
            + Add Medicine
          </button>

          {/* ── Doctor Notes / Diagnosis — ✅ NOW WITH 🎤 MIC ───────── */}
          <div
            className="admin-row-label"
            style={{ marginBottom: 6, marginTop: 10 }}
          >
            Doctor Notes / Diagnosis
          </div>
          <MedAutocompleteWithMic
            value={visitForm.notes}
            onChange={(v) => setVisitForm((f) => ({ ...f, notes: v }))}
            customMeds={customMeds}
            onCustomSaved={(saved) => {
              if (saved && saved._id) {
                setCustomMeds((prev) => {
                  const exists = prev.some(
                    (m) =>
                      m._id === saved._id ||
                      m.name.toLowerCase() === saved.name.toLowerCase(),
                  );
                  if (exists) return prev;
                  return [saved, ...prev];
                });
              } else {
                api
                  .get("/custommeds")
                  .then((data) => {
                    if (Array.isArray(data)) setCustomMeds(data);
                  })
                  .catch(() => {});
              }
            }}
          />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 10,
              marginTop: 4,
            }}
          >
            <button className="add-visit-save-btn" onClick={saveVisit}>
              💾 Save Visit Record
            </button>
          </div>
        </div>

        {/* Visit History */}
        <div style={{ marginBottom: 12 }}>
          <div className="admin-section-title" style={{ marginBottom: 8 }}>
            Visit History
          </div>
          <div className="visit-records-list">
            {visits.length === 0 ? (
              <div
                style={{
                  color: "var(--gray-400)",
                  fontSize: 13,
                  padding: "10px 0",
                }}
              >
                No visits recorded yet. Add the first visit above.
              </div>
            ) : (
              visits.map((v, i) => {
                const dtStr =
                  (v.visitDate || "") +
                  (v.visitTime ? " at " + v.visitTime : "");
                const isFollowUp = /follow[\s\-]?up/i.test(v.notes || "");
                return (
                  <div key={v._id || i} className="visit-record-card">
                    <button
                      className="visit-del-btn"
                      onClick={() => deleteVisit(v._id)}
                      title="Delete"
                    >
                      ✕
                    </button>
                    <div className="visit-record-meta">
                      <span className="visit-record-service">
                        {v.service || "Visit"}
                      </span>
                      <span className="visit-record-date">📅 {dtStr}</span>
                      {v.amount && (
                        <span
                          className="patient-info-pill"
                          style={{ fontSize: 11 }}
                        >
                          Rs. {v.amount}
                        </span>
                      )}
                      {v.doctor && (
                        <span
                          style={{
                            fontSize: 11,
                            color: "var(--teal)",
                            fontWeight: 600,
                            background: "rgba(13,115,119,0.08)",
                            padding: "2px 8px",
                            borderRadius: 100,
                            border: "1px solid rgba(13,115,119,0.2)",
                          }}
                        >
                          👨‍⚕️ {v.doctor}
                        </span>
                      )}
                    </div>
                    <div className="visit-record-notes">{v.notes || "—"}</div>
                    {v.prescription &&
                      v.prescription.medicineRows &&
                      v.prescription.medicineRows.length > 0 && (
                        <div style={{ marginTop: 10, overflowX: "auto" }}>
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                              fontSize: 12,
                              fontFamily: "'DM Sans',sans-serif",
                            }}
                          >
                            <thead>
                              <tr
                                style={{
                                  background:
                                    "linear-gradient(135deg,#0a1628,#1a3a6b)",
                                  color: "#fff",
                                }}
                              >
                                <th
                                  style={{
                                    padding: "6px 8px",
                                    textAlign: "left",
                                    fontWeight: 600,
                                    fontSize: 11,
                                    width: 30,
                                  }}
                                >
                                  SR.
                                </th>
                                <th
                                  style={{
                                    padding: "6px 8px",
                                    textAlign: "left",
                                    fontWeight: 600,
                                    fontSize: 11,
                                  }}
                                >
                                  MEDICINE
                                </th>
                                <th
                                  style={{
                                    padding: "6px 8px",
                                    textAlign: "left",
                                    fontWeight: 600,
                                    fontSize: 11,
                                  }}
                                >
                                  DOSAGE INSTRUCTION
                                </th>
                                <th
                                  style={{
                                    padding: "6px 8px",
                                    textAlign: "left",
                                    fontWeight: 600,
                                    fontSize: 11,
                                    width: 90,
                                  }}
                                >
                                  DUR. / ROUTE
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {v.prescription.medicineRows.map((row, ri) => (
                                <tr
                                  key={ri}
                                  style={{
                                    background:
                                      ri % 2 === 0 ? "#f8f9fc" : "#fff",
                                    borderBottom: "1px solid #e8e4e0",
                                  }}
                                >
                                  <td
                                    style={{
                                      padding: "5px 8px",
                                      color: "#666",
                                      fontSize: 11,
                                      textAlign: "center",
                                    }}
                                  >
                                    {ri + 1}.
                                  </td>
                                  <td
                                    style={{
                                      padding: "5px 8px",
                                      fontWeight: 600,
                                      color: "#0a1628",
                                    }}
                                  >
                                    {row.medicine || "—"}
                                  </td>
                                  <td
                                    style={{
                                      padding: "5px 8px",
                                      color: "#444",
                                    }}
                                  >
                                    {row.dosage || "—"}
                                  </td>
                                  <td
                                    style={{
                                      padding: "5px 8px",
                                      color: "#666",
                                      fontSize: 11,
                                    }}
                                  >
                                    {row.duration}
                                    {row.duration && row.route ? " / " : ""}
                                    {row.route}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    {v.nextVisitDate && (
                      <div
                        style={{
                          marginTop: 8,
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 6,
                          background: isFollowUp
                            ? "rgba(201,168,76,0.12)"
                            : "rgba(13,115,119,0.08)",
                          border:
                            "1px solid " +
                            (isFollowUp
                              ? "rgba(201,168,76,0.35)"
                              : "rgba(13,115,119,0.2)"),
                          borderRadius: 100,
                          padding: "3px 12px",
                          fontSize: 12,
                          fontWeight: 500,
                          color: isFollowUp ? "#8b6914" : "var(--teal)",
                        }}
                      >
                        {isFollowUp ? "Follow-Up: " : "Next Visit: "}
                        {fmtDateShort(v.nextVisitDate)}
                        {isFollowUp ? " — WhatsApp sent" : ""}
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        marginTop: 10,
                        flexWrap: "wrap",
                      }}
                    >
                      <button
                        onClick={() => sendPrescription(v)}
                        style={{
                          background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
                          color: "white",
                          border: "none",
                          borderRadius: 7,
                          padding: "7px 14px",
                          fontSize: 12,
                          fontWeight: 500,
                          cursor: "pointer",
                          fontFamily: "'DM Sans',sans-serif",
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                          transition: "opacity 0.2s",
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.opacity = "0.85")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.opacity = "1")
                        }
                      >
                        <svg
                          width="13"
                          height="13"
                          viewBox="0 0 24 24"
                          fill="white"
                        >
                          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                          <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
                        </svg>
                        Send Prescription
                      </button>
                      <button
                        onClick={() => {
                          let mob = (p.mobile || "").replace(
                            /[\s\-\(\)\+]/g,
                            "",
                          );
                          if (!mob) {
                            alert("No mobile number saved for this patient.");
                            return;
                          }
                          if (!mob.startsWith("91") && mob.length === 10)
                            mob = "91" + mob;
                          const msg = encodeURIComponent(
                            ` *Welcome to PearlSmile Dental Hospital!*\n\nDear ${p.name},\n\nWe warmly welcome you to our family. It is a pleasure to have you with us.\n\nWe are committed to providing you the best dental care and a comfortable experience throughout your journey with us.\n\n_Wishing you great health and a beautiful smile!_\n— *PearlSmile Dental Hospital Team*`,
                          );
                          window.open(
                            "https://wa.me/" + mob + "?text=" + msg,
                            "_blank",
                          );
                        }}
                        style={{
                          background: "linear-gradient(135deg,#25d366,#128c7e)",
                          color: "white",
                          border: "none",
                          borderRadius: 7,
                          padding: "7px 14px",
                          fontSize: 12,
                          fontWeight: 500,
                          cursor: "pointer",
                          fontFamily: "'DM Sans',sans-serif",
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                          transition: "opacity 0.2s",
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.opacity = "0.85")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.opacity = "1")
                        }
                      >
                        <svg
                          width="13"
                          height="13"
                          viewBox="0 0 24 24"
                          fill="white"
                        >
                          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                          <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.556 4.126 1.526 5.857L0 24l6.335-1.508A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.807 9.807 0 0 1-5.028-1.382l-.36-.214-3.732.888.939-3.618-.235-.372A9.808 9.808 0 0 1 2.182 12C2.182 6.57 6.57 2.182 12 2.182S21.818 6.57 21.818 12 17.43 21.818 12 21.818z" />
                        </svg>
                        Patient Number
                      </button>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>

        {/* ✅ NEW: Lab Reports Section */}
        <div style={{ marginBottom: 24 }}>
          <div className="admin-section-title" style={{ marginBottom: 8 }}>
            🧪 Lab Reports
          </div>
          <div style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
            Upload patient lab reports by pasting a public file URL (Google
            Drive, Dropbox, etc). Saved permanently to this patient profile.
          </div>
          {/* Add Report Form */}
          <div
            style={{
              background: "#f8fafc",
              border: "1.5px solid #e2e8f0",
              borderRadius: 12,
              padding: 16,
              marginBottom: 16,
            }}
          >
            {/* Row 1: Report Name */}
            <div style={{ marginBottom: 12 }}>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#475569",
                  marginBottom: 4,
                }}
              >
                Report Name *
              </div>
              <input
                type="text"
                placeholder="e.g. Blood Report, X-Ray, OPG"
                value={labName}
                onChange={(e) => setLabName(e.target.value)}
                style={{
                  width: "100%",
                  padding: "9px 12px",
                  borderRadius: 8,
                  border: "1.5px solid #e2e8f0",
                  fontSize: 13,
                  fontFamily: "DM Sans,sans-serif",
                  outline: "none",
                  background: "#fff",
                  boxSizing: "border-box",
                }}
              />
            </div>
            {/* Row 2: File Upload OR URL */}
            <div style={{ marginBottom: 12 }}>
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#475569",
                  marginBottom: 8,
                }}
              >
                Attach File or Paste URL *
              </div>
              {/* File Upload Button */}
              <div
                style={{
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                  marginBottom: 8,
                  flexWrap: "wrap",
                }}
              >
                <label
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 7,
                    padding: "9px 16px",
                    background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
                    color: "#fff",
                    borderRadius: 8,
                    fontSize: 13,
                    fontWeight: 600,
                    cursor: "pointer",
                    fontFamily: "DM Sans,sans-serif",
                    whiteSpace: "nowrap",
                  }}
                >
                  📎 Upload File
                  <input
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (!file) return;
                      // Auto-fill report name from filename if empty
                      if (!labName.trim()) {
                        setLabName(file.name.replace(/\.[^/.]+$/, ""));
                      }
                      setLabUploading(true);
                      setLabUrl(""); // clear URL field
                      // Convert to base64 data URL for preview; store as data URL
                      const reader = new FileReader();
                      reader.onload = (ev) => {
                        setLabUrl(ev.target.result);
                        setLabUploading(false);
                      };
                      reader.onerror = () => {
                        showNotify("Error", "Could not read file.", true);
                        setLabUploading(false);
                      };
                      reader.readAsDataURL(file);
                    }}
                  />
                </label>
                <span style={{ fontSize: 12, color: "#94a3b8" }}>
                  or paste a public link below
                </span>
              </div>
              {/* URL Input */}
              <input
                type="url"
                placeholder="https://drive.google.com/file/d/... or https://cloudinary.com/..."
                value={labUrl.startsWith("data:") ? "" : labUrl}
                onChange={(e) => setLabUrl(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") saveLabReport();
                }}
                disabled={labUrl.startsWith("data:")}
                style={{
                  width: "100%",
                  padding: "9px 12px",
                  borderRadius: 8,
                  border: "1.5px solid #e2e8f0",
                  fontSize: 13,
                  fontFamily: "DM Sans,sans-serif",
                  outline: "none",
                  background: labUrl.startsWith("data:") ? "#f1f5f9" : "#fff",
                  boxSizing: "border-box",
                  color: labUrl.startsWith("data:") ? "#94a3b8" : "#0a1628",
                }}
              />
              {/* File preview strip */}
              {labUrl.startsWith("data:") && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    marginTop: 8,
                    background: "#f0fdf4",
                    border: "1px solid #86efac",
                    borderRadius: 8,
                    padding: "8px 12px",
                  }}
                >
                  <span style={{ fontSize: 18 }}>
                    {labUrl.startsWith("data:image") ? "🖼️" : "📄"}
                  </span>
                  <span
                    style={{
                      fontSize: 12,
                      color: "#16a34a",
                      fontWeight: 600,
                      flex: 1,
                    }}
                  >
                    File loaded and ready to save
                  </span>
                  <button
                    onClick={() => {
                      setLabUrl("");
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#dc2626",
                      cursor: "pointer",
                      fontSize: 13,
                      fontWeight: 600,
                    }}
                  >
                    ✕ Remove
                  </button>
                </div>
              )}
            </div>
            {/* Save Button */}
            <button
              onClick={saveLabReport}
              disabled={labSaving || labUploading}
              style={{
                padding: "10px 22px",
                background:
                  labSaving || labUploading
                    ? "#94a3b8"
                    : "linear-gradient(135deg,#0d7377,#14a0a5)",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                fontSize: 13,
                fontWeight: 700,
                cursor: labSaving || labUploading ? "not-allowed" : "pointer",
                fontFamily: "DM Sans,sans-serif",
              }}
            >
              {labUploading
                ? "⏳ Loading file..."
                : labSaving
                  ? "Saving..."
                  : "💾 Save Report"}
            </button>
            <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 8 }}>
              💡 Upload: PDF, images, Word, Excel (stored in this browser
              session). For permanent cloud storage paste a Google Drive /
              Cloudinary public link.
            </div>
          </div>
          {/* Lab Reports List */}
          {labReports.length === 0 ? (
            <div style={{ color: "#94a3b8", fontSize: 13, padding: "12px 0" }}>
              No lab reports saved yet. Add the first report above.
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {labReports.map((report, i) => (
                <div
                  key={report._id || i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    background: "#fff",
                    border: "1.5px solid #e2e8f0",
                    borderRadius: 10,
                    padding: "12px 16px",
                  }}
                >
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      background: "rgba(13,115,119,0.08)",
                      borderRadius: 8,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 20,
                      flexShrink: 0,
                    }}
                  >
                    🧪
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: 14,
                        color: "#0a1628",
                        marginBottom: 2,
                      }}
                    >
                      {report.name}
                    </div>
                    <div style={{ fontSize: 11, color: "#94a3b8" }}>
                      {report.uploadedAt
                        ? new Date(report.uploadedAt).toLocaleDateString(
                            "en-IN",
                            { day: "numeric", month: "short", year: "numeric" },
                          )
                        : ""}
                    </div>
                  </div>
                  <a
                    href={report.url}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      padding: "7px 14px",
                      background: "rgba(13,115,119,0.08)",
                      color: "#0d7377",
                      border: "1px solid rgba(13,115,119,0.2)",
                      borderRadius: 8,
                      fontSize: 12,
                      fontWeight: 600,
                      textDecoration: "none",
                      whiteSpace: "nowrap",
                    }}
                  >
                    🔗 View Report
                  </a>
                  <button
                    onClick={() => deleteLabReport(report._id)}
                    style={{
                      padding: "7px 10px",
                      background: "#fef2f2",
                      color: "#dc2626",
                      border: "1px solid #fca5a5",
                      borderRadius: 8,
                      fontSize: 12,
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                    }}
                  >
                    🗑️ Delete
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {rxModal && (
        <PrescriptionModal
          visit={rxModal.visit}
          patient={rxModal.patient}
          doctor={rxModal.doctor}
          onClose={() => setRxModal(null)}
          showNotify={showNotify}
        />
      )}
    </div>
  );
}

// ── Medicine Database ─────────────────────────────────────────
const MEDICINE_DB = [
  { name: "Amoxicillin 250mg Capsule", cat: "Antibiotic" },
  { name: "Amoxicillin 500mg Capsule", cat: "Antibiotic" },
  { name: "Amoxicillin 875mg Tablet", cat: "Antibiotic" },
  { name: "Amoxicillin 125mg/5ml Syrup", cat: "Antibiotic" },
  { name: "Amoxicillin 250mg/5ml Syrup", cat: "Antibiotic" },
  { name: "Amoxicillin + Clavulanate 375mg Tablet", cat: "Antibiotic" },
  { name: "Amoxicillin + Clavulanate 625mg Tablet", cat: "Antibiotic" },
  { name: "Amoxicillin + Clavulanate 1000mg Tablet", cat: "Antibiotic" },
  { name: "Amoxicillin + Clavulanate 228.5mg/5ml Syrup", cat: "Antibiotic" },
  { name: "Azithromycin 250mg Tablet", cat: "Antibiotic" },
  { name: "Azithromycin 500mg Tablet", cat: "Antibiotic" },
  { name: "Azithromycin 200mg/5ml Syrup", cat: "Antibiotic" },
  { name: "Clindamycin 150mg Capsule", cat: "Antibiotic" },
  { name: "Clindamycin 300mg Capsule", cat: "Antibiotic" },
  { name: "Clindamycin 600mg Injection", cat: "Antibiotic Inj" },
  { name: "Metronidazole 200mg Tablet", cat: "Antibiotic" },
  { name: "Metronidazole 400mg Tablet", cat: "Antibiotic" },
  { name: "Metronidazole 500mg Tablet", cat: "Antibiotic" },
  { name: "Metronidazole 200mg/5ml Syrup", cat: "Antibiotic" },
  { name: "Metronidazole 500mg Infusion", cat: "Antibiotic Inj" },
  { name: "Ciprofloxacin 250mg Tablet", cat: "Antibiotic" },
  { name: "Ciprofloxacin 500mg Tablet", cat: "Antibiotic" },
  { name: "Ciprofloxacin 750mg Tablet", cat: "Antibiotic" },
  { name: "Ciprofloxacin 200mg/100ml Infusion", cat: "Antibiotic Inj" },
  { name: "Doxycycline 100mg Capsule", cat: "Antibiotic" },
  { name: "Doxycycline 200mg Tablet", cat: "Antibiotic" },
  { name: "Erythromycin 250mg Tablet", cat: "Antibiotic" },
  { name: "Erythromycin 500mg Tablet", cat: "Antibiotic" },
  { name: "Tinidazole 500mg Tablet", cat: "Antibiotic" },
  { name: "Ornidazole 500mg Tablet", cat: "Antibiotic" },
  { name: "Secnidazole 500mg Tablet", cat: "Antibiotic" },
  { name: "Co-Amoxiclav 375mg Tablet", cat: "Antibiotic" },
  { name: "Co-Amoxiclav 625mg Tablet", cat: "Antibiotic" },
  { name: "Levofloxacin 250mg Tablet", cat: "Antibiotic" },
  { name: "Levofloxacin 500mg Tablet", cat: "Antibiotic" },
  { name: "Levofloxacin 750mg Tablet", cat: "Antibiotic" },
  { name: "Ofloxacin 200mg Tablet", cat: "Antibiotic" },
  { name: "Ofloxacin 400mg Tablet", cat: "Antibiotic" },
  { name: "Cephalexin 250mg Capsule", cat: "Antibiotic" },
  { name: "Cephalexin 500mg Capsule", cat: "Antibiotic" },
  { name: "Cefixime 100mg Tablet", cat: "Antibiotic" },
  { name: "Cefixime 200mg Tablet", cat: "Antibiotic" },
  { name: "Cefixime 400mg Tablet", cat: "Antibiotic" },
  { name: "Cefixime 50mg/5ml Syrup", cat: "Antibiotic" },
  { name: "Cefuroxime 250mg Tablet", cat: "Antibiotic" },
  { name: "Cefuroxime 500mg Tablet", cat: "Antibiotic" },
  { name: "Cefpodoxime 100mg Tablet", cat: "Antibiotic" },
  { name: "Cefpodoxime 200mg Tablet", cat: "Antibiotic" },
  { name: "Ceftriaxone 250mg Injection", cat: "Antibiotic Inj" },
  { name: "Ceftriaxone 500mg Injection", cat: "Antibiotic Inj" },
  { name: "Ceftriaxone 1g Injection", cat: "Antibiotic Inj" },
  { name: "Ceftriaxone 2g Injection", cat: "Antibiotic Inj" },
  { name: "Amikacin 250mg Injection", cat: "Antibiotic Inj" },
  { name: "Amikacin 500mg Injection", cat: "Antibiotic Inj" },
  { name: "Gentamicin 40mg Injection", cat: "Antibiotic Inj" },
  { name: "Gentamicin 80mg Injection", cat: "Antibiotic Inj" },
  { name: "Vancomycin 500mg Injection", cat: "Antibiotic Inj" },
  { name: "Vancomycin 1g Injection", cat: "Antibiotic Inj" },
  { name: "Meropenem 500mg Injection", cat: "Antibiotic Inj" },
  { name: "Meropenem 1g Injection", cat: "Antibiotic Inj" },
  { name: "Piperacillin + Tazobactam 4.5g Injection", cat: "Antibiotic Inj" },
  { name: "Imipenem + Cilastatin 500mg Injection", cat: "Antibiotic Inj" },
  { name: "Linezolid 600mg Tablet", cat: "Antibiotic" },
  { name: "Linezolid 600mg Infusion", cat: "Antibiotic Inj" },
  { name: "Colistin 1 MU Injection", cat: "Antibiotic Inj" },
  { name: "Tetracycline 250mg Capsule", cat: "Antibiotic" },
  { name: "Tetracycline 500mg Capsule", cat: "Antibiotic" },
  { name: "Chloramphenicol 250mg Capsule", cat: "Antibiotic" },
  { name: "Ampicillin 250mg Capsule", cat: "Antibiotic" },
  { name: "Ampicillin 500mg Capsule", cat: "Antibiotic" },
  { name: "Ampicillin + Sulbactam 1.5g Injection", cat: "Antibiotic Inj" },
  { name: "Nitrofurantoin 50mg Capsule", cat: "Antibiotic" },
  { name: "Nitrofurantoin 100mg Capsule", cat: "Antibiotic" },
  { name: "Norfloxacin 400mg Tablet", cat: "Antibiotic" },
  { name: "Trimethoprim + Sulfamethoxazole 480mg Tablet", cat: "Antibiotic" },
  { name: "Trimethoprim + Sulfamethoxazole 960mg Tablet", cat: "Antibiotic" },
  { name: "Cefoperazone + Sulbactam 1.5g Injection", cat: "Antibiotic Inj" },
  { name: "Cefoperazone + Sulbactam 3g Injection", cat: "Antibiotic Inj" },
  { name: "Ertapenem 1g Injection", cat: "Antibiotic Inj" },
  { name: "Tigecycline 50mg Injection", cat: "Antibiotic Inj" },
  { name: "Fosfomycin 3g Sachet", cat: "Antibiotic" },
  { name: "Rifampicin 150mg Capsule", cat: "Antibiotic" },
  { name: "Rifampicin 300mg Capsule", cat: "Antibiotic" },
  { name: "Isoniazid 100mg Tablet", cat: "Antibiotic" },
  { name: "Isoniazid 300mg Tablet", cat: "Antibiotic" },
  { name: "Pyrazinamide 500mg Tablet", cat: "Antibiotic" },
  { name: "Ethambutol 400mg Tablet", cat: "Antibiotic" },
  { name: "Streptomycin 1g Injection", cat: "Antibiotic Inj" },
  { name: "Paracetamol 325mg Tablet", cat: "Painkiller" },
  { name: "Paracetamol 500mg Tablet", cat: "Painkiller" },
  { name: "Paracetamol 650mg Tablet", cat: "Painkiller" },
  { name: "Paracetamol 1000mg Tablet", cat: "Painkiller" },
  { name: "Paracetamol 120mg/5ml Syrup", cat: "Painkiller" },
  { name: "Paracetamol 250mg/5ml Syrup", cat: "Painkiller" },
  { name: "Paracetamol 150mg/ml Drops", cat: "Painkiller" },
  { name: "Paracetamol 500mg/100ml Infusion", cat: "Painkiller Inj" },
  { name: "Ibuprofen 200mg Tablet", cat: "NSAID" },
  { name: "Ibuprofen 400mg Tablet", cat: "NSAID" },
  { name: "Ibuprofen 600mg Tablet", cat: "NSAID" },
  { name: "Ibuprofen 100mg/5ml Syrup", cat: "NSAID" },
  { name: "Diclofenac 50mg Tablet", cat: "NSAID" },
  { name: "Diclofenac 75mg Tablet", cat: "NSAID" },
  { name: "Diclofenac 100mg SR Tablet", cat: "NSAID" },
  { name: "Diclofenac 75mg Injection", cat: "NSAID Inj" },
  { name: "Ketorolac 10mg Tablet", cat: "NSAID" },
  { name: "Ketorolac 30mg Injection", cat: "NSAID Inj" },
  { name: "Naproxen 250mg Tablet", cat: "NSAID" },
  { name: "Naproxen 500mg Tablet", cat: "NSAID" },
  { name: "Mefenamic Acid 250mg Tablet", cat: "NSAID" },
  { name: "Mefenamic Acid 500mg Tablet", cat: "NSAID" },
  { name: "Nimesulide 100mg Tablet", cat: "NSAID" },
  { name: "Piroxicam 10mg Tablet", cat: "NSAID" },
  { name: "Piroxicam 20mg Tablet", cat: "NSAID" },
  { name: "Etoricoxib 60mg Tablet", cat: "NSAID" },
  { name: "Etoricoxib 90mg Tablet", cat: "NSAID" },
  { name: "Etoricoxib 120mg Tablet", cat: "NSAID" },
  { name: "Celecoxib 100mg Capsule", cat: "NSAID" },
  { name: "Celecoxib 200mg Capsule", cat: "NSAID" },
  { name: "Aceclofenac 100mg Tablet", cat: "NSAID" },
  { name: "Aceclofenac + Paracetamol Tablet", cat: "NSAID Combo" },
  { name: "Tramadol 50mg Capsule", cat: "Opioid Analgesic" },
  { name: "Tramadol 100mg SR Tablet", cat: "Opioid Analgesic" },
  { name: "Tramadol 50mg Injection", cat: "Opioid Analgesic Inj" },
  { name: "Tramadol + Paracetamol Tablet", cat: "Analgesic Combo" },
  { name: "Morphine 10mg Injection", cat: "Opioid Analgesic Inj" },
  { name: "Morphine 15mg Tablet", cat: "Opioid Analgesic" },
  { name: "Fentanyl 50mcg/ml Injection", cat: "Opioid Analgesic Inj" },
  { name: "Pentazocine 30mg Injection", cat: "Opioid Analgesic Inj" },
  { name: "Pethidine 50mg Injection", cat: "Opioid Analgesic Inj" },
  { name: "Buprenorphine 0.3mg Injection", cat: "Opioid Analgesic Inj" },
  { name: "Tapentadol 50mg Tablet", cat: "Opioid Analgesic" },
  { name: "Tapentadol 100mg Tablet", cat: "Opioid Analgesic" },
  { name: "Lignocaine 2% Dental Cartridge (1.8ml)", cat: "Local Anaesthetic" },
  {
    name: "Lignocaine + Adrenaline 2% Dental Cartridge",
    cat: "Local Anaesthetic",
  },
  {
    name: "Articaine 4% + Adrenaline 1:100000 Cartridge",
    cat: "Local Anaesthetic",
  },
  {
    name: "Articaine 4% + Adrenaline 1:200000 Cartridge",
    cat: "Local Anaesthetic",
  },
  { name: "Bupivacaine 0.5% Injection", cat: "Local Anaesthetic" },
  { name: "Bupivacaine 0.5% Heavy Spinal Injection", cat: "Local Anaesthetic" },
  { name: "Mepivacaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
  { name: "Prilocaine 3% Dental Cartridge", cat: "Local Anaesthetic" },
  { name: "Lignocaine 2% Plain Injection 30ml Vial", cat: "Local Anaesthetic" },
  {
    name: "Lignocaine 2% + Adrenaline Injection Vial",
    cat: "Local Anaesthetic",
  },
  { name: "Lignocaine 10% Topical Spray", cat: "Local Anaesthetic Topical" },
  { name: "Lignocaine 2% Viscous Gel", cat: "Local Anaesthetic Topical" },
  { name: "Lignocaine 5% Ointment", cat: "Local Anaesthetic Topical" },
  { name: "Benzocaine 20% Topical Gel", cat: "Local Anaesthetic Topical" },
  {
    name: "EMLA Cream (Lignocaine + Prilocaine)",
    cat: "Local Anaesthetic Topical",
  },
  { name: "Xylocaine Jelly 2%", cat: "Local Anaesthetic Topical" },
  { name: "Ropivacaine 0.2% Injection", cat: "Local Anaesthetic" },
  { name: "Ropivacaine 0.75% Injection", cat: "Local Anaesthetic" },
  {
    name: "Tetracaine (Amethocaine) Eye Drops",
    cat: "Local Anaesthetic Topical",
  },
  { name: "Propofol 10mg/ml Injection", cat: "General Anaesthesia" },
  { name: "Ketamine 500mg Injection", cat: "General Anaesthesia" },
  { name: "Ketamine 10mg/ml Injection", cat: "General Anaesthesia" },
  { name: "Thiopentone Sodium 500mg Injection", cat: "General Anaesthesia" },
  { name: "Midazolam 1mg/ml Injection", cat: "Sedative / Anaesthesia" },
  { name: "Midazolam 5mg/ml Injection", cat: "Sedative / Anaesthesia" },
  { name: "Midazolam 7.5mg Tablet", cat: "Sedative" },
  { name: "Isoflurane Inhalation", cat: "Inhalation Anaesthetic" },
  { name: "Sevoflurane Inhalation", cat: "Inhalation Anaesthetic" },
  { name: "Desflurane Inhalation", cat: "Inhalation Anaesthetic" },
  { name: "Nitrous Oxide Gas", cat: "Inhalation Anaesthetic" },
  { name: "Oxygen Gas Cylinder", cat: "Medical Gas" },
  { name: "Succinylcholine 100mg Injection", cat: "Muscle Relaxant" },
  { name: "Vecuronium 4mg Injection", cat: "Muscle Relaxant" },
  { name: "Atracurium 25mg Injection", cat: "Muscle Relaxant" },
  { name: "Rocuronium 50mg Injection", cat: "Muscle Relaxant" },
  { name: "Neostigmine 0.5mg Injection", cat: "Reversal Agent" },
  { name: "Atropine 0.6mg Injection", cat: "Anticholinergic" },
  { name: "Glycopyrrolate 0.2mg Injection", cat: "Anticholinergic" },
  { name: "Dexamethasone 0.5mg Tablet", cat: "Steroid" },
  { name: "Dexamethasone 4mg Tablet", cat: "Steroid" },
  { name: "Dexamethasone 4mg Injection", cat: "Steroid Inj" },
  { name: "Dexamethasone 8mg Injection", cat: "Steroid Inj" },
  { name: "Betamethasone 0.5mg Tablet", cat: "Steroid" },
  { name: "Prednisolone 5mg Tablet", cat: "Steroid" },
  { name: "Prednisolone 10mg Tablet", cat: "Steroid" },
  { name: "Prednisolone 20mg Tablet", cat: "Steroid" },
  { name: "Prednisolone 40mg Tablet", cat: "Steroid" },
  { name: "Methylprednisolone 4mg Tablet", cat: "Steroid" },
  { name: "Methylprednisolone 16mg Tablet", cat: "Steroid" },
  { name: "Methylprednisolone 40mg Injection", cat: "Steroid Inj" },
  { name: "Methylprednisolone 125mg Injection", cat: "Steroid Inj" },
  { name: "Hydrocortisone 100mg Injection", cat: "Steroid Inj" },
  { name: "Triamcinolone 10mg Injection", cat: "Steroid Inj" },
  { name: "Triamcinolone Acetonide 0.1% Oral Paste", cat: "Steroid Topical" },
  { name: "Kenacort 0.1% Dental Paste", cat: "Steroid Topical" },
  { name: "Betamethasone Gel Oral 0.025%", cat: "Steroid Topical" },
  { name: "Fluconazole 50mg Capsule", cat: "Antifungal" },
  { name: "Fluconazole 100mg Capsule", cat: "Antifungal" },
  { name: "Fluconazole 150mg Capsule", cat: "Antifungal" },
  { name: "Fluconazole 200mg Capsule", cat: "Antifungal" },
  { name: "Fluconazole 2mg/ml Infusion", cat: "Antifungal Inj" },
  { name: "Itraconazole 100mg Capsule", cat: "Antifungal" },
  { name: "Voriconazole 200mg Tablet", cat: "Antifungal" },
  { name: "Amphotericin B 50mg Injection", cat: "Antifungal Inj" },
  { name: "Clotrimazole 1% Oral Gel", cat: "Antifungal Topical" },
  { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
  { name: "Nystatin 100000 IU/ml Oral Drops", cat: "Antifungal" },
  { name: "Nystatin 500000 IU Tablet", cat: "Antifungal" },
  { name: "Clotrimazole + Betamethasone Cream", cat: "Antifungal Topical" },
  { name: "Ketoconazole 200mg Tablet", cat: "Antifungal" },
  { name: "Ketoconazole 2% Shampoo", cat: "Antifungal Topical" },
  { name: "Terbinafine 250mg Tablet", cat: "Antifungal" },
  { name: "Acyclovir 200mg Tablet", cat: "Antiviral" },
  { name: "Acyclovir 400mg Tablet", cat: "Antiviral" },
  { name: "Acyclovir 800mg Tablet", cat: "Antiviral" },
  { name: "Acyclovir 5% Cream", cat: "Antiviral Topical" },
  { name: "Acyclovir 250mg Injection", cat: "Antiviral Inj" },
  { name: "Valacyclovir 500mg Tablet", cat: "Antiviral" },
  { name: "Valacyclovir 1000mg Tablet", cat: "Antiviral" },
  { name: "Famciclovir 250mg Tablet", cat: "Antiviral" },
  { name: "Oseltamivir 75mg Capsule", cat: "Antiviral" },
  { name: "Chlorhexidine Gluconate 0.2% Mouthwash", cat: "Dental Antiseptic" },
  { name: "Chlorhexidine Gluconate 0.12% Mouthwash", cat: "Dental Antiseptic" },
  { name: "Chlorhexidine 1% Gel (Gum Gel)", cat: "Dental Antiseptic" },
  { name: "Povidone Iodine 5% Mouthwash / Gargle", cat: "Dental Antiseptic" },
  { name: "Povidone Iodine 10% Solution", cat: "Antiseptic" },
  { name: "Povidone Iodine 5% Ointment", cat: "Antiseptic Topical" },
  { name: "Hydrogen Peroxide 3% Solution", cat: "Dental Antiseptic" },
  { name: "Hydrogen Peroxide 1.5% Mouthwash", cat: "Dental Antiseptic" },
  {
    name: "Benzydamine Hydrochloride 0.15% Mouthwash",
    cat: "Dental Analgesic Rinse",
  },
  { name: "Hexetidine 0.1% Mouthwash", cat: "Dental Antiseptic" },
  { name: "Sodium Fluoride 0.05% Mouthwash", cat: "Fluoride Rinse" },
  { name: "Sodium Fluoride Varnish 5%", cat: "Fluoride Varnish" },
  { name: "Fluoride Gel APF 1.23%", cat: "Fluoride Gel" },
  { name: "Silver Diamine Fluoride 38%", cat: "Dental Fluoride" },
  { name: "Aloe Vera Gel Oral", cat: "Oral Care" },
  { name: "Hyaluronic Acid Gel 0.2% Oral", cat: "Oral Care" },
  { name: "Triclosan Toothpaste", cat: "Dental Brand" },
  { name: "Sensodyne Toothpaste", cat: "Dental Brand" },
  { name: "Colgate Total Toothpaste", cat: "Dental Brand" },
  { name: "Pepsodent Toothpaste", cat: "Dental Brand" },
  { name: "Emoform Toothpaste", cat: "Dental Brand" },
  { name: "Thermoseal Toothpaste", cat: "Dental Brand" },
  { name: "Himalaya HiOra Toothpaste", cat: "Dental Brand" },
  { name: "Dabur Red Toothpaste", cat: "Dental Brand" },
  { name: "Meswak Toothpaste", cat: "Dental Brand" },
  { name: "Oral-B Electric Toothbrush Head", cat: "Dental Accessory" },
  { name: "Interdental Brush", cat: "Dental Accessory" },
  { name: "Dental Floss", cat: "Dental Accessory" },
  { name: "Tongue Cleaner", cat: "Dental Accessory" },
  { name: "Water Flosser / Oral Irrigator", cat: "Dental Accessory" },
  { name: "GIC Cement (Glass Ionomer Cement)", cat: "Dental Material" },
  { name: "GIC Type II Restorative", cat: "Dental Material" },
  { name: "RMGIC (Resin Modified GIC)", cat: "Dental Material" },
  { name: "Composite Resin A1 Shade", cat: "Dental Material" },
  { name: "Composite Resin A2 Shade", cat: "Dental Material" },
  { name: "Composite Resin A3 Shade", cat: "Dental Material" },
  { name: "Composite Resin B1 Shade", cat: "Dental Material" },
  { name: "Flowable Composite", cat: "Dental Material" },
  { name: "Bulk Fill Composite", cat: "Dental Material" },
  { name: "IRM (Intermediate Restorative Material)", cat: "Dental Material" },
  { name: "Zinc Oxide Eugenol Cement", cat: "Dental Material" },
  { name: "Zinc Phosphate Cement", cat: "Dental Material" },
  { name: "Zinc Polycarboxylate Cement", cat: "Dental Material" },
  { name: "MTA (Mineral Trioxide Aggregate)", cat: "Dental Material" },
  { name: "Calcium Hydroxide Paste", cat: "Dental Material" },
  { name: "Biodentine (Calcium Silicate)", cat: "Dental Material" },
  { name: "Dycal (Calcium Hydroxide Base)", cat: "Dental Material" },
  { name: "Cavity Liner (Varnish)", cat: "Dental Material" },
  { name: "Etchant 37% Phosphoric Acid Gel", cat: "Dental Material" },
  { name: "Bonding Agent (5th Gen)", cat: "Dental Material" },
  { name: "Bonding Agent (7th Gen Self-Etch)", cat: "Dental Material" },
  { name: "Dental Amalgam Capsule", cat: "Dental Material" },
  { name: "Impression Material Alginate", cat: "Dental Material" },
  {
    name: "Impression Material Polyvinyl Siloxane (PVS)",
    cat: "Dental Material",
  },
  { name: "Impression Material Polyether", cat: "Dental Material" },
  { name: "Zinc Oxide Impression Paste", cat: "Dental Material" },
  { name: "Plaster of Paris (Type II)", cat: "Dental Material" },
  { name: "Dental Stone (Type III)", cat: "Dental Material" },
  { name: "Dental Stone (Type IV)", cat: "Dental Material" },
  { name: "Acrylic Resin Heat Cure", cat: "Dental Material" },
  { name: "Acrylic Resin Cold Cure / Self Cure", cat: "Dental Material" },
  { name: "Denture Base Resin", cat: "Dental Material" },
  { name: "Denture Reliner", cat: "Dental Material" },
  { name: "Denture Adhesive Cream", cat: "Dental Material" },
  { name: "Dental Wax (Sheet Wax)", cat: "Dental Material" },
  { name: "Boxing Wax", cat: "Dental Material" },
  { name: "Inlay Wax", cat: "Dental Material" },
  { name: "Sticky Wax", cat: "Dental Material" },
  { name: "Orthodontic Wire NiTi 0.012", cat: "Dental Ortho" },
  { name: "Orthodontic Wire NiTi 0.014", cat: "Dental Ortho" },
  { name: "Orthodontic Wire NiTi 0.016", cat: "Dental Ortho" },
  { name: "Orthodontic Wire SS 0.019x0.025", cat: "Dental Ortho" },
  { name: "Orthodontic Brackets (Metal)", cat: "Dental Ortho" },
  { name: "Orthodontic Brackets (Ceramic)", cat: "Dental Ortho" },
  { name: "Orthodontic Elastic Bands", cat: "Dental Ortho" },
  { name: "Orthodontic Separator Elastics", cat: "Dental Ortho" },
  { name: "Orthodontic Molar Band", cat: "Dental Ortho" },
  { name: "Orthodontic Retainer Wire", cat: "Dental Ortho" },
  { name: "Invisalign Clear Aligner Tray", cat: "Dental Ortho" },
  { name: "Dental Implant Fixture (Titanium)", cat: "Dental Implant" },
  { name: "Dental Implant Abutment", cat: "Dental Implant" },
  { name: "Healing Cap / Cover Screw", cat: "Dental Implant" },
  { name: "Bone Graft Material (Synthetic HA)", cat: "Dental Implant" },
  { name: "Bone Graft Material (Xenograft)", cat: "Dental Implant" },
  { name: "Collagen Membrane (Resorbable)", cat: "Dental Implant" },
  { name: "Titanium Mesh", cat: "Dental Implant" },
  { name: "PRP (Platelet Rich Plasma) Kit", cat: "Dental Surgical" },
  { name: "PRF (Platelet Rich Fibrin) Kit", cat: "Dental Surgical" },
  { name: "Hemostatic Agent (Gelatin Sponge)", cat: "Dental Surgical" },
  { name: "Surgicel (Oxidised Cellulose)", cat: "Haemostatic" },
  { name: "Alvogyl (Dry Socket Dressing)", cat: "Dental Surgical" },
  { name: "Whitehead Varnish (Iodoform Paste)", cat: "Dental Surgical" },
  { name: "Ledermix Paste", cat: "Dental Material" },
  { name: "Root Canal Sealer (AH Plus)", cat: "Endodontic" },
  { name: "Root Canal Sealer (Sealapex)", cat: "Endodontic" },
  { name: "Root Canal Sealer (Zinc Oxide Eugenol)", cat: "Endodontic" },
  { name: "Gutta Percha Points (ISO 20-80)", cat: "Endodontic" },
  { name: "Paper Points (Absorbent Points)", cat: "Endodontic" },
  { name: "EDTA Liquid 17% (Root Canal)", cat: "Endodontic" },
  { name: "EDTA Gel 17% (Root Canal)", cat: "Endodontic" },
  { name: "Sodium Hypochlorite 2.5% Solution", cat: "Endodontic" },
  { name: "Sodium Hypochlorite 5.25% Solution", cat: "Endodontic" },
  { name: "Chlorhexidine 2% Irrigant", cat: "Endodontic" },
  { name: "RC Prep (Root Canal Lubricant)", cat: "Endodontic" },
  { name: "K-Files (Root Canal Files) ISO 6-80", cat: "Endodontic Instrument" },
  { name: "H-Files (Hedstrom Files) ISO 15-60", cat: "Endodontic Instrument" },
  { name: "Rotary NiTi Files (ProTaper)", cat: "Endodontic Instrument" },
  { name: "Rotary NiTi Files (WaveOne Gold)", cat: "Endodontic Instrument" },
  { name: "Rubber Dam Sheet", cat: "Endodontic Accessory" },
  { name: "Rubber Dam Clamp", cat: "Endodontic Accessory" },
  { name: "Rubber Dam Frame", cat: "Endodontic Accessory" },
  { name: "Pulp Capping Agent (Vitrebond)", cat: "Endodontic" },
  { name: "Formocresol Solution", cat: "Endodontic Paediatric" },
  { name: "Buckley's Formocresol", cat: "Endodontic Paediatric" },
  {
    name: "Zinc Oxide + Iodoform Paste (Kri Paste)",
    cat: "Endodontic Paediatric",
  },
  { name: "Stainless Steel Crown (Paediatric)", cat: "Paediatric Dental" },
  { name: "Fluoride Varnish Duraphat 22600 ppm", cat: "Fluoride Varnish" },
  { name: "Dental Needle 27G Short (21mm)", cat: "Dental Needle" },
  { name: "Dental Needle 27G Long (38mm)", cat: "Dental Needle" },
  { name: "Dental Needle 30G Short (21mm)", cat: "Dental Needle" },
  { name: "Dental Needle 25G Long (38mm)", cat: "Dental Needle" },
  {
    name: "Aspirating Dental Syringe (Breech Loading)",
    cat: "Dental Instrument",
  },
  { name: "Disposable Syringe 1ml (Insulin)", cat: "Syringe" },
  { name: "Disposable Syringe 2ml", cat: "Syringe" },
  { name: "Disposable Syringe 5ml", cat: "Syringe" },
  { name: "Disposable Syringe 10ml", cat: "Syringe" },
  { name: "Disposable Syringe 20ml", cat: "Syringe" },
  { name: "Disposable Syringe 50ml (Piston)", cat: "Syringe" },
  { name: "Normal Saline 0.9% 100ml Infusion", cat: "IV Fluid" },
  { name: "Normal Saline 0.9% 500ml Infusion", cat: "IV Fluid" },
  { name: "Normal Saline 0.9% 1000ml Infusion", cat: "IV Fluid" },
  { name: "Ringer's Lactate 500ml Infusion", cat: "IV Fluid" },
  { name: "Ringer's Lactate 1000ml Infusion", cat: "IV Fluid" },
  { name: "Dextrose 5% 500ml Infusion", cat: "IV Fluid" },
  { name: "Mannitol 20% 100ml Infusion", cat: "IV Fluid" },
  { name: "Mannitol 20% 500ml Infusion", cat: "IV Fluid" },
  { name: "Ondansetron 4mg Tablet", cat: "Antiemetic" },
  { name: "Ondansetron 8mg Tablet", cat: "Antiemetic" },
  { name: "Ondansetron 2mg/ml Injection", cat: "Antiemetic Inj" },
  { name: "Metoclopramide 10mg Tablet", cat: "Antiemetic" },
  { name: "Metoclopramide 10mg Injection", cat: "Antiemetic Inj" },
  { name: "Domperidone 10mg Tablet", cat: "Antiemetic" },
  { name: "Pantoprazole 20mg Tablet", cat: "Antacid / PPI" },
  { name: "Pantoprazole 40mg Tablet", cat: "Antacid / PPI" },
  { name: "Pantoprazole 40mg Injection", cat: "Antacid Inj" },
  { name: "Omeprazole 20mg Capsule", cat: "Antacid / PPI" },
  { name: "Rabeprazole 20mg Tablet", cat: "Antacid / PPI" },
  { name: "Esomeprazole 40mg Tablet", cat: "Antacid / PPI" },
  { name: "Ranitidine 150mg Tablet", cat: "Antacid / H2 Blocker" },
  { name: "Sucralfate Suspension 1g/10ml", cat: "Antacid" },
  { name: "Cetirizine 5mg Tablet", cat: "Antihistamine" },
  { name: "Cetirizine 10mg Tablet", cat: "Antihistamine" },
  { name: "Cetirizine 5mg/5ml Syrup", cat: "Antihistamine" },
  { name: "Levocetirizine 5mg Tablet", cat: "Antihistamine" },
  { name: "Fexofenadine 120mg Tablet", cat: "Antihistamine" },
  { name: "Fexofenadine 180mg Tablet", cat: "Antihistamine" },
  { name: "Loratadine 10mg Tablet", cat: "Antihistamine" },
  { name: "Chlorpheniramine 4mg Tablet", cat: "Antihistamine" },
  { name: "Adrenaline (Epinephrine) 1mg/ml Injection", cat: "Emergency Drug" },
  { name: "Hydrocortisone 100mg Injection (Allergy)", cat: "Emergency Drug" },
  { name: "Epinephrine Auto-Injector (EpiPen)", cat: "Emergency Drug" },
  { name: "Amlodipine 5mg Tablet", cat: "Antihypertensive" },
  { name: "Atenolol 50mg Tablet", cat: "Beta Blocker" },
  { name: "Metoprolol 50mg Tablet", cat: "Beta Blocker" },
  { name: "Losartan 50mg Tablet", cat: "Antihypertensive" },
  { name: "Telmisartan 40mg Tablet", cat: "Antihypertensive" },
  { name: "Telmisartan 80mg Tablet", cat: "Antihypertensive" },
  { name: "Ramipril 5mg Tablet", cat: "ACE Inhibitor" },
  { name: "Furosemide 40mg Tablet", cat: "Diuretic" },
  { name: "Aspirin 75mg Tablet", cat: "Antiplatelet" },
  { name: "Clopidogrel 75mg Tablet", cat: "Antiplatelet" },
  { name: "Atorvastatin 20mg Tablet", cat: "Statin" },
  { name: "Atorvastatin 40mg Tablet", cat: "Statin" },
  { name: "Metformin 500mg Tablet", cat: "Antidiabetic" },
  { name: "Metformin 850mg Tablet", cat: "Antidiabetic" },
  { name: "Glimepiride 2mg Tablet", cat: "Antidiabetic" },
  { name: "Insulin Regular (Soluble) 100 IU/ml", cat: "Insulin" },
  { name: "Vitamin C 500mg Tablet", cat: "Vitamin" },
  { name: "Vitamin C 1000mg Tablet", cat: "Vitamin" },
  { name: "Vitamin D3 60000 IU Capsule (Weekly)", cat: "Vitamin" },
  { name: "Vitamin D3 1000 IU Tablet (Daily)", cat: "Vitamin" },
  { name: "Vitamin B Complex Tablet", cat: "Vitamin" },
  { name: "Vitamin B12 500mcg Tablet", cat: "Vitamin" },
  { name: "Folic Acid 5mg Tablet", cat: "Vitamin" },
  { name: "Iron (Ferrous Sulphate) 200mg Tablet", cat: "Iron Supplement" },
  { name: "Iron + Folic Acid Tablet", cat: "Iron Supplement" },
  { name: "Calcium Carbonate 500mg Tablet", cat: "Calcium Supplement" },
  { name: "Calcium + Vitamin D3 Tablet", cat: "Calcium Supplement" },
  { name: "Zinc Sulphate 50mg Tablet", cat: "Micronutrient" },
  { name: "Multivitamin Tablet (Adult)", cat: "Multivitamin" },
  { name: "Tranexamic Acid 500mg Tablet", cat: "Haemostatic" },
  { name: "Tranexamic Acid 250mg/5ml Injection", cat: "Haemostatic Inj" },
  { name: "Etamsylate 250mg Tablet", cat: "Haemostatic" },
  { name: "Gelatin Sponge (Absorbable Haemostat)", cat: "Haemostatic" },
  { name: "Bone Wax", cat: "Haemostatic Surgical" },
  { name: "Vicryl (Polyglactin 910) 3-0 Suture", cat: "Suture" },
  { name: "Vicryl (Polyglactin 910) 4-0 Suture", cat: "Suture" },
  { name: "Vicryl Rapid 4-0 Suture", cat: "Suture" },
  { name: "Chromic Catgut 2-0 Suture", cat: "Suture" },
  { name: "Chromic Catgut 3-0 Suture", cat: "Suture" },
  { name: "Plain Catgut 2-0 Suture", cat: "Suture" },
  { name: "Silk Suture 3-0 Black Braided", cat: "Suture" },
  { name: "Silk Suture 4-0 Black Braided", cat: "Suture" },
  { name: "Nylon Suture 3-0 (Ethilon)", cat: "Suture" },
  { name: "Nylon Suture 4-0 (Ethilon)", cat: "Suture" },
  { name: "Gauze Swab 4x4 inch (Sterile)", cat: "Dressing" },
  { name: "Cotton Roll (Non-Sterile)", cat: "Dental Material" },
  { name: "Cotton Roll (Dental Grade)", cat: "Consumable" },
  { name: "Cotton Pellet Small", cat: "Consumable" },
  { name: "Ribbon Gauze 1/2 inch (Dental Packing)", cat: "Dental Consumable" },
  { name: "Dry Foil (Dental)", cat: "Dental Consumable" },
  { name: "Tetanus Toxoid 0.5ml Injection", cat: "Vaccine" },
  { name: "Influenza Vaccine (Flu Shot)", cat: "Vaccine" },
  { name: "MMR Vaccine", cat: "Vaccine" },
  { name: "Anti-Tetanus Serum (ATS)", cat: "Antiserum" },
  { name: "OPG (Orthopantomogram) X-ray", cat: "Dental Investigation" },
  { name: "IOPA X-ray (Intraoral Periapical)", cat: "Dental Investigation" },
  { name: "Bitewing X-ray", cat: "Dental Investigation" },
  { name: "CBCT Scan (Cone Beam CT)", cat: "Dental Investigation" },
  { name: "Lateral Cephalogram X-ray", cat: "Dental Investigation" },
  { name: "Complete Blood Count (CBC)", cat: "Lab Test" },
  { name: "Blood Sugar Fasting (BSF)", cat: "Lab Test" },
  { name: "Random Blood Sugar (RBS)", cat: "Lab Test" },
  { name: "HbA1c Test", cat: "Lab Test" },
  { name: "Liver Function Test (LFT)", cat: "Lab Test" },
  { name: "Kidney Function Test (KFT) / RFT", cat: "Lab Test" },
  { name: "Lipid Profile Test", cat: "Lab Test" },
  { name: "Blood Group and Rh Typing", cat: "Lab Test" },
  { name: "PT / INR (Prothrombin Time)", cat: "Lab Test" },
  { name: "APTT Test", cat: "Lab Test" },
  { name: "Bleeding Time (BT)", cat: "Lab Test" },
  { name: "Clotting Time (CT)", cat: "Lab Test" },
  { name: "HBsAg Test (Hepatitis B Surface Antigen)", cat: "Lab Test" },
  { name: "HIV Test (ELISA)", cat: "Lab Test" },
  { name: "Adrenaline 1:1000 (1mg/ml) Injection", cat: "Emergency Drug" },
  { name: "Atropine 0.6mg Injection", cat: "Emergency Drug" },
  { name: "Sodium Bicarbonate 8.4% Injection", cat: "Emergency Drug" },
  { name: "Dextrose 50% Injection (Hypoglycaemia)", cat: "Emergency Drug" },
  { name: "Naloxone 0.4mg Injection (Opioid Reversal)", cat: "Emergency Drug" },
  {
    name: "Augmentin 625mg Tablet (Amoxicillin+Clavulanate)",
    cat: "Antibiotic",
  },
  { name: "Azithral 500mg Tablet (Azithromycin)", cat: "Antibiotic" },
  { name: "Cifran 500mg Tablet (Ciprofloxacin)", cat: "Antibiotic" },
  { name: "Flagyl 400mg Tablet (Metronidazole)", cat: "Antibiotic" },
  { name: "Doxy 100mg Capsule (Doxycycline)", cat: "Antibiotic" },
  { name: "Calpol 650mg Tablet (Paracetamol)", cat: "Painkiller" },
  { name: "Dolo 650 Tablet (Paracetamol)", cat: "Painkiller" },
  { name: "Combiflam Tablet (Ibuprofen+Paracetamol)", cat: "NSAID Combo" },
  { name: "Voveran 50mg Tablet (Diclofenac)", cat: "NSAID" },
  { name: "Brufen 400mg Tablet (Ibuprofen)", cat: "NSAID" },
  { name: "Ultracet Tablet (Tramadol+Paracetamol)", cat: "Analgesic Combo" },
  { name: "Pan 40mg Tablet (Pantoprazole)", cat: "Antacid / PPI" },
  { name: "Omez 20mg Capsule (Omeprazole)", cat: "Antacid / PPI" },
  { name: "Ondem 4mg Tablet (Ondansetron)", cat: "Antiemetic" },
  { name: "Allegra 120mg Tablet (Fexofenadine)", cat: "Antihistamine" },
  {
    name: "Montair-LC Tablet (Montelukast+Levocetirizine)",
    cat: "Antihistamine",
  },
  { name: "Rantac 150mg Tablet (Ranitidine)", cat: "Antacid / H2 Blocker" },
  { name: "Kenacort Oral Paste (Triamcinolone)", cat: "Steroid Topical" },
  { name: "Kenalog Injection 40mg (Triamcinolone)", cat: "Steroid Inj" },
  { name: "Depo-Medrol 40mg Injection", cat: "Steroid Inj" },
  { name: "Betnesol 0.5mg Tablet (Betamethasone)", cat: "Steroid" },
  { name: "Wysolone 5mg Tablet (Prednisolone)", cat: "Steroid" },
  { name: "Defcort 6mg Tablet (Deflazacort)", cat: "Steroid" },
  { name: "Dexona 0.5mg Tablet (Dexamethasone)", cat: "Steroid" },
  { name: "Mox 500mg Capsule (Amoxicillin)", cat: "Antibiotic" },
  { name: "Sporanox 100mg Capsule (Itraconazole)", cat: "Antifungal" },
  { name: "Zovirax 400mg Tablet (Acyclovir)", cat: "Antiviral" },
  { name: "Valcivir 500mg Tablet (Valacyclovir)", cat: "Antiviral" },
  { name: "Betadine Ointment 5%", cat: "Antiseptic Topical" },
  { name: "Borax Glycerine (Oral Ulcer)", cat: "Oral Care" },
  { name: "Tantum Verde Mouthwash (Benzydamine)", cat: "Oral Care" },
  { name: "Hexidine Mouthwash", cat: "Dental Antiseptic" },
  { name: "Recaldent (CPP-ACP Paste)", cat: "Dental Fluoride" },
  { name: "Tooth Mousse Plus (GC)", cat: "Dental Fluoride" },
  { name: "Sensodyne Repair & Protect", cat: "Dental Brand" },
  { name: "Colgate Sensitive Pro-Relief", cat: "Dental Brand" },
  { name: "Mouth Guard (Bruxism)", cat: "Dental Brand" },
  {
    name: "Triamcinolone Acetonide 0.1% Oral Paste (Kenacort)",
    cat: "Steroid Topical",
  },
  { name: "Clotrimazole 1% Cream", cat: "Antifungal Topical" },
  { name: "Miconazole 2% Oral Gel", cat: "Antifungal Topical" },
  { name: "Nystatin Oral Suspension", cat: "Antifungal" },
  { name: "Mupirocin 2% Ointment (Bactroban)", cat: "Topical Antibiotic" },
  { name: "Lignocaine Viscous 2% Mouthwash", cat: "Local Anaesthetic Topical" },
  { name: "Amlexanox 5% Paste (Aphthous Ulcer)", cat: "Oral Care" },
  { name: "Benzydamine 0.15% Mouthwash (Tantum Verde)", cat: "Oral Care" },
  { name: "Ulcerex Gel (Choline Salicylate)", cat: "Oral Care" },
  { name: "Dologel CT (Clove Oil Gel)", cat: "Oral Care" },
  { name: "Clove Oil (Eugenol)", cat: "Dental Material" },
  { name: "Titanium Implant Fixture (3.3mm)", cat: "Dental Implant" },
  { name: "Titanium Implant Fixture (4.0mm)", cat: "Dental Implant" },
  { name: "Implant Cover Screw", cat: "Dental Implant" },
  { name: "Implant Healing Abutment", cat: "Dental Implant" },
  { name: "Bone Graft (Xenograft - Bio-Oss)", cat: "Dental Surgical" },
  { name: "Collagen Membrane (Bio-Gide)", cat: "Dental Surgical" },
  { name: "Haemostatic Foam (Gelfoam)", cat: "Haemostatic" },
  { name: "Surgical Suction Tip (Frazier)", cat: "Dental Instrument" },
  { name: "CBC (Complete Blood Count)", cat: "Lab Test" },
  { name: "RBS (Random Blood Sugar)", cat: "Lab Test" },
  { name: "HbA1c (Glycated Haemoglobin)", cat: "Lab Test" },
  { name: "Blood Group & Rh Typing", cat: "Lab Test" },
  { name: "BT (Bleeding Time) & CT (Clotting Time)", cat: "Lab Test" },
  { name: "PT/INR (Prothrombin Time)", cat: "Lab Test" },
  { name: "LFT (Liver Function Test)", cat: "Lab Test" },
  { name: "KFT (Kidney Function Test)", cat: "Lab Test" },
  { name: "Dental Radiograph (IOPA X-ray)", cat: "Dental Investigation" },
  { name: "Orthopantomogram (OPG) X-ray", cat: "Dental Investigation" },
  { name: "CBCT Scan (Dental 3D)", cat: "Dental Investigation" },
  { name: "Aceclofenac + Paracetamol + Serratiopeptidase", cat: "NSAID Combo" },
  { name: "Serratiopeptidase 10mg Tablet", cat: "Enzyme Combination" },
  { name: "Serratiopeptidase 20mg Tablet", cat: "Enzyme Combination" },
  { name: "Deflazacort 6mg Tablet", cat: "Steroid" },
  { name: "Deflazacort 12mg Tablet", cat: "Steroid" },
  { name: "Deflazacort 30mg Tablet", cat: "Steroid" },
  { name: "Omeprazole 10mg Capsule", cat: "Antacid / PPI" },
  { name: "Omeprazole 40mg Capsule", cat: "Antacid / PPI" },
  { name: "Rabeprazole 10mg Tablet", cat: "Antacid / PPI" },
  { name: "Esomeprazole 20mg Tablet", cat: "Antacid / PPI" },
  { name: "Ranitidine 300mg Tablet", cat: "Antacid / H2 Blocker" },
  { name: "Ondansetron 4mg/5ml Syrup", cat: "Antiemetic" },
  { name: "Domperidone 1mg/ml Suspension", cat: "Antiemetic" },
  { name: "Levocetirizine 2.5mg Tablet", cat: "Antihistamine" },
  { name: "Vitamin C 1000mg Tablet", cat: "Vitamin" },
  { name: "Vitamin B Complex + Zinc Capsule", cat: "Vitamin" },
  { name: "Vitamin D3 60000 IU Capsule", cat: "Vitamin" },
  { name: "Vitamin E 400mg Capsule", cat: "Vitamin" },
  { name: "Zinc Sulphate 20mg Tablet", cat: "Mineral Supplement" },
  { name: "Ferrous Sulphate 200mg Tablet", cat: "Iron Supplement" },
  { name: "Ferrous Ascorbate + Folic Acid Tablet", cat: "Iron Supplement" },
];

function saveCustomMed(name) {
  if (!name || name.trim().length < 3) return Promise.resolve(null);
  if (!/[a-zA-Z]/.test(name.trim())) return Promise.resolve(null);
  const nameLow = name.trim().toLowerCase();
  const already = MEDICINE_DB.some(
    (m) => m && m.name && m.name.toLowerCase() === nameLow,
  );
  if (already) return Promise.resolve(null);
  // ✅ Call api.post directly — NOT via prop — so auth token is always included
  return api
    .post("/custommeds", { name: name.trim(), cat: "Custom" })
    .then((saved) => saved || null)
    .catch(() => null);
}

function googleSearch(query, customMeds = []) {
  const words = query
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .filter((w) => w.length > 0);
  if (!words.length) return [];
  const safeMeds = Array.isArray(customMeds)
    ? customMeds.filter(
        (m) => m && typeof m.name === "string" && m.name.trim().length > 0,
      )
    : [];
  const combined = [
    ...MEDICINE_DB.filter(Boolean),
    ...safeMeds.map((m) => ({ ...m, _custom: true })),
  ];
  const scored = combined
    .map((m) => {
      if (!m || typeof m.name !== "string") return { m, score: 0 };
      const nameLow = m.name.toLowerCase();
      const catLow = (m.cat || "").toLowerCase();
      let score = 0;
      for (const w of words) {
        if (nameLow.startsWith(w)) score += 5;
        else if (nameLow.includes(w)) score += 3;
        else if (catLow.includes(w)) score += 1;
      }
      if (m._custom) score += 2;
      return { m, score };
    })
    .filter((x) => x.score > 0)
    .sort((a, b) => b.score - a.score)
    .map((x) => x.m);
  return scored.slice(0, 12);
}

function highlightWords(text, query) {
  const words = query
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .filter((w) => w.length > 0);
  let result = text;
  words.forEach((w) => {
    const re = new RegExp(
      "(" + w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
      "gi",
    );
    result = result.replace(re, "<b>$1</b>");
  });
  return result;
}

// ── RxMedInput — original unchanged ─────────────────────────
function RxMedInput({ value, onChange, customMeds = [], onCustomSaved }) {
  const inpRef = React.useRef(null);
  const wrapRef = React.useRef(null);
  const [sugs, setSugs] = React.useState([]);
  const [activeIdx, setActive] = React.useState(-1);
  const [query, setQuery] = React.useState("");
  const [dropPos, setDropPos] = React.useState({ top: 0, left: 0, width: 0 });

  const hide = () => {
    setSugs([]);
    setActive(-1);
    setQuery("");
  };

  const handleChange = (e) => {
    const v = e.target.value;
    onChange(v);
    if (v.trim().length < 2) {
      hide();
      return;
    }
    const matches = googleSearch(v, customMeds);
    if (!matches.length) {
      hide();
      return;
    }
    setQuery(v);
    setSugs(matches);
    setActive(-1);
    requestAnimationFrame(() => {
      if (!inpRef.current) return;
      const r = inpRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - r.bottom;
      const dropH = Math.min(220, matches.length * 36);
      const top =
        spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
      setDropPos({ top, left: r.left, width: r.width });
    });
  };

  const handleKeyDown = (e) => {
    if (!sugs.length) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActive((i) => Math.min(i + 1, sugs.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActive((i) => Math.max(i - 1, 0));
    } else if (
      (e.key === "Enter" || e.key === "Tab") &&
      activeIdx >= 0 &&
      sugs[activeIdx]
    ) {
      e.preventDefault();
      select(sugs[activeIdx].name);
    } else if (e.key === "Escape") hide();
  };

  const select = (name) => {
    onChange(name);
    hide();
    saveCustomMed(name).then((saved) => {
      if (onCustomSaved) onCustomSaved(saved || null);
    });
    setTimeout(() => {
      if (inpRef.current) inpRef.current.focus();
    }, 0);
  };

  React.useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) hide();
    };
    document.addEventListener("mousedown", handler);
    const scrollHandler = () => {
      if (sugs.length > 0 && inpRef.current) {
        const r = inpRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - r.bottom;
        const dropH = Math.min(220, sugs.length * 36);
        const top =
          spaceBelow > dropH || spaceBelow > 100 ? r.bottom : r.top - dropH;
        setDropPos({ top, left: r.left, width: r.width });
      }
    };
    window.addEventListener("scroll", scrollHandler, true);
    return () => {
      document.removeEventListener("mousedown", handler);
      window.removeEventListener("scroll", scrollHandler, true);
    };
  }, [sugs.length]);

  return (
    <div ref={wrapRef} style={{ position: "relative" }}>
      <input
        ref={inpRef}
        type="text"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder="Type medicine name..."
        autoComplete="off"
        style={{
          width: "100%",
          border: "1px solid #ddd",
          borderRadius: 5,
          padding: "5px 8px",
          fontSize: 12,
          fontFamily: "'DM Sans',sans-serif",
        }}
      />
      {sugs.length > 0 &&
        ReactDOM.createPortal(
          <div
            style={{
              position: "fixed",
              top: dropPos.top,
              left: dropPos.left,
              width: Math.max(dropPos.width, 280),
              background: "#fff",
              border: "1.5px solid #0d7377",
              borderRadius: 8,
              boxShadow: "0 8px 32px rgba(13,115,119,0.28)",
              zIndex: 999999,
              maxHeight: 220,
              overflowY: "auto",
              fontFamily: "'DM Sans',sans-serif",
            }}
          >
            {sugs.map((m, i) => (
              <div
                key={m.name + i}
                style={{
                  padding: "7px 12px",
                  cursor: "pointer",
                  fontSize: 12,
                  background: i === activeIdx ? "#e8f7f7" : "#fff",
                  borderBottom: "1px solid #f0eeeb",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  select(m.name);
                }}
                onMouseEnter={() => setActive(i)}
              >
                <span style={{ fontSize: 13, opacity: 0.6, flexShrink: 0 }}>
                  💊
                </span>
                <span
                  style={{ flex: 1, fontWeight: 500 }}
                  dangerouslySetInnerHTML={{
                    __html: highlightWords(m.name, query),
                  }}
                />
                <span
                  style={{
                    fontSize: 10,
                    color: "#9a9590",
                    background: "#f0eeeb",
                    padding: "1px 6px",
                    borderRadius: 20,
                    flexShrink: 0,
                  }}
                >
                  {m.cat}
                </span>
              </div>
            ))}
          </div>,
          document.body,
        )}
    </div>
  );
}

// ── MedAutocomplete — original unchanged ─────────────────────
function MedAutocomplete({ value, onChange, customMeds = [], onCustomSaved }) {
  const taRef = React.useRef(null);
  const wrapperRef = React.useRef(null);
  const [suggestions, setSuggestions] = React.useState([]);
  const [activeIdx, setActiveIdx] = React.useState(-1);
  const [currentQuery, setCurrentQuery] = React.useState("");
  const queryStartRef = React.useRef(0);
  const queryEndRef = React.useRef(0);

  const hideSuggestions = () => {
    setSuggestions([]);
    setActiveIdx(-1);
    setCurrentQuery("");
  };

  const handleChange = (e) => {
    const ta = e.target;
    const val = ta.value;
    const cursor = ta.selectionStart;
    onChange(val);
    let lineStart = cursor - 1;
    while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
    lineStart++;
    const query = val.substring(lineStart, cursor);
    queryStartRef.current = lineStart;
    queryEndRef.current = cursor;
    if (query.trim().length < 2) {
      hideSuggestions();
      return;
    }
    const matches = googleSearch(query, customMeds);
    if (!matches.length) {
      hideSuggestions();
      return;
    }
    setCurrentQuery(query);
    setSuggestions(matches);
    setActiveIdx(-1);
  };

  const handleKeyDown = (e) => {
    if (!suggestions.length) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIdx((i) => Math.max(i - 1, 0));
    } else if (
      (e.key === "Enter" || e.key === "Tab") &&
      activeIdx >= 0 &&
      suggestions[activeIdx]
    ) {
      e.preventDefault();
      selectMed(suggestions[activeIdx].name);
    } else if (e.key === "Escape") hideSuggestions();
  };

  const selectMed = (name) => {
    const ta = taRef.current;
    const val = ta.value;
    const before = val.substring(0, queryStartRef.current);
    const after = val.substring(queryEndRef.current);
    onChange(before + name + after);
    hideSuggestions();
    saveCustomMed(name).then((saved) => {
      if (onCustomSaved) onCustomSaved(saved || null);
    });
    setTimeout(() => {
      if (taRef.current) {
        const nc = queryStartRef.current + name.length;
        taRef.current.setSelectionRange(nc, nc);
        taRef.current.focus();
        queryEndRef.current = nc;
      }
    }, 0);
  };

  const handleBlur = () => {
    if (!taRef.current) return;
    const val = taRef.current.value;
    val.split("\n").forEach((line) => {
      const trimmed = line.trim();
      if (
        trimmed.length >= 3 &&
        /[a-zA-Z]/.test(trimmed) &&
        !/^[0-9\s]+$/.test(trimmed)
      ) {
        saveCustomMed(trimmed).then((saved) => {
          if (saved && onCustomSaved) onCustomSaved(saved);
        });
      }
    });
  };

  React.useEffect(() => {
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target))
        hideSuggestions();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <>
      <style>{`
        .med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}
        .med-suggestion-item:last-child{border-bottom:none;}
        .med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}
        .med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}
        .med-sug-name{font-weight:500;flex:1;color:#1a1614;}
        .med-sug-name b{color:#0d7377;font-weight:700;}
        .med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}
      `}</style>
      <div style={{ position: "relative" }} ref={wrapperRef}>
        <textarea
          ref={taRef}
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          autoComplete="off"
          placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
        />
        {suggestions.length > 0 && (
          <div
            style={{
              position: "absolute",
              left: 0,
              right: 0,
              background: "#fff",
              border: "1.5px solid #0d7377",
              borderTop: "none",
              borderRadius: "0 0 12px 12px",
              boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
              zIndex: 99999,
              maxHeight: 280,
              overflowY: "auto",
              fontFamily: "'DM Sans',sans-serif",
            }}
          >
            {suggestions.map((m, i) => (
              <div
                key={m.name + i}
                className={
                  "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
                }
                onMouseDown={(e) => {
                  e.preventDefault();
                  selectMed(m.name);
                }}
              >
                <span className="med-sug-icon">💊</span>
                <span
                  className="med-sug-name"
                  dangerouslySetInnerHTML={{
                    __html: highlightWords(m.name, currentQuery),
                  }}
                />
                <span className="med-sug-cat">{m.cat}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

// ── MedAutocompleteWithMic — Doctor Notes (mic removed) ────────
function MedAutocompleteWithMic({
  value,
  onChange,
  customMeds = [],
  onCustomSaved,
}) {
  const taRef = React.useRef(null);
  const wrapperRef = React.useRef(null);
  const [suggestions, setSuggestions] = React.useState([]);
  const [activeIdx, setActiveIdx] = React.useState(-1);
  const [currentQuery, setCurrentQuery] = React.useState("");
  const queryStartRef = React.useRef(0);
  const queryEndRef = React.useRef(0);

  const hideSuggestions = () => {
    setSuggestions([]);
    setActiveIdx(-1);
    setCurrentQuery("");
  };

  const handleChange = (e) => {
    const ta = e.target,
      val = ta.value,
      cursor = ta.selectionStart;
    onChange(val);
    let lineStart = cursor - 1;
    while (lineStart >= 0 && val[lineStart] !== "\n") lineStart--;
    lineStart++;
    const query = val.substring(lineStart, cursor);
    queryStartRef.current = lineStart;
    queryEndRef.current = cursor;
    if (query.trim().length < 2) {
      hideSuggestions();
      return;
    }
    const matches = googleSearch(query, customMeds);
    if (!matches.length) {
      hideSuggestions();
      return;
    }
    setCurrentQuery(query);
    setSuggestions(matches);
    setActiveIdx(-1);
  };

  const handleKeyDown = (e) => {
    if (!suggestions.length) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIdx((i) => Math.min(i + 1, suggestions.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIdx((i) => Math.max(i - 1, 0));
    } else if (
      (e.key === "Enter" || e.key === "Tab") &&
      activeIdx >= 0 &&
      suggestions[activeIdx]
    ) {
      e.preventDefault();
      selectMed(suggestions[activeIdx].name);
    } else if (e.key === "Escape") hideSuggestions();
  };

  const selectMed = (name) => {
    const ta = taRef.current,
      val = ta.value;
    const before = val.substring(0, queryStartRef.current),
      after = val.substring(queryEndRef.current);
    onChange(before + name + after);
    hideSuggestions();
    saveCustomMed(name).then((saved) => {
      if (onCustomSaved) onCustomSaved(saved || null);
    });
    setTimeout(() => {
      if (taRef.current) {
        const nc = queryStartRef.current + name.length;
        taRef.current.setSelectionRange(nc, nc);
        taRef.current.focus();
        queryEndRef.current = nc;
      }
    }, 0);
  };

  const handleBlur = () => {
    if (!taRef.current) return;
    taRef.current.value.split("\n").forEach((line) => {
      const trimmed = line.trim();
      if (
        trimmed.length >= 3 &&
        /[a-zA-Z]/.test(trimmed) &&
        !/^[0-9\s]+$/.test(trimmed)
      ) {
        saveCustomMed(trimmed).then((saved) => {
          if (saved && onCustomSaved) onCustomSaved(saved);
        });
      }
    });
  };

  React.useEffect(() => {
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target))
        hideSuggestions();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <>
      <style>{`.med-suggestion-item{padding:8px 14px;cursor:pointer;font-size:13.5px;color:#1a1614;display:flex;align-items:center;gap:10px;border-bottom:1px solid #f0eeeb;transition:background 0.12s;}.med-suggestion-item:last-child{border-bottom:none;}.med-suggestion-item:hover,.med-suggestion-item.med-active{background:#e8f7f7;}.med-sug-icon{font-size:14px;opacity:0.65;flex-shrink:0;}.med-sug-name{font-weight:500;flex:1;color:#1a1614;}.med-sug-name b{color:#0d7377;font-weight:700;}.med-sug-cat{font-size:11px;color:#9a9590;flex-shrink:0;background:#f0eeeb;padding:2px 7px;border-radius:20px;}`}</style>
      <div style={{ position: "relative" }} ref={wrapperRef}>
        <textarea
          ref={taRef}
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          autoComplete="off"
          placeholder="Enter observations, treatment given, prescription, follow-up advice... (type name of medicine to get suggestions)"
        />
        {suggestions.length > 0 && (
          <div
            style={{
              position: "absolute",
              left: 0,
              right: 0,
              background: "#fff",
              border: "1.5px solid #0d7377",
              borderTop: "none",
              borderRadius: "0 0 12px 12px",
              boxShadow: "0 8px 32px rgba(13,115,119,0.18)",
              zIndex: 99999,
              maxHeight: 280,
              overflowY: "auto",
              fontFamily: "'DM Sans',sans-serif",
            }}
          >
            {suggestions.map((m, i) => (
              <div
                key={m.name + i}
                className={
                  "med-suggestion-item" + (i === activeIdx ? " med-active" : "")
                }
                onMouseDown={(e) => {
                  e.preventDefault();
                  selectMed(m.name);
                }}
              >
                <span className="med-sug-icon">💊</span>
                <span
                  className="med-sug-name"
                  dangerouslySetInnerHTML={{
                    __html: highlightWords(m.name, currentQuery),
                  }}
                />
                <span className="med-sug-cat">{m.cat}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

// ── Prescription Modal — exact original PDF design ────────────
function PrescriptionModal({ visit, patient, doctor, onClose, showNotify }) {
  const [pdfUrl, setPdfUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [rxMobile, setRxMobile] = useState("");
  const [fileName, setFileName] = useState("");
  const [canNativeShare, setCanNativeShare] = useState(false);

  useEffect(() => {
    generatePDF();
  }, []);
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onClose]);

  const fmtDateLocal = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr + "T00:00:00");
    return d.getDate() + " " + MONTHS[d.getMonth()] + " " + d.getFullYear();
  };
  const fmtTimeLocal = (t) => {
    if (!t) return "";
    const parts = t.split(":");
    const hh = parseInt(parts[0]),
      mm = parts[1];
    return (hh % 12 || 12) + ":" + mm + " " + (hh < 12 ? "AM" : "PM");
  };

  const generatePDF = () => {
    if (window.jspdf) {
      buildPDF();
      return;
    }
    const existing = document.getElementById("jspdf-cdn");
    if (existing) {
      existing.addEventListener("load", buildPDF);
      return;
    }
    const script = document.createElement("script");
    script.id = "jspdf-cdn";
    script.src =
      "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
    script.crossOrigin = "anonymous";
    script.onload = buildPDF;
    script.onerror = () => setLoading(false);
    document.head.appendChild(script);
  };

  const buildPDF = () => {
    const { jsPDF } = window.jspdf;
    const pdf = new jsPDF({
      unit: "mm",
      format: "a4",
      orientation: "portrait",
    });
    const W = 210,
      H = 297;
    const sf = (c) => pdf.setFillColor(c[0], c[1], c[2]);
    const sd = (c) => pdf.setDrawColor(c[0], c[1], c[2]);
    const st = (c) => pdf.setTextColor(c[0], c[1], c[2]);
    const NAVY = [8, 25, 65],
      BLUE = [20, 80, 160];
    const LBLUE = [210, 228, 248],
      LBLUE2 = [232, 242, 252],
      MIDBLUE = [160, 195, 235];
    const TEAL = [0, 130, 130],
      TEAL2 = [210, 240, 240];
    const WHITE = [255, 255, 255],
      LGRAY = [245, 247, 251],
      LGRAY2 = [250, 251, 254],
      LGRAY3 = [240, 243, 248];
    const GRAY = [115, 118, 130],
      GRAY2 = [75, 80, 95];
    const GOLD = [170, 130, 40],
      GOLD2 = [250, 245, 225];
    const today = new Date();
    const todayFmt =
      today.getDate() +
      " " +
      MONTHS[today.getMonth()] +
      " " +
      today.getFullYear();
    const rxNum =
      "PS-" +
      today.getFullYear() +
      ("0" + (today.getMonth() + 1)).slice(-2) +
      ("0" + today.getDate()).slice(-2) +
      "-" +
      Math.floor(1000 + Math.random() * 8999);
    const visitDate = visit.visitDate || "",
      visitTime = visit.visitTime || "",
      notes = visit.notes || "",
      nextDate = visit.nextVisitDate || "",
      service = visit.service || "";
    const doc = { name: doctor?.name || "Doctor", qual: "", reg: "" };
    const visitDateFmt = fmtDateLocal(visitDate),
      visitTimeFmt = fmtTimeLocal(visitTime),
      nextDateFmt = fmtDateLocal(nextDate);
    sd(MIDBLUE);
    pdf.setLineWidth(0.8);
    pdf.rect(3.5, 3.5, W - 7, H - 7, "S");
    sd(LBLUE);
    pdf.setLineWidth(0.3);
    pdf.rect(5.5, 5.5, W - 11, H - 11, "S");
    sf(NAVY);
    pdf.rect(3.5, 3.5, W - 7, 46, "F");
    sf(BLUE);
    pdf.rect(3.5, 43, W - 7, 10, "F");
    sf(LBLUE);
    pdf.rect(3.5, 53, W - 7, 6, "F");
    st(WHITE);
    pdf.setFontSize(18);
    pdf.setFont("helvetica", "bold");
    pdf.text(doc.name, 14, 19);
    st(LBLUE);
    pdf.setFontSize(8);
    pdf.setFont("helvetica", "normal");
    pdf.text((doc.qual || "").toUpperCase(), 14, 26);
    sd(MIDBLUE);
    pdf.setLineWidth(0.25);
    pdf.line(14, 28.5, W - 40, 28.5);
    st(LGRAY);
    pdf.setFontSize(7);
    pdf.text("Reg. No.:  " + (doc.reg || "—"), 14, 33.5);
    pdf.text("Specialisation:  Dental & Oral Health Care", 14, 38.5);
    st(WHITE);
    pdf.setFontSize(15);
    pdf.setFont("helvetica", "bold");
    pdf.text("PEARLSMILE", W - 10, 19, { align: "right" });
    st(LBLUE);
    pdf.setFontSize(7.5);
    pdf.setFont("helvetica", "normal");
    pdf.text("DENTAL HOSPITAL", W - 10, 25.5, { align: "right" });
    sd(MIDBLUE);
    pdf.setLineWidth(0.25);
    pdf.line(W - 72, 28.5, W - 10, 28.5);
    st(LGRAY);
    pdf.setFontSize(6.8);
    pdf.text("12, Dental Plaza, MG Road, Pune - 411001", W - 10, 33.5, {
      align: "right",
    });
    pdf.text("+91 87936 08083  |  care@pearlsmiledental.in", W - 10, 38.5, {
      align: "right",
    });
    st(WHITE);
    pdf.setFontSize(9);
    pdf.setFont("helvetica", "bold");
    pdf.text("DIGITAL PRESCRIPTION", W / 2, 50, { align: "center" });
    st(LBLUE2);
    pdf.setFontSize(7);
    pdf.setFont("helvetica", "normal");
    pdf.text("Rx No.: " + rxNum, 10, 50);
    pdf.text("Date: " + todayFmt, W - 10, 50, { align: "right" });
    st(BLUE);
    pdf.setFontSize(7.5);
    pdf.setFont("helvetica", "bold");
    pdf.text("PATIENT INFORMATION", W / 2, 57, { align: "center" });
    const infoTop = 61;
    sf(LGRAY3);
    pdf.rect(10, infoTop, W - 20, 44, "F");
    sd(LBLUE);
    pdf.setLineWidth(0.25);
    pdf.rect(10, infoTop, W - 20, 44, "S");
    sd(MIDBLUE);
    pdf.setLineWidth(0.2);
    pdf.line(W / 2, infoTop, W / 2, infoTop + 44);
    let rdy = infoTop + 11;
    for (let ri = 0; ri < 3; ri++) {
      pdf.line(10, rdy, W - 10, rdy);
      rdy += 11;
    }
    const drawCell = (label, value, x, y, maxW) => {
      st(GRAY2);
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(6.8);
      pdf.text(label, x + 3, y + 4);
      st(NAVY);
      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(8.5);
      const val = pdf.splitTextToSize(String(value || "—"), maxW || 75);
      pdf.text(val[0], x + 3, y + 9.5);
    };
    const cHalf = W / 2;
    drawCell("PATIENT NAME", patient.name || "—", 10, infoTop, cHalf - 16);
    drawCell("MOBILE", patient.mobile || "—", cHalf, infoTop, cHalf - 16);
    drawCell("EMAIL", patient.email || "—", 10, infoTop + 11, cHalf - 16);
    drawCell(
      "BLOOD GROUP",
      patient.blood || "—",
      cHalf,
      infoTop + 11,
      cHalf - 16,
    );
    drawCell(
      "AGE / GENDER",
      (patient.age || "—") + (patient.gender ? "  |  " + patient.gender : ""),
      10,
      infoTop + 22,
      cHalf - 16,
    );
    drawCell(
      "VISIT DATE",
      visitDateFmt + (visitTimeFmt ? " (" + visitTimeFmt + ")" : ""),
      cHalf,
      infoTop + 22,
      cHalf - 16,
    );
    drawCell("SERVICE/TREATMENT", service || "—", 10, infoTop + 33, cHalf - 16);
    drawCell(
      "NEXT VISIT DATE",
      nextDateFmt || "—",
      cHalf,
      infoTop + 33,
      cHalf - 16,
    );
    const diagTop = infoTop + 50;
    const rxRows =
      visit.prescription && visit.prescription.medicineRows
        ? visit.prescription.medicineRows.filter(
            (r) => r.medicine && r.medicine.trim(),
          )
        : [];
    let rxTableEndY = diagTop;
    if (rxRows.length > 0) {
      const tTop = diagTop;
      sf(BLUE);
      pdf.rect(10, tTop, W - 20, 7, "F");
      st(WHITE);
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(7.5);
      pdf.text("PRESCRIPTION", W / 2, tTop + 5, { align: "center" });
      const colX = [10, 20, 90, 155, 183];
      let ry = tTop + 7;
      sf(LGRAY3);
      pdf.rect(10, ry, W - 20, 6, "F");
      [
        ["SR.", "normal", 6],
        ["MEDICINE", "bold", 6],
        ["DOSAGE INSTRUCTION", "normal", 6],
        ["DURATION", "normal", 6],
        ["ROUTE", "normal", 6],
      ].forEach(([h, fw, fs], hi) => {
        st(GRAY2);
        pdf.setFont("helvetica", fw);
        pdf.setFontSize(fs);
        pdf.text(h, colX[hi] + 1, ry + 4.5);
      });
      ry += 6;
      rxRows.forEach((row, ri) => {
        sf(ri % 2 === 0 ? LGRAY2 : WHITE);
        pdf.rect(10, ry, W - 20, 7, "F");
        sd(LBLUE);
        pdf.setLineWidth(0.1);
        pdf.rect(10, ry, W - 20, 7, "S");
        st(GRAY2);
        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(6);
        pdf.text(String(ri + 1) + ".", colX[0] + 1, ry + 4.5);
        st(NAVY);
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(7);
        pdf.text(
          pdf.splitTextToSize(row.medicine || "", 68)[0] || "",
          colX[1] + 1,
          ry + 4.5,
        );
        st(GRAY2);
        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(6.5);
        pdf.text(
          pdf.splitTextToSize(row.dosage || "", 63)[0] || "",
          colX[2] + 1,
          ry + 4.5,
        );
        pdf.text(row.duration || "", colX[3] + 1, ry + 4.5);
        pdf.text(row.route || "", colX[4] + 1, ry + 4.5);
        ry += 7;
      });
      rxTableEndY = ry + 4;
    }
    const notesTop = rxTableEndY + 4;
    sf(BLUE);
    pdf.rect(10, notesTop, W - 20, 8, "F");
    st(WHITE);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(8.5);
    pdf.text("Rx   CLINICAL NOTES / DIAGNOSIS", 14, notesTop + 5.5);
    st(GOLD);
    pdf.setFontSize(10);
    pdf.text("Rx", W - 16, notesTop + 5.5, { align: "right" });
    const notesBoxH = 46;
    sf(LGRAY2);
    pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "F");
    sd(LBLUE);
    pdf.setLineWidth(0.25);
    pdf.rect(10, notesTop + 8, W - 20, notesBoxH, "S");
    sd([215, 225, 240]);
    pdf.setLineWidth(0.15);
    for (let rl = 0; rl < 6; rl++)
      pdf.line(14, notesTop + 16 + rl * 7, W - 14, notesTop + 16 + rl * 7);
    st(NAVY);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(9.5);
    const noteLines = pdf.splitTextToSize(
      notes || "No diagnosis or notes recorded for this visit.",
      W - 30,
    );
    pdf.text(noteLines, 14, notesTop + 15);
    let tableEndY = notesTop + notesBoxH + 8;
    let afterY = tableEndY;
    if (nextDateFmt) {
      sf(TEAL2);
      pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "F");
      sd(TEAL);
      pdf.setLineWidth(0.4);
      pdf.roundedRect(10, afterY, W - 20, 13, 2, 2, "S");
      sf(TEAL);
      pdf.roundedRect(10, afterY, 10, 13, 2, 2, "F");
      st(WHITE);
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(6.5);
      pdf.text("NEXT", 11.2, afterY + 5.5);
      pdf.text("VISIT", 11.0, afterY + 10);
      st(TEAL);
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(9);
      pdf.text("Next Appointment:", 24, afterY + 6.5);
      st(NAVY);
      pdf.setFontSize(10);
      pdf.setFont("helvetica", "bold");
      pdf.text(nextDateFmt, 72, afterY + 6.5);
      st(GRAY);
      pdf.setFontSize(7);
      pdf.setFont("helvetica", "italic");
      pdf.text(
        "Please arrive 10 minutes early and bring this prescription.",
        24,
        afterY + 11,
      );
      afterY += 19;
    }
    const advY = afterY + 4;
    sf(GOLD2);
    pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "F");
    sd(GOLD);
    pdf.setLineWidth(0.35);
    pdf.roundedRect(10, advY, W - 20, 20, 2, 2, "S");
    sf(GOLD);
    pdf.roundedRect(10, advY, 10, 20, 2, 2, "F");
    st(WHITE);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(6.2);
    pdf.text("GEN.", 11.2, advY + 8);
    pdf.text("ADV.", 11.2, advY + 13.5);
    st(GOLD);
    pdf.setFontSize(7.5);
    pdf.setFont("helvetica", "bold");
    pdf.text("General Advice:", 24, advY + 6.5);
    st(GRAY2);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(7);
    pdf.text(
      "1.  Follow all prescribed medicines on time and complete the full course.",
      24,
      advY + 11.5,
    );
    pdf.text(
      "2.  Maintain good oral hygiene. Brush gently twice daily.",
      24,
      advY + 15.5,
    );
    pdf.text(
      "3.  Avoid very hot, cold, or hard foods until fully healed.",
      24,
      advY + 19.2,
    );
    pdf.saveGraphicsState();
    pdf.setGState(new pdf.GState({ opacity: 0.035 }));
    st(NAVY);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(44);
    pdf.text("PEARLSMILE", W / 2, H / 2 - 5, { align: "center", angle: 35 });
    pdf.restoreGraphicsState();
    const sigY = Math.max(advY + 28, H - 55);
    const INK = [28, 52, 140],
      INK2 = [45, 75, 170];
    const cx = W - 46,
      cy = sigY + 13,
      R = 18;
    sd(INK);
    pdf.setLineWidth(1.2);
    pdf.circle(cx, cy, R, "S");
    pdf.setLineWidth(0.4);
    pdf.circle(cx, cy, R - 2.5, "S");
    const drawStar = (sx, sy, sr) => {
      const pts = [];
      for (let si = 0; si < 5; si++) {
        const ao = (si * 4 * Math.PI) / 5 - Math.PI / 2,
          ai = ao + (2 * Math.PI) / 5;
        pts.push({ x: sx + sr * Math.cos(ao), y: sy + sr * Math.sin(ao) });
        pts.push({
          x: sx + sr * 0.4 * Math.cos(ai),
          y: sy + sr * 0.4 * Math.sin(ai),
        });
      }
      pdf.setLineWidth(0.3);
      sd(INK);
      sf(INK);
      pdf.lines(
        pts.slice(1).map((pt, i) => [pt.x - pts[i].x, pt.y - pts[i].y]),
        pts[0].x,
        pts[0].y,
        [1, 1],
        "FD",
        true,
      );
    };
    drawStar(cx - R + 3.5, cy + 1, 2.2);
    drawStar(cx + R - 3.5, cy + 1, 2.2);
    const docShort = (doc.name || "Doctor").toUpperCase();
    sd(INK);
    st(INK);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(5.8);
    const topSpan = Math.min(docShort.length * 0.19, 1.3),
      topStart = -Math.PI / 2 - topSpan / 2;
    for (let ti = 0; ti < docShort.length; ti++) {
      const ta = topStart + (ti / Math.max(docShort.length - 1, 1)) * topSpan;
      const tx = cx + (R - 1.5) * Math.cos(ta),
        ty = cy + (R - 1.5) * Math.sin(ta);
      const trot = ((ta + Math.PI / 2) * 180) / Math.PI;
      pdf.text(docShort[ti], tx, ty, { align: "center", angle: -trot });
    }
    pdf.setFontSize(5.5);
    const botStr = "PEARLSMILE DENTAL";
    const botSpan = Math.min(botStr.length * 0.175, 1.4),
      botStart = Math.PI / 2 - botSpan / 2;
    for (let bi = 0; bi < botStr.length; bi++) {
      const ba = botStart + (bi / Math.max(botStr.length - 1, 1)) * botSpan;
      const bx = cx + (R - 1.5) * Math.cos(ba),
        by = cy + (R - 1.5) * Math.sin(ba);
      const brot = ((ba - Math.PI / 2) * 180) / Math.PI;
      pdf.text(botStr[bi], bx, by, { align: "center", angle: -brot });
    }
    sd(INK);
    pdf.setLineWidth(0.8);
    pdf.line(cx, cy - 8, cx, cy + 7);
    pdf.setLineWidth(0.5);
    pdf.line(cx, cy - 7.5, cx - 4, cy - 9.5);
    pdf.line(cx - 4, cy - 9.5, cx - 6, cy - 8);
    pdf.line(cx - 6, cy - 8, cx - 3, cy - 6.5);
    pdf.line(cx, cy - 7.5, cx + 4, cy - 9.5);
    pdf.line(cx + 4, cy - 9.5, cx + 6, cy - 8);
    pdf.line(cx + 6, cy - 8, cx + 3, cy - 6.5);
    sf(INK);
    pdf.circle(cx, cy - 8.2, 1, "F");
    pdf.setLineWidth(0.6);
    pdf.lines(
      [
        [2, -2],
        [2, -2],
        [0, -2],
      ],
      cx - 3,
      cy + 5,
      [1, 1],
      "S",
    );
    pdf.lines(
      [
        [-2, -2],
        [-2, -2],
        [0, -2],
      ],
      cx + 3,
      cy + 1,
      [1, 1],
      "S",
    );
    pdf.lines(
      [
        [2, -2],
        [2, -2],
      ],
      cx - 3,
      cy - 3,
      [1, 1],
      "S",
    );
    pdf.lines(
      [
        [-2, -2],
        [-2, -2],
        [0, -2],
      ],
      cx + 3,
      cy + 5,
      [1, 1],
      "S",
    );
    pdf.lines(
      [
        [2, -2],
        [2, -2],
        [0, -2],
      ],
      cx - 3,
      cy + 1,
      [1, 1],
      "S",
    );
    st(INK);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(4.5);
    pdf.text("Reg. " + (doc.reg || "—"), cx, cy + R - 5.5, { align: "center" });
    st(INK2);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(6.5);
    pdf.text("Authorised Signatory", cx, cy + R + 4, { align: "center" });
    st(GRAY);
    pdf.setFontSize(7);
    pdf.setFont("helvetica", "normal");
    pdf.text("Rx No.: " + rxNum, 14, sigY + 30);
    pdf.text("Date: " + todayFmt, W - 14, sigY + 30, { align: "right" });
    sf(NAVY);
    pdf.rect(3.5, H - 21, W - 7, 17.5, "F");
    sf(BLUE);
    pdf.rect(3.5, H - 7, W - 7, 3.5, "F");
    st(WHITE);
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(7.5);
    pdf.text("PearlSmile Dental Hospital", 10, H - 14.5);
    st(LBLUE);
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(7);
    pdf.text("+91 87936 08083", 10, H - 9.5);
    pdf.text("care@pearlsmiledental.in", W / 2, H - 9.5, { align: "center" });
    pdf.text("12, Dental Plaza, MG Road, Pune - 411001", W - 10, H - 9.5, {
      align: "right",
    });
    st(LBLUE2);
    pdf.setFontSize(6);
    pdf.setFont("helvetica", "italic");
    pdf.text(
      "This is a computer-generated prescription from PearlSmile Dental Hospital. Valid only with authorised doctor details.",
      W / 2,
      H - 5.5,
      { align: "center" },
    );
    const blob = pdf.output("blob");
    const url = URL.createObjectURL(blob);
    const name =
      "Prescription_" +
      (patient.name || "Patient").replace(/\s+/g, "_") +
      "_" +
      visitDate +
      ".pdf";
    let rawMob = (patient.mobile || "").replace(/[\s\-\(\)\+]/g, "");
    if (!rawMob.startsWith("91") && rawMob.length === 10)
      rawMob = "91" + rawMob;
    setPdfBlob(blob);
    setPdfUrl(url);
    setRxMobile(rawMob);
    setFileName(name);
    const testFile = new File([blob], name, { type: "application/pdf" });
    if (
      navigator.share &&
      navigator.canShare &&
      navigator.canShare({ files: [testFile] })
    )
      setCanNativeShare(true);
    setLoading(false);
  };

  const openFullPreview = () => {
    if (pdfUrl) window.open(pdfUrl, "_blank");
  };

  const nativeShare = async () => {
    if (!pdfBlob) return;
    const file = new File([pdfBlob], fileName, { type: "application/pdf" });
    const dlLink = document.createElement("a");
    dlLink.href = pdfUrl;
    dlLink.download = fileName;
    dlLink.click();
    if (
      navigator.share &&
      navigator.canShare &&
      navigator.canShare({ files: [file] })
    ) {
      navigator
        .share({
          title: "Digital Prescription — PearlSmile Dental Hospital",
          text: "Dear Patient, please find your digital prescription attached.",
          files: [file],
        })
        .then(() => {
          showNotify("Sent! ✓", "Prescription shared successfully.");
          onClose();
        })
        .catch((err) => {
          if (err.name !== "AbortError") {
            if (rxMobile) {
              const waMsg = encodeURIComponent(
                "Dear Patient, your digital prescription has been generated. Please find the PDF file attached.",
              );
              window.open(
                "https://wa.me/" + rxMobile + "?text=" + waMsg,
                "_blank",
              );
            }
          }
        });
    } else {
      if (rxMobile) {
        const waMsg = encodeURIComponent(
          "Dear Patient, your digital prescription has been downloaded. Please check the PDF in your Downloads folder.",
        );
        setTimeout(
          () =>
            window.open(
              "https://wa.me/" + rxMobile + "?text=" + waMsg,
              "_blank",
            ),
          600,
        );
        showNotify(
          "PDF Downloaded + WhatsApp Opened! ✓",
          "Prescription saved. WhatsApp opened to patient number.",
        );
      } else {
        showNotify("PDF Downloaded ✓", "Prescription saved. Share manually.");
      }
    }
  };

  return (
    <div
      className="rx-share-overlay open"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 20,
          width: "100%",
          maxWidth: 540,
          boxShadow: "0 24px 80px rgba(0,0,0,0.45)",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          maxHeight: "92vh",
        }}
      >
        <div
          style={{
            background: "linear-gradient(135deg,#0a1628,#1a3a6b)",
            padding: "18px 22px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 22 }}>📄</span>
            <div>
              <div
                style={{
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: 15,
                  fontFamily: "DM Sans,sans-serif",
                }}
              >
                Digital Prescription Ready
              </div>
              <div
                style={{
                  color: "rgba(255,255,255,0.55)",
                  fontSize: 12,
                  fontFamily: "DM Sans,sans-serif",
                }}
              >
                {patient.name} · {visit.visitDate}
              </div>
            </div>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "rgba(255,255,255,0.12)",
              border: "none",
              color: "#fff",
              width: 32,
              height: 32,
              borderRadius: "50%",
              fontSize: 17,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            ✕
          </button>
        </div>
        <div
          style={{
            flex: 1,
            overflow: "hidden",
            background: "#f0eeeb",
            minHeight: 340,
            position: "relative",
          }}
        >
          {loading && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                background: "#f0eeeb",
                gap: 10,
              }}
            >
              <div
                style={{
                  width: 36,
                  height: 36,
                  border: "3px solid #0d7377",
                  borderTopColor: "transparent",
                  borderRadius: "50%",
                  animation: "spin 0.8s linear infinite",
                }}
              />
              <div
                style={{
                  fontSize: 13,
                  color: "#5a5550",
                  fontFamily: "DM Sans,sans-serif",
                }}
              >
                Generating PDF…
              </div>
            </div>
          )}
          {pdfUrl && (
            <iframe
              title="prescription"
              src={pdfUrl}
              style={{ width: "100%", height: 420, border: "none" }}
            />
          )}
        </div>
        <div
          style={{
            padding: "16px 20px",
            display: "flex",
            flexDirection: "column",
            gap: 10,
            background: "#fff",
          }}
        >
          <div style={{ display: "flex", gap: 8 }}>
            <button
              onClick={openFullPreview}
              onMouseOver={(e) =>
                (e.currentTarget.style.background = "#e5e0d8")
              }
              onMouseOut={(e) => (e.currentTarget.style.background = "#f0eeeb")}
              style={{
                flex: 1,
                background: "#f0eeeb",
                color: "#0a1628",
                border: "1.5px solid #ddd9d3",
                borderRadius: 10,
                padding: 10,
                fontSize: 13,
                fontWeight: 500,
                cursor: "pointer",
                fontFamily: "DM Sans,sans-serif",
                transition: "background 0.2s",
              }}
            >
              🔍 Open Full PDF
            </button>
            {canNativeShare && (
              <button
                onClick={nativeShare}
                onMouseOver={(e) =>
                  (e.currentTarget.style.background = "#e5e0d8")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.background = "#f0eeeb")
                }
                style={{
                  flex: 1,
                  background: "#f0eeeb",
                  color: "#0a1628",
                  border: "1.5px solid #ddd9d3",
                  borderRadius: 10,
                  padding: 10,
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: "pointer",
                  fontFamily: "DM Sans,sans-serif",
                  transition: "background 0.2s",
                }}
              >
                📤 Share (Device)
              </button>
            )}
          </div>
          <p
            style={{
              fontSize: 11,
              color: "#9a9590",
              textAlign: "center",
              margin: 0,
              fontFamily: "DM Sans,sans-serif",
              lineHeight: 1.5,
            }}
          >
            On mobile: tap "Share (Device)" to send directly via WhatsApp.
            <br />
            On desktop: use "Open Full PDF" to view, then share manually.
          </p>
        </div>
      </div>
    </div>
  );
}
